(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

parcelRegister("aSiaI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1tTUb"));

});
parcelRegister("1tTUb", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1143dd7f04075183$export$ffb0004e005737fa; }, function (v) { return $1143dd7f04075183$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1143dd7f04075183$export$34b9dba7ce09269b; }, function (v) { return $1143dd7f04075183$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1143dd7f04075183$export$25062201e9e25d76; }, function (v) { return $1143dd7f04075183$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1143dd7f04075183$export$ffb0004e005737fa;
var $1143dd7f04075183$export$34b9dba7ce09269b;
var $1143dd7f04075183$export$25062201e9e25d76;
"use strict";
var $1143dd7f04075183$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1143dd7f04075183$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $1143dd7f04075183$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $1143dd7f04075183$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$1143dd7f04075183$export$ffb0004e005737fa = $1143dd7f04075183$var$REACT_FRAGMENT_TYPE;
$1143dd7f04075183$export$34b9dba7ce09269b = $1143dd7f04075183$var$jsxProd;
$1143dd7f04075183$export$25062201e9e25d76 = $1143dd7f04075183$var$jsxProd;

});


parcelRegister("exYeM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gfHYB"));

});
parcelRegister("gfHYB", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $bd5028e33dce7343$export$dca3b0875bd9a954; }, function (v) { return $bd5028e33dce7343$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bd5028e33dce7343$export$16fa2f45be04daa8; }, function (v) { return $bd5028e33dce7343$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bd5028e33dce7343$export$ffb0004e005737fa; }, function (v) { return $bd5028e33dce7343$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $bd5028e33dce7343$export$e2c29f18771995cb; }, function (v) { return $bd5028e33dce7343$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bd5028e33dce7343$export$221d75b3f55bb0bd; }, function (v) { return $bd5028e33dce7343$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bd5028e33dce7343$export$5f8d39834fd61797; }, function (v) { return $bd5028e33dce7343$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bd5028e33dce7343$export$74bf444e3cd11ea5; }, function (v) { return $bd5028e33dce7343$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $bd5028e33dce7343$export$1ced07cd6b1985ce; }, function (v) { return $bd5028e33dce7343$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $bd5028e33dce7343$export$3ba232387fd5d6dd; }, function (v) { return $bd5028e33dce7343$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $bd5028e33dce7343$export$69a3209f1a06c04d; }, function (v) { return $bd5028e33dce7343$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bd5028e33dce7343$export$e530037191fcd5d7; }, function (v) { return $bd5028e33dce7343$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bd5028e33dce7343$export$fd42f52fd3ae1109; }, function (v) { return $bd5028e33dce7343$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bd5028e33dce7343$export$c8a8987d4410bf2d; }, function (v) { return $bd5028e33dce7343$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $bd5028e33dce7343$export$7d1e3a5e95ceca43; }, function (v) { return $bd5028e33dce7343$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bd5028e33dce7343$export$257a8862b851cb5b; }, function (v) { return $bd5028e33dce7343$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bd5028e33dce7343$export$a8257692ac88316c; }, function (v) { return $bd5028e33dce7343$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bd5028e33dce7343$export$488013bae63b21da; }, function (v) { return $bd5028e33dce7343$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bd5028e33dce7343$export$7c73462e0d25e514; }, function (v) { return $bd5028e33dce7343$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $bd5028e33dce7343$export$7568632d0d33d16d; }, function (v) { return $bd5028e33dce7343$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $bd5028e33dce7343$export$f93f40ac0ca7e3a8; }, function (v) { return $bd5028e33dce7343$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $bd5028e33dce7343$export$1f96ae73734a86cc; }, function (v) { return $bd5028e33dce7343$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $bd5028e33dce7343$export$9a47ced3238df325; }, function (v) { return $bd5028e33dce7343$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bd5028e33dce7343$export$35808ee640e87ca7; }, function (v) { return $bd5028e33dce7343$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bd5028e33dce7343$export$fae74005e78b1a27; }, function (v) { return $bd5028e33dce7343$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bd5028e33dce7343$export$dc8fbce3eb94dc1e; }, function (v) { return $bd5028e33dce7343$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $bd5028e33dce7343$export$6a7bc4e911dc01cf; }, function (v) { return $bd5028e33dce7343$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $bd5028e33dce7343$export$6d9c69b0de29b591; }, function (v) { return $bd5028e33dce7343$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $bd5028e33dce7343$export$f680877a34711e37; }, function (v) { return $bd5028e33dce7343$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bd5028e33dce7343$export$d5a552a76deda3c2; }, function (v) { return $bd5028e33dce7343$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $bd5028e33dce7343$export$aaabe4eda9ed9969; }, function (v) { return $bd5028e33dce7343$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bd5028e33dce7343$export$e5c5a5f917a5871c; }, function (v) { return $bd5028e33dce7343$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bd5028e33dce7343$export$1538c33de8887b59; }, function (v) { return $bd5028e33dce7343$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $bd5028e33dce7343$export$fca7f784ae7a249a; }, function (v) { return $bd5028e33dce7343$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $bd5028e33dce7343$export$13e3392192263954; }, function (v) { return $bd5028e33dce7343$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bd5028e33dce7343$export$b8f5890fc79d6aca; }, function (v) { return $bd5028e33dce7343$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bd5028e33dce7343$export$60241385465d0a34; }, function (v) { return $bd5028e33dce7343$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $bd5028e33dce7343$export$306c0aa65ff9ec16; }, function (v) { return $bd5028e33dce7343$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $bd5028e33dce7343$export$7b286972b8d8ccbf; }, function (v) { return $bd5028e33dce7343$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $bd5028e33dce7343$export$83d89fbfd8236492; }, function (v) { return $bd5028e33dce7343$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd5028e33dce7343$export$dca3b0875bd9a954;
var $bd5028e33dce7343$export$16fa2f45be04daa8;
var $bd5028e33dce7343$export$ffb0004e005737fa;
var $bd5028e33dce7343$export$e2c29f18771995cb;
var $bd5028e33dce7343$export$221d75b3f55bb0bd;
var $bd5028e33dce7343$export$5f8d39834fd61797;
var $bd5028e33dce7343$export$74bf444e3cd11ea5;
var $bd5028e33dce7343$export$1ced07cd6b1985ce;
var $bd5028e33dce7343$export$3ba232387fd5d6dd;
var $bd5028e33dce7343$export$69a3209f1a06c04d;
var $bd5028e33dce7343$export$e530037191fcd5d7;
var $bd5028e33dce7343$export$fd42f52fd3ae1109;
var $bd5028e33dce7343$export$c8a8987d4410bf2d;
var $bd5028e33dce7343$export$7d1e3a5e95ceca43;
var $bd5028e33dce7343$export$257a8862b851cb5b;
var $bd5028e33dce7343$export$a8257692ac88316c;
var $bd5028e33dce7343$export$488013bae63b21da;
var $bd5028e33dce7343$export$7c73462e0d25e514;
var $bd5028e33dce7343$export$7568632d0d33d16d;
var $bd5028e33dce7343$export$f93f40ac0ca7e3a8;
var $bd5028e33dce7343$export$1f96ae73734a86cc;
var $bd5028e33dce7343$export$9a47ced3238df325;
var $bd5028e33dce7343$export$35808ee640e87ca7;
var $bd5028e33dce7343$export$fae74005e78b1a27;
var $bd5028e33dce7343$export$dc8fbce3eb94dc1e;
var $bd5028e33dce7343$export$6a7bc4e911dc01cf;
var $bd5028e33dce7343$export$6d9c69b0de29b591;
var $bd5028e33dce7343$export$f680877a34711e37;
var $bd5028e33dce7343$export$d5a552a76deda3c2;
var $bd5028e33dce7343$export$aaabe4eda9ed9969;
var $bd5028e33dce7343$export$e5c5a5f917a5871c;
var $bd5028e33dce7343$export$1538c33de8887b59;
var $bd5028e33dce7343$export$fca7f784ae7a249a;
var $bd5028e33dce7343$export$13e3392192263954;
var $bd5028e33dce7343$export$b8f5890fc79d6aca;
var $bd5028e33dce7343$export$60241385465d0a34;
var $bd5028e33dce7343$export$306c0aa65ff9ec16;
var $bd5028e33dce7343$export$7b286972b8d8ccbf;
var $bd5028e33dce7343$export$83d89fbfd8236492;

var $6qd2L = parcelRequire("6qd2L");
"use strict";
var $bd5028e33dce7343$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bd5028e33dce7343$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bd5028e33dce7343$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bd5028e33dce7343$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bd5028e33dce7343$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bd5028e33dce7343$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bd5028e33dce7343$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bd5028e33dce7343$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bd5028e33dce7343$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bd5028e33dce7343$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bd5028e33dce7343$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $bd5028e33dce7343$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $bd5028e33dce7343$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bd5028e33dce7343$var$assign = Object.assign, $bd5028e33dce7343$var$emptyObject = {};
function $bd5028e33dce7343$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $bd5028e33dce7343$var$emptyObject;
    this.updater = updater || $bd5028e33dce7343$var$ReactNoopUpdateQueue;
}
$bd5028e33dce7343$var$Component.prototype.isReactComponent = {};
$bd5028e33dce7343$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$bd5028e33dce7343$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $bd5028e33dce7343$var$ComponentDummy() {}
$bd5028e33dce7343$var$ComponentDummy.prototype = $bd5028e33dce7343$var$Component.prototype;
function $bd5028e33dce7343$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $bd5028e33dce7343$var$emptyObject;
    this.updater = updater || $bd5028e33dce7343$var$ReactNoopUpdateQueue;
}
var $bd5028e33dce7343$var$pureComponentPrototype = $bd5028e33dce7343$var$PureComponent.prototype = new $bd5028e33dce7343$var$ComponentDummy();
$bd5028e33dce7343$var$pureComponentPrototype.constructor = $bd5028e33dce7343$var$PureComponent;
$bd5028e33dce7343$var$assign($bd5028e33dce7343$var$pureComponentPrototype, $bd5028e33dce7343$var$Component.prototype);
$bd5028e33dce7343$var$pureComponentPrototype.isPureReactComponent = !0;
var $bd5028e33dce7343$var$isArrayImpl = Array.isArray, $bd5028e33dce7343$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $bd5028e33dce7343$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $bd5028e33dce7343$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $bd5028e33dce7343$var$cloneAndReplaceKey(oldElement, newKey) {
    return $bd5028e33dce7343$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $bd5028e33dce7343$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $bd5028e33dce7343$var$REACT_ELEMENT_TYPE;
}
function $bd5028e33dce7343$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $bd5028e33dce7343$var$userProvidedKeyEscapeRegex = /\/+/g;
function $bd5028e33dce7343$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $bd5028e33dce7343$var$escape("" + element.key) : index.toString(36);
}
function $bd5028e33dce7343$var$noop$1() {}
function $bd5028e33dce7343$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($bd5028e33dce7343$var$noop$1, $bd5028e33dce7343$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $bd5028e33dce7343$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $bd5028e33dce7343$var$REACT_ELEMENT_TYPE:
                case $bd5028e33dce7343$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $bd5028e33dce7343$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $bd5028e33dce7343$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $bd5028e33dce7343$var$getElementKey(children, 0) : nameSoFar, $bd5028e33dce7343$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($bd5028e33dce7343$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $bd5028e33dce7343$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($bd5028e33dce7343$var$isValidElement(callback) && (callback = $bd5028e33dce7343$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($bd5028e33dce7343$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($bd5028e33dce7343$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $bd5028e33dce7343$var$getElementKey(nameSoFar, i), invokeCallback += $bd5028e33dce7343$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $bd5028e33dce7343$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $bd5028e33dce7343$var$getElementKey(nameSoFar, i++), invokeCallback += $bd5028e33dce7343$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $bd5028e33dce7343$var$mapIntoArray($bd5028e33dce7343$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $bd5028e33dce7343$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $bd5028e33dce7343$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $bd5028e33dce7343$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $bd5028e33dce7343$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $6qd2L && "function" === typeof $6qd2L.emit) {
        $6qd2L.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $bd5028e33dce7343$var$noop() {}
$bd5028e33dce7343$export$dca3b0875bd9a954 = {
    map: $bd5028e33dce7343$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $bd5028e33dce7343$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $bd5028e33dce7343$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $bd5028e33dce7343$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$bd5028e33dce7343$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$bd5028e33dce7343$export$16fa2f45be04daa8 = $bd5028e33dce7343$var$Component;
$bd5028e33dce7343$export$ffb0004e005737fa = $bd5028e33dce7343$var$REACT_FRAGMENT_TYPE;
$bd5028e33dce7343$export$e2c29f18771995cb = $bd5028e33dce7343$var$REACT_PROFILER_TYPE;
$bd5028e33dce7343$export$221d75b3f55bb0bd = $bd5028e33dce7343$var$PureComponent;
$bd5028e33dce7343$export$5f8d39834fd61797 = $bd5028e33dce7343$var$REACT_STRICT_MODE_TYPE;
$bd5028e33dce7343$export$74bf444e3cd11ea5 = $bd5028e33dce7343$var$REACT_SUSPENSE_TYPE;
$bd5028e33dce7343$export$1ced07cd6b1985ce = $bd5028e33dce7343$var$ReactSharedInternals;
$bd5028e33dce7343$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$bd5028e33dce7343$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$bd5028e33dce7343$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $bd5028e33dce7343$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$bd5028e33dce7343$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $bd5028e33dce7343$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$bd5028e33dce7343$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $bd5028e33dce7343$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $bd5028e33dce7343$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$bd5028e33dce7343$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$bd5028e33dce7343$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $bd5028e33dce7343$var$ReactElement(type, key, void 0, void 0, null, props);
};
$bd5028e33dce7343$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bd5028e33dce7343$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$bd5028e33dce7343$export$a8257692ac88316c = $bd5028e33dce7343$var$isValidElement;
$bd5028e33dce7343$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $bd5028e33dce7343$var$lazyInitializer
    };
};
$bd5028e33dce7343$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$bd5028e33dce7343$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $bd5028e33dce7343$var$ReactSharedInternals.T, currentTransition = {};
    $bd5028e33dce7343$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $bd5028e33dce7343$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($bd5028e33dce7343$var$noop, $bd5028e33dce7343$var$reportGlobalError);
    } catch (error) {
        $bd5028e33dce7343$var$reportGlobalError(error);
    } finally{
        $bd5028e33dce7343$var$ReactSharedInternals.T = prevTransition;
    }
};
$bd5028e33dce7343$export$f93f40ac0ca7e3a8 = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useCacheRefresh();
};
$bd5028e33dce7343$export$1f96ae73734a86cc = function(usable) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.use(usable);
};
$bd5028e33dce7343$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$bd5028e33dce7343$export$35808ee640e87ca7 = function(callback, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$bd5028e33dce7343$export$fae74005e78b1a27 = function(Context) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useContext(Context);
};
$bd5028e33dce7343$export$dc8fbce3eb94dc1e = function() {};
$bd5028e33dce7343$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$bd5028e33dce7343$export$6d9c69b0de29b591 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useEffect(create, deps);
};
$bd5028e33dce7343$export$f680877a34711e37 = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useId();
};
$bd5028e33dce7343$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$bd5028e33dce7343$export$aaabe4eda9ed9969 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$bd5028e33dce7343$export$e5c5a5f917a5871c = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$bd5028e33dce7343$export$1538c33de8887b59 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useMemo(create, deps);
};
$bd5028e33dce7343$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$bd5028e33dce7343$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$bd5028e33dce7343$export$b8f5890fc79d6aca = function(initialValue) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useRef(initialValue);
};
$bd5028e33dce7343$export$60241385465d0a34 = function(initialState) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useState(initialState);
};
$bd5028e33dce7343$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$bd5028e33dce7343$export$7b286972b8d8ccbf = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useTransition();
};
$bd5028e33dce7343$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = 'browser';
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ''; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return '/';
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});



parcelRegister("8LThT", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $662d9978aa5168bc$export$882461b6382ed46c; }, function (v) { return $662d9978aa5168bc$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $662d9978aa5168bc$export$757ceba2d55c277e; }, function (v) { return $662d9978aa5168bc$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $662d9978aa5168bc$export$83d89fbfd8236492; }, function (v) { return $662d9978aa5168bc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $662d9978aa5168bc$export$882461b6382ed46c;
var $662d9978aa5168bc$export$757ceba2d55c277e;
var $662d9978aa5168bc$export$83d89fbfd8236492;

var $6qd2L = parcelRequire("6qd2L");
"use strict";

var $ibqfJ = parcelRequire("ibqfJ");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
function $662d9978aa5168bc$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $662d9978aa5168bc$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $662d9978aa5168bc$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $662d9978aa5168bc$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $662d9978aa5168bc$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $662d9978aa5168bc$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $662d9978aa5168bc$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $662d9978aa5168bc$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $662d9978aa5168bc$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $662d9978aa5168bc$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $662d9978aa5168bc$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $662d9978aa5168bc$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $662d9978aa5168bc$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $662d9978aa5168bc$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $662d9978aa5168bc$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $662d9978aa5168bc$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $662d9978aa5168bc$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $662d9978aa5168bc$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $662d9978aa5168bc$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $662d9978aa5168bc$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$662d9978aa5168bc$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $662d9978aa5168bc$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $662d9978aa5168bc$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $662d9978aa5168bc$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $662d9978aa5168bc$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $662d9978aa5168bc$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $662d9978aa5168bc$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $662d9978aa5168bc$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $662d9978aa5168bc$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $662d9978aa5168bc$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $662d9978aa5168bc$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $662d9978aa5168bc$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $662d9978aa5168bc$var$getComponentNameFromType(type.type) || "Memo";
        case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $662d9978aa5168bc$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $662d9978aa5168bc$var$ReactSharedInternals = $exYeM.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $662d9978aa5168bc$var$assign = Object.assign, $662d9978aa5168bc$var$prefix, $662d9978aa5168bc$var$suffix;
function $662d9978aa5168bc$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $662d9978aa5168bc$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $662d9978aa5168bc$var$prefix = match && match[1] || "";
        $662d9978aa5168bc$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $662d9978aa5168bc$var$prefix + name + $662d9978aa5168bc$var$suffix;
}
var $662d9978aa5168bc$var$reentry = !1;
function $662d9978aa5168bc$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $662d9978aa5168bc$var$reentry) return "";
    $662d9978aa5168bc$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $662d9978aa5168bc$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $662d9978aa5168bc$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $662d9978aa5168bc$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $662d9978aa5168bc$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $662d9978aa5168bc$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $662d9978aa5168bc$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $662d9978aa5168bc$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $662d9978aa5168bc$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $662d9978aa5168bc$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $662d9978aa5168bc$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $662d9978aa5168bc$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $662d9978aa5168bc$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $662d9978aa5168bc$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $662d9978aa5168bc$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $662d9978aa5168bc$var$assertIsMounted(fiber) {
    if ($662d9978aa5168bc$var$getNearestMountedFiber(fiber) !== fiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
}
function $662d9978aa5168bc$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $662d9978aa5168bc$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $662d9978aa5168bc$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $662d9978aa5168bc$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $662d9978aa5168bc$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $662d9978aa5168bc$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $662d9978aa5168bc$var$isArrayImpl = Array.isArray, $662d9978aa5168bc$var$ReactDOMSharedInternals = $d2lNW.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $662d9978aa5168bc$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $662d9978aa5168bc$var$valueStack = [], $662d9978aa5168bc$var$index = -1;
function $662d9978aa5168bc$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $662d9978aa5168bc$var$pop(cursor) {
    0 > $662d9978aa5168bc$var$index || (cursor.current = $662d9978aa5168bc$var$valueStack[$662d9978aa5168bc$var$index], $662d9978aa5168bc$var$valueStack[$662d9978aa5168bc$var$index] = null, $662d9978aa5168bc$var$index--);
}
function $662d9978aa5168bc$var$push(cursor, value) {
    $662d9978aa5168bc$var$index++;
    $662d9978aa5168bc$var$valueStack[$662d9978aa5168bc$var$index] = cursor.current;
    cursor.current = value;
}
var $662d9978aa5168bc$var$contextStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$contextFiberStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$rootInstanceStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$hostTransitionProviderCursor = $662d9978aa5168bc$var$createCursor(null);
function $662d9978aa5168bc$var$pushHostContainer(fiber, nextRootInstance) {
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$rootInstanceStackCursor, nextRootInstance);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextFiberStackCursor, fiber);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $662d9978aa5168bc$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $662d9978aa5168bc$var$getOwnHostContext(fiber), nextRootInstance = $662d9978aa5168bc$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextStackCursor);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextStackCursor, nextRootInstance);
}
function $662d9978aa5168bc$var$popHostContainer() {
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextStackCursor);
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextFiberStackCursor);
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$rootInstanceStackCursor);
}
function $662d9978aa5168bc$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $662d9978aa5168bc$var$push($662d9978aa5168bc$var$hostTransitionProviderCursor, fiber);
    var context = $662d9978aa5168bc$var$contextStackCursor.current;
    var JSCompiler_inline_result = $662d9978aa5168bc$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextFiberStackCursor, fiber), $662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextStackCursor, JSCompiler_inline_result));
}
function $662d9978aa5168bc$var$popHostContext(fiber) {
    $662d9978aa5168bc$var$contextFiberStackCursor.current === fiber && ($662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextStackCursor), $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextFiberStackCursor));
    $662d9978aa5168bc$var$hostTransitionProviderCursor.current === fiber && ($662d9978aa5168bc$var$pop($662d9978aa5168bc$var$hostTransitionProviderCursor), $662d9978aa5168bc$var$HostTransitionContext._currentValue = $662d9978aa5168bc$var$sharedNotPendingObject);
}
var $662d9978aa5168bc$var$hasOwnProperty = Object.prototype.hasOwnProperty, $662d9978aa5168bc$var$scheduleCallback$3 = $ibqfJ.unstable_scheduleCallback, $662d9978aa5168bc$var$cancelCallback$1 = $ibqfJ.unstable_cancelCallback, $662d9978aa5168bc$var$shouldYield = $ibqfJ.unstable_shouldYield, $662d9978aa5168bc$var$requestPaint = $ibqfJ.unstable_requestPaint, $662d9978aa5168bc$var$now = $ibqfJ.unstable_now, $662d9978aa5168bc$var$getCurrentPriorityLevel = $ibqfJ.unstable_getCurrentPriorityLevel, $662d9978aa5168bc$var$ImmediatePriority = $ibqfJ.unstable_ImmediatePriority, $662d9978aa5168bc$var$UserBlockingPriority = $ibqfJ.unstable_UserBlockingPriority, $662d9978aa5168bc$var$NormalPriority$1 = $ibqfJ.unstable_NormalPriority, $662d9978aa5168bc$var$LowPriority = $ibqfJ.unstable_LowPriority, $662d9978aa5168bc$var$IdlePriority = $ibqfJ.unstable_IdlePriority, $662d9978aa5168bc$var$log$1 = $ibqfJ.log, $662d9978aa5168bc$var$unstable_setDisableYieldValue = $ibqfJ.unstable_setDisableYieldValue, $662d9978aa5168bc$var$rendererID = null, $662d9978aa5168bc$var$injectedHook = null;
function $662d9978aa5168bc$var$onCommitRoot(root) {
    if ($662d9978aa5168bc$var$injectedHook && "function" === typeof $662d9978aa5168bc$var$injectedHook.onCommitFiberRoot) try {
        $662d9978aa5168bc$var$injectedHook.onCommitFiberRoot($662d9978aa5168bc$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $662d9978aa5168bc$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $662d9978aa5168bc$var$log$1 && $662d9978aa5168bc$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($662d9978aa5168bc$var$injectedHook && "function" === typeof $662d9978aa5168bc$var$injectedHook.setStrictMode) try {
        $662d9978aa5168bc$var$injectedHook.setStrictMode($662d9978aa5168bc$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $662d9978aa5168bc$var$clz32 = Math.clz32 ? Math.clz32 : $662d9978aa5168bc$var$clz32Fallback, $662d9978aa5168bc$var$log = Math.log, $662d9978aa5168bc$var$LN2 = Math.LN2;
function $662d9978aa5168bc$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($662d9978aa5168bc$var$log(x) / $662d9978aa5168bc$var$LN2 | 0) | 0;
}
var $662d9978aa5168bc$var$nextTransitionLane = 128, $662d9978aa5168bc$var$nextRetryLane = 4194304;
function $662d9978aa5168bc$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $662d9978aa5168bc$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $662d9978aa5168bc$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $662d9978aa5168bc$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $662d9978aa5168bc$var$claimNextTransitionLane() {
    var lane = $662d9978aa5168bc$var$nextTransitionLane;
    $662d9978aa5168bc$var$nextTransitionLane <<= 1;
    0 === ($662d9978aa5168bc$var$nextTransitionLane & 4194176) && ($662d9978aa5168bc$var$nextTransitionLane = 128);
    return lane;
}
function $662d9978aa5168bc$var$claimNextRetryLane() {
    var lane = $662d9978aa5168bc$var$nextRetryLane;
    $662d9978aa5168bc$var$nextRetryLane <<= 1;
    0 === ($662d9978aa5168bc$var$nextRetryLane & 62914560) && ($662d9978aa5168bc$var$nextRetryLane = 4194304);
    return lane;
}
function $662d9978aa5168bc$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $662d9978aa5168bc$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $662d9978aa5168bc$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $662d9978aa5168bc$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $662d9978aa5168bc$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $662d9978aa5168bc$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $662d9978aa5168bc$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $662d9978aa5168bc$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $662d9978aa5168bc$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $662d9978aa5168bc$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $662d9978aa5168bc$var$resolveUpdatePriority() {
    var updatePriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $662d9978aa5168bc$var$getEventPriority(updatePriority.type);
}
function $662d9978aa5168bc$var$runWithPriority(priority, fn) {
    var previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    try {
        return $662d9978aa5168bc$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $662d9978aa5168bc$var$randomKey = Math.random().toString(36).slice(2), $662d9978aa5168bc$var$internalInstanceKey = "__reactFiber$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalPropsKey = "__reactProps$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalContainerInstanceKey = "__reactContainer$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalEventHandlersKey = "__reactEvents$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalEventHandlerListenersKey = "__reactListeners$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalEventHandlesSetKey = "__reactHandles$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalRootNodeResourcesKey = "__reactResources$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalHoistableMarker = "__reactMarker$" + $662d9978aa5168bc$var$randomKey;
function $662d9978aa5168bc$var$detachDeletedInstance(node) {
    delete node[$662d9978aa5168bc$var$internalInstanceKey];
    delete node[$662d9978aa5168bc$var$internalPropsKey];
    delete node[$662d9978aa5168bc$var$internalEventHandlersKey];
    delete node[$662d9978aa5168bc$var$internalEventHandlerListenersKey];
    delete node[$662d9978aa5168bc$var$internalEventHandlesSetKey];
}
function $662d9978aa5168bc$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$662d9978aa5168bc$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$662d9978aa5168bc$var$internalContainerInstanceKey] || parentNode[$662d9978aa5168bc$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $662d9978aa5168bc$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$662d9978aa5168bc$var$internalInstanceKey]) return parentNode;
                targetNode = $662d9978aa5168bc$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $662d9978aa5168bc$var$getInstanceFromNode(node) {
    if (node = node[$662d9978aa5168bc$var$internalInstanceKey] || node[$662d9978aa5168bc$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $662d9978aa5168bc$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(33));
}
function $662d9978aa5168bc$var$getResourcesFromRoot(root) {
    var resources = root[$662d9978aa5168bc$var$internalRootNodeResourcesKey];
    resources || (resources = root[$662d9978aa5168bc$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $662d9978aa5168bc$var$markNodeAsHoistable(node) {
    node[$662d9978aa5168bc$var$internalHoistableMarker] = !0;
}
var $662d9978aa5168bc$var$allNativeEvents = new Set(), $662d9978aa5168bc$var$registrationNameDependencies = {};
function $662d9978aa5168bc$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $662d9978aa5168bc$var$registerDirectEvent(registrationName, dependencies);
    $662d9978aa5168bc$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $662d9978aa5168bc$var$registerDirectEvent(registrationName, dependencies) {
    $662d9978aa5168bc$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$662d9978aa5168bc$var$allNativeEvents.add(dependencies[registrationName]);
}
var $662d9978aa5168bc$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $662d9978aa5168bc$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $662d9978aa5168bc$var$illegalAttributeNameCache = {}, $662d9978aa5168bc$var$validatedAttributeNameCache = {};
function $662d9978aa5168bc$var$isAttributeNameSafe(attributeName) {
    if ($662d9978aa5168bc$var$hasOwnProperty.call($662d9978aa5168bc$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($662d9978aa5168bc$var$hasOwnProperty.call($662d9978aa5168bc$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($662d9978aa5168bc$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $662d9978aa5168bc$var$validatedAttributeNameCache[attributeName] = !0;
    $662d9978aa5168bc$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $662d9978aa5168bc$var$setValueForAttribute(node, name, value) {
    if ($662d9978aa5168bc$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $662d9978aa5168bc$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $662d9978aa5168bc$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $662d9978aa5168bc$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $662d9978aa5168bc$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $662d9978aa5168bc$var$trackValueOnNode(node) {
    var valueField = $662d9978aa5168bc$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $662d9978aa5168bc$var$track(node) {
    node._valueTracker || (node._valueTracker = $662d9978aa5168bc$var$trackValueOnNode(node));
}
function $662d9978aa5168bc$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $662d9978aa5168bc$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $662d9978aa5168bc$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $662d9978aa5168bc$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $662d9978aa5168bc$var$getToStringValue(value);
        } else element.value !== "" + $662d9978aa5168bc$var$getToStringValue(value) && (element.value = "" + $662d9978aa5168bc$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $662d9978aa5168bc$var$setDefaultValue(element, type, $662d9978aa5168bc$var$getToStringValue(value)) : null != defaultValue ? $662d9978aa5168bc$var$setDefaultValue(element, type, $662d9978aa5168bc$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $662d9978aa5168bc$var$getToStringValue(name) : element.removeAttribute("name");
}
function $662d9978aa5168bc$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $662d9978aa5168bc$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $662d9978aa5168bc$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $662d9978aa5168bc$var$setDefaultValue(node, type, value) {
    "number" === type && $662d9978aa5168bc$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $662d9978aa5168bc$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $662d9978aa5168bc$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $662d9978aa5168bc$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $662d9978aa5168bc$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $662d9978aa5168bc$var$getToStringValue(defaultValue) : "";
}
function $662d9978aa5168bc$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(92));
            if ($662d9978aa5168bc$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $662d9978aa5168bc$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $662d9978aa5168bc$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $662d9978aa5168bc$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $662d9978aa5168bc$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $662d9978aa5168bc$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $662d9978aa5168bc$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $662d9978aa5168bc$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $662d9978aa5168bc$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $662d9978aa5168bc$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $662d9978aa5168bc$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $662d9978aa5168bc$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $662d9978aa5168bc$var$sanitizeURL(url) {
    return $662d9978aa5168bc$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $662d9978aa5168bc$var$currentReplayingEvent = null;
function $662d9978aa5168bc$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $662d9978aa5168bc$var$restoreTarget = null, $662d9978aa5168bc$var$restoreQueue = null;
function $662d9978aa5168bc$var$restoreStateOfTarget(target) {
    var internalInstance = $662d9978aa5168bc$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$662d9978aa5168bc$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $662d9978aa5168bc$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$662d9978aa5168bc$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(90));
                            $662d9978aa5168bc$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $662d9978aa5168bc$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $662d9978aa5168bc$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $662d9978aa5168bc$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $662d9978aa5168bc$var$isInsideEventHandler = !1;
function $662d9978aa5168bc$var$batchedUpdates$1(fn, a, b) {
    if ($662d9978aa5168bc$var$isInsideEventHandler) return fn(a, b);
    $662d9978aa5168bc$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($662d9978aa5168bc$var$isInsideEventHandler = !1, null !== $662d9978aa5168bc$var$restoreTarget || null !== $662d9978aa5168bc$var$restoreQueue) {
            if ($662d9978aa5168bc$var$flushSyncWork$1(), $662d9978aa5168bc$var$restoreTarget && (a = $662d9978aa5168bc$var$restoreTarget, fn = $662d9978aa5168bc$var$restoreQueue, $662d9978aa5168bc$var$restoreQueue = $662d9978aa5168bc$var$restoreTarget = null, $662d9978aa5168bc$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$662d9978aa5168bc$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $662d9978aa5168bc$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$662d9978aa5168bc$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $662d9978aa5168bc$var$passiveBrowserEventsSupported = !1;
if ($662d9978aa5168bc$var$canUseDOM) try {
    var $662d9978aa5168bc$var$options = {};
    Object.defineProperty($662d9978aa5168bc$var$options, "passive", {
        get: function() {
            $662d9978aa5168bc$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $662d9978aa5168bc$var$options, $662d9978aa5168bc$var$options);
    window.removeEventListener("test", $662d9978aa5168bc$var$options, $662d9978aa5168bc$var$options);
} catch (e) {
    $662d9978aa5168bc$var$passiveBrowserEventsSupported = !1;
}
var $662d9978aa5168bc$var$root = null, $662d9978aa5168bc$var$startText = null, $662d9978aa5168bc$var$fallbackText = null;
function $662d9978aa5168bc$var$getData() {
    if ($662d9978aa5168bc$var$fallbackText) return $662d9978aa5168bc$var$fallbackText;
    var start, startValue = $662d9978aa5168bc$var$startText, startLength = startValue.length, end, endValue = "value" in $662d9978aa5168bc$var$root ? $662d9978aa5168bc$var$root.value : $662d9978aa5168bc$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $662d9978aa5168bc$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $662d9978aa5168bc$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $662d9978aa5168bc$var$functionThatReturnsTrue() {
    return !0;
}
function $662d9978aa5168bc$var$functionThatReturnsFalse() {
    return !1;
}
function $662d9978aa5168bc$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $662d9978aa5168bc$var$functionThatReturnsTrue : $662d9978aa5168bc$var$functionThatReturnsFalse;
        this.isPropagationStopped = $662d9978aa5168bc$var$functionThatReturnsFalse;
        return this;
    }
    $662d9978aa5168bc$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $662d9978aa5168bc$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $662d9978aa5168bc$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $662d9978aa5168bc$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $662d9978aa5168bc$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $662d9978aa5168bc$var$SyntheticEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$EventInterface), $662d9978aa5168bc$var$UIEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    view: 0,
    detail: 0
}), $662d9978aa5168bc$var$SyntheticUIEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$UIEventInterface), $662d9978aa5168bc$var$lastMovementX, $662d9978aa5168bc$var$lastMovementY, $662d9978aa5168bc$var$lastMouseEvent, $662d9978aa5168bc$var$MouseEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $662d9978aa5168bc$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $662d9978aa5168bc$var$lastMouseEvent && ($662d9978aa5168bc$var$lastMouseEvent && "mousemove" === event.type ? ($662d9978aa5168bc$var$lastMovementX = event.screenX - $662d9978aa5168bc$var$lastMouseEvent.screenX, $662d9978aa5168bc$var$lastMovementY = event.screenY - $662d9978aa5168bc$var$lastMouseEvent.screenY) : $662d9978aa5168bc$var$lastMovementY = $662d9978aa5168bc$var$lastMovementX = 0, $662d9978aa5168bc$var$lastMouseEvent = event);
        return $662d9978aa5168bc$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $662d9978aa5168bc$var$lastMovementY;
    }
}), $662d9978aa5168bc$var$SyntheticMouseEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$MouseEventInterface), $662d9978aa5168bc$var$DragEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$MouseEventInterface, {
    dataTransfer: 0
}), $662d9978aa5168bc$var$SyntheticDragEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$DragEventInterface), $662d9978aa5168bc$var$FocusEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$UIEventInterface, {
    relatedTarget: 0
}), $662d9978aa5168bc$var$SyntheticFocusEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$FocusEventInterface), $662d9978aa5168bc$var$AnimationEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $662d9978aa5168bc$var$SyntheticAnimationEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$AnimationEventInterface), $662d9978aa5168bc$var$ClipboardEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $662d9978aa5168bc$var$SyntheticClipboardEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$ClipboardEventInterface), $662d9978aa5168bc$var$CompositionEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    data: 0
}), $662d9978aa5168bc$var$SyntheticCompositionEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$CompositionEventInterface), $662d9978aa5168bc$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $662d9978aa5168bc$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $662d9978aa5168bc$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $662d9978aa5168bc$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $662d9978aa5168bc$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $662d9978aa5168bc$var$getEventModifierState() {
    return $662d9978aa5168bc$var$modifierStateGetter;
}
var $662d9978aa5168bc$var$KeyboardEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $662d9978aa5168bc$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $662d9978aa5168bc$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $662d9978aa5168bc$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $662d9978aa5168bc$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $662d9978aa5168bc$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $662d9978aa5168bc$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $662d9978aa5168bc$var$SyntheticKeyboardEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$KeyboardEventInterface), $662d9978aa5168bc$var$PointerEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $662d9978aa5168bc$var$SyntheticPointerEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$PointerEventInterface), $662d9978aa5168bc$var$TouchEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $662d9978aa5168bc$var$getEventModifierState
}), $662d9978aa5168bc$var$SyntheticTouchEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$TouchEventInterface), $662d9978aa5168bc$var$TransitionEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $662d9978aa5168bc$var$SyntheticTransitionEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$TransitionEventInterface), $662d9978aa5168bc$var$WheelEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $662d9978aa5168bc$var$SyntheticWheelEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$WheelEventInterface), $662d9978aa5168bc$var$ToggleEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $662d9978aa5168bc$var$SyntheticToggleEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$ToggleEventInterface), $662d9978aa5168bc$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $662d9978aa5168bc$var$canUseCompositionEvent = $662d9978aa5168bc$var$canUseDOM && "CompositionEvent" in window, $662d9978aa5168bc$var$documentMode = null;
$662d9978aa5168bc$var$canUseDOM && "documentMode" in document && ($662d9978aa5168bc$var$documentMode = document.documentMode);
var $662d9978aa5168bc$var$canUseTextInputEvent = $662d9978aa5168bc$var$canUseDOM && "TextEvent" in window && !$662d9978aa5168bc$var$documentMode, $662d9978aa5168bc$var$useFallbackCompositionData = $662d9978aa5168bc$var$canUseDOM && (!$662d9978aa5168bc$var$canUseCompositionEvent || $662d9978aa5168bc$var$documentMode && 8 < $662d9978aa5168bc$var$documentMode && 11 >= $662d9978aa5168bc$var$documentMode), $662d9978aa5168bc$var$SPACEBAR_CHAR = String.fromCharCode(32), $662d9978aa5168bc$var$hasSpaceKeypress = !1;
function $662d9978aa5168bc$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $662d9978aa5168bc$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $662d9978aa5168bc$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $662d9978aa5168bc$var$isComposing = !1;
function $662d9978aa5168bc$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $662d9978aa5168bc$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $662d9978aa5168bc$var$hasSpaceKeypress = !0;
            return $662d9978aa5168bc$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $662d9978aa5168bc$var$SPACEBAR_CHAR && $662d9978aa5168bc$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $662d9978aa5168bc$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($662d9978aa5168bc$var$isComposing) return "compositionend" === domEventName || !$662d9978aa5168bc$var$canUseCompositionEvent && $662d9978aa5168bc$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $662d9978aa5168bc$var$getData(), $662d9978aa5168bc$var$fallbackText = $662d9978aa5168bc$var$startText = $662d9978aa5168bc$var$root = null, $662d9978aa5168bc$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $662d9978aa5168bc$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $662d9978aa5168bc$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $662d9978aa5168bc$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$662d9978aa5168bc$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $662d9978aa5168bc$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $662d9978aa5168bc$var$restoreTarget ? $662d9978aa5168bc$var$restoreQueue ? $662d9978aa5168bc$var$restoreQueue.push(target) : $662d9978aa5168bc$var$restoreQueue = [
        target
    ] : $662d9978aa5168bc$var$restoreTarget = target;
    inst = $662d9978aa5168bc$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $662d9978aa5168bc$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $662d9978aa5168bc$var$activeElement$1 = null, $662d9978aa5168bc$var$activeElementInst$1 = null;
function $662d9978aa5168bc$var$runEventInBatch(dispatchQueue) {
    $662d9978aa5168bc$var$processDispatchQueue(dispatchQueue, 0);
}
function $662d9978aa5168bc$var$getInstIfValueChanged(targetInst) {
    var targetNode = $662d9978aa5168bc$var$getNodeFromInstance(targetInst);
    if ($662d9978aa5168bc$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $662d9978aa5168bc$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $662d9978aa5168bc$var$isInputEventSupported = !1;
if ($662d9978aa5168bc$var$canUseDOM) {
    var $662d9978aa5168bc$var$JSCompiler_inline_result$jscomp$283;
    if ($662d9978aa5168bc$var$canUseDOM) {
        var $662d9978aa5168bc$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$662d9978aa5168bc$var$isSupported$jscomp$inline_418) {
            var $662d9978aa5168bc$var$element$jscomp$inline_419 = document.createElement("div");
            $662d9978aa5168bc$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $662d9978aa5168bc$var$isSupported$jscomp$inline_418 = "function" === typeof $662d9978aa5168bc$var$element$jscomp$inline_419.oninput;
        }
        $662d9978aa5168bc$var$JSCompiler_inline_result$jscomp$283 = $662d9978aa5168bc$var$isSupported$jscomp$inline_418;
    } else $662d9978aa5168bc$var$JSCompiler_inline_result$jscomp$283 = !1;
    $662d9978aa5168bc$var$isInputEventSupported = $662d9978aa5168bc$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $662d9978aa5168bc$var$stopWatchingForValueChange() {
    $662d9978aa5168bc$var$activeElement$1 && ($662d9978aa5168bc$var$activeElement$1.detachEvent("onpropertychange", $662d9978aa5168bc$var$handlePropertyChange), $662d9978aa5168bc$var$activeElementInst$1 = $662d9978aa5168bc$var$activeElement$1 = null);
}
function $662d9978aa5168bc$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $662d9978aa5168bc$var$getInstIfValueChanged($662d9978aa5168bc$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $662d9978aa5168bc$var$createAndAccumulateChangeEvent(dispatchQueue, $662d9978aa5168bc$var$activeElementInst$1, nativeEvent, $662d9978aa5168bc$var$getEventTarget(nativeEvent));
        $662d9978aa5168bc$var$batchedUpdates$1($662d9978aa5168bc$var$runEventInBatch, dispatchQueue);
    }
}
function $662d9978aa5168bc$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($662d9978aa5168bc$var$stopWatchingForValueChange(), $662d9978aa5168bc$var$activeElement$1 = target, $662d9978aa5168bc$var$activeElementInst$1 = targetInst, $662d9978aa5168bc$var$activeElement$1.attachEvent("onpropertychange", $662d9978aa5168bc$var$handlePropertyChange)) : "focusout" === domEventName && $662d9978aa5168bc$var$stopWatchingForValueChange();
}
function $662d9978aa5168bc$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $662d9978aa5168bc$var$getInstIfValueChanged($662d9978aa5168bc$var$activeElementInst$1);
}
function $662d9978aa5168bc$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $662d9978aa5168bc$var$getInstIfValueChanged(targetInst);
}
function $662d9978aa5168bc$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $662d9978aa5168bc$var$getInstIfValueChanged(targetInst);
}
function $662d9978aa5168bc$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $662d9978aa5168bc$var$objectIs = "function" === typeof Object.is ? Object.is : $662d9978aa5168bc$var$is;
function $662d9978aa5168bc$var$shallowEqual(objA, objB) {
    if ($662d9978aa5168bc$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$662d9978aa5168bc$var$hasOwnProperty.call(objB, currentKey) || !$662d9978aa5168bc$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $662d9978aa5168bc$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $662d9978aa5168bc$var$getNodeForCharacterOffset(root, offset) {
    var node = $662d9978aa5168bc$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $662d9978aa5168bc$var$getLeafNode(node);
    }
}
function $662d9978aa5168bc$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $662d9978aa5168bc$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $662d9978aa5168bc$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $662d9978aa5168bc$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $662d9978aa5168bc$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $662d9978aa5168bc$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $662d9978aa5168bc$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $662d9978aa5168bc$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $662d9978aa5168bc$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $662d9978aa5168bc$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $662d9978aa5168bc$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $662d9978aa5168bc$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $662d9978aa5168bc$var$skipSelectionChangeEvent = $662d9978aa5168bc$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $662d9978aa5168bc$var$activeElement = null, $662d9978aa5168bc$var$activeElementInst = null, $662d9978aa5168bc$var$lastSelection = null, $662d9978aa5168bc$var$mouseDown = !1;
function $662d9978aa5168bc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $662d9978aa5168bc$var$mouseDown || null == $662d9978aa5168bc$var$activeElement || $662d9978aa5168bc$var$activeElement !== $662d9978aa5168bc$var$getActiveElement(doc) || (doc = $662d9978aa5168bc$var$activeElement, "selectionStart" in doc && $662d9978aa5168bc$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $662d9978aa5168bc$var$lastSelection && $662d9978aa5168bc$var$shallowEqual($662d9978aa5168bc$var$lastSelection, doc) || ($662d9978aa5168bc$var$lastSelection = doc, doc = $662d9978aa5168bc$var$accumulateTwoPhaseListeners($662d9978aa5168bc$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $662d9978aa5168bc$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $662d9978aa5168bc$var$activeElement)));
}
function $662d9978aa5168bc$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $662d9978aa5168bc$var$vendorPrefixes = {
    animationend: $662d9978aa5168bc$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $662d9978aa5168bc$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $662d9978aa5168bc$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $662d9978aa5168bc$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $662d9978aa5168bc$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $662d9978aa5168bc$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $662d9978aa5168bc$var$makePrefixMap("Transition", "TransitionEnd")
}, $662d9978aa5168bc$var$prefixedEventNames = {}, $662d9978aa5168bc$var$style = {};
$662d9978aa5168bc$var$canUseDOM && ($662d9978aa5168bc$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $662d9978aa5168bc$var$vendorPrefixes.animationend.animation, delete $662d9978aa5168bc$var$vendorPrefixes.animationiteration.animation, delete $662d9978aa5168bc$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $662d9978aa5168bc$var$vendorPrefixes.transitionend.transition);
function $662d9978aa5168bc$var$getVendorPrefixedEventName(eventName) {
    if ($662d9978aa5168bc$var$prefixedEventNames[eventName]) return $662d9978aa5168bc$var$prefixedEventNames[eventName];
    if (!$662d9978aa5168bc$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $662d9978aa5168bc$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $662d9978aa5168bc$var$style) return $662d9978aa5168bc$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $662d9978aa5168bc$var$ANIMATION_END = $662d9978aa5168bc$var$getVendorPrefixedEventName("animationend"), $662d9978aa5168bc$var$ANIMATION_ITERATION = $662d9978aa5168bc$var$getVendorPrefixedEventName("animationiteration"), $662d9978aa5168bc$var$ANIMATION_START = $662d9978aa5168bc$var$getVendorPrefixedEventName("animationstart"), $662d9978aa5168bc$var$TRANSITION_RUN = $662d9978aa5168bc$var$getVendorPrefixedEventName("transitionrun"), $662d9978aa5168bc$var$TRANSITION_START = $662d9978aa5168bc$var$getVendorPrefixedEventName("transitionstart"), $662d9978aa5168bc$var$TRANSITION_CANCEL = $662d9978aa5168bc$var$getVendorPrefixedEventName("transitioncancel"), $662d9978aa5168bc$var$TRANSITION_END = $662d9978aa5168bc$var$getVendorPrefixedEventName("transitionend"), $662d9978aa5168bc$var$topLevelEventsToReactNames = new Map(), $662d9978aa5168bc$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $662d9978aa5168bc$var$registerSimpleEvent(domEventName, reactName) {
    $662d9978aa5168bc$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $662d9978aa5168bc$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $662d9978aa5168bc$var$concurrentQueues = [], $662d9978aa5168bc$var$concurrentQueuesIndex = 0, $662d9978aa5168bc$var$concurrentlyUpdatedLanes = 0;
function $662d9978aa5168bc$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $662d9978aa5168bc$var$concurrentQueuesIndex, i = $662d9978aa5168bc$var$concurrentlyUpdatedLanes = $662d9978aa5168bc$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $662d9978aa5168bc$var$concurrentQueues[i];
        $662d9978aa5168bc$var$concurrentQueues[i++] = null;
        var queue = $662d9978aa5168bc$var$concurrentQueues[i];
        $662d9978aa5168bc$var$concurrentQueues[i++] = null;
        var update = $662d9978aa5168bc$var$concurrentQueues[i];
        $662d9978aa5168bc$var$concurrentQueues[i++] = null;
        var lane = $662d9978aa5168bc$var$concurrentQueues[i];
        $662d9978aa5168bc$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $662d9978aa5168bc$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $662d9978aa5168bc$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $662d9978aa5168bc$var$concurrentQueues[$662d9978aa5168bc$var$concurrentQueuesIndex++] = fiber;
    $662d9978aa5168bc$var$concurrentQueues[$662d9978aa5168bc$var$concurrentQueuesIndex++] = queue;
    $662d9978aa5168bc$var$concurrentQueues[$662d9978aa5168bc$var$concurrentQueuesIndex++] = update;
    $662d9978aa5168bc$var$concurrentQueues[$662d9978aa5168bc$var$concurrentQueuesIndex++] = lane;
    $662d9978aa5168bc$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $662d9978aa5168bc$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $662d9978aa5168bc$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $662d9978aa5168bc$var$getRootForUpdatedFiber(fiber);
}
function $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $662d9978aa5168bc$var$enqueueUpdate$1(fiber, null, null, lane);
    return $662d9978aa5168bc$var$getRootForUpdatedFiber(fiber);
}
function $662d9978aa5168bc$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $662d9978aa5168bc$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $662d9978aa5168bc$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $662d9978aa5168bc$var$nestedUpdateCount) throw $662d9978aa5168bc$var$nestedUpdateCount = 0, $662d9978aa5168bc$var$rootWithNestedUpdates = null, Error($662d9978aa5168bc$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $662d9978aa5168bc$var$emptyContextObject = {}, $662d9978aa5168bc$var$CapturedStacks = new WeakMap();
function $662d9978aa5168bc$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $662d9978aa5168bc$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $662d9978aa5168bc$var$getStackByFiberInDevAndProd(source)
        };
        $662d9978aa5168bc$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $662d9978aa5168bc$var$getStackByFiberInDevAndProd(source)
    };
}
var $662d9978aa5168bc$var$forkStack = [], $662d9978aa5168bc$var$forkStackIndex = 0, $662d9978aa5168bc$var$treeForkProvider = null, $662d9978aa5168bc$var$treeForkCount = 0, $662d9978aa5168bc$var$idStack = [], $662d9978aa5168bc$var$idStackIndex = 0, $662d9978aa5168bc$var$treeContextProvider = null, $662d9978aa5168bc$var$treeContextId = 1, $662d9978aa5168bc$var$treeContextOverflow = "";
function $662d9978aa5168bc$var$pushTreeFork(workInProgress, totalChildren) {
    $662d9978aa5168bc$var$forkStack[$662d9978aa5168bc$var$forkStackIndex++] = $662d9978aa5168bc$var$treeForkCount;
    $662d9978aa5168bc$var$forkStack[$662d9978aa5168bc$var$forkStackIndex++] = $662d9978aa5168bc$var$treeForkProvider;
    $662d9978aa5168bc$var$treeForkProvider = workInProgress;
    $662d9978aa5168bc$var$treeForkCount = totalChildren;
}
function $662d9978aa5168bc$var$pushTreeId(workInProgress, totalChildren, index) {
    $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextId;
    $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextOverflow;
    $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextProvider;
    $662d9978aa5168bc$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $662d9978aa5168bc$var$treeContextId;
    workInProgress = $662d9978aa5168bc$var$treeContextOverflow;
    var baseLength = 32 - $662d9978aa5168bc$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $662d9978aa5168bc$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $662d9978aa5168bc$var$treeContextId = 1 << 32 - $662d9978aa5168bc$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $662d9978aa5168bc$var$treeContextOverflow = length + workInProgress;
    } else $662d9978aa5168bc$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $662d9978aa5168bc$var$treeContextOverflow = workInProgress;
}
function $662d9978aa5168bc$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($662d9978aa5168bc$var$pushTreeFork(workInProgress, 1), $662d9978aa5168bc$var$pushTreeId(workInProgress, 1, 0));
}
function $662d9978aa5168bc$var$popTreeContext(workInProgress) {
    for(; workInProgress === $662d9978aa5168bc$var$treeForkProvider;)$662d9978aa5168bc$var$treeForkProvider = $662d9978aa5168bc$var$forkStack[--$662d9978aa5168bc$var$forkStackIndex], $662d9978aa5168bc$var$forkStack[$662d9978aa5168bc$var$forkStackIndex] = null, $662d9978aa5168bc$var$treeForkCount = $662d9978aa5168bc$var$forkStack[--$662d9978aa5168bc$var$forkStackIndex], $662d9978aa5168bc$var$forkStack[$662d9978aa5168bc$var$forkStackIndex] = null;
    for(; workInProgress === $662d9978aa5168bc$var$treeContextProvider;)$662d9978aa5168bc$var$treeContextProvider = $662d9978aa5168bc$var$idStack[--$662d9978aa5168bc$var$idStackIndex], $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex] = null, $662d9978aa5168bc$var$treeContextOverflow = $662d9978aa5168bc$var$idStack[--$662d9978aa5168bc$var$idStackIndex], $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex] = null, $662d9978aa5168bc$var$treeContextId = $662d9978aa5168bc$var$idStack[--$662d9978aa5168bc$var$idStackIndex], $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex] = null;
}
var $662d9978aa5168bc$var$hydrationParentFiber = null, $662d9978aa5168bc$var$nextHydratableInstance = null, $662d9978aa5168bc$var$isHydrating = !1, $662d9978aa5168bc$var$hydrationErrors = null, $662d9978aa5168bc$var$rootOrSingletonContext = !1, $662d9978aa5168bc$var$HydrationMismatchException = Error($662d9978aa5168bc$var$formatProdErrorMessage(519));
function $662d9978aa5168bc$var$throwOnHydrationMismatch(fiber) {
    var error = Error($662d9978aa5168bc$var$formatProdErrorMessage(418, ""));
    $662d9978aa5168bc$var$queueHydrationError($662d9978aa5168bc$var$createCapturedValueAtFiber(error, fiber));
    throw $662d9978aa5168bc$var$HydrationMismatchException;
}
function $662d9978aa5168bc$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$662d9978aa5168bc$var$internalInstanceKey] = fiber;
    instance[$662d9978aa5168bc$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("cancel", instance);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $662d9978aa5168bc$var$mediaEventTypes.length; type++)$662d9978aa5168bc$var$listenToNonDelegatedEvent($662d9978aa5168bc$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", instance);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", instance);
            $662d9978aa5168bc$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $662d9978aa5168bc$var$track(instance);
            break;
        case "select":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", instance), $662d9978aa5168bc$var$initTextarea(instance, props.value, props.defaultValue, props.children), $662d9978aa5168bc$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $662d9978aa5168bc$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($662d9978aa5168bc$var$listenToNonDelegatedEvent("beforetoggle", instance), $662d9978aa5168bc$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $662d9978aa5168bc$var$noop$1), instance = !0) : instance = !1;
    instance || $662d9978aa5168bc$var$throwOnHydrationMismatch(fiber);
}
function $662d9978aa5168bc$var$popToNextHostParent(fiber) {
    for($662d9978aa5168bc$var$hydrationParentFiber = fiber.return; $662d9978aa5168bc$var$hydrationParentFiber;)switch($662d9978aa5168bc$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $662d9978aa5168bc$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $662d9978aa5168bc$var$rootOrSingletonContext = !1;
            return;
        default:
            $662d9978aa5168bc$var$hydrationParentFiber = $662d9978aa5168bc$var$hydrationParentFiber.return;
    }
}
function $662d9978aa5168bc$var$popHydrationState(fiber) {
    if (fiber !== $662d9978aa5168bc$var$hydrationParentFiber) return !1;
    if (!$662d9978aa5168bc$var$isHydrating) return $662d9978aa5168bc$var$popToNextHostParent(fiber), $662d9978aa5168bc$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $662d9978aa5168bc$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $662d9978aa5168bc$var$nextHydratableInstance && $662d9978aa5168bc$var$throwOnHydrationMismatch(fiber);
    $662d9978aa5168bc$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $662d9978aa5168bc$var$nextHydratableInstance = null;
        }
    } else $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$hydrationParentFiber ? $662d9978aa5168bc$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $662d9978aa5168bc$var$resetHydrationState() {
    $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$hydrationParentFiber = null;
    $662d9978aa5168bc$var$isHydrating = !1;
}
function $662d9978aa5168bc$var$queueHydrationError(error) {
    null === $662d9978aa5168bc$var$hydrationErrors ? $662d9978aa5168bc$var$hydrationErrors = [
        error
    ] : $662d9978aa5168bc$var$hydrationErrors.push(error);
}
var $662d9978aa5168bc$var$SuspenseException = Error($662d9978aa5168bc$var$formatProdErrorMessage(460)), $662d9978aa5168bc$var$SuspenseyCommitException = Error($662d9978aa5168bc$var$formatProdErrorMessage(474)), $662d9978aa5168bc$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $662d9978aa5168bc$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $662d9978aa5168bc$var$noop$3() {}
function $662d9978aa5168bc$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($662d9978aa5168bc$var$noop$3, $662d9978aa5168bc$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $662d9978aa5168bc$var$SuspenseException) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($662d9978aa5168bc$var$noop$3, $662d9978aa5168bc$var$noop$3);
            else {
                thenableState = $662d9978aa5168bc$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $662d9978aa5168bc$var$SuspenseException) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $662d9978aa5168bc$var$suspendedThenable = thenable;
            throw $662d9978aa5168bc$var$SuspenseException;
    }
}
var $662d9978aa5168bc$var$suspendedThenable = null;
function $662d9978aa5168bc$var$getSuspendedThenable() {
    if (null === $662d9978aa5168bc$var$suspendedThenable) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(459));
    var thenable = $662d9978aa5168bc$var$suspendedThenable;
    $662d9978aa5168bc$var$suspendedThenable = null;
    return thenable;
}
var $662d9978aa5168bc$var$thenableState$1 = null, $662d9978aa5168bc$var$thenableIndexCounter$1 = 0;
function $662d9978aa5168bc$var$unwrapThenable(thenable) {
    var index = $662d9978aa5168bc$var$thenableIndexCounter$1;
    $662d9978aa5168bc$var$thenableIndexCounter$1 += 1;
    null === $662d9978aa5168bc$var$thenableState$1 && ($662d9978aa5168bc$var$thenableState$1 = []);
    return $662d9978aa5168bc$var$trackUsedThenable($662d9978aa5168bc$var$thenableState$1, thenable, index);
}
function $662d9978aa5168bc$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $662d9978aa5168bc$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $662d9978aa5168bc$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $662d9978aa5168bc$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $662d9978aa5168bc$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $662d9978aa5168bc$var$REACT_LAZY_TYPE && $662d9978aa5168bc$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $662d9978aa5168bc$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $662d9978aa5168bc$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $662d9978aa5168bc$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $662d9978aa5168bc$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $662d9978aa5168bc$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $662d9978aa5168bc$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $662d9978aa5168bc$var$REACT_ELEMENT_TYPE:
                    return lanes = $662d9978aa5168bc$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $662d9978aa5168bc$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
                    return newChild = $662d9978aa5168bc$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($662d9978aa5168bc$var$isArrayImpl(newChild) || $662d9978aa5168bc$var$getIteratorFn(newChild)) return newChild = $662d9978aa5168bc$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $662d9978aa5168bc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $662d9978aa5168bc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $662d9978aa5168bc$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($662d9978aa5168bc$var$isArrayImpl(newChild) || $662d9978aa5168bc$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $662d9978aa5168bc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $662d9978aa5168bc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $662d9978aa5168bc$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($662d9978aa5168bc$var$isArrayImpl(newChild) || $662d9978aa5168bc$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $662d9978aa5168bc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $662d9978aa5168bc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $662d9978aa5168bc$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $662d9978aa5168bc$var$REACT_LAZY_TYPE && $662d9978aa5168bc$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $662d9978aa5168bc$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE ? (lanes = $662d9978aa5168bc$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $662d9978aa5168bc$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $662d9978aa5168bc$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $662d9978aa5168bc$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($662d9978aa5168bc$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($662d9978aa5168bc$var$getIteratorFn(newChild)) {
                key = $662d9978aa5168bc$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $662d9978aa5168bc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $662d9978aa5168bc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $662d9978aa5168bc$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $662d9978aa5168bc$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $662d9978aa5168bc$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $662d9978aa5168bc$var$SuspenseException) throw x;
            var fiber = $662d9978aa5168bc$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $662d9978aa5168bc$var$reconcileChildFibers = $662d9978aa5168bc$var$createChildReconciler(!0), $662d9978aa5168bc$var$mountChildFibers = $662d9978aa5168bc$var$createChildReconciler(!1), $662d9978aa5168bc$var$currentTreeHiddenStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$prevEntangledRenderLanesCursor = $662d9978aa5168bc$var$createCursor(0);
function $662d9978aa5168bc$var$pushHiddenContext(fiber, context) {
    fiber = $662d9978aa5168bc$var$entangledRenderLanes;
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$prevEntangledRenderLanesCursor, fiber);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$currentTreeHiddenStackCursor, context);
    $662d9978aa5168bc$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $662d9978aa5168bc$var$reuseHiddenContextOnStack() {
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$prevEntangledRenderLanesCursor, $662d9978aa5168bc$var$entangledRenderLanes);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$currentTreeHiddenStackCursor, $662d9978aa5168bc$var$currentTreeHiddenStackCursor.current);
}
function $662d9978aa5168bc$var$popHiddenContext() {
    $662d9978aa5168bc$var$entangledRenderLanes = $662d9978aa5168bc$var$prevEntangledRenderLanesCursor.current;
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$currentTreeHiddenStackCursor);
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$prevEntangledRenderLanesCursor);
}
var $662d9978aa5168bc$var$suspenseHandlerStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$shellBoundary = null;
function $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current & 1);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseHandlerStackCursor, handler);
    null === $662d9978aa5168bc$var$shellBoundary && (null === current || null !== $662d9978aa5168bc$var$currentTreeHiddenStackCursor.current ? $662d9978aa5168bc$var$shellBoundary = handler : null !== current.memoizedState && ($662d9978aa5168bc$var$shellBoundary = handler));
}
function $662d9978aa5168bc$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current), $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseHandlerStackCursor, fiber), null === $662d9978aa5168bc$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($662d9978aa5168bc$var$shellBoundary = fiber);
        }
    } else $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(fiber);
}
function $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack() {
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseHandlerStackCursor, $662d9978aa5168bc$var$suspenseHandlerStackCursor.current);
}
function $662d9978aa5168bc$var$popSuspenseHandler(fiber) {
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseHandlerStackCursor);
    $662d9978aa5168bc$var$shellBoundary === fiber && ($662d9978aa5168bc$var$shellBoundary = null);
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseStackCursor);
}
var $662d9978aa5168bc$var$suspenseStackCursor = $662d9978aa5168bc$var$createCursor(0);
function $662d9978aa5168bc$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $662d9978aa5168bc$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $662d9978aa5168bc$var$scheduleCallback$2 = $ibqfJ.unstable_scheduleCallback, $662d9978aa5168bc$var$NormalPriority = $ibqfJ.unstable_NormalPriority, $662d9978aa5168bc$var$CacheContext = {
    $$typeof: $662d9978aa5168bc$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $662d9978aa5168bc$var$createCache() {
    return {
        controller: new $662d9978aa5168bc$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $662d9978aa5168bc$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $662d9978aa5168bc$var$scheduleCallback$2($662d9978aa5168bc$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $662d9978aa5168bc$var$currentEntangledListeners = null, $662d9978aa5168bc$var$currentEntangledPendingCount = 0, $662d9978aa5168bc$var$currentEntangledLane = 0, $662d9978aa5168bc$var$currentEntangledActionThenable = null;
function $662d9978aa5168bc$var$entangleAsyncAction(transition, thenable) {
    if (null === $662d9978aa5168bc$var$currentEntangledListeners) {
        var entangledListeners = $662d9978aa5168bc$var$currentEntangledListeners = [];
        $662d9978aa5168bc$var$currentEntangledPendingCount = 0;
        $662d9978aa5168bc$var$currentEntangledLane = $662d9978aa5168bc$var$requestTransitionLane();
        $662d9978aa5168bc$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $662d9978aa5168bc$var$currentEntangledPendingCount++;
    thenable.then($662d9978aa5168bc$var$pingEngtangledActionScope, $662d9978aa5168bc$var$pingEngtangledActionScope);
    return thenable;
}
function $662d9978aa5168bc$var$pingEngtangledActionScope() {
    if (0 === --$662d9978aa5168bc$var$currentEntangledPendingCount && null !== $662d9978aa5168bc$var$currentEntangledListeners) {
        null !== $662d9978aa5168bc$var$currentEntangledActionThenable && ($662d9978aa5168bc$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $662d9978aa5168bc$var$currentEntangledListeners;
        $662d9978aa5168bc$var$currentEntangledListeners = null;
        $662d9978aa5168bc$var$currentEntangledLane = 0;
        $662d9978aa5168bc$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $662d9978aa5168bc$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $662d9978aa5168bc$var$prevOnStartTransitionFinish = $662d9978aa5168bc$var$ReactSharedInternals.S;
$662d9978aa5168bc$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $662d9978aa5168bc$var$entangleAsyncAction(transition, returnValue);
    null !== $662d9978aa5168bc$var$prevOnStartTransitionFinish && $662d9978aa5168bc$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $662d9978aa5168bc$var$resumedCache = $662d9978aa5168bc$var$createCursor(null);
function $662d9978aa5168bc$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $662d9978aa5168bc$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $662d9978aa5168bc$var$workInProgressRoot.pooledCache;
}
function $662d9978aa5168bc$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $662d9978aa5168bc$var$push($662d9978aa5168bc$var$resumedCache, $662d9978aa5168bc$var$resumedCache.current) : $662d9978aa5168bc$var$push($662d9978aa5168bc$var$resumedCache, prevCachePool.pool);
}
function $662d9978aa5168bc$var$getSuspendedCache() {
    var cacheFromPool = $662d9978aa5168bc$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $662d9978aa5168bc$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $662d9978aa5168bc$var$renderLanes = 0, $662d9978aa5168bc$var$currentlyRenderingFiber$1 = null, $662d9978aa5168bc$var$currentHook = null, $662d9978aa5168bc$var$workInProgressHook = null, $662d9978aa5168bc$var$didScheduleRenderPhaseUpdate = !1, $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $662d9978aa5168bc$var$localIdCounter = 0, $662d9978aa5168bc$var$thenableIndexCounter = 0, $662d9978aa5168bc$var$thenableState = null, $662d9978aa5168bc$var$globalClientIdCounter = 0;
function $662d9978aa5168bc$var$throwInvalidHookError() {
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(321));
}
function $662d9978aa5168bc$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$662d9978aa5168bc$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $662d9978aa5168bc$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $662d9978aa5168bc$var$renderLanes = nextRenderLanes;
    $662d9978aa5168bc$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $662d9978aa5168bc$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $662d9978aa5168bc$var$HooksDispatcherOnMount : $662d9978aa5168bc$var$HooksDispatcherOnUpdate;
    $662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $662d9978aa5168bc$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $662d9978aa5168bc$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $662d9978aa5168bc$var$finishRenderingHooks(current) {
    $662d9978aa5168bc$var$ReactSharedInternals.H = $662d9978aa5168bc$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $662d9978aa5168bc$var$currentHook && null !== $662d9978aa5168bc$var$currentHook.next;
    $662d9978aa5168bc$var$renderLanes = 0;
    $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$currentHook = $662d9978aa5168bc$var$currentlyRenderingFiber$1 = null;
    $662d9978aa5168bc$var$didScheduleRenderPhaseUpdate = !1;
    $662d9978aa5168bc$var$thenableIndexCounter = 0;
    $662d9978aa5168bc$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(300));
    null === current || $662d9978aa5168bc$var$didReceiveUpdate || (current = current.dependencies, null !== current && $662d9978aa5168bc$var$checkIfContextChanged(current) && ($662d9978aa5168bc$var$didReceiveUpdate = !0));
}
function $662d9978aa5168bc$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $662d9978aa5168bc$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass && ($662d9978aa5168bc$var$thenableState = null);
        $662d9978aa5168bc$var$thenableIndexCounter = 0;
        $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $662d9978aa5168bc$var$ReactSharedInternals.H = $662d9978aa5168bc$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $662d9978aa5168bc$var$TransitionAwareHostComponent() {
    var dispatcher = $662d9978aa5168bc$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $662d9978aa5168bc$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $662d9978aa5168bc$var$currentHook ? $662d9978aa5168bc$var$currentHook.memoizedState : null) !== dispatcher && ($662d9978aa5168bc$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $662d9978aa5168bc$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $662d9978aa5168bc$var$localIdCounter;
    $662d9978aa5168bc$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $662d9978aa5168bc$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $662d9978aa5168bc$var$resetHooksOnUnwind(workInProgress) {
    if ($662d9978aa5168bc$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $662d9978aa5168bc$var$didScheduleRenderPhaseUpdate = !1;
    }
    $662d9978aa5168bc$var$renderLanes = 0;
    $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$currentHook = $662d9978aa5168bc$var$currentlyRenderingFiber$1 = null;
    $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $662d9978aa5168bc$var$thenableIndexCounter = $662d9978aa5168bc$var$localIdCounter = 0;
    $662d9978aa5168bc$var$thenableState = null;
}
function $662d9978aa5168bc$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $662d9978aa5168bc$var$workInProgressHook ? $662d9978aa5168bc$var$currentlyRenderingFiber$1.memoizedState = $662d9978aa5168bc$var$workInProgressHook = hook : $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$workInProgressHook.next = hook;
    return $662d9978aa5168bc$var$workInProgressHook;
}
function $662d9978aa5168bc$var$updateWorkInProgressHook() {
    if (null === $662d9978aa5168bc$var$currentHook) {
        var nextCurrentHook = $662d9978aa5168bc$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $662d9978aa5168bc$var$currentHook.next;
    var nextWorkInProgressHook = null === $662d9978aa5168bc$var$workInProgressHook ? $662d9978aa5168bc$var$currentlyRenderingFiber$1.memoizedState : $662d9978aa5168bc$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $662d9978aa5168bc$var$workInProgressHook = nextWorkInProgressHook, $662d9978aa5168bc$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $662d9978aa5168bc$var$currentlyRenderingFiber$1.alternate) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(467));
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(310));
        }
        $662d9978aa5168bc$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $662d9978aa5168bc$var$currentHook.memoizedState,
            baseState: $662d9978aa5168bc$var$currentHook.baseState,
            baseQueue: $662d9978aa5168bc$var$currentHook.baseQueue,
            queue: $662d9978aa5168bc$var$currentHook.queue,
            next: null
        };
        null === $662d9978aa5168bc$var$workInProgressHook ? $662d9978aa5168bc$var$currentlyRenderingFiber$1.memoizedState = $662d9978aa5168bc$var$workInProgressHook = nextCurrentHook : $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$workInProgressHook.next = nextCurrentHook;
    }
    return $662d9978aa5168bc$var$workInProgressHook;
}
var $662d9978aa5168bc$var$createFunctionComponentUpdateQueue;
$662d9978aa5168bc$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $662d9978aa5168bc$var$useThenable(thenable) {
    var index = $662d9978aa5168bc$var$thenableIndexCounter;
    $662d9978aa5168bc$var$thenableIndexCounter += 1;
    null === $662d9978aa5168bc$var$thenableState && ($662d9978aa5168bc$var$thenableState = []);
    thenable = $662d9978aa5168bc$var$trackUsedThenable($662d9978aa5168bc$var$thenableState, thenable, index);
    index = $662d9978aa5168bc$var$currentlyRenderingFiber$1;
    null === (null === $662d9978aa5168bc$var$workInProgressHook ? index.memoizedState : $662d9978aa5168bc$var$workInProgressHook.next) && (index = index.alternate, $662d9978aa5168bc$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $662d9978aa5168bc$var$HooksDispatcherOnMount : $662d9978aa5168bc$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $662d9978aa5168bc$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $662d9978aa5168bc$var$useThenable(usable);
        if (usable.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return $662d9978aa5168bc$var$readContext(usable);
    }
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(438, String(usable)));
}
function $662d9978aa5168bc$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $662d9978aa5168bc$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $662d9978aa5168bc$var$createFunctionComponentUpdateQueue(), $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $662d9978aa5168bc$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $662d9978aa5168bc$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $662d9978aa5168bc$var$updateReducer(reducer) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    return $662d9978aa5168bc$var$updateReducerImpl(hook, $662d9978aa5168bc$var$currentHook, reducer);
}
function $662d9978aa5168bc$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($662d9978aa5168bc$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($662d9978aa5168bc$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $662d9978aa5168bc$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($662d9978aa5168bc$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $662d9978aa5168bc$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $662d9978aa5168bc$var$currentlyRenderingFiber$1.lanes |= revertLane, $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $662d9978aa5168bc$var$currentlyRenderingFiber$1.lanes |= updateLane, $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$662d9978aa5168bc$var$objectIs(pendingQueue, hook.memoizedState) && ($662d9978aa5168bc$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $662d9978aa5168bc$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $662d9978aa5168bc$var$rerenderReducer(reducer) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $662d9978aa5168bc$var$objectIs(newState, hook.memoizedState) || ($662d9978aa5168bc$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $662d9978aa5168bc$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $662d9978aa5168bc$var$currentlyRenderingFiber$1, hook = $662d9978aa5168bc$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $662d9978aa5168bc$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$662d9978aa5168bc$var$objectIs(($662d9978aa5168bc$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $662d9978aa5168bc$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $662d9978aa5168bc$var$updateEffect($662d9978aa5168bc$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $662d9978aa5168bc$var$workInProgressHook && $662d9978aa5168bc$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $662d9978aa5168bc$var$pushEffect(9, $662d9978aa5168bc$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $662d9978aa5168bc$var$workInProgressRoot) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($662d9978aa5168bc$var$renderLanes & 60) || $662d9978aa5168bc$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $662d9978aa5168bc$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $662d9978aa5168bc$var$createFunctionComponentUpdateQueue(), $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $662d9978aa5168bc$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $662d9978aa5168bc$var$checkIfSnapshotChanged(inst) && $662d9978aa5168bc$var$forceStoreRerender(fiber);
}
function $662d9978aa5168bc$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $662d9978aa5168bc$var$checkIfSnapshotChanged(inst) && $662d9978aa5168bc$var$forceStoreRerender(fiber);
    });
}
function $662d9978aa5168bc$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$662d9978aa5168bc$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $662d9978aa5168bc$var$forceStoreRerender(fiber) {
    var root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $662d9978aa5168bc$var$mountStateImpl(initialState) {
    var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $662d9978aa5168bc$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $662d9978aa5168bc$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $662d9978aa5168bc$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $662d9978aa5168bc$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $662d9978aa5168bc$var$updateReducerImpl(hook, $662d9978aa5168bc$var$currentHook, "function" === typeof reducer ? reducer : $662d9978aa5168bc$var$basicStateReducer);
}
function $662d9978aa5168bc$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($662d9978aa5168bc$var$isRenderPhaseUpdate(fiber)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $662d9978aa5168bc$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $662d9978aa5168bc$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $662d9978aa5168bc$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T, currentTransition = {};
        $662d9978aa5168bc$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $662d9978aa5168bc$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $662d9978aa5168bc$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $662d9978aa5168bc$var$onActionError(actionQueue, node, error);
        } finally{
            $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $662d9978aa5168bc$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $662d9978aa5168bc$var$onActionError(actionQueue, node, error$60);
    }
}
function $662d9978aa5168bc$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $662d9978aa5168bc$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $662d9978aa5168bc$var$onActionError(actionQueue, node, error);
    }) : $662d9978aa5168bc$var$onActionSuccess(actionQueue, node, returnValue);
}
function $662d9978aa5168bc$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $662d9978aa5168bc$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $662d9978aa5168bc$var$runActionStateAction(actionQueue, nextState)));
}
function $662d9978aa5168bc$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $662d9978aa5168bc$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $662d9978aa5168bc$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $662d9978aa5168bc$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $662d9978aa5168bc$var$mountActionState(action, initialStateProp) {
    if ($662d9978aa5168bc$var$isHydrating) {
        var ssrFormState = $662d9978aa5168bc$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $662d9978aa5168bc$var$currentlyRenderingFiber$1;
                if ($662d9978aa5168bc$var$isHydrating) {
                    if ($662d9978aa5168bc$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $662d9978aa5168bc$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $662d9978aa5168bc$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $662d9978aa5168bc$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $662d9978aa5168bc$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $662d9978aa5168bc$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $662d9978aa5168bc$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $662d9978aa5168bc$var$dispatchSetState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $662d9978aa5168bc$var$mountStateImpl(!1);
    inRootOrSingleton = $662d9978aa5168bc$var$dispatchOptimisticSetState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $662d9978aa5168bc$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $662d9978aa5168bc$var$dispatchActionState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $662d9978aa5168bc$var$updateActionState(action) {
    var stateHook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    return $662d9978aa5168bc$var$updateActionStateImpl(stateHook, $662d9978aa5168bc$var$currentHook, action);
}
function $662d9978aa5168bc$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $662d9978aa5168bc$var$updateReducerImpl(stateHook, currentStateHook, $662d9978aa5168bc$var$actionStateReducer)[0];
    stateHook = $662d9978aa5168bc$var$updateReducer($662d9978aa5168bc$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $662d9978aa5168bc$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $662d9978aa5168bc$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($662d9978aa5168bc$var$currentlyRenderingFiber$1.flags |= 2048, $662d9978aa5168bc$var$pushEffect(9, $662d9978aa5168bc$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $662d9978aa5168bc$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $662d9978aa5168bc$var$rerenderActionState(action) {
    var stateHook = $662d9978aa5168bc$var$updateWorkInProgressHook(), currentStateHook = $662d9978aa5168bc$var$currentHook;
    if (null !== currentStateHook) return $662d9978aa5168bc$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $662d9978aa5168bc$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $662d9978aa5168bc$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $662d9978aa5168bc$var$createFunctionComponentUpdateQueue(), $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $662d9978aa5168bc$var$updateRef() {
    return $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
}
function $662d9978aa5168bc$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
    $662d9978aa5168bc$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $662d9978aa5168bc$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $662d9978aa5168bc$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $662d9978aa5168bc$var$currentHook && null !== deps && $662d9978aa5168bc$var$areHookInputsEqual(deps, $662d9978aa5168bc$var$currentHook.memoizedState.deps) ? hook.memoizedState = $662d9978aa5168bc$var$pushEffect(hookFlags, create, inst, deps) : ($662d9978aa5168bc$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $662d9978aa5168bc$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $662d9978aa5168bc$var$mountEffect(create, deps) {
    $662d9978aa5168bc$var$mountEffectImpl(8390656, 8, create, deps);
}
function $662d9978aa5168bc$var$updateEffect(create, deps) {
    $662d9978aa5168bc$var$updateEffectImpl(2048, 8, create, deps);
}
function $662d9978aa5168bc$var$updateInsertionEffect(create, deps) {
    return $662d9978aa5168bc$var$updateEffectImpl(4, 2, create, deps);
}
function $662d9978aa5168bc$var$updateLayoutEffect(create, deps) {
    return $662d9978aa5168bc$var$updateEffectImpl(4, 4, create, deps);
}
function $662d9978aa5168bc$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $662d9978aa5168bc$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $662d9978aa5168bc$var$updateEffectImpl(4, 4, $662d9978aa5168bc$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $662d9978aa5168bc$var$mountDebugValue() {}
function $662d9978aa5168bc$var$updateCallback(callback, deps) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $662d9978aa5168bc$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $662d9978aa5168bc$var$updateMemo(nextCreate, deps) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $662d9978aa5168bc$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $662d9978aa5168bc$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $662d9978aa5168bc$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $662d9978aa5168bc$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($662d9978aa5168bc$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $662d9978aa5168bc$var$requestDeferredLane();
    $662d9978aa5168bc$var$currentlyRenderingFiber$1.lanes |= hook;
    $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $662d9978aa5168bc$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($662d9978aa5168bc$var$objectIs(value, prevValue)) return value;
    if (null !== $662d9978aa5168bc$var$currentTreeHiddenStackCursor.current) return hook = $662d9978aa5168bc$var$mountDeferredValueImpl(hook, value, initialValue), $662d9978aa5168bc$var$objectIs(hook, prevValue) || ($662d9978aa5168bc$var$didReceiveUpdate = !0), hook;
    if (0 === ($662d9978aa5168bc$var$renderLanes & 42)) return $662d9978aa5168bc$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $662d9978aa5168bc$var$requestDeferredLane();
    $662d9978aa5168bc$var$currentlyRenderingFiber$1.lanes |= hook;
    $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $662d9978aa5168bc$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T, currentTransition = {};
    $662d9978aa5168bc$var$ReactSharedInternals.T = currentTransition;
    $662d9978aa5168bc$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $662d9978aa5168bc$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $662d9978aa5168bc$var$chainThenableValue(returnValue, finishedState);
            $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $662d9978aa5168bc$var$requestUpdateLane(fiber));
        } else $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, finishedState, $662d9978aa5168bc$var$requestUpdateLane(fiber));
    } catch (error) {
        $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $662d9978aa5168bc$var$requestUpdateLane());
    } finally{
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority, $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $662d9978aa5168bc$var$noop$2() {}
function $662d9978aa5168bc$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(476));
    var queue = $662d9978aa5168bc$var$ensureFormComponentIsStateful(formFiber).queue;
    $662d9978aa5168bc$var$startTransition(formFiber, queue, pendingState, $662d9978aa5168bc$var$sharedNotPendingObject, null === action ? $662d9978aa5168bc$var$noop$2 : function() {
        $662d9978aa5168bc$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $662d9978aa5168bc$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $662d9978aa5168bc$var$sharedNotPendingObject,
        baseState: $662d9978aa5168bc$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $662d9978aa5168bc$var$basicStateReducer,
            lastRenderedState: $662d9978aa5168bc$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $662d9978aa5168bc$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $662d9978aa5168bc$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $662d9978aa5168bc$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $662d9978aa5168bc$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $662d9978aa5168bc$var$requestUpdateLane());
}
function $662d9978aa5168bc$var$useHostTransitionStatus() {
    return $662d9978aa5168bc$var$readContext($662d9978aa5168bc$var$HostTransitionContext);
}
function $662d9978aa5168bc$var$updateId() {
    return $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
}
function $662d9978aa5168bc$var$updateRefresh() {
    return $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
}
function $662d9978aa5168bc$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $662d9978aa5168bc$var$requestUpdateLane();
                fiber = $662d9978aa5168bc$var$createUpdate(lane);
                var root$63 = $662d9978aa5168bc$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(root$63, provider, lane), $662d9978aa5168bc$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $662d9978aa5168bc$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $662d9978aa5168bc$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $662d9978aa5168bc$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $662d9978aa5168bc$var$isRenderPhaseUpdate(fiber) ? $662d9978aa5168bc$var$enqueueRenderPhaseUpdate(queue, action) : (action = $662d9978aa5168bc$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(action, fiber, lane), $662d9978aa5168bc$var$entangleTransitionUpdate(action, queue, lane)));
}
function $662d9978aa5168bc$var$dispatchSetState(fiber, queue, action) {
    var lane = $662d9978aa5168bc$var$requestUpdateLane();
    $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($662d9978aa5168bc$var$isRenderPhaseUpdate(fiber)) $662d9978aa5168bc$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($662d9978aa5168bc$var$objectIs(eagerState, currentState)) return $662d9978aa5168bc$var$enqueueUpdate$1(fiber, queue, update, 0), null === $662d9978aa5168bc$var$workInProgressRoot && $662d9978aa5168bc$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $662d9978aa5168bc$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $662d9978aa5168bc$var$scheduleUpdateOnFiber(action, fiber, lane), $662d9978aa5168bc$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $662d9978aa5168bc$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $662d9978aa5168bc$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($662d9978aa5168bc$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $662d9978aa5168bc$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $662d9978aa5168bc$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $662d9978aa5168bc$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $662d9978aa5168bc$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $662d9978aa5168bc$var$currentlyRenderingFiber$1;
}
function $662d9978aa5168bc$var$enqueueRenderPhaseUpdate(queue, update) {
    $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass = $662d9978aa5168bc$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $662d9978aa5168bc$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $662d9978aa5168bc$var$markRootEntangled(root, lane);
    }
}
var $662d9978aa5168bc$var$ContextOnlyDispatcher = {
    readContext: $662d9978aa5168bc$var$readContext,
    use: $662d9978aa5168bc$var$use,
    useCallback: $662d9978aa5168bc$var$throwInvalidHookError,
    useContext: $662d9978aa5168bc$var$throwInvalidHookError,
    useEffect: $662d9978aa5168bc$var$throwInvalidHookError,
    useImperativeHandle: $662d9978aa5168bc$var$throwInvalidHookError,
    useLayoutEffect: $662d9978aa5168bc$var$throwInvalidHookError,
    useInsertionEffect: $662d9978aa5168bc$var$throwInvalidHookError,
    useMemo: $662d9978aa5168bc$var$throwInvalidHookError,
    useReducer: $662d9978aa5168bc$var$throwInvalidHookError,
    useRef: $662d9978aa5168bc$var$throwInvalidHookError,
    useState: $662d9978aa5168bc$var$throwInvalidHookError,
    useDebugValue: $662d9978aa5168bc$var$throwInvalidHookError,
    useDeferredValue: $662d9978aa5168bc$var$throwInvalidHookError,
    useTransition: $662d9978aa5168bc$var$throwInvalidHookError,
    useSyncExternalStore: $662d9978aa5168bc$var$throwInvalidHookError,
    useId: $662d9978aa5168bc$var$throwInvalidHookError
};
$662d9978aa5168bc$var$ContextOnlyDispatcher.useCacheRefresh = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useMemoCache = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useHostTransitionStatus = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useFormState = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useActionState = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useOptimistic = $662d9978aa5168bc$var$throwInvalidHookError;
var $662d9978aa5168bc$var$HooksDispatcherOnMount = {
    readContext: $662d9978aa5168bc$var$readContext,
    use: $662d9978aa5168bc$var$use,
    useCallback: function(callback, deps) {
        $662d9978aa5168bc$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $662d9978aa5168bc$var$readContext,
    useEffect: $662d9978aa5168bc$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $662d9978aa5168bc$var$mountEffectImpl(4194308, 4, $662d9978aa5168bc$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $662d9978aa5168bc$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $662d9978aa5168bc$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $662d9978aa5168bc$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $662d9978aa5168bc$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $662d9978aa5168bc$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $662d9978aa5168bc$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $662d9978aa5168bc$var$dispatchReducerAction.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $662d9978aa5168bc$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $662d9978aa5168bc$var$dispatchSetState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $662d9978aa5168bc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        return $662d9978aa5168bc$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $662d9978aa5168bc$var$mountStateImpl(!1);
        stateHook = $662d9978aa5168bc$var$startTransition.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $662d9978aa5168bc$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $662d9978aa5168bc$var$currentlyRenderingFiber$1, hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        if ($662d9978aa5168bc$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $662d9978aa5168bc$var$workInProgressRoot) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(349));
            0 !== ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 60) || $662d9978aa5168bc$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $662d9978aa5168bc$var$mountEffect($662d9978aa5168bc$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $662d9978aa5168bc$var$pushEffect(9, $662d9978aa5168bc$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook(), identifierPrefix = $662d9978aa5168bc$var$workInProgressRoot.identifierPrefix;
        if ($662d9978aa5168bc$var$isHydrating) {
            var JSCompiler_inline_result = $662d9978aa5168bc$var$treeContextOverflow;
            var idWithLeadingBit = $662d9978aa5168bc$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $662d9978aa5168bc$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $662d9978aa5168bc$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $662d9978aa5168bc$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $662d9978aa5168bc$var$mountWorkInProgressHook().memoizedState = $662d9978aa5168bc$var$refreshCache.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1);
    }
};
$662d9978aa5168bc$var$HooksDispatcherOnMount.useMemoCache = $662d9978aa5168bc$var$useMemoCache;
$662d9978aa5168bc$var$HooksDispatcherOnMount.useHostTransitionStatus = $662d9978aa5168bc$var$useHostTransitionStatus;
$662d9978aa5168bc$var$HooksDispatcherOnMount.useFormState = $662d9978aa5168bc$var$mountActionState;
$662d9978aa5168bc$var$HooksDispatcherOnMount.useActionState = $662d9978aa5168bc$var$mountActionState;
$662d9978aa5168bc$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $662d9978aa5168bc$var$dispatchOptimisticSetState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $662d9978aa5168bc$var$HooksDispatcherOnUpdate = {
    readContext: $662d9978aa5168bc$var$readContext,
    use: $662d9978aa5168bc$var$use,
    useCallback: $662d9978aa5168bc$var$updateCallback,
    useContext: $662d9978aa5168bc$var$readContext,
    useEffect: $662d9978aa5168bc$var$updateEffect,
    useImperativeHandle: $662d9978aa5168bc$var$updateImperativeHandle,
    useInsertionEffect: $662d9978aa5168bc$var$updateInsertionEffect,
    useLayoutEffect: $662d9978aa5168bc$var$updateLayoutEffect,
    useMemo: $662d9978aa5168bc$var$updateMemo,
    useReducer: $662d9978aa5168bc$var$updateReducer,
    useRef: $662d9978aa5168bc$var$updateRef,
    useState: function() {
        return $662d9978aa5168bc$var$updateReducer($662d9978aa5168bc$var$basicStateReducer);
    },
    useDebugValue: $662d9978aa5168bc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
        return $662d9978aa5168bc$var$updateDeferredValueImpl(hook, $662d9978aa5168bc$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $662d9978aa5168bc$var$updateReducer($662d9978aa5168bc$var$basicStateReducer)[0], start = $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $662d9978aa5168bc$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $662d9978aa5168bc$var$updateSyncExternalStore,
    useId: $662d9978aa5168bc$var$updateId
};
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useCacheRefresh = $662d9978aa5168bc$var$updateRefresh;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useMemoCache = $662d9978aa5168bc$var$useMemoCache;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $662d9978aa5168bc$var$useHostTransitionStatus;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useFormState = $662d9978aa5168bc$var$updateActionState;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useActionState = $662d9978aa5168bc$var$updateActionState;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    return $662d9978aa5168bc$var$updateOptimisticImpl(hook, $662d9978aa5168bc$var$currentHook, passthrough, reducer);
};
var $662d9978aa5168bc$var$HooksDispatcherOnRerender = {
    readContext: $662d9978aa5168bc$var$readContext,
    use: $662d9978aa5168bc$var$use,
    useCallback: $662d9978aa5168bc$var$updateCallback,
    useContext: $662d9978aa5168bc$var$readContext,
    useEffect: $662d9978aa5168bc$var$updateEffect,
    useImperativeHandle: $662d9978aa5168bc$var$updateImperativeHandle,
    useInsertionEffect: $662d9978aa5168bc$var$updateInsertionEffect,
    useLayoutEffect: $662d9978aa5168bc$var$updateLayoutEffect,
    useMemo: $662d9978aa5168bc$var$updateMemo,
    useReducer: $662d9978aa5168bc$var$rerenderReducer,
    useRef: $662d9978aa5168bc$var$updateRef,
    useState: function() {
        return $662d9978aa5168bc$var$rerenderReducer($662d9978aa5168bc$var$basicStateReducer);
    },
    useDebugValue: $662d9978aa5168bc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
        return null === $662d9978aa5168bc$var$currentHook ? $662d9978aa5168bc$var$mountDeferredValueImpl(hook, value, initialValue) : $662d9978aa5168bc$var$updateDeferredValueImpl(hook, $662d9978aa5168bc$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $662d9978aa5168bc$var$rerenderReducer($662d9978aa5168bc$var$basicStateReducer)[0], start = $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $662d9978aa5168bc$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $662d9978aa5168bc$var$updateSyncExternalStore,
    useId: $662d9978aa5168bc$var$updateId
};
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useCacheRefresh = $662d9978aa5168bc$var$updateRefresh;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useMemoCache = $662d9978aa5168bc$var$useMemoCache;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useHostTransitionStatus = $662d9978aa5168bc$var$useHostTransitionStatus;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useFormState = $662d9978aa5168bc$var$rerenderActionState;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useActionState = $662d9978aa5168bc$var$rerenderActionState;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    if (null !== $662d9978aa5168bc$var$currentHook) return $662d9978aa5168bc$var$updateOptimisticImpl(hook, $662d9978aa5168bc$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $662d9978aa5168bc$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $662d9978aa5168bc$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $662d9978aa5168bc$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $662d9978aa5168bc$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $662d9978aa5168bc$var$requestUpdateLane(), update = $662d9978aa5168bc$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $662d9978aa5168bc$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(payload, inst, lane), $662d9978aa5168bc$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $662d9978aa5168bc$var$requestUpdateLane(), update = $662d9978aa5168bc$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $662d9978aa5168bc$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(payload, inst, lane), $662d9978aa5168bc$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $662d9978aa5168bc$var$requestUpdateLane(), update = $662d9978aa5168bc$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $662d9978aa5168bc$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(callback, inst, lane), $662d9978aa5168bc$var$entangleTransitions(callback, inst, lane));
    }
};
function $662d9978aa5168bc$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$662d9978aa5168bc$var$shallowEqual(oldProps, newProps) || !$662d9978aa5168bc$var$shallowEqual(oldState, newState) : !0;
}
function $662d9978aa5168bc$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $662d9978aa5168bc$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $662d9978aa5168bc$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $662d9978aa5168bc$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $662d9978aa5168bc$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $6qd2L && "function" === typeof $6qd2L.emit) {
        $6qd2L.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $662d9978aa5168bc$var$defaultOnUncaughtError(error) {
    $662d9978aa5168bc$var$reportGlobalError(error);
}
function $662d9978aa5168bc$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $662d9978aa5168bc$var$defaultOnRecoverableError(error) {
    $662d9978aa5168bc$var$reportGlobalError(error);
}
function $662d9978aa5168bc$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $662d9978aa5168bc$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $662d9978aa5168bc$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $662d9978aa5168bc$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $662d9978aa5168bc$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $662d9978aa5168bc$var$createClassErrorUpdate(lane) {
    lane = $662d9978aa5168bc$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $662d9978aa5168bc$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $662d9978aa5168bc$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $662d9978aa5168bc$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed ? $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $662d9978aa5168bc$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $662d9978aa5168bc$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $662d9978aa5168bc$var$shellBoundary ? $662d9978aa5168bc$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $662d9978aa5168bc$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $662d9978aa5168bc$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $662d9978aa5168bc$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $662d9978aa5168bc$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $662d9978aa5168bc$var$attachPingListener(root, value, rootRenderLanes);
        $662d9978aa5168bc$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($662d9978aa5168bc$var$isHydrating) return returnFiber = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $662d9978aa5168bc$var$HydrationMismatchException && (root = Error($662d9978aa5168bc$var$formatProdErrorMessage(422), {
        cause: value
    }), $662d9978aa5168bc$var$queueHydrationError($662d9978aa5168bc$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $662d9978aa5168bc$var$HydrationMismatchException && (returnFiber = Error($662d9978aa5168bc$var$formatProdErrorMessage(423), {
        cause: value
    }), $662d9978aa5168bc$var$queueHydrationError($662d9978aa5168bc$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $662d9978aa5168bc$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $662d9978aa5168bc$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $662d9978aa5168bc$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($662d9978aa5168bc$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $662d9978aa5168bc$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $662d9978aa5168bc$var$workInProgressRootConcurrentErrors ? $662d9978aa5168bc$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $662d9978aa5168bc$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $662d9978aa5168bc$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $662d9978aa5168bc$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $662d9978aa5168bc$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed || !$662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $662d9978aa5168bc$var$createClassErrorUpdate(rootRenderLanes), $662d9978aa5168bc$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $662d9978aa5168bc$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $662d9978aa5168bc$var$SelectiveHydrationException = Error($662d9978aa5168bc$var$formatProdErrorMessage(461)), $662d9978aa5168bc$var$didReceiveUpdate = !1;
function $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $662d9978aa5168bc$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $662d9978aa5168bc$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $662d9978aa5168bc$var$prepareToReadContext(workInProgress);
    nextProps = $662d9978aa5168bc$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $662d9978aa5168bc$var$checkDidRenderIdHook();
    if (null !== current && !$662d9978aa5168bc$var$didReceiveUpdate) return $662d9978aa5168bc$var$bailoutHooks(current, workInProgress, renderLanes), $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $662d9978aa5168bc$var$isHydrating && key && $662d9978aa5168bc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $662d9978aa5168bc$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$662d9978aa5168bc$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $662d9978aa5168bc$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $662d9978aa5168bc$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$662d9978aa5168bc$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $662d9978aa5168bc$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $662d9978aa5168bc$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $662d9978aa5168bc$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($662d9978aa5168bc$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($662d9978aa5168bc$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $662d9978aa5168bc$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($662d9978aa5168bc$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $662d9978aa5168bc$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $662d9978aa5168bc$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $662d9978aa5168bc$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $662d9978aa5168bc$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $662d9978aa5168bc$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $662d9978aa5168bc$var$pushHiddenContext(workInProgress, prevState) : $662d9978aa5168bc$var$reuseHiddenContextOnStack(), $662d9978aa5168bc$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $662d9978aa5168bc$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($662d9978aa5168bc$var$pushTransition(workInProgress, prevState.cachePool), $662d9978aa5168bc$var$pushHiddenContext(workInProgress, prevState), $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $662d9978aa5168bc$var$pushTransition(workInProgress, null), $662d9978aa5168bc$var$reuseHiddenContextOnStack(), $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress));
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $662d9978aa5168bc$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $662d9978aa5168bc$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $662d9978aa5168bc$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $662d9978aa5168bc$var$pushTransition(workInProgress, null);
    $662d9978aa5168bc$var$reuseHiddenContextOnStack();
    $662d9978aa5168bc$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $662d9978aa5168bc$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $662d9978aa5168bc$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $662d9978aa5168bc$var$prepareToReadContext(workInProgress);
    Component = $662d9978aa5168bc$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $662d9978aa5168bc$var$checkDidRenderIdHook();
    if (null !== current && !$662d9978aa5168bc$var$didReceiveUpdate) return $662d9978aa5168bc$var$bailoutHooks(current, workInProgress, renderLanes), $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $662d9978aa5168bc$var$isHydrating && nextProps && $662d9978aa5168bc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $662d9978aa5168bc$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $662d9978aa5168bc$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $662d9978aa5168bc$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $662d9978aa5168bc$var$finishRenderingHooks(current);
    Component = $662d9978aa5168bc$var$checkDidRenderIdHook();
    if (null !== current && !$662d9978aa5168bc$var$didReceiveUpdate) return $662d9978aa5168bc$var$bailoutHooks(current, workInProgress, renderLanes), $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $662d9978aa5168bc$var$isHydrating && Component && $662d9978aa5168bc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $662d9978aa5168bc$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $662d9978aa5168bc$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $662d9978aa5168bc$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $662d9978aa5168bc$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $662d9978aa5168bc$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $662d9978aa5168bc$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $662d9978aa5168bc$var$readContext(contextType) : $662d9978aa5168bc$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($662d9978aa5168bc$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $662d9978aa5168bc$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $662d9978aa5168bc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $662d9978aa5168bc$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $662d9978aa5168bc$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $662d9978aa5168bc$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $662d9978aa5168bc$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $662d9978aa5168bc$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $662d9978aa5168bc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $662d9978aa5168bc$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($662d9978aa5168bc$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $662d9978aa5168bc$var$hasForceUpdate || $662d9978aa5168bc$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $662d9978aa5168bc$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $662d9978aa5168bc$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $662d9978aa5168bc$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $662d9978aa5168bc$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $662d9978aa5168bc$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $662d9978aa5168bc$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $662d9978aa5168bc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $662d9978aa5168bc$var$hasForceUpdate || null !== current && null !== current.dependencies && $662d9978aa5168bc$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($662d9978aa5168bc$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $662d9978aa5168bc$var$hasForceUpdate || $662d9978aa5168bc$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $662d9978aa5168bc$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $662d9978aa5168bc$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $662d9978aa5168bc$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $662d9978aa5168bc$var$resetHydrationState();
    workInProgress.flags |= 256;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $662d9978aa5168bc$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $662d9978aa5168bc$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $662d9978aa5168bc$var$getSuspendedCache()
    };
}
function $662d9978aa5168bc$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $662d9978aa5168bc$var$workInProgressDeferredLane);
    return current;
}
function $662d9978aa5168bc$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($662d9978aa5168bc$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($662d9978aa5168bc$var$isHydrating) {
            showFallback ? $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($662d9978aa5168bc$var$isHydrating) {
                var nextInstance = $662d9978aa5168bc$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $662d9978aa5168bc$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $662d9978aa5168bc$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $662d9978aa5168bc$var$treeContextProvider ? {
                            id: $662d9978aa5168bc$var$treeContextId,
                            overflow: $662d9978aa5168bc$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $662d9978aa5168bc$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $662d9978aa5168bc$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $662d9978aa5168bc$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $662d9978aa5168bc$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $662d9978aa5168bc$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $662d9978aa5168bc$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $662d9978aa5168bc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $662d9978aa5168bc$var$SUSPENDED_MARKER, nextProps;
        $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $662d9978aa5168bc$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $662d9978aa5168bc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $662d9978aa5168bc$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $662d9978aa5168bc$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $662d9978aa5168bc$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $662d9978aa5168bc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $662d9978aa5168bc$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($662d9978aa5168bc$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $662d9978aa5168bc$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $662d9978aa5168bc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($662d9978aa5168bc$var$didReceiveUpdate || $662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $662d9978aa5168bc$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $662d9978aa5168bc$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(current, nextProps), $662d9978aa5168bc$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $662d9978aa5168bc$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $662d9978aa5168bc$var$renderDidSuspendDelayIfPossible();
            workInProgress = $662d9978aa5168bc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $662d9978aa5168bc$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(nextInstance.nextSibling), $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$isHydrating = !0, $662d9978aa5168bc$var$hydrationErrors = null, $662d9978aa5168bc$var$rootOrSingletonContext = !1, null !== current && ($662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextId, $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextOverflow, $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextProvider, $662d9978aa5168bc$var$treeContextId = current.id, $662d9978aa5168bc$var$treeContextOverflow = current.overflow, $662d9978aa5168bc$var$treeContextProvider = workInProgress), workInProgress = $662d9978aa5168bc$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $662d9978aa5168bc$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $662d9978aa5168bc$var$createWorkInProgress(digest, showFallback) : (showFallback = $662d9978aa5168bc$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $662d9978aa5168bc$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $662d9978aa5168bc$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $662d9978aa5168bc$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $662d9978aa5168bc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $662d9978aa5168bc$var$SUSPENDED_MARKER, nextProps;
    $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $662d9978aa5168bc$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $662d9978aa5168bc$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $662d9978aa5168bc$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $662d9978aa5168bc$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $662d9978aa5168bc$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $662d9978aa5168bc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $662d9978aa5168bc$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $662d9978aa5168bc$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $662d9978aa5168bc$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $662d9978aa5168bc$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $662d9978aa5168bc$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $662d9978aa5168bc$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $662d9978aa5168bc$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $662d9978aa5168bc$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $662d9978aa5168bc$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $662d9978aa5168bc$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $662d9978aa5168bc$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $662d9978aa5168bc$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $662d9978aa5168bc$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $662d9978aa5168bc$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $662d9978aa5168bc$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $662d9978aa5168bc$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $662d9978aa5168bc$var$checkIfContextChanged(current) ? !0 : !1;
}
function $662d9978aa5168bc$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $662d9978aa5168bc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, current.memoizedState.cache);
            $662d9978aa5168bc$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $662d9978aa5168bc$var$pushHostContext(workInProgress);
            break;
        case 4:
            $662d9978aa5168bc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $662d9978aa5168bc$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $662d9978aa5168bc$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $662d9978aa5168bc$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $662d9978aa5168bc$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, current.memoizedState.cache);
    }
    return $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $662d9978aa5168bc$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $662d9978aa5168bc$var$didReceiveUpdate = !0;
        else {
            if (!$662d9978aa5168bc$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $662d9978aa5168bc$var$didReceiveUpdate = !1, $662d9978aa5168bc$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $662d9978aa5168bc$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $662d9978aa5168bc$var$didReceiveUpdate = !1, $662d9978aa5168bc$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $662d9978aa5168bc$var$pushTreeId(workInProgress, $662d9978aa5168bc$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $662d9978aa5168bc$var$shouldConstruct(lazyComponent) ? (current = $662d9978aa5168bc$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $662d9978aa5168bc$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $662d9978aa5168bc$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $662d9978aa5168bc$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $662d9978aa5168bc$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $662d9978aa5168bc$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $662d9978aa5168bc$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $662d9978aa5168bc$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $662d9978aa5168bc$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $662d9978aa5168bc$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $662d9978aa5168bc$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $662d9978aa5168bc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $662d9978aa5168bc$var$cloneUpdateQueue(current, workInProgress);
                $662d9978aa5168bc$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, nextProps);
                nextProps !== init.cache && $662d9978aa5168bc$var$propagateContextChanges(workInProgress, [
                    $662d9978aa5168bc$var$CacheContext
                ], renderLanes, !0);
                $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $662d9978aa5168bc$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $662d9978aa5168bc$var$createCapturedValueAtFiber(Error($662d9978aa5168bc$var$formatProdErrorMessage(424)), workInProgress);
                        $662d9978aa5168bc$var$queueHydrationError(lazyComponent);
                        workInProgress = $662d9978aa5168bc$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$isHydrating = !0, $662d9978aa5168bc$var$hydrationErrors = null, $662d9978aa5168bc$var$rootOrSingletonContext = !0, renderLanes = $662d9978aa5168bc$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $662d9978aa5168bc$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $662d9978aa5168bc$var$markRef(current, workInProgress), null === current ? (renderLanes = $662d9978aa5168bc$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $662d9978aa5168bc$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer($662d9978aa5168bc$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress, lazyComponent[$662d9978aa5168bc$var$internalPropsKey] = current, $662d9978aa5168bc$var$setInitialProperties(lazyComponent, renderLanes, current), $662d9978aa5168bc$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $662d9978aa5168bc$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $662d9978aa5168bc$var$pushHostContext(workInProgress), null === current && $662d9978aa5168bc$var$isHydrating && (lazyComponent = workInProgress.stateNode = $662d9978aa5168bc$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $662d9978aa5168bc$var$rootInstanceStackCursor.current), $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$rootOrSingletonContext = !0, $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $662d9978aa5168bc$var$isHydrating ? $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $662d9978aa5168bc$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $662d9978aa5168bc$var$isHydrating) {
                if (init = lazyComponent = $662d9978aa5168bc$var$nextHydratableInstance) lazyComponent = $662d9978aa5168bc$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $662d9978aa5168bc$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(lazyComponent.firstChild), $662d9978aa5168bc$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $662d9978aa5168bc$var$throwOnHydrationMismatch(workInProgress);
            }
            $662d9978aa5168bc$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $662d9978aa5168bc$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $662d9978aa5168bc$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $662d9978aa5168bc$var$renderWithHooks(current, workInProgress, $662d9978aa5168bc$var$TransitionAwareHostComponent, null, null, renderLanes), $662d9978aa5168bc$var$HostTransitionContext._currentValue = init);
            $662d9978aa5168bc$var$markRef(current, workInProgress);
            $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $662d9978aa5168bc$var$isHydrating) {
                if (current = renderLanes = $662d9978aa5168bc$var$nextHydratableInstance) renderLanes = $662d9978aa5168bc$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $662d9978aa5168bc$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $662d9978aa5168bc$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $662d9978aa5168bc$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $662d9978aa5168bc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $662d9978aa5168bc$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $662d9978aa5168bc$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $662d9978aa5168bc$var$prepareToReadContext(workInProgress), init = $662d9978aa5168bc$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $662d9978aa5168bc$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $662d9978aa5168bc$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $662d9978aa5168bc$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $662d9978aa5168bc$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $662d9978aa5168bc$var$prepareToReadContext(workInProgress), lazyComponent = $662d9978aa5168bc$var$readContext($662d9978aa5168bc$var$CacheContext), null === current ? (init = $662d9978aa5168bc$var$peekCacheFromPool(), null === init && (init = $662d9978aa5168bc$var$workInProgressRoot, nextProps = $662d9978aa5168bc$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $662d9978aa5168bc$var$initializeUpdateQueue(workInProgress), $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($662d9978aa5168bc$var$cloneUpdateQueue(current, workInProgress), $662d9978aa5168bc$var$processUpdateQueue(workInProgress, null, null, renderLanes), $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $662d9978aa5168bc$var$propagateContextChanges(workInProgress, [
                $662d9978aa5168bc$var$CacheContext
            ], renderLanes, !0))), $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $662d9978aa5168bc$var$valueCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$currentlyRenderingFiber = null, $662d9978aa5168bc$var$lastContextDependency = null;
function $662d9978aa5168bc$var$pushProvider(providerFiber, context, nextValue) {
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $662d9978aa5168bc$var$popProvider(context) {
    context._currentValue = $662d9978aa5168bc$var$valueCursor.current;
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$valueCursor);
}
function $662d9978aa5168bc$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $662d9978aa5168bc$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $662d9978aa5168bc$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $662d9978aa5168bc$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $662d9978aa5168bc$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $662d9978aa5168bc$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($662d9978aa5168bc$var$HostTransitionContext) : current = [
                $662d9978aa5168bc$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $662d9978aa5168bc$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $662d9978aa5168bc$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$662d9978aa5168bc$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $662d9978aa5168bc$var$prepareToReadContext(workInProgress) {
    $662d9978aa5168bc$var$currentlyRenderingFiber = workInProgress;
    $662d9978aa5168bc$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $662d9978aa5168bc$var$readContext(context) {
    return $662d9978aa5168bc$var$readContextForConsumer($662d9978aa5168bc$var$currentlyRenderingFiber, context);
}
function $662d9978aa5168bc$var$readContextDuringReconciliation(consumer, context) {
    null === $662d9978aa5168bc$var$currentlyRenderingFiber && $662d9978aa5168bc$var$prepareToReadContext(consumer);
    return $662d9978aa5168bc$var$readContextForConsumer(consumer, context);
}
function $662d9978aa5168bc$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $662d9978aa5168bc$var$lastContextDependency) {
        if (null === consumer) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(308));
        $662d9978aa5168bc$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$lastContextDependency.next = context;
    return value;
}
var $662d9978aa5168bc$var$hasForceUpdate = !1;
function $662d9978aa5168bc$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $662d9978aa5168bc$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $662d9978aa5168bc$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $662d9978aa5168bc$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($662d9978aa5168bc$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $662d9978aa5168bc$var$getRootForUpdatedFiber(fiber);
        $662d9978aa5168bc$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $662d9978aa5168bc$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $662d9978aa5168bc$var$getRootForUpdatedFiber(fiber);
}
function $662d9978aa5168bc$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $662d9978aa5168bc$var$markRootEntangled(root, lane);
    }
}
function $662d9978aa5168bc$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $662d9978aa5168bc$var$didReadFromEntangledAsyncAction = !1;
function $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($662d9978aa5168bc$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $662d9978aa5168bc$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $662d9978aa5168bc$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $662d9978aa5168bc$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $662d9978aa5168bc$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($662d9978aa5168bc$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $662d9978aa5168bc$var$currentEntangledLane && ($662d9978aa5168bc$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $662d9978aa5168bc$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $662d9978aa5168bc$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $662d9978aa5168bc$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $662d9978aa5168bc$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$662d9978aa5168bc$var$callCallback(callbacks[updateQueue], context);
}
function $662d9978aa5168bc$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $662d9978aa5168bc$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $662d9978aa5168bc$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $662d9978aa5168bc$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $662d9978aa5168bc$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $662d9978aa5168bc$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $662d9978aa5168bc$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $662d9978aa5168bc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $662d9978aa5168bc$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $662d9978aa5168bc$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $662d9978aa5168bc$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$662d9978aa5168bc$var$internalPropsKey] = newProps;
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $662d9978aa5168bc$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $662d9978aa5168bc$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $662d9978aa5168bc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $662d9978aa5168bc$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($662d9978aa5168bc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$662d9978aa5168bc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $662d9978aa5168bc$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($662d9978aa5168bc$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$662d9978aa5168bc$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $662d9978aa5168bc$var$offscreenSubtreeIsHidden = !1, $662d9978aa5168bc$var$offscreenSubtreeWasHidden = !1, $662d9978aa5168bc$var$needsFormReset = !1, $662d9978aa5168bc$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $662d9978aa5168bc$var$nextEffect = null, $662d9978aa5168bc$var$shouldFireAfterActiveInstanceBlur = !1;
function $662d9978aa5168bc$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $662d9978aa5168bc$var$eventsEnabled = $662d9978aa5168bc$var$_enabled;
    root = $662d9978aa5168bc$var$getActiveElementDeep(root);
    if ($662d9978aa5168bc$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $662d9978aa5168bc$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $662d9978aa5168bc$var$_enabled = !1;
    for($662d9978aa5168bc$var$nextEffect = firstChild; null !== $662d9978aa5168bc$var$nextEffect;)if (firstChild = $662d9978aa5168bc$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $662d9978aa5168bc$var$nextEffect = root;
    else for(; null !== $662d9978aa5168bc$var$nextEffect;){
        firstChild = $662d9978aa5168bc$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $662d9978aa5168bc$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $662d9978aa5168bc$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $662d9978aa5168bc$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $662d9978aa5168bc$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $662d9978aa5168bc$var$nextEffect = root;
            break;
        }
        $662d9978aa5168bc$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $662d9978aa5168bc$var$shouldFireAfterActiveInstanceBlur;
    $662d9978aa5168bc$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $662d9978aa5168bc$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $662d9978aa5168bc$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $662d9978aa5168bc$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $662d9978aa5168bc$var$commitClassCallbacks(finishedWork);
            flags & 512 && $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $662d9978aa5168bc$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $662d9978aa5168bc$var$commitHostMount(finishedWork);
            flags & 512 && $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $662d9978aa5168bc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $662d9978aa5168bc$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $662d9978aa5168bc$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $662d9978aa5168bc$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $662d9978aa5168bc$var$offscreenSubtreeWasHidden;
                $662d9978aa5168bc$var$offscreenSubtreeIsHidden = prevProps;
                ($662d9978aa5168bc$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $662d9978aa5168bc$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $662d9978aa5168bc$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return) : $662d9978aa5168bc$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $662d9978aa5168bc$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $662d9978aa5168bc$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $662d9978aa5168bc$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $662d9978aa5168bc$var$hostParent = null, $662d9978aa5168bc$var$hostParentIsContainer = !1;
function $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$662d9978aa5168bc$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $662d9978aa5168bc$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($662d9978aa5168bc$var$injectedHook && "function" === typeof $662d9978aa5168bc$var$injectedHook.onCommitFiberUnmount) try {
        $662d9978aa5168bc$var$injectedHook.onCommitFiberUnmount($662d9978aa5168bc$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $662d9978aa5168bc$var$hostParent, prevHostParentIsContainer = $662d9978aa5168bc$var$hostParentIsContainer;
            $662d9978aa5168bc$var$hostParent = deletedFiber.stateNode;
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $662d9978aa5168bc$var$detachDeletedInstance(deletedFiber);
            $662d9978aa5168bc$var$hostParent = prevHostParent;
            $662d9978aa5168bc$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $662d9978aa5168bc$var$hostParent;
            var prevHostParentIsContainer$119 = $662d9978aa5168bc$var$hostParentIsContainer;
            $662d9978aa5168bc$var$hostParent = null;
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $662d9978aa5168bc$var$hostParent = prevHostParentIsContainer;
            $662d9978aa5168bc$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $662d9978aa5168bc$var$hostParent) {
                if ($662d9978aa5168bc$var$hostParentIsContainer) try {
                    finishedRoot = $662d9978aa5168bc$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $662d9978aa5168bc$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $662d9978aa5168bc$var$hostParent && ($662d9978aa5168bc$var$hostParentIsContainer ? (nearestMountedAncestor = $662d9978aa5168bc$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $662d9978aa5168bc$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $662d9978aa5168bc$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $662d9978aa5168bc$var$retryIfBlockedOn(nearestMountedAncestor)) : $662d9978aa5168bc$var$clearSuspenseBoundary($662d9978aa5168bc$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $662d9978aa5168bc$var$hostParent;
            prevHostParentIsContainer = $662d9978aa5168bc$var$hostParentIsContainer;
            $662d9978aa5168bc$var$hostParent = deletedFiber.stateNode.containerInfo;
            $662d9978aa5168bc$var$hostParentIsContainer = !0;
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $662d9978aa5168bc$var$hostParent = prevHostParent;
            $662d9978aa5168bc$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || ($662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $662d9978aa5168bc$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden = (prevHostParent = $662d9978aa5168bc$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $662d9978aa5168bc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $662d9978aa5168bc$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $662d9978aa5168bc$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $662d9978aa5168bc$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $662d9978aa5168bc$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $662d9978aa5168bc$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $662d9978aa5168bc$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $662d9978aa5168bc$var$hostParent = parent.stateNode;
                    $662d9978aa5168bc$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $662d9978aa5168bc$var$hostParent = parent.stateNode.containerInfo;
                    $662d9978aa5168bc$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $662d9978aa5168bc$var$hostParent = parent.stateNode.containerInfo;
                    $662d9978aa5168bc$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $662d9978aa5168bc$var$hostParent) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(160));
        $662d9978aa5168bc$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $662d9978aa5168bc$var$hostParent = null;
        $662d9978aa5168bc$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $662d9978aa5168bc$var$currentHoistableRoot = null;
function $662d9978aa5168bc$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($662d9978aa5168bc$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $662d9978aa5168bc$var$commitHookEffectListMount(3, finishedWork), $662d9978aa5168bc$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($662d9978aa5168bc$var$offscreenSubtreeWasHidden || null === current || $662d9978aa5168bc$var$safelyDetachRef(current, current.return));
            flags & 64 && $662d9978aa5168bc$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $662d9978aa5168bc$var$currentHoistableRoot;
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($662d9978aa5168bc$var$offscreenSubtreeWasHidden || null === current || $662d9978aa5168bc$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$662d9978aa5168bc$var$internalHoistableMarker] || currentResource[$662d9978aa5168bc$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $662d9978aa5168bc$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$662d9978aa5168bc$var$internalInstanceKey] = finishedWork;
                                        $662d9978aa5168bc$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $662d9978aa5168bc$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $662d9978aa5168bc$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $662d9978aa5168bc$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $662d9978aa5168bc$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$662d9978aa5168bc$var$internalInstanceKey] = finishedWork;
                                $662d9978aa5168bc$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $662d9978aa5168bc$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $662d9978aa5168bc$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $662d9978aa5168bc$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $662d9978aa5168bc$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $662d9978aa5168bc$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$662d9978aa5168bc$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $662d9978aa5168bc$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$662d9978aa5168bc$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$662d9978aa5168bc$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($662d9978aa5168bc$var$offscreenSubtreeWasHidden || null === current || $662d9978aa5168bc$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $662d9978aa5168bc$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $662d9978aa5168bc$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($662d9978aa5168bc$var$needsFormReset = !0);
            break;
        case 6:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $662d9978aa5168bc$var$tagCaches = null;
            hoistableRoot = $662d9978aa5168bc$var$currentHoistableRoot;
            $662d9978aa5168bc$var$currentHoistableRoot = $662d9978aa5168bc$var$getHoistableRoot(root.containerInfo);
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$currentHoistableRoot = hoistableRoot;
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $662d9978aa5168bc$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $662d9978aa5168bc$var$needsFormReset && ($662d9978aa5168bc$var$needsFormReset = !1, $662d9978aa5168bc$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $662d9978aa5168bc$var$currentHoistableRoot;
            $662d9978aa5168bc$var$currentHoistableRoot = $662d9978aa5168bc$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            $662d9978aa5168bc$var$currentHoistableRoot = flags;
            break;
        case 12:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($662d9978aa5168bc$var$globalMostRecentFallbackTime = $662d9978aa5168bc$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $662d9978aa5168bc$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($662d9978aa5168bc$var$offscreenSubtreeWasHidden || null === current || $662d9978aa5168bc$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $662d9978aa5168bc$var$offscreenSubtreeIsHidden;
            type = $662d9978aa5168bc$var$offscreenSubtreeWasHidden;
            $662d9978aa5168bc$var$offscreenSubtreeIsHidden = nodeName || node;
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden = type || nextNode;
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden = type;
            $662d9978aa5168bc$var$offscreenSubtreeIsHidden = nodeName;
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $662d9978aa5168bc$var$offscreenSubtreeIsHidden || $662d9978aa5168bc$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $662d9978aa5168bc$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $662d9978aa5168bc$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $662d9978aa5168bc$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $662d9978aa5168bc$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork), $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
    }
}
function $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($662d9978aa5168bc$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $662d9978aa5168bc$var$getHostSibling(finishedWork);
                        $662d9978aa5168bc$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($662d9978aa5168bc$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $662d9978aa5168bc$var$getHostSibling(finishedWork);
                        $662d9978aa5168bc$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $662d9978aa5168bc$var$getHostSibling(finishedWork);
                        $662d9978aa5168bc$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $662d9978aa5168bc$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $662d9978aa5168bc$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $662d9978aa5168bc$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $662d9978aa5168bc$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $662d9978aa5168bc$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $662d9978aa5168bc$var$safelyDetachRef(finishedWork, finishedWork.return);
                $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $662d9978aa5168bc$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $662d9978aa5168bc$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$662d9978aa5168bc$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $662d9978aa5168bc$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $662d9978aa5168bc$var$commitClassCallbacks(finishedWork);
                $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $662d9978aa5168bc$var$commitHostMount(finishedWork);
                $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $662d9978aa5168bc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $662d9978aa5168bc$var$releaseCache(previousCache));
}
function $662d9978aa5168bc$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $662d9978aa5168bc$var$releaseCache(current));
}
function $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $662d9978aa5168bc$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $662d9978aa5168bc$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $662d9978aa5168bc$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $662d9978aa5168bc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $662d9978aa5168bc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $662d9978aa5168bc$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $662d9978aa5168bc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $662d9978aa5168bc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $662d9978aa5168bc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $662d9978aa5168bc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $662d9978aa5168bc$var$suspenseyCommitFlag = 8192;
function $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $662d9978aa5168bc$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $662d9978aa5168bc$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $662d9978aa5168bc$var$suspenseyCommitFlag && null !== fiber.memoizedState && $662d9978aa5168bc$var$suspendResource($662d9978aa5168bc$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $662d9978aa5168bc$var$currentHoistableRoot;
            $662d9978aa5168bc$var$currentHoistableRoot = $662d9978aa5168bc$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $662d9978aa5168bc$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $662d9978aa5168bc$var$suspenseyCommitFlag, $662d9978aa5168bc$var$suspenseyCommitFlag = 16777216, $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber), $662d9978aa5168bc$var$suspenseyCommitFlag = previousHoistableRoot) : $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $662d9978aa5168bc$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $662d9978aa5168bc$var$nextEffect = childToDelete;
            $662d9978aa5168bc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $662d9978aa5168bc$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $662d9978aa5168bc$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $662d9978aa5168bc$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $662d9978aa5168bc$var$nextEffect = childToDelete;
            $662d9978aa5168bc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $662d9978aa5168bc$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $662d9978aa5168bc$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $662d9978aa5168bc$var$nextEffect;){
        var fiber = $662d9978aa5168bc$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $662d9978aa5168bc$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $662d9978aa5168bc$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $662d9978aa5168bc$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $662d9978aa5168bc$var$nextEffect;){
            cache = $662d9978aa5168bc$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $662d9978aa5168bc$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $662d9978aa5168bc$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $662d9978aa5168bc$var$nextEffect = sibling;
                break a;
            }
            $662d9978aa5168bc$var$nextEffect = returnFiber;
        }
    }
}
function $662d9978aa5168bc$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $662d9978aa5168bc$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $662d9978aa5168bc$var$FiberNode(tag, pendingProps, key, mode);
}
function $662d9978aa5168bc$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $662d9978aa5168bc$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $662d9978aa5168bc$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $662d9978aa5168bc$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $662d9978aa5168bc$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $662d9978aa5168bc$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $662d9978aa5168bc$var$isHostHoistableType(type, pendingProps, $662d9978aa5168bc$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE:
            return $662d9978aa5168bc$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $662d9978aa5168bc$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $662d9978aa5168bc$var$REACT_PROFILER_TYPE:
            return type = $662d9978aa5168bc$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $662d9978aa5168bc$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $662d9978aa5168bc$var$REACT_SUSPENSE_TYPE:
            return type = $662d9978aa5168bc$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $662d9978aa5168bc$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $662d9978aa5168bc$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $662d9978aa5168bc$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $662d9978aa5168bc$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $662d9978aa5168bc$var$REACT_OFFSCREEN_TYPE:
            return $662d9978aa5168bc$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $662d9978aa5168bc$var$REACT_PROVIDER_TYPE:
                case $662d9978aa5168bc$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $662d9978aa5168bc$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $662d9978aa5168bc$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $662d9978aa5168bc$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($662d9978aa5168bc$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $662d9978aa5168bc$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $662d9978aa5168bc$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $662d9978aa5168bc$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $662d9978aa5168bc$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $662d9978aa5168bc$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $662d9978aa5168bc$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $662d9978aa5168bc$var$createFiberFromText(content, mode, lanes) {
    content = $662d9978aa5168bc$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $662d9978aa5168bc$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $662d9978aa5168bc$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $662d9978aa5168bc$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $662d9978aa5168bc$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$662d9978aa5168bc$var$preloadResource(resource)) {
        resource = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($662d9978aa5168bc$var$workInProgressRootRenderLanes & 4194176) === $662d9978aa5168bc$var$workInProgressRootRenderLanes ? null !== $662d9978aa5168bc$var$shellBoundary : ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 62914560) !== $662d9978aa5168bc$var$workInProgressRootRenderLanes && 0 === ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 536870912) || resource !== $662d9978aa5168bc$var$shellBoundary)) throw $662d9978aa5168bc$var$suspendedThenable = $662d9978aa5168bc$var$noopSuspenseyCommitThenable, $662d9978aa5168bc$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $662d9978aa5168bc$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $662d9978aa5168bc$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$662d9978aa5168bc$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $662d9978aa5168bc$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $662d9978aa5168bc$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $662d9978aa5168bc$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 1:
            return $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext);
            $662d9978aa5168bc$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $662d9978aa5168bc$var$popHydrationState(workInProgress) ? $662d9978aa5168bc$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $662d9978aa5168bc$var$hydrationErrors && ($662d9978aa5168bc$var$queueRecoverableErrors($662d9978aa5168bc$var$hydrationErrors), $662d9978aa5168bc$var$hydrationErrors = null));
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($662d9978aa5168bc$var$markUpdate(workInProgress), null !== renderLanes ? ($662d9978aa5168bc$var$bubbleProperties(workInProgress), $662d9978aa5168bc$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($662d9978aa5168bc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($662d9978aa5168bc$var$markUpdate(workInProgress), $662d9978aa5168bc$var$bubbleProperties(workInProgress), $662d9978aa5168bc$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($662d9978aa5168bc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $662d9978aa5168bc$var$markUpdate(workInProgress), $662d9978aa5168bc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $662d9978aa5168bc$var$popHostContext(workInProgress);
            renderLanes = $662d9978aa5168bc$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $662d9978aa5168bc$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(166));
                    $662d9978aa5168bc$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $662d9978aa5168bc$var$contextStackCursor.current;
                $662d9978aa5168bc$var$popHydrationState(workInProgress) ? $662d9978aa5168bc$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $662d9978aa5168bc$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $662d9978aa5168bc$var$markUpdate(workInProgress));
            }
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $662d9978aa5168bc$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $662d9978aa5168bc$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(166));
                    $662d9978aa5168bc$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $662d9978aa5168bc$var$contextStackCursor.current;
                if ($662d9978aa5168bc$var$popHydrationState(workInProgress)) $662d9978aa5168bc$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer($662d9978aa5168bc$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress;
                    current[$662d9978aa5168bc$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($662d9978aa5168bc$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $662d9978aa5168bc$var$markUpdate(workInProgress);
                }
            }
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $662d9978aa5168bc$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(166));
                current = $662d9978aa5168bc$var$rootInstanceStackCursor.current;
                if ($662d9978aa5168bc$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $662d9978aa5168bc$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $662d9978aa5168bc$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $662d9978aa5168bc$var$throwOnHydrationMismatch(workInProgress);
                } else current = $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $662d9978aa5168bc$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(317));
                        type[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress;
                    } else $662d9978aa5168bc$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $662d9978aa5168bc$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $662d9978aa5168bc$var$hydrationErrors && ($662d9978aa5168bc$var$queueRecoverableErrors($662d9978aa5168bc$var$hydrationErrors), $662d9978aa5168bc$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $662d9978aa5168bc$var$popSuspenseHandler(workInProgress), workInProgress;
                    $662d9978aa5168bc$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $662d9978aa5168bc$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $662d9978aa5168bc$var$popHostContainer(), null === current && $662d9978aa5168bc$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 10:
            return $662d9978aa5168bc$var$popProvider(workInProgress.type), $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 19:
            $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $662d9978aa5168bc$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $662d9978aa5168bc$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$662d9978aa5168bc$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $662d9978aa5168bc$var$now() > $662d9978aa5168bc$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $662d9978aa5168bc$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, current), $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$662d9978aa5168bc$var$isHydrating) return $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
                    } else 2 * $662d9978aa5168bc$var$now() - type.renderingStartTime > $662d9978aa5168bc$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $662d9978aa5168bc$var$now(), workInProgress.sibling = null, current = $662d9978aa5168bc$var$suspenseStackCursor.current, $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $662d9978aa5168bc$var$popSuspenseHandler(workInProgress), $662d9978aa5168bc$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($662d9978aa5168bc$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $662d9978aa5168bc$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext), $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $662d9978aa5168bc$var$unwindWork(current, workInProgress) {
    $662d9978aa5168bc$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext), $662d9978aa5168bc$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $662d9978aa5168bc$var$popHostContext(workInProgress), null;
        case 13:
            $662d9978aa5168bc$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(340));
                $662d9978aa5168bc$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseStackCursor), null;
        case 4:
            return $662d9978aa5168bc$var$popHostContainer(), null;
        case 10:
            return $662d9978aa5168bc$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $662d9978aa5168bc$var$popSuspenseHandler(workInProgress), $662d9978aa5168bc$var$popHiddenContext(), null !== current && $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $662d9978aa5168bc$var$unwindInterruptedWork(current, interruptedWork) {
    $662d9978aa5168bc$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext);
            $662d9978aa5168bc$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $662d9978aa5168bc$var$popHostContext(interruptedWork);
            break;
        case 4:
            $662d9978aa5168bc$var$popHostContainer();
            break;
        case 13:
            $662d9978aa5168bc$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseStackCursor);
            break;
        case 10:
            $662d9978aa5168bc$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $662d9978aa5168bc$var$popSuspenseHandler(interruptedWork);
            $662d9978aa5168bc$var$popHiddenContext();
            null !== current && $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$resumedCache);
            break;
        case 24:
            $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext);
    }
}
var $662d9978aa5168bc$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $662d9978aa5168bc$var$readContext($662d9978aa5168bc$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $662d9978aa5168bc$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $662d9978aa5168bc$var$executionContext = 0, $662d9978aa5168bc$var$workInProgressRoot = null, $662d9978aa5168bc$var$workInProgress = null, $662d9978aa5168bc$var$workInProgressRootRenderLanes = 0, $662d9978aa5168bc$var$workInProgressSuspendedReason = 0, $662d9978aa5168bc$var$workInProgressThrownValue = null, $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings = !1, $662d9978aa5168bc$var$workInProgressRootIsPrerendering = !1, $662d9978aa5168bc$var$workInProgressRootDidAttachPingListener = !1, $662d9978aa5168bc$var$entangledRenderLanes = 0, $662d9978aa5168bc$var$workInProgressRootExitStatus = 0, $662d9978aa5168bc$var$workInProgressRootSkippedLanes = 0, $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes = 0, $662d9978aa5168bc$var$workInProgressRootPingedLanes = 0, $662d9978aa5168bc$var$workInProgressDeferredLane = 0, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes = 0, $662d9978aa5168bc$var$workInProgressRootConcurrentErrors = null, $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = null, $662d9978aa5168bc$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $662d9978aa5168bc$var$globalMostRecentFallbackTime = 0, $662d9978aa5168bc$var$workInProgressRootRenderTargetTime = Infinity, $662d9978aa5168bc$var$workInProgressTransitions = null, $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed = null, $662d9978aa5168bc$var$rootDoesHavePassiveEffects = !1, $662d9978aa5168bc$var$rootWithPendingPassiveEffects = null, $662d9978aa5168bc$var$pendingPassiveEffectsLanes = 0, $662d9978aa5168bc$var$pendingPassiveEffectsRemainingLanes = 0, $662d9978aa5168bc$var$pendingPassiveTransitions = null, $662d9978aa5168bc$var$nestedUpdateCount = 0, $662d9978aa5168bc$var$rootWithNestedUpdates = null;
function $662d9978aa5168bc$var$requestUpdateLane() {
    if (0 !== ($662d9978aa5168bc$var$executionContext & 2) && 0 !== $662d9978aa5168bc$var$workInProgressRootRenderLanes) return $662d9978aa5168bc$var$workInProgressRootRenderLanes & -$662d9978aa5168bc$var$workInProgressRootRenderLanes;
    if (null !== $662d9978aa5168bc$var$ReactSharedInternals.T) {
        var actionScopeLane = $662d9978aa5168bc$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $662d9978aa5168bc$var$requestTransitionLane();
    }
    return $662d9978aa5168bc$var$resolveUpdatePriority();
}
function $662d9978aa5168bc$var$requestDeferredLane() {
    0 === $662d9978aa5168bc$var$workInProgressDeferredLane && ($662d9978aa5168bc$var$workInProgressDeferredLane = 0 === ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 536870912) || $662d9978aa5168bc$var$isHydrating ? $662d9978aa5168bc$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $662d9978aa5168bc$var$workInProgressDeferredLane;
}
function $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $662d9978aa5168bc$var$workInProgressRoot && 2 === $662d9978aa5168bc$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $662d9978aa5168bc$var$prepareFreshStack(root, 0), $662d9978aa5168bc$var$markRootSuspended(root, $662d9978aa5168bc$var$workInProgressRootRenderLanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !1);
    $662d9978aa5168bc$var$markRootUpdated$1(root, lane);
    if (0 === ($662d9978aa5168bc$var$executionContext & 2) || root !== $662d9978aa5168bc$var$workInProgressRoot) root === $662d9978aa5168bc$var$workInProgressRoot && (0 === ($662d9978aa5168bc$var$executionContext & 2) && ($662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $662d9978aa5168bc$var$workInProgressRootExitStatus && $662d9978aa5168bc$var$markRootSuspended(root, $662d9978aa5168bc$var$workInProgressRootRenderLanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !1)), $662d9978aa5168bc$var$ensureRootIsScheduled(root);
}
function $662d9978aa5168bc$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($662d9978aa5168bc$var$executionContext & 6)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $662d9978aa5168bc$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $662d9978aa5168bc$var$renderRootConcurrent(root$jscomp$0, lanes) : $662d9978aa5168bc$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $662d9978aa5168bc$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $662d9978aa5168bc$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $662d9978aa5168bc$var$markRootSuspended(root$jscomp$0, lanes, 0, !$662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$662d9978aa5168bc$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $662d9978aa5168bc$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $662d9978aa5168bc$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($662d9978aa5168bc$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $662d9978aa5168bc$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($662d9978aa5168bc$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $662d9978aa5168bc$var$workInProgressRootRecoverableErrors;
                            $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $662d9978aa5168bc$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $662d9978aa5168bc$var$prepareFreshStack(root$jscomp$0, 0);
                $662d9978aa5168bc$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $662d9978aa5168bc$var$markRootSuspended(shouldTimeSlice, lanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !$662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $662d9978aa5168bc$var$globalMostRecentFallbackTime + 300 - $662d9978aa5168bc$var$now(), 10 < renderWasConcurrent)) {
                    $662d9978aa5168bc$var$markRootSuspended(shouldTimeSlice, lanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !$662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $662d9978aa5168bc$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $662d9978aa5168bc$var$scheduleTimeout($662d9978aa5168bc$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $662d9978aa5168bc$var$workInProgressRootRecoverableErrors, $662d9978aa5168bc$var$workInProgressTransitions, $662d9978aa5168bc$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $662d9978aa5168bc$var$workInProgressDeferredLane, $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes, $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $662d9978aa5168bc$var$commitRootWhenReady(shouldTimeSlice, forceSync, $662d9978aa5168bc$var$workInProgressRootRecoverableErrors, $662d9978aa5168bc$var$workInProgressTransitions, $662d9978aa5168bc$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $662d9978aa5168bc$var$workInProgressDeferredLane, $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes, $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $662d9978aa5168bc$var$ensureRootIsScheduled(root$jscomp$0);
}
function $662d9978aa5168bc$var$queueRecoverableErrors(errors) {
    null === $662d9978aa5168bc$var$workInProgressRootRecoverableErrors ? $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = errors : $662d9978aa5168bc$var$workInProgressRootRecoverableErrors.push.apply($662d9978aa5168bc$var$workInProgressRootRecoverableErrors, errors);
}
function $662d9978aa5168bc$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($662d9978aa5168bc$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $662d9978aa5168bc$var$noop
        }, $662d9978aa5168bc$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $662d9978aa5168bc$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($662d9978aa5168bc$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $662d9978aa5168bc$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $662d9978aa5168bc$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $662d9978aa5168bc$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$662d9978aa5168bc$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $662d9978aa5168bc$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$662d9978aa5168bc$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $662d9978aa5168bc$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $662d9978aa5168bc$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $662d9978aa5168bc$var$flushSyncWork$1() {
    return 0 === ($662d9978aa5168bc$var$executionContext & 6) ? ($662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $662d9978aa5168bc$var$resetWorkInProgressStack() {
    if (null !== $662d9978aa5168bc$var$workInProgress) {
        if (0 === $662d9978aa5168bc$var$workInProgressSuspendedReason) var interruptedWork = $662d9978aa5168bc$var$workInProgress.return;
        else interruptedWork = $662d9978aa5168bc$var$workInProgress, $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$currentlyRenderingFiber = null, $662d9978aa5168bc$var$resetHooksOnUnwind(interruptedWork), $662d9978aa5168bc$var$thenableState$1 = null, $662d9978aa5168bc$var$thenableIndexCounter$1 = 0, interruptedWork = $662d9978aa5168bc$var$workInProgress;
        for(; null !== interruptedWork;)$662d9978aa5168bc$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $662d9978aa5168bc$var$workInProgress = null;
    }
}
function $662d9978aa5168bc$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $662d9978aa5168bc$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $662d9978aa5168bc$var$resetWorkInProgressStack();
    $662d9978aa5168bc$var$workInProgressRoot = root;
    $662d9978aa5168bc$var$workInProgress = timeoutHandle = $662d9978aa5168bc$var$createWorkInProgress(root.current, null);
    $662d9978aa5168bc$var$workInProgressRootRenderLanes = lanes;
    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
    $662d9978aa5168bc$var$workInProgressThrownValue = null;
    $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $662d9978aa5168bc$var$workInProgressRootIsPrerendering = $662d9978aa5168bc$var$checkIfRootIsPrerendering(root, lanes);
    $662d9978aa5168bc$var$workInProgressRootDidAttachPingListener = !1;
    $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes = $662d9978aa5168bc$var$workInProgressDeferredLane = $662d9978aa5168bc$var$workInProgressRootPingedLanes = $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes = $662d9978aa5168bc$var$workInProgressRootSkippedLanes = $662d9978aa5168bc$var$workInProgressRootExitStatus = 0;
    $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = $662d9978aa5168bc$var$workInProgressRootConcurrentErrors = null;
    $662d9978aa5168bc$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $662d9978aa5168bc$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $662d9978aa5168bc$var$entangledRenderLanes = lanes;
    $662d9978aa5168bc$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $662d9978aa5168bc$var$handleThrow(root, thrownValue) {
    $662d9978aa5168bc$var$currentlyRenderingFiber$1 = null;
    $662d9978aa5168bc$var$ReactSharedInternals.H = $662d9978aa5168bc$var$ContextOnlyDispatcher;
    thrownValue === $662d9978aa5168bc$var$SuspenseException ? (thrownValue = $662d9978aa5168bc$var$getSuspendedThenable(), $662d9978aa5168bc$var$workInProgressSuspendedReason = 3) : thrownValue === $662d9978aa5168bc$var$SuspenseyCommitException ? (thrownValue = $662d9978aa5168bc$var$getSuspendedThenable(), $662d9978aa5168bc$var$workInProgressSuspendedReason = 4) : $662d9978aa5168bc$var$workInProgressSuspendedReason = thrownValue === $662d9978aa5168bc$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $662d9978aa5168bc$var$workInProgressThrownValue = thrownValue;
    null === $662d9978aa5168bc$var$workInProgress && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 1, $662d9978aa5168bc$var$logUncaughtError(root, $662d9978aa5168bc$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $662d9978aa5168bc$var$pushDispatcher() {
    var prevDispatcher = $662d9978aa5168bc$var$ReactSharedInternals.H;
    $662d9978aa5168bc$var$ReactSharedInternals.H = $662d9978aa5168bc$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $662d9978aa5168bc$var$ContextOnlyDispatcher : prevDispatcher;
}
function $662d9978aa5168bc$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $662d9978aa5168bc$var$ReactSharedInternals.A;
    $662d9978aa5168bc$var$ReactSharedInternals.A = $662d9978aa5168bc$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $662d9978aa5168bc$var$renderDidSuspendDelayIfPossible() {
    $662d9978aa5168bc$var$workInProgressRootExitStatus = 4;
    $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings || ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 4194176) !== $662d9978aa5168bc$var$workInProgressRootRenderLanes && null !== $662d9978aa5168bc$var$suspenseHandlerStackCursor.current || ($662d9978aa5168bc$var$workInProgressRootIsPrerendering = !0);
    0 === ($662d9978aa5168bc$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $662d9978aa5168bc$var$workInProgressRoot || $662d9978aa5168bc$var$markRootSuspended($662d9978aa5168bc$var$workInProgressRoot, $662d9978aa5168bc$var$workInProgressRootRenderLanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !1);
}
function $662d9978aa5168bc$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $662d9978aa5168bc$var$executionContext;
    $662d9978aa5168bc$var$executionContext |= 2;
    var prevDispatcher = $662d9978aa5168bc$var$pushDispatcher(), prevAsyncDispatcher = $662d9978aa5168bc$var$pushAsyncDispatcher();
    if ($662d9978aa5168bc$var$workInProgressRoot !== root || $662d9978aa5168bc$var$workInProgressRootRenderLanes !== lanes) $662d9978aa5168bc$var$workInProgressTransitions = null, $662d9978aa5168bc$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $662d9978aa5168bc$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $662d9978aa5168bc$var$workInProgressSuspendedReason && null !== $662d9978aa5168bc$var$workInProgress) {
            var unitOfWork = $662d9978aa5168bc$var$workInProgress, thrownValue = $662d9978aa5168bc$var$workInProgressThrownValue;
            switch($662d9978aa5168bc$var$workInProgressSuspendedReason){
                case 8:
                    $662d9978aa5168bc$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $662d9978aa5168bc$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $662d9978aa5168bc$var$workInProgressSuspendedReason;
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                    $662d9978aa5168bc$var$workInProgressThrownValue = null;
                    $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $662d9978aa5168bc$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $662d9978aa5168bc$var$workInProgressSuspendedReason, $662d9978aa5168bc$var$workInProgressSuspendedReason = 0, $662d9978aa5168bc$var$workInProgressThrownValue = null, $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $662d9978aa5168bc$var$workLoopSync();
        exitStatus = $662d9978aa5168bc$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $662d9978aa5168bc$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$currentlyRenderingFiber = null;
    $662d9978aa5168bc$var$executionContext = prevExecutionContext;
    $662d9978aa5168bc$var$ReactSharedInternals.H = prevDispatcher;
    $662d9978aa5168bc$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $662d9978aa5168bc$var$workInProgress && ($662d9978aa5168bc$var$workInProgressRoot = null, $662d9978aa5168bc$var$workInProgressRootRenderLanes = 0, $662d9978aa5168bc$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $662d9978aa5168bc$var$workLoopSync() {
    for(; null !== $662d9978aa5168bc$var$workInProgress;)$662d9978aa5168bc$var$performUnitOfWork($662d9978aa5168bc$var$workInProgress);
}
function $662d9978aa5168bc$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $662d9978aa5168bc$var$executionContext;
    $662d9978aa5168bc$var$executionContext |= 2;
    var prevDispatcher = $662d9978aa5168bc$var$pushDispatcher(), prevAsyncDispatcher = $662d9978aa5168bc$var$pushAsyncDispatcher();
    $662d9978aa5168bc$var$workInProgressRoot !== root || $662d9978aa5168bc$var$workInProgressRootRenderLanes !== lanes ? ($662d9978aa5168bc$var$workInProgressTransitions = null, $662d9978aa5168bc$var$workInProgressRootRenderTargetTime = $662d9978aa5168bc$var$now() + 500, $662d9978aa5168bc$var$prepareFreshStack(root, lanes)) : $662d9978aa5168bc$var$workInProgressRootIsPrerendering = $662d9978aa5168bc$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $662d9978aa5168bc$var$workInProgressSuspendedReason && null !== $662d9978aa5168bc$var$workInProgress) {
            lanes = $662d9978aa5168bc$var$workInProgress;
            var thrownValue = $662d9978aa5168bc$var$workInProgressThrownValue;
            b: switch($662d9978aa5168bc$var$workInProgressSuspendedReason){
                case 1:
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                    $662d9978aa5168bc$var$workInProgressThrownValue = null;
                    $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($662d9978aa5168bc$var$isThenableResolved(thrownValue)) {
                        $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                        $662d9978aa5168bc$var$workInProgressThrownValue = null;
                        $662d9978aa5168bc$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $662d9978aa5168bc$var$workInProgressSuspendedReason && $662d9978aa5168bc$var$workInProgressRoot === root && ($662d9978aa5168bc$var$workInProgressSuspendedReason = 7);
                        $662d9978aa5168bc$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $662d9978aa5168bc$var$isThenableResolved(thrownValue) ? ($662d9978aa5168bc$var$workInProgressSuspendedReason = 0, $662d9978aa5168bc$var$workInProgressThrownValue = null, $662d9978aa5168bc$var$replaySuspendedUnitOfWork(lanes)) : ($662d9978aa5168bc$var$workInProgressSuspendedReason = 0, $662d9978aa5168bc$var$workInProgressThrownValue = null, $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($662d9978aa5168bc$var$workInProgress.tag){
                        case 26:
                            resource = $662d9978aa5168bc$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $662d9978aa5168bc$var$workInProgress;
                            if (resource ? $662d9978aa5168bc$var$preloadResource(resource) : 1) {
                                $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                                $662d9978aa5168bc$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $662d9978aa5168bc$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($662d9978aa5168bc$var$workInProgress = returnFiber, $662d9978aa5168bc$var$completeUnitOfWork(returnFiber)) : $662d9978aa5168bc$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                    $662d9978aa5168bc$var$workInProgressThrownValue = null;
                    $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                    $662d9978aa5168bc$var$workInProgressThrownValue = null;
                    $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $662d9978aa5168bc$var$resetWorkInProgressStack();
                    $662d9978aa5168bc$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(462));
            }
        }
        $662d9978aa5168bc$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $662d9978aa5168bc$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$currentlyRenderingFiber = null;
    $662d9978aa5168bc$var$ReactSharedInternals.H = prevDispatcher;
    $662d9978aa5168bc$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $662d9978aa5168bc$var$executionContext = prevExecutionContext;
    if (null !== $662d9978aa5168bc$var$workInProgress) return 0;
    $662d9978aa5168bc$var$workInProgressRoot = null;
    $662d9978aa5168bc$var$workInProgressRootRenderLanes = 0;
    $662d9978aa5168bc$var$finishQueueingConcurrentUpdates();
    return $662d9978aa5168bc$var$workInProgressRootExitStatus;
}
function $662d9978aa5168bc$var$workLoopConcurrent() {
    for(; null !== $662d9978aa5168bc$var$workInProgress && !$662d9978aa5168bc$var$shouldYield();)$662d9978aa5168bc$var$performUnitOfWork($662d9978aa5168bc$var$workInProgress);
}
function $662d9978aa5168bc$var$performUnitOfWork(unitOfWork) {
    var next = $662d9978aa5168bc$var$beginWork(unitOfWork.alternate, unitOfWork, $662d9978aa5168bc$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $662d9978aa5168bc$var$completeUnitOfWork(unitOfWork) : $662d9978aa5168bc$var$workInProgress = next;
}
function $662d9978aa5168bc$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $662d9978aa5168bc$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $662d9978aa5168bc$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $662d9978aa5168bc$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $662d9978aa5168bc$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $662d9978aa5168bc$var$resetHooksOnUnwind(next);
        default:
            $662d9978aa5168bc$var$unwindInterruptedWork(current, next), next = $662d9978aa5168bc$var$workInProgress = $662d9978aa5168bc$var$resetWorkInProgress(next, $662d9978aa5168bc$var$entangledRenderLanes), next = $662d9978aa5168bc$var$beginWork(current, next, $662d9978aa5168bc$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $662d9978aa5168bc$var$completeUnitOfWork(unitOfWork) : $662d9978aa5168bc$var$workInProgress = next;
}
function $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$currentlyRenderingFiber = null;
    $662d9978aa5168bc$var$resetHooksOnUnwind(unitOfWork);
    $662d9978aa5168bc$var$thenableState$1 = null;
    $662d9978aa5168bc$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($662d9978aa5168bc$var$throwException(root, returnFiber, unitOfWork, thrownValue, $662d9978aa5168bc$var$workInProgressRootRenderLanes)) {
            $662d9978aa5168bc$var$workInProgressRootExitStatus = 1;
            $662d9978aa5168bc$var$logUncaughtError(root, $662d9978aa5168bc$var$createCapturedValueAtFiber(thrownValue, root.current));
            $662d9978aa5168bc$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $662d9978aa5168bc$var$workInProgress = returnFiber, error;
        $662d9978aa5168bc$var$workInProgressRootExitStatus = 1;
        $662d9978aa5168bc$var$logUncaughtError(root, $662d9978aa5168bc$var$createCapturedValueAtFiber(thrownValue, root.current));
        $662d9978aa5168bc$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($662d9978aa5168bc$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($662d9978aa5168bc$var$workInProgressRootIsPrerendering || 0 !== ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $662d9978aa5168bc$var$unwindUnitOfWork(unitOfWork, root);
    } else $662d9978aa5168bc$var$completeUnitOfWork(unitOfWork);
}
function $662d9978aa5168bc$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $662d9978aa5168bc$var$unwindUnitOfWork(completedWork, $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $662d9978aa5168bc$var$completeWork(completedWork.alternate, completedWork, $662d9978aa5168bc$var$entangledRenderLanes);
        if (null !== next) {
            $662d9978aa5168bc$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $662d9978aa5168bc$var$workInProgress = completedWork;
            return;
        }
        $662d9978aa5168bc$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 5);
}
function $662d9978aa5168bc$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $662d9978aa5168bc$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $662d9978aa5168bc$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $662d9978aa5168bc$var$workInProgress = unitOfWork;
            return;
        }
        $662d9978aa5168bc$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $662d9978aa5168bc$var$workInProgressRootExitStatus = 6;
    $662d9978aa5168bc$var$workInProgress = null;
}
function $662d9978aa5168bc$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T, previousUpdateLanePriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    try {
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 2, $662d9978aa5168bc$var$ReactSharedInternals.T = null, $662d9978aa5168bc$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition, $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $662d9978aa5168bc$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $662d9978aa5168bc$var$flushPassiveEffects();
    while (null !== $662d9978aa5168bc$var$rootWithPendingPassiveEffects);
    if (0 !== ($662d9978aa5168bc$var$executionContext & 6)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $662d9978aa5168bc$var$concurrentlyUpdatedLanes;
    $662d9978aa5168bc$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $662d9978aa5168bc$var$workInProgressRoot && ($662d9978aa5168bc$var$workInProgress = $662d9978aa5168bc$var$workInProgressRoot = null, $662d9978aa5168bc$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $662d9978aa5168bc$var$rootDoesHavePassiveEffects || ($662d9978aa5168bc$var$rootDoesHavePassiveEffects = !0, $662d9978aa5168bc$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $662d9978aa5168bc$var$pendingPassiveTransitions = transitions, $662d9978aa5168bc$var$scheduleCallback$1($662d9978aa5168bc$var$NormalPriority$1, function() {
        $662d9978aa5168bc$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $662d9978aa5168bc$var$ReactSharedInternals.T, $662d9978aa5168bc$var$ReactSharedInternals.T = null, spawnedLane = $662d9978aa5168bc$var$ReactDOMSharedInternals.p, $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 2, updatedLanes = $662d9978aa5168bc$var$executionContext, $662d9978aa5168bc$var$executionContext |= 4, $662d9978aa5168bc$var$commitBeforeMutationEffects(root, finishedWork), $662d9978aa5168bc$var$commitMutationEffectsOnFiber(finishedWork, root), $662d9978aa5168bc$var$restoreSelection($662d9978aa5168bc$var$selectionInformation, root.containerInfo), $662d9978aa5168bc$var$_enabled = !!$662d9978aa5168bc$var$eventsEnabled, $662d9978aa5168bc$var$selectionInformation = $662d9978aa5168bc$var$eventsEnabled = null, root.current = finishedWork, $662d9978aa5168bc$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $662d9978aa5168bc$var$requestPaint(), $662d9978aa5168bc$var$executionContext = updatedLanes, $662d9978aa5168bc$var$ReactDOMSharedInternals.p = spawnedLane, $662d9978aa5168bc$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $662d9978aa5168bc$var$rootDoesHavePassiveEffects ? ($662d9978aa5168bc$var$rootDoesHavePassiveEffects = !1, $662d9978aa5168bc$var$rootWithPendingPassiveEffects = root, $662d9978aa5168bc$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $662d9978aa5168bc$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $662d9978aa5168bc$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $662d9978aa5168bc$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($662d9978aa5168bc$var$pendingPassiveEffectsLanes & 3) && $662d9978aa5168bc$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $662d9978aa5168bc$var$rootWithNestedUpdates ? $662d9978aa5168bc$var$nestedUpdateCount++ : ($662d9978aa5168bc$var$nestedUpdateCount = 0, $662d9978aa5168bc$var$rootWithNestedUpdates = root) : $662d9978aa5168bc$var$nestedUpdateCount = 0;
    $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $662d9978aa5168bc$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $662d9978aa5168bc$var$releaseCache(remainingLanes)));
}
function $662d9978aa5168bc$var$flushPassiveEffects() {
    if (null !== $662d9978aa5168bc$var$rootWithPendingPassiveEffects) {
        var root$170 = $662d9978aa5168bc$var$rootWithPendingPassiveEffects, remainingLanes = $662d9978aa5168bc$var$pendingPassiveEffectsRemainingLanes;
        $662d9978aa5168bc$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $662d9978aa5168bc$var$lanesToEventPriority($662d9978aa5168bc$var$pendingPassiveEffectsLanes), prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T, previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
        try {
            $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $662d9978aa5168bc$var$ReactSharedInternals.T = null;
            if (null === $662d9978aa5168bc$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $662d9978aa5168bc$var$pendingPassiveTransitions;
                $662d9978aa5168bc$var$pendingPassiveTransitions = null;
                var root = $662d9978aa5168bc$var$rootWithPendingPassiveEffects, lanes = $662d9978aa5168bc$var$pendingPassiveEffectsLanes;
                $662d9978aa5168bc$var$rootWithPendingPassiveEffects = null;
                $662d9978aa5168bc$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($662d9978aa5168bc$var$executionContext & 6)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(331));
                var prevExecutionContext = $662d9978aa5168bc$var$executionContext;
                $662d9978aa5168bc$var$executionContext |= 4;
                $662d9978aa5168bc$var$commitPassiveUnmountOnFiber(root.current);
                $662d9978aa5168bc$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $662d9978aa5168bc$var$executionContext = prevExecutionContext;
                $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($662d9978aa5168bc$var$injectedHook && "function" === typeof $662d9978aa5168bc$var$injectedHook.onPostCommitFiberRoot) try {
                    $662d9978aa5168bc$var$injectedHook.onPostCommitFiberRoot($662d9978aa5168bc$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority, $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition, $662d9978aa5168bc$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $662d9978aa5168bc$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $662d9978aa5168bc$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $662d9978aa5168bc$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $662d9978aa5168bc$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($662d9978aa5168bc$var$markRootUpdated$1(rootFiber, 2), $662d9978aa5168bc$var$ensureRootIsScheduled(rootFiber));
}
function $662d9978aa5168bc$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $662d9978aa5168bc$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $662d9978aa5168bc$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed || !$662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $662d9978aa5168bc$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $662d9978aa5168bc$var$createClassErrorUpdate(2);
                instance = $662d9978aa5168bc$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($662d9978aa5168bc$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $662d9978aa5168bc$var$markRootUpdated$1(instance, 2), $662d9978aa5168bc$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $662d9978aa5168bc$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $662d9978aa5168bc$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($662d9978aa5168bc$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $662d9978aa5168bc$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $662d9978aa5168bc$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $662d9978aa5168bc$var$workInProgressRoot === root && ($662d9978aa5168bc$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $662d9978aa5168bc$var$workInProgressRootExitStatus || 3 === $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 62914560) === $662d9978aa5168bc$var$workInProgressRootRenderLanes && 300 > $662d9978aa5168bc$var$now() - $662d9978aa5168bc$var$globalMostRecentFallbackTime ? 0 === ($662d9978aa5168bc$var$executionContext & 2) && $662d9978aa5168bc$var$prepareFreshStack(root, 0) : $662d9978aa5168bc$var$workInProgressRootPingedLanes |= pingedLanes, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes === $662d9978aa5168bc$var$workInProgressRootRenderLanes && ($662d9978aa5168bc$var$workInProgressSuspendedRetryLanes = 0));
    $662d9978aa5168bc$var$ensureRootIsScheduled(root);
}
function $662d9978aa5168bc$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $662d9978aa5168bc$var$claimNextRetryLane());
    boundaryFiber = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($662d9978aa5168bc$var$markRootUpdated$1(boundaryFiber, retryLane), $662d9978aa5168bc$var$ensureRootIsScheduled(boundaryFiber));
}
function $662d9978aa5168bc$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $662d9978aa5168bc$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $662d9978aa5168bc$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $662d9978aa5168bc$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $662d9978aa5168bc$var$scheduleCallback$1(priorityLevel, callback) {
    return $662d9978aa5168bc$var$scheduleCallback$3(priorityLevel, callback);
}
var $662d9978aa5168bc$var$firstScheduledRoot = null, $662d9978aa5168bc$var$lastScheduledRoot = null, $662d9978aa5168bc$var$didScheduleMicrotask = !1, $662d9978aa5168bc$var$mightHavePendingSyncWork = !1, $662d9978aa5168bc$var$isFlushingWork = !1, $662d9978aa5168bc$var$currentEventTransitionLane = 0;
function $662d9978aa5168bc$var$ensureRootIsScheduled(root) {
    root !== $662d9978aa5168bc$var$lastScheduledRoot && null === root.next && (null === $662d9978aa5168bc$var$lastScheduledRoot ? $662d9978aa5168bc$var$firstScheduledRoot = $662d9978aa5168bc$var$lastScheduledRoot = root : $662d9978aa5168bc$var$lastScheduledRoot = $662d9978aa5168bc$var$lastScheduledRoot.next = root);
    $662d9978aa5168bc$var$mightHavePendingSyncWork = !0;
    $662d9978aa5168bc$var$didScheduleMicrotask || ($662d9978aa5168bc$var$didScheduleMicrotask = !0, $662d9978aa5168bc$var$scheduleImmediateTask($662d9978aa5168bc$var$processRootScheduleInMicrotask));
}
function $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$662d9978aa5168bc$var$isFlushingWork && $662d9978aa5168bc$var$mightHavePendingSyncWork) {
        $662d9978aa5168bc$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $662d9978aa5168bc$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $662d9978aa5168bc$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $662d9978aa5168bc$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $662d9978aa5168bc$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $662d9978aa5168bc$var$getNextLanes(root$172, root$172 === $662d9978aa5168bc$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $662d9978aa5168bc$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $662d9978aa5168bc$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $662d9978aa5168bc$var$isFlushingWork = !1;
    }
}
function $662d9978aa5168bc$var$processRootScheduleInMicrotask() {
    $662d9978aa5168bc$var$mightHavePendingSyncWork = $662d9978aa5168bc$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $662d9978aa5168bc$var$currentEventTransitionLane && ($662d9978aa5168bc$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $662d9978aa5168bc$var$currentEventTransitionLane), $662d9978aa5168bc$var$currentEventTransitionLane = 0);
    for(var currentTime = $662d9978aa5168bc$var$now(), prev = null, root = $662d9978aa5168bc$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $662d9978aa5168bc$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $662d9978aa5168bc$var$firstScheduledRoot = next : prev.next = next, null === next && ($662d9978aa5168bc$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $662d9978aa5168bc$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $662d9978aa5168bc$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $662d9978aa5168bc$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $662d9978aa5168bc$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $662d9978aa5168bc$var$workInProgressRoot;
    suspendedLanes = $662d9978aa5168bc$var$workInProgressRootRenderLanes;
    suspendedLanes = $662d9978aa5168bc$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $662d9978aa5168bc$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $662d9978aa5168bc$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $662d9978aa5168bc$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $662d9978aa5168bc$var$cancelCallback$1(pingedLanes);
        switch($662d9978aa5168bc$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $662d9978aa5168bc$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $662d9978aa5168bc$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $662d9978aa5168bc$var$IdlePriority;
                break;
            default:
                suspendedLanes = $662d9978aa5168bc$var$NormalPriority$1;
        }
        pingedLanes = $662d9978aa5168bc$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $662d9978aa5168bc$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $662d9978aa5168bc$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $662d9978aa5168bc$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($662d9978aa5168bc$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $662d9978aa5168bc$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $662d9978aa5168bc$var$getNextLanes(root, root === $662d9978aa5168bc$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $662d9978aa5168bc$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $662d9978aa5168bc$var$scheduleTaskForRootDuringMicrotask(root, $662d9978aa5168bc$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $662d9978aa5168bc$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $662d9978aa5168bc$var$performSyncWorkOnRoot(root, lanes) {
    if ($662d9978aa5168bc$var$flushPassiveEffects()) return null;
    $662d9978aa5168bc$var$performWorkOnRoot(root, lanes, !0);
}
function $662d9978aa5168bc$var$scheduleImmediateTask(cb) {
    $662d9978aa5168bc$var$scheduleMicrotask(function() {
        0 !== ($662d9978aa5168bc$var$executionContext & 6) ? $662d9978aa5168bc$var$scheduleCallback$3($662d9978aa5168bc$var$ImmediatePriority, cb) : cb();
    });
}
function $662d9978aa5168bc$var$requestTransitionLane() {
    0 === $662d9978aa5168bc$var$currentEventTransitionLane && ($662d9978aa5168bc$var$currentEventTransitionLane = $662d9978aa5168bc$var$claimNextTransitionLane());
    return $662d9978aa5168bc$var$currentEventTransitionLane;
}
function $662d9978aa5168bc$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $662d9978aa5168bc$var$sanitizeURL("" + actionProp);
}
function $662d9978aa5168bc$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $662d9978aa5168bc$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $662d9978aa5168bc$var$coerceFormActionProp((nativeEventTarget[$662d9978aa5168bc$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$662d9978aa5168bc$var$internalPropsKey] || null) ? $662d9978aa5168bc$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $662d9978aa5168bc$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $662d9978aa5168bc$var$currentEventTransitionLane) {
                                var formData = submitter ? $662d9978aa5168bc$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $662d9978aa5168bc$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $662d9978aa5168bc$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $662d9978aa5168bc$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $662d9978aa5168bc$var$i$jscomp$inline_1439 = 0; $662d9978aa5168bc$var$i$jscomp$inline_1439 < $662d9978aa5168bc$var$simpleEventPluginEvents.length; $662d9978aa5168bc$var$i$jscomp$inline_1439++){
    var $662d9978aa5168bc$var$eventName$jscomp$inline_1440 = $662d9978aa5168bc$var$simpleEventPluginEvents[$662d9978aa5168bc$var$i$jscomp$inline_1439], $662d9978aa5168bc$var$domEventName$jscomp$inline_1441 = $662d9978aa5168bc$var$eventName$jscomp$inline_1440.toLowerCase(), $662d9978aa5168bc$var$capitalizedEvent$jscomp$inline_1442 = $662d9978aa5168bc$var$eventName$jscomp$inline_1440[0].toUpperCase() + $662d9978aa5168bc$var$eventName$jscomp$inline_1440.slice(1);
    $662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$domEventName$jscomp$inline_1441, "on" + $662d9978aa5168bc$var$capitalizedEvent$jscomp$inline_1442);
}
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$ANIMATION_END, "onAnimationEnd");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$ANIMATION_ITERATION, "onAnimationIteration");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$ANIMATION_START, "onAnimationStart");
$662d9978aa5168bc$var$registerSimpleEvent("dblclick", "onDoubleClick");
$662d9978aa5168bc$var$registerSimpleEvent("focusin", "onFocus");
$662d9978aa5168bc$var$registerSimpleEvent("focusout", "onBlur");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$TRANSITION_RUN, "onTransitionRun");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$TRANSITION_START, "onTransitionStart");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$TRANSITION_CANCEL, "onTransitionCancel");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$TRANSITION_END, "onTransitionEnd");
$662d9978aa5168bc$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$662d9978aa5168bc$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$662d9978aa5168bc$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$662d9978aa5168bc$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$662d9978aa5168bc$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$662d9978aa5168bc$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$662d9978aa5168bc$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$662d9978aa5168bc$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$662d9978aa5168bc$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$662d9978aa5168bc$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $662d9978aa5168bc$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $662d9978aa5168bc$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($662d9978aa5168bc$var$mediaEventTypes));
function $662d9978aa5168bc$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $662d9978aa5168bc$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $662d9978aa5168bc$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $662d9978aa5168bc$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$662d9978aa5168bc$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$662d9978aa5168bc$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($662d9978aa5168bc$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $662d9978aa5168bc$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $662d9978aa5168bc$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $662d9978aa5168bc$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $662d9978aa5168bc$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$662d9978aa5168bc$var$listeningMarker]) {
        rootContainerElement[$662d9978aa5168bc$var$listeningMarker] = !0;
        $662d9978aa5168bc$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($662d9978aa5168bc$var$nonDelegatedEvents.has(domEventName) || $662d9978aa5168bc$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $662d9978aa5168bc$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$662d9978aa5168bc$var$listeningMarker] || (ownerDocument[$662d9978aa5168bc$var$listeningMarker] = !0, $662d9978aa5168bc$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $662d9978aa5168bc$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($662d9978aa5168bc$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $662d9978aa5168bc$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $662d9978aa5168bc$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $662d9978aa5168bc$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$662d9978aa5168bc$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $662d9978aa5168bc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $662d9978aa5168bc$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $662d9978aa5168bc$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $662d9978aa5168bc$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $662d9978aa5168bc$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $662d9978aa5168bc$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticTouchEvent;
                        break;
                    case $662d9978aa5168bc$var$ANIMATION_END:
                    case $662d9978aa5168bc$var$ANIMATION_ITERATION:
                    case $662d9978aa5168bc$var$ANIMATION_START:
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticAnimationEvent;
                        break;
                    case $662d9978aa5168bc$var$TRANSITION_END:
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $662d9978aa5168bc$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($662d9978aa5168bc$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $662d9978aa5168bc$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($662d9978aa5168bc$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$662d9978aa5168bc$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $662d9978aa5168bc$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $662d9978aa5168bc$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $662d9978aa5168bc$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $662d9978aa5168bc$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $662d9978aa5168bc$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $662d9978aa5168bc$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $662d9978aa5168bc$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $662d9978aa5168bc$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $662d9978aa5168bc$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $662d9978aa5168bc$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $662d9978aa5168bc$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $662d9978aa5168bc$var$getParent(inCapturePhase);
                                reactEventName = $662d9978aa5168bc$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $662d9978aa5168bc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $662d9978aa5168bc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $662d9978aa5168bc$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForChangeEvent;
                else if ($662d9978aa5168bc$var$isTextInputElement(reactName)) {
                    if ($662d9978aa5168bc$var$isInputEventSupported) getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $662d9978aa5168bc$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $662d9978aa5168bc$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForChangeEvent) : getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $662d9978aa5168bc$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $662d9978aa5168bc$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $662d9978aa5168bc$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($662d9978aa5168bc$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $662d9978aa5168bc$var$activeElement = handleEventFunc, $662d9978aa5168bc$var$activeElementInst = targetInst, $662d9978aa5168bc$var$lastSelection = null;
                    break;
                case "focusout":
                    $662d9978aa5168bc$var$lastSelection = $662d9978aa5168bc$var$activeElementInst = $662d9978aa5168bc$var$activeElement = null;
                    break;
                case "mousedown":
                    $662d9978aa5168bc$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $662d9978aa5168bc$var$mouseDown = !1;
                    $662d9978aa5168bc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($662d9978aa5168bc$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $662d9978aa5168bc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($662d9978aa5168bc$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $662d9978aa5168bc$var$isComposing ? $662d9978aa5168bc$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($662d9978aa5168bc$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($662d9978aa5168bc$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $662d9978aa5168bc$var$isComposing && (fallbackData = $662d9978aa5168bc$var$getData()) : ($662d9978aa5168bc$var$root = nativeEventTarget, $662d9978aa5168bc$var$startText = "value" in $662d9978aa5168bc$var$root ? $662d9978aa5168bc$var$root.value : $662d9978aa5168bc$var$root.textContent, $662d9978aa5168bc$var$isComposing = !0)), handleEventFunc = $662d9978aa5168bc$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $662d9978aa5168bc$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $662d9978aa5168bc$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $662d9978aa5168bc$var$canUseTextInputEvent ? $662d9978aa5168bc$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $662d9978aa5168bc$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $662d9978aa5168bc$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $662d9978aa5168bc$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $662d9978aa5168bc$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $662d9978aa5168bc$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $662d9978aa5168bc$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $662d9978aa5168bc$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $662d9978aa5168bc$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($662d9978aa5168bc$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $662d9978aa5168bc$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($662d9978aa5168bc$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $662d9978aa5168bc$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $662d9978aa5168bc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $662d9978aa5168bc$var$getListener(target, registrationName), null != stateNode && listeners.unshift($662d9978aa5168bc$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $662d9978aa5168bc$var$getListener(target, registrationName), null != stateNode && listeners.push($662d9978aa5168bc$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $662d9978aa5168bc$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $662d9978aa5168bc$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $662d9978aa5168bc$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($662d9978aa5168bc$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($662d9978aa5168bc$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $662d9978aa5168bc$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $662d9978aa5168bc$var$normalizeMarkupForTextOrAttribute(clientText);
    return $662d9978aa5168bc$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $662d9978aa5168bc$var$noop$1() {}
function $662d9978aa5168bc$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $662d9978aa5168bc$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $662d9978aa5168bc$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $662d9978aa5168bc$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $662d9978aa5168bc$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $662d9978aa5168bc$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $662d9978aa5168bc$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $662d9978aa5168bc$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $662d9978aa5168bc$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $662d9978aa5168bc$var$setProp(domElement, tag, "name", props.name, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($662d9978aa5168bc$var$setProp(domElement, tag, "encType", props.encType, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "method", props.method, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $662d9978aa5168bc$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $662d9978aa5168bc$var$noop$1);
            break;
        case "onScroll":
            null != value && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $662d9978aa5168bc$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("toggle", domElement);
            $662d9978aa5168bc$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $662d9978aa5168bc$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $662d9978aa5168bc$var$aliases.get(key) || key, $662d9978aa5168bc$var$setValueForAttribute(domElement, key, value);
    }
}
function $662d9978aa5168bc$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $662d9978aa5168bc$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $662d9978aa5168bc$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $662d9978aa5168bc$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $662d9978aa5168bc$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$662d9978aa5168bc$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$662d9978aa5168bc$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $662d9978aa5168bc$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $662d9978aa5168bc$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", domElement);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                    default:
                        $662d9978aa5168bc$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $662d9978aa5168bc$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $662d9978aa5168bc$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $662d9978aa5168bc$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $662d9978aa5168bc$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $662d9978aa5168bc$var$track(domElement);
            return;
        case "select":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $662d9978aa5168bc$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $662d9978aa5168bc$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(91));
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $662d9978aa5168bc$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $662d9978aa5168bc$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("cancel", domElement);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $662d9978aa5168bc$var$mediaEventTypes.length; hasSrc++)$662d9978aa5168bc$var$listenToNonDelegatedEvent($662d9978aa5168bc$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", domElement);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", domElement), $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($662d9978aa5168bc$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $662d9978aa5168bc$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $662d9978aa5168bc$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $662d9978aa5168bc$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $662d9978aa5168bc$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $662d9978aa5168bc$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $662d9978aa5168bc$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $662d9978aa5168bc$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $662d9978aa5168bc$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $662d9978aa5168bc$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $662d9978aa5168bc$var$updateOptions(domElement, !!lastProps, tag, !0) : $662d9978aa5168bc$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $662d9978aa5168bc$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $662d9978aa5168bc$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $662d9978aa5168bc$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($662d9978aa5168bc$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $662d9978aa5168bc$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $662d9978aa5168bc$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $662d9978aa5168bc$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $662d9978aa5168bc$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $662d9978aa5168bc$var$eventsEnabled = null, $662d9978aa5168bc$var$selectionInformation = null;
function $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $662d9978aa5168bc$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $662d9978aa5168bc$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $662d9978aa5168bc$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $662d9978aa5168bc$var$currentPopstateTransitionEvent = null;
function $662d9978aa5168bc$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $662d9978aa5168bc$var$currentPopstateTransitionEvent) return !1;
        $662d9978aa5168bc$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $662d9978aa5168bc$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $662d9978aa5168bc$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $662d9978aa5168bc$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $662d9978aa5168bc$var$localPromise = "function" === typeof Promise ? Promise : void 0, $662d9978aa5168bc$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $662d9978aa5168bc$var$localPromise ? function(callback) {
    return $662d9978aa5168bc$var$localPromise.resolve(null).then(callback).catch($662d9978aa5168bc$var$handleErrorInNextTick);
} : $662d9978aa5168bc$var$scheduleTimeout;
function $662d9978aa5168bc$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $662d9978aa5168bc$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $662d9978aa5168bc$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $662d9978aa5168bc$var$retryIfBlockedOn(suspenseInstance);
}
function $662d9978aa5168bc$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $662d9978aa5168bc$var$clearContainerSparingly(node);
                $662d9978aa5168bc$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $662d9978aa5168bc$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$662d9978aa5168bc$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $662d9978aa5168bc$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $662d9978aa5168bc$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $662d9978aa5168bc$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $662d9978aa5168bc$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $662d9978aa5168bc$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $662d9978aa5168bc$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(451));
    }
}
var $662d9978aa5168bc$var$preloadPropsMap = new Map(), $662d9978aa5168bc$var$preconnectsSet = new Set();
function $662d9978aa5168bc$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $662d9978aa5168bc$var$previousDispatcher = $662d9978aa5168bc$var$ReactDOMSharedInternals.d;
$662d9978aa5168bc$var$ReactDOMSharedInternals.d = {
    f: $662d9978aa5168bc$var$flushSyncWork,
    r: $662d9978aa5168bc$var$requestFormReset,
    D: $662d9978aa5168bc$var$prefetchDNS,
    C: $662d9978aa5168bc$var$preconnect,
    L: $662d9978aa5168bc$var$preload,
    m: $662d9978aa5168bc$var$preloadModule,
    X: $662d9978aa5168bc$var$preinitScript,
    S: $662d9978aa5168bc$var$preinitStyle,
    M: $662d9978aa5168bc$var$preinitModuleScript
};
function $662d9978aa5168bc$var$flushSyncWork() {
    var previousWasRendering = $662d9978aa5168bc$var$previousDispatcher.f(), wasRendering = $662d9978aa5168bc$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $662d9978aa5168bc$var$requestFormReset(form) {
    var formInst = $662d9978aa5168bc$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $662d9978aa5168bc$var$requestFormReset$1(formInst) : $662d9978aa5168bc$var$previousDispatcher.r(form);
}
var $662d9978aa5168bc$var$globalDocument = "undefined" === typeof document ? null : document;
function $662d9978aa5168bc$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $662d9978aa5168bc$var$preconnectsSet.has(limitedEscapedHref) || ($662d9978aa5168bc$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $662d9978aa5168bc$var$setInitialProperties(href, "link", rel), $662d9978aa5168bc$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $662d9978aa5168bc$var$prefetchDNS(href) {
    $662d9978aa5168bc$var$previousDispatcher.D(href);
    $662d9978aa5168bc$var$preconnectAs("dns-prefetch", href, null);
}
function $662d9978aa5168bc$var$preconnect(href, crossOrigin) {
    $662d9978aa5168bc$var$previousDispatcher.C(href, crossOrigin);
    $662d9978aa5168bc$var$preconnectAs("preconnect", href, crossOrigin);
}
function $662d9978aa5168bc$var$preload(href, as, options) {
    $662d9978aa5168bc$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $662d9978aa5168bc$var$getStyleKey(href);
                break;
            case "script":
                key = $662d9978aa5168bc$var$getScriptKey(href);
        }
        $662d9978aa5168bc$var$preloadPropsMap.has(key) || (href = $662d9978aa5168bc$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $662d9978aa5168bc$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $662d9978aa5168bc$var$setInitialProperties(as, "link", href), $662d9978aa5168bc$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $662d9978aa5168bc$var$preloadModule(href, options) {
    $662d9978aa5168bc$var$previousDispatcher.m(href, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $662d9978aa5168bc$var$getScriptKey(href);
        }
        if (!$662d9978aa5168bc$var$preloadPropsMap.has(key) && (href = $662d9978aa5168bc$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $662d9978aa5168bc$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $662d9978aa5168bc$var$setInitialProperties(as, "link", href);
            $662d9978aa5168bc$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $662d9978aa5168bc$var$preinitStyle(href, precedence, options) {
    $662d9978aa5168bc$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $662d9978aa5168bc$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $662d9978aa5168bc$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $662d9978aa5168bc$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $662d9978aa5168bc$var$preloadPropsMap.get(key)) && $662d9978aa5168bc$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $662d9978aa5168bc$var$markNodeAsHoistable(link);
                $662d9978aa5168bc$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $662d9978aa5168bc$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $662d9978aa5168bc$var$preinitScript(src, options) {
    $662d9978aa5168bc$var$previousDispatcher.X(src, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $662d9978aa5168bc$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $662d9978aa5168bc$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(key)), resource || (src = $662d9978aa5168bc$var$assign({
            src: src,
            async: !0
        }, options), (options = $662d9978aa5168bc$var$preloadPropsMap.get(key)) && $662d9978aa5168bc$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $662d9978aa5168bc$var$markNodeAsHoistable(resource), $662d9978aa5168bc$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $662d9978aa5168bc$var$preinitModuleScript(src, options) {
    $662d9978aa5168bc$var$previousDispatcher.M(src, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $662d9978aa5168bc$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $662d9978aa5168bc$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(key)), resource || (src = $662d9978aa5168bc$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $662d9978aa5168bc$var$preloadPropsMap.get(key)) && $662d9978aa5168bc$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $662d9978aa5168bc$var$markNodeAsHoistable(resource), $662d9978aa5168bc$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $662d9978aa5168bc$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $662d9978aa5168bc$var$rootInstanceStackCursor.current) ? $662d9978aa5168bc$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $662d9978aa5168bc$var$getStyleKey(pendingProps.href), pendingProps = $662d9978aa5168bc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $662d9978aa5168bc$var$getStyleKey(pendingProps.href);
                var styles$242 = $662d9978aa5168bc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $662d9978aa5168bc$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $662d9978aa5168bc$var$preloadPropsMap.set(type, pendingProps), styles$242 || $662d9978aa5168bc$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $662d9978aa5168bc$var$getScriptKey(pendingProps), pendingProps = $662d9978aa5168bc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(444, type));
    }
}
function $662d9978aa5168bc$var$getStyleKey(href) {
    return 'href="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $662d9978aa5168bc$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $662d9978aa5168bc$var$stylesheetPropsFromRawProps(rawProps) {
    return $662d9978aa5168bc$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $662d9978aa5168bc$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $662d9978aa5168bc$var$setInitialProperties(key, "link", preloadProps), $662d9978aa5168bc$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $662d9978aa5168bc$var$getScriptKey(src) {
    return '[src="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $662d9978aa5168bc$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $662d9978aa5168bc$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $662d9978aa5168bc$var$markNodeAsHoistable(instance), instance;
            var styleProps = $662d9978aa5168bc$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $662d9978aa5168bc$var$markNodeAsHoistable(instance);
            $662d9978aa5168bc$var$setInitialProperties(instance, "style", styleProps);
            $662d9978aa5168bc$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $662d9978aa5168bc$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $662d9978aa5168bc$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $662d9978aa5168bc$var$stylesheetPropsFromRawProps(props);
            (styleProps = $662d9978aa5168bc$var$preloadPropsMap.get(styleProps)) && $662d9978aa5168bc$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $662d9978aa5168bc$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $662d9978aa5168bc$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $662d9978aa5168bc$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $662d9978aa5168bc$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $662d9978aa5168bc$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $662d9978aa5168bc$var$preloadPropsMap.get(instance$248)) instance = $662d9978aa5168bc$var$assign({}, props), $662d9978aa5168bc$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $662d9978aa5168bc$var$markNodeAsHoistable(styleProps);
            $662d9978aa5168bc$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $662d9978aa5168bc$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $662d9978aa5168bc$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $662d9978aa5168bc$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $662d9978aa5168bc$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $662d9978aa5168bc$var$tagCaches = null;
function $662d9978aa5168bc$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $662d9978aa5168bc$var$tagCaches) {
        var cache = new Map();
        var caches = $662d9978aa5168bc$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $662d9978aa5168bc$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$662d9978aa5168bc$var$internalHoistableMarker] || node[$662d9978aa5168bc$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $662d9978aa5168bc$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $662d9978aa5168bc$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $662d9978aa5168bc$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $662d9978aa5168bc$var$suspendedState = null;
function $662d9978aa5168bc$var$noop() {}
function $662d9978aa5168bc$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $662d9978aa5168bc$var$suspendedState) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(475));
    var state = $662d9978aa5168bc$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $662d9978aa5168bc$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $662d9978aa5168bc$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $662d9978aa5168bc$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $662d9978aa5168bc$var$stylesheetPropsFromRawProps(props);
            (key = $662d9978aa5168bc$var$preloadPropsMap.get(key)) && $662d9978aa5168bc$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $662d9978aa5168bc$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $662d9978aa5168bc$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $662d9978aa5168bc$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $662d9978aa5168bc$var$waitForCommitToBeReady() {
    if (null === $662d9978aa5168bc$var$suspendedState) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(475));
    var state = $662d9978aa5168bc$var$suspendedState;
    state.stylesheets && 0 === state.count && $662d9978aa5168bc$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $662d9978aa5168bc$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $662d9978aa5168bc$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $662d9978aa5168bc$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $662d9978aa5168bc$var$precedencesByRoot = null;
function $662d9978aa5168bc$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $662d9978aa5168bc$var$precedencesByRoot = new Map(), resources.forEach($662d9978aa5168bc$var$insertStylesheetIntoRoot, state), $662d9978aa5168bc$var$precedencesByRoot = null, $662d9978aa5168bc$var$onUnsuspend.call(state));
}
function $662d9978aa5168bc$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $662d9978aa5168bc$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $662d9978aa5168bc$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $662d9978aa5168bc$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $662d9978aa5168bc$var$HostTransitionContext = {
    $$typeof: $662d9978aa5168bc$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $662d9978aa5168bc$var$sharedNotPendingObject,
    _currentValue2: $662d9978aa5168bc$var$sharedNotPendingObject,
    _threadCount: 0
};
function $662d9978aa5168bc$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $662d9978aa5168bc$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $662d9978aa5168bc$var$createLaneMap(0);
    this.hiddenUpdates = $662d9978aa5168bc$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $662d9978aa5168bc$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $662d9978aa5168bc$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $662d9978aa5168bc$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $662d9978aa5168bc$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $662d9978aa5168bc$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $662d9978aa5168bc$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $662d9978aa5168bc$var$emptyContextObject;
    parentComponent = $662d9978aa5168bc$var$emptyContextObject;
    return parentComponent;
}
function $662d9978aa5168bc$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $662d9978aa5168bc$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $662d9978aa5168bc$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $662d9978aa5168bc$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(element, rootFiber, lane), $662d9978aa5168bc$var$entangleTransitions(element, rootFiber, lane));
}
function $662d9978aa5168bc$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $662d9978aa5168bc$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $662d9978aa5168bc$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $662d9978aa5168bc$var$markRetryLaneImpl(fiber, retryLane);
}
function $662d9978aa5168bc$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $662d9978aa5168bc$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $662d9978aa5168bc$var$_enabled = !0;
function $662d9978aa5168bc$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T;
    $662d9978aa5168bc$var$ReactSharedInternals.T = null;
    var previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    try {
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 2, $662d9978aa5168bc$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority, $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $662d9978aa5168bc$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T;
    $662d9978aa5168bc$var$ReactSharedInternals.T = null;
    var previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    try {
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 8, $662d9978aa5168bc$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority, $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $662d9978aa5168bc$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($662d9978aa5168bc$var$_enabled) {
        var blockedOn = $662d9978aa5168bc$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $662d9978aa5168bc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $662d9978aa5168bc$var$return_targetInst, targetContainer), $662d9978aa5168bc$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($662d9978aa5168bc$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($662d9978aa5168bc$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $662d9978aa5168bc$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $662d9978aa5168bc$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $662d9978aa5168bc$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $662d9978aa5168bc$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $662d9978aa5168bc$var$ensureRootIsScheduled(fiber);
                                0 === ($662d9978aa5168bc$var$executionContext & 6) && ($662d9978aa5168bc$var$workInProgressRootRenderTargetTime = $662d9978aa5168bc$var$now() + 500, $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 2), $662d9978aa5168bc$var$flushSyncWork$1(), $662d9978aa5168bc$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $662d9978aa5168bc$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $662d9978aa5168bc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $662d9978aa5168bc$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $662d9978aa5168bc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $662d9978aa5168bc$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $662d9978aa5168bc$var$getEventTarget(nativeEvent);
    return $662d9978aa5168bc$var$findInstanceBlockingTarget(nativeEvent);
}
var $662d9978aa5168bc$var$return_targetInst = null;
function $662d9978aa5168bc$var$findInstanceBlockingTarget(targetNode) {
    $662d9978aa5168bc$var$return_targetInst = null;
    targetNode = $662d9978aa5168bc$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $662d9978aa5168bc$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $662d9978aa5168bc$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $662d9978aa5168bc$var$return_targetInst = targetNode;
    return null;
}
function $662d9978aa5168bc$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($662d9978aa5168bc$var$getCurrentPriorityLevel()){
                case $662d9978aa5168bc$var$ImmediatePriority:
                    return 2;
                case $662d9978aa5168bc$var$UserBlockingPriority:
                    return 8;
                case $662d9978aa5168bc$var$NormalPriority$1:
                case $662d9978aa5168bc$var$LowPriority:
                    return 32;
                case $662d9978aa5168bc$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $662d9978aa5168bc$var$hasScheduledReplayAttempt = !1, $662d9978aa5168bc$var$queuedFocus = null, $662d9978aa5168bc$var$queuedDrag = null, $662d9978aa5168bc$var$queuedMouse = null, $662d9978aa5168bc$var$queuedPointers = new Map(), $662d9978aa5168bc$var$queuedPointerCaptures = new Map(), $662d9978aa5168bc$var$queuedExplicitHydrationTargets = [], $662d9978aa5168bc$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $662d9978aa5168bc$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $662d9978aa5168bc$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $662d9978aa5168bc$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $662d9978aa5168bc$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $662d9978aa5168bc$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $662d9978aa5168bc$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $662d9978aa5168bc$var$getInstanceFromNode(blockedOn), null !== blockedOn && $662d9978aa5168bc$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $662d9978aa5168bc$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $662d9978aa5168bc$var$queuedFocus = $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $662d9978aa5168bc$var$queuedDrag = $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $662d9978aa5168bc$var$queuedMouse = $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $662d9978aa5168bc$var$queuedPointers.set(pointerId, $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $662d9978aa5168bc$var$queuedPointerCaptures.set(pointerId, $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $662d9978aa5168bc$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $662d9978aa5168bc$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $662d9978aa5168bc$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $662d9978aa5168bc$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $662d9978aa5168bc$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $662d9978aa5168bc$var$requestUpdateLane(), root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $662d9978aa5168bc$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $662d9978aa5168bc$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $662d9978aa5168bc$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $662d9978aa5168bc$var$currentReplayingEvent = null;
        } else return targetContainers = $662d9978aa5168bc$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $662d9978aa5168bc$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $662d9978aa5168bc$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $662d9978aa5168bc$var$replayUnblockedEvents() {
    $662d9978aa5168bc$var$hasScheduledReplayAttempt = !1;
    null !== $662d9978aa5168bc$var$queuedFocus && $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent($662d9978aa5168bc$var$queuedFocus) && ($662d9978aa5168bc$var$queuedFocus = null);
    null !== $662d9978aa5168bc$var$queuedDrag && $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent($662d9978aa5168bc$var$queuedDrag) && ($662d9978aa5168bc$var$queuedDrag = null);
    null !== $662d9978aa5168bc$var$queuedMouse && $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent($662d9978aa5168bc$var$queuedMouse) && ($662d9978aa5168bc$var$queuedMouse = null);
    $662d9978aa5168bc$var$queuedPointers.forEach($662d9978aa5168bc$var$attemptReplayContinuousQueuedEventInMap);
    $662d9978aa5168bc$var$queuedPointerCaptures.forEach($662d9978aa5168bc$var$attemptReplayContinuousQueuedEventInMap);
}
function $662d9978aa5168bc$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $662d9978aa5168bc$var$hasScheduledReplayAttempt || ($662d9978aa5168bc$var$hasScheduledReplayAttempt = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $662d9978aa5168bc$var$replayUnblockedEvents)));
}
var $662d9978aa5168bc$var$lastScheduledReplayQueue = null;
function $662d9978aa5168bc$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $662d9978aa5168bc$var$lastScheduledReplayQueue !== formReplayingQueue && ($662d9978aa5168bc$var$lastScheduledReplayQueue = formReplayingQueue, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, function() {
        $662d9978aa5168bc$var$lastScheduledReplayQueue === formReplayingQueue && ($662d9978aa5168bc$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $662d9978aa5168bc$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $662d9978aa5168bc$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $662d9978aa5168bc$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $662d9978aa5168bc$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $662d9978aa5168bc$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $662d9978aa5168bc$var$queuedFocus && $662d9978aa5168bc$var$scheduleCallbackIfUnblocked($662d9978aa5168bc$var$queuedFocus, unblocked);
    null !== $662d9978aa5168bc$var$queuedDrag && $662d9978aa5168bc$var$scheduleCallbackIfUnblocked($662d9978aa5168bc$var$queuedDrag, unblocked);
    null !== $662d9978aa5168bc$var$queuedMouse && $662d9978aa5168bc$var$scheduleCallbackIfUnblocked($662d9978aa5168bc$var$queuedMouse, unblocked);
    $662d9978aa5168bc$var$queuedPointers.forEach(unblock);
    $662d9978aa5168bc$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $662d9978aa5168bc$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $662d9978aa5168bc$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $662d9978aa5168bc$var$queuedExplicitHydrationTargets.length && (i = $662d9978aa5168bc$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$662d9978aa5168bc$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $662d9978aa5168bc$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$662d9978aa5168bc$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $662d9978aa5168bc$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$662d9978aa5168bc$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $662d9978aa5168bc$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $662d9978aa5168bc$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $662d9978aa5168bc$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$662d9978aa5168bc$var$ReactDOMHydrationRoot.prototype.render = $662d9978aa5168bc$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(409));
    var current = root.current, lane = $662d9978aa5168bc$var$requestUpdateLane();
    $662d9978aa5168bc$var$updateContainerImpl(current, lane, children, root, null, null);
};
$662d9978aa5168bc$var$ReactDOMHydrationRoot.prototype.unmount = $662d9978aa5168bc$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $662d9978aa5168bc$var$flushPassiveEffects();
        $662d9978aa5168bc$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $662d9978aa5168bc$var$flushSyncWork$1();
        container[$662d9978aa5168bc$var$internalContainerInstanceKey] = null;
    }
};
function $662d9978aa5168bc$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$662d9978aa5168bc$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $662d9978aa5168bc$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $662d9978aa5168bc$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $662d9978aa5168bc$var$queuedExplicitHydrationTargets[i].priority; i++);
        $662d9978aa5168bc$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $662d9978aa5168bc$var$attemptExplicitHydrationTarget(target);
    }
};
var $662d9978aa5168bc$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $exYeM.version;
if ("19.0.0" !== $662d9978aa5168bc$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(527, $662d9978aa5168bc$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$662d9978aa5168bc$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $662d9978aa5168bc$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $662d9978aa5168bc$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $662d9978aa5168bc$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $662d9978aa5168bc$var$ReactSharedInternals,
    findFiberByHostInstance: $662d9978aa5168bc$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $662d9978aa5168bc$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$662d9978aa5168bc$var$hook$jscomp$inline_2166.isDisabled && $662d9978aa5168bc$var$hook$jscomp$inline_2166.supportsFiber) try {
        $662d9978aa5168bc$var$rendererID = $662d9978aa5168bc$var$hook$jscomp$inline_2166.inject($662d9978aa5168bc$var$internals$jscomp$inline_2165), $662d9978aa5168bc$var$injectedHook = $662d9978aa5168bc$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$662d9978aa5168bc$export$882461b6382ed46c = function(container, options) {
    if (!$662d9978aa5168bc$var$isValidContainer(container)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $662d9978aa5168bc$var$defaultOnUncaughtError, onCaughtError = $662d9978aa5168bc$var$defaultOnCaughtError, onRecoverableError = $662d9978aa5168bc$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $662d9978aa5168bc$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$662d9978aa5168bc$var$internalContainerInstanceKey] = options.current;
    $662d9978aa5168bc$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $662d9978aa5168bc$var$ReactDOMRoot(options);
};
$662d9978aa5168bc$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$662d9978aa5168bc$var$isValidContainer(container)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $662d9978aa5168bc$var$defaultOnUncaughtError, onCaughtError = $662d9978aa5168bc$var$defaultOnCaughtError, onRecoverableError = $662d9978aa5168bc$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $662d9978aa5168bc$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $662d9978aa5168bc$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $662d9978aa5168bc$var$requestUpdateLane();
    identifierPrefix = $662d9978aa5168bc$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $662d9978aa5168bc$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $662d9978aa5168bc$var$markRootUpdated$1(initialChildren, isStrictMode);
    $662d9978aa5168bc$var$ensureRootIsScheduled(initialChildren);
    container[$662d9978aa5168bc$var$internalContainerInstanceKey] = initialChildren.current;
    $662d9978aa5168bc$var$listenToAllSupportedEvents(container);
    return new $662d9978aa5168bc$var$ReactDOMHydrationRoot(initialChildren);
};
$662d9978aa5168bc$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("ibqfJ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8GlMf"));

});
parcelRegister("8GlMf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $65232378122dc16b$export$c4744153514ff05d; }, function (v) { return $65232378122dc16b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $65232378122dc16b$export$3e506c1ccc9cc1a7; }, function (v) { return $65232378122dc16b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $65232378122dc16b$export$e26fe2ed2fa76875; }, function (v) { return $65232378122dc16b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $65232378122dc16b$export$502329bbf4b505b1; }, function (v) { return $65232378122dc16b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $65232378122dc16b$export$6e3807111c4874c4; }, function (v) { return $65232378122dc16b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $65232378122dc16b$export$c27134553091fb3a; }, function (v) { return $65232378122dc16b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $65232378122dc16b$export$33ee1acdc04fd2a2; }, function (v) { return $65232378122dc16b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $65232378122dc16b$export$b00a404bbd5edef2; }, function (v) { return $65232378122dc16b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $65232378122dc16b$export$8352ce38b91d0c62; }, function (v) { return $65232378122dc16b$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $65232378122dc16b$export$d66a1c1c77bd778b; }, function (v) { return $65232378122dc16b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $65232378122dc16b$export$d3dfb8e4810cb555; }, function (v) { return $65232378122dc16b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $65232378122dc16b$export$839f9183b0465a69; }, function (v) { return $65232378122dc16b$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $65232378122dc16b$export$72fdf0e06517287b; }, function (v) { return $65232378122dc16b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $65232378122dc16b$export$4b844e58a3e414b4; }, function (v) { return $65232378122dc16b$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $65232378122dc16b$export$816d2913ae6b83b1; }, function (v) { return $65232378122dc16b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $65232378122dc16b$export$61bcfe829111a1d0; }, function (v) { return $65232378122dc16b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $65232378122dc16b$export$7ee8c9beb337bc3f; }, function (v) { return $65232378122dc16b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $65232378122dc16b$export$b5836b71941fa3ed; }, function (v) { return $65232378122dc16b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $65232378122dc16b$export$cf845f2c119da08a; }, function (v) { return $65232378122dc16b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $65232378122dc16b$export$c4744153514ff05d;
var $65232378122dc16b$export$3e506c1ccc9cc1a7;
var $65232378122dc16b$export$e26fe2ed2fa76875;
var $65232378122dc16b$export$502329bbf4b505b1;
var $65232378122dc16b$export$6e3807111c4874c4;
var $65232378122dc16b$export$c27134553091fb3a;
var $65232378122dc16b$export$33ee1acdc04fd2a2;
var $65232378122dc16b$export$b00a404bbd5edef2;
var $65232378122dc16b$export$8352ce38b91d0c62;
var $65232378122dc16b$export$d66a1c1c77bd778b;
var $65232378122dc16b$export$d3dfb8e4810cb555;
var $65232378122dc16b$export$839f9183b0465a69;
var $65232378122dc16b$export$72fdf0e06517287b;
var $65232378122dc16b$export$4b844e58a3e414b4;
var $65232378122dc16b$export$816d2913ae6b83b1;
var $65232378122dc16b$export$61bcfe829111a1d0;
var $65232378122dc16b$export$7ee8c9beb337bc3f;
var $65232378122dc16b$export$b5836b71941fa3ed;
var $65232378122dc16b$export$cf845f2c119da08a;
"use strict";
function $65232378122dc16b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $65232378122dc16b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $65232378122dc16b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $65232378122dc16b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $65232378122dc16b$var$compare(left, last)) rightIndex < length && 0 > $65232378122dc16b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $65232378122dc16b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $65232378122dc16b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$65232378122dc16b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $65232378122dc16b$var$localPerformance = performance;
    $65232378122dc16b$export$c4744153514ff05d = function() {
        return $65232378122dc16b$var$localPerformance.now();
    };
} else {
    var $65232378122dc16b$var$localDate = Date, $65232378122dc16b$var$initialTime = $65232378122dc16b$var$localDate.now();
    $65232378122dc16b$export$c4744153514ff05d = function() {
        return $65232378122dc16b$var$localDate.now() - $65232378122dc16b$var$initialTime;
    };
}
var $65232378122dc16b$var$taskQueue = [], $65232378122dc16b$var$timerQueue = [], $65232378122dc16b$var$taskIdCounter = 1, $65232378122dc16b$var$currentTask = null, $65232378122dc16b$var$currentPriorityLevel = 3, $65232378122dc16b$var$isPerformingWork = !1, $65232378122dc16b$var$isHostCallbackScheduled = !1, $65232378122dc16b$var$isHostTimeoutScheduled = !1, $65232378122dc16b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $65232378122dc16b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $65232378122dc16b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $65232378122dc16b$var$advanceTimers(currentTime) {
    for(var timer = $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $65232378122dc16b$var$pop($65232378122dc16b$var$timerQueue);
        else if (timer.startTime <= currentTime) $65232378122dc16b$var$pop($65232378122dc16b$var$timerQueue), timer.sortIndex = timer.expirationTime, $65232378122dc16b$var$push($65232378122dc16b$var$taskQueue, timer);
        else break;
        timer = $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue);
    }
}
function $65232378122dc16b$var$handleTimeout(currentTime) {
    $65232378122dc16b$var$isHostTimeoutScheduled = !1;
    $65232378122dc16b$var$advanceTimers(currentTime);
    if (!$65232378122dc16b$var$isHostCallbackScheduled) {
        if (null !== $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue)) $65232378122dc16b$var$isHostCallbackScheduled = !0, $65232378122dc16b$var$requestHostCallback();
        else {
            var firstTimer = $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue);
            null !== firstTimer && $65232378122dc16b$var$requestHostTimeout($65232378122dc16b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $65232378122dc16b$var$isMessageLoopRunning = !1, $65232378122dc16b$var$taskTimeoutID = -1, $65232378122dc16b$var$frameInterval = 5, $65232378122dc16b$var$startTime = -1;
function $65232378122dc16b$var$shouldYieldToHost() {
    return $65232378122dc16b$export$c4744153514ff05d() - $65232378122dc16b$var$startTime < $65232378122dc16b$var$frameInterval ? !1 : !0;
}
function $65232378122dc16b$var$performWorkUntilDeadline() {
    if ($65232378122dc16b$var$isMessageLoopRunning) {
        var currentTime = $65232378122dc16b$export$c4744153514ff05d();
        $65232378122dc16b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $65232378122dc16b$var$isHostCallbackScheduled = !1;
                $65232378122dc16b$var$isHostTimeoutScheduled && ($65232378122dc16b$var$isHostTimeoutScheduled = !1, $65232378122dc16b$var$localClearTimeout($65232378122dc16b$var$taskTimeoutID), $65232378122dc16b$var$taskTimeoutID = -1);
                $65232378122dc16b$var$isPerformingWork = !0;
                var previousPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
                try {
                    b: {
                        $65232378122dc16b$var$advanceTimers(currentTime);
                        for($65232378122dc16b$var$currentTask = $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue); null !== $65232378122dc16b$var$currentTask && !($65232378122dc16b$var$currentTask.expirationTime > currentTime && $65232378122dc16b$var$shouldYieldToHost());){
                            var callback = $65232378122dc16b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $65232378122dc16b$var$currentTask.callback = null;
                                $65232378122dc16b$var$currentPriorityLevel = $65232378122dc16b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($65232378122dc16b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $65232378122dc16b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $65232378122dc16b$var$currentTask.callback = continuationCallback;
                                    $65232378122dc16b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $65232378122dc16b$var$currentTask === $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue) && $65232378122dc16b$var$pop($65232378122dc16b$var$taskQueue);
                                $65232378122dc16b$var$advanceTimers(currentTime);
                            } else $65232378122dc16b$var$pop($65232378122dc16b$var$taskQueue);
                            $65232378122dc16b$var$currentTask = $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue);
                        }
                        if (null !== $65232378122dc16b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue);
                            null !== firstTimer && $65232378122dc16b$var$requestHostTimeout($65232378122dc16b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $65232378122dc16b$var$currentTask = null, $65232378122dc16b$var$currentPriorityLevel = previousPriorityLevel, $65232378122dc16b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $65232378122dc16b$var$schedulePerformWorkUntilDeadline() : $65232378122dc16b$var$isMessageLoopRunning = !1;
        }
    }
}
var $65232378122dc16b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $65232378122dc16b$var$localSetImmediate) $65232378122dc16b$var$schedulePerformWorkUntilDeadline = function() {
    $65232378122dc16b$var$localSetImmediate($65232378122dc16b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $65232378122dc16b$var$channel = new MessageChannel(), $65232378122dc16b$var$port = $65232378122dc16b$var$channel.port2;
    $65232378122dc16b$var$channel.port1.onmessage = $65232378122dc16b$var$performWorkUntilDeadline;
    $65232378122dc16b$var$schedulePerformWorkUntilDeadline = function() {
        $65232378122dc16b$var$port.postMessage(null);
    };
} else $65232378122dc16b$var$schedulePerformWorkUntilDeadline = function() {
    $65232378122dc16b$var$localSetTimeout($65232378122dc16b$var$performWorkUntilDeadline, 0);
};
function $65232378122dc16b$var$requestHostCallback() {
    $65232378122dc16b$var$isMessageLoopRunning || ($65232378122dc16b$var$isMessageLoopRunning = !0, $65232378122dc16b$var$schedulePerformWorkUntilDeadline());
}
function $65232378122dc16b$var$requestHostTimeout(callback, ms) {
    $65232378122dc16b$var$taskTimeoutID = $65232378122dc16b$var$localSetTimeout(function() {
        callback($65232378122dc16b$export$c4744153514ff05d());
    }, ms);
}
$65232378122dc16b$export$3e506c1ccc9cc1a7 = 5;
$65232378122dc16b$export$e26fe2ed2fa76875 = 1;
$65232378122dc16b$export$502329bbf4b505b1 = 4;
$65232378122dc16b$export$6e3807111c4874c4 = 3;
$65232378122dc16b$export$c27134553091fb3a = null;
$65232378122dc16b$export$33ee1acdc04fd2a2 = 2;
$65232378122dc16b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$65232378122dc16b$export$8352ce38b91d0c62 = function() {
    $65232378122dc16b$var$isHostCallbackScheduled || $65232378122dc16b$var$isPerformingWork || ($65232378122dc16b$var$isHostCallbackScheduled = !0, $65232378122dc16b$var$requestHostCallback());
};
$65232378122dc16b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $65232378122dc16b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$65232378122dc16b$export$d3dfb8e4810cb555 = function() {
    return $65232378122dc16b$var$currentPriorityLevel;
};
$65232378122dc16b$export$839f9183b0465a69 = function() {
    return $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue);
};
$65232378122dc16b$export$72fdf0e06517287b = function(eventHandler) {
    switch($65232378122dc16b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $65232378122dc16b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
    $65232378122dc16b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $65232378122dc16b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$65232378122dc16b$export$4b844e58a3e414b4 = function() {};
$65232378122dc16b$export$816d2913ae6b83b1 = function() {};
$65232378122dc16b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
    $65232378122dc16b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $65232378122dc16b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$65232378122dc16b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $65232378122dc16b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $65232378122dc16b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $65232378122dc16b$var$push($65232378122dc16b$var$timerQueue, priorityLevel), null === $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue) && priorityLevel === $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue) && ($65232378122dc16b$var$isHostTimeoutScheduled ? ($65232378122dc16b$var$localClearTimeout($65232378122dc16b$var$taskTimeoutID), $65232378122dc16b$var$taskTimeoutID = -1) : $65232378122dc16b$var$isHostTimeoutScheduled = !0, $65232378122dc16b$var$requestHostTimeout($65232378122dc16b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $65232378122dc16b$var$push($65232378122dc16b$var$taskQueue, priorityLevel), $65232378122dc16b$var$isHostCallbackScheduled || $65232378122dc16b$var$isPerformingWork || ($65232378122dc16b$var$isHostCallbackScheduled = !0, $65232378122dc16b$var$requestHostCallback()));
    return priorityLevel;
};
$65232378122dc16b$export$b5836b71941fa3ed = $65232378122dc16b$var$shouldYieldToHost;
$65232378122dc16b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
        $65232378122dc16b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $65232378122dc16b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("d2lNW", function(module, exports) {
'use strict';
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

module.exports = (parcelRequire("cONs6"));

});
parcelRegister("cONs6", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $955083c1bd0bad05$export$69ce8ef3fe5cead0; }, function (v) { return $955083c1bd0bad05$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $955083c1bd0bad05$export$d39a5bbd09211389; }, function (v) { return $955083c1bd0bad05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $955083c1bd0bad05$export$cd75ccfd720a3cd4; }, function (v) { return $955083c1bd0bad05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $955083c1bd0bad05$export$a0816fa17a9e79be; }, function (v) { return $955083c1bd0bad05$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $955083c1bd0bad05$export$7292efcadded39f3; }, function (v) { return $955083c1bd0bad05$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $955083c1bd0bad05$export$da407abadb9b8f86; }, function (v) { return $955083c1bd0bad05$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $955083c1bd0bad05$export$314cfea32580671c; }, function (v) { return $955083c1bd0bad05$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $955083c1bd0bad05$export$513ccb98c53b8039; }, function (v) { return $955083c1bd0bad05$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $955083c1bd0bad05$export$dbca993bc2d264a; }, function (v) { return $955083c1bd0bad05$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $955083c1bd0bad05$export$4797a8006f0655d0; }, function (v) { return $955083c1bd0bad05$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $955083c1bd0bad05$export$c78a37762a8d58e1; }, function (v) { return $955083c1bd0bad05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $955083c1bd0bad05$export$606f11b2eb45ecc6; }, function (v) { return $955083c1bd0bad05$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $955083c1bd0bad05$export$f7e8a0bf92324b1e; }, function (v) { return $955083c1bd0bad05$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $955083c1bd0bad05$export$83d89fbfd8236492; }, function (v) { return $955083c1bd0bad05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $955083c1bd0bad05$export$69ce8ef3fe5cead0;
var $955083c1bd0bad05$export$d39a5bbd09211389;
var $955083c1bd0bad05$export$cd75ccfd720a3cd4;
var $955083c1bd0bad05$export$a0816fa17a9e79be;
var $955083c1bd0bad05$export$7292efcadded39f3;
var $955083c1bd0bad05$export$da407abadb9b8f86;
var $955083c1bd0bad05$export$314cfea32580671c;
var $955083c1bd0bad05$export$513ccb98c53b8039;
var $955083c1bd0bad05$export$dbca993bc2d264a;
var $955083c1bd0bad05$export$4797a8006f0655d0;
var $955083c1bd0bad05$export$c78a37762a8d58e1;
var $955083c1bd0bad05$export$606f11b2eb45ecc6;
var $955083c1bd0bad05$export$f7e8a0bf92324b1e;
var $955083c1bd0bad05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");
function $955083c1bd0bad05$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $955083c1bd0bad05$var$noop() {}
var $955083c1bd0bad05$var$Internals = {
    d: {
        f: $955083c1bd0bad05$var$noop,
        r: function() {
            throw Error($955083c1bd0bad05$var$formatProdErrorMessage(522));
        },
        D: $955083c1bd0bad05$var$noop,
        C: $955083c1bd0bad05$var$noop,
        L: $955083c1bd0bad05$var$noop,
        m: $955083c1bd0bad05$var$noop,
        X: $955083c1bd0bad05$var$noop,
        S: $955083c1bd0bad05$var$noop,
        M: $955083c1bd0bad05$var$noop
    },
    p: 0,
    findDOMNode: null
}, $955083c1bd0bad05$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $955083c1bd0bad05$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $955083c1bd0bad05$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $955083c1bd0bad05$var$ReactSharedInternals = $exYeM.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $955083c1bd0bad05$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$955083c1bd0bad05$export$69ce8ef3fe5cead0 = $955083c1bd0bad05$var$Internals;
$955083c1bd0bad05$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($955083c1bd0bad05$var$formatProdErrorMessage(299));
    return $955083c1bd0bad05$var$createPortal$1(children, container, null, key);
};
$955083c1bd0bad05$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $955083c1bd0bad05$var$ReactSharedInternals.T, previousUpdatePriority = $955083c1bd0bad05$var$Internals.p;
    try {
        if ($955083c1bd0bad05$var$ReactSharedInternals.T = null, $955083c1bd0bad05$var$Internals.p = 2, fn) return fn();
    } finally{
        $955083c1bd0bad05$var$ReactSharedInternals.T = previousTransition, $955083c1bd0bad05$var$Internals.p = previousUpdatePriority, $955083c1bd0bad05$var$Internals.d.f();
    }
};
$955083c1bd0bad05$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $955083c1bd0bad05$var$Internals.d.C(href, options));
};
$955083c1bd0bad05$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $955083c1bd0bad05$var$Internals.d.D(href);
};
$955083c1bd0bad05$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $955083c1bd0bad05$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $955083c1bd0bad05$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $955083c1bd0bad05$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$955083c1bd0bad05$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $955083c1bd0bad05$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $955083c1bd0bad05$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $955083c1bd0bad05$var$Internals.d.M(href);
    }
};
$955083c1bd0bad05$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $955083c1bd0bad05$var$getCrossOriginStringAs(as, options.crossOrigin);
        $955083c1bd0bad05$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$955083c1bd0bad05$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $955083c1bd0bad05$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $955083c1bd0bad05$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $955083c1bd0bad05$var$Internals.d.m(href);
    }
};
$955083c1bd0bad05$export$4797a8006f0655d0 = function(form) {
    $955083c1bd0bad05$var$Internals.d.r(form);
};
$955083c1bd0bad05$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$955083c1bd0bad05$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $955083c1bd0bad05$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$955083c1bd0bad05$export$f7e8a0bf92324b1e = function() {
    return $955083c1bd0bad05$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$955083c1bd0bad05$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("i5N2N", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return $c5b33ec0dccca72b$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $c5b33ec0dccca72b$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $c5b33ec0dccca72b$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "Route", function () { return $c5b33ec0dccca72b$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $c5b33ec0dccca72b$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "BrowserRouter", function () { return $c5b33ec0dccca72b$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $c5b33ec0dccca72b$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $c5b33ec0dccca72b$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useSearchParams", function () { return $c5b33ec0dccca72b$export$f1a78c17382fe22a; });
/**
 * react-router v7.2.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // lib/router/history.ts

var $exYeM = parcelRequire("exYeM");

var $im7Ii = parcelRequire("im7Ii");

var $9Hd0Q = parcelRequire("9Hd0Q");

var $7oXzj = parcelRequire("7oXzj");
var $c5b33ec0dccca72b$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-HA7DTUK3.mjs"
});
var $c5b33ec0dccca72b$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($c5b33ec0dccca72b$export$e19cd5f9376f8cee || {});
var $c5b33ec0dccca72b$var$PopStateEventType = "popstate";
function $c5b33ec0dccca72b$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $c5b33ec0dccca72b$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $c5b33ec0dccca72b$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $c5b33ec0dccca72b$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $c5b33ec0dccca72b$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $c5b33ec0dccca72b$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $c5b33ec0dccca72b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $c5b33ec0dccca72b$export$fe53371bee54353d(to);
    }
    return $c5b33ec0dccca72b$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $c5b33ec0dccca72b$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $c5b33ec0dccca72b$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $c5b33ec0dccca72b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href2 = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href2 = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href2 + "#" + (typeof to === "string" ? to : $c5b33ec0dccca72b$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $c5b33ec0dccca72b$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $c5b33ec0dccca72b$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $c5b33ec0dccca72b$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $c5b33ec0dccca72b$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $c5b33ec0dccca72b$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $c5b33ec0dccca72b$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $c5b33ec0dccca72b$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $c5b33ec0dccca72b$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $c5b33ec0dccca72b$var$createKey()
    };
    return location;
}
function $c5b33ec0dccca72b$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $c5b33ec0dccca72b$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $c5b33ec0dccca72b$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $c5b33ec0dccca72b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $c5b33ec0dccca72b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $c5b33ec0dccca72b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $c5b33ec0dccca72b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        let base = window2.location.origin !== "null" ? window2.location.origin : window2.location.href;
        let href2 = typeof to === "string" ? to : $c5b33ec0dccca72b$export$fe53371bee54353d(to);
        href2 = href2.replace(/ $/, "%20");
        $c5b33ec0dccca72b$export$f5708dca728d7177(base, `No window.location.(origin|href) available to create URL for href: ${href2}`);
        return new URL(href2, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($c5b33ec0dccca72b$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($c5b33ec0dccca72b$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
// lib/router/utils.ts
var $c5b33ec0dccca72b$var$immutableRouteKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $c5b33ec0dccca72b$var$isIndexRoute(route) {
    return route.index === true;
}
function $c5b33ec0dccca72b$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $c5b33ec0dccca72b$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $c5b33ec0dccca72b$export$f5708dca728d7177(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($c5b33ec0dccca72b$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $c5b33ec0dccca72b$var$convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function $c5b33ec0dccca72b$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $c5b33ec0dccca72b$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $c5b33ec0dccca72b$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $c5b33ec0dccca72b$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $c5b33ec0dccca72b$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $c5b33ec0dccca72b$var$flattenRoutes(routes);
    $c5b33ec0dccca72b$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $c5b33ec0dccca72b$var$decodePath(pathname);
        matches = $c5b33ec0dccca72b$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $c5b33ec0dccca72b$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $c5b33ec0dccca72b$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $c5b33ec0dccca72b$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $c5b33ec0dccca72b$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $c5b33ec0dccca72b$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $c5b33ec0dccca72b$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $c5b33ec0dccca72b$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $c5b33ec0dccca72b$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function $c5b33ec0dccca72b$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $c5b33ec0dccca72b$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $c5b33ec0dccca72b$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $c5b33ec0dccca72b$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $c5b33ec0dccca72b$var$paramRe = /^:[\w-]+$/;
var $c5b33ec0dccca72b$var$dynamicSegmentValue = 3;
var $c5b33ec0dccca72b$var$indexRouteValue = 2;
var $c5b33ec0dccca72b$var$emptySegmentValue = 1;
var $c5b33ec0dccca72b$var$staticSegmentValue = 10;
var $c5b33ec0dccca72b$var$splatPenalty = -2;
var $c5b33ec0dccca72b$var$isSplat = (s)=>s === "*";
function $c5b33ec0dccca72b$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($c5b33ec0dccca72b$var$isSplat)) initialScore += $c5b33ec0dccca72b$var$splatPenalty;
    if (index) initialScore += $c5b33ec0dccca72b$var$indexRouteValue;
    return segments.filter((s)=>!$c5b33ec0dccca72b$var$isSplat(s)).reduce((score, segment)=>score + ($c5b33ec0dccca72b$var$paramRe.test(segment) ? $c5b33ec0dccca72b$var$dynamicSegmentValue : segment === "" ? $c5b33ec0dccca72b$var$emptySegmentValue : $c5b33ec0dccca72b$var$staticSegmentValue), initialScore);
}
function $c5b33ec0dccca72b$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $c5b33ec0dccca72b$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $c5b33ec0dccca72b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $c5b33ec0dccca72b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $c5b33ec0dccca72b$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $c5b33ec0dccca72b$var$normalizePathname($c5b33ec0dccca72b$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $c5b33ec0dccca72b$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $c5b33ec0dccca72b$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $c5b33ec0dccca72b$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $c5b33ec0dccca72b$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $c5b33ec0dccca72b$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $c5b33ec0dccca72b$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $c5b33ec0dccca72b$var$compilePath(path, caseSensitive = false, end = true) {
    $c5b33ec0dccca72b$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $c5b33ec0dccca72b$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $c5b33ec0dccca72b$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $c5b33ec0dccca72b$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $c5b33ec0dccca72b$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $c5b33ec0dccca72b$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $c5b33ec0dccca72b$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $c5b33ec0dccca72b$var$normalizeSearch(search),
        hash: $c5b33ec0dccca72b$var$normalizeHash(hash)
    };
}
function $c5b33ec0dccca72b$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $c5b33ec0dccca72b$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $c5b33ec0dccca72b$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $c5b33ec0dccca72b$var$getResolveToMatches(matches) {
    let pathMatches = $c5b33ec0dccca72b$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $c5b33ec0dccca72b$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $c5b33ec0dccca72b$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $c5b33ec0dccca72b$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $c5b33ec0dccca72b$var$getInvalidPathError("?", "pathname", "search", to));
        $c5b33ec0dccca72b$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $c5b33ec0dccca72b$var$getInvalidPathError("#", "pathname", "hash", to));
        $c5b33ec0dccca72b$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $c5b33ec0dccca72b$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $c5b33ec0dccca72b$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $c5b33ec0dccca72b$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $c5b33ec0dccca72b$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $c5b33ec0dccca72b$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $c5b33ec0dccca72b$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $c5b33ec0dccca72b$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $c5b33ec0dccca72b$export$4051a07651545597(data2, init) {
    return new $c5b33ec0dccca72b$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $c5b33ec0dccca72b$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $c5b33ec0dccca72b$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $c5b33ec0dccca72b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $c5b33ec0dccca72b$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $c5b33ec0dccca72b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $c5b33ec0dccca72b$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $c5b33ec0dccca72b$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $c5b33ec0dccca72b$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $c5b33ec0dccca72b$var$validMutationMethods = new Set($c5b33ec0dccca72b$var$validMutationMethodsArr);
var $c5b33ec0dccca72b$var$validRequestMethodsArr = [
    "GET",
    ...$c5b33ec0dccca72b$var$validMutationMethodsArr
];
var $c5b33ec0dccca72b$var$validRequestMethods = new Set($c5b33ec0dccca72b$var$validRequestMethodsArr);
var $c5b33ec0dccca72b$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $c5b33ec0dccca72b$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $c5b33ec0dccca72b$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $c5b33ec0dccca72b$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $c5b33ec0dccca72b$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $c5b33ec0dccca72b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $c5b33ec0dccca72b$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $c5b33ec0dccca72b$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $c5b33ec0dccca72b$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $c5b33ec0dccca72b$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $c5b33ec0dccca72b$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties2 = init.mapRouteProperties || $c5b33ec0dccca72b$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $c5b33ec0dccca72b$var$convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $c5b33ec0dccca72b$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $c5b33ec0dccca72b$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        let error = $c5b33ec0dccca72b$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $c5b33ec0dccca72b$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active && fogOfWar.matches) {
            initialMatchesIsFOW = true;
            initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
    else {
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$c5b33ec0dccca72b$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$c5b33ec0dccca72b$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $c5b33ec0dccca72b$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $c5b33ec0dccca72b$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $c5b33ec0dccca72b$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $c5b33ec0dccca72b$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$c5b33ec0dccca72b$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $c5b33ec0dccca72b$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $c5b33ec0dccca72b$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $c5b33ec0dccca72b$export$386d57f03f0b2883));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $c5b33ec0dccca72b$var$isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $c5b33ec0dccca72b$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $c5b33ec0dccca72b$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $c5b33ec0dccca72b$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $c5b33ec0dccca72b$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $c5b33ec0dccca72b$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $c5b33ec0dccca72b$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $c5b33ec0dccca72b$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $c5b33ec0dccca72b$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $c5b33ec0dccca72b$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $c5b33ec0dccca72b$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $c5b33ec0dccca72b$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $c5b33ec0dccca72b$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $c5b33ec0dccca72b$var$isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($c5b33ec0dccca72b$var$isErrorResult(result) && $c5b33ec0dccca72b$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $c5b33ec0dccca72b$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $c5b33ec0dccca72b$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$c5b33ec0dccca72b$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, isFogOfWar, opts = {}) {
        interruptActiveLoads();
        let navigation = $c5b33ec0dccca72b$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $c5b33ec0dccca72b$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $c5b33ec0dccca72b$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $c5b33ec0dccca72b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($c5b33ec0dccca72b$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $c5b33ec0dccca72b$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($c5b33ec0dccca72b$var$isErrorResult(result)) {
            let boundaryMatch = $c5b33ec0dccca72b$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $c5b33ec0dccca72b$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $c5b33ec0dccca72b$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $c5b33ec0dccca72b$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $c5b33ec0dccca72b$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $c5b33ec0dccca72b$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$c5b33ec0dccca72b$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $c5b33ec0dccca72b$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $c5b33ec0dccca72b$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $c5b33ec0dccca72b$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$c5b33ec0dccca72b$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $c5b33ec0dccca72b$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href2, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $c5b33ec0dccca72b$var$normalizeTo(state.location, state.matches, basename, href2, routeId, opts?.relative);
        let matches = $c5b33ec0dccca72b$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $c5b33ec0dccca72b$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $c5b33ec0dccca72b$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $c5b33ec0dccca72b$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $c5b33ec0dccca72b$var$isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $c5b33ec0dccca72b$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c5b33ec0dccca72b$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c5b33ec0dccca72b$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c5b33ec0dccca72b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $c5b33ec0dccca72b$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($c5b33ec0dccca72b$var$isRedirectResult(actionResult) || $c5b33ec0dccca72b$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $c5b33ec0dccca72b$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($c5b33ec0dccca72b$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $c5b33ec0dccca72b$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $c5b33ec0dccca72b$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($c5b33ec0dccca72b$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $c5b33ec0dccca72b$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $c5b33ec0dccca72b$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $c5b33ec0dccca72b$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $c5b33ec0dccca72b$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $c5b33ec0dccca72b$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $c5b33ec0dccca72b$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect2 = $c5b33ec0dccca72b$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $c5b33ec0dccca72b$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $c5b33ec0dccca72b$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        if (state.fetchers.has(key)) {
            let doneFetcher = $c5b33ec0dccca72b$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $c5b33ec0dccca72b$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $c5b33ec0dccca72b$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c5b33ec0dccca72b$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c5b33ec0dccca72b$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c5b33ec0dccca72b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $c5b33ec0dccca72b$var$getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $c5b33ec0dccca72b$var$getDoneFetcher(void 0));
            return;
        }
        if ($c5b33ec0dccca72b$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $c5b33ec0dccca72b$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($c5b33ec0dccca72b$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $c5b33ec0dccca72b$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $c5b33ec0dccca72b$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $c5b33ec0dccca72b$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $c5b33ec0dccca72b$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($c5b33ec0dccca72b$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $c5b33ec0dccca72b$var$stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $c5b33ec0dccca72b$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($c5b33ec0dccca72b$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $c5b33ec0dccca72b$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $c5b33ec0dccca72b$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(type, state2, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $c5b33ec0dccca72b$var$callDataStrategyImpl(dataStrategyImpl, type, state2, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2);
        } catch (e) {
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($c5b33ec0dccca72b$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $c5b33ec0dccca72b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $c5b33ec0dccca72b$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state2, matches, matchesToLoad, fetchersToLoad, request) {
        let loaderResultsPromise = callDataStrategy("loader", state2, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state2, $c5b33ec0dccca72b$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $c5b33ec0dccca72b$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $c5b33ec0dccca72b$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $c5b33ec0dccca72b$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $c5b33ec0dccca72b$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $c5b33ec0dccca72b$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $c5b33ec0dccca72b$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $c5b33ec0dccca72b$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $c5b33ec0dccca72b$export$386d57f03f0b2883;
        $c5b33ec0dccca72b$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $c5b33ec0dccca72b$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $c5b33ec0dccca72b$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $c5b33ec0dccca72b$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $c5b33ec0dccca72b$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$c5b33ec0dccca72b$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $c5b33ec0dccca72b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $c5b33ec0dccca72b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $c5b33ec0dccca72b$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $c5b33ec0dccca72b$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $c5b33ec0dccca72b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $c5b33ec0dccca72b$var$convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $c5b33ec0dccca72b$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function $c5b33ec0dccca72b$var$createStaticHandler(routes, opts) {
    $c5b33ec0dccca72b$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $c5b33ec0dccca72b$var$defaultMapRouteProperties;
    let dataRoutes = $c5b33ec0dccca72b$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $c5b33ec0dccca72b$var$createLocation("", $c5b33ec0dccca72b$export$fe53371bee54353d(url), null, "default");
        let matches = $c5b33ec0dccca72b$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$c5b33ec0dccca72b$var$isValidMethod(method) && method !== "HEAD") {
            let error = $c5b33ec0dccca72b$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $c5b33ec0dccca72b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $c5b33ec0dccca72b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $c5b33ec0dccca72b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($c5b33ec0dccca72b$var$isResponse(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $c5b33ec0dccca72b$var$createLocation("", $c5b33ec0dccca72b$export$fe53371bee54353d(url), null, "default");
        let matches = $c5b33ec0dccca72b$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$c5b33ec0dccca72b$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $c5b33ec0dccca72b$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $c5b33ec0dccca72b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $c5b33ec0dccca72b$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $c5b33ec0dccca72b$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $c5b33ec0dccca72b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($c5b33ec0dccca72b$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $c5b33ec0dccca72b$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($c5b33ec0dccca72b$var$isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $c5b33ec0dccca72b$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $c5b33ec0dccca72b$var$isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($c5b33ec0dccca72b$var$isDataStrategyResult(e) && $c5b33ec0dccca72b$var$isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($c5b33ec0dccca72b$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $c5b33ec0dccca72b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $c5b33ec0dccca72b$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($c5b33ec0dccca72b$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($c5b33ec0dccca72b$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($c5b33ec0dccca72b$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $c5b33ec0dccca72b$var$findNearestBoundary(matches, actionMatch.route.id);
            let context2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...context2,
                statusCode: $c5b33ec0dccca72b$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return {
            ...context,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $c5b33ec0dccca72b$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $c5b33ec0dccca72b$var$isErrorResult(pendingActionResult[1]) ? $c5b33ec0dccca72b$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $c5b33ec0dccca72b$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $c5b33ec0dccca72b$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let context = $c5b33ec0dccca72b$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return {
            ...context,
            matches: matches
        };
    }
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $c5b33ec0dccca72b$var$callDataStrategyImpl(dataStrategy || $c5b33ec0dccca72b$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties2, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($c5b33ec0dccca72b$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $c5b33ec0dccca72b$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if ($c5b33ec0dccca72b$var$isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await $c5b33ec0dccca72b$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $c5b33ec0dccca72b$var$getStaticContextFromError(routes, context, error) {
    let newContext = {
        ...context,
        statusCode: $c5b33ec0dccca72b$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    };
    return newContext;
}
function $c5b33ec0dccca72b$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $c5b33ec0dccca72b$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $c5b33ec0dccca72b$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $c5b33ec0dccca72b$var$resolveTo(to ? to : ".", $c5b33ec0dccca72b$var$getResolveToMatches(contextualMatches), $c5b33ec0dccca72b$var$stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $c5b33ec0dccca72b$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $c5b33ec0dccca72b$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $c5b33ec0dccca72b$export$fe53371bee54353d(path);
}
function $c5b33ec0dccca72b$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$c5b33ec0dccca72b$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$c5b33ec0dccca72b$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $c5b33ec0dccca72b$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $c5b33ec0dccca72b$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $c5b33ec0dccca72b$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$c5b33ec0dccca72b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$c5b33ec0dccca72b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $c5b33ec0dccca72b$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $c5b33ec0dccca72b$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $c5b33ec0dccca72b$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $c5b33ec0dccca72b$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $c5b33ec0dccca72b$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($c5b33ec0dccca72b$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $c5b33ec0dccca72b$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $c5b33ec0dccca72b$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $c5b33ec0dccca72b$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $c5b33ec0dccca72b$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary = false) {
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $c5b33ec0dccca72b$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $c5b33ec0dccca72b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let boundaryMatches = matches;
    if (initialHydration && state.errors) boundaryMatches = $c5b33ec0dccca72b$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $c5b33ec0dccca72b$var$isErrorResult(pendingActionResult[1])) boundaryMatches = $c5b33ec0dccca72b$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) return true;
        if (route.loader == null) return false;
        if (initialHydration) return $c5b33ec0dccca72b$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        if ($c5b33ec0dccca72b$var$isNewLoader(state.loaderData, state.matches[index], match)) return true;
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $c5b33ec0dccca72b$var$shouldRevalidateLoader(match, {
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $c5b33ec0dccca72b$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        });
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcherMatches = $c5b33ec0dccca72b$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $c5b33ec0dccca72b$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) shouldRevalidate = isRevalidationRequired;
        else shouldRevalidate = $c5b33ec0dccca72b$var$shouldRevalidateLoader(fetcherMatch, {
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        });
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $c5b33ec0dccca72b$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== void 0;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $c5b33ec0dccca72b$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $c5b33ec0dccca72b$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $c5b33ec0dccca72b$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $c5b33ec0dccca72b$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $c5b33ec0dccca72b$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$c5b33ec0dccca72b$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $c5b33ec0dccca72b$var$convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $c5b33ec0dccca72b$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$c5b33ec0dccca72b$var$isSameRoute(aChild, bChild)));
}
async function $c5b33ec0dccca72b$var$loadLazyRouteModule(route, mapRouteProperties2, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $c5b33ec0dccca72b$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $c5b33ec0dccca72b$var$warning(!isPropertyStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
        if (!isPropertyStaticallyDefined && !$c5b33ec0dccca72b$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    Object.assign(routeToUpdate, routeUpdates);
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided `mapRouteProperties`
        // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
        // since the logic will differ between frameworks.
        ...mapRouteProperties2(routeToUpdate),
        lazy: void 0
    });
}
async function $c5b33ec0dccca72b$var$defaultDataStrategy({ matches: matches }) {
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $c5b33ec0dccca72b$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $c5b33ec0dccca72b$var$loadLazyRouteModule(m.route, mapRouteProperties2, manifest) : void 0);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $c5b33ec0dccca72b$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        };
        return {
            ...match,
            shouldLoad: shouldLoad,
            resolve: resolve
        };
    });
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {}
    return results;
}
async function $c5b33ec0dccca72b$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (loadRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $c5b33ec0dccca72b$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $c5b33ec0dccca72b$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $c5b33ec0dccca72b$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($c5b33ec0dccca72b$var$isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $c5b33ec0dccca72b$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($c5b33ec0dccca72b$var$isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new $c5b33ec0dccca72b$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data),
                statusCode: $c5b33ec0dccca72b$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $c5b33ec0dccca72b$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($c5b33ec0dccca72b$var$isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $c5b33ec0dccca72b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $c5b33ec0dccca72b$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$c5b33ec0dccca72b$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $c5b33ec0dccca72b$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $c5b33ec0dccca72b$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($c5b33ec0dccca72b$var$ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $c5b33ec0dccca72b$var$stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $c5b33ec0dccca72b$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($c5b33ec0dccca72b$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $c5b33ec0dccca72b$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $c5b33ec0dccca72b$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $c5b33ec0dccca72b$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $c5b33ec0dccca72b$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $c5b33ec0dccca72b$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $c5b33ec0dccca72b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $c5b33ec0dccca72b$export$f5708dca728d7177(!$c5b33ec0dccca72b$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($c5b33ec0dccca72b$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $c5b33ec0dccca72b$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $c5b33ec0dccca72b$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $c5b33ec0dccca72b$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $c5b33ec0dccca72b$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $c5b33ec0dccca72b$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $c5b33ec0dccca72b$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if ($c5b33ec0dccca72b$var$isErrorResult(result)) {
            let boundaryMatch = $c5b33ec0dccca72b$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($c5b33ec0dccca72b$var$isRedirectResult(result)) $c5b33ec0dccca72b$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $c5b33ec0dccca72b$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $c5b33ec0dccca72b$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $c5b33ec0dccca72b$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $c5b33ec0dccca72b$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $c5b33ec0dccca72b$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $c5b33ec0dccca72b$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $c5b33ec0dccca72b$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $c5b33ec0dccca72b$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $c5b33ec0dccca72b$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $c5b33ec0dccca72b$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($c5b33ec0dccca72b$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $c5b33ec0dccca72b$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $c5b33ec0dccca72b$export$8ccf933b0513f8d0(path) : path;
    return $c5b33ec0dccca72b$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $c5b33ec0dccca72b$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $c5b33ec0dccca72b$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $c5b33ec0dccca72b$var$isRedirectDataStrategyResult(result) {
    return $c5b33ec0dccca72b$var$isResponse(result.result) && $c5b33ec0dccca72b$var$redirectStatusCodes.has(result.result.status);
}
function $c5b33ec0dccca72b$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $c5b33ec0dccca72b$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $c5b33ec0dccca72b$var$isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $c5b33ec0dccca72b$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $c5b33ec0dccca72b$var$isRedirectStatusCode(statusCode) {
    return $c5b33ec0dccca72b$var$redirectStatusCodes.has(statusCode);
}
function $c5b33ec0dccca72b$var$isRedirectResponse(result) {
    return $c5b33ec0dccca72b$var$isResponse(result) && $c5b33ec0dccca72b$var$isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function $c5b33ec0dccca72b$var$isValidMethod(method) {
    return $c5b33ec0dccca72b$var$validRequestMethods.has(method.toUpperCase());
}
function $c5b33ec0dccca72b$var$isMutationMethod(method) {
    return $c5b33ec0dccca72b$var$validMutationMethods.has(method.toUpperCase());
}
function $c5b33ec0dccca72b$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $c5b33ec0dccca72b$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $c5b33ec0dccca72b$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $c5b33ec0dccca72b$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $c5b33ec0dccca72b$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $c5b33ec0dccca72b$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $c5b33ec0dccca72b$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $c5b33ec0dccca72b$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $c5b33ec0dccca72b$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $c5b33ec0dccca72b$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $c5b33ec0dccca72b$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $c5b33ec0dccca72b$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($c5b33ec0dccca72b$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $c5b33ec0dccca72b$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($c5b33ec0dccca72b$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $c5b33ec0dccca72b$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $c5b33ec0dccca72b$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $c5b33ec0dccca72b$export$2eeee58951ff3c1c = $exYeM.createContext(null);
$c5b33ec0dccca72b$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $c5b33ec0dccca72b$export$315e3ffb01f217 = $exYeM.createContext(null);
$c5b33ec0dccca72b$export$315e3ffb01f217.displayName = "DataRouterState";
var $c5b33ec0dccca72b$export$3681f408decb40d1 = $exYeM.createContext({
    isTransitioning: false
});
$c5b33ec0dccca72b$export$3681f408decb40d1.displayName = "ViewTransition";
var $c5b33ec0dccca72b$export$cb3f1df1bef00a39 = $exYeM.createContext(/* @__PURE__ */ new Map());
$c5b33ec0dccca72b$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $c5b33ec0dccca72b$var$AwaitContext = $exYeM.createContext(null);
$c5b33ec0dccca72b$var$AwaitContext.displayName = "Await";
var $c5b33ec0dccca72b$export$3044ab7fdabeaee6 = $exYeM.createContext(null);
$c5b33ec0dccca72b$export$3044ab7fdabeaee6.displayName = "Navigation";
var $c5b33ec0dccca72b$export$e6a44b110a0c44d3 = $exYeM.createContext(null);
$c5b33ec0dccca72b$export$e6a44b110a0c44d3.displayName = "Location";
var $c5b33ec0dccca72b$export$aac280ed165a4397 = $exYeM.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$c5b33ec0dccca72b$export$aac280ed165a4397.displayName = "Route";
var $c5b33ec0dccca72b$var$RouteErrorContext = $exYeM.createContext(null);
$c5b33ec0dccca72b$var$RouteErrorContext.displayName = "RouteError";
var $c5b33ec0dccca72b$var$ENABLE_DEV_WARNINGS = true;
function $c5b33ec0dccca72b$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $c5b33ec0dccca72b$export$f5708dca728d7177($c5b33ec0dccca72b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator2 } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $c5b33ec0dccca72b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $c5b33ec0dccca72b$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $c5b33ec0dccca72b$export$9c954a9d03d32f4a() {
    return $exYeM.useContext($c5b33ec0dccca72b$export$e6a44b110a0c44d3) != null;
}
function $c5b33ec0dccca72b$export$45d76561a5302f2b() {
    $c5b33ec0dccca72b$export$f5708dca728d7177($c5b33ec0dccca72b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $exYeM.useContext($c5b33ec0dccca72b$export$e6a44b110a0c44d3).location;
}
function $c5b33ec0dccca72b$export$1b3f31771c5d07c() {
    return $exYeM.useContext($c5b33ec0dccca72b$export$e6a44b110a0c44d3).navigationType;
}
function $c5b33ec0dccca72b$export$6c330e8992e8a295(pattern) {
    $c5b33ec0dccca72b$export$f5708dca728d7177($c5b33ec0dccca72b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    return $exYeM.useMemo(()=>$c5b33ec0dccca72b$export$81336c211d5ff295(pattern, $c5b33ec0dccca72b$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $c5b33ec0dccca72b$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $c5b33ec0dccca72b$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6).static;
    if (!isStatic) $exYeM.useLayoutEffect(cb);
}
function $c5b33ec0dccca72b$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397);
    return isDataRoute ? $c5b33ec0dccca72b$var$useNavigateStable() : $c5b33ec0dccca72b$var$useNavigateUnstable();
}
function $c5b33ec0dccca72b$var$useNavigateUnstable() {
    $c5b33ec0dccca72b$export$f5708dca728d7177($c5b33ec0dccca72b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $exYeM.useContext($c5b33ec0dccca72b$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator2 } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    let { matches: matches } = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397);
    let { pathname: locationPathname } = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($c5b33ec0dccca72b$var$getResolveToMatches(matches));
    let activeRef = $exYeM.useRef(false);
    $c5b33ec0dccca72b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback((to, options = {})=>{
        $c5b33ec0dccca72b$var$warning(activeRef.current, $c5b33ec0dccca72b$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator2.go(to);
            return;
        }
        let path = $c5b33ec0dccca72b$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $c5b33ec0dccca72b$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator2.replace : navigator2.push)(path, options.state, options);
    }, [
        basename,
        navigator2,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $c5b33ec0dccca72b$var$OutletContext = $exYeM.createContext(null);
function $c5b33ec0dccca72b$export$4138103a3ae699cc() {
    return $exYeM.useContext($c5b33ec0dccca72b$var$OutletContext);
}
function $c5b33ec0dccca72b$export$a3be3530d8e40d0b(context) {
    let outlet = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $c5b33ec0dccca72b$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $c5b33ec0dccca72b$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397);
    let { pathname: locationPathname } = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($c5b33ec0dccca72b$var$getResolveToMatches(matches));
    return $exYeM.useMemo(()=>$c5b33ec0dccca72b$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $c5b33ec0dccca72b$export$5d3fca4a98652595(routes, locationArg) {
    return $c5b33ec0dccca72b$var$useRoutesImpl(routes, locationArg);
}
function $c5b33ec0dccca72b$var$useRoutesImpl(routes, locationArg, dataRouterState, future) {
    $c5b33ec0dccca72b$export$f5708dca728d7177($c5b33ec0dccca72b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator2, static: isStatic } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($c5b33ec0dccca72b$var$ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        $c5b33ec0dccca72b$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $c5b33ec0dccca72b$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $c5b33ec0dccca72b$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : $c5b33ec0dccca72b$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($c5b33ec0dccca72b$var$ENABLE_DEV_WARNINGS) {
        $c5b33ec0dccca72b$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $c5b33ec0dccca72b$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $c5b33ec0dccca72b$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $c5b33ec0dccca72b$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $c5b33ec0dccca72b$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $c5b33ec0dccca72b$var$DefaultErrorComponent() {
    let error = $c5b33ec0dccca72b$export$ed527bf60f6e05f2();
    let message = $c5b33ec0dccca72b$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($c5b33ec0dccca72b$var$ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, /* @__PURE__ */ $exYeM.createElement("p", null, "\u{1F4BF} Hey developer \u{1F44B}"), /* @__PURE__ */ $exYeM.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $exYeM.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $exYeM.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, /* @__PURE__ */ $exYeM.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $exYeM.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $exYeM.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $c5b33ec0dccca72b$var$defaultErrorElement = /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$DefaultErrorComponent, null);
var $c5b33ec0dccca72b$var$RenderErrorBoundary = class extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $c5b33ec0dccca72b$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $exYeM.useContext($c5b33ec0dccca72b$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $c5b33ec0dccca72b$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $c5b33ec0dccca72b$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $c5b33ec0dccca72b$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $c5b33ec0dccca72b$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $exYeM.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function $c5b33ec0dccca72b$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $c5b33ec0dccca72b$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext($c5b33ec0dccca72b$export$2eeee58951ff3c1c);
    $c5b33ec0dccca72b$export$f5708dca728d7177(ctx, $c5b33ec0dccca72b$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $c5b33ec0dccca72b$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext($c5b33ec0dccca72b$export$315e3ffb01f217);
    $c5b33ec0dccca72b$export$f5708dca728d7177(state, $c5b33ec0dccca72b$var$getDataRouterConsoleError(hookName));
    return state;
}
function $c5b33ec0dccca72b$var$useRouteContext(hookName) {
    let route = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397);
    $c5b33ec0dccca72b$export$f5708dca728d7177(route, $c5b33ec0dccca72b$var$getDataRouterConsoleError(hookName));
    return route;
}
function $c5b33ec0dccca72b$var$useCurrentRouteId(hookName) {
    let route = $c5b33ec0dccca72b$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $c5b33ec0dccca72b$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $c5b33ec0dccca72b$var$useRouteId() {
    return $c5b33ec0dccca72b$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $c5b33ec0dccca72b$export$d0fd4b7106de2769() {
    let state = $c5b33ec0dccca72b$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $c5b33ec0dccca72b$export$600dc272ed516c15() {
    let dataRouterContext = $c5b33ec0dccca72b$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $c5b33ec0dccca72b$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    return $exYeM.useMemo(()=>({
            async revalidate () {
                await dataRouterContext.router.revalidate();
            },
            state: state.revalidation
        }), [
        dataRouterContext.router,
        state.revalidation
    ]);
}
function $c5b33ec0dccca72b$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $c5b33ec0dccca72b$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $exYeM.useMemo(()=>matches.map((m)=>$c5b33ec0dccca72b$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $c5b33ec0dccca72b$export$1448a5050d252c4d() {
    let state = $c5b33ec0dccca72b$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $c5b33ec0dccca72b$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $c5b33ec0dccca72b$export$fd5d37484eab868d(routeId) {
    let state = $c5b33ec0dccca72b$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $c5b33ec0dccca72b$export$fdc00f3f26066d5e() {
    let state = $c5b33ec0dccca72b$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $c5b33ec0dccca72b$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $c5b33ec0dccca72b$export$ed527bf60f6e05f2() {
    let error = $exYeM.useContext($c5b33ec0dccca72b$var$RouteErrorContext);
    let state = $c5b33ec0dccca72b$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $c5b33ec0dccca72b$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $c5b33ec0dccca72b$export$78a72ddb39bdd145() {
    let value = $exYeM.useContext($c5b33ec0dccca72b$var$AwaitContext);
    return value?._data;
}
function $c5b33ec0dccca72b$export$17f53340677d5831() {
    let value = $exYeM.useContext($c5b33ec0dccca72b$var$AwaitContext);
    return value?._error;
}
var $c5b33ec0dccca72b$var$blockerId = 0;
function $c5b33ec0dccca72b$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $c5b33ec0dccca72b$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $c5b33ec0dccca72b$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $exYeM.useState("");
    let blockerFunction = $exYeM.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $c5b33ec0dccca72b$var$stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $c5b33ec0dccca72b$var$stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $exYeM.useEffect(()=>{
        let key = String(++$c5b33ec0dccca72b$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $exYeM.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $c5b33ec0dccca72b$export$386d57f03f0b2883;
}
function $c5b33ec0dccca72b$var$useNavigateStable() {
    let { router: router } = $c5b33ec0dccca72b$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $c5b33ec0dccca72b$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $exYeM.useRef(false);
    $c5b33ec0dccca72b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(async (to, options = {})=>{
        $c5b33ec0dccca72b$var$warning(activeRef.current, $c5b33ec0dccca72b$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $c5b33ec0dccca72b$var$alreadyWarned = {};
function $c5b33ec0dccca72b$var$warningOnce(key, cond, message) {
    if (!cond && !$c5b33ec0dccca72b$var$alreadyWarned[key]) {
        $c5b33ec0dccca72b$var$alreadyWarned[key] = true;
        $c5b33ec0dccca72b$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $c5b33ec0dccca72b$var$alreadyWarned2 = {};
function $c5b33ec0dccca72b$var$warnOnce(condition, message) {
    if (!condition && !$c5b33ec0dccca72b$var$alreadyWarned2[message]) {
        $c5b33ec0dccca72b$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $c5b33ec0dccca72b$var$ENABLE_DEV_WARNINGS2 = true;
function $c5b33ec0dccca72b$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($c5b33ec0dccca72b$var$ENABLE_DEV_WARNINGS2) {
            if (route.element) $c5b33ec0dccca72b$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $exYeM.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($c5b33ec0dccca72b$var$ENABLE_DEV_WARNINGS2) {
            if (route.hydrateFallbackElement) $c5b33ec0dccca72b$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $exYeM.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($c5b33ec0dccca72b$var$ENABLE_DEV_WARNINGS2) {
            if (route.errorElement) $c5b33ec0dccca72b$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $exYeM.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
function $c5b33ec0dccca72b$export$f30f7e456d254e83(routes, opts) {
    return $c5b33ec0dccca72b$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $c5b33ec0dccca72b$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: $c5b33ec0dccca72b$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $c5b33ec0dccca72b$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $c5b33ec0dccca72b$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = $exYeM.useState(router.state);
    let [pendingState, setPendingState] = $exYeM.useState();
    let [vtContext, setVtContext] = $exYeM.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $exYeM.useState();
    let [transition, setTransition] = $exYeM.useState();
    let [interruption, setInterruption] = $exYeM.useState();
    let fetcherData = $exYeM.useRef(/* @__PURE__ */ new Map());
    let setState = $exYeM.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $c5b33ec0dccca72b$var$warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $c5b33ec0dccca72b$var$warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else $exYeM.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $exYeM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $exYeM.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c5b33ec0dccca72b$var$Deferred());
    }, [
        vtContext
    ]);
    $exYeM.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $exYeM.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $exYeM.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $exYeM.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator2 = $exYeM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $exYeM.useMemo(()=>({
            router: router,
            navigator: navigator2,
            static: false,
            basename: basename
        }), [
        router,
        navigator2,
        basename
    ]);
    return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator2
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var $c5b33ec0dccca72b$var$MemoizedDataRoutes = $exYeM.memo($c5b33ec0dccca72b$var$DataRoutes);
function $c5b33ec0dccca72b$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return $c5b33ec0dccca72b$var$useRoutesImpl(routes, void 0, state, future);
}
function $c5b33ec0dccca72b$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = $c5b33ec0dccca72b$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let setState = $exYeM.useCallback((newState)=>{
        $exYeM.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $c5b33ec0dccca72b$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $c5b33ec0dccca72b$export$f5708dca728d7177($c5b33ec0dccca72b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    $c5b33ec0dccca72b$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397);
    let { pathname: locationPathname } = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let navigate = $c5b33ec0dccca72b$export$9770f232ac06a008();
    let path = $c5b33ec0dccca72b$var$resolveTo(to, $c5b33ec0dccca72b$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $exYeM.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $c5b33ec0dccca72b$export$910ae8079b2c2852(props) {
    return $c5b33ec0dccca72b$export$a3be3530d8e40d0b(props.context);
}
function $c5b33ec0dccca72b$export$e7b0ac011bb776c6(_props) {
    $c5b33ec0dccca72b$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $c5b33ec0dccca72b$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator2, static: staticProp = false }) {
    $c5b33ec0dccca72b$export$f5708dca728d7177(!$c5b33ec0dccca72b$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $exYeM.useMemo(()=>({
            basename: basename,
            navigator: navigator2,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator2,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $c5b33ec0dccca72b$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $exYeM.useMemo(()=>{
        let trailingPathname = $c5b33ec0dccca72b$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $c5b33ec0dccca72b$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $c5b33ec0dccca72b$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $c5b33ec0dccca72b$export$5d3fca4a98652595($c5b33ec0dccca72b$export$16da398f5434bdec(children), location);
}
function $c5b33ec0dccca72b$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$ResolveAwait, null, children));
}
var $c5b33ec0dccca72b$var$AwaitErrorBoundary = class extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $c5b33ec0dccca72b$var$ResolveAwait({ children: children }) {
    let data2 = $c5b33ec0dccca72b$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, toRender);
}
function $c5b33ec0dccca72b$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $exYeM.Children.forEach(children, (element, index)=>{
        if (!$exYeM.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $exYeM.Fragment) {
            routes.push.apply(routes, $c5b33ec0dccca72b$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $c5b33ec0dccca72b$export$f5708dca728d7177(element.type === $c5b33ec0dccca72b$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $c5b33ec0dccca72b$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $c5b33ec0dccca72b$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $c5b33ec0dccca72b$export$9b5b6d122dea0c88 = $c5b33ec0dccca72b$export$16da398f5434bdec;
function $c5b33ec0dccca72b$export$daf73786167a7f72(matches) {
    return $c5b33ec0dccca72b$var$_renderMatches(matches);
}
// lib/dom/dom.ts
var $c5b33ec0dccca72b$var$defaultMethod = "get";
var $c5b33ec0dccca72b$var$defaultEncType = "application/x-www-form-urlencoded";
function $c5b33ec0dccca72b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c5b33ec0dccca72b$var$isButtonElement(object) {
    return $c5b33ec0dccca72b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c5b33ec0dccca72b$var$isFormElement(object) {
    return $c5b33ec0dccca72b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c5b33ec0dccca72b$var$isInputElement(object) {
    return $c5b33ec0dccca72b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c5b33ec0dccca72b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c5b33ec0dccca72b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c5b33ec0dccca72b$var$isModifiedEvent(event);
}
function $c5b33ec0dccca72b$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c5b33ec0dccca72b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c5b33ec0dccca72b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $c5b33ec0dccca72b$var$_formDataSupportsSubmitter = null;
function $c5b33ec0dccca72b$var$isFormDataSubmitterSupported() {
    if ($c5b33ec0dccca72b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c5b33ec0dccca72b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c5b33ec0dccca72b$var$_formDataSupportsSubmitter = true;
    }
    return $c5b33ec0dccca72b$var$_formDataSupportsSubmitter;
}
var $c5b33ec0dccca72b$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c5b33ec0dccca72b$var$getFormEncType(encType) {
    if (encType != null && !$c5b33ec0dccca72b$var$supportedFormEncTypes.has(encType)) {
        $c5b33ec0dccca72b$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$c5b33ec0dccca72b$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $c5b33ec0dccca72b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c5b33ec0dccca72b$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $c5b33ec0dccca72b$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || $c5b33ec0dccca72b$var$defaultMethod;
        encType = $c5b33ec0dccca72b$var$getFormEncType(target.getAttribute("enctype")) || $c5b33ec0dccca72b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c5b33ec0dccca72b$var$isButtonElement(target) || $c5b33ec0dccca72b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $c5b33ec0dccca72b$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c5b33ec0dccca72b$var$defaultMethod;
        encType = $c5b33ec0dccca72b$var$getFormEncType(target.getAttribute("formenctype")) || $c5b33ec0dccca72b$var$getFormEncType(form.getAttribute("enctype")) || $c5b33ec0dccca72b$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$c5b33ec0dccca72b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c5b33ec0dccca72b$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $c5b33ec0dccca72b$var$defaultMethod;
        action = null;
        encType = $c5b33ec0dccca72b$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// lib/dom/ssr/invariant.ts
function $c5b33ec0dccca72b$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function $c5b33ec0dccca72b$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $c5b33ec0dccca72b$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $c5b33ec0dccca72b$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href2)=>({
                    rel: "stylesheet",
                    href: href2
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $c5b33ec0dccca72b$var$getModuleLinkHrefs(matches, manifest);
    return $c5b33ec0dccca72b$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $c5b33ec0dccca72b$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href2)=>({
            rel: "stylesheet",
            href: href2
        }));
}
async function $c5b33ec0dccca72b$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $c5b33ec0dccca72b$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($c5b33ec0dccca72b$var$prefetchStyleLink));
}
async function $c5b33ec0dccca72b$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$c5b33ec0dccca72b$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$c5b33ec0dccca72b$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$c5b33ec0dccca72b$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($c5b33ec0dccca72b$var$prefetchStyleLink));
}
async function $c5b33ec0dccca72b$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $c5b33ec0dccca72b$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $c5b33ec0dccca72b$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $c5b33ec0dccca72b$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $c5b33ec0dccca72b$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $c5b33ec0dccca72b$var$dedupeLinkDescriptors(links.flat(1).filter($c5b33ec0dccca72b$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $c5b33ec0dccca72b$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $c5b33ec0dccca72b$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $c5b33ec0dccca72b$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $c5b33ec0dccca72b$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $c5b33ec0dccca72b$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $c5b33ec0dccca72b$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$c5b33ec0dccca72b$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($c5b33ec0dccca72b$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $c5b33ec0dccca72b$var$_isPreloadSupported;
function $c5b33ec0dccca72b$var$isPreloadSupported() {
    if ($c5b33ec0dccca72b$var$_isPreloadSupported !== void 0) return $c5b33ec0dccca72b$var$_isPreloadSupported;
    let el = document.createElement("link");
    $c5b33ec0dccca72b$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $c5b33ec0dccca72b$var$_isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var $c5b33ec0dccca72b$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $c5b33ec0dccca72b$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $c5b33ec0dccca72b$var$escapeHtml(html) {
    return html.replace($c5b33ec0dccca72b$var$ESCAPE_REGEX, (match)=>$c5b33ec0dccca72b$var$ESCAPE_LOOKUP[match]);
}
function $c5b33ec0dccca72b$var$createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/data.ts
async function $c5b33ec0dccca72b$var$createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var $c5b33ec0dccca72b$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
function $c5b33ec0dccca72b$var$StreamTransfer({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $exYeM.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$c5b33ec0dccca72b$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, scriptTag, /* @__PURE__ */ $exYeM.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, scriptTag, /* @__PURE__ */ $exYeM.createElement($exYeM.Suspense, null, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $c5b33ec0dccca72b$export$c7c51be9b423c4d6(manifest, routeModules, ssr, getRouter) {
    return async ({ request: request, matches: matches, fetcherKey: fetcherKey })=>{
        if (request.method !== "GET") return $c5b33ec0dccca72b$var$singleFetchActionStrategy(request, matches);
        if (!ssr) {
            let foundRevalidatingServerLoader = matches.some((m)=>m.shouldLoad && manifest.routes[m.route.id]?.hasLoader && !manifest.routes[m.route.id]?.hasClientLoader);
            if (!foundRevalidatingServerLoader) {
                let matchesToLoad = matches.filter((m)=>m.shouldLoad);
                let url = $c5b33ec0dccca72b$var$stripIndexParam($c5b33ec0dccca72b$var$singleFetchUrl(request.url));
                let init = await $c5b33ec0dccca72b$var$createRequestInit(request);
                let results = {};
                await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
                        try {
                            let result = manifest.routes[m.route.id]?.hasClientLoader ? await $c5b33ec0dccca72b$var$fetchSingleLoader(handler, url, init, m.route.id) : await handler();
                            results[m.route.id] = {
                                type: "data",
                                result: result
                            };
                        } catch (e) {
                            results[m.route.id] = {
                                type: "error",
                                result: e
                            };
                        }
                    })));
                return results;
            }
        }
        if (fetcherKey) return $c5b33ec0dccca72b$var$singleFetchLoaderFetcherStrategy(request, matches);
        return $c5b33ec0dccca72b$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, ssr, getRouter(), request, matches);
    };
}
async function $c5b33ec0dccca72b$var$singleFetchActionStrategy(request, matches) {
    let actionMatch = matches.find((m)=>m.shouldLoad);
    $c5b33ec0dccca72b$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let url = $c5b33ec0dccca72b$var$singleFetchUrl(request.url);
            let init = await $c5b33ec0dccca72b$var$createRequestInit(request);
            let { data: data2, status: status } = await $c5b33ec0dccca72b$var$fetchAndDecode(url, init);
            actionStatus = status;
            return $c5b33ec0dccca72b$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($c5b33ec0dccca72b$var$isResponse(result.result) || $c5b33ec0dccca72b$export$972111febbeef05b(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $c5b33ec0dccca72b$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $c5b33ec0dccca72b$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, ssr, router, request, matches) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = matches.map(()=>$c5b33ec0dccca72b$var$createDeferred2());
    let routesLoadedPromise = Promise.all(routeDfds.map((d)=>d.promise));
    let singleFetchDfd = $c5b33ec0dccca72b$var$createDeferred2();
    let url = $c5b33ec0dccca72b$var$stripIndexParam($c5b33ec0dccca72b$var$singleFetchUrl(request.url));
    let init = await $c5b33ec0dccca72b$var$createRequestInit(request);
    let results = {};
    let resolvePromise = Promise.all(matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let manifestRoute = manifest.routes[m.route.id];
            if (!m.shouldLoad) {
                if (!router.state.initialized) return;
                if (m.route.id in router.state.loaderData && manifestRoute && manifestRoute.hasLoader && routeModules[m.route.id]?.shouldRevalidate) {
                    foundOptOutRoute = true;
                    return;
                }
            }
            if (manifestRoute && manifestRoute.hasClientLoader) {
                if (manifestRoute.hasLoader) foundOptOutRoute = true;
                try {
                    let result = await $c5b33ec0dccca72b$var$fetchSingleLoader(handler, url, init, m.route.id);
                    results[m.route.id] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[m.route.id] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (manifestRoute && manifestRoute.hasLoader) routesParams.add(m.route.id);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $c5b33ec0dccca72b$var$unwrapSingleFetchResults(data2, m.route.id);
                });
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await routesLoadedPromise;
    if ((!router.state.initialized || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({});
    else try {
        if (ssr && foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", matches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        let data2 = await $c5b33ec0dccca72b$var$fetchAndDecode(url, init);
        singleFetchDfd.resolve(data2.data);
    } catch (e) {
        singleFetchDfd.reject(e);
    }
    await resolvePromise;
    return results;
}
async function $c5b33ec0dccca72b$var$singleFetchLoaderFetcherStrategy(request, matches) {
    let fetcherMatch = matches.find((m)=>m.shouldLoad);
    $c5b33ec0dccca72b$var$invariant2(fetcherMatch, "No fetcher match found");
    let result = await fetcherMatch.resolve(async (handler)=>{
        let url = $c5b33ec0dccca72b$var$stripIndexParam($c5b33ec0dccca72b$var$singleFetchUrl(request.url));
        let init = await $c5b33ec0dccca72b$var$createRequestInit(request);
        return $c5b33ec0dccca72b$var$fetchSingleLoader(handler, url, init, fetcherMatch.route.id);
    });
    return {
        [fetcherMatch.route.id]: result
    };
}
function $c5b33ec0dccca72b$var$fetchSingleLoader(handler, url, init, routeId) {
    return handler(async ()=>{
        let singleLoaderUrl = new URL(url);
        singleLoaderUrl.searchParams.set("_routes", routeId);
        let { data: data2 } = await $c5b33ec0dccca72b$var$fetchAndDecode(singleLoaderUrl, init);
        return $c5b33ec0dccca72b$var$unwrapSingleFetchResults(data2, routeId);
    });
}
function $c5b33ec0dccca72b$var$stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $c5b33ec0dccca72b$var$singleFetchUrl(reqUrl) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function $c5b33ec0dccca72b$var$fetchAndDecode(url, init) {
    let res = await fetch(url, init);
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $c5b33ec0dccca72b$export$f2680fa305b734ca(404, "Not Found", true);
    const NO_BODY_STATUS_CODES2 = /* @__PURE__ */ new Set([
        100,
        101,
        204,
        205
    ]);
    if (NO_BODY_STATUS_CODES2.has(res.status)) {
        if (!init.method || init.method === "GET") return {
            status: res.status,
            data: {}
        };
        else return {
            status: res.status,
            data: {
                data: void 0
            }
        };
    }
    $c5b33ec0dccca72b$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $c5b33ec0dccca72b$export$4023ad4ecd4126a2(res.body, window);
        return {
            status: res.status,
            data: decoded.value
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $c5b33ec0dccca72b$export$4023ad4ecd4126a2(body, global2) {
    return (0, $im7Ii.decode)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $c5b33ec0dccca72b$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$c5b33ec0dccca72b$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $c5b33ec0dccca72b$var$unwrapSingleFetchResults(results, routeId) {
    let redirect2 = results[$c5b33ec0dccca72b$export$60644022b8b46aaa];
    if (redirect2) return $c5b33ec0dccca72b$var$unwrapSingleFetchResult(redirect2, routeId);
    return results[routeId] !== void 0 ? $c5b33ec0dccca72b$var$unwrapSingleFetchResult(results[routeId], routeId) : null;
}
function $c5b33ec0dccca72b$var$unwrapSingleFetchResult(result, routeId) {
    if ("error" in result) throw result.error;
    else if ("redirect" in result) {
        let headers = {};
        if (result.revalidate) headers["X-Remix-Revalidate"] = "yes";
        if (result.reload) headers["X-Remix-Reload-Document"] = "yes";
        if (result.replace) headers["X-Remix-Replace"] = "yes";
        throw $c5b33ec0dccca72b$export$89e12c5b50f7529d(result.redirect, {
            status: result.status,
            headers: headers
        });
    } else if ("data" in result) return result.data;
    else throw new Error(`No response found for routeId "${routeId}"`);
}
function $c5b33ec0dccca72b$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $c5b33ec0dccca72b$export$32e57f52df4b6e34 = class extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $c5b33ec0dccca72b$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $exYeM.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."
        );
      `
        }
    });
    if ($c5b33ec0dccca72b$export$972111febbeef05b(error)) return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $exYeM.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), heyDeveloper);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $exYeM.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $exYeM.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $c5b33ec0dccca72b$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $c5b33ec0dccca72b$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $exYeM.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $exYeM.createElement("head", null, /* @__PURE__ */ $exYeM.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $exYeM.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $exYeM.createElement("title", null, title)), /* @__PURE__ */ $exYeM.createElement("body", null, /* @__PURE__ */ $exYeM.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$ff0bf87698939488, null) : null)));
}
function $c5b33ec0dccca72b$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, /* @__PURE__ */ $exYeM.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://remix.run/route/hydrate-fallback " +
                "for more information."
              );
            `
        }
    }));
}
// lib/dom/ssr/routes.tsx
function $c5b33ec0dccca72b$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $c5b33ec0dccca72b$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $c5b33ec0dccca72b$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $c5b33ec0dccca72b$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$RemixRootDefaultErrorBoundary, {
            error: $c5b33ec0dccca72b$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $exYeM.createElement(routeModule.Layout, null, /* @__PURE__ */ $exYeM.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $exYeM.createElement(routeModule.Layout, null, /* @__PURE__ */ $exYeM.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $exYeM.createElement(routeModule.Layout, null, /* @__PURE__ */ $exYeM.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $c5b33ec0dccca72b$var$createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $c5b33ec0dccca72b$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $c5b33ec0dccca72b$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$c5b33ec0dccca72b$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $c5b33ec0dccca72b$var$createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $c5b33ec0dccca72b$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $c5b33ec0dccca72b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $c5b33ec0dccca72b$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $c5b33ec0dccca72b$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $c5b33ec0dccca72b$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $c5b33ec0dccca72b$var$noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $c5b33ec0dccca72b$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $c5b33ec0dccca72b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $c5b33ec0dccca72b$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $c5b33ec0dccca72b$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $c5b33ec0dccca72b$var$noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $c5b33ec0dccca72b$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$c5b33ec0dccca72b$var$getRouteComponents(route, routeModule, isSpaMode),
                handle: routeModule.handle,
                shouldRevalidate: $c5b33ec0dccca72b$var$getShouldRevalidateFunction(routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $c5b33ec0dccca72b$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            async serverLoader () {
                                $c5b33ec0dccca72b$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $c5b33ec0dccca72b$export$6ac68922d4e92125(route, routeModule, isSpaMode);
            dataRoute.action = ({ request: request, params: params }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $c5b33ec0dccca72b$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $c5b33ec0dccca72b$var$noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        async serverAction () {
                            $c5b33ec0dccca72b$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            else if (route.clientLoaderModule) dataRoute.loader = async (args, singleFetch)=>{
                $c5b33ec0dccca72b$var$invariant2(route.clientLoaderModule);
                let { clientLoader: clientLoader } = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule);
                return clientLoader({
                    ...args,
                    async serverLoader () {
                        $c5b33ec0dccca72b$var$preventInvalidServerHandlerCall("loader", route);
                        return fetchServerLoader(singleFetch);
                    }
                });
            };
            if (!route.hasClientAction) dataRoute.action = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $c5b33ec0dccca72b$var$noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            else if (route.clientActionModule) dataRoute.action = async (args, singleFetch)=>{
                $c5b33ec0dccca72b$var$invariant2(route.clientActionModule);
                prefetchRouteModuleChunks(route);
                let { clientAction: clientAction } = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule);
                return clientAction({
                    ...args,
                    async serverAction () {
                        $c5b33ec0dccca72b$var$preventInvalidServerHandlerCall("action", route);
                        return fetchServerAction(singleFetch);
                    }
                });
            };
            dataRoute.lazy = async ()=>{
                if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                let modPromise = $c5b33ec0dccca72b$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                prefetchRouteModuleChunks(route);
                let mod = await modPromise;
                let lazyRoute = {
                    ...mod
                };
                if (mod.clientLoader) {
                    let clientLoader = mod.clientLoader;
                    lazyRoute.loader = (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $c5b33ec0dccca72b$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                }
                if (mod.clientAction) {
                    let clientAction = mod.clientAction;
                    lazyRoute.action = (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $c5b33ec0dccca72b$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                }
                return {
                    ...lazyRoute.loader ? {
                        loader: lazyRoute.loader
                    } : {},
                    ...lazyRoute.action ? {
                        action: lazyRoute.action
                    } : {},
                    hasErrorBoundary: lazyRoute.hasErrorBoundary,
                    shouldRevalidate: $c5b33ec0dccca72b$var$getShouldRevalidateFunction(lazyRoute, route, ssr, needsRevalidation),
                    handle: lazyRoute.handle,
                    // No need to wrap these in layout since the root route is never
                    // loaded via route.lazy()
                    Component: lazyRoute.Component,
                    ErrorBoundary: lazyRoute.ErrorBoundary
                };
            };
        }
        let children = $c5b33ec0dccca72b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $c5b33ec0dccca72b$var$getShouldRevalidateFunction(route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $c5b33ec0dccca72b$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: false
                });
        } else return ()=>false;
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $c5b33ec0dccca72b$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $c5b33ec0dccca72b$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $c5b33ec0dccca72b$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $c5b33ec0dccca72b$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $c5b33ec0dccca72b$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $c5b33ec0dccca72b$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $c5b33ec0dccca72b$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $c5b33ec0dccca72b$export$6ac68922d4e92125(route, routeModule, isSpaMode) {
    return isSpaMode && route.id !== "root" || routeModule.clientLoader != null && (routeModule.clientLoader.hydrate === true || route.hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $c5b33ec0dccca72b$var$nextPaths = /* @__PURE__ */ new Set();
var $c5b33ec0dccca72b$var$discoveredPathsMaxSize = 1e3;
var $c5b33ec0dccca72b$var$discoveredPaths = /* @__PURE__ */ new Set();
var $c5b33ec0dccca72b$var$URL_LIMIT = 7680;
function $c5b33ec0dccca72b$var$isFogOfWarEnabled(ssr) {
    return ssr === true;
}
function $c5b33ec0dccca72b$var$getPartialManifest(manifest, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $c5b33ec0dccca72b$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes
    };
}
function $c5b33ec0dccca72b$export$72ab377a1030deb9(manifest, routeModules, ssr, isSpaMode, basename) {
    if (!$c5b33ec0dccca72b$var$isFogOfWarEnabled(ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal })=>{
        if ($c5b33ec0dccca72b$var$discoveredPaths.has(path)) return;
        await $c5b33ec0dccca72b$var$fetchAndApplyManifestPatches([
            path
        ], manifest, routeModules, ssr, isSpaMode, basename, patch, signal);
    };
}
function $c5b33ec0dccca72b$export$5ef046b23d96090d(router, manifest, routeModules, ssr, isSpaMode) {
    $exYeM.useEffect(()=>{
        if (!$c5b33ec0dccca72b$var$isFogOfWarEnabled(ssr) || navigator.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$c5b33ec0dccca72b$var$discoveredPaths.has(pathname)) $c5b33ec0dccca72b$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($c5b33ec0dccca72b$var$nextPaths.keys()).filter((path)=>{
                if ($c5b33ec0dccca72b$var$discoveredPaths.has(path)) {
                    $c5b33ec0dccca72b$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $c5b33ec0dccca72b$var$fetchAndApplyManifestPatches(lazyPaths, manifest, routeModules, ssr, isSpaMode, router.basename, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $c5b33ec0dccca72b$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router
    ]);
}
async function $c5b33ec0dccca72b$var$fetchAndApplyManifestPatches(paths, manifest, routeModules, ssr, isSpaMode, basename, patchRoutes, signal) {
    let manifestPath = `${basename != null ? basename : "/"}/__manifest`.replace(/\/+/g, "/");
    let url = new URL(manifestPath, window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > $c5b33ec0dccca72b$var$URL_LIMIT) {
        $c5b33ec0dccca72b$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status >= 400) throw new Error(await res.text());
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$c5b33ec0dccca72b$var$addToFifoQueue(p, $c5b33ec0dccca72b$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $c5b33ec0dccca72b$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $c5b33ec0dccca72b$var$addToFifoQueue(path, queue) {
    if (queue.size >= $c5b33ec0dccca72b$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $c5b33ec0dccca72b$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $c5b33ec0dccca72b$var$useDataRouterContext2() {
    let context = $exYeM.useContext($c5b33ec0dccca72b$export$2eeee58951ff3c1c);
    $c5b33ec0dccca72b$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $c5b33ec0dccca72b$var$useDataRouterStateContext() {
    let context = $exYeM.useContext($c5b33ec0dccca72b$export$315e3ffb01f217);
    $c5b33ec0dccca72b$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $c5b33ec0dccca72b$export$208d6a3bc3aa62bd = $exYeM.createContext(void 0);
$c5b33ec0dccca72b$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $c5b33ec0dccca72b$var$useFrameworkContext() {
    let context = $exYeM.useContext($c5b33ec0dccca72b$export$208d6a3bc3aa62bd);
    $c5b33ec0dccca72b$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $c5b33ec0dccca72b$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $exYeM.useContext($c5b33ec0dccca72b$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $exYeM.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $exYeM.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $exYeM.useRef(null);
    $exYeM.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $exYeM.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $c5b33ec0dccca72b$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $c5b33ec0dccca72b$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $c5b33ec0dccca72b$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $c5b33ec0dccca72b$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $c5b33ec0dccca72b$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $c5b33ec0dccca72b$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $c5b33ec0dccca72b$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$c5b33ec0dccca72b$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function $c5b33ec0dccca72b$export$b2e089eb3692b073() {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $c5b33ec0dccca72b$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $c5b33ec0dccca72b$var$useDataRouterStateContext();
    let matches = $c5b33ec0dccca72b$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $exYeM.useMemo(()=>$c5b33ec0dccca72b$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, criticalCss ? /* @__PURE__ */ $exYeM.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, keyedLinks.map(({ key: key, link: link })=>$c5b33ec0dccca72b$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$60dcec93e67386bd, {
            key: key,
            ...link
        }) : /* @__PURE__ */ $exYeM.createElement("link", {
            key: key,
            ...link
        })));
}
function $c5b33ec0dccca72b$export$60dcec93e67386bd({ page: page, ...dataLinkProps }) {
    let { router: router } = $c5b33ec0dccca72b$var$useDataRouterContext2();
    let matches = $exYeM.useMemo(()=>$c5b33ec0dccca72b$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...dataLinkProps
    });
}
function $c5b33ec0dccca72b$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $c5b33ec0dccca72b$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $exYeM.useState([]);
    $exYeM.useEffect(()=>{
        let interrupted = false;
        $c5b33ec0dccca72b$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $c5b33ec0dccca72b$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $c5b33ec0dccca72b$var$useFrameworkContext();
    let { loaderData: loaderData, matches: matches } = $c5b33ec0dccca72b$var$useDataRouterStateContext();
    let newMatchesForData = $exYeM.useMemo(()=>$c5b33ec0dccca72b$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $exYeM.useMemo(()=>$c5b33ec0dccca72b$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $exYeM.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $c5b33ec0dccca72b$var$singleFetchUrl(page);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $exYeM.useMemo(()=>$c5b33ec0dccca72b$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $c5b33ec0dccca72b$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, dataHrefs.map((href2)=>/* @__PURE__ */ $exYeM.createElement("link", {
            key: href2,
            rel: "prefetch",
            as: "fetch",
            href: href2,
            ...linkProps
        })), moduleHrefs.map((href2)=>/* @__PURE__ */ $exYeM.createElement("link", {
            key: href2,
            rel: "modulepreload",
            href: href2,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $exYeM.createElement("link", {
            key: key,
            ...link
        })));
}
function $c5b33ec0dccca72b$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $c5b33ec0dccca72b$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $c5b33ec0dccca72b$var$useDataRouterStateContext();
    let location = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let _matches = $c5b33ec0dccca72b$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$c5b33ec0dccca72b$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $exYeM.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $exYeM.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $exYeM.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $exYeM.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $exYeM.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $c5b33ec0dccca72b$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $c5b33ec0dccca72b$var$isHydrated = false;
function $c5b33ec0dccca72b$export$ff0bf87698939488(props) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, ssr: ssr, renderMeta: renderMeta } = $c5b33ec0dccca72b$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $c5b33ec0dccca72b$var$useDataRouterContext2();
    let { matches: routerMatches } = $c5b33ec0dccca72b$var$useDataRouterStateContext();
    let enableFogOfWar = $c5b33ec0dccca72b$var$isFogOfWarEnabled(ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $c5b33ec0dccca72b$var$getActiveMatches(routerMatches, null, isSpaMode);
    $exYeM.useEffect(()=>{
        $c5b33ec0dccca72b$var$isHydrated = true;
    }, []);
    let initialScripts = $exYeM.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $c5b33ec0dccca72b$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($c5b33ec0dccca72b$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, /* @__PURE__ */ $exYeM.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $c5b33ec0dccca72b$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $exYeM.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $c5b33ec0dccca72b$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $c5b33ec0dccca72b$var$isHydrated ? [] : manifest.entry.imports.concat($c5b33ec0dccca72b$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    }));
    return $c5b33ec0dccca72b$var$isHydrated ? null : /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, !enableFogOfWar ? /* @__PURE__ */ $exYeM.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin
    }) : null, /* @__PURE__ */ $exYeM.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin
    }), $c5b33ec0dccca72b$var$dedupe(preloads).map((path)=>/* @__PURE__ */ $exYeM.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin
        })), initialScripts);
}
function $c5b33ec0dccca72b$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $c5b33ec0dccca72b$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var $c5b33ec0dccca72b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($c5b33ec0dccca72b$var$isBrowser) window.__reactRouterVersion = "7.2.0";
} catch (e) {}
function $c5b33ec0dccca72b$export$1f3f55432a00e06d(routes, opts) {
    return $c5b33ec0dccca72b$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $c5b33ec0dccca72b$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $c5b33ec0dccca72b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $c5b33ec0dccca72b$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $c5b33ec0dccca72b$export$1ba7ed8a3a7b3765(routes, opts) {
    return $c5b33ec0dccca72b$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $c5b33ec0dccca72b$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $c5b33ec0dccca72b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $c5b33ec0dccca72b$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $c5b33ec0dccca72b$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $c5b33ec0dccca72b$var$deserializeErrors(state.errors)
    };
    return state;
}
function $c5b33ec0dccca72b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $c5b33ec0dccca72b$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $c5b33ec0dccca72b$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = $c5b33ec0dccca72b$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let setState = $exYeM.useCallback((newState)=>{
        $exYeM.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $c5b33ec0dccca72b$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = $c5b33ec0dccca72b$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let setState = $exYeM.useCallback((newState)=>{
        $exYeM.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $c5b33ec0dccca72b$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let setState = $exYeM.useCallback((newState)=>{
        $exYeM.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$c5b33ec0dccca72b$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $c5b33ec0dccca72b$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $c5b33ec0dccca72b$export$a6c7ac8248d6e38a = $exYeM.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $c5b33ec0dccca72b$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($c5b33ec0dccca72b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $c5b33ec0dccca72b$var$stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $c5b33ec0dccca72b$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href2 = $c5b33ec0dccca72b$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $c5b33ec0dccca72b$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $c5b33ec0dccca72b$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $exYeM.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href2,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $c5b33ec0dccca72b$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, link, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$60dcec93e67386bd, {
        page: href2
    })) : link;
});
$c5b33ec0dccca72b$export$a6c7ac8248d6e38a.displayName = "Link";
var $c5b33ec0dccca72b$export$b0d92dbee9b5b60d = $exYeM.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $c5b33ec0dccca72b$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let routerState = $exYeM.useContext($c5b33ec0dccca72b$export$315e3ffb01f217);
    let { navigator: navigator2, basename: basename } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c5b33ec0dccca72b$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $c5b33ec0dccca72b$var$stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$c5b33ec0dccca72b$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $c5b33ec0dccca72b$export$a7fed597f4b8afd8 = $exYeM.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $c5b33ec0dccca72b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $c5b33ec0dccca72b$export$47c85c6e3a081d3();
    let formAction = $c5b33ec0dccca72b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $c5b33ec0dccca72b$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $exYeM.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$c5b33ec0dccca72b$export$a7fed597f4b8afd8.displayName = "Form";
function $c5b33ec0dccca72b$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $exYeM.useContext($c5b33ec0dccca72b$export$208d6a3bc3aa62bd);
    let { basename: basename } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    let location = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let matches = $c5b33ec0dccca72b$export$2378eb7f5ff86053();
    $c5b33ec0dccca72b$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $exYeM.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $c5b33ec0dccca72b$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $exYeM.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $c5b33ec0dccca72b$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$c5b33ec0dccca72b$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $c5b33ec0dccca72b$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $c5b33ec0dccca72b$var$useDataRouterContext3(hookName) {
    let ctx = $exYeM.useContext($c5b33ec0dccca72b$export$2eeee58951ff3c1c);
    $c5b33ec0dccca72b$export$f5708dca728d7177(ctx, $c5b33ec0dccca72b$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $c5b33ec0dccca72b$var$useDataRouterState2(hookName) {
    let state = $exYeM.useContext($c5b33ec0dccca72b$export$315e3ffb01f217);
    $c5b33ec0dccca72b$export$f5708dca728d7177(state, $c5b33ec0dccca72b$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $c5b33ec0dccca72b$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $c5b33ec0dccca72b$export$9770f232ac06a008();
    let location = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let path = $c5b33ec0dccca72b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $exYeM.useCallback((event)=>{
        if ($c5b33ec0dccca72b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $c5b33ec0dccca72b$export$fe53371bee54353d(location) === $c5b33ec0dccca72b$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $c5b33ec0dccca72b$export$f1a78c17382fe22a(defaultInit) {
    $c5b33ec0dccca72b$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $exYeM.useRef($c5b33ec0dccca72b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $exYeM.useRef(false);
    let location = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let searchParams = $exYeM.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c5b33ec0dccca72b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $c5b33ec0dccca72b$export$9770f232ac06a008();
    let setSearchParams = $exYeM.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c5b33ec0dccca72b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $c5b33ec0dccca72b$var$fetcherId = 0;
var $c5b33ec0dccca72b$var$getUniqueFetcherId = ()=>`__${String(++$c5b33ec0dccca72b$var$fetcherId)}__`;
function $c5b33ec0dccca72b$export$47c85c6e3a081d3() {
    let { router: router } = $c5b33ec0dccca72b$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    let currentRouteId = $c5b33ec0dccca72b$var$useRouteId();
    return $exYeM.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c5b33ec0dccca72b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c5b33ec0dccca72b$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $c5b33ec0dccca72b$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    let routeContext = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397);
    $c5b33ec0dccca72b$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$c5b33ec0dccca72b$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $c5b33ec0dccca72b$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $c5b33ec0dccca72b$export$fe53371bee54353d(path);
}
function $c5b33ec0dccca72b$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $c5b33ec0dccca72b$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $c5b33ec0dccca72b$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $exYeM.useContext($c5b33ec0dccca72b$export$cb3f1df1bef00a39);
    let route = $exYeM.useContext($c5b33ec0dccca72b$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $c5b33ec0dccca72b$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $c5b33ec0dccca72b$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $c5b33ec0dccca72b$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $exYeM.useId();
    let [fetcherKey, setFetcherKey] = $exYeM.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $exYeM.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $exYeM.useCallback(async (href2, opts)=>{
        $c5b33ec0dccca72b$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href2, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $c5b33ec0dccca72b$export$47c85c6e3a081d3();
    let submit = $exYeM.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $exYeM.useMemo(()=>{
        let FetcherForm2 = $exYeM.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $c5b33ec0dccca72b$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $exYeM.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $c5b33ec0dccca72b$export$fa996778a3a31087() {
    let state = $c5b33ec0dccca72b$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $c5b33ec0dccca72b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $c5b33ec0dccca72b$var$savedScrollPositions = {};
function $c5b33ec0dccca72b$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $c5b33ec0dccca72b$var$stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $c5b33ec0dccca72b$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $c5b33ec0dccca72b$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c5b33ec0dccca72b$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $exYeM.useContext($c5b33ec0dccca72b$export$3044ab7fdabeaee6);
    let location = $c5b33ec0dccca72b$export$45d76561a5302f2b();
    let matches = $c5b33ec0dccca72b$export$2378eb7f5ff86053();
    let navigation = $c5b33ec0dccca72b$export$d0fd4b7106de2769();
    $exYeM.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $c5b33ec0dccca72b$var$usePageHide($exYeM.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $c5b33ec0dccca72b$var$getScrollRestorationKey(location, matches, basename, getKey);
            $c5b33ec0dccca72b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c5b33ec0dccca72b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c5b33ec0dccca72b$var$savedScrollPositions));
        } catch (error) {
            $c5b33ec0dccca72b$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $exYeM.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c5b33ec0dccca72b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c5b33ec0dccca72b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $exYeM.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($c5b33ec0dccca72b$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$c5b33ec0dccca72b$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $exYeM.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $c5b33ec0dccca72b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $c5b33ec0dccca72b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $c5b33ec0dccca72b$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $c5b33ec0dccca72b$export$b273b3273281a049(when);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $c5b33ec0dccca72b$export$e262bd1977bea848(to, opts = {}) {
    let vtContext = $exYeM.useContext($c5b33ec0dccca72b$export$3681f408decb40d1);
    $c5b33ec0dccca72b$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $c5b33ec0dccca72b$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $c5b33ec0dccca72b$export$e75d2a2d1b3c245b(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $c5b33ec0dccca72b$var$stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $c5b33ec0dccca72b$var$stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $c5b33ec0dccca72b$export$81336c211d5ff295(path.pathname, nextPath) != null || $c5b33ec0dccca72b$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $c5b33ec0dccca72b$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $c5b33ec0dccca72b$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $c5b33ec0dccca72b$var$getStatelessNavigator();
    return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $c5b33ec0dccca72b$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate = true, nonce: nonce }) {
    $c5b33ec0dccca72b$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $c5b33ec0dccca72b$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $c5b33ec0dccca72b$var$serializeErrors(context.errors)
        };
        let json = $c5b33ec0dccca72b$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $exYeM.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $c5b33ec0dccca72b$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $c5b33ec0dccca72b$var$useRoutesImpl(routes, void 0, state, future);
}
function $c5b33ec0dccca72b$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($c5b33ec0dccca72b$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $c5b33ec0dccca72b$var$getStatelessNavigator() {
    return {
        createHref: $c5b33ec0dccca72b$var$createHref,
        encodeLocation: $c5b33ec0dccca72b$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $c5b33ec0dccca72b$export$3336b097a6fbc59a(routes, opts) {
    return $c5b33ec0dccca72b$var$createStaticHandler(routes, {
        ...opts,
        mapRouteProperties: $c5b33ec0dccca72b$export$9269a41d8c4635e
    });
}
function $c5b33ec0dccca72b$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $c5b33ec0dccca72b$var$convertRoutesToDataRoutes(routes, $c5b33ec0dccca72b$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $c5b33ec0dccca72b$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $c5b33ec0dccca72b$var$createHref,
        encodeLocation: $c5b33ec0dccca72b$var$encodeLocation,
        getFetcher () {
            return $c5b33ec0dccca72b$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $c5b33ec0dccca72b$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function $c5b33ec0dccca72b$var$createHref(to) {
    return typeof to === "string" ? to : $c5b33ec0dccca72b$export$fe53371bee54353d(to);
}
function $c5b33ec0dccca72b$var$encodeLocation(to) {
    let href2 = typeof to === "string" ? to : $c5b33ec0dccca72b$export$fe53371bee54353d(to);
    href2 = href2.replace(/ $/, "%20");
    let encoded = $c5b33ec0dccca72b$var$ABSOLUTE_URL_REGEX3.test(href2) ? new URL(href2) : new URL(href2, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $c5b33ec0dccca72b$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $c5b33ec0dccca72b$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $c5b33ec0dccca72b$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $c5b33ec0dccca72b$var$htmlEscape(str) {
    return str.replace($c5b33ec0dccca72b$var$ESCAPE_REGEX2, (match)=>$c5b33ec0dccca72b$var$ESCAPE_LOOKUP2[match]);
}
function $c5b33ec0dccca72b$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = $c5b33ec0dccca72b$var$createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && $c5b33ec0dccca72b$export$6ac68922d4e92125(manifestRoute, route, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = $c5b33ec0dccca72b$export$3dd6171c30258b6f(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$208d6a3bc3aa62bd.Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$32e57f52df4b6e34, {
        location: router.state.location
    }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$3d80f15952491985, {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $exYeM.createElement($exYeM.Suspense, null, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$var$StreamTransfer, {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $c5b33ec0dccca72b$export$bea31554c7dfd2ad(routes, context = {}) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $exYeM.useRef();
        let remixContextRef = $exYeM.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {},
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false
            };
            let patched = $c5b33ec0dccca72b$var$processRoutes(// @ts-expect-error loader/action context types don't match :/
            $c5b33ec0dccca72b$var$convertRoutesToDataRoutes(routes, (r)=>r), context, remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = $c5b33ec0dccca72b$export$f30f7e456d254e83(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$208d6a3bc3aa62bd.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ $exYeM.createElement($c5b33ec0dccca72b$export$323e4fc2fa4753fb, {
            router: routerRef.current
        }));
    };
}
function $c5b33ec0dccca72b$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let { loader: loader, action: action } = route;
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component,
            HydrateFallback: route.HydrateFallback,
            ErrorBoundary: route.ErrorBoundary,
            action: action ? (args)=>action({
                    ...args,
                    context: context
                }) : void 0,
            loader: loader ? (args)=>loader({
                    ...args,
                    context: context
                }) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should just be stubbing loader/action, not
            // trying to re-implement the full loader/clientLoader/SSR/hydration flow.
            // That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: route.Component || $c5b33ec0dccca72b$export$910ae8079b2c2852,
            ErrorBoundary: route.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $c5b33ec0dccca72b$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $c5b33ec0dccca72b$var$encoder = new TextEncoder();
var $c5b33ec0dccca72b$var$sign = async (value, secret)=>{
    let data2 = $c5b33ec0dccca72b$var$encoder.encode(value);
    let key = await $c5b33ec0dccca72b$var$createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $c5b33ec0dccca72b$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $c5b33ec0dccca72b$var$encoder.encode(value);
    let key = await $c5b33ec0dccca72b$var$createKey2(secret, [
        "verify"
    ]);
    let signature = $c5b33ec0dccca72b$var$byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var $c5b33ec0dccca72b$var$createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", $c5b33ec0dccca72b$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $c5b33ec0dccca72b$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $c5b33ec0dccca72b$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $c5b33ec0dccca72b$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $9Hd0Q.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $c5b33ec0dccca72b$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $9Hd0Q.serialize)(name, value === "" ? "" : await $c5b33ec0dccca72b$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $c5b33ec0dccca72b$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $c5b33ec0dccca72b$var$encodeCookieValue(value, secrets) {
    let encoded = $c5b33ec0dccca72b$var$encodeData(value);
    if (secrets.length > 0) encoded = await $c5b33ec0dccca72b$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $c5b33ec0dccca72b$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $c5b33ec0dccca72b$var$unsign(value, secret);
            if (unsignedValue !== false) return $c5b33ec0dccca72b$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $c5b33ec0dccca72b$var$decodeData(value);
}
function $c5b33ec0dccca72b$var$encodeData(value) {
    return btoa($c5b33ec0dccca72b$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $c5b33ec0dccca72b$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($c5b33ec0dccca72b$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $c5b33ec0dccca72b$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $c5b33ec0dccca72b$var$hex(code, 2);
            else result += "%u" + $c5b33ec0dccca72b$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $c5b33ec0dccca72b$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $c5b33ec0dccca72b$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $c5b33ec0dccca72b$var$warnOnceAboutExpiresCookie(name, expires) {
    $c5b33ec0dccca72b$var$warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $c5b33ec0dccca72b$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var $c5b33ec0dccca72b$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($c5b33ec0dccca72b$export$e7973f87fd96e4f2 || {});
function $c5b33ec0dccca72b$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $c5b33ec0dccca72b$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $c5b33ec0dccca72b$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $c5b33ec0dccca72b$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $c5b33ec0dccca72b$var$serializeError(error, serverMode) {
    let sanitized = $c5b33ec0dccca72b$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $c5b33ec0dccca72b$var$serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($c5b33ec0dccca72b$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $c5b33ec0dccca72b$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $c5b33ec0dccca72b$var$matchServerRoutes(routes, pathname, basename) {
    let matches = $c5b33ec0dccca72b$export$2708184779ceb39d(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $c5b33ec0dccca72b$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $c5b33ec0dccca72b$var$stripRoutesParam($c5b33ec0dccca72b$var$stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if ($c5b33ec0dccca72b$var$isDataWithResponseInit(result) && result.init && result.init.status && $c5b33ec0dccca72b$var$isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $c5b33ec0dccca72b$var$stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $c5b33ec0dccca72b$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $c5b33ec0dccca72b$var$invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routes.ts
function $c5b33ec0dccca72b$var$groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $c5b33ec0dccca72b$var$createRoutes(manifest, parentId = "", routesByParentId = $c5b33ec0dccca72b$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $c5b33ec0dccca72b$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $c5b33ec0dccca72b$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $c5b33ec0dccca72b$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                if (args.request.headers.has("X-React-Router-Prerender-Data")) {
                    const preRenderedData = args.request.headers.get("X-React-Router-Prerender-Data");
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $c5b33ec0dccca72b$var$invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await $c5b33ec0dccca72b$export$4023ad4ecd4126a2(stream, $parcel$global);
                    let data2 = decoded.value;
                    $c5b33ec0dccca72b$var$invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                    let result = data2[route.id];
                    $c5b33ec0dccca72b$var$invariant3("data" in result, "Unable to process prerendered data");
                    return result.data;
                }
                let val = await $c5b33ec0dccca72b$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$c5b33ec0dccca72b$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $c5b33ec0dccca72b$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var $c5b33ec0dccca72b$var$ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $c5b33ec0dccca72b$var$ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function $c5b33ec0dccca72b$var$escapeHtml2(html) {
    return html.replace($c5b33ec0dccca72b$var$ESCAPE_REGEX3, (match)=>$c5b33ec0dccca72b$var$ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function $c5b33ec0dccca72b$var$createServerHandoffString(serverHandoff) {
    return $c5b33ec0dccca72b$var$escapeHtml2(JSON.stringify(serverHandoff));
}
// lib/server-runtime/dev.ts
var $c5b33ec0dccca72b$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $c5b33ec0dccca72b$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$c5b33ec0dccca72b$var$globalDevServerHooksKey] = devServerHooks;
}
function $c5b33ec0dccca72b$var$getDevServerHooks() {
    return globalThis[$c5b33ec0dccca72b$var$globalDevServerHooksKey];
}
function $c5b33ec0dccca72b$var$getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let route = build.routes[id];
        $c5b33ec0dccca72b$var$invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $c5b33ec0dccca72b$var$prependCookies(errorHeaders, headers2);
            $c5b33ec0dccca72b$var$prependCookies(actionHeaders, headers2);
            $c5b33ec0dccca72b$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) $c5b33ec0dccca72b$var$prependCookies(errorHeaders, headers);
        $c5b33ec0dccca72b$var$prependCookies(actionHeaders, headers);
        $c5b33ec0dccca72b$var$prependCookies(loaderHeaders, headers);
        $c5b33ec0dccca72b$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function $c5b33ec0dccca72b$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $7oXzj.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var $c5b33ec0dccca72b$var$SINGLE_FETCH_REDIRECT_STATUS = 202;
function $c5b33ec0dccca72b$var$getSingleFetchDataStrategy2({ isActionDataRequest: isActionDataRequest, loadRouteIds: loadRouteIds } = {}) {
    return async ({ request: request, matches: matches })=>{
        if (isActionDataRequest && request.method === "GET") return {};
        let matchesToLoad = loadRouteIds ? matches.filter((m)=>loadRouteIds.includes(m.route.id)) : matches;
        let results = await Promise.all(matchesToLoad.map((match)=>match.resolve()));
        return results.reduce((acc, result, i)=>Object.assign(acc, {
                [matchesToLoad[i].route.id]: result
            }), {});
    };
}
async function $c5b33ec0dccca72b$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $c5b33ec0dccca72b$var$getSingleFetchDataStrategy2({
                isActionDataRequest: true
            })
        });
        if ($c5b33ec0dccca72b$var$isResponse(result)) return {
            result: $c5b33ec0dccca72b$var$getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: $c5b33ec0dccca72b$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $c5b33ec0dccca72b$var$getDocumentHeaders(build, context);
        if ($c5b33ec0dccca72b$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: $c5b33ec0dccca72b$var$getSingleFetchRedirect(context.statusCode, headers, build.basename),
            headers: headers,
            status: $c5b33ec0dccca72b$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$c5b33ec0dccca72b$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $c5b33ec0dccca72b$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        };
    }
}
async function $c5b33ec0dccca72b$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let loadRouteIds = new URL(request.url).searchParams.get("_routes")?.split(",") || void 0;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $c5b33ec0dccca72b$var$getSingleFetchDataStrategy2({
                loadRouteIds: loadRouteIds
            })
        });
        if ($c5b33ec0dccca72b$var$isResponse(result)) return {
            result: {
                [$c5b33ec0dccca72b$export$60644022b8b46aaa]: $c5b33ec0dccca72b$var$getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: $c5b33ec0dccca72b$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $c5b33ec0dccca72b$var$getDocumentHeaders(build, context);
        if ($c5b33ec0dccca72b$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: {
                [$c5b33ec0dccca72b$export$60644022b8b46aaa]: $c5b33ec0dccca72b$var$getSingleFetchRedirect(context.statusCode, headers, build.basename)
            },
            headers: headers,
            status: $c5b33ec0dccca72b$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$c5b33ec0dccca72b$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $c5b33ec0dccca72b$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = loadRouteIds ? context.matches.filter((m)=>m.route.loader && loadRouteIds.includes(m.route.id)) : context.matches;
        loadedMatches.forEach((m)=>{
            let { id: id } = m.route;
            if (context.errors && context.errors.hasOwnProperty(id)) results[id] = {
                error: context.errors[id]
            };
            else if (context.loaderData.hasOwnProperty(id)) results[id] = {
                data: context.loaderData[id]
            };
        });
        return {
            result: results,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                root: {
                    error: error
                }
            },
            headers: new Headers(),
            status: 500
        };
    }
}
function $c5b33ec0dccca72b$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = $c5b33ec0dccca72b$var$stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $c5b33ec0dccca72b$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, $im7Ii.encode)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $c5b33ec0dccca72b$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof $c5b33ec0dccca72b$export$f2680fa305b734ca) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && $c5b33ec0dccca72b$export$60644022b8b46aaa in value) return [
                    "SingleFetchRedirect",
                    value[$c5b33ec0dccca72b$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
var $c5b33ec0dccca72b$var$NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205,
    304
]);
function $c5b33ec0dccca72b$var$derive(build, mode) {
    let routes = $c5b33ec0dccca72b$var$createRoutes(build.routes);
    let dataRoutes = $c5b33ec0dccca72b$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $c5b33ec0dccca72b$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = $c5b33ec0dccca72b$var$createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        $c5b33ec0dccca72b$export$972111febbeef05b(error) && error.error ? error.error : error);
    });
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler
    };
}
var $c5b33ec0dccca72b$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, loadContext = {}) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $c5b33ec0dccca72b$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = $c5b33ec0dccca72b$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let url = new URL(request.url);
        let normalizedPath = url.pathname.replace(/\.data$/, "").replace(/^\/_root$/, "/");
        if (normalizedPath !== "/" && normalizedPath.endsWith("/")) normalizedPath = normalizedPath.slice(0, -1);
        let params = {};
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $c5b33ec0dccca72b$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        if (!_build.ssr) {
            if (_build.prerender.length === 0) request.headers.set("X-React-Router-SPA-Mode", "yes");
            else if (!_build.prerender.includes(normalizedPath) && !_build.prerender.includes(normalizedPath + "/")) {
                if (url.pathname.endsWith(".data")) {
                    errorHandler(new $c5b33ec0dccca72b$export$f2680fa305b734ca(404, "Not Found", `Refusing to SSR the path \`${normalizedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else request.headers.set("X-React-Router-SPA-Mode", "yes");
            }
        }
        let manifestUrl = `${_build.basename ?? "/"}/__manifest`.replace(/\/+/g, "/");
        if (url.pathname === manifestUrl) try {
            let res = await $c5b33ec0dccca72b$var$handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $c5b33ec0dccca72b$var$matchServerRoutes(routes, url.pathname, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = normalizedPath;
            let singleFetchMatches = $c5b33ec0dccca72b$var$matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await $c5b33ec0dccca72b$var$handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ($c5b33ec0dccca72b$var$isRedirectResponse(response)) {
                    let result = $c5b33ec0dccca72b$var$getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [$c5b33ec0dccca72b$export$60644022b8b46aaa]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response($c5b33ec0dccca72b$var$encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: $c5b33ec0dccca72b$var$SINGLE_FETCH_REDIRECT_STATUS,
                        headers: headers
                    });
                }
            }
        } else if (matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $c5b33ec0dccca72b$var$handleResourceRequest(serverMode, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let criticalCss = mode === "development" /* Development */  ? await $c5b33ec0dccca72b$var$getDevServerHooks()?.getCriticalCss?.(_build, url.pathname) : void 0;
            response = await $c5b33ec0dccca72b$var$handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function $c5b33ec0dccca72b$var$handleManifestRequest(build, routes, url) {
    let patches = {};
    if (url.searchParams.has("p")) {
        for (let path of url.searchParams.getAll("p")){
            let matches = $c5b33ec0dccca72b$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $c5b33ec0dccca72b$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let { result: result, headers: headers, status: status } = request.method !== "GET" ? await $c5b33ec0dccca72b$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $c5b33ec0dccca72b$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if ($c5b33ec0dccca72b$var$NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status: status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response($c5b33ec0dccca72b$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
async function $c5b33ec0dccca72b$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
    let isSpaMode = request.headers.has("X-React-Router-SPA-Mode");
    let context;
    try {
        context = await staticHandler.query(request, {
            requestContext: loadContext
        });
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    if ($c5b33ec0dccca72b$var$isResponse(context)) return context;
    let headers = $c5b33ec0dccca72b$var$getDocumentHeaders(build, context);
    if ($c5b33ec0dccca72b$var$NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
        status: context.statusCode,
        headers: headers
    });
    if (context.errors) {
        Object.values(context.errors).forEach((err)=>{
            if (!$c5b33ec0dccca72b$export$972111febbeef05b(err) || err.error) handleError(err);
        });
        context.errors = $c5b33ec0dccca72b$var$sanitizeErrors(context.errors, serverMode);
    }
    let state = {
        loaderData: context.loaderData,
        actionData: context.actionData,
        errors: $c5b33ec0dccca72b$var$serializeErrors2(context.errors, serverMode)
    };
    let entryContext = {
        manifest: build.assets,
        routeModules: $c5b33ec0dccca72b$var$createEntryRouteModules(build.routes),
        staticHandlerContext: context,
        criticalCss: criticalCss,
        serverHandoffString: $c5b33ec0dccca72b$var$createServerHandoffString({
            basename: build.basename,
            criticalCss: criticalCss,
            future: build.future,
            ssr: build.ssr,
            isSpaMode: isSpaMode
        }),
        serverHandoffStream: $c5b33ec0dccca72b$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
        renderMeta: {},
        future: build.future,
        ssr: build.ssr,
        isSpaMode: isSpaMode,
        serializeError: (err)=>$c5b33ec0dccca72b$var$serializeError(err, serverMode)
    };
    let handleDocumentRequestFunction = build.entry.module.default;
    try {
        return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
    } catch (error) {
        handleError(error);
        let errorForSecondRender = error;
        if ($c5b33ec0dccca72b$var$isResponse(error)) try {
            let data2 = await $c5b33ec0dccca72b$var$unwrapResponse(error);
            errorForSecondRender = new $c5b33ec0dccca72b$export$f2680fa305b734ca(error.status, error.statusText, data2);
        } catch (e) {}
        context = $c5b33ec0dccca72b$var$getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
        if (context.errors) context.errors = $c5b33ec0dccca72b$var$sanitizeErrors(context.errors, serverMode);
        let state2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $c5b33ec0dccca72b$var$serializeErrors2(context.errors, serverMode)
        };
        entryContext = {
            ...entryContext,
            staticHandlerContext: context,
            serverHandoffString: $c5b33ec0dccca72b$var$createServerHandoffString({
                basename: build.basename,
                future: build.future,
                ssr: build.ssr,
                isSpaMode: isSpaMode
            }),
            serverHandoffStream: $c5b33ec0dccca72b$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {}
        };
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error2) {
            handleError(error2);
            return $c5b33ec0dccca72b$var$returnLastResortErrorResponse(error2, serverMode);
        }
    }
}
async function $c5b33ec0dccca72b$var$handleResourceRequest(serverMode, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext
        });
        if ($c5b33ec0dccca72b$var$isResponse(response)) return response;
        if (typeof response === "string") return new Response(response);
        return Response.json(response);
    } catch (error) {
        if ($c5b33ec0dccca72b$var$isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if ($c5b33ec0dccca72b$export$972111febbeef05b(error)) {
            if (error) handleError(error);
            return $c5b33ec0dccca72b$var$errorResponseToJson(error, serverMode);
        }
        handleError(error);
        return $c5b33ec0dccca72b$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $c5b33ec0dccca72b$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($c5b33ec0dccca72b$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function $c5b33ec0dccca72b$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $c5b33ec0dccca72b$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $c5b33ec0dccca72b$var$flash(name) {
    return `__flash_${name}__`;
}
var $c5b33ec0dccca72b$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($c5b33ec0dccca72b$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $c5b33ec0dccca72b$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($c5b33ec0dccca72b$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $c5b33ec0dccca72b$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $c5b33ec0dccca72b$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $c5b33ec0dccca72b$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $c5b33ec0dccca72b$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $c5b33ec0dccca72b$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $c5b33ec0dccca72b$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $c5b33ec0dccca72b$var$warnOnceAboutSigningSessionCookie(cookie) {
    $c5b33ec0dccca72b$var$warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://remix.run/utils/cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $c5b33ec0dccca72b$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $c5b33ec0dccca72b$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $c5b33ec0dccca72b$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $c5b33ec0dccca72b$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $c5b33ec0dccca72b$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $c5b33ec0dccca72b$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $c5b33ec0dccca72b$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function $c5b33ec0dccca72b$export$8f51af5840e0602a(path, ...args) {
    let params = args[0];
    return path.split("/").map((segment)=>{
        const match = segment.match(/^:([\w-]+)(\?)?/);
        if (!match) return segment;
        const param = match[1];
        const value = params ? params[param] : void 0;
        const isRequired = match[2] === void 0;
        if (isRequired && value === void 0) throw Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value;
    }).filter((segment)=>segment !== void 0).join("/");
}
// lib/dom/ssr/errors.ts
function $c5b33ec0dccca72b$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $c5b33ec0dccca72b$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}

});
parcelRegister("im7Ii", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $c514e3d30b567925$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encode", function () { return $c514e3d30b567925$export$c564cdbbe6da493; });
// src/utils.ts
var $c514e3d30b567925$var$HOLE = -1;
var $c514e3d30b567925$var$NAN = -2;
var $c514e3d30b567925$var$NEGATIVE_INFINITY = -3;
var $c514e3d30b567925$var$NEGATIVE_ZERO = -4;
var $c514e3d30b567925$var$NULL = -5;
var $c514e3d30b567925$var$POSITIVE_INFINITY = -6;
var $c514e3d30b567925$var$UNDEFINED = -7;
var $c514e3d30b567925$var$TYPE_BIGINT = "B";
var $c514e3d30b567925$var$TYPE_DATE = "D";
var $c514e3d30b567925$var$TYPE_ERROR = "E";
var $c514e3d30b567925$var$TYPE_MAP = "M";
var $c514e3d30b567925$var$TYPE_NULL_OBJECT = "N";
var $c514e3d30b567925$var$TYPE_PROMISE = "P";
var $c514e3d30b567925$var$TYPE_REGEXP = "R";
var $c514e3d30b567925$var$TYPE_SET = "S";
var $c514e3d30b567925$var$TYPE_SYMBOL = "Y";
var $c514e3d30b567925$var$TYPE_URL = "U";
var $c514e3d30b567925$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $c514e3d30b567925$var$Deferred = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $c514e3d30b567925$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// src/flatten.ts
function $c514e3d30b567925$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $c514e3d30b567925$var$UNDEFINED;
    if (input === null) return $c514e3d30b567925$var$NULL;
    if (Number.isNaN(input)) return $c514e3d30b567925$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $c514e3d30b567925$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $c514e3d30b567925$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $c514e3d30b567925$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $c514e3d30b567925$var$stringify.call(this, input, index);
    return index;
}
function $c514e3d30b567925$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$c514e3d30b567925$var$flatten.call(this, k)}":${$c514e3d30b567925$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$c514e3d30b567925$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$c514e3d30b567925$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$c514e3d30b567925$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$c514e3d30b567925$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $c514e3d30b567925$var$flatten.call(this, input2[i]) : $c514e3d30b567925$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) str[index2] = `["${$c514e3d30b567925$var$TYPE_DATE}",${input2.getTime()}]`;
                        else if (input2 instanceof URL) str[index2] = `["${$c514e3d30b567925$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$c514e3d30b567925$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$c514e3d30b567925$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$c514e3d30b567925$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$c514e3d30b567925$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$c514e3d30b567925$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $c514e3d30b567925$var$flatten.call(this, k),
                                    $c514e3d30b567925$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$c514e3d30b567925$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$c514e3d30b567925$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$c514e3d30b567925$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$c514e3d30b567925$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($c514e3d30b567925$var$isPlainObject(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$c514e3d30b567925$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$c514e3d30b567925$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $c514e3d30b567925$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $c514e3d30b567925$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $c514e3d30b567925$var$objectProtoNames;
}
// src/unflatten.ts
var $c514e3d30b567925$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $c514e3d30b567925$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $c514e3d30b567925$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $c514e3d30b567925$var$hydrate.call(this, startIndex);
}
function $c514e3d30b567925$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $c514e3d30b567925$var$UNDEFINED:
                set(void 0);
                continue;
            case $c514e3d30b567925$var$NULL:
                set(null);
                continue;
            case $c514e3d30b567925$var$NAN:
                set(NaN);
                continue;
            case $c514e3d30b567925$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $c514e3d30b567925$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $c514e3d30b567925$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $c514e3d30b567925$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $c514e3d30b567925$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $c514e3d30b567925$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $c514e3d30b567925$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $c514e3d30b567925$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $c514e3d30b567925$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = 1; i < value.length; i++)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $c514e3d30b567925$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = 1; i < value.length; i += 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $c514e3d30b567925$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $c514e3d30b567925$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $c514e3d30b567925$var$Deferred();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $c514e3d30b567925$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $c514e3d30b567925$var$globalObj && $c514e3d30b567925$var$globalObj[errorType] ? new $c514e3d30b567925$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $c514e3d30b567925$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $c514e3d30b567925$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// src/turbo-stream.ts
async function $c514e3d30b567925$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $c514e3d30b567925$var$Deferred();
    const reader = readable.pipeThrough($c514e3d30b567925$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $c514e3d30b567925$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $c514e3d30b567925$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $c514e3d30b567925$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $c514e3d30b567925$var$unflatten.call(this, line)
    };
}
async function $c514e3d30b567925$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $c514e3d30b567925$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $c514e3d30b567925$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $c514e3d30b567925$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $c514e3d30b567925$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $c514e3d30b567925$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $c514e3d30b567925$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            while(Object.keys(encoder.deferred).length > 0){
                for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                    if (seenPromises.has(deferred)) continue;
                    seenPromises.add(encoder.deferred[Number(deferredId)] = $c514e3d30b567925$var$raceSignal(deferred, encoder.signal).then((resolved)=>{
                        const id2 = $c514e3d30b567925$var$flatten.call(encoder, resolved);
                        if (Array.isArray(id2)) {
                            controller.enqueue(textEncoder.encode(`${$c514e3d30b567925$var$TYPE_PROMISE}${deferredId}:[["${$c514e3d30b567925$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$c514e3d30b567925$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$c514e3d30b567925$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }, (reason)=>{
                        if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                        const id2 = $c514e3d30b567925$var$flatten.call(encoder, reason);
                        if (Array.isArray(id2)) {
                            controller.enqueue(textEncoder.encode(`${$c514e3d30b567925$var$TYPE_ERROR}${deferredId}:[["${$c514e3d30b567925$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$c514e3d30b567925$var$TYPE_ERROR}${deferredId}:${id2}
`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$c514e3d30b567925$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }).finally(()=>{
                        delete encoder.deferred[Number(deferredId)];
                    }));
                }
                await Promise.race(Object.values(encoder.deferred));
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
function $c514e3d30b567925$var$raceSignal(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(signal.reason || new Error("Signal was aborted."));
    const abort = new Promise((resolve, reject)=>{
        signal.addEventListener("abort", (event)=>{
            reject(signal.reason || new Error("Signal was aborted."));
        });
        promise.then(resolve).catch(reject);
    });
    abort.catch(()=>{});
    return Promise.race([
        abort,
        promise
    ]);
}

});

parcelRegister("9Hd0Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $70f23939d76c0480$var$parse;
module.exports.serialize = $70f23939d76c0480$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $70f23939d76c0480$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $70f23939d76c0480$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $70f23939d76c0480$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $70f23939d76c0480$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $70f23939d76c0480$var$__toString = Object.prototype.toString;
const $70f23939d76c0480$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $70f23939d76c0480$var$parse(str, options) {
    const obj = new $70f23939d76c0480$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $70f23939d76c0480$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $70f23939d76c0480$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $70f23939d76c0480$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $70f23939d76c0480$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $70f23939d76c0480$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $70f23939d76c0480$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $70f23939d76c0480$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $70f23939d76c0480$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$70f23939d76c0480$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$70f23939d76c0480$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$70f23939d76c0480$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$70f23939d76c0480$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$70f23939d76c0480$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $70f23939d76c0480$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $70f23939d76c0480$var$isDate(val) {
    return $70f23939d76c0480$var$__toString.call(val) === "[object Date]";
}

});

parcelRegister("7oXzj", function(module, exports) {
"use strict";
var $5638fb5bd871bb7d$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $5638fb5bd871bb7d$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $5638fb5bd871bb7d$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($5638fb5bd871bb7d$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $5638fb5bd871bb7d$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $5638fb5bd871bb7d$var$defaultParseOptions, options) : $5638fb5bd871bb7d$var$defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function $5638fb5bd871bb7d$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $5638fb5bd871bb7d$var$parse(input, options) {
    options = options ? Object.assign({}, $5638fb5bd871bb7d$var$defaultParseOptions, options) : $5638fb5bd871bb7d$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($5638fb5bd871bb7d$var$isNonEmptyString).map(function(str) {
        return $5638fb5bd871bb7d$var$parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter($5638fb5bd871bb7d$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $5638fb5bd871bb7d$var$parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $5638fb5bd871bb7d$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
module.exports = $5638fb5bd871bb7d$var$parse;
module.exports.parse = $5638fb5bd871bb7d$var$parse;
module.exports.parseString = $5638fb5bd871bb7d$var$parseString;
module.exports.splitCookiesString = $5638fb5bd871bb7d$var$splitCookiesString;

});


parcelRegister("hj9EK", function(module, exports) {

$parcel$export(module.exports, "toast", function () { return $d070fb72b8df9bc7$export$b410431fab84fa58; });
$parcel$export(module.exports, "ToastContainer", function () { return $d070fb72b8df9bc7$export$f2815235e76a62b9; });

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");
"use client";
function $d070fb72b8df9bc7$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$d070fb72b8df9bc7$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $d070fb72b8df9bc7$var$L = (t)=>typeof t == "number" && !isNaN(t), $d070fb72b8df9bc7$var$N = (t)=>typeof t == "string", $d070fb72b8df9bc7$var$P = (t)=>typeof t == "function", $d070fb72b8df9bc7$var$mt = (t)=>$d070fb72b8df9bc7$var$N(t) || $d070fb72b8df9bc7$var$L(t), $d070fb72b8df9bc7$var$B = (t)=>$d070fb72b8df9bc7$var$N(t) || $d070fb72b8df9bc7$var$P(t) ? t : null, $d070fb72b8df9bc7$var$pt = (t, o)=>t === !1 || $d070fb72b8df9bc7$var$L(t) && t > 0 ? t : o, $d070fb72b8df9bc7$var$z = (t)=>(0, $exYeM.isValidElement)(t) || $d070fb72b8df9bc7$var$N(t) || $d070fb72b8df9bc7$var$P(t) || $d070fb72b8df9bc7$var$L(t);
function $d070fb72b8df9bc7$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $d070fb72b8df9bc7$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $exYeM.useRef)(0);
        return (0, $exYeM.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $exYeM.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $d070fb72b8df9bc7$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, a);
    };
}
function $d070fb72b8df9bc7$var$J(t, o) {
    return {
        content: $d070fb72b8df9bc7$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $d070fb72b8df9bc7$var$tt(t, o, e = !1) {
    return (0, $exYeM.isValidElement)(t) && !$d070fb72b8df9bc7$var$N(t.type) ? (0, $exYeM.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $d070fb72b8df9bc7$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $d070fb72b8df9bc7$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $d070fb72b8df9bc7$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $4qr5a.default)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $d070fb72b8df9bc7$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $4qr5a.default)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $d070fb72b8df9bc7$var$Xt = 1, $d070fb72b8df9bc7$var$at = ()=>`${$d070fb72b8df9bc7$var$Xt++}`;
function $d070fb72b8df9bc7$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($d070fb72b8df9bc7$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $d070fb72b8df9bc7$var$B(n.className || d.toastClassName),
                progressClassName: $d070fb72b8df9bc7$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $d070fb72b8df9bc7$var$pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e($d070fb72b8df9bc7$var$J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $d070fb72b8df9bc7$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $d070fb72b8df9bc7$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $d070fb72b8df9bc7$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $d070fb72b8df9bc7$var$I = new Map, $d070fb72b8df9bc7$var$F = [], $d070fb72b8df9bc7$var$st = new Set, $d070fb72b8df9bc7$var$Vt = (t)=>$d070fb72b8df9bc7$var$st.forEach((o)=>o(t)), $d070fb72b8df9bc7$var$bt = ()=>$d070fb72b8df9bc7$var$I.size > 0;
function $d070fb72b8df9bc7$var$Qt() {
    $d070fb72b8df9bc7$var$F.forEach((t)=>$d070fb72b8df9bc7$var$nt(t.content, t.options)), $d070fb72b8df9bc7$var$F = [];
}
var $d070fb72b8df9bc7$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $d070fb72b8df9bc7$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $d070fb72b8df9bc7$var$X(t, o) {
    var r;
    if (o) return !!((r = $d070fb72b8df9bc7$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $d070fb72b8df9bc7$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $d070fb72b8df9bc7$var$ht(t) {
    if (!$d070fb72b8df9bc7$var$bt()) {
        $d070fb72b8df9bc7$var$F = $d070fb72b8df9bc7$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $d070fb72b8df9bc7$var$mt(t)) $d070fb72b8df9bc7$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $d070fb72b8df9bc7$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $d070fb72b8df9bc7$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $d070fb72b8df9bc7$var$Ct = (t = {})=>{
    $d070fb72b8df9bc7$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $d070fb72b8df9bc7$var$nt(t, o) {
    $d070fb72b8df9bc7$var$z(t) && ($d070fb72b8df9bc7$var$bt() || $d070fb72b8df9bc7$var$F.push({
        content: t,
        options: o
    }), $d070fb72b8df9bc7$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $d070fb72b8df9bc7$var$xt(t) {
    var o;
    (o = $d070fb72b8df9bc7$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $d070fb72b8df9bc7$var$rt(t, o) {
    $d070fb72b8df9bc7$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $d070fb72b8df9bc7$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $d070fb72b8df9bc7$var$_t(o, t, $d070fb72b8df9bc7$var$Vt);
            $d070fb72b8df9bc7$var$I.set(o, r);
            let s = r.observe(e);
            return $d070fb72b8df9bc7$var$Qt(), ()=>{
                s(), $d070fb72b8df9bc7$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $d070fb72b8df9bc7$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $d070fb72b8df9bc7$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $d070fb72b8df9bc7$var$Pt(t) {
    return $d070fb72b8df9bc7$var$st.add(t), ()=>{
        $d070fb72b8df9bc7$var$st.delete(t);
    };
}
function $d070fb72b8df9bc7$var$Wt(t) {
    return t && ($d070fb72b8df9bc7$var$N(t.toastId) || $d070fb72b8df9bc7$var$L(t.toastId)) ? t.toastId : $d070fb72b8df9bc7$var$at();
}
function $d070fb72b8df9bc7$var$U(t, o) {
    return $d070fb72b8df9bc7$var$nt(t, o), o.toastId;
}
function $d070fb72b8df9bc7$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $d070fb72b8df9bc7$var$Wt(o)
    };
}
function $d070fb72b8df9bc7$var$Q(t) {
    return (o, e)=>$d070fb72b8df9bc7$var$U(o, $d070fb72b8df9bc7$var$V(t, e));
}
function $d070fb72b8df9bc7$export$b410431fab84fa58(t, o) {
    return $d070fb72b8df9bc7$var$U(t, $d070fb72b8df9bc7$var$V("default", o));
}
$d070fb72b8df9bc7$export$b410431fab84fa58.loading = (t, o)=>$d070fb72b8df9bc7$var$U(t, $d070fb72b8df9bc7$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $d070fb72b8df9bc7$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $d070fb72b8df9bc7$var$N(o) ? $d070fb72b8df9bc7$export$b410431fab84fa58.loading(o, s) : $d070fb72b8df9bc7$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $d070fb72b8df9bc7$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $d070fb72b8df9bc7$var$N(g) ? {
            render: g
        } : g;
        return l ? $d070fb72b8df9bc7$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $d070fb72b8df9bc7$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $d070fb72b8df9bc7$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$d070fb72b8df9bc7$export$b410431fab84fa58.promise = $d070fb72b8df9bc7$var$Gt;
$d070fb72b8df9bc7$export$b410431fab84fa58.success = $d070fb72b8df9bc7$var$Q("success");
$d070fb72b8df9bc7$export$b410431fab84fa58.info = $d070fb72b8df9bc7$var$Q("info");
$d070fb72b8df9bc7$export$b410431fab84fa58.error = $d070fb72b8df9bc7$var$Q("error");
$d070fb72b8df9bc7$export$b410431fab84fa58.warning = $d070fb72b8df9bc7$var$Q("warning");
$d070fb72b8df9bc7$export$b410431fab84fa58.warn = $d070fb72b8df9bc7$export$b410431fab84fa58.warning;
$d070fb72b8df9bc7$export$b410431fab84fa58.dark = (t, o)=>$d070fb72b8df9bc7$var$U(t, $d070fb72b8df9bc7$var$V("default", {
        theme: "dark",
        ...o
    }));
function $d070fb72b8df9bc7$var$qt(t) {
    $d070fb72b8df9bc7$var$ht(t);
}
$d070fb72b8df9bc7$export$b410431fab84fa58.dismiss = $d070fb72b8df9bc7$var$qt;
$d070fb72b8df9bc7$export$b410431fab84fa58.clearWaitingQueue = $d070fb72b8df9bc7$var$Ct;
$d070fb72b8df9bc7$export$b410431fab84fa58.isActive = $d070fb72b8df9bc7$var$X;
$d070fb72b8df9bc7$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $d070fb72b8df9bc7$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $d070fb72b8df9bc7$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $d070fb72b8df9bc7$var$U(a, l);
    }
};
$d070fb72b8df9bc7$export$b410431fab84fa58.done = (t)=>{
    $d070fb72b8df9bc7$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$d070fb72b8df9bc7$export$b410431fab84fa58.onChange = $d070fb72b8df9bc7$var$Pt;
$d070fb72b8df9bc7$export$b410431fab84fa58.play = (t)=>$d070fb72b8df9bc7$var$rt(!0, t);
$d070fb72b8df9bc7$export$b410431fab84fa58.pause = (t)=>$d070fb72b8df9bc7$var$rt(!1, t);
function $d070fb72b8df9bc7$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $exYeM.useRef)($d070fb72b8df9bc7$var$Et(t)).current;
    r(t);
    let s = (a = (0, $exYeM.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $d070fb72b8df9bc7$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $d070fb72b8df9bc7$var$At(t) {
    let [o, e] = (0, $exYeM.useState)(!1), [r, s] = (0, $exYeM.useState)(!1), l = (0, $exYeM.useRef)(null), a = (0, $exYeM.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $d070fb72b8df9bc7$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $exYeM.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $d070fb72b8df9bc7$var$Ot = typeof window != "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
var $d070fb72b8df9bc7$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $d070fb72b8df9bc7$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d070fb72b8df9bc7$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $d070fb72b8df9bc7$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d070fb72b8df9bc7$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $d070fb72b8df9bc7$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d070fb72b8df9bc7$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $d070fb72b8df9bc7$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d070fb72b8df9bc7$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $d070fb72b8df9bc7$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $d070fb72b8df9bc7$export$4f13f83fd8bb1dac = {
    info: $d070fb72b8df9bc7$var$so,
    warning: $d070fb72b8df9bc7$var$ao,
    success: $d070fb72b8df9bc7$var$no,
    error: $d070fb72b8df9bc7$var$ro,
    spinner: $d070fb72b8df9bc7$var$io
}, $d070fb72b8df9bc7$var$lo = (t)=>t in $d070fb72b8df9bc7$export$4f13f83fd8bb1dac;
function $d070fb72b8df9bc7$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($d070fb72b8df9bc7$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $exYeM.isValidElement)(r) ? s = (0, $exYeM.cloneElement)(r, l) : e ? s = $d070fb72b8df9bc7$export$4f13f83fd8bb1dac.spinner() : $d070fb72b8df9bc7$var$lo(o) && (s = $d070fb72b8df9bc7$export$4f13f83fd8bb1dac[o](l))), s;
}
var $d070fb72b8df9bc7$var$wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $d070fb72b8df9bc7$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, $4qr5a.default)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $d070fb72b8df9bc7$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, $4qr5a.default)(D, E), ft = $d070fb72b8df9bc7$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($d070fb72b8df9bc7$var$P(a) ? H = a(j) : (0, $exYeM.isValidElement)(a) ? H = (0, $exYeM.cloneElement)(a, j) : H = $d070fb72b8df9bc7$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $4qr5a.default)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $d070fb72b8df9bc7$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d070fb72b8df9bc7$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $d070fb72b8df9bc7$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $d070fb72b8df9bc7$export$d20e79fdc3899e95 = $d070fb72b8df9bc7$export$3ff7dc44d332d222($d070fb72b8df9bc7$var$K("bounce", !0)), $d070fb72b8df9bc7$export$d8dc01b5c85a37b9 = $d070fb72b8df9bc7$export$3ff7dc44d332d222($d070fb72b8df9bc7$var$K("slide", !0)), $d070fb72b8df9bc7$export$65cfd44a2050f99 = $d070fb72b8df9bc7$export$3ff7dc44d332d222($d070fb72b8df9bc7$var$K("zoom")), $d070fb72b8df9bc7$export$4d2fae537bd90431 = $d070fb72b8df9bc7$export$3ff7dc44d332d222($d070fb72b8df9bc7$var$K("flip"));
var $d070fb72b8df9bc7$var$_o = {
    position: "top-right",
    transition: $d070fb72b8df9bc7$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $d070fb72b8df9bc7$export$f2815235e76a62b9(t) {
    let o = {
        ...$d070fb72b8df9bc7$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $exYeM.useState)(!0), l = (0, $exYeM.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $d070fb72b8df9bc7$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $4qr5a.default)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $d070fb72b8df9bc7$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $4qr5a.default)(p, $d070fb72b8df9bc7$var$B(T));
    }
    function E() {
        e && (s(!0), $d070fb72b8df9bc7$export$b410431fab84fa58.play());
    }
    return $d070fb72b8df9bc7$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $exYeM.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $d070fb72b8df9bc7$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $d070fb72b8df9bc7$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $d070fb72b8df9bc7$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d070fb72b8df9bc7$var$wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}

});
parcelRegister("4qr5a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fecb99b999628060$export$2e2bcd8739ae039; });
function $fecb99b999628060$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fecb99b999628060$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fecb99b999628060$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fecb99b999628060$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fecb99b999628060$export$2e2bcd8739ae039 = $fecb99b999628060$export$4f5d2d50c9deca37;

});


parcelRegister("bsJmv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87195daa1b576205$export$2e2bcd8739ae039; });
// Replaces SubmitButton

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $8yjzm = parcelRequire("8yjzm");
function $87195daa1b576205$export$2e2bcd8739ae039(props) {
    const { as: as, style: style, className: className, isProcessing: isProcessing, children: children, ...rest } = props;
    // Explicitly type the component using a generic function signature.
    // Otherwise, we'll get TypeScript error: 
    // `JSX element type 'Component' does not have any construct or call signatures.ts(2604)`  
    // because TypeScript cannot guarantee that the string or component passed to as is a valid JSX element.
    const Component = as || "button";
    const isAnchor = Component === "a";
    // Automatically inject accessibility overrides matching the target tag
    const accessibilityProps = isAnchor ? {
        role: props.role ?? "button"
    } // Treat an <a> anchor acting as a trigger as a button.
     : {
        type: props.type || "button"
    }; // Enforce type="button" to stop accidental form submission
    const processingIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8yjzm.default), {
        top: "12",
        color: "white",
        width: "35",
        height: "15",
        style: {
            backgroundColor: "inherit",
            color: "#fff"
        }
    });
    let finalClassName = "btn action-btn";
    if (isProcessing) finalClassName += " btn-processing disabled";
    if (className) finalClassName += ` ${className}`;
    if (as === "a") finalClassName = finalClassName.replace(/btn/, "");
    const appliedStyle = {
        borderRadius: "5px",
        cursor: "pointer",
        outline: 0,
        ...style ?? {}
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Component, {
        className: finalClassName,
        style: appliedStyle,
        ...accessibilityProps,
        ...rest,
        children: isProcessing ? processingIcon : children
    });
}

});
parcelRegister("8yjzm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $196f4473faefcd22$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $28hOY = parcelRequire("28hOY");
function $196f4473faefcd22$export$2e2bcd8739ae039({ width: width, height: height, color: color, top: top, ...rest }) {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        height: height ?? "40",
        width: width ?? "40",
        className: $28hOY.loader,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                className: $28hOY.dot,
                cx: "10",
                cy: top ?? "20",
                r: "3",
                style: {
                    fill: color ?? "grey"
                }
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                className: $28hOY.dot,
                cx: "20",
                cy: top ?? "20",
                r: "3",
                style: {
                    fill: color ?? "grey"
                }
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                className: $28hOY.dot,
                cx: "30",
                cy: top ?? "20",
                r: "3",
                style: {
                    fill: color ?? "grey"
                }
            })
        ]
    });
}

});
parcelRegister("28hOY", function(module, exports) {

$parcel$export(module.exports, "blink", function () { return $18da270f2e020d2e$export$a0f5ee27be08228f; }, function (v) { return $18da270f2e020d2e$export$a0f5ee27be08228f = v; });
$parcel$export(module.exports, "dot", function () { return $18da270f2e020d2e$export$94132a0e348806d4; }, function (v) { return $18da270f2e020d2e$export$94132a0e348806d4 = v; });
$parcel$export(module.exports, "loader", function () { return $18da270f2e020d2e$export$f4c5de44377d2946; }, function (v) { return $18da270f2e020d2e$export$f4c5de44377d2946 = v; });
var $18da270f2e020d2e$export$a0f5ee27be08228f;
var $18da270f2e020d2e$export$94132a0e348806d4;
var $18da270f2e020d2e$export$f4c5de44377d2946;
$18da270f2e020d2e$export$a0f5ee27be08228f = `aqLcmq_blink`;
$18da270f2e020d2e$export$a0f5ee27be08228f;
$18da270f2e020d2e$export$94132a0e348806d4 = `aqLcmq_dot`;
$18da270f2e020d2e$export$f4c5de44377d2946 = `aqLcmq_loader`;

});



parcelRegister("42IXp", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $788aa55553ce4d53$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "debounceWithPromise", function () { return $788aa55553ce4d53$export$344d3c11850e092e; });
$parcel$export(module.exports, "sleep", function () { return $788aa55553ce4d53$export$e772c8ff12451969; });
$parcel$export(module.exports, "retryWithExponentialBackOff", function () { return $788aa55553ce4d53$export$cb2b5198576755a7; });
$parcel$export(module.exports, "withExponentialBackoffRetry", function () { return $788aa55553ce4d53$export$4258c7a5ac352b3c; });
parcelRequire("bO9s5");
var $h5JAr = parcelRequire("h5JAr");

var $1KXyM = parcelRequire("1KXyM");

var $9w0rm = parcelRequire("9w0rm");
function $788aa55553ce4d53$export$61fc7d43ac8f84b0(func, delay) {
    let timeoutId;
    return function(...args) {
        const context = null; //this // just to pass typescript error: "Unexpected alisaing of 'this' to local variable"
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
            func.apply(context, args);
        }, delay);
    };
}
function $788aa55553ce4d53$export$344d3c11850e092e(func, wait) {
    let timeoutId;
    // Track the single active resolve/reject for the latest call
    let activeResolve;
    let activeReject;
    return (...args)=>{
        if (timeoutId) {
            clearTimeout(timeoutId);
            // Reject previous pending promises because they were debounced/cancelled
            const error = {
                name: "Pending Promise Cancelled",
                message: "Pending Promise Resolution Cancelled by a newer debounced call"
            };
            activeReject?.(error);
        }
        return new Promise((resolve, reject)=>{
            activeResolve = resolve;
            activeReject = reject;
            timeoutId = setTimeout(async ()=>{
                try {
                    const result = await func(...args);
                    activeResolve?.(result);
                } catch (error) {
                    activeReject?.(error);
                }
            }, wait);
        });
    };
}
function $788aa55553ce4d53$export$de363e709c412c8a(func, throttleDuration) {
    // While throttle is active, no function calls will be executed
    let throttleOn = false;
    return function(...args) {
        const context = null; // this; // just to pass typescript error: "Unexpected alisaing of 'this' to local variable"
        // If the throttle is active when the function is invoked, do nothing...
        if (throttleOn) return;
        // ...Otherwise, execute the function invocation. 
        // However, before doing that, activate the throttle, so that no other calls are allowed.
        throttleOn = true;
        func.apply(context, args);
        // Even after the current invocation finishes executing, 
        // No function calls will be allowed until the throttle duration has elapsed.
        //
        // An alternative implementation would probably put this setTimeout call 
        // above the function invocation (func.apply(context, args))
        // But, depending on the context/situation, that could lead to race conditions 
        // if the timer expires before the current function is done executing.
        setTimeout(function() {
            throttleOn = false;
        }, throttleDuration);
    };
}
async function $788aa55553ce4d53$export$e772c8ff12451969(ms) {
    return new Promise((res)=>setTimeout(res, ms));
}
async function $788aa55553ce4d53$export$cb2b5198576755a7(callback, options) {
    const { maxAttempts: maxAttempts = (0, $h5JAr.REQUEST_MAX_ATTEMPTS), baseDelay: baseDelay = (0, $h5JAr.REQUEST_RETRY_DELAY) } = options ?? {};
    let attempts = 0;
    const delayInMs = (0, $1KXyM.secondsToMilliseconds)(baseDelay);
    while(attempts < maxAttempts)try {
        await callback();
        return;
    } catch (err) {
        attempts++;
        (0, $9w0rm.default).error(`Retrying (${attempts}/${maxAttempts}) - Error:`, err);
        if (attempts === maxAttempts) (0, $9w0rm.default).error(`${maxAttempts} exceeded.`);
        // Exponential backoff
        await new Promise((res)=>setTimeout(res, delayInMs * attempts));
    }
}
function $788aa55553ce4d53$export$4258c7a5ac352b3c(fn, options) {
    const { maxAttempts: maxAttempts = (0, $h5JAr.REQUEST_MAX_ATTEMPTS), baseDelay: baseDelay = (0, $h5JAr.REQUEST_RETRY_DELAY) } = options ?? {};
    let attempts = 0;
    const delayInMs = (0, $1KXyM.secondsToMilliseconds)(baseDelay);
    return function(...args) {
        const context = null; // this; // just to pass typescript error: "Unexpected alisaing of 'this' to local variable"
        return new Promise((resolve, reject)=>{
            (async function() {
                while(attempts < maxAttempts)try {
                    const val = await fn.apply(context, args);
                    resolve(val);
                    return; // Don't keep running the function after a successful response
                } catch (err) {
                    attempts++;
                    (0, $9w0rm.default).error(`Retrying (${attempts}/${maxAttempts}) - Error:`, err);
                    if (attempts === maxAttempts) {
                        (0, $9w0rm.default).error(`${maxAttempts} exceeded.`);
                        reject(err);
                    }
                    // Exponential backoff (delay/sleep for some time before retrying)
                    await new Promise((res)=>setTimeout(res, delayInMs * attempts));
                }
            })();
        });
    };
} /**
 * Debounce function to limit the rate of function calls
 * @param func - Function to debounce
 * @param wait - Wait time in milliseconds
 * @returns Debounced function
 * 
 * (implemented by cursor AI)
 */  /*function debounce<T extends (...args: any[]) => any>(func: T, wait: number): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout;

  return function executedFunction(...args: Parameters<T>) {
    function deferredFunction() {
      clearTimeout(timeout);
      func(...args);
    }

    clearTimeout(timeout);
    timeout = setTimeout(deferredFunction, wait);
  };
}*/ 

});
parcelRegister("bO9s5", function(module, exports) {
$parcel$export(module.exports, "DEBOUNCE_TIMEOUT", function () { return (parcelRequire("h5JAr")).DEBOUNCE_TIMEOUT; });
$parcel$export(module.exports, "DEFAULT_RESULTS_PER_PAGE", function () { return (parcelRequire("h5JAr")).DEFAULT_RESULTS_PER_PAGE; });
$parcel$export(module.exports, "MAIN_SLIDER_NAVIGATION_MODE", function () { return (parcelRequire("h5JAr")).MAIN_SLIDER_NAVIGATION_MODE; });
$parcel$export(module.exports, "REQUEST_MAX_ATTEMPTS", function () { return (parcelRequire("h5JAr")).REQUEST_MAX_ATTEMPTS; });
$parcel$export(module.exports, "REQUEST_RETRY_DELAY", function () { return (parcelRequire("h5JAr")).REQUEST_RETRY_DELAY; });

$parcel$export(module.exports, "DEFAULT", function () { return $cdf8409f07b189fe$export$e6952b12ade67489; });

var $kqPd4 = parcelRequire("kqPd4");

var $aV3xn = parcelRequire("aV3xn");
parcelRequire("h5JAr");
const $cdf8409f07b189fe$export$e6952b12ade67489 = $kqPd4;
const $cdf8409f07b189fe$export$4d6aaadf2171139b = $aV3xn;
 /*export { 
  DEFAULT_RESULTS_PER_PAGE as DEFAULT_RESULTS_PER_PAGE, 
  MAIN_SLIDER_NAVIGATION_MODE as MAIN_SLIDER_NAVIGATION_MODE,
  REQUEST_MAX_ATTEMPTS as REQUEST_MAX_ATTEMPTS, 
  REQUEST_RETRY_DELAY as REQUEST_RETRY_DELAY
} from "./global";
*/ 
});
parcelRegister("kqPd4", function(module, exports) {

$parcel$export(module.exports, "TAX_PERCENTAGE", function () { return $ef2b2a8dab17feae$export$9c75d559a2ef406; });
const $ef2b2a8dab17feae$export$9c75d559a2ef406 = 7.5;

});

parcelRegister("aV3xn", function(module, exports) {

$parcel$export(module.exports, "TAX_PERCENTAGe", function () { return $b04cbfe639fbb97b$export$48c09396da482dad; });
const $b04cbfe639fbb97b$export$48c09396da482dad = 7.5;

});

parcelRegister("h5JAr", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESULTS_PER_PAGE", function () { return $99ff8adb527543a0$export$8e91068a74e09fc6; });
$parcel$export(module.exports, "MAIN_SLIDER_NAVIGATION_MODE", function () { return $99ff8adb527543a0$export$918e2c5825fffd3c; });
$parcel$export(module.exports, "REQUEST_MAX_ATTEMPTS", function () { return $99ff8adb527543a0$export$a1370ad5ad66b825; });
$parcel$export(module.exports, "REQUEST_RETRY_DELAY", function () { return $99ff8adb527543a0$export$c6d8c776fae9f4f6; });
$parcel$export(module.exports, "DEBOUNCE_TIMEOUT", function () { return $99ff8adb527543a0$export$7ebf6620acc135ab; });
const $99ff8adb527543a0$export$8e91068a74e09fc6 = Number("20") || 20;
const $99ff8adb527543a0$export$918e2c5825fffd3c = "auto";
const $99ff8adb527543a0$export$a1370ad5ad66b825 = Number(undefined) || 5;
const $99ff8adb527543a0$export$c6d8c776fae9f4f6 = Number(undefined) || 1;
const $99ff8adb527543a0$export$7ebf6620acc135ab = 350;

});


parcelRegister("1KXyM", function(module, exports) {

$parcel$export(module.exports, "convertLocalDateToUTCDate", function () { return $e861ee54f505961a$export$ee63e1e02f1f1ee; });
$parcel$export(module.exports, "toISODateString", function () { return $e861ee54f505961a$export$c0335d436cc2228b; });
$parcel$export(module.exports, "minutesToSeconds", function () { return $e861ee54f505961a$export$81ded4628c655103; });
$parcel$export(module.exports, "secondsToMilliseconds", function () { return $e861ee54f505961a$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "formatDateTime", function () { return $e861ee54f505961a$export$8b492ed8828f789c; });
$parcel$export(module.exports, "formatDateToYMD", function () { return $e861ee54f505961a$export$f06c591b038a4971; });
$parcel$export(module.exports, "isBetweenDates", function () { return $e861ee54f505961a$export$e5296774e302b8d9; });
$parcel$export(module.exports, "isLessThanDays", function () { return $e861ee54f505961a$export$114c4bce0631c044; });
function $e861ee54f505961a$export$ee63e1e02f1f1ee(localDateString) {
    let localDate;
    if (localDateString instanceof Date) localDateString = $e861ee54f505961a$export$c0335d436cc2228b(localDateString);
    try {
        localDate = new Date($e861ee54f505961a$var$asISODateString(localDateString));
    } catch  {
        localDate = new Date();
    }
    // Force the local clock numbers into a UTC timestamp
    const forcedUtcDate = new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), localDate.getHours(), localDate.getMinutes(), localDate.getSeconds()));
    return forcedUtcDate; // UTC Date (timestamp is now in UTC)
//return forcedUtcDate.toISOString();
}
function $e861ee54f505961a$export$59b1396ccbd5a4e1(hours) {
    return hours * 3600;
}
function $e861ee54f505961a$export$81ded4628c655103(minutes) {
    return minutes * 60;
}
function $e861ee54f505961a$export$47d555ff5354096f(seconds) {
    return seconds / 3600;
}
function $e861ee54f505961a$export$fc3e7e8557f8c8c7(seconds) {
    return seconds * 1000;
}
function $e861ee54f505961a$export$ed657adb62398e99(seconds) {
    return seconds / 60;
}
function $e861ee54f505961a$export$8b492ed8828f789c(dateString, options = {}) {
    const utcDate = new Date(dateString);
    // Destructure to separate non-format keys from actual Intl options
    const { preset: preset, locale: optionLocale, ...dateTimeOptions } = options;
    // Locale fallback
    const locale = optionLocale || undefined;
    // Helper for padding numbers
    const pad = (num)=>String(num).padStart(2, "0");
    const presets = {
        short: {
            year: "2-digit",
            month: "numeric",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        },
        medium: {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        },
        long: {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }
    };
    // If ISO preset is chosen, return custom formatted string
    if (preset === "iso") {
        const pad = (num)=>String(num).padStart(2, "0");
        const year = utcDate.getFullYear();
        const month = pad(utcDate.getMonth() + 1);
        const day = pad(utcDate.getDate());
        const hours = pad(utcDate.getHours());
        const minutes = pad(utcDate.getMinutes());
        const seconds = pad(utcDate.getSeconds());
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    if (preset === "isoUTC") {
        const year = utcDate.getUTCFullYear();
        const month = pad(utcDate.getUTCMonth() + 1);
        const day = pad(utcDate.getUTCDate());
        const hours = pad(utcDate.getUTCHours());
        const minutes = pad(utcDate.getUTCMinutes());
        const seconds = pad(utcDate.getUTCSeconds());
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
    }
    // Pick preset if provided (excluding ISO variants which returned above)
    let presetOptions = {};
    if (preset === "short" || preset === "medium" || preset === "long") presetOptions = presets[preset];
    // Merge preset with custom options (custom wins)
    const formatOptions = {
        ...presetOptions,
        ...dateTimeOptions
    };
    return utcDate.toLocaleString(locale, formatOptions);
/* Notes: 
    - All options are optional: pass only what you need.
    - Locale-aware: respects user's system settings unless you override with `locale`.
    - Time zone override: lets you display the time in any region, not just the user's local zone.
    - `preset` can be "short", "medium", or "long", "iso", or "isoUTC".
    - You can pass custom options to override the preset.
  */ // Example usage:
/*const utcDateString = "2026-03-07T16:43:25.489Z";

  // Default local format
  console.log(convertToLocal(utcDateString));

  // Short preset
  console.log(convertToLocal(utcDateString, { preset: "short" }));

  // Medium preset
  console.log(convertToLocal(utcDateString, { preset: "medium" }));

  // Long preset with override
  console.log(convertToLocal(utcDateString, { preset: "long", hour12: true }));

  // Force time zone with preset
  console.log(convertToLocal(utcDateString, { preset: "short", timeZone: "Africa/Lagos" }));

  // Custom format
  console.log(convertToLocal(utcDateString, {
  locale: "en-US",
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: true
  }));

  // Force a specific time zone
  console.log(convertToLocal(utcDateString, {
  timeZone: "Africa/Lagos",
  hour: "2-digit",
  minute: "2-digit"
  }));

  */ }
function $e861ee54f505961a$export$f06c591b038a4971(date, options) {
    const { isUTC: isUTC = false, includeTime: includeTime = false } = options ?? {};
    if (!(date instanceof Date)) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    if (includeTime) {
        const hour = String(isUTC ? date.getUTCHours() : date.getHours()).padStart(2, "0");
        const minute = String(isUTC ? date.getUTCMinutes() : date.getMinutes()).padStart(2, "0");
        const seconds = String(isUTC ? date.getUTCSeconds() : date.getSeconds()).padStart(2, "0");
        const milliseconds = String(isUTC ? date.getUTCMilliseconds() : date.getMilliseconds());
        return `${year}/${month}/${day} ${hour}:${minute}:${seconds}:${milliseconds}`;
    } else return `${year}-${month}-${day}`;
}
function $e861ee54f505961a$export$e5296774e302b8d9(startDate, endDate, dateToCheck) {
    dateToCheck = dateToCheck ?? $e861ee54f505961a$export$c0335d436cc2228b(new Date());
    // Convert all inputs into Date objects to handle both strings and Date instances
    const check = new Date($e861ee54f505961a$export$c0335d436cc2228b($e861ee54f505961a$export$ee63e1e02f1f1ee(dateToCheck))); // new Date(dateToCheck);
    const start = new Date($e861ee54f505961a$var$asISODateString(startDate));
    const end = new Date($e861ee54f505961a$var$asISODateString(endDate));
    // Compare the underlying millisecond values
    return check >= start && check <= end;
}
function $e861ee54f505961a$export$114c4bce0631c044(dateString, days = 7) {
    try {
        const targetDate = new Date($e861ee54f505961a$var$asISODateString(dateString));
        const now = new Date();
        const diffInMilliseconds = now.getTime() - targetDate.getTime();
        const isWithinLimit = diffInMilliseconds < $e861ee54f505961a$var$daysToMilliseconds(days);
        return isWithinLimit;
    } catch  {
        return false;
    }
}
function $e861ee54f505961a$export$c0335d436cc2228b(date) {
    return date.toISOString();
}
/**
 * Ensure a date string has the ISODate string format.
 * 
 * @param value 
 * @returns 
 */ function $e861ee54f505961a$var$asISODateString(value) {
    if (isNaN(Date.parse(value))) throw new Error(`Invalid date format ${String(value)}`);
    return value;
// Usage:
// const secureDate: ISODate = asISODateString("2026-06-19T17:24:34.074Z");
}
function $e861ee54f505961a$var$daysToMilliseconds(days) {
    return days * 86400000; //(Days * 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
}

});

parcelRegister("9w0rm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44426aec840068ed$export$2e2bcd8739ae039; });
const $44426aec840068ed$var$LogLevel = {
    ERROR: 0,
    WARN: 1,
    INFO: 2,
    DEBUG: 3
};
class $44426aec840068ed$var$Logger {
    constructor(level = $44426aec840068ed$var$LogLevel.INFO){
        this.level = level;
    }
    shouldLog(level) {
        return level <= this.level;
    }
    formatMessage(level, message) {
        return `[${Object.keys($44426aec840068ed$var$LogLevel)[level]}] ${message}`;
    }
    error(message, ...args) {
        if (this.shouldLog($44426aec840068ed$var$LogLevel.ERROR)) console.error(this.formatMessage($44426aec840068ed$var$LogLevel.ERROR, message), ...args);
    }
    warn(message, ...args) {
        if (this.shouldLog($44426aec840068ed$var$LogLevel.WARN)) console.warn(this.formatMessage($44426aec840068ed$var$LogLevel.WARN, message), ...args);
    }
    info(message, ...args) {
        if (this.shouldLog($44426aec840068ed$var$LogLevel.INFO)) console.log(this.formatMessage($44426aec840068ed$var$LogLevel.INFO, message), ...args);
    }
    debug(message, ...args) {
        if (this.shouldLog($44426aec840068ed$var$LogLevel.DEBUG)) console.log(this.formatMessage($44426aec840068ed$var$LogLevel.DEBUG, message), ...args);
    }
    setLevel(level) {
        this.level = level;
    }
}
const $44426aec840068ed$var$logger = new $44426aec840068ed$var$Logger($44426aec840068ed$var$LogLevel.DEBUG);
var $44426aec840068ed$export$2e2bcd8739ae039 = $44426aec840068ed$var$logger;

});


parcelRegister("bLIxp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bef1178bcc1bf25d$export$2e2bcd8739ae039; });

var $7qAy3 = parcelRequire("7qAy3");

var $1KXyM = parcelRequire("1KXyM");

var $4FeSR = parcelRequire("4FeSR");

var $9w0rm = parcelRequire("9w0rm");

var $gB5us = parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");

var $9t5Ss = parcelRequire("9t5Ss");
const $bef1178bcc1bf25d$var$ACCESS_TOKEN = "token" ?? "accessToken";
class $bef1178bcc1bf25d$export$2e2bcd8739ae039 {
    static deleteAccessToken() {
        (0, $9t5Ss.default).removeItem($bef1178bcc1bf25d$var$ACCESS_TOKEN);
    }
    static getAccessTokenKey() {
        return $bef1178bcc1bf25d$var$ACCESS_TOKEN;
    }
    static getBearerToken() {
        const accessToken = $bef1178bcc1bf25d$export$2e2bcd8739ae039.#getAccessToken();
        return `Bearer ${accessToken}`;
    }
    static saveAccessToken(authorization) {
        const { token: token, expiresIn: expiresIn } = authorization;
        const expiresInSeconds = (0, $1KXyM.minutesToSeconds)(parseInt(expiresIn, 10));
        $bef1178bcc1bf25d$export$2e2bcd8739ae039.#saveAccessToken(token.replace("Bearer ", ""), expiresInSeconds);
    }
    static isAuthenticatedUser() {
        const accessToken = $bef1178bcc1bf25d$export$2e2bcd8739ae039.#getAccessToken();
        return accessToken !== null;
    }
    static isProtectedRoute(endpoint) {
        //const page = pages.find(page => page.route === endpoint); // frontend route.
        const page = (0, $gB5us.default).find((page)=>page.path === endpoint); // frontend route.
        return page?.authRequired || (0, $7qAy3.PROTECTED_API_ENDPOINTS).includes(endpoint);
    }
    // We placed this in AuthService because its redirecting is not just a
    // regular redirect to this url. Instead, what it does is,
    // when a user tries to access a protected page,
    // it redirects them to the login page. The login page then checks
    // if the user is authenticated. If they are, they are automatically
    // granted access to the protected resource. Otherwise, they are presented
    // with the login form.
    static redirect(path) {
        if (path === (0, $hSqCk).SIGNIN) {
            window.location = (0, $hSqCk).SIGNIN;
            return;
        }
        if ($bef1178bcc1bf25d$export$2e2bcd8739ae039.isAuthenticatedUser()) {
            window.location = encodeURIComponent(path);
            return;
        }
        window.location = `${(0, $hSqCk).SIGNIN}?redirect=${encodeURIComponent(path)}`;
    }
    static async refreshAccessToken() {
        try {
            // Hit the refresh endpoint to fetch a new access token
            const refreshResponse = await fetch(`${(0, $4FeSR.baseUrl)}/auth/token/refresh`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (refreshResponse.ok) {
                const json = await refreshResponse.json();
                const { authorization: authorization } = json.data;
                $bef1178bcc1bf25d$export$2e2bcd8739ae039.deleteAccessToken(); // Delete the previous token
                $bef1178bcc1bf25d$export$2e2bcd8739ae039.saveAccessToken(authorization); // Save the new token
                return true;
            } else {
                $bef1178bcc1bf25d$export$2e2bcd8739ae039.deleteAccessToken();
                return false;
            }
        } catch (error) {
            (0, $9w0rm.default).error("Error refreshing access token: ", error);
            $bef1178bcc1bf25d$export$2e2bcd8739ae039.deleteAccessToken();
            throw error;
        }
    }
    static #getAccessToken() {
        const { token: token, expiry: expiry } = (0, $9t5Ss.default).getItem($bef1178bcc1bf25d$var$ACCESS_TOKEN) ?? {};
        if (expiry && expiry < Date.now()) {
            $bef1178bcc1bf25d$export$2e2bcd8739ae039.deleteAccessToken(); // Delete the token from the file-system.
            return null;
        }
        return token ?? null;
    }
    /*static #isTokenValid(token) {
    try {
      // Decode JWT payload locally (no API call)
      const payload = JSON.parse(atob(token.split(".")[1]));

      // Check if token expiration time (exp) is in the future
      const isExpired = secondsToMilliseconds(payload.exp) < Date.now();

      return !(isExpired);
    } catch(error) {
      return false;
    }
  }*/ /**
   * @param {String} token: The access token
   * @param {Number} ttl: The time (in seconds) when the token should expire.
   */ static #saveAccessToken(token, ttl) {
        const expiry = ttl; //parseInt(ttl as unknown as string, 10);
        const data = {
            token: token,
            expiry: Date.now() + (0, $1KXyM.secondsToMilliseconds)(expiry)
        };
        (0, $9t5Ss.default).setItem($bef1178bcc1bf25d$var$ACCESS_TOKEN, data);
    }
}

});
parcelRegister("7qAy3", function(module, exports) {

$parcel$export(module.exports, "PROTECTED_API_ENDPOINTS", function () { return $5e7eac8405188924$export$60fb3640f8a5d2cb; });
// List of server endpoints requiring authentication;
const $5e7eac8405188924$export$60fb3640f8a5d2cb = [
    "/authenticate"
];

});

parcelRegister("4FeSR", function(module, exports) {

$parcel$export(module.exports, "fetchWithTimeout", function () { return $81a8de639190806b$export$b0613bdcd91c3d8; });
$parcel$export(module.exports, "baseUrl", function () { return $81a8de639190806b$export$a135e81e9a047f61; });
$parcel$export(module.exports, "HTTP_STATUS_CODES", function () { return $81a8de639190806b$export$eef5945dfeccfc61; });
$parcel$export(module.exports, "isServerDownError", function () { return $81a8de639190806b$export$2449003c1df2e22f; });

var $bLIxp = parcelRequire("bLIxp");

var $9w0rm = parcelRequire("9w0rm");
const $81a8de639190806b$var$host = "https://www.nearbuycart.com/api";
const $81a8de639190806b$var$port = "";
const $81a8de639190806b$export$b0613bdcd91c3d8 = $81a8de639190806b$var$timedFetch(Number("15"), $81a8de639190806b$var$onAbort);
const $81a8de639190806b$export$a135e81e9a047f61 = ($81a8de639190806b$var$port && ![
    80,
    443
].includes(Number($81a8de639190806b$var$port)) ? [
    $81a8de639190806b$var$host,
    $81a8de639190806b$var$port
] : [
    $81a8de639190806b$var$host
]).join(":");
const $81a8de639190806b$export$eef5945dfeccfc61 = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
};
function $81a8de639190806b$export$2449003c1df2e22f(error) {
    // Return true if the server is (temporarily) down.
    return error.message === "Failed to fetch";
}
function $81a8de639190806b$var$onAbort(url, requestData, timeout) {
    const { method: method = "GET" /*, headers, body*/  } = requestData;
    (0, $9w0rm.default).warn(`HTTP ${method.toUpperCase()} request to ${url} aborted after ${timeout} seconds.`);
}
/**
 * Create a timed fecth:
 *   (a fetch that aborts the request after a specified number of seconds have passed).
 *
 * @param {number} timeout (in seconds)
 * @param {Function} onAbort:
 *    A function to invoke when the fetch aborts due to timeout.
 *    The handler is auto-passed the arguments to the `fetch` call.
 * @return A function
 *   that takes the arguments that `fetch` takes
 *   returns the same Promise that `fetch` returns.
 */ function $81a8de639190806b$var$timedFetch(timeout = 0, onAbort) {
    const controller = new AbortController();
    const signal = controller.signal;
    const abortHandler = typeof onAbort === "function" ? onAbort : ()=>{};
    return async function proxyFetch(url, options) {
        let timerId;
        // Send the fetch request,
        const serverResponse = fetch(url, options);
        if (typeof timeout === "number" && timeout > 0) {
            // Setup the timer to cancel the request when the timeout expires.
            timerId = setTimeout(function abortRequest() {
                controller.abort();
            }, timeout * 1000);
            signal.addEventListener("abort", function handleRequestTimeout() {
                abortHandler(url, options ?? {}, timeout);
            });
        }
        let response = await serverResponse;
        response = await $81a8de639190806b$var$autoHandleExpiredAccessToken({
            response: response,
            url: url,
            options: options
        });
        // Clear the timeout once our fetch returns before timeout expiry.
        if (timerId) clearTimeout(timerId);
        return response;
    };
}
// Automatically handle refresh tokens.
async function $81a8de639190806b$var$autoHandleExpiredAccessToken(data) {
    let response = data.response;
    const { url: url, options: options = {} } = data;
    // Check for token expiration (401 Unauthorized)
    if (response.status === $81a8de639190806b$export$eef5945dfeccfc61.UNAUTHORIZED) try {
        // Hit the refresh endpoint to fetch a new access token
        const userStillLoggedIn = await (0, $bLIxp.default).refreshAccessToken();
        if (userStillLoggedIn) {
            // Retry the original request with the new access token
            options.headers = options.headers ?? {};
            options.headers["Authorization"] = (0, $bLIxp.default).getBearerToken();
            response = await fetch(url, options);
        }
    } catch (error) {
        (0, $9w0rm.default).error("autoHandleExpiredAccessToken error: ", error);
    }
    return response;
}

});

parcelRegister("gB5us", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9db888be98751495$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ROUTES", function () { return (parcelRequire("hSqCk")); });

var $hSqCk = parcelRequire("hSqCk");
var $9db888be98751495$export$2e2bcd8739ae039 = [
    {
        path: $hSqCk.HOME,
        authRequired: false,
        component: "Home"
    },
    {
        path: $hSqCk.SIGNIN,
        authRequired: false,
        component: "Login"
    },
    {
        path: $hSqCk.SIGNIN_TWO_FACTOR_CONFIRMATION,
        authRequired: false,
        component: "Login"
    },
    {
        path: $hSqCk.SIGNUP,
        authRequired: false,
        component: "Register"
    },
    {
        path: $hSqCk.REQUEST_PASSWORD_RESET,
        authRequired: false,
        component: "PasswordResetRequest"
    },
    {
        path: $hSqCk.RESET_PASSWORD,
        authRequired: false,
        component: "PasswordReset"
    },
    {
        path: $hSqCk.RESET_PASSWORD_TWO_FACTOR_AUTHENTICATION,
        authRequired: false,
        component: "PasswordReset" // Use same component as password reset. Let it detect that it's a 2fa reset.
    },
    {
        path: $hSqCk.SHOP,
        authRequired: false,
        component: "Shop"
    },
    {
        path: $hSqCk.BRAND,
        authRequired: false,
        component: "Brand"
    },
    {
        path: $hSqCk.CATEGORY,
        authRequired: false,
        component: "Category"
    },
    {
        path: $hSqCk.CART,
        authRequired: false,
        component: "Cart"
    },
    {
        path: $hSqCk.CHECKOUT,
        authRequired: false,
        component: "Checkout"
    },
    {
        path: $hSqCk.PRODUCT,
        authRequired: false,
        component: "Product"
    },
    {
        path: $hSqCk.PAYMENT_STATUS,
        authRequired: false,
        component: "PaymentStatus"
    },
    {
        path: $hSqCk.PAY_FOR_ORDER,
        authRequired: false,
        component: "OrderPayment"
    },
    {
        path: $hSqCk.WISHLIST,
        authRequired: false,
        component: "Wishlist"
    },
    {
        path: $hSqCk.VERIFY_EMAIL,
        authRequired: false,
        component: "EmailVerification"
    },
    {
        path: $hSqCk.PRODUCT_COMPARE,
        authRequired: false,
        component: "ProductCompare"
    },
    {
        path: $hSqCk.ORDER_TRACKING,
        authRequired: false,
        component: "OrderTracking"
    },
    {
        path: $hSqCk.PRIVACY_POLICY,
        authRequired: false,
        component: "PrivacyPolicy"
    },
    {
        path: $hSqCk.ABOUT_US,
        authRequired: false,
        component: "AboutUs"
    },
    {
        path: $hSqCk.CONTACT_US,
        authRequired: false,
        component: "ContactUs"
    },
    {
        path: $hSqCk.SEARCH,
        authRequired: false,
        component: "Search"
    },
    {
        path: $hSqCk.ORDER_LISTING,
        authRequired: true,
        component: "OrderListing"
    },
    {
        path: $hSqCk.ORDER_DETAILS,
        authRequired: true,
        component: "OrderDetails"
    }
];

});
parcelRegister("hSqCk", function(module, exports) {

$parcel$export(module.exports, "HOME", function () { return $9ce7621529781793$export$a7c5707626fc90f; });
$parcel$export(module.exports, "SIGNIN", function () { return $9ce7621529781793$export$ae94a804fa92ec6d; });
$parcel$export(module.exports, "SIGNIN_TWO_FACTOR_CONFIRMATION", function () { return $9ce7621529781793$export$e8bc6877e08c07ee; });
$parcel$export(module.exports, "SIGNUP", function () { return $9ce7621529781793$export$942ff90a7f53f719; });
$parcel$export(module.exports, "REQUEST_PASSWORD_RESET", function () { return $9ce7621529781793$export$6b700fc3a13de93; });
$parcel$export(module.exports, "RESET_PASSWORD", function () { return $9ce7621529781793$export$bf768f070251ce56; });
$parcel$export(module.exports, "RESET_PASSWORD_TWO_FACTOR_AUTHENTICATION", function () { return $9ce7621529781793$export$91ba2ceaac4e3bd2; });
$parcel$export(module.exports, "SHOP", function () { return $9ce7621529781793$export$7c7d5795114795c8; });
$parcel$export(module.exports, "BRAND", function () { return $9ce7621529781793$export$cf2deea74cde46b4; });
$parcel$export(module.exports, "CATEGORY", function () { return $9ce7621529781793$export$2c04807512a22510; });
$parcel$export(module.exports, "CART", function () { return $9ce7621529781793$export$7bdecb28ecd67098; });
$parcel$export(module.exports, "CHECKOUT", function () { return $9ce7621529781793$export$5353295c12db8f9e; });
$parcel$export(module.exports, "PRODUCT", function () { return $9ce7621529781793$export$e36553b0ff5db35a; });
$parcel$export(module.exports, "PAYMENT_STATUS", function () { return $9ce7621529781793$export$e71425624a5600f0; });
$parcel$export(module.exports, "PAY_FOR_ORDER", function () { return $9ce7621529781793$export$21cd1e0a1d6084a7; });
$parcel$export(module.exports, "WISHLIST", function () { return $9ce7621529781793$export$6d0b8327861c2ed3; });
$parcel$export(module.exports, "VERIFY_EMAIL", function () { return $9ce7621529781793$export$f052772c18d4f88; });
$parcel$export(module.exports, "PRODUCT_COMPARE", function () { return $9ce7621529781793$export$fee7c94762015351; });
$parcel$export(module.exports, "ORDER_TRACKING", function () { return $9ce7621529781793$export$9d8f2c54033793f0; });
$parcel$export(module.exports, "PRIVACY_POLICY", function () { return $9ce7621529781793$export$ecf6508459835aaf; });
$parcel$export(module.exports, "ABOUT_US", function () { return $9ce7621529781793$export$3dad34f770fcb308; });
$parcel$export(module.exports, "CONTACT_US", function () { return $9ce7621529781793$export$f8b031824e68df83; });
$parcel$export(module.exports, "SEARCH", function () { return $9ce7621529781793$export$a6b9aaee40d49fd0; });
$parcel$export(module.exports, "ORDER_LISTING", function () { return $9ce7621529781793$export$51981c19912cffd3; });
$parcel$export(module.exports, "ORDER_DETAILS", function () { return $9ce7621529781793$export$c15b713113540d5a; });
// The export names can be nouns or verbs
const $9ce7621529781793$export$a7c5707626fc90f = "/";
const $9ce7621529781793$export$ae94a804fa92ec6d = "/login";
const $9ce7621529781793$export$e8bc6877e08c07ee = "/login/verify";
const $9ce7621529781793$export$942ff90a7f53f719 = "/register";
const $9ce7621529781793$export$6b700fc3a13de93 = "/password/forgot";
const $9ce7621529781793$export$bf768f070251ce56 = "/password/reset";
const $9ce7621529781793$export$91ba2ceaac4e3bd2 = "/password/reset/verify";
const $9ce7621529781793$export$7c7d5795114795c8 = "/shop";
const $9ce7621529781793$export$cf2deea74cde46b4 = "/shop/brands/:brandName";
const $9ce7621529781793$export$2c04807512a22510 = "/shop/categories/:categoryName";
const $9ce7621529781793$export$7bdecb28ecd67098 = "/cart";
const $9ce7621529781793$export$5353295c12db8f9e = "/checkout";
const $9ce7621529781793$export$e36553b0ff5db35a = "/products/:productId";
const $9ce7621529781793$export$e71425624a5600f0 = "/payments/status";
const $9ce7621529781793$export$21cd1e0a1d6084a7 = "/orders/:orderReferenceNumber/pay";
const $9ce7621529781793$export$6d0b8327861c2ed3 = "/wishlist";
const $9ce7621529781793$export$f052772c18d4f88 = "/email/verify";
const $9ce7621529781793$export$fee7c94762015351 = "/products/:productId/compare";
const $9ce7621529781793$export$9d8f2c54033793f0 = "/orders/:orderReferenceNumber/track";
const $9ce7621529781793$export$ecf6508459835aaf = "/privacy-policy";
const $9ce7621529781793$export$3dad34f770fcb308 = "/about-us";
const $9ce7621529781793$export$f8b031824e68df83 = "/contact-us";
const $9ce7621529781793$export$a6b9aaee40d49fd0 = "/shop/search";
const $9ce7621529781793$export$51981c19912cffd3 = "/orders";
const $9ce7621529781793$export$c15b713113540d5a = "/orders/:orderReferenceNumber";

});


parcelRegister("9t5Ss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5b9f1b246c13439$export$2e2bcd8739ae039; });

var $1RJFN = parcelRequire("1RJFN");

var $kHtqW = parcelRequire("kHtqW");
const $a5b9f1b246c13439$var$dataStore = new (0, $kHtqW.default)("StorageService", {
    enableCaching: true,
    enableCacheCompression: (0, $1RJFN.toBoolean)("true"),
    cache: localStorage
});
class $a5b9f1b246c13439$export$2e2bcd8739ae039 {
    static setItem(key, data) {
        return $a5b9f1b246c13439$var$dataStore.set(key, data); // return localStorage.setItem(key, JSON.stringify(data));
    }
    static getItem(key) {
        return $a5b9f1b246c13439$var$dataStore.get(key);
    /*const item = localStorage.getItem(key);

    try {
      if(item) { 
        return JSON.parse(item);
      }
    } catch {
      return item;
    }*/ }
    static removeItem(key) {
        return $a5b9f1b246c13439$var$dataStore.delete(key); // return localStorage.removeItem(key);
    }
}

});
parcelRegister("1RJFN", function(module, exports) {

$parcel$export(module.exports, "cleanForDisplay", function () { return $b8250d7b0cb21678$export$43e36ca0210036bf; });
$parcel$export(module.exports, "decodeSpecialChars", function () { return $b8250d7b0cb21678$export$ab1b0877c21dba53; });
$parcel$export(module.exports, "sanitizeData", function () { return $b8250d7b0cb21678$export$7ca33c02e12018a6; });
$parcel$export(module.exports, "sanitizeString", function () { return $b8250d7b0cb21678$export$4fbe97595eedc968; });
$parcel$export(module.exports, "shorten", function () { return $b8250d7b0cb21678$export$dd78866213f805a5; });
$parcel$export(module.exports, "toTitleCase", function () { return $b8250d7b0cb21678$export$f06f8b3003f18927; });
$parcel$export(module.exports, "stringToSlug", function () { return $b8250d7b0cb21678$export$5b2cbc89429643df; });
$parcel$export(module.exports, "toBoolean", function () { return $b8250d7b0cb21678$export$3c2e6d1b7583eee6; });
function $b8250d7b0cb21678$export$43e36ca0210036bf(str) {
    return $b8250d7b0cb21678$export$ab1b0877c21dba53(str);
}
function $b8250d7b0cb21678$export$ab1b0877c21dba53(str) {
    if (!str) return str;
    const res = [
        {
            re: /&lt;/gm,
            ch: "<"
        },
        {
            re: /&gt;/gm,
            ch: ">"
        },
        {
            re: /&amp;/gm,
            ch: "&"
        },
        {
            re: /&quot;/gm,
            ch: "\""
        },
        {
            re: /&#x27;/gm,
            ch: "'"
        },
        {
            re: /&#x2F;/gm,
            ch: "/"
        },
        {
            re: /&#x5C;/gm,
            ch: "\\"
        }
    ];
    for(let i = 0; i < res.length; i++)str = str.replace(res[i].re, res[i].ch);
    return str;
}
function $b8250d7b0cb21678$export$db76b8692399c383(template, data) {
    return template.replace(/{{(.*?)}}/g, (_, key)=>{
        return data[key] !== undefined ? data[key] : '';
    });
/**
 * USAGE EXAMPLE:
 * const templateString = "Hello, {{name}}! You are {{age}} years old.";
 * const dataObject = { name: "John", age: 30 };
 * const result = replacePlaceholders(templateString, dataObject);
 * console.log(result); // Output: Hello, John! You are 30 years old.
 */ }
function $b8250d7b0cb21678$export$7ca33c02e12018a6(results, key) {
    return (results ?? []).map((result)=>({
            ...result,
            [key]: $b8250d7b0cb21678$export$ab1b0877c21dba53(result[key])
        }));
}
function $b8250d7b0cb21678$export$4fbe97595eedc968(input) {
    return input.replace(/[<>:"\/\\|?*\x00-\x1F.]/g, ""); // eslint-disable-line
}
function $b8250d7b0cb21678$export$dd78866213f805a5(input, maxLen = 30) {
    return input.substring(0, maxLen - 1) + (input.length > maxLen ? "..." : "");
}
function $b8250d7b0cb21678$export$32d87a40faf1e496(input) {
    return input.replace(/([A-Z])/g, " $1").trim();
}
function $b8250d7b0cb21678$export$f06f8b3003f18927(str) {
    return str.split(" ").map((w)=>w[0].toUpperCase() + w.substring(1)).join(" ");
}
function $b8250d7b0cb21678$export$5b2cbc89429643df(str) {
    str = str.trim(); //str.replace(/^\s+|\s+$/g, ""); // trim
    str = str.toLowerCase();
    // remove accents, swap ñ for n, etc
    const from = "\xe0\xe1\xe4\xe2\xe8\xe9\xeb\xea\xec\xed\xef\xee\xf2\xf3\xf6\xf4\xf9\xfa\xfc\xfb\xf1\xe7\xb7/_,:;";
    const to = "aaaaeeeeiiiioooouuuunc------";
    for(let i = 0; i < from.length; i++)str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    str = str.replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-"); // collapse dashes
    return str;
}
function $b8250d7b0cb21678$export$3c2e6d1b7583eee6(val) {
    const specialTypes = {
        "false": false,
        "true": true,
        "null": null
    };
    for (const type of Object.keys(specialTypes))if (typeof val === "string" && val.trim().match(new RegExp(`^\\(?${type}\\)?$`))) val = specialTypes[type];
    if (typeof val !== "boolean") val = Boolean(Number(val));
    return val;
}

});

parcelRegister("kHtqW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35e5b3cb6a2ad3c5$export$2e2bcd8739ae039; });
/** 
 * Name : DataStore 
 * Description : Data structuring for the application 
 * Stores recurring resources... 
 * Such as images/profile data etc.  
 */ 
var $7ATg2 = parcelRequire("7ATg2");

var $9w0rm = parcelRequire("9w0rm");

var $bLIxp = parcelRequire("bLIxp");
function $35e5b3cb6a2ad3c5$export$2e2bcd8739ae039(name, config) {
    config = config || {
        // Caching is enabled by default
        // Set `config.enableCache = false` 
        // if you want to disable caching
        enableCaching: true,
        // Cache data compression is enabled by default
        // Set `config.enableCacheCompression = false` 
        // if you want to disable cache compression
        enableCacheCompression: true,
        // Caching is done in the localStorage, 
        // overide this function and the set function to change this
        cache: localStorage
    };
    if (typeof name !== "string" || name.trim().length === 0) throw new Error("DataStore object expects a name string property");
    if (typeof config.enableCaching === "undefined") config.enableCaching = true;
    if (typeof config.enableCacheCompression === "undefined") config.enableCacheCompression = true;
    if (config.enableCaching) {
        const isValidCache = config.cache && typeof config.cache === "object" && typeof config.cache.getItem === "function" && typeof config.cache.setItem === "function" && typeof config.cache.removeItem === "function";
        if (!isValidCache) config.cache = localStorage;
    }
    this.queue = [];
    this.store = {}; // Internal store/cache, different from supplied cache.
    this.name = name.trim();
    this.config = config;
    this.cache = config.cache;
    if (this.config.enableCaching) {
        const store = $35e5b3cb6a2ad3c5$var$deserialize(this.cache.getItem(this.name), this.config.enableCacheCompression);
        if (store) this.store = store;
        for(const data in store)//if(Object.prototype.hasOwnProperty.call(store, data)) {
        if (Object.hasOwn(store, data)) this.queue.push(data);
    }
}
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype._getStore = function() {
    let store = this.store;
    if (!store && this.config.enableCaching) store = $35e5b3cb6a2ad3c5$var$deserialize(this.cache.getItem(this.name), this.config.enableCacheCompression);
    return store ?? {};
};
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype._replaceCachedStore = function(newStore) {
    if (this.config.enableCaching) this.cache.setItem(this.name, $35e5b3cb6a2ad3c5$var$serialize(newStore, this.config.enableCacheCompression));
};
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype._getQueue = function() {
    return this.queue;
};
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype._pushToQueue = function(key) {
    this.queue.push(key);
};
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype._inQueue = function(key) {
    for(let i = 0; i < this.queue.length; i++){
        if (this.queue[i] === key) return true;
    }
    return false;
};
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype._removeOldestValueInQueue = function() {
    //const key = this.queue.shift(); // Remove the item from the internal queue.
    //this.delete(key);               // Remove the item from local store and cache storage.
    // Switch to using a delete with exemption method 
    // so we don't delete a logged-in user's access token by mistake.
    const ACCESS_TOKEN_KEY = (0, $bLIxp.default).getAccessTokenKey();
    //this._removeOldestValue_ExceptExemptionList_FromQueue([ACCESS_TOKEN_KEY]);
    this._removeOldestValue_ExceptExemptionMap_FromQueue({
        [ACCESS_TOKEN_KEY]: 9
    });
};
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype._removeOldestValue_ExceptExemptionList_FromQueue = function(exemptionList) {
    // Convert array to a Set for O(1) fast lookups
    const exemptions = new Set(exemptionList ?? []);
    let attempts = this.queue.length;
    while(attempts > 0){
        const key = this.queue.shift(); // Take the oldest item
        if (exemptions.has(key)) {
            this._pushToQueue(key); // Rotate exempted key to the back
            attempts--; // Decrease count to prevent infinite loops
        } else {
            this.delete(key); // Delete the first non-exempted key
            return; // Exit the function immediately
        }
    }
};
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype._removeOldestValue_ExceptExemptionMap_FromQueue = function(exemptionPriorityMap) {
    // Item with the lowest priority will be deleted first if all items in the queue are exempted.
    if (this.queue.length === 0) return;
    let attempts = this.queue.length;
    let lowestPriorityKey = null;
    let lowestPriorityValue = Infinity;
    let lowestPriorityIndex = -1;
    // Try to find the oldest non-exempted item
    while(attempts > 0){
        const key = this.queue.shift();
        // Check if the key is exempted
        if (key in exemptionPriorityMap) {
            const currentPriority = exemptionPriorityMap[key];
            // Track the item with the lowest priority (smallest number)
            if (currentPriority < lowestPriorityValue) {
                lowestPriorityValue = currentPriority;
                lowestPriorityKey = key;
                // The index will be at the back of the queue after we push it
                lowestPriorityIndex = this.queue.length;
            }
            this._pushToQueue(key); // Rotate to the back
            attempts--;
        } else {
            // Found a non-exempted item! Delete it and exit.
            this.delete(key);
            return;
        }
    }
    // If we reach here, ALL items in the queue were exempted.
    // Remove the lowest priority item from its current position in the queue.
    if (lowestPriorityKey !== null) {
        this.queue.splice(lowestPriorityIndex, 1);
        this.delete(lowestPriorityKey);
    }
};
// Public API 
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype.get = function(key) {
    return this._getStore()[key];
};
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype.set = function(key, value) {
    this.store = this._getStore();
    this.store[key] = value;
    try {
        // Try to add the updated store, containing the new item to add, 
        // to local storage...
        this._replaceCachedStore(this.store);
        // If the update was successful, 
        // push the recently added item to the end of the queue.
        if (!this._inQueue(key)) this._pushToQueue(key);
    } catch (error) {
        if (error.name === "QuotaExceededError") {
            (0, $9w0rm.default).error("LocalStorage quota exceeded. Deleting some items to make space...");
            // If adding the item fails due to large size, 
            // remove the oldest item from the store.
            // This reduces the size of the store object.
            this._removeOldestValueInQueue();
            // Then try adding the item again. 
            // Repeate the process until a large enough item 
            // has been removed from the store to allow the new item.
            this.set(key, value);
        } else (0, $9w0rm.default).error(`Error adding item ${key} to cache`, error);
    }
};
$35e5b3cb6a2ad3c5$export$2e2bcd8739ae039.prototype.delete = function(key) {
    this.store = this._getStore();
    if (this.store[key]) {
        delete this.store[key];
        try {
            this._replaceCachedStore(this.store);
        } catch (error) {
            (0, $9w0rm.default).error(error);
        }
    }
};
// Helper functions 
function $35e5b3cb6a2ad3c5$var$serialize(data, shouldCompress) {
    const json = $35e5b3cb6a2ad3c5$var$toJSON(data);
    return shouldCompress ? $35e5b3cb6a2ad3c5$var$compress(json) : json;
}
function $35e5b3cb6a2ad3c5$var$deserialize(serializedData, isCompressed) {
    const jsonStr = isCompressed ? $35e5b3cb6a2ad3c5$var$decompress(serializedData) : serializedData;
    return $35e5b3cb6a2ad3c5$var$parseJSON(jsonStr);
}
/**
 * To do away with this compress function, 
 * - First, replace all calls to `compress` with `JSON.stringify`
 * - You can then delete this function if you want.
 */ function $35e5b3cb6a2ad3c5$var$compress(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7ATg2))).compressToUTF16(data);
}
/**
 * To do away with this decompress method, 
 * - First, replace all calls to `decompress` with `JSON.parse` 
 * - You can then delete this function if you want.
 */ function $35e5b3cb6a2ad3c5$var$decompress(compressedString) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7ATg2))).decompressFromUTF16(compressedString);
}
function $35e5b3cb6a2ad3c5$var$parseJSON(jsonString) {
    try {
        return JSON.parse(jsonString);
    } catch (error) {
        (0, $9w0rm.default).error(error);
        return undefined;
    }
}
function $35e5b3cb6a2ad3c5$var$toJSON(data) {
    return JSON.stringify(data);
}

});
parcelRegister("7ATg2", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

});




parcelRegister("ehJ6T", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", function () { return $a7a0fdc843cb58b5$export$3901076af3749fa9; });
$parcel$export(module.exports, "clearCachedUser", function () { return (parcelRequire("hcamj")).clearCachedUser; });
//import { useEffect } from "react";

var $1KXyM = parcelRequire("1KXyM");

var $bLIxp = parcelRequire("bLIxp");
parcelRequire("aIP2u");
var $hcamj = parcelRequire("hcamj");
var $aIP2u = parcelRequire("aIP2u");
let $a7a0fdc843cb58b5$var$expiry = 0;
const $a7a0fdc843cb58b5$var$msToExpire = (0, $1KXyM.secondsToMilliseconds)((0, $1KXyM.minutesToSeconds)(1));
function $a7a0fdc843cb58b5$export$3901076af3749fa9() {
    const [currentUser, isFetchingCurrentUser, fetchCurrentUser, setCurrentUser] = (0, $aIP2u.default)();
    async function proxyFetchCurrentUser() {
        // Because a user might manually call the proxyFetchCurrentUser (exported as fetchCurrentUser) 
        // We want to ensure that: 
        // If the user is not logged in, no need to call the `/authenticate` API endpoint.
        // This will be the case when AuthService.isAuthenticatedUser() is false. 
        // AuthService.isAuthenticatedUser() checks to see if an access token is set.
        // The access token is set when the user logs in from the login form 
        // and is unset when the user logs out.
        // So, if the user is logged-in, it will be set. Otherwise, it will not be set.
        // We make use of that knowledge to avoid calling the `/authenticate` API endpoint 
        // unnecessarily when the user is not logged in.
        //
        // If the user is logged-in, however, that is, access token is set, 
        // then, we proceed below to check whether their access token is still valid 
        // or if a fetch user request is currently ongoing. 
        // Only if all these fail do we finally make a request to the `/authenticate` API endpoint.
        if (!(0, $bLIxp.default).isAuthenticatedUser()) return null;
        // Because a user might manually call the proxyFetchCurrentUser (exported as fetchCurrentUser) 
        // We want to ensure that if a fetchCurrentUser request is already in progress 
        // or an arbitrary expiry time has not passed, their new request should not be fired.
        if ($a7a0fdc843cb58b5$var$expiry > Date.now() || isFetchingCurrentUser) return;
        //retryWithExponentialBackOff(async () => {
        // fetchCurrentUser (augmented and returned by useCurrentUserHook() which is returned by createDataHook()) 
        // also automatically calls setCurrentUser() 
        // with the data of the returned user. 
        // However, it also returns the current user's data.
        // So, we can manually also call setCurrentUser with the returned user's data.
        await fetchCurrentUser();
        $a7a0fdc843cb58b5$var$expiry = Date.now() + $a7a0fdc843cb58b5$var$msToExpire;
    //});
    }
    // Move this to the initializeApp hook 
    // That way, we don't make a fetchCurrentUser() request 
    // every time a component that uses this hook mounts.
    // Instead, we make a fetchCurrentUser() the first time the application (App component) mounts.
    // Then, fetchCurrentUser() is only ever called again by components that need it to be called, 
    // for example, Wishlist, OrderListing, and themes/limupa/header/helper-components/wishlist-count.
    /*useEffect(() => {
    if(!currentUser) {
      proxyFetchCurrentUser();
    }
  }, []);*/ return [
        currentUser,
        isFetchingCurrentUser,
        proxyFetchCurrentUser,
        setCurrentUser
    ];
} /*export function usePreFetchedCurrentUser(): [IUser | null, boolean, boolean, typeof setCurrentUser] {
  const userFetchedRef = useRef(false); 
  const [prevUser, setPrevUser] = useState<IUser|null>(null);
  const [currentUser, isFetchingCurrentUser, fetchCurrentUser, setCurrentUser] = useCurrentUserHook();

  useEffect(() => {
    if(currentUser !== prevUser) {
      setPrevUser(currentUser);
    }
  }, [currentUser, prevUser]);
    
  useEffect(() => {
    if(!currentUser && !userFetchedRef.current && !isFetchingCurrentUser) {
      fetchCurrentUser().then((res) => {
        userFetchedRef.current = true;
      });
    }
  }, [currentUser, isFetchingCurrentUser, userFetchedRef.current]);

  return [currentUser, isFetchingCurrentUser, userFetchedRef.current, setCurrentUser];
}*/ 

});
parcelRegister("aIP2u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec494758dd0bb878$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "clearCachedUser", function () { return (parcelRequire("hcamj")).clearCachedUser; });

var $2Wbq7 = parcelRequire("2Wbq7");

var $hcamj = parcelRequire("hcamj");
var $ec494758dd0bb878$export$2e2bcd8739ae039 = (0, $2Wbq7.default)(null, (0, $hcamj.fetchCurrentUser));

});
parcelRegister("2Wbq7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04cbada5e7d49534$export$2e2bcd8739ae039; });

var $11ryz = parcelRequire("11ryz");
function $04cbada5e7d49534$export$2e2bcd8739ae039(initialState, dataFetcher) {
    const [useIsFetchingData, setIsFetchingData] = (0, $11ryz.default)(false);
    const [useData, setData] = (0, $11ryz.default)(initialState);
    async function fetchData(...args) {
        setIsFetchingData(true);
        const data = await dataFetcher(...args);
        setData(data);
        setIsFetchingData(false);
    }
    return function useDataExported() {
        const isFetchingData = useIsFetchingData();
        const data = useData();
        return [
            data,
            isFetchingData,
            fetchData,
            setData
        ];
    };
}

});
parcelRegister("11ryz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3447b32d0b6f5c93$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
function $3447b32d0b6f5c93$export$2e2bcd8739ae039(initialStore) {
    let store = initialStore;
    const listeners = new Set();
    function getStore() {
        return store;
    }
    function dispatch(newStore) {
        const oldStore = store;
        // Make it like reacts setState
        // so if you pass in a function you can get the store value first
        store = typeof newStore === "function" ? newStore(store) : newStore;
        if (!shouldUpdate(oldStore, store)) return;
        listeners.forEach((listener)=>listener(()=>store));
    }
    function subscribe(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    }
    function useStore() {
        return (0, $exYeM.useSyncExternalStore)(subscribe, getStore);
    }
    function shouldUpdate(a, b) {
        if ((!a || !b) && a !== b) return true;
        if (typeof a !== "object" || typeof b !== "object") return true;
        if (Object.keys(a || {}).length !== Object.keys(b || {}).length) return true;
        // (b) needs to be an object or you will have to do checks before looping
        // make sure your store is an object or check it in this function.
        for(const key in b){
            if (b[key] !== a[key]) return true;
        }
        return false;
    }
    return [
        useStore,
        dispatch
    ];
}

});


parcelRegister("hcamj", function(module, exports) {

$parcel$export(module.exports, "clearCachedUser", function () { return $f6706f2290b9416b$export$20b643857c1c0b07; });
$parcel$export(module.exports, "fetchCurrentUser", function () { return $f6706f2290b9416b$export$1efbf588c53462f7; });

var $7DA0g = parcelRequire("7DA0g");

var $1KXyM = parcelRequire("1KXyM");

var $4FeSR = parcelRequire("4FeSR");

var $9w0rm = parcelRequire("9w0rm");

var $jjGdj = parcelRequire("jjGdj");
let $f6706f2290b9416b$var$clearCachedCurrentUser;
function $f6706f2290b9416b$export$20b643857c1c0b07() {
    $f6706f2290b9416b$var$clearCachedCurrentUser?.();
}
async function $f6706f2290b9416b$export$1efbf588c53462f7() {
    try {
        // If we have the user cached, just return it.
        // Otherwise, make a request to fetch the user
        // and then cache the response if successful.
        const response = await (0, $7DA0g.default)((0, $jjGdj.default).getCurrentUser, {
            cacheKey: "cached_user",
            expiresIn: (0, $1KXyM.minutesToSeconds)(Number("15") || 15),
            isSuccessfulRequest: (data)=>!!data?.user
        });
        const { data: data, clearCachedResponse: clearCachedResponse } = response;
        $f6706f2290b9416b$var$clearCachedCurrentUser = clearCachedResponse;
        return data?.user;
    } catch (error) {
        (0, $9w0rm.default).error("store::currentUser::fetchCurrentUser:: Error fetching current user", error);
        if ((0, $4FeSR.isServerDownError)(error)) throw error;
        return null;
    }
}

});
parcelRegister("7DA0g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7b3bfc3f2407add$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "withCachedResponse", function () { return $d7b3bfc3f2407add$export$c0f9691a4e70aa0e; });

var $9t5Ss = parcelRequire("9t5Ss");

var $1KXyM = parcelRequire("1KXyM");

var $4FeSR = parcelRequire("4FeSR");

var $9w0rm = parcelRequire("9w0rm");
async function $d7b3bfc3f2407add$export$2e2bcd8739ae039(request, options) {
    const { cacheKey: key, expiresIn: secondsToExpire = 300 } = options ?? {};
    let data = null;
    const msToExpire = (0, $1KXyM.secondsToMilliseconds)(secondsToExpire);
    const cachedItem = (0, $9t5Ss.default).getItem(key);
    try {
        const cache = cachedItem ?? null;
        if (cache?.data && cache?.expiry > Date.now()) data = cache.data;
        else {
            // Clear any previously cached but expired response(s) 
            // so that we don't fill the local storage too fast
            clearCachedResponse();
            const response = await request();
            if (response && "success" in response) {
                data = response.data;
                (0, $9t5Ss.default).setItem(key, {
                    data: data,
                    expiry: Date.now() + msToExpire
                });
            } else if (response && "error" in response) (0, $9w0rm.default).error(`helpers::makeCachedRequest: API returned error response:`, response.errorData.message);
        }
    } catch (error) {
        (0, $9w0rm.default).error("helpers::makeCachedRequest: Error", error);
        if ((0, $4FeSR.isServerDownError)(error)) throw error;
    }
    return {
        data: data,
        clearCachedResponse: clearCachedResponse
    };
    function clearCachedResponse() {
        if ((0, $9t5Ss.default).getItem(key)) (0, $9t5Ss.default).removeItem(key);
    }
}
function $d7b3bfc3f2407add$export$c0f9691a4e70aa0e(callback, options) {
    const { cacheKey: cacheKey = "", expiresIn: secondsToExpire = 300, isSuccessfulRequest: isSuccessfulRequest = ()=>true } = options ?? {};
    let data = null;
    const msToExpire = (0, $1KXyM.secondsToMilliseconds)(secondsToExpire);
    //const cachedItem = StorageService.getItem(key);
    function sort(object) {
        const sortedEntries = Object.entries(object).sort((a, b)=>a[0].localeCompare(b[0]));
        const withSortedValues = sortedEntries.map(([key, value])=>{
            const isObject = typeof value === 'object' && value !== null;
            const newVal = isObject ? sort(value) : value;
            return [
                key,
                newVal
            ];
        });
        return Object.fromEntries(withSortedValues);
    }
    function replacer(k, v) {
        return v === undefined ? "[undefined]" : v;
    }
    function getKey(obj) {
        return JSON.stringify(sort(obj), replacer);
    }
    return async function wrapped(...args) {
        let key = cacheKey;
        if (args.length > 0) {
            if (key.length > 0) key = `${key}_${getKey(args)}`;
            else key = getKey(args);
        }
        const cachedItem = (0, $9t5Ss.default).getItem(key);
        const cache = cachedItem ?? null;
        function clearCachedResponse() {
            if ((0, $9t5Ss.default).getItem(key)) (0, $9t5Ss.default).removeItem(key);
        }
        /* @ts-expect-error: don't check for TS error */ if (typeof wrapped.clearCache !== "function") /* @ts-expect-error: don't check for TS error */ wrapped.clearCache = clearCachedResponse;
        if (cache?.data && cache?.expiry > Date.now()) data = cache.data;
        else {
            // Clear any previously cached but expired response(s) 
            // so that we don't fill the local storage too fast
            clearCachedResponse();
            data = await callback(...args);
            // If `cacheOnlyOnSuccess` is false, then cache whatever result is returned.
            // However, if `cacheOnlyOnSuccess` is true, then cache only a successful request.
            if (isSuccessfulRequest(data)) (0, $9t5Ss.default).setItem(key, {
                data: data,
                expiry: Date.now() + msToExpire
            });
        }
        return data;
    };
}

});

parcelRegister("jjGdj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edf27797917f29ac$export$2e2bcd8739ae039; });

var $kdahk = parcelRequire("kdahk");
const $edf27797917f29ac$var$endpoint = "/users";
const $edf27797917f29ac$var$wishlistEndpoint = "/wishlists";
const $edf27797917f29ac$var$twoFactorAuthBaseEndpoint = "/auth/two-factor";
const $edf27797917f29ac$var$passwordResetBaseEndpoint = "/password/reset";
class $edf27797917f29ac$export$2e2bcd8739ae039 {
    static async createUser(userData) {
        return await (0, $kdahk.default).post($edf27797917f29ac$var$endpoint, undefined, userData);
    }
    static async resendVerificationCode({ email: email }) {
        return await (0, $kdahk.default).post("/email/verification/resend", undefined, {
            email: email
        });
    }
    static async verifyEmail(verificationCode) {
        return await (0, $kdahk.default).get(`/email/verification/verify?verificationCode=${verificationCode}`);
    }
    static async login(loginCreds) {
        return await (0, $kdahk.default).post("/login", undefined, loginCreds);
    }
    static async loginWithTwoFactorAuth(authCode, endpoint) {
        endpoint = endpoint || "/login/two-factor-auth";
        return await (0, $kdahk.default).post(endpoint, null, {
            auth_code: authCode
        });
    }
    static async requestEnableTwoFactorAuth(authMethod) {
        const endpoint = `${$edf27797917f29ac$var$twoFactorAuthBaseEndpoint}/enable/request`;
        return await (0, $kdahk.default).post(endpoint, null, {
            auth_method: authMethod
        });
    }
    static async enableTwoFactorAuth(authCode) {
        const endpoint = `${$edf27797917f29ac$var$twoFactorAuthBaseEndpoint}/enable`;
        return await (0, $kdahk.default).post(endpoint, null, {
            auth_code: authCode
        });
    }
    static async requestDisableTwoFactorAuth() {
        const endpoint = `${$edf27797917f29ac$var$twoFactorAuthBaseEndpoint}/disable/request`;
        return await (0, $kdahk.default).post(endpoint, null, {});
    }
    static async disableTwoFactorAuth(authCode) {
        const endpoint = `${$edf27797917f29ac$var$twoFactorAuthBaseEndpoint}/disable`;
        return await (0, $kdahk.default).post(endpoint, null, {
            auth_code: authCode
        });
    }
    static async logout() {
        return await (0, $kdahk.default).get("/logout");
    }
    static async requestPasswordReset(email) {
        const endpoint = `${$edf27797917f29ac$var$passwordResetBaseEndpoint}/request`;
        return await (0, $kdahk.default).post(endpoint, null, {
            email: email
        });
    }
    static async resetPassword(data) {
        const endpoint = $edf27797917f29ac$var$passwordResetBaseEndpoint;
        const { password: password, resetCode: resetCode, userId: userId, fromAccountSettings: fromAccountSettings, resendTwoFactorAuthCode: resendTwoFactorAuthCode } = data;
        return await (0, $kdahk.default).put(endpoint, null, {
            password: password,
            reset_code: resetCode,
            user_id: userId,
            from_account_settings: fromAccountSettings,
            resend_two_factor_auth_code: resendTwoFactorAuthCode
        });
    }
    static async resetPasswordWithTwoFactorAuth(data) {
        const { userId: userId, password: password, authCode: authCode, endpoint: endpoint = `${$edf27797917f29ac$var$passwordResetBaseEndpoint}/two-factor-auth` } = data;
        return await (0, $kdahk.default).put(endpoint, null, {
            password: password,
            user_id: userId,
            auth_code: authCode
        });
    }
    static async getUser(userId) {
        return await (0, $kdahk.default).get(`${$edf27797917f29ac$var$endpoint}/:userId`, {
            userId: userId
        });
    }
    static async getCurrentUser() {
        return await (0, $kdahk.default).get("/authenticate");
    }
    static async addItemToUserWishlist(userId, item) {
        return await (0, $kdahk.default).post($edf27797917f29ac$var$wishlistEndpoint, undefined, {
            user_id: userId,
            entity_id: item.id,
            entity_type: item.type
        });
    }
    static async removeItemFromUserWishlist(userId, itemId) {
        return await (0, $kdahk.default).delete($edf27797917f29ac$var$wishlistEndpoint, undefined, {
            user_id: userId,
            entity_id: itemId
        });
    }
    static async getUserWishlist(userId, params) {
        return await (0, $kdahk.default).get(`${$edf27797917f29ac$var$wishlistEndpoint}/${userId}`, params);
    }
    static async getUserWishlistCount(userId) {
        return await (0, $kdahk.default).get(`${$edf27797917f29ac$var$wishlistEndpoint}/${userId}/count`);
    }
}

});
parcelRegister("kdahk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fac3660e23fc29c$export$2e2bcd8739ae039; });

var $a7GDC = parcelRequire("a7GDC");

var $4FeSR = parcelRequire("4FeSR");

var $lIMa5 = parcelRequire("lIMa5");

var $bLIxp = parcelRequire("bLIxp");
// Complete list of standard RequestInit properties
const $9fac3660e23fc29c$var$REQUEST_INIT_KEYS = [
    //"method",
    //"headers",
    //"body",
    "mode",
    //"credentials",
    "cache",
    "redirect",
    "referrer",
    "referrerPolicy",
    "integrity",
    "keepalive",
    "signal",
    "priority",
    "duplex",
    "window" // Historical/specific implementations
];
/**
 * Extracts RequestInit properties from a mixed object.
 */ function $9fac3660e23fc29c$var$extractRequestInit(sourceObject) {
    const result = {};
    if (!sourceObject || typeof sourceObject !== "object") return result;
    for (const key of $9fac3660e23fc29c$var$REQUEST_INIT_KEYS)if (key in sourceObject && typeof sourceObject[key] !== "undefined") result[key] = sourceObject[key];
    return result;
}
function $9fac3660e23fc29c$var$extractNonRequestInit(sourceObject) {
    const result = {};
    if (!sourceObject || typeof sourceObject !== "object") return result;
    for (const key of Object.keys(sourceObject))if (!$9fac3660e23fc29c$var$REQUEST_INIT_KEYS.includes(key) && typeof sourceObject[key] !== "undefined") result[key] = sourceObject[key];
    return result;
}
class $9fac3660e23fc29c$export$2e2bcd8739ae039 {
    static async get(endpoint, params) {
        const fetchOptions = $9fac3660e23fc29c$var$extractRequestInit(params);
        const requestParams = $9fac3660e23fc29c$var$extractNonRequestInit(params);
        return await $9fac3660e23fc29c$export$2e2bcd8739ae039.#makeRequest({
            method: "GET",
            endpoint: endpoint,
            params: requestParams,
            fetchOptions: fetchOptions
        });
    }
    static async post(endpoint, params, payload) {
        const fetchOptions = $9fac3660e23fc29c$var$extractRequestInit(params);
        const requestParams = $9fac3660e23fc29c$var$extractNonRequestInit(params);
        return await $9fac3660e23fc29c$export$2e2bcd8739ae039.#makeRequest({
            method: "POST",
            endpoint: endpoint,
            params: requestParams,
            fetchOptions: fetchOptions,
            payload: payload
        });
    }
    static async put(endpoint, params, payload) {
        const fetchOptions = $9fac3660e23fc29c$var$extractRequestInit(params);
        const requestParams = $9fac3660e23fc29c$var$extractNonRequestInit(params);
        return await $9fac3660e23fc29c$export$2e2bcd8739ae039.#makeRequest({
            method: "PUT",
            endpoint: endpoint,
            params: requestParams,
            fetchOptions: fetchOptions,
            payload: payload
        });
    }
    static async delete(endpoint, params, payload) {
        const fetchOptions = $9fac3660e23fc29c$var$extractRequestInit(params);
        const requestParams = $9fac3660e23fc29c$var$extractNonRequestInit(params);
        return await $9fac3660e23fc29c$export$2e2bcd8739ae039.#makeRequest({
            method: "DELETE",
            endpoint: endpoint,
            params: requestParams,
            fetchOptions: fetchOptions,
            payload: payload
        });
    }
    /**
   * @method request - Make http requests to remote urls
   *
   * @param {String} method: The request method.
   * @param {String} endpoint: The request endpoint (allows placeholders)
   *    e.g: "posts/:postId"
   * @param {Object} params: Key-value pairs of parameters to replace in the endpoint.
   *    e.g: {
   *      postId: 5, // Will replace :postId with 5 in the endpointwhen post is made
   *      name: "James" // will be appended to query string, since no matching placeholder exists in endpoint
   *    }
   *
   * @param {Object} payload: The request payload
   *
   * @return {Object}
   *
   */ //static async #makeRequest<PARAMS, PAYLOAD>(method: RequestMethods, endpoint: string, params?: PARAMS, payload?: PAYLOAD): Promise<ApiResponse> {
    static async #makeRequest(options) {
        const { method: method, params: params, payload: payload, fetchOptions: fetchOptions = {} } = options;
        let { endpoint: endpoint } = options;
        // Replace all named parameters in the URL
        Object.keys(params ?? {}).forEach((key)=>{
            if (endpoint.indexOf(`:${key}`) !== -1) {
                endpoint = endpoint.replace(`:${key}`, encodeURIComponent(params?.[key]));
                delete params?.[key];
            }
        });
        // If it's a GET request, append all other params in the query string.
        if (method === "GET") {
            const queryParams = [];
            Object.keys(params ?? {}).forEach((key)=>queryParams.push(`${key}=${encodeURIComponent(params?.[key])}`));
            endpoint += queryParams.length ? `${(0, $lIMa5.getLeadingQueryStringChar)(endpoint)}${queryParams.join("&")}` : "";
        }
        const url = [
            (0, $4FeSR.baseUrl),
            endpoint
        ].join(endpoint.charAt(0) === "/" ? "" : "/");
        const frontendRoute = window.location.pathname;
        const isProtectedClientRoute = (0, $bLIxp.default).isProtectedRoute(frontendRoute);
        if (isProtectedClientRoute && (0, $bLIxp.default).isProtectedRoute(endpoint)) {
            if (!(0, $bLIxp.default).isAuthenticatedUser()) {
                (0, $bLIxp.default).redirect(frontendRoute);
                return {
                    error: true,
                    statusCode: (0, $4FeSR.HTTP_STATUS_CODES).UNAUTHORIZED,
                    errorData: {
                        message: "Authentication required"
                    }
                };
            }
        }
        const response = await (0, $a7GDC.default)[method](url, payload, fetchOptions);
        const result = await response?.json();
        if (response?.status === (0, $4FeSR.HTTP_STATUS_CODES).UNAUTHORIZED && result?.errorData?.message === "Invalid access token.") {
            // Prevent our components from seeing the user as logged in.
            (0, $bLIxp.default).deleteAccessToken();
            // Prevent infinite-loop redirection.
            // This is in conjunction with some updates to the
            // useBusinessNotCreateNotifiction hook.
            // Also, it makes sense that if the user is currently
            // accessing or on a non-protected page,
            // we don't need to redirect them to the login page to be authenticated.
            if (isProtectedClientRoute) (0, $bLIxp.default).redirect(frontendRoute);
        }
        if (response?.status >= (0, $4FeSR.HTTP_STATUS_CODES).SERVER_ERROR) return {
            error: true,
            statusCode: response.status,
            errorData: {
                message: "A server error has occured. Please try again later."
            }
        };
        return {
            ...result,
            statusCode: response?.status
        };
    }
}

});
parcelRegister("a7GDC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $662db7b625d87a57$export$2e2bcd8739ae039; });
//import { type Fingerprint } from "../interfaces/browser";

var $bLIxp = parcelRequire("bLIxp");

var $ejJmI = parcelRequire("ejJmI");

var $9w0rm = parcelRequire("9w0rm");

var $4FeSR = parcelRequire("4FeSR");
const $662db7b625d87a57$var$request = $662db7b625d87a57$var$createHttpRequestApi();
var $662db7b625d87a57$export$2e2bcd8739ae039 = $662db7b625d87a57$var$request;
function $662db7b625d87a57$var$createHttpRequestApi() {
    return [
        "GET",
        "POST",
        "PUT",
        "DELETE"
    ].reduce((acc, method)=>{
        acc[method.toLowerCase()] = acc[method] = async function(endpoint, payload, fetchOptions) {
            return await $662db7b625d87a57$var$makeRequest({
                method: method,
                endpoint: endpoint,
                payload: payload,
                fetchOptions: fetchOptions
            });
        };
        return acc;
    }, {});
}
/**
 * Make HTTP request to an endpoint
 */ //async function makeRequest(reqMethod: string, endpoint: string, payload?: FormData | Record<string, unknown>): Promise<Response | undefined> {
async function $662db7b625d87a57$var$makeRequest(requestOptions) {
    const { method: reqMethod, endpoint: endpoint, payload: payload, fetchOptions: fetchOptions } = requestOptions;
    try {
        const url = endpoint;
        const method = reqMethod.toUpperCase();
        const isFormData = payload instanceof FormData;
        const fingerprint = await (0, $ejJmI.getFingerprint)();
        //const fingerprintHeaders = removeNullAndUndefinedFromFingerprint(fingerprint);
        const headers = {
            "Authorization": (0, $bLIxp.default).getBearerToken(),
            "X-Metrics": JSON.stringify(fingerprint)
        };
        const requestConfig = {
            ...fetchOptions ?? {},
            method: method,
            credentials: "include",
            headers: isFormData ? {
                ...headers
            } : {
                ...headers,
                "Content-Type": "application/json"
            }
        };
        if (method !== "GET" && payload) requestConfig.body = isFormData ? payload : JSON.stringify(payload);
        return await (0, $4FeSR.fetchWithTimeout)(url, requestConfig);
    } catch (error) {
        (0, $9w0rm.default).error("helpers.request:: HTTP Request Error:", endpoint, error);
        if ((0, $4FeSR.isServerDownError)(error)) //throw error; 
        (0, $9w0rm.default).error("helpers.request:: HTTP Request Error:", endpoint, {
            message: "The server is temporarily down"
        });
        return undefined;
    }
}

});
parcelRegister("ejJmI", function(module, exports) {

$parcel$export(module.exports, "getFingerprint", function () { return $905122e7cda7013a$export$916afe101e186768; });

var $2DGI6 = parcelRequire("2DGI6");

var $9t5Ss = parcelRequire("9t5Ss");

var $9w0rm = parcelRequire("9w0rm");
async function $905122e7cda7013a$export$916afe101e186768(params) {
    const storageKey = "x-metrics";
    const cachedFingerprint = (0, $9t5Ss.default).getItem(storageKey);
    if (cachedFingerprint) return cachedFingerprint;
    const { onError: onError } = params ?? {};
    let fingerprint = null;
    try {
        // FingerprintOSS and other fingerprinting libraries use IP Address to detect location.
        // The problem with this is that the IP Address usually tracks to the user's WI-FI's ISP provided IP address, 
        // not the user's actual IP address. So, we can get Lagos, while the user is actually in Abuja.
        // By using navigator.geolocation API (which the user must explicitly accept) along with reverse geocoding, 
        // we can get the user's actual location in terms of their city, locality (and country).
        // We need that city and locality info for showing the users products from vendors within the same city/locality.
        // If the user does not explicitly consent to this or when they change city, we have to present them with an input 
        // field to type in their city or to enter a list of cities from which they wish to see vendors' products.
        const [fingerprintOSSData, bigDataCloudGPSData] = await Promise.all([
            (0, $2DGI6.default)({
                transparency: false,
                message: "We use this data to improve your experience" // GDPR notice
            }),
            $905122e7cda7013a$var$getUserLocationViaGPS()
        ]);
        const { geolocation: geolocation, hash: hash, systemInfo: systemInfo } = fingerprintOSSData;
        const { ip: ip, city: city, region: region, country: country, location: location, vpnStatus: vpnStatus } = geolocation ?? {};
        const { os: os, browser: browser, vendor: vendor, platform: platform, userAgent: userAgent, screenResolution: screenResolution, timezone: timezone, bot: bot } = systemInfo;
        const { countryName: countryName, countryCode: countryCode, city: gpsCity, locality: locality, localityInfo: localityInfo } = bigDataCloudGPSData ?? {};
        const geolocationTimezone = location?.timeZone;
        const systemTimezone = timezone;
        // Order of location accuracy:
        // 1. (parsedData.)location.gps is more accurate, if available, as it uses GPS information.
        //    With it, we can get a user's exact location and show them relevant products.
        // 2. (parsedData.)client.timezone is less accurate but gets us close enough 
        //    (at least for fingerprinting purposes) via the OS's timezone information. 
        // 3. (parsedData.)location.ipAddress is the least accurate, 
        //    because it uses the ISP/Wi-Fi provided IP Address, rather than the user's actual IP address. 
        //    It is especially less reliable if the user is behind a VPN (client.isUsingVpn?.evaluation === true). 
        //    In both cases, we'll get either 
        //    - the ISP's address and location info or 
        //    - the VPN's ip address and location info, 
        //    rather than the user's actual ip address and location info.
        const parsedData = {
            client: {
                os: os,
                hash: hash,
                platform: platform,
                userAgent: userAgent,
                screenResolution: screenResolution,
                timezone: systemTimezone,
                browser: {
                    ...browser,
                    vendor: vendor
                },
                isBot: {
                    evaluation: bot.isBot,
                    probability: bot.confidence
                },
                isUsingVpn: {
                    evaluation: vpnStatus?.vpn?.status,
                    probability: vpnStatus?.vpn?.probability
                }
            },
            location: {
                ipAddress: ip,
                ip: {
                    region: region,
                    country: country,
                    city: {
                        name: city
                    },
                    timezone: geolocationTimezone
                },
                gps: {
                    city: {
                        name: gpsCity
                    },
                    locality: {
                        name: locality
                    },
                    country: {
                        name: countryName,
                        code: countryCode
                    },
                    timezone: localityInfo?.informative?.find((info)=>info.description === "time zone")?.name
                }
            }
        };
        fingerprint = Object.entries(parsedData ?? {}).reduce((acc, [key, value])=>{
            if (value !== null && value !== undefined) acc[key] = value;
            return acc;
        }, {});
        if (Object.keys(fingerprint).length > 0) (0, $9t5Ss.default).setItem(storageKey, fingerprint);
    } catch (error) {
        onError?.(error);
        (0, $9w0rm.default).error("Error getting browser fingerprint", error);
    }
    return fingerprint;
}
function $905122e7cda7013a$var$getUserLocationViaGPS() {
    return new Promise((resolve, reject)=>{
        if ("geolocation" in navigator) navigator.geolocation.getCurrentPosition(async (position)=>{
            const lat = position.coords.latitude;
            const lon = position.coords.longitude;
            // Pass these coordinates to a reverse geocoding API
            const data = await getCity(lat, lon);
            resolve(data);
        }, (error)=>{
            (0, $9w0rm.default).error("Error code:", error.code, "Message:", error.message);
            reject(error);
        });
        else {
            (0, $9w0rm.default).warn("Geolocation is not supported by this browser.");
            reject("Geolocation is not supported by this browser.");
        }
    });
    // See: 
    // - https://www.bigdatacloud.com/free-api/free-reverse-geocode-to-city-api
    // - https://www.bigdatacloud.com/docs/article/fair-use-policy-for-free-client-side-reverse-geocoding-api
    async function getCity(lat, lon) {
        let url = "https://api.bigdatacloud.net/data/reverse-geocode-client";
        url += `?latitude=${lat}&longitude=${lon}&localityLanguage=en`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            return data;
        } catch (err) {
            (0, $9w0rm.default).error("Reverse geocoding failed:", err);
            return null;
        }
    }
} /*async function getFingerprintWithConsent(params?: GetFingerprint) {
  // Check for existing consent
  const hasConsent = localStorage.getItem("fingerprint-consent") === "true";

  // Function to request consent
  function requestConsent() {
    if(confirm("We use device fingerprinting to improve security. Allow this feature?")) {
      localStorage.setItem("fingerprint-consent", "true");
      return true;
    }

    return false;
  }

  // Usage
  if(hasConsent || requestConsent()) {
    return await getFingerprint(params);
  }
}*/  /*export function removeNullAndUndefinedFromFingerprint(fingerprint: Fingerprint | null) {
  return Object.entries(fingerprint ?? {}).reduce<Record<string, string>>((acc, [key, value]) => {
    if(value !== null && value !== undefined) {
      acc[key] = typeof value === "string" ? value : JSON.stringify(value);
    }
  
    return acc;
  }, {});
}*/ 

});
parcelRegister("2DGI6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ec05aac0120a3f2$export$2e2bcd8739ae039; });
/*!
 * hash-wasm (https://www.npmjs.com/package/hash-wasm)
 * (c) Dani Biro
 * @license MIT
 */ 
var $6qd2L = parcelRequire("6qd2L");
function $1ec05aac0120a3f2$var$e(e, t, n, r) {
    return new (n || (n = Promise))(function(t, i) {
        function o(e) {
            try {
                s(r.next(e));
            } catch (e) {
                i(e);
            }
        }
        function a(e) {
            try {
                s(r.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            var r;
            e.done ? t(e.value) : (r = e.value, r instanceof n ? r : new n(function(e) {
                e(r);
            })).then(o, a);
        }
        s((r = r.apply(e, [])).next());
    });
}
"function" == typeof SuppressedError && SuppressedError;
class $1ec05aac0120a3f2$var$t {
    constructor(){
        this.mutex = Promise.resolve();
    }
    lock() {
        let e = ()=>{};
        return this.mutex = this.mutex.then(()=>new Promise(e)), new Promise((t)=>{
            e = t;
        });
    }
    dispatch(t) {
        return $1ec05aac0120a3f2$var$e(this, 0, void 0, function*() {
            const e = yield this.lock();
            try {
                return yield Promise.resolve(t());
            } finally{
                e();
            }
        });
    }
}
var $1ec05aac0120a3f2$var$n;
const $1ec05aac0120a3f2$var$r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : $parcel$global, $1ec05aac0120a3f2$var$i = null !== ($1ec05aac0120a3f2$var$n = $1ec05aac0120a3f2$var$r.Buffer) && void 0 !== $1ec05aac0120a3f2$var$n ? $1ec05aac0120a3f2$var$n : null, $1ec05aac0120a3f2$var$o = $1ec05aac0120a3f2$var$r.TextEncoder ? new $1ec05aac0120a3f2$var$r.TextEncoder : null;
function $1ec05aac0120a3f2$var$a(e, t) {
    return (15 & e) + (e >> 6 | e >> 3 & 8) << 4 | (15 & t) + (t >> 6 | t >> 3 & 8);
}
const $1ec05aac0120a3f2$var$s = "a".charCodeAt(0) - 10, $1ec05aac0120a3f2$var$c = "0".charCodeAt(0);
function $1ec05aac0120a3f2$var$u(e, t, n) {
    let r = 0;
    for(let i = 0; i < n; i++){
        let n = t[i] >>> 4;
        e[r++] = n > 9 ? n + $1ec05aac0120a3f2$var$s : n + $1ec05aac0120a3f2$var$c, n = 15 & t[i], e[r++] = n > 9 ? n + $1ec05aac0120a3f2$var$s : n + $1ec05aac0120a3f2$var$c;
    }
    return String.fromCharCode.apply(null, e);
}
const $1ec05aac0120a3f2$var$l = null !== $1ec05aac0120a3f2$var$i ? (e)=>{
    if ("string" == typeof e) {
        const t = $1ec05aac0120a3f2$var$i.from(e, "utf8");
        return new Uint8Array(t.buffer, t.byteOffset, t.length);
    }
    if ($1ec05aac0120a3f2$var$i.isBuffer(e)) return new Uint8Array(e.buffer, e.byteOffset, e.length);
    if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
    throw new Error("Invalid data type!");
} : (e)=>{
    if ("string" == typeof e) return $1ec05aac0120a3f2$var$o.encode(e);
    if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
    throw new Error("Invalid data type!");
}, $1ec05aac0120a3f2$var$d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $1ec05aac0120a3f2$var$p = new Uint8Array(256);
for(let e = 0; e < 64; e++)$1ec05aac0120a3f2$var$p[$1ec05aac0120a3f2$var$d.charCodeAt(e)] = e;
function $1ec05aac0120a3f2$var$f(e) {
    const t = function(e) {
        let t = Math.floor(.75 * e.length);
        const n = e.length;
        return "=" === e[n - 1] && (t -= 1, "=" === e[n - 2] && (t -= 1)), t;
    }(e), n = e.length, r = new Uint8Array(t);
    let i = 0;
    for(let t = 0; t < n; t += 4){
        const n = $1ec05aac0120a3f2$var$p[e.charCodeAt(t)], o = $1ec05aac0120a3f2$var$p[e.charCodeAt(t + 1)], a = $1ec05aac0120a3f2$var$p[e.charCodeAt(t + 2)], s = $1ec05aac0120a3f2$var$p[e.charCodeAt(t + 3)];
        r[i] = n << 2 | o >> 4, i += 1, r[i] = (15 & o) << 4 | a >> 2, i += 1, r[i] = (3 & a) << 6 | 63 & s, i += 1;
    }
    return r;
}
const $1ec05aac0120a3f2$var$g = 16384, $1ec05aac0120a3f2$var$h = new $1ec05aac0120a3f2$var$t, $1ec05aac0120a3f2$var$E = new Map;
function $1ec05aac0120a3f2$var$A(t, n) {
    return $1ec05aac0120a3f2$var$e(this, 0, void 0, function*() {
        let r = null, i = null, o = !1;
        if ("undefined" == typeof WebAssembly) throw new Error("WebAssembly is not supported in this environment!");
        const s = ()=>new DataView(r.exports.memory.buffer).getUint32(r.exports.STATE_SIZE, !0), c = $1ec05aac0120a3f2$var$h.dispatch(()=>$1ec05aac0120a3f2$var$e(this, 0, void 0, function*() {
                if (!$1ec05aac0120a3f2$var$E.has(t.name)) {
                    const e = $1ec05aac0120a3f2$var$f(t.data), n = WebAssembly.compile(e);
                    $1ec05aac0120a3f2$var$E.set(t.name, n);
                }
                const e = yield $1ec05aac0120a3f2$var$E.get(t.name);
                r = yield WebAssembly.instantiate(e, {});
            })), d = (e = null)=>{
            o = !0, r.exports.Hash_Init(e);
        }, p = (e)=>{
            if (!o) throw new Error("update() called before init()");
            ((e)=>{
                let t = 0;
                for(; t < e.length;){
                    const n = e.subarray(t, t + $1ec05aac0120a3f2$var$g);
                    t += n.length, i.set(n), r.exports.Hash_Update(n.length);
                }
            })($1ec05aac0120a3f2$var$l(e));
        }, A = new Uint8Array(2 * n), _ = (e, t = null)=>{
            if (!o) throw new Error("digest() called before init()");
            return o = !1, r.exports.Hash_Final(t), "binary" === e ? i.slice(0, n) : $1ec05aac0120a3f2$var$u(A, i, n);
        }, m = (e)=>"string" == typeof e ? e.length < 4096 : e.byteLength < $1ec05aac0120a3f2$var$g;
        let T = m;
        switch(t.name){
            case "argon2":
            case "scrypt":
                T = ()=>!0;
                break;
            case "blake2b":
            case "blake2s":
                T = (e, t)=>t <= 512 && m(e);
                break;
            case "blake3":
                T = (e, t)=>0 === t && m(e);
                break;
            case "xxhash64":
            case "xxhash3":
            case "xxhash128":
            case "crc64":
                T = ()=>!1;
        }
        return yield (()=>$1ec05aac0120a3f2$var$e(this, 0, void 0, function*() {
                r || (yield c);
                const e = r.exports.Hash_GetBuffer(), t = r.exports.memory.buffer;
                i = new Uint8Array(t, e, $1ec05aac0120a3f2$var$g);
            }))(), {
            getMemory: ()=>i,
            writeMemory: (e, t = 0)=>{
                i.set(e, t);
            },
            getExports: ()=>r.exports,
            setMemorySize: (e)=>{
                r.exports.Hash_SetMemorySize(e);
                const t = r.exports.Hash_GetBuffer(), n = r.exports.memory.buffer;
                i = new Uint8Array(n, t, e);
            },
            init: d,
            update: p,
            digest: _,
            save: ()=>{
                if (!o) throw new Error("save() can only be called after init() and before digest()");
                const e = r.exports.Hash_GetState(), n = s(), i = r.exports.memory.buffer, c = new Uint8Array(i, e, n), u = new Uint8Array(4 + n);
                return function(e, t) {
                    const n = t.length >> 1;
                    for(let r = 0; r < n; r++){
                        const n = r << 1;
                        e[r] = $1ec05aac0120a3f2$var$a(t.charCodeAt(n), t.charCodeAt(n + 1));
                    }
                }(u, t.hash), u.set(c, 4), u;
            },
            load: (e)=>{
                if (!(e instanceof Uint8Array)) throw new Error("load() expects an Uint8Array generated by save()");
                const n = r.exports.Hash_GetState(), i = s(), c = 4 + i, u = r.exports.memory.buffer;
                if (e.length !== c) throw new Error(`Bad state length (expected ${c} bytes, got ${e.length})`);
                if (!function(e, t) {
                    if (e.length !== 2 * t.length) return !1;
                    for(let n = 0; n < t.length; n++){
                        const r = n << 1;
                        if (t[n] !== $1ec05aac0120a3f2$var$a(e.charCodeAt(r), e.charCodeAt(r + 1))) return !1;
                    }
                    return !0;
                }(t.hash, e.subarray(0, 4))) throw new Error("This state was written by an incompatible hash implementation");
                const l = e.subarray(4);
                new Uint8Array(u, n, i).set(l), o = !0;
            },
            calculate: (e, t = null, o = null)=>{
                if (!T(e, t)) return d(t), p(e), _("hex", o);
                const a = $1ec05aac0120a3f2$var$l(e);
                return i.set(a), r.exports.Hash_Calculate(a.length, t, o), $1ec05aac0120a3f2$var$u(A, i, n);
            },
            hashLength: n
        };
    });
}
new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t;
var $1ec05aac0120a3f2$var$_ = {
    name: "sha256",
    data: "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",
    hash: "8c18dd94"
};
new $1ec05aac0120a3f2$var$t;
const $1ec05aac0120a3f2$var$m = new $1ec05aac0120a3f2$var$t;
let $1ec05aac0120a3f2$var$T = null;
function $1ec05aac0120a3f2$var$y(t) {
    if (null === $1ec05aac0120a3f2$var$T) return (function(t, n, r) {
        return $1ec05aac0120a3f2$var$e(this, 0, void 0, function*() {
            const e = yield t.lock(), i = yield $1ec05aac0120a3f2$var$A(n, r);
            return e(), i;
        });
    })($1ec05aac0120a3f2$var$m, $1ec05aac0120a3f2$var$_, 32).then((e)=>($1ec05aac0120a3f2$var$T = e, $1ec05aac0120a3f2$var$T.calculate(t, 256)));
    try {
        const e = $1ec05aac0120a3f2$var$T.calculate(t, 256);
        return Promise.resolve(e);
    } catch (e) {
        return Promise.reject(e);
    }
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ function $1ec05aac0120a3f2$var$v(e, t) {
    const n = Math.pow(10, t);
    return (Math.round(e * n) / n).toFixed(t);
}
async function $1ec05aac0120a3f2$export$567fc7097e064344(e) {
    const t = $1ec05aac0120a3f2$var$S({
        userAgent: e.userAgent ?? "ua_unavailable",
        platform: e.platform ?? "platform_unavailable",
        screenResolution: e.screenResolution ?? [
            0,
            0
        ],
        colorDepth: e.colorDepth ?? 0,
        colorGamut: e.colorGamut ?? "gamut_unavailable",
        os: e.os ?? {
            os: "os_unavailable",
            version: "version_unavailable"
        },
        webGLImageHash: e.webGL?.imageHash ?? "webgl_hash_unavailable",
        detectedFontsString: e.fontPreferences?.detectedFonts && e.fontPreferences.detectedFonts.length > 0 ? e.fontPreferences.detectedFonts.slice().sort().join(",") : "no_fonts_detected",
        canvasFingerprint: e.canvas?.geometry ?? "canvas_geo_unavailable",
        audioFingerprint: null !== e.audio && void 0 !== e.audio ? e.audio : "audio_fp_unavailable",
        mathConstants: e.mathConstants ? Object.fromEntries(Object.entries(e.mathConstants).map(([e, t])=>[
                e,
                $1ec05aac0120a3f2$var$v(Number(t), 3)
            ])) : {},
        plugins: e.plugins ? e.plugins.filter((e)=>e && e.name && !e.name.includes("Brave")).map((e)=>({
                name: e.name?.replace(/\s+/g, " ").trim() || "",
                types: e.mimeTypes?.map((e)=>e.type) || []
            })) : []
    }), n = JSON.stringify(t, $1ec05aac0120a3f2$var$I);
    return await $1ec05aac0120a3f2$var$y(n);
}
function $1ec05aac0120a3f2$var$I(e, t) {
    return t instanceof ArrayBuffer ? "" : "number" == typeof t ? $1ec05aac0120a3f2$var$v(t, 3) : "string" == typeof t ? t.replace(/\s+/g, " ").trim() : t;
}
function $1ec05aac0120a3f2$var$S(e) {
    return Array.isArray(e) ? e.map($1ec05aac0120a3f2$var$S).sort((e, t)=>{
        const n = JSON.stringify(e), r = JSON.stringify(t);
        return n.localeCompare(r);
    }) : e && "object" == typeof e && null !== e ? Object.keys(e).sort().reduce((t, n)=>(t[n] = $1ec05aac0120a3f2$var$S(e[n]), t), {}) : e;
}
async function $1ec05aac0120a3f2$export$c9681fead8fa2991(e, t = {}) {
    const n = Date.now(), r = $1ec05aac0120a3f2$var$S({
        userAgent: e.userAgent ?? "ua_unavailable",
        platform: e.platform ?? "platform_unavailable",
        screenResolution: e.screenResolution ?? [
            0,
            0
        ],
        colorDepth: e.colorDepth ?? 0,
        colorGamut: e.colorGamut ?? "gamut_unavailable",
        os: e.os ?? {
            os: "os_unavailable",
            version: "version_unavailable"
        },
        webGLImageHash: e.webGL?.imageHash ?? "webgl_hash_unavailable",
        detectedFontsString: e.fontPreferences?.detectedFonts && e.fontPreferences.detectedFonts.length > 0 ? e.fontPreferences.detectedFonts.slice().sort().join(",") : "no_fonts_detected",
        canvasFingerprint: e.canvas?.geometry ?? "canvas_geo_unavailable",
        audioFingerprint: null !== e.audio && void 0 !== e.audio ? e.audio : "audio_fp_unavailable",
        mathConstants: e.mathConstants ? Object.fromEntries(Object.entries(e.mathConstants).map(([e, t])=>[
                e,
                $1ec05aac0120a3f2$var$v(Number(t), 3)
            ])) : {},
        plugins: e.plugins ? e.plugins.filter((e)=>e && e.name && !e.name.includes("Brave")).map((e)=>({
                name: e.name?.replace(/\s+/g, " ").trim() || "",
                types: e.mimeTypes?.map((e)=>e.type) || []
            })) : []
    }), i = JSON.stringify(r, $1ec05aac0120a3f2$var$I), o = await $1ec05aac0120a3f2$var$y(i);
    if (!t.debugMode) return {
        hash: o
    };
    return {
        hash: o,
        debugInfo: {
            processingTime: Date.now() - n,
            originalInput: e,
            normalizedInput: r,
            hashInput: i,
            appliedFallbacks: {},
            validationErrors: t.enableValidation ? [] : void 0,
            serializationResult: {
                normalized: r,
                stats: {
                    length: i.length
                }
            }
        }
    };
}
async function $1ec05aac0120a3f2$export$f6e3bee154d53ac5(e, t, n = {}) {
    const r = $1ec05aac0120a3f2$var$S({
        userAgent: e.userAgent ?? "ua_unavailable",
        platform: e.platform ?? "platform_unavailable",
        screenResolution: e.screenResolution ?? [
            0,
            0
        ],
        colorDepth: e.colorDepth ?? 0,
        colorGamut: e.colorGamut ?? "gamut_unavailable",
        os: e.os ?? {
            os: "os_unavailable",
            version: "version_unavailable"
        },
        webGLImageHash: e.webGL?.imageHash ?? "webgl_hash_unavailable",
        detectedFontsString: e.fontPreferences?.detectedFonts && e.fontPreferences.detectedFonts.length > 0 ? e.fontPreferences.detectedFonts.slice().sort().join(",") : "no_fonts_detected",
        canvasFingerprint: e.canvas?.geometry ?? "canvas_geo_unavailable",
        audioFingerprint: null !== e.audio && void 0 !== e.audio ? e.audio : "audio_fp_unavailable",
        mathConstants: e.mathConstants ? Object.fromEntries(Object.entries(e.mathConstants).map(([e, t])=>[
                e,
                $1ec05aac0120a3f2$var$v(Number(t), 3)
            ])) : {},
        plugins: e.plugins ? e.plugins.filter((e)=>e && e.name && !e.name.includes("Brave")).map((e)=>({
                name: e.name?.replace(/\s+/g, " ").trim() || "",
                types: e.mimeTypes?.map((e)=>e.type) || []
            })) : []
    }), i = $1ec05aac0120a3f2$var$S({
        userAgent: t.userAgent ?? "ua_unavailable",
        platform: t.platform ?? "platform_unavailable",
        screenResolution: t.screenResolution ?? [
            0,
            0
        ],
        colorDepth: t.colorDepth ?? 0,
        colorGamut: t.colorGamut ?? "gamut_unavailable",
        os: t.os ?? {
            os: "os_unavailable",
            version: "version_unavailable"
        },
        webGLImageHash: t.webGL?.imageHash ?? "webgl_hash_unavailable",
        detectedFontsString: t.fontPreferences?.detectedFonts && t.fontPreferences.detectedFonts.length > 0 ? t.fontPreferences.detectedFonts.slice().sort().join(",") : "no_fonts_detected",
        canvasFingerprint: t.canvas?.geometry ?? "canvas_geo_unavailable",
        audioFingerprint: null !== t.audio && void 0 !== t.audio ? t.audio : "audio_fp_unavailable",
        mathConstants: t.mathConstants ? Object.fromEntries(Object.entries(t.mathConstants).map(([e, t])=>[
                e,
                $1ec05aac0120a3f2$var$v(Number(t), 3)
            ])) : {},
        plugins: t.plugins ? t.plugins.filter((e)=>e && e.name && !e.name.includes("Brave")).map((e)=>({
                name: e.name?.replace(/\s+/g, " ").trim() || "",
                types: e.mimeTypes?.map((e)=>e.type) || []
            })) : []
    }), o = JSON.stringify(r, $1ec05aac0120a3f2$var$I), a = JSON.stringify(i, $1ec05aac0120a3f2$var$I), s = o === a, c = [], u = new Set([
        "userAgent",
        "platform",
        "screenResolution",
        "colorDepth",
        "colorGamut",
        "os",
        "webGLImageHash",
        "detectedFontsString",
        "canvasFingerprint",
        "audioFingerprint"
    ]);
    for (const e of u){
        const t = r[e], n = i[e];
        if (JSON.stringify(t) !== JSON.stringify(n)) {
            const r = !0;
            c.push({
                property: e,
                left: t,
                right: n,
                affectsHash: r
            });
        }
    }
    return {
        identical: s,
        normalizedInput1: r,
        normalizedInput2: i,
        hashInput1: o,
        hashInput2: a,
        differences: c.map((e)=>({
                property: e.property,
                left: e.left,
                right: e.right,
                affectsHash: e.affectsHash
            }))
    };
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t, new $1ec05aac0120a3f2$var$t;
const $1ec05aac0120a3f2$var$R = {
    "Asia/Calcutta": "Asia/Kolkata",
    "Asia/Culcutta": "Asia/Kolkata",
    "Asia/Saigon": "Asia/Ho_Chi_Minh",
    "Asia/Rangoon": "Asia/Yangon",
    "Asia/Istanbul": "Europe/Istanbul",
    "Asia/Chongqing": "Asia/Shanghai",
    "Asia/Harbin": "Asia/Shanghai",
    "Asia/Urumqi": "Asia/Shanghai",
    "Asia/Kashgar": "Asia/Shanghai",
    "Asia/Thimbu": "Asia/Thimphu",
    "Asia/Ashkhabad": "Asia/Ashgabat",
    "Asia/Kathmandu": "Asia/Kathmandu",
    "Asia/Dacca": "Asia/Dhaka",
    "Asia/Dili": "Asia/Dili",
    "Asia/Dubai": "Asia/Dubai",
    "Asia/Kuala_Lumpur": "Asia/Kuala_Lumpur",
    "Asia/Jakarta": "Asia/Jakarta",
    "Asia/Kolkata": "Asia/Kolkata",
    "Asia/Dhaka": "Asia/Dhaka",
    "Asia/Tbilisi": "Asia/Tbilisi",
    "Asia/Tehran": "Asia/Tehran",
    "Asia/Kabul": "Asia/Kabul",
    "Europe/Kiev": "Europe/Kyiv",
    "W-SU": "Europe/Moscow",
    GB: "Europe/London",
    "GB-Eire": "Europe/London",
    Eire: "Europe/Dublin",
    "Europe/Minsk": "Europe/Minsk",
    "Europe/Bucharest": "Europe/Bucharest",
    "Europe/Budapest": "Europe/Budapest",
    "Europe/Prague": "Europe/Prague",
    "Europe/Vienna": "Europe/Vienna",
    "Europe/Berlin": "Europe/Berlin",
    "Europe/Zurich": "Europe/Zurich",
    "Europe/Paris": "Europe/Paris",
    "Europe/Lisbon": "Europe/Lisbon",
    "Europe/Madrid": "Europe/Madrid",
    "Europe/Rome": "Europe/Rome",
    "Europe/Athens": "Europe/Athens",
    "Europe/Istanbul": "Europe/Istanbul",
    "US/Pacific": "America/Los_Angeles",
    "US/Eastern": "America/New_York",
    "US/Mountain": "America/Denver",
    "US/Central": "America/Chicago",
    "US/Hawaii": "Pacific/Honolulu",
    "US/Alaska": "America/Anchorage",
    "Canada/Eastern": "America/Toronto",
    "Canada/Central": "America/Winnipeg",
    "Canada/Mountain": "America/Edmonton",
    "Canada/Pacific": "America/Vancouver",
    "America/Porto_Acre": "America/Rio_Branco",
    "America/Argentina/Buenos_Aires": "America/Argentina/Buenos_Aires",
    "America/Sao_Paulo": "America/Sao_Paulo",
    "America/Mexico_City": "America/Mexico_City",
    "America/Bogota": "America/Bogota",
    "America/Lima": "America/Lima",
    "America/Santiago": "America/Santiago",
    "America/Caracas": "America/Caracas",
    "America/Havana": "America/Havana",
    "America/Toronto": "America/Toronto",
    "Australia/NSW": "Australia/Sydney",
    "Australia/Victoria": "Australia/Melbourne",
    "Australia/Queensland": "Australia/Brisbane",
    "Australia/Tasmania": "Australia/Hobart",
    "Australia/ACT": "Australia/Canberra",
    "Australia/North": "Australia/Darwin",
    "Australia/West": "Australia/Perth",
    "Australia/South": "Australia/Adelaide",
    "Africa/Asmera": "Africa/Asmara",
    "Africa/Timbuktu": "Africa/Bamako",
    "Africa/Cairo": "Africa/Cairo",
    "Africa/Casablanca": "Africa/Casablanca",
    "Africa/Johannesburg": "Africa/Johannesburg",
    "Africa/Nairobi": "Africa/Nairobi",
    "Africa/Lagos": "Africa/Lagos",
    "Africa/Abidjan": "Africa/Abidjan",
    "Africa/Algiers": "Africa/Algiers",
    "Africa/Tunis": "Africa/Tunis",
    "Africa/Maputo": "Africa/Maputo",
    "Pacific/Ponape": "Pacific/Pohnpei",
    "Pacific/Truk": "Pacific/Chuuk",
    "Pacific/Yap": "Pacific/Chuuk",
    "Pacific/Auckland": "Pacific/Auckland",
    "Pacific/Fiji": "Pacific/Fiji",
    "Pacific/Tahiti": "Pacific/Tahiti",
    "Pacific/Guam": "Pacific/Guam",
    "Pacific/Honolulu": "Pacific/Honolulu",
    "Pacific/Marquesas": "Pacific/Marquesas",
    "Asia/Tel_Aviv": "Asia/Jerusalem",
    "Asia/Beirut": "Asia/Beirut",
    "Asia/Damascus": "Asia/Damascus",
    "Asia/Jerusalem": "Asia/Jerusalem",
    "America/Coral_Harbour": "America/Atikokan",
    "US/Arizona": "America/Phoenix",
    "US/Samoa": "Pacific/Samoa",
    "US/Indiana-Starke": "America/Chicago",
    "US/Indiana-Vevay": "America/New_York",
    "US/Indiana-Tell City": "America/Indiana/Tell_City",
    "US/Indiana-Knox": "America/Indiana/Knox",
    CET: "Europe/Berlin",
    CEST: "Europe/Berlin",
    MET: "Europe/Paris",
    MEST: "Europe/Paris",
    JST: "Asia/Tokyo",
    KST: "Asia/Seoul",
    IST: "Asia/Kolkata",
    AEST: "Australia/Brisbane",
    AWST: "Australia/Perth",
    CAT: "Africa/Nairobi",
    SAST: "Africa/Johannesburg",
    NZDT: "Pacific/Auckland",
    NZST: "Pacific/Auckland",
    PST: "America/Los_Angeles",
    PDT: "America/Los_Angeles",
    GMT: "Etc/GMT",
    UTC: "Etc/UTC",
    "GMT+1": "Europe/Berlin",
    "GMT+2": "Europe/Athens",
    "GMT+3": "Europe/Moscow"
};
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ function $1ec05aac0120a3f2$var$L(e) {
    if (!e) return e;
    const t = e.trim();
    return $1ec05aac0120a3f2$var$R[t] || t;
}
async function $1ec05aac0120a3f2$export$958f39eada2708e4(e) {
    if (!e || !e.geoip || !e.localtime) return {
        vpn: {
            status: !1,
            probability: .5
        }
    };
    if ("unknown" === e.geoip || "unknown" === e.localtime) return {
        vpn: {
            status: !1,
            probability: .5
        }
    };
    const t = $1ec05aac0120a3f2$var$L(e.geoip);
    return $1ec05aac0120a3f2$var$L(e.localtime) !== t ? {
        vpn: {
            status: !0,
            probability: .75
        }
    } : {
        vpn: {
            status: !1,
            probability: .2
        }
    };
}
function $1ec05aac0120a3f2$var$P(e) {
    return e >= .8 ? {
        rating: "High Confidence",
        description: "The data appears to be from a genuine user with consistent information across all signals.",
        reliability: "Data is highly reliable for most purposes including fraud detection and analytics.",
        level: "high"
    } : e >= .65 ? {
        rating: "Medium-High Confidence",
        description: "The data appears mostly consistent with some minor discrepancies.",
        reliability: "Data is generally reliable but may have some inconsistencies worth investigating.",
        level: "medium-high"
    } : e >= .5 ? {
        rating: "Medium Confidence",
        description: "The data shows a moderate level of consistency, but with some concerning signals.",
        reliability: "Data should be treated with caution and verified through additional means.",
        level: "medium"
    } : e >= .35 ? {
        rating: "Medium-Low Confidence",
        description: "The data shows significant inconsistencies that suggest possible fraud or spoofing.",
        reliability: "Data reliability is questionable and should not be trusted without verification.",
        level: "medium-low"
    } : {
        rating: "Low Confidence",
        description: "The data exhibits strong signals of automation, spoofing, or intentional manipulation.",
        reliability: "Data is highly unreliable and shows strong indications of non-human origin.",
        level: "low"
    };
}
async function $1ec05aac0120a3f2$export$d23738d50f257f47(e, t, n) {
    const r = $1ec05aac0120a3f2$var$P(t.confidenceScore), i = n ? $1ec05aac0120a3f2$var$P(n) : {
        rating: "",
        description: "",
        reliability: "",
        level: "medium"
    }, o = e?.traits?.isAnonymousProxy || !1, a = e?.traits?.isAnonymousVpn || !1, s = e?.traits?.isHostingProvider || !1, c = e?.traits?.isTorExitNode || !1, u = e ? await $1ec05aac0120a3f2$export$958f39eada2708e4({
        geoip: e.location?.timeZone || "UTC",
        localtime: t?.timezone || "UTC"
    }) : void 0;
    return {
        confidenceAssessment: {
            system: {
                score: t.confidenceScore,
                ...r,
                factors: t?.bot?.isBot ? `Bot signals detected: ${t.bot.signals?.join(", ") || "unknown signals"}` : "No bot signals detected"
            },
            ...n ? {
                combined: {
                    score: n,
                    ...i,
                    factors: [
                        o ? "Proxy detected" : null,
                        c ? "Tor exit node detected" : null,
                        s ? "Hosting provider detected" : null,
                        a ? "VPN detected" : null
                    ].filter(Boolean).join(", ") || "No suspicious network factors detected"
                }
            } : {}
        },
        geolocation: e ? {
            vpnStatus: u,
            ip: e.ipAddress || e.ipv4 || null,
            ipv4: e.ipv4 || null,
            ipv6: e.ipv6 || null,
            city: e.city?.name || "unknown",
            region: e.subdivisions?.[0] || {
                isoCode: "",
                name: ""
            },
            country: e.country || {
                isoCode: "",
                name: ""
            },
            continent: e.continent || {
                code: "",
                name: ""
            },
            location: e.location || {
                accuracyRadius: 0,
                latitude: 0,
                longitude: 0,
                timeZone: "UTC"
            },
            traits: {
                isAnonymous: e.traits?.isAnonymous || !1,
                isAnonymousProxy: e.traits?.isAnonymousProxy || !1,
                isAnonymousVpn: e.traits?.isAnonymousVpn || !1,
                network: e.traits?.network || "unknown"
            }
        } : null,
        systemInfo: t,
        hash: await $1ec05aac0120a3f2$export$567fc7097e064344(t)
    };
}
/*!
 * Configuration System for Fingerprint OSS
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * Licensed under LGPL-3.0
 */ const $1ec05aac0120a3f2$var$N = 4500, $1ec05aac0120a3f2$var$M = [
    "error",
    "warn",
    "info",
    "verbose",
    "debug"
], $1ec05aac0120a3f2$var$x = {
    TEST: {
        verbose: !0,
        logLevel: "debug",
        enableConsoleLogging: !0,
        enablePerformanceLogging: !0,
        transparency: !0,
        geoTimeout: $1ec05aac0120a3f2$var$N
    },
    DEV: {
        verbose: !0,
        logLevel: "verbose",
        enableConsoleLogging: !0,
        enablePerformanceLogging: !0,
        transparency: !0,
        geoTimeout: $1ec05aac0120a3f2$var$N
    },
    STAGING: {
        verbose: !1,
        logLevel: "info",
        enableConsoleLogging: !0,
        enablePerformanceLogging: !1,
        transparency: !0,
        geoTimeout: $1ec05aac0120a3f2$var$N
    },
    PROD: {
        verbose: !1,
        logLevel: "error",
        enableConsoleLogging: !1,
        enablePerformanceLogging: !1,
        transparency: !1,
        geoTimeout: $1ec05aac0120a3f2$var$N
    }
};
function $1ec05aac0120a3f2$var$D(e, t, n) {
    e && e.push({
        code: "CONFIG_INVALID",
        message: t,
        ...n ? {
            details: n
        } : {}
    });
}
function $1ec05aac0120a3f2$var$F(e, t, n, r) {
    return void 0 === e ? n : "boolean" == typeof e ? e : ($1ec05aac0120a3f2$var$D(r, `${t} must be a boolean`, {
        field: t,
        value: e,
        fallback: n
    }), n);
}
function $1ec05aac0120a3f2$var$Q(e, t, n) {
    return void 0 === e ? t : $1ec05aac0120a3f2$var$M.includes(e) ? e : ($1ec05aac0120a3f2$var$D(n, `Invalid logLevel "${e}", falling back to ${t}`, {
        value: e,
        fallback: t,
        allowed: $1ec05aac0120a3f2$var$M
    }), t);
}
function $1ec05aac0120a3f2$var$U(e, t, n) {
    return void 0 === e ? t : "number" == typeof e && Number.isFinite(e) && e >= 250 ? e : ($1ec05aac0120a3f2$var$D(n, "geoTimeout must be a number >= 250ms", {
        value: e,
        fallback: t
    }), t);
}
function $1ec05aac0120a3f2$var$k(e, t) {
    if (null != e) return "string" == typeof e ? e : void $1ec05aac0120a3f2$var$D(t, "Message must be a string", {
        value: e
    });
}
let $1ec05aac0120a3f2$var$G;
function $1ec05aac0120a3f2$export$2480726bf2d3fb51() {
    if ("undefined" != typeof $6qd2L && $6qd2L.env) {
        const e = "production"?.toUpperCase(), t = undefined?.toUpperCase();
        if ("TEST" === t || "DEV" === t || "STAGING" === t || "PROD" === t) return t;
        if ("TEST" === e) return "TEST";
        if ("DEVELOPMENT" === e) return "DEV";
        if ("STAGING" === e) return "STAGING";
        if ("PRODUCTION" === e) return "PROD";
    }
    if ("undefined" != typeof window) {
        if ("localhost" === window.location.hostname || "127.0.0.1" === window.location.hostname || window.location.hostname.includes("dev") || "3000" === window.location.port || "8080" === window.location.port) return "DEV";
        if (window.location.hostname.includes("staging") || window.location.hostname.includes("test")) return "STAGING";
        if (window.location.search.includes("test=true") || window.location.hash.includes("test")) return "TEST";
    }
    return "PROD";
}
function $1ec05aac0120a3f2$export$62b110e0dc0699c4(e, t = []) {
    const n = $1ec05aac0120a3f2$export$2480726bf2d3fb51(), r = function(e, t, n) {
        if ("string" == typeof e) {
            const r = e.toUpperCase();
            if ("TEST" === r || "DEV" === r || "STAGING" === r || "PROD" === r) return r;
            $1ec05aac0120a3f2$var$D(n, `Invalid environment "${e}", falling back to ${t}`, {
                value: e,
                fallback: t
            });
        }
        return t;
    }(e?.environment, n, t), i = $1ec05aac0120a3f2$var$x[r];
    return $1ec05aac0120a3f2$var$G = {
        environment: r,
        verbose: $1ec05aac0120a3f2$var$F(e?.verbose ?? i.verbose ?? !1, "verbose", i.verbose ?? !1, t),
        transparency: $1ec05aac0120a3f2$var$F(e?.transparency ?? i.transparency ?? !1, "transparency", i.transparency ?? !1, t),
        message: $1ec05aac0120a3f2$var$k(e?.message ?? i.message, t),
        logLevel: $1ec05aac0120a3f2$var$Q(e?.logLevel ?? i.logLevel ?? "error", i.logLevel ?? "error", t),
        enableConsoleLogging: $1ec05aac0120a3f2$var$F(e?.enableConsoleLogging ?? i.enableConsoleLogging ?? !1, "enableConsoleLogging", i.enableConsoleLogging ?? !1, t),
        enablePerformanceLogging: $1ec05aac0120a3f2$var$F(e?.enablePerformanceLogging ?? i.enablePerformanceLogging ?? !1, "enablePerformanceLogging", i.enablePerformanceLogging ?? !1, t),
        geoTimeout: $1ec05aac0120a3f2$var$U(e?.geoTimeout ?? i.geoTimeout ?? $1ec05aac0120a3f2$var$N, $1ec05aac0120a3f2$var$N, t)
    }, $1ec05aac0120a3f2$var$G;
}
function $1ec05aac0120a3f2$export$44487a86467333c3() {
    return $1ec05aac0120a3f2$var$G || $1ec05aac0120a3f2$export$62b110e0dc0699c4();
}
function $1ec05aac0120a3f2$export$2eaf9172a83ee9e7(e) {
    return $1ec05aac0120a3f2$export$62b110e0dc0699c4({
        ...$1ec05aac0120a3f2$export$44487a86467333c3(),
        ...e
    });
}
function $1ec05aac0120a3f2$export$be292d663ef09398() {
    const e = $1ec05aac0120a3f2$export$44487a86467333c3();
    return e.verbose || "TEST" === e.environment || "DEV" === e.environment;
}
function $1ec05aac0120a3f2$var$V(e) {
    const t = $1ec05aac0120a3f2$export$44487a86467333c3();
    if (!t.enableConsoleLogging) return !1;
    const n = [
        "error",
        "warn",
        "info",
        "verbose",
        "debug"
    ], r = n.indexOf(t.logLevel);
    return n.indexOf(e) <= r;
}
class $1ec05aac0120a3f2$export$79de5099e43c732e {
    static formatMessage(e, t, n, r) {
        const i = $1ec05aac0120a3f2$export$44487a86467333c3();
        let o = `[${(new Date).toISOString()}] [${i.environment}] [${e.toUpperCase()}] [${t}] ${n}`;
        return r && i.verbose && (o += `\nData: ${JSON.stringify(r, null, 2)}`), o;
    }
    static error(e, t, n) {
        $1ec05aac0120a3f2$var$V("error") && console.error(this.formatMessage("error", e, t, n));
    }
    static warn(e, t, n) {
        $1ec05aac0120a3f2$var$V("warn") && console.warn(this.formatMessage("warn", e, t, n));
    }
    static info(e, t, n) {
        $1ec05aac0120a3f2$var$V("info") && console.info(this.formatMessage("info", e, t, n));
    }
    static verbose(e, t, n) {
        $1ec05aac0120a3f2$var$V("verbose") && console.log(this.formatMessage("verbose", e, t, n));
    }
    static debug(e, t, n) {
        $1ec05aac0120a3f2$var$V("debug") && console.log(this.formatMessage("debug", e, t, n));
    }
    static logBlock(e, t, n) {
        const r = $1ec05aac0120a3f2$export$44487a86467333c3(), i = performance.now();
        r.verbose && this.verbose(e, `Starting: ${t}`);
        try {
            const o = n();
            if (o instanceof Promise) return o.then((n)=>{
                const o = performance.now();
                return (r.verbose || r.enablePerformanceLogging) && this.verbose(e, `Completed: ${t} (${(o - i).toFixed(2)}ms)`), n;
            }).catch((n)=>{
                const r = performance.now();
                throw this.error(e, `Failed: ${t} (${(r - i).toFixed(2)}ms)`, n), n;
            });
            {
                const n = performance.now();
                return (r.verbose || r.enablePerformanceLogging) && this.verbose(e, `Completed: ${t} (${(n - i).toFixed(2)}ms)`), o;
            }
        } catch (n) {
            const r = performance.now();
            throw this.error(e, `Failed: ${t} (${(r - i).toFixed(2)}ms)`, n), n;
        }
    }
}
class $1ec05aac0120a3f2$export$67e62f8ce7018ffb {
    static start(e) {
        const t = $1ec05aac0120a3f2$export$44487a86467333c3();
        (t.enablePerformanceLogging || t.verbose) && (this.timers.set(e, performance.now()), $1ec05aac0120a3f2$export$79de5099e43c732e.debug("PERFORMANCE", `Timer started: ${e}`));
    }
    static end(e) {
        const t = $1ec05aac0120a3f2$export$44487a86467333c3();
        if (t.enablePerformanceLogging || t.verbose) {
            const t = this.timers.get(e);
            if (t) {
                const n = performance.now() - t;
                return this.timers.delete(e), $1ec05aac0120a3f2$export$79de5099e43c732e.debug("PERFORMANCE", `Timer ended: ${e} (${n.toFixed(2)}ms)`), n;
            }
        }
        return 0;
    }
}
$1ec05aac0120a3f2$export$67e62f8ce7018ffb.timers = new Map, $1ec05aac0120a3f2$export$62b110e0dc0699c4();
function $1ec05aac0120a3f2$var$Y(e) {
    if (!e) return !1;
    const t = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/.exec(e);
    return !!t && t.slice(1, 5).every((e)=>{
        const t = parseInt(e, 10);
        return t >= 0 && t <= 255;
    });
}
function $1ec05aac0120a3f2$var$W(e) {
    if (!e) return !1;
    if (e.startsWith("::ffff:")) return !1;
    return /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^::1$|^::$|^([0-9a-fA-F]{1,4}:)*::([0-9a-fA-F]{1,4}:)*[0-9a-fA-F]{1,4}$/.test(e) || e.includes(":") && /^[0-9a-fA-F:]+$/.test(e);
}
function $1ec05aac0120a3f2$var$Z() {
    return {
        ipAddress: "192.168.1.1",
        ipv4: "192.168.1.1",
        ipv6: null,
        country: {
            isoCode: "US",
            name: "United States"
        },
        registeredCountry: {
            isoCode: "US",
            name: "United States",
            isInEuropeanUnion: !1
        },
        city: {
            name: "New York",
            geonameId: 123456
        },
        continent: {
            code: "NA",
            name: "North America"
        },
        subdivisions: [
            {
                isoCode: "NY",
                name: "New York"
            }
        ],
        location: {
            accuracyRadius: 100,
            latitude: 40.7128,
            longitude: -74.006,
            timeZone: "America/New_York"
        },
        postal: {
            code: "10001"
        },
        traits: {
            isAnonymous: !1,
            isAnonymousProxy: !1,
            isAnonymousVpn: !1,
            isAnycast: !1,
            isHostingProvider: !1,
            isLegitimateProxy: !1,
            isPublicProxy: !1,
            isResidentialProxy: !1,
            isSatelliteProvider: !1,
            isTorExitNode: !1,
            ipAddress: "192.168.1.1",
            network: "192.168.1.0/24"
        }
    };
}
async function $1ec05aac0120a3f2$export$5ee1c09fab1d5356(e = {}) {
    return $1ec05aac0120a3f2$export$79de5099e43c732e.logBlock("fetchGeolocationInfo", "Geolocation information fetch", async ()=>{
        const t = e.timeoutMs ?? $1ec05aac0120a3f2$var$N, n = Number.isFinite(t) && t >= 100 ? t : $1ec05aac0120a3f2$var$N;
        n !== t && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("fetchGeolocationInfo", `Invalid timeoutMs value (${t}), using default 4500ms`);
        const r = "undefined" != typeof AbortController ? new AbortController : null;
        try {
            const t = await ((e)=>{
                let t = null;
                const i = new Promise((e, i)=>{
                    t = setTimeout(()=>{
                        r?.abort(), i(Object.assign(new Error(`Geolocation request timed out after ${n}ms`), {
                            name: "AbortError"
                        }));
                    }, n);
                });
                return Promise.race([
                    e,
                    i
                ]).finally(()=>{
                    t && clearTimeout(t);
                });
            })(fetch("https://fingerprint-proxy.gossorg.in/", {
                method: "GET",
                ...r ? {
                    signal: r.signal
                } : {}
            }));
            if (!t.ok) return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("fetchGeolocationInfo", `Geolocation API request failed: ${t.statusText}, using mock data`), e.onWarning?.({
                code: "GEO_HTTP_ERROR",
                message: `Geolocation API responded with status ${t.status}`,
                details: {
                    status: t.status,
                    statusText: t.statusText
                }
            }), {
                ipAddress: "192.168.1.1",
                ipv4: "192.168.1.1",
                ipv6: null,
                country: {
                    isoCode: "US",
                    name: "United States"
                },
                registeredCountry: {
                    isoCode: "US",
                    name: "United States",
                    isInEuropeanUnion: !1
                },
                city: {
                    name: "New York",
                    geonameId: 123456
                },
                continent: {
                    code: "NA",
                    name: "North America"
                },
                subdivisions: [
                    {
                        isoCode: "NY",
                        name: "New York"
                    }
                ],
                location: {
                    accuracyRadius: 100,
                    latitude: 40.7128,
                    longitude: -74.006,
                    timeZone: "America/New_York"
                },
                postal: {
                    code: "10001"
                },
                traits: {
                    isAnonymous: !1,
                    isAnonymousProxy: !1,
                    isAnonymousVpn: !1,
                    isAnycast: !1,
                    isHostingProvider: !1,
                    isLegitimateProxy: !1,
                    isPublicProxy: !1,
                    isResidentialProxy: !1,
                    isSatelliteProvider: !1,
                    isTorExitNode: !1,
                    ipAddress: "192.168.1.1",
                    network: "192.168.1.0/24"
                }
            };
            const i = await t.json();
            if (!i || "object" != typeof i) return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("fetchGeolocationInfo", "Invalid API response, using mock data"), e.onWarning?.({
                code: "GEO_INVALID_RESPONSE",
                message: "Geolocation API returned invalid payload"
            }), {
                ipAddress: "192.168.1.1",
                ipv4: "192.168.1.1",
                ipv6: null,
                country: {
                    isoCode: "US",
                    name: "United States"
                },
                registeredCountry: {
                    isoCode: "US",
                    name: "United States",
                    isInEuropeanUnion: !1
                },
                city: {
                    name: "New York",
                    geonameId: 123456
                },
                continent: {
                    code: "NA",
                    name: "North America"
                },
                subdivisions: [
                    {
                        isoCode: "NY",
                        name: "New York"
                    }
                ],
                location: {
                    accuracyRadius: 100,
                    latitude: 40.7128,
                    longitude: -74.006,
                    timeZone: "America/New_York"
                },
                postal: {
                    code: "10001"
                },
                traits: {
                    isAnonymous: !1,
                    isAnonymousProxy: !1,
                    isAnonymousVpn: !1,
                    isAnycast: !1,
                    isHostingProvider: !1,
                    isLegitimateProxy: !1,
                    isPublicProxy: !1,
                    isResidentialProxy: !1,
                    isSatelliteProvider: !1,
                    isTorExitNode: !1,
                    ipAddress: "192.168.1.1",
                    network: "192.168.1.0/24"
                }
            };
            const o = function(e) {
                let t = null, n = null;
                e.ipv4 && $1ec05aac0120a3f2$var$Y(e.ipv4) && (t = e.ipv4), e.ipv6 && $1ec05aac0120a3f2$var$W(e.ipv6) && (n = e.ipv6), e.ip && ($1ec05aac0120a3f2$var$Y(e.ip) ? t || (t = e.ip) : $1ec05aac0120a3f2$var$W(e.ip) && (n || (n = e.ip)));
                const r = e.traits?.ipAddress;
                r && ($1ec05aac0120a3f2$var$Y(r) ? t || (t = r) : $1ec05aac0120a3f2$var$W(r) && (n || (n = r)));
                const i = e.ipAddress;
                return i && ($1ec05aac0120a3f2$var$Y(i) ? t || (t = i) : $1ec05aac0120a3f2$var$W(i) && (n || (n = i))), {
                    ip: t || n || null,
                    ipv4: t || null,
                    ipv6: n || null
                };
            }(i);
            return o.ip || o.ipv4 || o.ipv6 ? {
                ipAddress: o.ip,
                ipv4: o.ipv4,
                ipv6: o.ipv6,
                country: i.country || {
                    isoCode: "US",
                    name: "United States"
                },
                registeredCountry: i.registeredCountry || {
                    isoCode: "US",
                    name: "United States",
                    isInEuropeanUnion: !1
                },
                city: i.city || {
                    name: "New York",
                    geonameId: 123456
                },
                continent: i.continent || {
                    code: "NA",
                    name: "North America"
                },
                subdivisions: i.subdivisions || [
                    {
                        isoCode: "NY",
                        name: "New York"
                    }
                ],
                location: i.location || {
                    accuracyRadius: 100,
                    latitude: 40.7128,
                    longitude: -74.006,
                    timeZone: "America/New_York"
                },
                postal: i.postal || {
                    code: "10001"
                },
                traits: i.traits || {
                    isAnonymous: !1,
                    isAnonymousProxy: !1,
                    isAnonymousVpn: !1,
                    isAnycast: !1,
                    isHostingProvider: !1,
                    isLegitimateProxy: !1,
                    isPublicProxy: !1,
                    isResidentialProxy: !1,
                    isSatelliteProvider: !1,
                    isTorExitNode: !1,
                    ipAddress: o.ip,
                    network: "192.168.1.0/24"
                }
            } : ($1ec05aac0120a3f2$export$79de5099e43c732e.warn("fetchGeolocationInfo", "No valid IP address found in response, using mock data"), e.onWarning?.({
                code: "GEO_INVALID_RESPONSE",
                message: "Geolocation response missing valid IP address"
            }), {
                ipAddress: "192.168.1.1",
                ipv4: "192.168.1.1",
                ipv6: null,
                country: {
                    isoCode: "US",
                    name: "United States"
                },
                registeredCountry: {
                    isoCode: "US",
                    name: "United States",
                    isInEuropeanUnion: !1
                },
                city: {
                    name: "New York",
                    geonameId: 123456
                },
                continent: {
                    code: "NA",
                    name: "North America"
                },
                subdivisions: [
                    {
                        isoCode: "NY",
                        name: "New York"
                    }
                ],
                location: {
                    accuracyRadius: 100,
                    latitude: 40.7128,
                    longitude: -74.006,
                    timeZone: "America/New_York"
                },
                postal: {
                    code: "10001"
                },
                traits: {
                    isAnonymous: !1,
                    isAnonymousProxy: !1,
                    isAnonymousVpn: !1,
                    isAnycast: !1,
                    isHostingProvider: !1,
                    isLegitimateProxy: !1,
                    isPublicProxy: !1,
                    isResidentialProxy: !1,
                    isSatelliteProvider: !1,
                    isTorExitNode: !1,
                    ipAddress: "192.168.1.1",
                    network: "192.168.1.0/24"
                }
            });
        } catch (t) {
            return "AbortError" === t?.name ? ($1ec05aac0120a3f2$export$79de5099e43c732e.warn("fetchGeolocationInfo", `Geolocation request timed out after ${n}ms, using mock data`), e.onWarning?.({
                code: "GEO_TIMEOUT",
                message: "Geolocation request timed out",
                details: {
                    timeoutMs: n
                }
            })) : ($1ec05aac0120a3f2$export$79de5099e43c732e.warn("fetchGeolocationInfo", "Error fetching geolocation information, using mock data", t), e.onWarning?.({
                code: "GEO_FETCH_FAILED",
                message: "Geolocation request failed",
                details: {
                    error: t?.message || String(t)
                }
            })), {
                ipAddress: "192.168.1.1",
                ipv4: "192.168.1.1",
                ipv6: null,
                country: {
                    isoCode: "US",
                    name: "United States"
                },
                registeredCountry: {
                    isoCode: "US",
                    name: "United States",
                    isInEuropeanUnion: !1
                },
                city: {
                    name: "New York",
                    geonameId: 123456
                },
                continent: {
                    code: "NA",
                    name: "North America"
                },
                subdivisions: [
                    {
                        isoCode: "NY",
                        name: "New York"
                    }
                ],
                location: {
                    accuracyRadius: 100,
                    latitude: 40.7128,
                    longitude: -74.006,
                    timeZone: "America/New_York"
                },
                postal: {
                    code: "10001"
                },
                traits: {
                    isAnonymous: !1,
                    isAnonymousProxy: !1,
                    isAnonymousVpn: !1,
                    isAnycast: !1,
                    isHostingProvider: !1,
                    isLegitimateProxy: !1,
                    isPublicProxy: !1,
                    isResidentialProxy: !1,
                    isSatelliteProvider: !1,
                    isTorExitNode: !1,
                    ipAddress: "192.168.1.1",
                    network: "192.168.1.0/24"
                }
            };
        }
    });
}
var $1ec05aac0120a3f2$var$ee = Object.freeze({
    __proto__: null,
    fetchGeolocationInfo: $1ec05aac0120a3f2$export$5ee1c09fab1d5356,
    getMockGeolocationData: $1ec05aac0120a3f2$var$Z
});
/*!
 * Bowser - a browser detector
 * https://github.com/bowser-js/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ const $1ec05aac0120a3f2$var$te = {
    AmazonBot: "amazonbot",
    "Amazon Silk": "amazon_silk",
    "Android Browser": "android",
    BaiduSpider: "baiduspider",
    Bada: "bada",
    BingCrawler: "bingcrawler",
    BlackBerry: "blackberry",
    "ChatGPT-User": "chatgpt_user",
    Chrome: "chrome",
    ClaudeBot: "claudebot",
    Chromium: "chromium",
    Diffbot: "diffbot",
    DuckDuckBot: "duckduckbot",
    Electron: "electron",
    Epiphany: "epiphany",
    FacebookExternalHit: "facebookexternalhit",
    Firefox: "firefox",
    Focus: "focus",
    Generic: "generic",
    "Google Search": "google_search",
    Googlebot: "googlebot",
    GPTBot: "gptbot",
    "Internet Explorer": "ie",
    InternetArchiveCrawler: "internetarchivecrawler",
    "K-Meleon": "k_meleon",
    LibreWolf: "librewolf",
    Maxthon: "maxthon",
    "Meta-ExternalAds": "meta_externalads",
    "Meta-ExternalAgent": "meta_externalagent",
    "Meta-ExternalFetcher": "meta_externalfetcher",
    "Meta-WebIndexer": "meta_webindexer",
    "Microsoft Edge": "edge",
    "MZ Browser": "mz",
    "NAVER Whale Browser": "naver",
    "OAI-SearchBot": "oai_searchbot",
    Omgilibot: "omgilibot",
    Opera: "opera",
    "Opera Coast": "opera_coast",
    "Pale Moon": "pale_moon",
    PerplexityBot: "perplexitybot",
    "Perplexity-User": "perplexity_user",
    PhantomJS: "phantomjs",
    PingdomBot: "pingdombot",
    Puffin: "puffin",
    QQ: "qq",
    QQLite: "qqlite",
    QupZilla: "qupzilla",
    Roku: "roku",
    Safari: "safari",
    Sailfish: "sailfish",
    "Samsung Internet for Android": "samsung_internet",
    SeaMonkey: "seamonkey",
    Sleipnir: "sleipnir",
    "Sogou Browser": "sogou",
    Swing: "swing",
    Tizen: "tizen",
    "UC Browser": "uc",
    Vivaldi: "vivaldi",
    "WebOS Browser": "webos",
    WeChat: "wechat",
    YahooSlurp: "yahooslurp",
    "Yandex Browser": "yandex",
    YandexBot: "yandexbot",
    YouBot: "youbot"
}, $1ec05aac0120a3f2$var$ne = {
    amazonbot: "AmazonBot",
    amazon_silk: "Amazon Silk",
    android: "Android Browser",
    baiduspider: "BaiduSpider",
    bada: "Bada",
    bingcrawler: "BingCrawler",
    blackberry: "BlackBerry",
    chatgpt_user: "ChatGPT-User",
    chrome: "Chrome",
    claudebot: "ClaudeBot",
    chromium: "Chromium",
    diffbot: "Diffbot",
    duckduckbot: "DuckDuckBot",
    edge: "Microsoft Edge",
    electron: "Electron",
    epiphany: "Epiphany",
    facebookexternalhit: "FacebookExternalHit",
    firefox: "Firefox",
    focus: "Focus",
    generic: "Generic",
    google_search: "Google Search",
    googlebot: "Googlebot",
    gptbot: "GPTBot",
    ie: "Internet Explorer",
    internetarchivecrawler: "InternetArchiveCrawler",
    k_meleon: "K-Meleon",
    librewolf: "LibreWolf",
    maxthon: "Maxthon",
    meta_externalads: "Meta-ExternalAds",
    meta_externalagent: "Meta-ExternalAgent",
    meta_externalfetcher: "Meta-ExternalFetcher",
    meta_webindexer: "Meta-WebIndexer",
    mz: "MZ Browser",
    naver: "NAVER Whale Browser",
    oai_searchbot: "OAI-SearchBot",
    omgilibot: "Omgilibot",
    opera: "Opera",
    opera_coast: "Opera Coast",
    pale_moon: "Pale Moon",
    perplexitybot: "PerplexityBot",
    perplexity_user: "Perplexity-User",
    phantomjs: "PhantomJS",
    pingdombot: "PingdomBot",
    puffin: "Puffin",
    qq: "QQ Browser",
    qqlite: "QQ Browser Lite",
    qupzilla: "QupZilla",
    roku: "Roku",
    safari: "Safari",
    sailfish: "Sailfish",
    samsung_internet: "Samsung Internet for Android",
    seamonkey: "SeaMonkey",
    sleipnir: "Sleipnir",
    sogou: "Sogou Browser",
    swing: "Swing",
    tizen: "Tizen",
    uc: "UC Browser",
    vivaldi: "Vivaldi",
    webos: "WebOS Browser",
    wechat: "WeChat",
    yahooslurp: "YahooSlurp",
    yandex: "Yandex Browser",
    yandexbot: "YandexBot",
    youbot: "YouBot"
}, $1ec05aac0120a3f2$var$re = {
    bot: "bot",
    desktop: "desktop",
    mobile: "mobile",
    tablet: "tablet",
    tv: "tv"
}, $1ec05aac0120a3f2$var$ie = {
    Android: "Android",
    Bada: "Bada",
    BlackBerry: "BlackBerry",
    ChromeOS: "Chrome OS",
    HarmonyOS: "HarmonyOS",
    iOS: "iOS",
    Linux: "Linux",
    MacOS: "macOS",
    PlayStation4: "PlayStation 4",
    Roku: "Roku",
    Tizen: "Tizen",
    WebOS: "WebOS",
    Windows: "Windows",
    WindowsPhone: "Windows Phone"
}, $1ec05aac0120a3f2$var$oe = {
    Blink: "Blink",
    EdgeHTML: "EdgeHTML",
    Gecko: "Gecko",
    Presto: "Presto",
    Trident: "Trident",
    WebKit: "WebKit"
};
/*!
 * Bowser - a browser detector
 * https://github.com/bowser-js/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ class $1ec05aac0120a3f2$var$ae {
    static getFirstMatch(e, t) {
        const n = t.match(e);
        return n && n.length > 0 && n[1] || "";
    }
    static getSecondMatch(e, t) {
        const n = t.match(e);
        return n && n.length > 1 && n[2] || "";
    }
    static matchAndReturnConst(e, t, n) {
        if (e.test(t)) return n;
    }
    static getWindowsVersionName(e) {
        switch(e){
            case "NT":
                return "NT";
            case "XP":
            case "NT 5.1":
                return "XP";
            case "NT 5.0":
                return "2000";
            case "NT 5.2":
                return "2003";
            case "NT 6.0":
                return "Vista";
            case "NT 6.1":
                return "7";
            case "NT 6.2":
                return "8";
            case "NT 6.3":
                return "8.1";
            case "NT 10.0":
                return "10";
            default:
                return;
        }
    }
    static getMacOSVersionName(e) {
        const t = e.split(".").splice(0, 2).map((e)=>parseInt(e, 10) || 0);
        t.push(0);
        const n = t[0], r = t[1];
        if (10 === n) switch(r){
            case 5:
                return "Leopard";
            case 6:
                return "Snow Leopard";
            case 7:
                return "Lion";
            case 8:
                return "Mountain Lion";
            case 9:
                return "Mavericks";
            case 10:
                return "Yosemite";
            case 11:
                return "El Capitan";
            case 12:
                return "Sierra";
            case 13:
                return "High Sierra";
            case 14:
                return "Mojave";
            case 15:
                return "Catalina";
            default:
                return;
        }
        switch(n){
            case 11:
                return "Big Sur";
            case 12:
                return "Monterey";
            case 13:
                return "Ventura";
            case 14:
                return "Sonoma";
            case 15:
                return "Sequoia";
            default:
                return;
        }
    }
    static getAndroidVersionName(e) {
        const t = e.split(".").splice(0, 2).map((e)=>parseInt(e, 10) || 0);
        if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
    }
    static getVersionPrecision(e) {
        return e.split(".").length;
    }
    static compareVersions(e, t, n = !1) {
        const r = $1ec05aac0120a3f2$var$ae.getVersionPrecision(e), i = $1ec05aac0120a3f2$var$ae.getVersionPrecision(t);
        let o = Math.max(r, i), a = 0;
        const s = $1ec05aac0120a3f2$var$ae.map([
            e,
            t
        ], (e)=>{
            const t = o - $1ec05aac0120a3f2$var$ae.getVersionPrecision(e), n = e + new Array(Math.max(0, t + 1)).join(".0");
            return $1ec05aac0120a3f2$var$ae.map(n.split("."), (e)=>new Array(Math.max(0, 20 - e.length)).join("0") + e).reverse();
        });
        for(n && (a = o - Math.min(r, i)), o -= 1; o >= a;){
            if (s[0][o] > s[1][o]) return 1;
            if (s[0][o] === s[1][o]) {
                if (o === a) return 0;
                o -= 1;
            } else if (s[0][o] < s[1][o]) return -1;
        }
    }
    static map(e, t) {
        const n = [];
        let r;
        if (Array.prototype.map) return Array.prototype.map.call(e, t);
        for(r = 0; r < e.length; r += 1)n.push(t(e[r], r));
        return n;
    }
    static find(e, t) {
        let n, r;
        if (Array.prototype.find) return Array.prototype.find.call(e, t);
        for(n = 0, r = e.length; n < r; n += 1){
            const r = e[n];
            if (t(r, n)) return r;
        }
    }
    static assign(e, ...t) {
        const n = e;
        let r, i;
        if (Object.assign) return Object.assign(e, ...t);
        for(r = 0, i = t.length; r < i; r += 1){
            const e = t[r];
            if ("object" == typeof e && null !== e) Object.keys(e).forEach((t)=>{
                n[t] = e[t];
            });
        }
        return e;
    }
    static getBrowserAlias(e) {
        return $1ec05aac0120a3f2$var$te[e];
    }
    static getBrowserTypeByAlias(e) {
        return $1ec05aac0120a3f2$var$ne[e] || "";
    }
}
/*!
 * Bowser - a browser detector
 * https://github.com/bowser-js/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ const $1ec05aac0120a3f2$var$se = /version\/(\d+(\.?_?\d+)+)/i, $1ec05aac0120a3f2$var$ce = [
    {
        test: [
            /gptbot/i
        ],
        describe (e) {
            const t = {
                name: "GPTBot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/gptbot\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /chatgpt-user/i
        ],
        describe (e) {
            const t = {
                name: "ChatGPT-User"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/chatgpt-user\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /oai-searchbot/i
        ],
        describe (e) {
            const t = {
                name: "OAI-SearchBot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/oai-searchbot\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /claudebot/i,
            /claude-web/i,
            /claude-user/i,
            /claude-searchbot/i
        ],
        describe (e) {
            const t = {
                name: "ClaudeBot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:claudebot|claude-web|claude-user|claude-searchbot)\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /omgilibot/i,
            /webzio-extended/i
        ],
        describe (e) {
            const t = {
                name: "Omgilibot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:omgilibot|webzio-extended)\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /diffbot/i
        ],
        describe (e) {
            const t = {
                name: "Diffbot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/diffbot\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /perplexitybot/i
        ],
        describe (e) {
            const t = {
                name: "PerplexityBot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/perplexitybot\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /perplexity-user/i
        ],
        describe (e) {
            const t = {
                name: "Perplexity-User"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/perplexity-user\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /youbot/i
        ],
        describe (e) {
            const t = {
                name: "YouBot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/youbot\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /meta-webindexer/i
        ],
        describe (e) {
            const t = {
                name: "Meta-WebIndexer"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/meta-webindexer\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /meta-externalads/i
        ],
        describe (e) {
            const t = {
                name: "Meta-ExternalAds"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/meta-externalads\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /meta-externalagent/i
        ],
        describe (e) {
            const t = {
                name: "Meta-ExternalAgent"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/meta-externalagent\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /meta-externalfetcher/i
        ],
        describe (e) {
            const t = {
                name: "Meta-ExternalFetcher"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/meta-externalfetcher\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /googlebot/i
        ],
        describe (e) {
            const t = {
                name: "Googlebot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /amazonbot/i
        ],
        describe (e) {
            const t = {
                name: "AmazonBot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/amazonbot\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /bingbot/i
        ],
        describe (e) {
            const t = {
                name: "BingCrawler"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/bingbot\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /baiduspider/i
        ],
        describe (e) {
            const t = {
                name: "BaiduSpider"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/baiduspider\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /duckduckbot/i
        ],
        describe (e) {
            const t = {
                name: "DuckDuckBot"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/duckduckbot\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /ia_archiver/i
        ],
        describe (e) {
            const t = {
                name: "InternetArchiveCrawler"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/ia_archiver\/(\d+(\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /facebookexternalhit/i,
            /facebookcatalog/i
        ],
        describe: ()=>({
                name: "FacebookExternalHit"
            })
    },
    {
        test: [
            /yahoo!?[\s/]*slurp/i
        ],
        describe: ()=>({
                name: "YahooSlurp"
            })
    },
    {
        test: [
            /yandexbot/i,
            /yandexmobilebot/i
        ],
        describe: ()=>({
                name: "YandexBot"
            })
    },
    {
        test: [
            /pingdom/i
        ],
        describe: ()=>({
                name: "PingdomBot"
            })
    },
    {
        test: [
            /opera/i
        ],
        describe (e) {
            const t = {
                name: "Opera"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /opr\/|opios/i
        ],
        describe (e) {
            const t = {
                name: "Opera"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /SamsungBrowser/i
        ],
        describe (e) {
            const t = {
                name: "Samsung Internet for Android"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /Whale/i
        ],
        describe (e) {
            const t = {
                name: "NAVER Whale Browser"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /PaleMoon/i
        ],
        describe (e) {
            const t = {
                name: "Pale Moon"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:PaleMoon)[\s/](\d+(?:\.\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /MZBrowser/i
        ],
        describe (e) {
            const t = {
                name: "MZ Browser"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /focus/i
        ],
        describe (e) {
            const t = {
                name: "Focus"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /swing/i
        ],
        describe (e) {
            const t = {
                name: "Swing"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /coast/i
        ],
        describe (e) {
            const t = {
                name: "Opera Coast"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /opt\/\d+(?:.?_?\d+)+/i
        ],
        describe (e) {
            const t = {
                name: "Opera Touch"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /yabrowser/i
        ],
        describe (e) {
            const t = {
                name: "Yandex Browser"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /ucbrowser/i
        ],
        describe (e) {
            const t = {
                name: "UC Browser"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /Maxthon|mxios/i
        ],
        describe (e) {
            const t = {
                name: "Maxthon"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /epiphany/i
        ],
        describe (e) {
            const t = {
                name: "Epiphany"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /puffin/i
        ],
        describe (e) {
            const t = {
                name: "Puffin"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /sleipnir/i
        ],
        describe (e) {
            const t = {
                name: "Sleipnir"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /k-meleon/i
        ],
        describe (e) {
            const t = {
                name: "K-Meleon"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /micromessenger/i
        ],
        describe (e) {
            const t = {
                name: "WeChat"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /qqbrowser/i
        ],
        describe (e) {
            const t = {
                name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /msie|trident/i
        ],
        describe (e) {
            const t = {
                name: "Internet Explorer"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /\sedg\//i
        ],
        describe (e) {
            const t = {
                name: "Microsoft Edge"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /edg([ea]|ios)/i
        ],
        describe (e) {
            const t = {
                name: "Microsoft Edge"
            }, n = $1ec05aac0120a3f2$var$ae.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /vivaldi/i
        ],
        describe (e) {
            const t = {
                name: "Vivaldi"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /seamonkey/i
        ],
        describe (e) {
            const t = {
                name: "SeaMonkey"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /sailfish/i
        ],
        describe (e) {
            const t = {
                name: "Sailfish"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /silk/i
        ],
        describe (e) {
            const t = {
                name: "Amazon Silk"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /phantom/i
        ],
        describe (e) {
            const t = {
                name: "PhantomJS"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /slimerjs/i
        ],
        describe (e) {
            const t = {
                name: "SlimerJS"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /blackberry|\bbb\d+/i,
            /rim\stablet/i
        ],
        describe (e) {
            const t = {
                name: "BlackBerry"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /(web|hpw)[o0]s/i
        ],
        describe (e) {
            const t = {
                name: "WebOS Browser"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /bada/i
        ],
        describe (e) {
            const t = {
                name: "Bada"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /tizen/i
        ],
        describe (e) {
            const t = {
                name: "Tizen"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /qupzilla/i
        ],
        describe (e) {
            const t = {
                name: "QupZilla"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /librewolf/i
        ],
        describe (e) {
            const t = {
                name: "LibreWolf"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:librewolf)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /firefox|iceweasel|fxios/i
        ],
        describe (e) {
            const t = {
                name: "Firefox"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /electron/i
        ],
        describe (e) {
            const t = {
                name: "Electron"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /sogoumobilebrowser/i,
            /metasr/i,
            /se 2\.[x]/i
        ],
        describe (e) {
            const t = {
                name: "Sogou Browser"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:sogoumobilebrowser)[\s/](\d+(\.?_?\d+)+)/i, e), r = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e), i = $1ec05aac0120a3f2$var$ae.getFirstMatch(/se ([\d.]+)x/i, e), o = n || r || i;
            return o && (t.version = o), t;
        }
    },
    {
        test: [
            /MiuiBrowser/i
        ],
        describe (e) {
            const t = {
                name: "Miui"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: (e)=>!!e.hasBrand("DuckDuckGo") || e.test(/\sDdg\/[\d.]+$/i),
        describe (e, t) {
            const n = {
                name: "DuckDuckGo"
            };
            if (t) {
                const e = t.getBrandVersion("DuckDuckGo");
                if (e) return n.version = e, n;
            }
            const r = $1ec05aac0120a3f2$var$ae.getFirstMatch(/\sDdg\/([\d.]+)$/i, e);
            return r && (n.version = r), n;
        }
    },
    {
        test: (e)=>e.hasBrand("Brave"),
        describe (e, t) {
            const n = {
                name: "Brave"
            };
            if (t) {
                const e = t.getBrandVersion("Brave");
                if (e) return n.version = e, n;
            }
            return n;
        }
    },
    {
        test: [
            /chromium/i
        ],
        describe (e) {
            const t = {
                name: "Chromium"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /chrome|crios|crmo/i
        ],
        describe (e) {
            const t = {
                name: "Chrome"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /GSA/i
        ],
        describe (e) {
            const t = {
                name: "Google Search"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
            return n && (t.version = n), t;
        }
    },
    {
        test (e) {
            const t = !e.test(/like android/i), n = e.test(/android/i);
            return t && n;
        },
        describe (e) {
            const t = {
                name: "Android Browser"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /playstation 4/i
        ],
        describe (e) {
            const t = {
                name: "PlayStation 4"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /safari|applewebkit/i
        ],
        describe (e) {
            const t = {
                name: "Safari"
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch($1ec05aac0120a3f2$var$se, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /.*/i
        ],
        describe (e) {
            const t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
            return {
                name: $1ec05aac0120a3f2$var$ae.getFirstMatch(t, e),
                version: $1ec05aac0120a3f2$var$ae.getSecondMatch(t, e)
            };
        }
    }
], $1ec05aac0120a3f2$var$ue = [
    {
        test: [
            /Roku\/DVP/
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
            return {
                name: $1ec05aac0120a3f2$var$ie.Roku,
                version: t
            };
        }
    },
    {
        test: [
            /windows phone/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
            return {
                name: $1ec05aac0120a3f2$var$ie.WindowsPhone,
                version: t
            };
        }
    },
    {
        test: [
            /windows /i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), n = $1ec05aac0120a3f2$var$ae.getWindowsVersionName(t);
            return {
                name: $1ec05aac0120a3f2$var$ie.Windows,
                version: t,
                versionName: n
            };
        }
    },
    {
        test: [
            /Macintosh(.*?) FxiOS(.*?)\//
        ],
        describe (e) {
            const t = {
                name: $1ec05aac0120a3f2$var$ie.iOS
            }, n = $1ec05aac0120a3f2$var$ae.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /macintosh/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), n = $1ec05aac0120a3f2$var$ae.getMacOSVersionName(t), r = {
                name: $1ec05aac0120a3f2$var$ie.MacOS,
                version: t
            };
            return n && (r.versionName = n), r;
        }
    },
    {
        test: [
            /(ipod|iphone|ipad)/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
            return {
                name: $1ec05aac0120a3f2$var$ie.iOS,
                version: t
            };
        }
    },
    {
        test: [
            /OpenHarmony/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/OpenHarmony\s+(\d+(\.\d+)*)/i, e);
            return {
                name: $1ec05aac0120a3f2$var$ie.HarmonyOS,
                version: t
            };
        }
    },
    {
        test (e) {
            const t = !e.test(/like android/i), n = e.test(/android/i);
            return t && n;
        },
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), n = $1ec05aac0120a3f2$var$ae.getAndroidVersionName(t), r = {
                name: $1ec05aac0120a3f2$var$ie.Android,
                version: t
            };
            return n && (r.versionName = n), r;
        }
    },
    {
        test: [
            /(web|hpw)[o0]s/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), n = {
                name: $1ec05aac0120a3f2$var$ie.WebOS
            };
            return t && t.length && (n.version = t), n;
        }
    },
    {
        test: [
            /blackberry|\bbb\d+/i,
            /rim\stablet/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || $1ec05aac0120a3f2$var$ae.getFirstMatch(/\bbb(\d+)/i, e);
            return {
                name: $1ec05aac0120a3f2$var$ie.BlackBerry,
                version: t
            };
        }
    },
    {
        test: [
            /bada/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
            return {
                name: $1ec05aac0120a3f2$var$ie.Bada,
                version: t
            };
        }
    },
    {
        test: [
            /tizen/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
            return {
                name: $1ec05aac0120a3f2$var$ie.Tizen,
                version: t
            };
        }
    },
    {
        test: [
            /linux/i
        ],
        describe: ()=>({
                name: $1ec05aac0120a3f2$var$ie.Linux
            })
    },
    {
        test: [
            /CrOS/
        ],
        describe: ()=>({
                name: $1ec05aac0120a3f2$var$ie.ChromeOS
            })
    },
    {
        test: [
            /PlayStation 4/
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
            return {
                name: $1ec05aac0120a3f2$var$ie.PlayStation4,
                version: t
            };
        }
    }
], $1ec05aac0120a3f2$var$le = [
    {
        test: [
            /googlebot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Google"
            })
    },
    {
        test: [
            /amazonbot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Amazon"
            })
    },
    {
        test: [
            /gptbot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "OpenAI"
            })
    },
    {
        test: [
            /chatgpt-user/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "OpenAI"
            })
    },
    {
        test: [
            /oai-searchbot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "OpenAI"
            })
    },
    {
        test: [
            /baiduspider/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Baidu"
            })
    },
    {
        test: [
            /bingbot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Bing"
            })
    },
    {
        test: [
            /duckduckbot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "DuckDuckGo"
            })
    },
    {
        test: [
            /claudebot/i,
            /claude-web/i,
            /claude-user/i,
            /claude-searchbot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Anthropic"
            })
    },
    {
        test: [
            /omgilibot/i,
            /webzio-extended/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Webz.io"
            })
    },
    {
        test: [
            /diffbot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Diffbot"
            })
    },
    {
        test: [
            /perplexitybot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Perplexity AI"
            })
    },
    {
        test: [
            /perplexity-user/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Perplexity AI"
            })
    },
    {
        test: [
            /youbot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "You.com"
            })
    },
    {
        test: [
            /ia_archiver/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Internet Archive"
            })
    },
    {
        test: [
            /meta-webindexer/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Meta"
            })
    },
    {
        test: [
            /meta-externalads/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Meta"
            })
    },
    {
        test: [
            /meta-externalagent/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Meta"
            })
    },
    {
        test: [
            /meta-externalfetcher/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Meta"
            })
    },
    {
        test: [
            /facebookexternalhit/i,
            /facebookcatalog/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Meta"
            })
    },
    {
        test: [
            /yahoo/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Yahoo"
            })
    },
    {
        test: [
            /yandexbot/i,
            /yandexmobilebot/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Yandex"
            })
    },
    {
        test: [
            /pingdom/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.bot,
                vendor: "Pingdom"
            })
    },
    {
        test: [
            /huawei/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(can-l01)/i, e || "") && "Nova", n = {
                type: $1ec05aac0120a3f2$var$re.mobile,
                vendor: "Huawei"
            };
            return t && (n.model = t), n;
        }
    },
    {
        test: [
            /nexus\s*(?:7|8|9|10).*/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.tablet,
                vendor: "Nexus"
            })
    },
    {
        test: [
            /ipad/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.tablet,
                vendor: "Apple",
                model: "iPad"
            })
    },
    {
        test: [
            /Macintosh(.*?) FxiOS(.*?)\//
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.tablet,
                vendor: "Apple",
                model: "iPad"
            })
    },
    {
        test: [
            /kftt build/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.tablet,
                vendor: "Amazon",
                model: "Kindle Fire HD 7"
            })
    },
    {
        test: [
            /silk/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.tablet,
                vendor: "Amazon"
            })
    },
    {
        test: [
            /tablet(?! pc)/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.tablet
            })
    },
    {
        test (e) {
            const t = e.test(/ipod|iphone/i), n = e.test(/like (ipod|iphone)/i);
            return t && !n;
        },
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/(ipod|iphone)/i, e || "");
            return {
                type: $1ec05aac0120a3f2$var$re.mobile,
                vendor: "Apple",
                model: t
            };
        }
    },
    {
        test: [
            /nexus\s*[0-6].*/i,
            /galaxy nexus/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.mobile,
                vendor: "Nexus"
            })
    },
    {
        test: [
            /Nokia/i
        ],
        describe (e) {
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/Nokia\s+([0-9]+(\.[0-9]+)?)/i, e || ""), n = {
                type: $1ec05aac0120a3f2$var$re.mobile,
                vendor: "Nokia"
            };
            return t && (n.model = t), n;
        }
    },
    {
        test: [
            /[^-]mobi/i
        ],
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.mobile
            })
    },
    {
        test: (e)=>"blackberry" === e.getBrowserName(!0),
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.mobile,
                vendor: "BlackBerry"
            })
    },
    {
        test: (e)=>"bada" === e.getBrowserName(!0),
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.mobile
            })
    },
    {
        test: (e)=>"windows phone" === e.getBrowserName(),
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.mobile,
                vendor: "Microsoft"
            })
    },
    {
        test (e) {
            const t = Number(String(e.getOSVersion()).split(".")[0]);
            return "android" === e.getOSName(!0) && t >= 3;
        },
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.tablet
            })
    },
    {
        test: (e)=>"android" === e.getOSName(!0),
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.mobile
            })
    },
    {
        test: (e)=>"macos" === e.getOSName(!0),
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.desktop,
                vendor: "Apple"
            })
    },
    {
        test: (e)=>"windows" === e.getOSName(!0),
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.desktop
            })
    },
    {
        test: (e)=>"linux" === e.getOSName(!0),
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.desktop
            })
    },
    {
        test: (e)=>"playstation 4" === e.getOSName(!0),
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.tv
            })
    },
    {
        test: (e)=>"roku" === e.getOSName(!0),
        describe: ()=>({
                type: $1ec05aac0120a3f2$var$re.tv
            })
    }
], $1ec05aac0120a3f2$var$de = [
    {
        test: (e)=>"microsoft edge" === e.getBrowserName(!0),
        describe (e) {
            if (/\sedg\//i.test(e || "")) return {
                name: $1ec05aac0120a3f2$var$oe.Blink
            };
            const t = $1ec05aac0120a3f2$var$ae.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e || "");
            return {
                name: $1ec05aac0120a3f2$var$oe.EdgeHTML,
                version: t
            };
        }
    },
    {
        test: [
            /trident/i
        ],
        describe (e) {
            const t = {
                name: $1ec05aac0120a3f2$var$oe.Trident
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e || "");
            return n && (t.version = n), t;
        }
    },
    {
        test: (e)=>e.test(/presto/i),
        describe (e) {
            const t = {
                name: $1ec05aac0120a3f2$var$oe.Presto
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e || "");
            return n && (t.version = n), t;
        }
    },
    {
        test (e) {
            const t = e.test(/gecko/i), n = e.test(/like gecko/i);
            return t && !n;
        },
        describe (e) {
            const t = {
                name: $1ec05aac0120a3f2$var$oe.Gecko
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e || "");
            return n && (t.version = n), t;
        }
    },
    {
        test: [
            /(apple)?webkit\/537\.36/i
        ],
        describe: ()=>({
                name: $1ec05aac0120a3f2$var$oe.Blink
            })
    },
    {
        test: [
            /(apple)?webkit/i
        ],
        describe (e) {
            const t = {
                name: $1ec05aac0120a3f2$var$oe.WebKit
            }, n = $1ec05aac0120a3f2$var$ae.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e || "");
            return n && (t.version = n), t;
        }
    }
];
/*!
 * Bowser - a browser detector
 * https://github.com/bowser-js/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ class $1ec05aac0120a3f2$var$pe {
    constructor(e, t = !1, n = null){
        if (null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
        this._ua = e;
        let r = !1;
        "boolean" == typeof t ? (r = t, this._hints = n) : this._hints = null != t && "object" == typeof t ? t : null, this.parsedResult = {}, !0 !== r && this.parse();
    }
    getHints() {
        return this._hints;
    }
    hasBrand(e) {
        if (!this._hints || !Array.isArray(this._hints.brands)) return !1;
        const t = e.toLowerCase();
        return this._hints.brands.some((e)=>e.brand && e.brand.toLowerCase() === t);
    }
    getBrandVersion(e) {
        if (!this._hints || !Array.isArray(this._hints.brands)) return;
        const t = e.toLowerCase(), n = this._hints.brands.find((e)=>e.brand && e.brand.toLowerCase() === t);
        return n ? n.version : void 0;
    }
    getUA() {
        return this._ua;
    }
    test(e) {
        return e.test(this._ua);
    }
    parseBrowser() {
        this.parsedResult.browser = {};
        const e = $1ec05aac0120a3f2$var$ae.find($1ec05aac0120a3f2$var$ce, (e)=>{
            if ("function" == typeof e.test) return e.test(this);
            if (Array.isArray(e.test)) return e.test.some((e)=>this.test(e));
            throw new Error("Browser's test function is not valid");
        });
        return e && (this.parsedResult.browser = e.describe(this.getUA(), this)), this.parsedResult.browser;
    }
    getBrowser() {
        return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
    }
    getBrowserName(e) {
        return e ? String(this.getBrowser().name || "").toLowerCase() || "" : this.getBrowser().name || "";
    }
    getBrowserVersion() {
        return this.getBrowser().version;
    }
    getOS() {
        return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
    }
    parseOS() {
        this.parsedResult.os = {};
        const e = $1ec05aac0120a3f2$var$ae.find($1ec05aac0120a3f2$var$ue, (e)=>{
            if ("function" == typeof e.test) return e.test(this);
            if (Array.isArray(e.test)) return e.test.some((e)=>this.test(e));
            throw new Error("Browser's test function is not valid");
        });
        return e && (this.parsedResult.os = e.describe(this.getUA())), this.parsedResult.os;
    }
    getOSName(e) {
        const { name: t } = this.getOS();
        return e ? String(t || "").toLowerCase() || "" : t || "";
    }
    getOSVersion() {
        return this.getOS().version;
    }
    getPlatform() {
        return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
    }
    getPlatformType(e = !1) {
        const { type: t } = this.getPlatform();
        return e ? String(t || "").toLowerCase() || "" : t || "";
    }
    parsePlatform() {
        this.parsedResult.platform = {};
        const e = $1ec05aac0120a3f2$var$ae.find($1ec05aac0120a3f2$var$le, (e)=>{
            if ("function" == typeof e.test) return e.test(this);
            if (Array.isArray(e.test)) return e.test.some((e)=>this.test(e));
            throw new Error("Browser's test function is not valid");
        });
        return e && (this.parsedResult.platform = e.describe(this.getUA())), this.parsedResult.platform;
    }
    getEngine() {
        return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
    }
    getEngineName(e) {
        return e ? String(this.getEngine().name || "").toLowerCase() || "" : this.getEngine().name || "";
    }
    parseEngine() {
        this.parsedResult.engine = {};
        const e = $1ec05aac0120a3f2$var$ae.find($1ec05aac0120a3f2$var$de, (e)=>{
            if ("function" == typeof e.test) return e.test(this);
            if (Array.isArray(e.test)) return e.test.some((e)=>this.test(e));
            throw new Error("Browser's test function is not valid");
        });
        return e && (this.parsedResult.engine = e.describe(this.getUA())), this.parsedResult.engine;
    }
    parse() {
        return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
    }
    getResult() {
        return $1ec05aac0120a3f2$var$ae.assign({
            browser: {},
            os: {},
            platform: {},
            engine: {}
        }, this.parsedResult);
    }
    satisfies(e) {
        const t = {};
        let n = 0;
        const r = {};
        let i = 0;
        if (Object.keys(e).forEach((o)=>{
            const a = e[o];
            "string" == typeof a ? (r[o] = a, i += 1) : "object" == typeof a && (t[o] = a, n += 1);
        }), n > 0) {
            const e = Object.keys(t), n = $1ec05aac0120a3f2$var$ae.find(e, (e)=>this.isOS(e));
            if (n) {
                const e = this.satisfies(t[n]);
                if (void 0 !== e) return e;
            }
            const r = $1ec05aac0120a3f2$var$ae.find(e, (e)=>this.isPlatform(e));
            if (r) {
                const e = this.satisfies(t[r]);
                if (void 0 !== e) return e;
            }
        }
        if (i > 0) {
            const e = Object.keys(r), t = $1ec05aac0120a3f2$var$ae.find(e, (e)=>this.isBrowser(e, !0));
            if (void 0 !== t) return this.compareVersion(r[t]);
        }
    }
    isBrowser(e, t = !1) {
        const n = this.getBrowserName().toLowerCase();
        let r = e.toLowerCase();
        const i = $1ec05aac0120a3f2$var$ae.getBrowserTypeByAlias(r);
        return t && i && (r = i.toLowerCase()), r === n;
    }
    compareVersion(e) {
        let t = [
            0
        ], n = e, r = !1;
        const i = this.getBrowserVersion();
        if ("string" != typeof i) return;
        ">" === e[0] || "<" === e[0] ? (n = e.substr(1), "=" === e[1] ? (r = !0, n = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? n = e.substr(1) : "~" === e[0] && (r = !0, n = e.substr(1));
        const o = $1ec05aac0120a3f2$var$ae.compareVersions(i, n, r);
        return void 0 !== o && t.indexOf(o) > -1;
    }
    isOS(e) {
        return this.getOSName(!0) === String(e).toLowerCase();
    }
    isPlatform(e) {
        return this.getPlatformType(!0) === String(e).toLowerCase();
    }
    isEngine(e) {
        return this.getEngineName(!0) === String(e).toLowerCase();
    }
    is(e, t = !1) {
        return this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
    }
    some(e = []) {
        return e.some((e)=>this.is(e));
    }
}
/*!
 * Bowser - a browser detector (v2.13.1)
 * https://github.com/bowser-js/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ class $1ec05aac0120a3f2$var$fe {
    static getParser(e, t = !1, n = null) {
        if ("string" != typeof e) throw new Error("UserAgent should be a string");
        return new $1ec05aac0120a3f2$var$pe(e, t, n);
    }
    static parse(e, t) {
        return new $1ec05aac0120a3f2$var$pe(e, t).getResult();
    }
    static get BROWSER_MAP() {
        return $1ec05aac0120a3f2$var$ne;
    }
    static get ENGINE_MAP() {
        return $1ec05aac0120a3f2$var$oe;
    }
    static get OS_MAP() {
        return $1ec05aac0120a3f2$var$ie;
    }
    static get PLATFORMS_MAP() {
        return $1ec05aac0120a3f2$var$re;
    }
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ /*!
 *
 * detectIncognito v1.5.0
 *
 * https://github.com/Joe12387/detectIncognito
 *
 * MIT License
 *
 * Copyright (c) 2021 - 2025 Joe Rutkowski <Joe@dreggle.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * Please keep this comment intact in order to properly abide by the MIT License.
 *
 **/ async function $1ec05aac0120a3f2$export$40b2248fa055142e() {
    return new Promise((e, t)=>{
        let n = "Unknown";
        function r(t) {
            e({
                isPrivate: t,
                browserName: n
            });
        }
        function i() {
            let e = 0, t = parseInt("-1");
            try {
                t.toFixed(t);
            } catch (t) {
                e = t.message.length;
            }
            return e;
        }
        function o() {
            return "undefined" != typeof navigator && void 0 !== navigator.msSaveBlob && function(e) {
                try {
                    return e === eval.toString().length;
                } catch (e) {
                    return !1;
                }
            }(39);
        }
        async function a() {
            "undefined" != typeof navigator ? void 0 !== navigator.storage?.getDirectory ? await async function() {
                if ("undefined" != typeof navigator && navigator.storage?.getDirectory) try {
                    await navigator.storage.getDirectory(), r(!1);
                } catch (e) {
                    let t = e;
                    if (e instanceof Error && (t = e.message ?? e), "string" != typeof t) return void r(!1);
                    r(!!t.includes("unknown transient reason"));
                }
                else r(!1);
            }() : void 0 !== navigator.maxTouchPoints ? function() {
                if ("undefined" == typeof indexedDB) return void r(!1);
                const e = String(Math.random());
                try {
                    const t = indexedDB.open(e, 1);
                    t.onupgradeneeded = (t)=>{
                        const n = t.target.result, i = (e)=>{
                            r(e);
                        };
                        try {
                            n.createObjectStore("t", {
                                autoIncrement: !0
                            }).put(new Blob), i(!1);
                        } catch (e) {
                            (e.message || "").includes("are not yet supported") ? i(!0) : i(!1);
                        } finally{
                            n.close(), indexedDB.deleteDatabase(e);
                        }
                    }, t.onerror = ()=>r(!1);
                } catch  {
                    r(!1);
                }
            }() : function() {
                if ("undefined" == typeof window) return void r(!1);
                const e = window.openDatabase, t = window.localStorage;
                try {
                    e(null, null, null, null);
                } catch (e) {
                    return void r(!0);
                }
                try {
                    t.setItem("test", "1"), t.removeItem("test");
                } catch (e) {
                    return void r(!0);
                }
                r(!1);
            }() : r(!1);
        }
        function s() {
            "undefined" != typeof navigator && navigator.webkitTemporaryStorage && "function" == typeof navigator.webkitTemporaryStorage.queryUsageAndQuota ? navigator.webkitTemporaryStorage.queryUsageAndQuota(function(e, t) {
                r(Math.round(t / 1048576) < 2 * Math.round(function() {
                    if ("undefined" == typeof window || "undefined" == typeof performance) return 1073741824;
                    const e = window;
                    return void 0 !== e.performance && void 0 !== e.performance.memory && void 0 !== e.performance.memory.jsHeapSizeLimit ? performance.memory.jsHeapSizeLimit : 1073741824;
                }() / 1048576));
            }, function(e) {
                $1ec05aac0120a3f2$export$79de5099e43c732e.warn("detectIncognito", `Failed to query storage quota: ${e.message}, defaulting to not private`), r(!1);
            }) : r(!1);
        }
        function c() {
            "undefined" != typeof self && "undefined" != typeof Promise ? void 0 !== self.Promise && void 0 !== self.Promise.allSettled ? s() : function() {
                if ("undefined" == typeof window || !window.webkitRequestFileSystem) return void r(!1);
                (0, window.webkitRequestFileSystem)(0, 1, function() {
                    r(!1);
                }, function() {
                    r(!0);
                });
            }() : r(!1);
        }
        "undefined" != typeof window && "undefined" != typeof navigator ? (async function() {
            "undefined" != typeof window && "undefined" != typeof navigator ? 44 === i() ? (n = "Safari", await a()) : 51 === i() ? (n = function() {
                if ("undefined" == typeof navigator) return "Unknown";
                try {
                    const e = $1ec05aac0120a3f2$var$fe.parse(navigator.userAgent).browser.name;
                    return "Chrome" === e && void 0 !== navigator.brave ? "Brave" : e || "Unknown";
                } catch (e) {
                    const t = navigator.userAgent;
                    return t.match(/Chrome/) ? void 0 !== navigator.brave ? "Brave" : t.match(/Edg/) ? "Edge" : t.match(/OPR/) ? "Opera" : "Chrome" : "Chromium";
                }
            }(), c()) : 25 === i() ? (n = "Firefox", "undefined" != typeof navigator ? r(void 0 === navigator.serviceWorker) : r(!1)) : o() ? (n = "Internet Explorer", "undefined" != typeof window ? r(void 0 === window.indexedDB) : r(!1)) : ($1ec05aac0120a3f2$export$79de5099e43c732e.warn("detectIncognito", "Cannot determine the browser, defaulting to not private"), r(!1)) : r(!1);
        })().catch(t) : e({
            isPrivate: !1,
            browserName: "Unknown"
        });
    });
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ function $1ec05aac0120a3f2$export$e66e9777a25f7214() {
    return "undefined" != typeof window && window.matchMedia ? window.matchMedia("(color-gamut: rec2020)").matches ? "rec2020" : window.matchMedia("(color-gamut: p3)").matches ? "p3" : window.matchMedia("(color-gamut: srgb)").matches ? "srgb" : "unknown" : "unknown";
}
async function $1ec05aac0120a3f2$export$ce9340c25c605fa0() {
    try {
        if ("undefined" == typeof window || !window.AudioContext && !window.webkitAudioContext) return null;
        const e = new (window.AudioContext || window.webkitAudioContext), t = e.createOscillator(), n = e.createAnalyser(), r = e.createGain(), i = e.createScriptProcessor(4096, 1, 1);
        r.gain.value = 0, t.type = "triangle", t.connect(n), n.connect(i), i.connect(r), r.connect(e.destination), t.start(0);
        const o = new Float32Array(n.frequencyBinCount);
        return n.getFloatFrequencyData(o), t.stop(), await e.close(), o.reduce((e, t)=>e + t, 0);
    } catch (e) {
        return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getAudioFingerprint", "Error getting audio fingerprint", e), null;
    }
}
function $1ec05aac0120a3f2$export$bceda55f827e9ec1() {
    const e = [];
    return navigator.userAgent.includes("Chrome") && e.push("chrome"), navigator.userAgent.includes("Firefox") && e.push("firefox"), navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome") && e.push("safari"), e;
}
function $1ec05aac0120a3f2$export$6515f7b9b46b3e7a() {
    try {
        return !("undefined" == typeof window || !window.localStorage) && (localStorage.setItem("test", "test"), localStorage.removeItem("test"), !0);
    } catch  {
        return !1;
    }
}
function $1ec05aac0120a3f2$export$aa54e0afc8dac45d() {
    try {
        return !("undefined" == typeof window || !window.sessionStorage) && (sessionStorage.setItem("test", "test"), sessionStorage.removeItem("test"), !0);
    } catch  {
        return !1;
    }
}
function $1ec05aac0120a3f2$export$775d9a05b79cc7d4() {
    return "undefined" != typeof window && !!window.indexedDB;
}
async function $1ec05aac0120a3f2$export$26314aceb7e23c5c() {
    let e = "unknown", t = "unknown", n = null;
    try {
        if ("undefined" == typeof document || !document.createElement) return {
            vendor: e,
            renderer: t,
            imageHash: "dom_unavailable"
        };
        const r = document.createElement("canvas");
        r.width = 64, r.height = 64;
        const i = r.getContext("webgl") || r.getContext("experimental-webgl");
        if (!i) return {
            vendor: e,
            renderer: t,
            imageHash: "webgl_context_unavailable"
        };
        try {
            const n = i.getExtension("WEBGL_debug_renderer_info");
            n ? (e = i.getParameter(n.UNMASKED_VENDOR_WEBGL) || e, t = i.getParameter(n.UNMASKED_RENDERER_WEBGL) || t) : (e = i.getParameter(i.VENDOR) || e, t = i.getParameter(i.RENDERER) || t);
        } catch (e) {
            $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getWebGLInfo", "Error getting WebGL vendor/renderer strings", e);
        }
        try {
            const o = "\n                attribute vec2 a_position;\n                attribute vec3 a_color;\n                varying vec3 v_color;\n                void main() {\n                    gl_Position = vec4(a_position, 0.0, 1.0);\n                    v_color = a_color;\n                }\n            ", a = "\n                precision mediump float;\n                varying vec3 v_color;\n                void main() {\n                    gl_FragColor = vec4(v_color, 1.0);\n                }\n            ", s = i.createShader(i.VERTEX_SHADER);
            if (!s) return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getWebGLInfo", "Failed to create vertex shader"), n = "shader_creation_error", {
                vendor: e,
                renderer: t,
                imageHash: n
            };
            i.shaderSource(s, o), i.compileShader(s);
            const c = i.createShader(i.FRAGMENT_SHADER);
            if (!c) return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getWebGLInfo", "Failed to create fragment shader"), n = "shader_creation_error", {
                vendor: e,
                renderer: t,
                imageHash: n
            };
            i.shaderSource(c, a), i.compileShader(c);
            const u = i.createProgram();
            if (!u) return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getWebGLInfo", "Failed to create program"), n = "program_creation_error", {
                vendor: e,
                renderer: t,
                imageHash: n
            };
            i.attachShader(u, s), i.attachShader(u, c), i.linkProgram(u), i.useProgram(u);
            const l = new Float32Array([
                -0.9,
                -0.9,
                1,
                0,
                0,
                .9,
                -0.9,
                0,
                1,
                0,
                -0.9,
                .9,
                0,
                0,
                1,
                .9,
                -0.9,
                0,
                1,
                0,
                .9,
                .9,
                1,
                1,
                0,
                -0.9,
                .9,
                0,
                0,
                1
            ]), d = i.createBuffer();
            i.bindBuffer(i.ARRAY_BUFFER, d), i.bufferData(i.ARRAY_BUFFER, l, i.STATIC_DRAW);
            const p = i.getAttribLocation(u, "a_position");
            i.enableVertexAttribArray(p), i.vertexAttribPointer(p, 2, i.FLOAT, !1, 5 * Float32Array.BYTES_PER_ELEMENT, 0);
            const f = i.getAttribLocation(u, "a_color");
            i.enableVertexAttribArray(f), i.vertexAttribPointer(f, 3, i.FLOAT, !1, 5 * Float32Array.BYTES_PER_ELEMENT, 2 * Float32Array.BYTES_PER_ELEMENT), i.clearColor(.5, .5, .5, 1), i.clear(i.COLOR_BUFFER_BIT), i.drawArrays(i.TRIANGLES, 0, 6);
            const g = new Uint8Array(r.width * r.height * 4);
            i.readPixels(0, 0, r.width, r.height, i.RGBA, i.UNSIGNED_BYTE, g);
            const h = Array.from(g).join(",");
            n = await $1ec05aac0120a3f2$var$y(h);
        } catch (e) {
            $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getWebGLInfo", "Error rendering WebGL scene for hash", e), n = "webgl_render_error";
        }
        return {
            vendor: e,
            renderer: t,
            imageHash: n
        };
    } catch (e) {
        return $1ec05aac0120a3f2$export$79de5099e43c732e.error("getWebGLInfo", "Error retrieving WebGL information", e), {
            vendor: "unknown",
            renderer: "unknown",
            imageHash: "webgl_overall_error"
        };
    }
}
function $1ec05aac0120a3f2$export$ae1f21143e050ca0() {
    try {
        if ("undefined" == typeof document || !document.createElement) return {
            winding: !1,
            geometry: "",
            text: ""
        };
        const e = document.createElement("canvas");
        e.width = 200, e.height = 50;
        const t = e.getContext("2d");
        return t ? (t.textBaseline = "top", t.font = "14px Arial", t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(125, 1, 62, 20), t.fillStyle = "#069", t.fillText("Fingerprint", 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.7)", t.fillText("Test", 4, 17), {
            winding: t.isPointInPath(0, 0, "evenodd") !== t.isPointInPath(0, 0, "nonzero"),
            geometry: e.toDataURL(),
            text: t.font
        }) : {
            winding: !1,
            geometry: "",
            text: ""
        };
    } catch  {
        return {
            winding: !1,
            geometry: "",
            text: ""
        };
    }
}
function $1ec05aac0120a3f2$export$53ed4462388b7e3c() {
    if ("undefined" == typeof navigator || !navigator.plugins) return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getPluginsInfo", "Navigator plugins not available"), [];
    try {
        return Array.from(navigator.plugins).map((e)=>{
            if (!e) return null;
            const t = [];
            try {
                for(const n in e){
                    const r = e[n];
                    r && "object" == typeof r && r.type && r.suffixes && t.push({
                        type: r.type || "",
                        suffixes: r.suffixes || ""
                    });
                }
            } catch (t) {
                $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getPluginsInfo", `Error enumerating mime types for plugin: ${e.name}`, t);
            }
            return {
                name: e.name || "",
                description: e.description || "",
                mimeTypes: t
            };
        }).filter(Boolean);
    } catch (e) {
        return $1ec05aac0120a3f2$export$79de5099e43c732e.error("getPluginsInfo", "Error getting plugins", e), [];
    }
}
function $1ec05aac0120a3f2$export$a1de9105a12432fa() {
    return {
        acos: Math.acos(.123456789),
        acosh: Math.acosh(1.123456789),
        asinh: Math.asinh(.123456789),
        atanh: Math.atanh(.123456789),
        expm1: Math.expm1(.123456789),
        sinh: Math.sinh(.123456789),
        cosh: Math.cosh(.123456789),
        tanh: Math.tanh(.123456789)
    };
}
function $1ec05aac0120a3f2$export$8edff794b322b33f() {
    const e = [
        "Arial",
        "Arial Black",
        "Calibri",
        "Cambria",
        "Candara",
        "Comic Sans MS",
        "Consolas",
        "Constantia",
        "Corbel",
        "Courier New",
        "Ebrima",
        "Franklin Gothic Medium",
        "Gabriola",
        "Gadugi",
        "Georgia",
        "Impact",
        "Javanese Text",
        "Leelawadee UI",
        "Lucida Console",
        "Lucida Sans Unicode",
        "Malgun Gothic",
        "Marlett",
        "Microsoft Himalaya",
        "Microsoft JhengHei",
        "Microsoft New Tai Lue",
        "Microsoft PhagsPa",
        "Microsoft Sans Serif",
        "Microsoft Tai Le",
        "Microsoft YaHei",
        "Microsoft Yi Baiti",
        "MingLiU-ExtB",
        "Mongolian Baiti",
        "MS Gothic",
        "MV Boli",
        "Myanmar Text",
        "Nirmala UI",
        "Palatino Linotype",
        "Segoe Print",
        "Segoe Script",
        "Segoe UI",
        "Segoe UI Historic",
        "Segoe UI Emoji",
        "Segoe UI Symbol",
        "SimSun",
        "Sitka",
        "Sylfaen",
        "Symbol",
        "Tahoma",
        "Times New Roman",
        "Trebuchet MS",
        "Verdana",
        "Webdings",
        "Wingdings",
        "Yu Gothic",
        "American Typewriter",
        "Andale Mono",
        "Apple Chancery",
        "AppleGothic",
        "AppleMyungjo",
        "Baskerville",
        "Big Caslon",
        "Bodoni 72",
        "Bradley Hand",
        "Brush Script MT",
        "Chalkboard",
        "Chalkduster",
        "Charter",
        "Cochin",
        "Copperplate",
        "Courier",
        "Didot",
        "Futura",
        "Geneva",
        "Gill Sans",
        "Helvetica",
        "Helvetica Neue",
        "Herculanum",
        "Hoefler Text",
        "Lucida Grande",
        "Marker Felt",
        "Menlo",
        "Monaco",
        "Noteworthy",
        "Optima",
        "Palatino",
        "Papyrus",
        "Rockwell",
        "Savoye LET",
        "Skia",
        "Snell Roundhand",
        "Thonburi",
        "Trattatello",
        "Zapfino",
        "DejaVu Sans",
        "DejaVu Serif",
        "DejaVu Sans Mono",
        "Liberation Sans",
        "Liberation Serif",
        "Liberation Mono",
        "Noto Sans",
        "Noto Serif",
        "Noto Mono",
        "Roboto",
        "Open Sans",
        "Ubuntu",
        "Cantarell",
        "Droid Sans",
        "Source Sans Pro",
        "Century Gothic",
        "Garamond"
    ], t = "abcdefghijklmnopqrstuvwxyz0123456789", n = "72px", r = [];
    try {
        if ("undefined" == typeof document || !document.createElement) return {
            detectedFonts: []
        };
        const i = document.createElement("canvas").getContext("2d");
        if (!i) return {
            detectedFonts: []
        };
        i.font = `${n} sans-serif`;
        const o = i.measureText(t).width, a = i.measureText(t).actualBoundingBoxAscent + i.measureText(t).actualBoundingBoxDescent;
        i.font = `${n} serif`;
        const s = i.measureText(t).width, c = i.measureText(t).actualBoundingBoxAscent + i.measureText(t).actualBoundingBoxDescent;
        i.font = `${n} monospace`;
        const u = i.measureText(t).width, l = i.measureText(t).actualBoundingBoxAscent + i.measureText(t).actualBoundingBoxDescent;
        for (const d of e){
            i.font = `${n} "${d}", sans-serif`;
            const e = i.measureText(t).width, p = i.measureText(t).actualBoundingBoxAscent + i.measureText(t).actualBoundingBoxDescent;
            if (e !== o || p !== a) {
                r.push(d);
                continue;
            }
            i.font = `${n} "${d}", serif`;
            const f = i.measureText(t).width, g = i.measureText(t).actualBoundingBoxAscent + i.measureText(t).actualBoundingBoxDescent;
            if (f !== s || g !== c) {
                r.push(d);
                continue;
            }
            i.font = `${n} "${d}", monospace`;
            const h = i.measureText(t).width, E = i.measureText(t).actualBoundingBoxAscent + i.measureText(t).actualBoundingBoxDescent;
            h === u && E === l || r.push(d);
        }
        return {
            detectedFonts: Array.from(new Set(r)).sort()
        };
    } catch (e) {
        return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getFontPreferences", "Error detecting font preferences", e), {
            detectedFonts: []
        };
    }
}
function $1ec05aac0120a3f2$export$4f3264e94584e8a3() {
    return {
        maxTouchPoints: navigator.maxTouchPoints || 0,
        touchEvent: "ontouchstart" in window,
        touchStart: "ontouchstart" in window
    };
}
function $1ec05aac0120a3f2$export$471d7e4c229dedf() {
    if ("undefined" == typeof navigator) return {
        platform: "unknown",
        os: "unknown",
        version: "unknown"
    };
    const e = navigator.platform || "unknown", t = navigator.userAgent || "unknown";
    let n = "unknown", r = "unknown";
    try {
        if (/Windows NT/.test(t)) {
            n = "Windows";
            const e = t.match(/Windows NT ([\d.]+)/);
            if (e && e[1]) {
                const n = {
                    "10.0": "10/11",
                    6.3: "8.1",
                    6.2: "8",
                    6.1: "7",
                    "6.0": "Vista",
                    5.2: "Server 2003",
                    5.1: "XP",
                    "5.0": "2000"
                };
                r = "10.0" === e[1] && /(Windows 11|WOW64|Win64|x64)/.test(t) ? "11" : "10.0" === e[1] ? "10" : n[e[1]] || e[1];
            }
        } else if (/Mac OS X/.test(t)) {
            n = "macOS";
            const e = t.match(/Mac OS X ([\d_]+)/);
            e && e[1] && (r = e[1].replace(/_/g, "."));
        } else if (/Android/.test(t)) {
            n = "Android";
            const e = t.match(/Android ([\d.]+)/);
            e && e[1] && (r = e[1]);
        } else if (/iPhone|iPad|iPod|CPU(?: iPhone)? OS|MacOS/.test(t)) {
            n = "iOS";
            const e = t.match(/OS ([\d_]+)/);
            e && e[1] && (r = e[1].replace(/_/g, "."));
        } else /Linux/.test(e) || /Linux/.test(t) ? (n = "Linux", r = /Ubuntu/.test(t) ? "Ubuntu" : /Fedora/.test(t) ? "Fedora" : /Debian/.test(t) ? "Debian" : /Arch/.test(t) ? "Arch" : /Manjaro/.test(t) ? "Manjaro" : /openSUSE/.test(t) ? "openSUSE" : /Mint/.test(t) ? "Linux Mint" : "generic") : /BSD/.test(t) || /SunOS/.test(t) ? (n = "Unix-like", r = "generic") : n = e;
    } catch (e) {
        $1ec05aac0120a3f2$export$79de5099e43c732e.error("getOSInfo", "Error parsing OS info", e);
    }
    return {
        os: n,
        version: r
    };
}
async function $1ec05aac0120a3f2$export$1f3a78993ad37dfd() {
    const e = navigator.hardwareConcurrency || 4;
    if ("undefined" == typeof Worker) return Math.min(e, 12);
    const t = new Blob([
        "\n    self.onmessage = (e) => {\n      const start = performance.now();\n      let result = 0;\n      for (let i = 0; i < 30000000; i++) {\n        result += Math.sin(i) * Math.log(i + 1) / (i % 23 + 1);\n        if (i % 1e5 === 0) self.postMessage({ progress: i });\n      }\n      const duration = performance.now() - start;\n      self.postMessage({\n        duration: duration,\n        noise: performance.timeOrigin % 1 + Math.random()\n      });\n    };\n  "
    ], {
        type: "application/javascript"
    }), n = URL.createObjectURL(t), r = [];
    try {
        const t = (async ()=>{
            const t = Math.min(2 * e, 16), i = Array.from({
                length: t
            }, async ()=>{
                const e = new Worker(n);
                return r.push(e), new Promise((t)=>{
                    e.onmessage = (e)=>{
                        e.data?.duration && t(e.data.duration);
                    }, e.postMessage("start");
                });
            }), o = await Promise.all(i);
            o.sort((e, t)=>e - t);
            const a = o[Math.floor(o.length / 2)], s = a * t / (a * (t / e)) * 100;
            let c = Math.round(100 * t / Math.max(s, 10));
            return c = Math.min(Math.max(c, e - 2), e + 2), Math.min(Math.max(c, 1), 12);
        })().catch((t)=>($1ec05aac0120a3f2$export$79de5099e43c732e.warn("estimateCores", "Core estimation failed", t), e)), i = await Promise.race([
            t,
            new Promise((t)=>setTimeout(()=>t(e), 1200))
        ]);
        return navigator.userAgent.includes("Firefox") || performance.timing?.navigationStart ? Math.min(i, 8) : Math.min(i, 12);
    } catch (t) {
        return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("estimateCores", "Overall error in estimateCores", t), e;
    } finally{
        r.forEach((e)=>e.terminate()), URL.revokeObjectURL(n);
    }
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ function $1ec05aac0120a3f2$export$ab8d7a02a09de127() {
    return {
        userAgent: "Mozilla/5.0 (Test Browser)",
        platform: "Test Platform",
        languages: [
            "en-US"
        ],
        cookiesEnabled: !0,
        doNotTrack: null,
        screenResolution: [
            1920,
            1080
        ],
        colorDepth: 24,
        colorGamut: "srgb",
        hardwareConcurrency: 8,
        deviceMemory: 8,
        os: {
            os: "test",
            version: "T"
        },
        audio: null,
        localStorage: !0,
        sessionStorage: !0,
        indexedDB: !0,
        webGL: {
            vendor: "Test Vendor",
            renderer: "Test Renderer",
            imageHash: null
        },
        canvas: {
            winding: !1,
            geometry: "",
            text: ""
        },
        plugins: [],
        timezone: "America/New_York",
        touchSupport: {
            maxTouchPoints: 0,
            touchEvent: !1,
            touchStart: !1
        },
        vendor: "Test Vendor",
        vendorFlavors: [
            "test"
        ],
        mathConstants: $1ec05aac0120a3f2$export$a1de9105a12432fa(),
        fontPreferences: {
            detectedFonts: []
        },
        incognito: {
            isPrivate: !1,
            browserName: "Test Browser"
        },
        browser: {
            name: "Test Browser",
            version: "1.0"
        },
        bot: {
            isBot: !1,
            signals: [],
            confidence: .82
        },
        deviceType: {
            type: "desktop",
            confidence: .85,
            signals: [
                {
                    name: "mock",
                    value: !0,
                    weight: 1,
                    detected: !0
                }
            ],
            method: "mock"
        },
        confidenceScore: .85,
        hash: "5d41402abc4b2a76b9719d911017c592"
    };
}
async function $1ec05aac0120a3f2$var$Ce() {
    if (navigator.brave && "function" == typeof navigator.brave.isBrave) try {
        return await navigator.brave.isBrave();
    } catch  {}
    return navigator.userAgent.toLowerCase().includes("brave");
}
async function $1ec05aac0120a3f2$var$Pe() {
    return !(!navigator.userAgentData || !navigator.userAgentData.brands) && navigator.userAgentData.brands.some((e)=>e.brand.toLowerCase().includes("brave"));
}
async function $1ec05aac0120a3f2$var$Be() {
    let e = !1;
    try {
        e = await async function() {
            try {
                const e = await fetch("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", {
                    method: "GET",
                    mode: "no-cors"
                });
                if (!e) return !0;
                const t = await e.text();
                return !(!t.includes("uBlock Origin") && !t.includes("window.adsbygoogle = { loaded: true, push: function() {} };"));
            } catch (e) {
                return !0;
            }
        }();
    } catch (e) {
        $1ec05aac0120a3f2$export$79de5099e43c732e.error("detectAdBlockers", "Error detecting ad blocker", e);
    }
    return e;
}
async function $1ec05aac0120a3f2$export$a0ca86ff5b917adc() {
    const e = [
        $1ec05aac0120a3f2$var$Ce(),
        $1ec05aac0120a3f2$var$Pe()
    ], [t, n] = await Promise.all(e);
    return {
        isBrave: t || n,
        adBlocker: await $1ec05aac0120a3f2$var$Be()
    };
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ function $1ec05aac0120a3f2$var$Me() {
    if ("undefined" == typeof navigator) return {};
    try {
        const e = $1ec05aac0120a3f2$var$fe.parse(navigator.userAgent);
        return {
            name: e.browser.name,
            version: e.browser.version
        };
    } catch (e) {
        return $1ec05aac0120a3f2$export$79de5099e43c732e.warn("getBrowserInfo", "Browser detection failed", e), {};
    }
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ function $1ec05aac0120a3f2$export$568a7d21694b4b32() {
    if ("undefined" == typeof window || "undefined" == typeof navigator) return {
        type: "unknown",
        confidence: .5,
        signals: [
            {
                name: "environment",
                value: "non-browser",
                weight: 0,
                detected: !0
            }
        ],
        method: "fallback"
    };
    const e = {
        mobile: 0,
        tablet: 0,
        desktop: 0,
        tv: 0
    }, t = [], n = [];
    try {
        !function(e, t, n) {
            const r = navigator;
            if (!r.userAgentData) return;
            const i = r.userAgentData.mobile;
            "boolean" == typeof i && (n.push("clientHints"), t.push({
                name: "clientHints.mobile",
                value: i,
                weight: .4,
                detected: !0
            }), i ? e.mobile += .4 : (e.desktop += .3, e.tablet += .05));
            const o = r.userAgentData.platform;
            if ("string" == typeof o) {
                const n = o.toLowerCase();
                t.push({
                    name: "clientHints.platform",
                    value: o,
                    weight: .1,
                    detected: !0
                }), "android" === n ? (e.mobile += .05, e.tablet += .05) : "ios" === n ? (e.mobile += .05, e.tablet += .03) : [
                    "windows",
                    "macos",
                    "linux",
                    "chromeos"
                ].includes(n) && (e.desktop += .1);
            }
        }(e, t, n), function(e, t, n) {
            try {
                const r = $1ec05aac0120a3f2$var$fe.parse(navigator.userAgent), i = r.platform?.type;
                if (i) switch(n.push("bowser"), t.push({
                    name: "bowser.platformType",
                    value: i,
                    weight: .25,
                    detected: !0
                }), i){
                    case "mobile":
                        e.mobile += .25;
                        break;
                    case "tablet":
                        e.tablet += .25;
                        break;
                    case "desktop":
                        e.desktop += .25;
                        break;
                    case "tv":
                        e.tv += .25;
                }
            } catch  {
                t.push({
                    name: "bowser.platformType",
                    value: null,
                    weight: .25,
                    detected: !1
                });
            }
        }(e, t, n), function(e, t) {
            const n = window.screen?.width ?? 0, r = window.screen?.height ?? 0, i = window.devicePixelRatio ?? 1, o = Math.min(n, r), a = Math.max(n, r);
            t.push({
                name: "screen.devicePixelRatio",
                value: i,
                weight: .05,
                detected: !0
            }), i >= 2.5 ? e.mobile += .05 : i >= 1.5 && i < 2.5 ? (e.tablet += .02, e.mobile += .02) : e.desktop += .03;
            t.push({
                name: "screen.resolution",
                value: [
                    n,
                    r
                ],
                weight: .1,
                detected: !0
            }), o <= 480 ? e.mobile += .1 : o <= 820 && a <= 1400 ? (e.tablet += .08, e.mobile += .02) : a >= 3840 ? (e.tv += .04, e.desktop += .06) : e.desktop += .1;
            const s = a / (o || 1);
            t.push({
                name: "screen.aspectRatio",
                value: parseFloat(s.toFixed(2)),
                weight: .05,
                detected: !0
            }), s >= 1.9 ? e.mobile += .05 : s >= 1.2 && s < 1.5 ? e.tablet += .04 : e.desktop += .03;
        }(e, t), function(e, t) {
            const n = navigator.maxTouchPoints ?? 0;
            t.push({
                name: "touch.maxTouchPoints",
                value: n,
                weight: .05,
                detected: !0
            });
            const r = "ontouchstart" in window || !!window.TouchEvent;
            t.push({
                name: "touch.hasTouchEvent",
                value: r,
                weight: .03,
                detected: r
            });
            const i = window.matchMedia;
            if (i) {
                const n = i("(pointer: coarse)").matches, r = i("(pointer: fine)").matches, o = i("(hover: hover)").matches, a = i("(hover: none)").matches, s = i("(any-pointer: coarse)").matches, c = i("(any-pointer: fine)").matches;
                t.push({
                    name: "css.pointerCoarse",
                    value: n,
                    weight: .04,
                    detected: n
                }), t.push({
                    name: "css.pointerFine",
                    value: r,
                    weight: .04,
                    detected: r
                }), t.push({
                    name: "css.hoverHover",
                    value: o,
                    weight: .04,
                    detected: o
                }), t.push({
                    name: "css.hoverNone",
                    value: a,
                    weight: .04,
                    detected: a
                }), t.push({
                    name: "css.anyPointerCoarse",
                    value: s,
                    weight: .02,
                    detected: s
                }), t.push({
                    name: "css.anyPointerFine",
                    value: c,
                    weight: .02,
                    detected: c
                }), n && !r && a ? (e.mobile += .1, e.tablet += .05) : r && s ? e.desktop += .1 : r && !s && o && (e.desktop += .12);
            }
            0 !== n || r ? n >= 1 && n <= 5 ? (e.mobile += .03, e.tablet += .03) : n > 5 && (e.tablet += .04, e.mobile += .02) : e.desktop += .05;
        }(e, t), function(e, t) {
            const n = navigator.deviceMemory, r = navigator.hardwareConcurrency ?? 0;
            "number" == typeof n && (t.push({
                name: "hw.deviceMemory",
                value: n,
                weight: .05,
                detected: !0
            }), n <= 2 ? e.mobile += .04 : n <= 4 ? (e.mobile += .02, e.tablet += .02) : n >= 8 && (e.desktop += .04));
            r > 0 && (t.push({
                name: "hw.cores",
                value: r,
                weight: .05,
                detected: !0
            }), r <= 4 ? e.mobile += .02 : r >= 12 && (e.desktop += .04));
        }(e, t), function(e, t) {
            const n = window.innerWidth ?? 0, r = window.screen?.width ?? 0, i = r > 0 ? n / r : 1;
            t.push({
                name: "behaviour.viewportScreenRatio",
                value: parseFloat(i.toFixed(2)),
                weight: .04,
                detected: !0
            }), i >= .95 ? (e.mobile += .03, e.tablet += .02) : i < .7 && (e.desktop += .05);
            const o = screen.orientation;
            if (o) {
                const n = o.type || "";
                t.push({
                    name: "behaviour.orientationType",
                    value: n,
                    weight: .03,
                    detected: !0
                }), n.startsWith("portrait") && (e.mobile += .03, e.tablet += .02);
            }
            if (window.matchMedia) {
                const e = window.matchMedia("(prefers-color-scheme: dark)").matches;
                t.push({
                    name: "behaviour.prefersDarkScheme",
                    value: e,
                    weight: .01,
                    detected: !0
                });
            }
            if (window.matchMedia) {
                const n = window.matchMedia("(display-mode: standalone)").matches;
                t.push({
                    name: "behaviour.standaloneMode",
                    value: n,
                    weight: .02,
                    detected: n
                }), n && (e.mobile += .02);
            }
        }(e, t), function(e, t) {
            const n = navigator.userAgent.toLowerCase(), r = [
                "smart-tv",
                "smarttv",
                "googletv",
                "appletv",
                "hbbtv",
                "pov_tv",
                "netcast.tv",
                "philipstv",
                "nettv",
                "tizen",
                "webos",
                "vidaa",
                "crkey",
                "chromecast",
                "firetv",
                "fire tv",
                "roku",
                "viera",
                "bravia"
            ];
            for (const i of r)if (n.includes(i)) {
                e.tv += .15, t.push({
                    name: `ua.tvPattern:${i}`,
                    value: !0,
                    weight: .05,
                    detected: !0
                });
                break;
            }
            const i = [
                "ipad",
                "tablet",
                "kindle",
                "silk",
                "playbook",
                "nexus 7",
                "nexus 9",
                "nexus 10",
                "sm-t",
                "gt-p",
                "gt-n",
                "lenovo tab"
            ];
            for (const r of i)if (n.includes(r)) {
                e.tablet += .05, t.push({
                    name: `ua.tabletPattern:${r}`,
                    value: !0,
                    weight: .05,
                    detected: !0
                });
                break;
            }
            const o = [
                "iphone",
                "ipod",
                "android",
                "mobile",
                "blackberry",
                "windows phone",
                "opera mini",
                "opera mobi",
                "iemobile"
            ];
            for (const r of o)if (n.includes(r)) {
                "android" !== r || n.includes("mobile") ? e.mobile += .05 : e.tablet += .03, t.push({
                    name: `ua.mobilePattern:${r}`,
                    value: !0,
                    weight: .05,
                    detected: !0
                });
                break;
            }
        }(e, t), function(e, t) {
            const n = t.find((e)=>"css.pointerFine" === e.name), r = t.find((e)=>"css.anyPointerCoarse" === e.name), i = t.find((e)=>"css.hoverHover" === e.name);
            n?.detected && r?.detected && i?.detected && (e.desktop += .05, t.push({
                name: "override.hybridDevice",
                value: !0,
                weight: .05,
                detected: !0
            }));
            const o = navigator.userAgent.toLowerCase();
            "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1 && (e.tablet += .3, t.push({
                name: "override.iPadDesktopMode",
                value: !0,
                weight: .3,
                detected: !0
            }));
            o.includes("android") && !o.includes("mobile") && navigator.maxTouchPoints > 0 && (e.tablet += .05, t.push({
                name: "override.androidTablet",
                value: !0,
                weight: .05,
                detected: !0
            }));
            e.mobile = Math.max(0, e.mobile), e.tablet = Math.max(0, e.tablet), e.desktop = Math.max(0, e.desktop), e.tv = Math.max(0, e.tv);
        }(e, t);
    } catch (e) {
        $1ec05aac0120a3f2$export$79de5099e43c732e.warn("detectDeviceType", "Error during detection", e);
    }
    const { type: r, confidence: i } = function(e, t) {
        const n = Object.entries(e);
        n.sort((e, t)=>t[1] - e[1]);
        const [r, i] = n[0], [, o] = n[1];
        if (i <= 0) return {
            type: "unknown",
            confidence: .3
        };
        const a = t.filter((e)=>e.detected).reduce((e, t)=>e + t.weight, 0), s = i - o;
        let c = a > 0 ? Math.min(i / a, 1) : .5;
        s > .3 ? c = Math.min(c + .05, .98) : s < .1 && (c = Math.max(c - .1, .3));
        return c = Math.max(.1, Math.min(.98, parseFloat(c.toFixed(2)))), {
            type: r,
            confidence: c
        };
    }(e, t);
    return {
        type: r,
        confidence: i,
        signals: t,
        method: n.length > 0 ? n.join("+") : "multiSignal"
    };
}
function $1ec05aac0120a3f2$export$7a062585ef37f700() {
    if ("undefined" == typeof window || "undefined" == typeof navigator) return {
        isBot: !0,
        signals: [
            "non-browser-environment"
        ],
        confidence: .8
    };
    const e = [], t = .3, n = .15, r = .05, i = window, o = document?.documentElement, a = [
        "bot",
        "crawler",
        "selenium",
        "webdriver",
        "headless",
        "puppeteer",
        "playwright"
    ];
    for (const t of a)navigator.userAgent.toLowerCase().includes(t) && e.push(`strong:ua-${t}`);
    navigator.webdriver && e.push("strong:webdriver-flag"), o?.getAttribute && o.getAttribute("webdriver") && e.push("strong:webdriver-attr"), (i.Cypress || i.__cypress) && e.push("strong:automation-cypress"), i.__nightmare && e.push("strong:automation-nightmare"), (i._phantom || i.callPhantom) && e.push("strong:automation-phantom"), (i.__webdriver_evaluate || i.__driver_evaluate || i.__selenium_unwrapped || i.__fxdriver_unwrapped) && e.push("strong:automation-webdriver"), (i.domAutomation || i.domAutomationController) && e.push("strong:automation-dom"), window.localStorage && window.sessionStorage || e.push("medium:missing-storage"), (!navigator.plugins || navigator.plugins.length < 2) && e.push("medium:few-plugins"), navigator.languages && 0 !== navigator.languages.length || e.push("medium:missing-languages"), navigator.mimeTypes && 0 !== navigator.mimeTypes.length || e.push("medium:missing-mimetypes"), (window.screen?.width <= 300 || window.screen?.height <= 300) && e.push("weak:small-screen"), (navigator.hardwareConcurrency < 2 || navigator.hardwareConcurrency > 32) && e.push("weak:unusual-concurrency");
    let s = .5;
    return s += e.filter((e)=>e.startsWith("strong:")).length * t, s += e.filter((e)=>e.startsWith("medium:")).length * n, s += e.filter((e)=>e.startsWith("weak:")).length * r, {
        isBot: s > .7,
        signals: e,
        confidence: Math.min(.9, s)
    };
}
async function $1ec05aac0120a3f2$export$d51248ece03722d6() {
    return "undefined" == typeof window ? ($1ec05aac0120a3f2$export$79de5099e43c732e.verbose("getSystemInfo", "Not in browser environment, returning mock data"), $1ec05aac0120a3f2$export$ab8d7a02a09de127()) : $1ec05aac0120a3f2$export$79de5099e43c732e.logBlock("getSystemInfo", "System information collection", async ()=>{
        const e = $1ec05aac0120a3f2$export$7a062585ef37f700(), t = await $1ec05aac0120a3f2$export$40b2248fa055142e(), n = function(e, t) {
            let n = .7;
            if (e && (n -= .1), t.isBot ? n -= .3 * t.confidence : n += .1 * (1 - t.confidence), "undefined" != typeof navigator) {
                const e = window;
                navigator.userAgent.includes("Chrome") && !e.chrome && (n -= .1), navigator.userAgent.includes("Firefox") && !e.InstallTrigger && (n -= .1);
            }
            return Math.max(.1, Math.min(.9, n));
        }(t.isPrivate, e);
        return {
            incognito: t,
            adBlocker: await $1ec05aac0120a3f2$export$a0ca86ff5b917adc(),
            browser: $1ec05aac0120a3f2$var$Me(),
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            languages: Array.from(navigator.languages),
            cookiesEnabled: navigator.cookieEnabled,
            doNotTrack: navigator.doNotTrack,
            screenResolution: [
                window.screen.width,
                window.screen.height
            ],
            colorDepth: window.screen.colorDepth,
            colorGamut: $1ec05aac0120a3f2$export$e66e9777a25f7214(),
            touchSupport: $1ec05aac0120a3f2$export$4f3264e94584e8a3(),
            hardwareConcurrency: await $1ec05aac0120a3f2$export$1f3a78993ad37dfd(),
            deviceMemory: navigator.deviceMemory,
            os: $1ec05aac0120a3f2$export$471d7e4c229dedf(),
            audio: await $1ec05aac0120a3f2$export$ce9340c25c605fa0(),
            localStorage: $1ec05aac0120a3f2$export$6515f7b9b46b3e7a(),
            sessionStorage: $1ec05aac0120a3f2$export$aa54e0afc8dac45d(),
            indexedDB: $1ec05aac0120a3f2$export$775d9a05b79cc7d4(),
            webGL: await $1ec05aac0120a3f2$export$26314aceb7e23c5c(),
            canvas: $1ec05aac0120a3f2$export$ae1f21143e050ca0(),
            plugins: $1ec05aac0120a3f2$export$53ed4462388b7e3c(),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            vendor: navigator.vendor,
            vendorFlavors: $1ec05aac0120a3f2$export$bceda55f827e9ec1(),
            mathConstants: $1ec05aac0120a3f2$export$a1de9105a12432fa(),
            fontPreferences: $1ec05aac0120a3f2$export$8edff794b322b33f(),
            bot: {
                isBot: e.isBot,
                signals: e.signals,
                confidence: e.confidence
            },
            deviceType: $1ec05aac0120a3f2$export$568a7d21694b4b32(),
            confidenceScore: n
        };
    });
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ function $1ec05aac0120a3f2$export$d67c3a3f1da56e2f(e, t) {
    const n = {
        US: [
            "en",
            "es"
        ],
        GB: [
            "en"
        ],
        FR: [
            "fr"
        ],
        DE: [
            "de"
        ],
        CN: [
            "zh"
        ],
        JP: [
            "ja"
        ],
        RU: [
            "ru"
        ],
        IN: [
            "hi",
            "en"
        ]
    }, r = e.split("-")[0].toLowerCase(), i = t.toUpperCase();
    return n[i] ? n[i].includes(r) ? .15 : -0.1 : 0;
}
function $1ec05aac0120a3f2$export$1cdc1ae1ff32569d(e) {
    return [
        "AS14061",
        "AS16276",
        "AS16509",
        "AS14618",
        "AS3356",
        "AS9009",
        "AS24940",
        "AS48666"
    ].includes(e);
}
function $1ec05aac0120a3f2$export$be0930778259d8a3(e, t) {
    const n = e.toLowerCase(), r = t.toLowerCase();
    if ((n.includes("mobile") || n.includes("android") || n.includes("iphone")) !== (r.includes("arm") || r.includes("iphone") || r.includes("android"))) return .2;
    return [
        {
            ua: "windows",
            platform: "win"
        },
        {
            ua: "mac",
            platform: "mac"
        },
        {
            ua: "linux",
            platform: "linux"
        }
    ].some((e)=>n.includes(e.ua) && !r.includes(e.platform)) ? .15 : 0;
}
function $1ec05aac0120a3f2$export$e6178ce1dec90fc(e) {
    let t = 0;
    if (e.screenResolution && e.viewportSize) {
        const [n, r] = e.screenResolution, [i, o] = e.viewportSize;
        (i > n || o > r) && t++;
    }
    e.deviceMemory && e.hardwareConcurrency && (e.deviceMemory < 2 && e.hardwareConcurrency > 4 && t++, e.deviceMemory > 8 && e.hardwareConcurrency < 4 && t++);
    const n = Math.max(-0.3, Math.min(.3, .1 * -t));
    return 0 === n ? 0 : n;
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ "undefined" != typeof window && (window.detectIncognito = $1ec05aac0120a3f2$export$40b2248fa055142e);
class $1ec05aac0120a3f2$export$8d8dc7d5f743331b {
    static show(e, t = 3e3) {
        if ("undefined" == typeof document || !document.body || !document.createElement) return void $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Toast", "Toast notification cannot be displayed: DOM not available");
        this.stylesInjected || (this.injectStyles(), this.stylesInjected = !0);
        const n = document.createElement("div");
        n.className = "toast", n.textContent = e, document.body.appendChild(n), requestAnimationFrame(()=>{
            n.classList.add("show");
        }), setTimeout(()=>{
            n.classList.remove("show"), n.addEventListener("transitionend", ()=>n.remove(), {
                once: !0
            });
        }, t);
    }
    static injectStyles() {
        if ("undefined" == typeof document || !document.head || !document.createElement) return void $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Toast", "Toast styles cannot be injected: DOM not available");
        const e = document.createElement("style");
        e.textContent = "\n      .toast {\n        position: fixed;\n        left: 50%;\n        bottom: 32px;\n        transform: translateX(-50%) translateY(20px);\n        max-width: 80vw;\n        background: rgba(255, 255, 255, 0.1);\n        color: #fff;\n        padding: 12px 24px;\n        border-radius: 10px;\n        font-size: 15px;\n        text-align: center;\n        z-index: 9999;\n        opacity: 0;\n        pointer-events: none;\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n        backdrop-filter: blur(10px);\n        -webkit-backdrop-filter: blur(10px);\n        border: 1px solid rgba(255, 255, 255, 0.15);\n        transition: opacity 0.4s ease, transform 0.4s ease;\n      }\n\n      .toast.show {\n        opacity: 1;\n        transform: translateX(-50%) translateY(0);\n      }\n\n      @media (prefers-color-scheme: dark) {\n        .toast {\n          background: rgba(30, 30, 30, 0.25);\n          border: 1px solid rgba(255, 255, 255, 0.1);\n        }\n      }\n    ", document.head.appendChild(e);
    }
}
$1ec05aac0120a3f2$export$8d8dc7d5f743331b.stylesInjected = !1;
var $1ec05aac0120a3f2$var$Xe = "object" == typeof globalThis ? globalThis : "object" == typeof self ? self : "object" == typeof window ? window : "object" == typeof $parcel$global ? $parcel$global : {}, $1ec05aac0120a3f2$var$He = "1.9.0", $1ec05aac0120a3f2$var$qe = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
var $1ec05aac0120a3f2$var$je = function(e) {
    var t = new Set([
        e
    ]), n = new Set, r = e.match($1ec05aac0120a3f2$var$qe);
    if (!r) return function() {
        return !1;
    };
    var i = +r[1], o = +r[2], a = +r[3];
    if (null != r[4]) return function(t) {
        return t === e;
    };
    function s(e) {
        return n.add(e), !1;
    }
    function c(e) {
        return t.add(e), !0;
    }
    return function(e) {
        if (t.has(e)) return !0;
        if (n.has(e)) return !1;
        var r = e.match($1ec05aac0120a3f2$var$qe);
        if (!r) return s(e);
        var u = +r[1], l = +r[2], d = +r[3];
        return null != r[4] || i !== u ? s(e) : 0 === i ? o === l && a <= d ? c(e) : s(e) : o <= l ? c(e) : s(e);
    };
}($1ec05aac0120a3f2$var$He), $1ec05aac0120a3f2$var$Ve = $1ec05aac0120a3f2$var$He.split(".")[0], $1ec05aac0120a3f2$var$Je = Symbol.for("opentelemetry.js.api." + $1ec05aac0120a3f2$var$Ve), $1ec05aac0120a3f2$var$Ke = $1ec05aac0120a3f2$var$Xe;
function $1ec05aac0120a3f2$var$Ye(e, t, n, r) {
    var i;
    void 0 === r && (r = !1);
    var o = $1ec05aac0120a3f2$var$Ke[$1ec05aac0120a3f2$var$Je] = null !== (i = $1ec05aac0120a3f2$var$Ke[$1ec05aac0120a3f2$var$Je]) && void 0 !== i ? i : {
        version: $1ec05aac0120a3f2$var$He
    };
    if (!r && o[e]) {
        var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
        return n.error(a.stack || a.message), !1;
    }
    if (o.version !== $1ec05aac0120a3f2$var$He) {
        a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + $1ec05aac0120a3f2$var$He);
        return n.error(a.stack || a.message), !1;
    }
    return o[e] = t, n.debug("@opentelemetry/api: Registered a global for " + e + " v" + $1ec05aac0120a3f2$var$He + "."), !0;
}
function $1ec05aac0120a3f2$var$We(e) {
    var t, n, r = null === (t = $1ec05aac0120a3f2$var$Ke[$1ec05aac0120a3f2$var$Je]) || void 0 === t ? void 0 : t.version;
    if (r && $1ec05aac0120a3f2$var$je(r)) return null === (n = $1ec05aac0120a3f2$var$Ke[$1ec05aac0120a3f2$var$Je]) || void 0 === n ? void 0 : n[e];
}
function $1ec05aac0120a3f2$var$Ze(e, t) {
    t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + $1ec05aac0120a3f2$var$He + ".");
    var n = $1ec05aac0120a3f2$var$Ke[$1ec05aac0120a3f2$var$Je];
    n && delete n[e];
}
var $1ec05aac0120a3f2$var$$e, $1ec05aac0120a3f2$var$et = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$tt = function(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
}, $1ec05aac0120a3f2$var$nt = function() {
    function e(e) {
        this._namespace = e.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
        for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
        return $1ec05aac0120a3f2$var$rt("debug", this._namespace, e);
    }, e.prototype.error = function() {
        for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
        return $1ec05aac0120a3f2$var$rt("error", this._namespace, e);
    }, e.prototype.info = function() {
        for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
        return $1ec05aac0120a3f2$var$rt("info", this._namespace, e);
    }, e.prototype.warn = function() {
        for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
        return $1ec05aac0120a3f2$var$rt("warn", this._namespace, e);
    }, e.prototype.verbose = function() {
        for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
        return $1ec05aac0120a3f2$var$rt("verbose", this._namespace, e);
    }, e;
}();
function $1ec05aac0120a3f2$var$rt(e, t, n) {
    var r = $1ec05aac0120a3f2$var$We("diag");
    if (r) return n.unshift(t), r[e].apply(r, $1ec05aac0120a3f2$var$tt([], $1ec05aac0120a3f2$var$et(n), !1));
}
!function(e) {
    e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
}($1ec05aac0120a3f2$var$$e || ($1ec05aac0120a3f2$var$$e = {}));
var $1ec05aac0120a3f2$var$it = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$ot = function(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
}, $1ec05aac0120a3f2$var$at = function() {
    function e() {
        function e(e) {
            return function() {
                for(var t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
                var r = $1ec05aac0120a3f2$var$We("diag");
                if (r) return r[e].apply(r, $1ec05aac0120a3f2$var$ot([], $1ec05aac0120a3f2$var$it(t), !1));
            };
        }
        var t = this;
        t.setLogger = function(e, n) {
            var r, i, o;
            if (void 0 === n && (n = {
                logLevel: $1ec05aac0120a3f2$var$$e.INFO
            }), e === t) {
                var a = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
                return t.error(null !== (r = a.stack) && void 0 !== r ? r : a.message), !1;
            }
            "number" == typeof n && (n = {
                logLevel: n
            });
            var s = $1ec05aac0120a3f2$var$We("diag"), c = function(e, t) {
                function n(n, r) {
                    var i = t[n];
                    return "function" == typeof i && e >= r ? i.bind(t) : function() {};
                }
                return e < $1ec05aac0120a3f2$var$$e.NONE ? e = $1ec05aac0120a3f2$var$$e.NONE : e > $1ec05aac0120a3f2$var$$e.ALL && (e = $1ec05aac0120a3f2$var$$e.ALL), t = t || {}, {
                    error: n("error", $1ec05aac0120a3f2$var$$e.ERROR),
                    warn: n("warn", $1ec05aac0120a3f2$var$$e.WARN),
                    info: n("info", $1ec05aac0120a3f2$var$$e.INFO),
                    debug: n("debug", $1ec05aac0120a3f2$var$$e.DEBUG),
                    verbose: n("verbose", $1ec05aac0120a3f2$var$$e.VERBOSE)
                };
            }(null !== (i = n.logLevel) && void 0 !== i ? i : $1ec05aac0120a3f2$var$$e.INFO, e);
            if (s && !n.suppressOverrideMessage) {
                var u = null !== (o = (new Error).stack) && void 0 !== o ? o : "<failed to generate stacktrace>";
                s.warn("Current logger will be overwritten from " + u), c.warn("Current logger will overwrite one already registered from " + u);
            }
            return $1ec05aac0120a3f2$var$Ye("diag", c, t, !0);
        }, t.disable = function() {
            $1ec05aac0120a3f2$var$Ze("diag", t);
        }, t.createComponentLogger = function(e) {
            return new $1ec05aac0120a3f2$var$nt(e);
        }, t.verbose = e("verbose"), t.debug = e("debug"), t.info = e("info"), t.warn = e("warn"), t.error = e("error");
    }
    return e.instance = function() {
        return this._instance || (this._instance = new e), this._instance;
    }, e;
}(), $1ec05aac0120a3f2$var$st = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$ct = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $1ec05aac0120a3f2$var$ut = function() {
    function e(e) {
        this._entries = e ? new Map(e) : new Map;
    }
    return e.prototype.getEntry = function(e) {
        var t = this._entries.get(e);
        if (t) return Object.assign({}, t);
    }, e.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(e) {
            var t = $1ec05aac0120a3f2$var$st(e, 2);
            return [
                t[0],
                t[1]
            ];
        });
    }, e.prototype.setEntry = function(t, n) {
        var r = new e(this._entries);
        return r._entries.set(t, n), r;
    }, e.prototype.removeEntry = function(t) {
        var n = new e(this._entries);
        return n._entries.delete(t), n;
    }, e.prototype.removeEntries = function() {
        for(var t, n, r = [], i = 0; i < arguments.length; i++)r[i] = arguments[i];
        var o = new e(this._entries);
        try {
            for(var a = $1ec05aac0120a3f2$var$ct(r), s = a.next(); !s.done; s = a.next()){
                var c = s.value;
                o._entries.delete(c);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                s && !s.done && (n = a.return) && n.call(a);
            } finally{
                if (t) throw t.error;
            }
        }
        return o;
    }, e.prototype.clear = function() {
        return new e;
    }, e;
}(), $1ec05aac0120a3f2$var$lt = Symbol("BaggageEntryMetadata"), $1ec05aac0120a3f2$var$dt = $1ec05aac0120a3f2$var$at.instance();
function $1ec05aac0120a3f2$var$pt(e) {
    return void 0 === e && (e = {}), new $1ec05aac0120a3f2$var$ut(new Map(Object.entries(e)));
}
function $1ec05aac0120a3f2$var$ft(e) {
    return "string" != typeof e && ($1ec05aac0120a3f2$var$dt.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
        __TYPE__: $1ec05aac0120a3f2$var$lt,
        toString: function() {
            return e;
        }
    };
}
function $1ec05aac0120a3f2$var$gt(e) {
    return Symbol.for(e);
}
var $1ec05aac0120a3f2$var$ht, $1ec05aac0120a3f2$var$Et, $1ec05aac0120a3f2$var$At = function e(t) {
    var n = this;
    n._currentContext = t ? new Map(t) : new Map, n.getValue = function(_e) {
        return n._currentContext.get(_e);
    }, n.setValue = function(t, r) {
        var i = new e(n._currentContext);
        return i._currentContext.set(t, r), i;
    }, n.deleteValue = function(t) {
        var r = new e(n._currentContext);
        return r._currentContext.delete(t), r;
    };
}, $1ec05aac0120a3f2$var$_t = new $1ec05aac0120a3f2$var$At, $1ec05aac0120a3f2$var$mt = ($1ec05aac0120a3f2$var$ht = function(e, t) {
    return $1ec05aac0120a3f2$var$ht = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(e, t) {
        e.__proto__ = t;
    } || function(e, t) {
        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }, $1ec05aac0120a3f2$var$ht(e, t);
}, function(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    function n() {
        this.constructor = e;
    }
    $1ec05aac0120a3f2$var$ht(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
}), $1ec05aac0120a3f2$var$Tt = function() {
    function e() {}
    return e.prototype.createGauge = function(e, t) {
        return $1ec05aac0120a3f2$var$Bt;
    }, e.prototype.createHistogram = function(e, t) {
        return $1ec05aac0120a3f2$var$Nt;
    }, e.prototype.createCounter = function(e, t) {
        return $1ec05aac0120a3f2$var$Pt;
    }, e.prototype.createUpDownCounter = function(e, t) {
        return $1ec05aac0120a3f2$var$Mt;
    }, e.prototype.createObservableGauge = function(e, t) {
        return $1ec05aac0120a3f2$var$Dt;
    }, e.prototype.createObservableCounter = function(e, t) {
        return $1ec05aac0120a3f2$var$xt;
    }, e.prototype.createObservableUpDownCounter = function(e, t) {
        return $1ec05aac0120a3f2$var$Ft;
    }, e.prototype.addBatchObservableCallback = function(e, t) {}, e.prototype.removeBatchObservableCallback = function(e) {}, e;
}(), $1ec05aac0120a3f2$var$yt = function() {}, $1ec05aac0120a3f2$var$vt = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $1ec05aac0120a3f2$var$mt(t, e), t.prototype.add = function(e, t) {}, t;
}($1ec05aac0120a3f2$var$yt), $1ec05aac0120a3f2$var$bt = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $1ec05aac0120a3f2$var$mt(t, e), t.prototype.add = function(e, t) {}, t;
}($1ec05aac0120a3f2$var$yt), $1ec05aac0120a3f2$var$It = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $1ec05aac0120a3f2$var$mt(t, e), t.prototype.record = function(e, t) {}, t;
}($1ec05aac0120a3f2$var$yt), $1ec05aac0120a3f2$var$St = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $1ec05aac0120a3f2$var$mt(t, e), t.prototype.record = function(e, t) {}, t;
}($1ec05aac0120a3f2$var$yt), $1ec05aac0120a3f2$var$Ot = function() {
    function e() {}
    return e.prototype.addCallback = function(e) {}, e.prototype.removeCallback = function(e) {}, e;
}(), $1ec05aac0120a3f2$var$wt = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $1ec05aac0120a3f2$var$mt(t, e), t;
}($1ec05aac0120a3f2$var$Ot), $1ec05aac0120a3f2$var$Rt = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $1ec05aac0120a3f2$var$mt(t, e), t;
}($1ec05aac0120a3f2$var$Ot), $1ec05aac0120a3f2$var$Lt = function(e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return $1ec05aac0120a3f2$var$mt(t, e), t;
}($1ec05aac0120a3f2$var$Ot), $1ec05aac0120a3f2$var$Ct = new $1ec05aac0120a3f2$var$Tt, $1ec05aac0120a3f2$var$Pt = new $1ec05aac0120a3f2$var$vt, $1ec05aac0120a3f2$var$Bt = new $1ec05aac0120a3f2$var$It, $1ec05aac0120a3f2$var$Nt = new $1ec05aac0120a3f2$var$St, $1ec05aac0120a3f2$var$Mt = new $1ec05aac0120a3f2$var$bt, $1ec05aac0120a3f2$var$xt = new $1ec05aac0120a3f2$var$wt, $1ec05aac0120a3f2$var$Dt = new $1ec05aac0120a3f2$var$Rt, $1ec05aac0120a3f2$var$Ft = new $1ec05aac0120a3f2$var$Lt, $1ec05aac0120a3f2$var$Qt = {
    get: function(e, t) {
        if (null != e) return e[t];
    },
    keys: function(e) {
        return null == e ? [] : Object.keys(e);
    }
}, $1ec05aac0120a3f2$var$Ut = {
    set: function(e, t, n) {
        null != e && (e[t] = n);
    }
}, $1ec05aac0120a3f2$var$kt = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$Gt = function(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
}, $1ec05aac0120a3f2$var$zt = function() {
    function e() {}
    return e.prototype.active = function() {
        return $1ec05aac0120a3f2$var$_t;
    }, e.prototype.with = function(e, t, n) {
        for(var r = [], i = 3; i < arguments.length; i++)r[i - 3] = arguments[i];
        return t.call.apply(t, $1ec05aac0120a3f2$var$Gt([
            n
        ], $1ec05aac0120a3f2$var$kt(r), !1));
    }, e.prototype.bind = function(e, t) {
        return t;
    }, e.prototype.enable = function() {
        return this;
    }, e.prototype.disable = function() {
        return this;
    }, e;
}(), $1ec05aac0120a3f2$var$Xt = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$Ht = function(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
}, $1ec05aac0120a3f2$var$qt = "context", $1ec05aac0120a3f2$var$jt = new $1ec05aac0120a3f2$var$zt, $1ec05aac0120a3f2$var$Vt = function() {
    function e() {}
    return e.getInstance = function() {
        return this._instance || (this._instance = new e), this._instance;
    }, e.prototype.setGlobalContextManager = function(e) {
        return $1ec05aac0120a3f2$var$Ye($1ec05aac0120a3f2$var$qt, e, $1ec05aac0120a3f2$var$at.instance());
    }, e.prototype.active = function() {
        return this._getContextManager().active();
    }, e.prototype.with = function(e, t, n) {
        for(var r, i = [], o = 3; o < arguments.length; o++)i[o - 3] = arguments[o];
        return (r = this._getContextManager()).with.apply(r, $1ec05aac0120a3f2$var$Ht([
            e,
            t,
            n
        ], $1ec05aac0120a3f2$var$Xt(i), !1));
    }, e.prototype.bind = function(e, t) {
        return this._getContextManager().bind(e, t);
    }, e.prototype._getContextManager = function() {
        return $1ec05aac0120a3f2$var$We($1ec05aac0120a3f2$var$qt) || $1ec05aac0120a3f2$var$jt;
    }, e.prototype.disable = function() {
        this._getContextManager().disable(), $1ec05aac0120a3f2$var$Ze($1ec05aac0120a3f2$var$qt, $1ec05aac0120a3f2$var$at.instance());
    }, e;
}();
!function(e) {
    e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
}($1ec05aac0120a3f2$var$Et || ($1ec05aac0120a3f2$var$Et = {}));
var $1ec05aac0120a3f2$var$Jt = "0000000000000000", $1ec05aac0120a3f2$var$Kt = "00000000000000000000000000000000", $1ec05aac0120a3f2$var$Yt = {
    traceId: $1ec05aac0120a3f2$var$Kt,
    spanId: $1ec05aac0120a3f2$var$Jt,
    traceFlags: $1ec05aac0120a3f2$var$Et.NONE
}, $1ec05aac0120a3f2$var$Wt = function() {
    function e(e) {
        void 0 === e && (e = $1ec05aac0120a3f2$var$Yt), this._spanContext = e;
    }
    return e.prototype.spanContext = function() {
        return this._spanContext;
    }, e.prototype.setAttribute = function(e, t) {
        return this;
    }, e.prototype.setAttributes = function(e) {
        return this;
    }, e.prototype.addEvent = function(e, t) {
        return this;
    }, e.prototype.addLink = function(e) {
        return this;
    }, e.prototype.addLinks = function(e) {
        return this;
    }, e.prototype.setStatus = function(e) {
        return this;
    }, e.prototype.updateName = function(e) {
        return this;
    }, e.prototype.end = function(e) {}, e.prototype.isRecording = function() {
        return !1;
    }, e.prototype.recordException = function(e, t) {}, e;
}(), $1ec05aac0120a3f2$var$Zt = $1ec05aac0120a3f2$var$gt("OpenTelemetry Context Key SPAN");
function $1ec05aac0120a3f2$var$$t(e) {
    return e.getValue($1ec05aac0120a3f2$var$Zt) || void 0;
}
function $1ec05aac0120a3f2$var$en() {
    return $1ec05aac0120a3f2$var$$t($1ec05aac0120a3f2$var$Vt.getInstance().active());
}
function $1ec05aac0120a3f2$var$tn(e, t) {
    return e.setValue($1ec05aac0120a3f2$var$Zt, t);
}
function $1ec05aac0120a3f2$var$nn(e) {
    return e.deleteValue($1ec05aac0120a3f2$var$Zt);
}
function $1ec05aac0120a3f2$var$rn(e, t) {
    return $1ec05aac0120a3f2$var$tn(e, new $1ec05aac0120a3f2$var$Wt(t));
}
function $1ec05aac0120a3f2$var$on(e) {
    var t;
    return null === (t = $1ec05aac0120a3f2$var$$t(e)) || void 0 === t ? void 0 : t.spanContext();
}
var $1ec05aac0120a3f2$var$an = /^([0-9a-f]{32})$/i, $1ec05aac0120a3f2$var$sn = /^[0-9a-f]{16}$/i;
function $1ec05aac0120a3f2$var$cn(e) {
    return $1ec05aac0120a3f2$var$an.test(e) && e !== $1ec05aac0120a3f2$var$Kt;
}
function $1ec05aac0120a3f2$var$un(e) {
    var t;
    return $1ec05aac0120a3f2$var$cn(e.traceId) && (t = e.spanId, $1ec05aac0120a3f2$var$sn.test(t) && t !== $1ec05aac0120a3f2$var$Jt);
}
function $1ec05aac0120a3f2$var$ln(e) {
    return new $1ec05aac0120a3f2$var$Wt(e);
}
var $1ec05aac0120a3f2$var$dn = $1ec05aac0120a3f2$var$Vt.getInstance(), $1ec05aac0120a3f2$var$pn = function() {
    function e() {}
    return e.prototype.startSpan = function(e, t, n) {
        if (void 0 === n && (n = $1ec05aac0120a3f2$var$dn.active()), Boolean(null == t ? void 0 : t.root)) return new $1ec05aac0120a3f2$var$Wt;
        var r, i = n && $1ec05aac0120a3f2$var$on(n);
        return "object" == typeof (r = i) && "string" == typeof r.spanId && "string" == typeof r.traceId && "number" == typeof r.traceFlags && $1ec05aac0120a3f2$var$un(i) ? new $1ec05aac0120a3f2$var$Wt(i) : new $1ec05aac0120a3f2$var$Wt;
    }, e.prototype.startActiveSpan = function(e, t, n, r) {
        var i, o, a;
        if (!(arguments.length < 2)) {
            2 === arguments.length ? a = t : 3 === arguments.length ? (i = t, a = n) : (i = t, o = n, a = r);
            var s = null != o ? o : $1ec05aac0120a3f2$var$dn.active(), c = this.startSpan(e, i, s), u = $1ec05aac0120a3f2$var$tn(s, c);
            return $1ec05aac0120a3f2$var$dn.with(u, a, void 0, c);
        }
    }, e;
}();
var $1ec05aac0120a3f2$var$fn, $1ec05aac0120a3f2$var$gn, $1ec05aac0120a3f2$var$hn, $1ec05aac0120a3f2$var$En = new $1ec05aac0120a3f2$var$pn, $1ec05aac0120a3f2$var$An = function() {
    function e(e, t, n, r) {
        this._provider = e, this.name = t, this.version = n, this.options = r;
    }
    return e.prototype.startSpan = function(e, t, n) {
        return this._getTracer().startSpan(e, t, n);
    }, e.prototype.startActiveSpan = function(e, t, n, r) {
        var i = this._getTracer();
        return Reflect.apply(i.startActiveSpan, i, arguments);
    }, e.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var e = this._provider.getDelegateTracer(this.name, this.version, this.options);
        return e ? (this._delegate = e, this._delegate) : $1ec05aac0120a3f2$var$En;
    }, e;
}(), $1ec05aac0120a3f2$var$_n = new (function() {
    function e() {}
    return e.prototype.getTracer = function(e, t, n) {
        return new $1ec05aac0120a3f2$var$pn;
    }, e;
}()), $1ec05aac0120a3f2$var$mn = function() {
    function e() {}
    return e.prototype.getTracer = function(e, t, n) {
        var r;
        return null !== (r = this.getDelegateTracer(e, t, n)) && void 0 !== r ? r : new $1ec05aac0120a3f2$var$An(this, e, t, n);
    }, e.prototype.getDelegate = function() {
        var e;
        return null !== (e = this._delegate) && void 0 !== e ? e : $1ec05aac0120a3f2$var$_n;
    }, e.prototype.setDelegate = function(e) {
        this._delegate = e;
    }, e.prototype.getDelegateTracer = function(e, t, n) {
        var r;
        return null === (r = this._delegate) || void 0 === r ? void 0 : r.getTracer(e, t, n);
    }, e;
}();
!function(e) {
    e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
}($1ec05aac0120a3f2$var$fn || ($1ec05aac0120a3f2$var$fn = {})), function(e) {
    e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
}($1ec05aac0120a3f2$var$gn || ($1ec05aac0120a3f2$var$gn = {})), function(e) {
    e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
}($1ec05aac0120a3f2$var$hn || ($1ec05aac0120a3f2$var$hn = {}));
var $1ec05aac0120a3f2$var$Tn = $1ec05aac0120a3f2$var$Vt.getInstance(), $1ec05aac0120a3f2$var$yn = $1ec05aac0120a3f2$var$at.instance(), $1ec05aac0120a3f2$var$vn = new (function() {
    function e() {}
    return e.prototype.getMeter = function(e, t, n) {
        return $1ec05aac0120a3f2$var$Ct;
    }, e;
}()), $1ec05aac0120a3f2$var$bn = "metrics", $1ec05aac0120a3f2$var$In = (function() {
    function e() {}
    return e.getInstance = function() {
        return this._instance || (this._instance = new e), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(e) {
        return $1ec05aac0120a3f2$var$Ye($1ec05aac0120a3f2$var$bn, e, $1ec05aac0120a3f2$var$at.instance());
    }, e.prototype.getMeterProvider = function() {
        return $1ec05aac0120a3f2$var$We($1ec05aac0120a3f2$var$bn) || $1ec05aac0120a3f2$var$vn;
    }, e.prototype.getMeter = function(e, t, n) {
        return this.getMeterProvider().getMeter(e, t, n);
    }, e.prototype.disable = function() {
        $1ec05aac0120a3f2$var$Ze($1ec05aac0120a3f2$var$bn, $1ec05aac0120a3f2$var$at.instance());
    }, e;
})().getInstance(), $1ec05aac0120a3f2$var$Sn = function() {
    function e() {}
    return e.prototype.inject = function(e, t) {}, e.prototype.extract = function(e, t) {
        return e;
    }, e.prototype.fields = function() {
        return [];
    }, e;
}(), $1ec05aac0120a3f2$var$On = $1ec05aac0120a3f2$var$gt("OpenTelemetry Baggage Key");
function $1ec05aac0120a3f2$var$wn(e) {
    return e.getValue($1ec05aac0120a3f2$var$On) || void 0;
}
function $1ec05aac0120a3f2$var$Rn() {
    return $1ec05aac0120a3f2$var$wn($1ec05aac0120a3f2$var$Vt.getInstance().active());
}
function $1ec05aac0120a3f2$var$Ln(e, t) {
    return e.setValue($1ec05aac0120a3f2$var$On, t);
}
function $1ec05aac0120a3f2$var$Cn(e) {
    return e.deleteValue($1ec05aac0120a3f2$var$On);
}
var $1ec05aac0120a3f2$var$Pn = "propagation", $1ec05aac0120a3f2$var$Bn = new $1ec05aac0120a3f2$var$Sn, $1ec05aac0120a3f2$var$Nn = function() {
    function e() {
        this.createBaggage = $1ec05aac0120a3f2$var$pt, this.getBaggage = $1ec05aac0120a3f2$var$wn, this.getActiveBaggage = $1ec05aac0120a3f2$var$Rn, this.setBaggage = $1ec05aac0120a3f2$var$Ln, this.deleteBaggage = $1ec05aac0120a3f2$var$Cn;
    }
    return e.getInstance = function() {
        return this._instance || (this._instance = new e), this._instance;
    }, e.prototype.setGlobalPropagator = function(e) {
        return $1ec05aac0120a3f2$var$Ye($1ec05aac0120a3f2$var$Pn, e, $1ec05aac0120a3f2$var$at.instance());
    }, e.prototype.inject = function(e, t, n) {
        return void 0 === n && (n = $1ec05aac0120a3f2$var$Ut), this._getGlobalPropagator().inject(e, t, n);
    }, e.prototype.extract = function(e, t, n) {
        return void 0 === n && (n = $1ec05aac0120a3f2$var$Qt), this._getGlobalPropagator().extract(e, t, n);
    }, e.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
        $1ec05aac0120a3f2$var$Ze($1ec05aac0120a3f2$var$Pn, $1ec05aac0120a3f2$var$at.instance());
    }, e.prototype._getGlobalPropagator = function() {
        return $1ec05aac0120a3f2$var$We($1ec05aac0120a3f2$var$Pn) || $1ec05aac0120a3f2$var$Bn;
    }, e;
}(), $1ec05aac0120a3f2$var$Mn = $1ec05aac0120a3f2$var$Nn.getInstance(), $1ec05aac0120a3f2$var$xn = "trace", $1ec05aac0120a3f2$var$Dn = (function() {
    function e() {
        this._proxyTracerProvider = new $1ec05aac0120a3f2$var$mn, this.wrapSpanContext = $1ec05aac0120a3f2$var$ln, this.isSpanContextValid = $1ec05aac0120a3f2$var$un, this.deleteSpan = $1ec05aac0120a3f2$var$nn, this.getSpan = $1ec05aac0120a3f2$var$$t, this.getActiveSpan = $1ec05aac0120a3f2$var$en, this.getSpanContext = $1ec05aac0120a3f2$var$on, this.setSpan = $1ec05aac0120a3f2$var$tn, this.setSpanContext = $1ec05aac0120a3f2$var$rn;
    }
    return e.getInstance = function() {
        return this._instance || (this._instance = new e), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(e) {
        var t = $1ec05aac0120a3f2$var$Ye($1ec05aac0120a3f2$var$xn, this._proxyTracerProvider, $1ec05aac0120a3f2$var$at.instance());
        return t && this._proxyTracerProvider.setDelegate(e), t;
    }, e.prototype.getTracerProvider = function() {
        return $1ec05aac0120a3f2$var$We($1ec05aac0120a3f2$var$xn) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(e, t) {
        return this.getTracerProvider().getTracer(e, t);
    }, e.prototype.disable = function() {
        $1ec05aac0120a3f2$var$Ze($1ec05aac0120a3f2$var$xn, $1ec05aac0120a3f2$var$at.instance()), this._proxyTracerProvider = new $1ec05aac0120a3f2$var$mn;
    }, e;
})().getInstance();
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * Telemetry module for fingerprint-oss
 * Provides minimal OpenTelemetry integration for error tracking and usage analytics
 */ const $1ec05aac0120a3f2$var$Fn = {
    enabled: !1,
    serviceName: "fingerprint-oss",
    serviceVersion: "0.9.3",
    sampleRate: .1,
    debug: !1,
    endpoint: "https://otl.fingerprint.gossorg.in/v1/traces"
};
const $1ec05aac0120a3f2$var$Qn = new class {
    constructor(){
        this.tracer = null, this.meter = null, this.initialized = !1, this.counters = new Map, this.histograms = new Map, this.config = {
            ...$1ec05aac0120a3f2$var$Fn
        };
    }
    initialize(e = {}) {
        if (this.config = {
            ...$1ec05aac0120a3f2$var$Fn,
            ...e
        }, this.config.enabled) try {
            if ("undefined" == typeof window) return;
            try {
                Promise.resolve().then(function() {
                    return $1ec05aac0120a3f2$var$Pi;
                }).then(async (e)=>{
                    const t = new e.WebTracerProvider;
                    if (this.config.endpoint) try {
                        const [{ OTLPTraceExporter: e }, n] = await Promise.all([
                            Promise.resolve().then(function() {
                                return $1ec05aac0120a3f2$var$ta;
                            }),
                            Promise.resolve().then(function() {
                                return $1ec05aac0120a3f2$var$Tc;
                            })
                        ]), r = new e({
                            url: this.config.endpoint
                        }), i = new n.BatchSpanProcessor(r);
                        t.addSpanProcessor(i);
                    } catch (e) {
                        this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "OTLP exporter setup skipped", e);
                    }
                    t.register(), this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.debug("Telemetry", "WebTracerProvider registered");
                }).catch(()=>{});
            } catch (e) {
                this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Provider registration skipped", e);
            }
            this.tracer = $1ec05aac0120a3f2$var$Dn.getTracer(this.config.serviceName, this.config.serviceVersion), this.meter = $1ec05aac0120a3f2$var$In.getMeter(this.config.serviceName, this.config.serviceVersion), this.initializeMetrics(), this.initialized = !0, this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.debug("Telemetry", "Initialized with config", this.config);
        } catch (e) {
            $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Failed to initialize", e);
        }
    }
    initializeMetrics() {
        if (this.meter) try {
            this.counters.set("function_calls", this.meter.createCounter("fingerprint_function_calls", {
                description: "Number of fingerprint function calls"
            })), this.counters.set("errors", this.meter.createCounter("fingerprint_errors", {
                description: "Number of errors encountered"
            })), this.histograms.set("execution_time", this.meter.createHistogram("fingerprint_execution_time", {
                description: "Execution time of fingerprint operations",
                unit: "ms"
            })), this.counters.set("data_points", this.meter.createCounter("fingerprint_data_points", {
                description: "Number of data points collected"
            }));
        } catch (e) {
            $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Failed to initialize metrics", e);
        }
    }
    shouldSample() {
        const e = this.config.sampleRate ?? .1;
        return Math.random() < e;
    }
    startSpan(e, t = {}) {
        if (!this.initialized || !this.tracer || !this.shouldSample()) return null;
        try {
            return this.tracer.startSpan(e, {
                kind: $1ec05aac0120a3f2$var$gn.INTERNAL,
                attributes: {
                    "service.name": this.config.serviceName,
                    "service.version": this.config.serviceVersion,
                    ...t
                }
            });
        } catch (e) {
            return this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Failed to start span", e), null;
        }
    }
    endSpan(e, t = {}) {
        if (e) try {
            e.setAttributes(t), e.setStatus({
                code: $1ec05aac0120a3f2$var$hn.OK
            }), e.end();
        } catch (e) {
            this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Failed to end span", e);
        }
    }
    endSpanWithError(e, t, n = {}) {
        if (e) try {
            e.setAttributes({
                "error.name": t.name,
                "error.type": t.constructor.name,
                ...n
            }), e.setStatus({
                code: $1ec05aac0120a3f2$var$hn.ERROR,
                message: `Error: ${t.name}`
            }), e.end();
        } catch (e) {
            this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Failed to end span with error", e);
        }
    }
    incrementCounter(e, t = 1, n = {}) {
        if (this.initialized && this.shouldSample()) try {
            const r = this.counters.get(e);
            r && r.add(t, n);
        } catch (e) {
            this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Failed to increment counter", e);
        }
    }
    recordHistogram(e, t, n = {}) {
        if (this.initialized && this.shouldSample()) try {
            const r = this.histograms.get(e);
            r && r.record(t, n);
        } catch (e) {
            this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Failed to record histogram", e);
        }
    }
    recordError(e, t = {}) {
        if (this.initialized) try {
            this.incrementCounter("errors", 1, {
                "error.name": e.name,
                "error.type": e.constructor.name,
                ...t
            }), this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.debug("Telemetry", `Recorded error: ${e.name}`, t);
        } catch (e) {
            this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Failed to record error", e);
        }
    }
    recordFunctionCall(e, t, n, r = {}) {
        if (this.initialized) try {
            this.incrementCounter("function_calls", 1, {
                "function.name": e,
                "function.success": n,
                ...r
            }), this.recordHistogram("execution_time", t, {
                "function.name": e,
                ...r
            }), this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.debug("Telemetry", `Recorded function call: ${e} ${t}ms success:${n}`);
        } catch (e) {
            this.config.debug && $1ec05aac0120a3f2$export$79de5099e43c732e.warn("Telemetry", "Failed to record function call", e);
        }
    }
    getConfig() {
        return {
            ...this.config
        };
    }
    isEnabled() {
        return !0 === this.config.enabled && this.initialized;
    }
}, $1ec05aac0120a3f2$export$dce6f134b7ab7df7 = {
    initialize: (e = {})=>$1ec05aac0120a3f2$var$Qn.initialize(e),
    startSpan: (e, t)=>$1ec05aac0120a3f2$var$Qn.startSpan(e, t),
    endSpan: (e, t)=>$1ec05aac0120a3f2$var$Qn.endSpan(e, t),
    endSpanWithError: (e, t, n)=>$1ec05aac0120a3f2$var$Qn.endSpanWithError(e, t, n),
    recordError: (e, t)=>$1ec05aac0120a3f2$var$Qn.recordError(e, t),
    recordFunctionCall: (e, t, n, r)=>$1ec05aac0120a3f2$var$Qn.recordFunctionCall(e, t, n, r),
    incrementCounter: (e, t, n)=>$1ec05aac0120a3f2$var$Qn.incrementCounter(e, t, n),
    recordHistogram: (e, t, n)=>$1ec05aac0120a3f2$var$Qn.recordHistogram(e, t, n),
    isEnabled: ()=>$1ec05aac0120a3f2$var$Qn.isEnabled(),
    getConfig: ()=>$1ec05aac0120a3f2$var$Qn.getConfig()
};
function $1ec05aac0120a3f2$export$8ab50839bbdce2a5(e, t) {
    return function(...n) {
        const r = Date.now(), i = $1ec05aac0120a3f2$export$dce6f134b7ab7df7.startSpan(`function.${e}`, {
            "function.name": e,
            "function.args.count": n.length
        });
        try {
            const o = t.apply(this, n);
            if (o && "function" == typeof o.then) return o.then((t)=>{
                const n = Date.now() - r;
                return $1ec05aac0120a3f2$export$dce6f134b7ab7df7.recordFunctionCall(e, n, !0), $1ec05aac0120a3f2$export$dce6f134b7ab7df7.endSpan(i, {
                    "function.result": "success"
                }), t;
            }).catch((t)=>{
                const n = Date.now() - r;
                throw $1ec05aac0120a3f2$export$dce6f134b7ab7df7.recordFunctionCall(e, n, !1), $1ec05aac0120a3f2$export$dce6f134b7ab7df7.recordError(t, {
                    "function.name": e
                }), $1ec05aac0120a3f2$export$dce6f134b7ab7df7.endSpanWithError(i, t), t;
            });
            {
                const t = Date.now() - r;
                return $1ec05aac0120a3f2$export$dce6f134b7ab7df7.recordFunctionCall(e, t, !0), $1ec05aac0120a3f2$export$dce6f134b7ab7df7.endSpan(i, {
                    "function.result": "success"
                }), o;
            }
        } catch (t) {
            const n = Date.now() - r;
            throw $1ec05aac0120a3f2$export$dce6f134b7ab7df7.recordFunctionCall(e, n, !1), $1ec05aac0120a3f2$export$dce6f134b7ab7df7.recordError(t, {
                "function.name": e
            }), $1ec05aac0120a3f2$export$dce6f134b7ab7df7.endSpanWithError(i, t), t;
        }
    };
}
/*!
 * Structured error definitions for Fingerprint OSS
 * Copyright (c) 2025 Akshat Kotpalliwar
 * Licensed under LGPL-3.0
 */ class $1ec05aac0120a3f2$export$4e82b395b85a80a extends Error {
    constructor(e, t, n){
        super(t), this.name = "FingerprintError", this.code = e, this.details = n;
    }
    toJSON() {
        return {
            code: this.code,
            message: this.message,
            ...this.details ? {
                details: this.details
            } : {}
        };
    }
}
/*!
 * Copyright (c) 2025 Akshat Kotpalliwar (alias IntegerAlex on GitHub)
 * This software is licensed under the GNU Lesser General Public License (LGPL) v3 or later.
 *
 * You are free to use, modify, and redistribute this software, but modifications must also be licensed under the LGPL.
 * This project is distributed without any warranty; see the LGPL for more details.
 *
 * For a full copy of the LGPL and ethical contribution guidelines, please refer to the `COPYRIGHT.md` and `NOTICE.md` files.
 */ function $1ec05aac0120a3f2$var$zn(e, t) {
    let n = e?.confidenceScore || .5;
    if (e?.bot?.isBot && (n -= Math.min(.4, .6 * e.bot.confidence)), (t.traits?.isAnonymousProxy || t.traits?.isHostingProvider || t.traits?.isTorExitNode) && (n -= .2), e?.timezone && t.location?.timeZone !== e.timezone && (n -= .15), e?.userAgent && e?.platform) n -= $1ec05aac0120a3f2$export$be0930778259d8a3(e.userAgent, e.platform);
    return Math.max(.1, Math.min(.9, n));
}
const $1ec05aac0120a3f2$export$2e2bcd8739ae039 = Object.assign(async function(e = {}) {
    const t = [], n = (e)=>t.push(e);
    $1ec05aac0120a3f2$export$62b110e0dc0699c4({
        environment: e.environment,
        verbose: e.verbose,
        logLevel: e.logLevel,
        enableConsoleLogging: e.enableConsoleLogging,
        enablePerformanceLogging: e.enablePerformanceLogging,
        transparency: e.transparency,
        message: e.message,
        geoTimeout: e.geoTimeout
    }, t);
    const r = $1ec05aac0120a3f2$export$44487a86467333c3();
    return $1ec05aac0120a3f2$export$79de5099e43c732e.logBlock("userInfo", "User fingerprint collection", async ()=>{
        const i = Date.now();
        let o = null;
        try {
            e.telemetry && $1ec05aac0120a3f2$export$dce6f134b7ab7df7.initialize(e.telemetry), o = $1ec05aac0120a3f2$export$dce6f134b7ab7df7.startSpan("userInfo", {
                "operation.type": "fingerprint_collection",
                "config.transparency": e.transparency || !1,
                "config.telemetry.enabled": e.telemetry?.enabled || !1,
                "config.environment": r.environment
            });
            const [a, s] = await Promise.all([
                $1ec05aac0120a3f2$export$d51248ece03722d6(),
                $1ec05aac0120a3f2$export$5ee1c09fab1d5356({
                    timeoutMs: r.geoTimeout ?? $1ec05aac0120a3f2$var$N,
                    onWarning: n
                })
            ]);
            if (e.transparency) {
                const t = e.message || "the software is gathering system data";
                r.enableConsoleLogging && $1ec05aac0120a3f2$export$79de5099e43c732e.info("TRANSPARENCY", `\xa9 fingerprint-oss ${t}`), $1ec05aac0120a3f2$export$8d8dc7d5f743331b.show(`\xa9 fingerprint-oss ${t}`);
            } else e.message && $1ec05aac0120a3f2$export$8d8dc7d5f743331b.show(`\xa9 fingerprint-oss ${e.message}`);
            const c = await $1ec05aac0120a3f2$export$79de5099e43c732e.logBlock("generateJSON", "JSON generation", ()=>$1ec05aac0120a3f2$export$d23738d50f257f47(s, a, $1ec05aac0120a3f2$var$zn(a, s))), u = t.length ? {
                ...c,
                warnings: t
            } : c, l = Date.now() - i, d = $1ec05aac0120a3f2$var$zn(a, s);
            return $1ec05aac0120a3f2$export$dce6f134b7ab7df7.recordFunctionCall("userInfo", l, !0, {
                "data.systemInfo.available": !!a,
                "data.geoInfo.available": !!s,
                "data.confidence": d
            }), $1ec05aac0120a3f2$export$dce6f134b7ab7df7.endSpan(o, {
                "result.success": !0,
                "result.confidence": d,
                "execution.time": l
            }), u;
        } catch (e) {
            const r = function(e) {
                if (e instanceof $1ec05aac0120a3f2$export$4e82b395b85a80a) return e;
                const t = $1ec05aac0120a3f2$export$2480726bf2d3fb51(), n = $1ec05aac0120a3f2$export$be292d663ef09398() || "DEV" === t || "TEST" === t;
                if (e instanceof Error) {
                    const t = {
                        name: e.name
                    };
                    return n && e.stack && (t.stack = e.stack), new $1ec05aac0120a3f2$export$4e82b395b85a80a("UNKNOWN_ERROR", e.message, t);
                }
                return new $1ec05aac0120a3f2$export$4e82b395b85a80a("UNKNOWN_ERROR", "Unknown error", n ? {
                    error: e
                } : {});
            }(e);
            n({
                code: r.code,
                message: r.message,
                details: r.details
            }), $1ec05aac0120a3f2$export$79de5099e43c732e.error("userInfo", "Data collection error", r);
            const a = Date.now() - i;
            $1ec05aac0120a3f2$export$dce6f134b7ab7df7.recordError(r, {
                "function.name": "userInfo",
                "execution.time": a
            }), $1ec05aac0120a3f2$export$dce6f134b7ab7df7.recordFunctionCall("userInfo", a, !1), $1ec05aac0120a3f2$export$dce6f134b7ab7df7.endSpanWithError(o, r);
            const s = $1ec05aac0120a3f2$export$ab8d7a02a09de127(), { getMockGeolocationData: c } = await Promise.resolve().then(function() {
                return $1ec05aac0120a3f2$var$ee;
            }), u = c(), l = await $1ec05aac0120a3f2$export$79de5099e43c732e.logBlock("generateJSON", "Fallback JSON generation", ()=>$1ec05aac0120a3f2$export$d23738d50f257f47(u, s, $1ec05aac0120a3f2$var$zn(s, u)));
            return t.length ? {
                ...l,
                warnings: t
            } : l;
        }
    });
}, {
    getSystemInfo: $1ec05aac0120a3f2$export$d51248ece03722d6,
    detectBot: $1ec05aac0120a3f2$export$7a062585ef37f700,
    fetchGeolocationInfo: $1ec05aac0120a3f2$export$5ee1c09fab1d5356,
    generateJSON: $1ec05aac0120a3f2$export$d23738d50f257f47,
    generateId: $1ec05aac0120a3f2$export$567fc7097e064344,
    detectDeviceType: $1ec05aac0120a3f2$export$568a7d21694b4b32,
    detectIncognito: $1ec05aac0120a3f2$export$40b2248fa055142e,
    detectAdBlockers: $1ec05aac0120a3f2$export$a0ca86ff5b917adc,
    getVpnStatus: $1ec05aac0120a3f2$export$958f39eada2708e4,
    getColorGamut: $1ec05aac0120a3f2$export$e66e9777a25f7214,
    getVendorFlavors: $1ec05aac0120a3f2$export$bceda55f827e9ec1,
    isLocalStorageEnabled: $1ec05aac0120a3f2$export$6515f7b9b46b3e7a,
    isSessionStorageEnabled: $1ec05aac0120a3f2$export$aa54e0afc8dac45d,
    isIndexedDBEnabled: $1ec05aac0120a3f2$export$775d9a05b79cc7d4,
    getTouchSupportInfo: $1ec05aac0120a3f2$export$4f3264e94584e8a3,
    getOSInfo: $1ec05aac0120a3f2$export$471d7e4c229dedf,
    getPluginsInfo: $1ec05aac0120a3f2$export$53ed4462388b7e3c,
    getMathFingerprint: $1ec05aac0120a3f2$export$a1de9105a12432fa,
    getCanvasFingerprint: $1ec05aac0120a3f2$export$ae1f21143e050ca0,
    getAudioFingerprint: $1ec05aac0120a3f2$export$ce9340c25c605fa0,
    getWebGLInfo: $1ec05aac0120a3f2$export$26314aceb7e23c5c,
    getFontPreferences: $1ec05aac0120a3f2$export$8edff794b322b33f,
    estimateCores: $1ec05aac0120a3f2$export$1f3a78993ad37dfd,
    getLanguageConsistency: $1ec05aac0120a3f2$export$d67c3a3f1da56e2f,
    isRiskyASN: $1ec05aac0120a3f2$export$1cdc1ae1ff32569d,
    getUAPlatformMismatch: $1ec05aac0120a3f2$export$be0930778259d8a3,
    checkBrowserConsistency: $1ec05aac0120a3f2$export$e6178ce1dec90fc,
    getMockSystemInfo: $1ec05aac0120a3f2$export$ab8d7a02a09de127,
    Toast: $1ec05aac0120a3f2$export$8d8dc7d5f743331b,
    Telemetry: $1ec05aac0120a3f2$export$dce6f134b7ab7df7,
    withTelemetry: $1ec05aac0120a3f2$export$8ab50839bbdce2a5,
    getConfig: $1ec05aac0120a3f2$export$44487a86467333c3,
    initializeConfig: $1ec05aac0120a3f2$export$62b110e0dc0699c4,
    updateConfig: $1ec05aac0120a3f2$export$2eaf9172a83ee9e7,
    detectEnvironment: $1ec05aac0120a3f2$export$2480726bf2d3fb51,
    isVerboseEnabled: $1ec05aac0120a3f2$export$be292d663ef09398,
    StructuredLogger: $1ec05aac0120a3f2$export$79de5099e43c732e,
    PerformanceTimer: $1ec05aac0120a3f2$export$67e62f8ce7018ffb
}), $1ec05aac0120a3f2$var$Hn = $1ec05aac0120a3f2$var$gt("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function $1ec05aac0120a3f2$var$qn(e) {
    return e.setValue($1ec05aac0120a3f2$var$Hn, !0);
}
function $1ec05aac0120a3f2$var$jn(e) {
    return !0 === e.getValue($1ec05aac0120a3f2$var$Hn);
}
const $1ec05aac0120a3f2$var$Vn = "baggage";
let $1ec05aac0120a3f2$var$Jn = class {
    inject(e, t, n) {
        const r = $1ec05aac0120a3f2$var$Mn.getBaggage(e);
        if (!r || $1ec05aac0120a3f2$var$jn(e)) return;
        const i = (function(e) {
            return e.getAllEntries().map(([e, t])=>{
                let n = `${encodeURIComponent(e)}=${encodeURIComponent(t.value)}`;
                return void 0 !== t.metadata && (n += ";" + t.metadata.toString()), n;
            });
        })(r).filter((e)=>e.length <= 4096).slice(0, 180), o = function(e) {
            return e.reduce((e, t)=>{
                const n = `${e}${"" !== e ? "," : ""}${t}`;
                return n.length > 8192 ? e : n;
            }, "");
        }(i);
        o.length > 0 && n.set(t, $1ec05aac0120a3f2$var$Vn, o);
    }
    extract(e, t, n) {
        const r = n.get(t, $1ec05aac0120a3f2$var$Vn), i = Array.isArray(r) ? r.join(",") : r;
        if (!i) return e;
        const o = {};
        if (0 === i.length) return e;
        return i.split(",").forEach((e)=>{
            const t = function(e) {
                if (!e) return;
                const t = e.indexOf(";"), n = -1 === t ? e : e.substring(0, t), r = n.indexOf("=");
                if (r <= 0) return;
                const i = n.substring(0, r).trim(), o = n.substring(r + 1).trim();
                if (!i || !o) return;
                let a, s, c;
                try {
                    a = decodeURIComponent(i), s = decodeURIComponent(o);
                } catch  {
                    return;
                }
                -1 !== t && t < e.length - 1 && (c = $1ec05aac0120a3f2$var$ft(e.substring(t + 1)));
                return {
                    key: a,
                    value: s,
                    metadata: c
                };
            }(e);
            if (t) {
                const e = {
                    value: t.value
                };
                t.metadata && (e.metadata = t.metadata), o[t.key] = e;
            }
        }), 0 === Object.entries(o).length ? e : $1ec05aac0120a3f2$var$Mn.setBaggage(e, $1ec05aac0120a3f2$var$Mn.createBaggage(o));
    }
    fields() {
        return [
            $1ec05aac0120a3f2$var$Vn
        ];
    }
};
function $1ec05aac0120a3f2$var$Kn(e) {
    const t = {};
    if ("object" != typeof e || null == e) return t;
    for(const n in e){
        if (!Object.prototype.hasOwnProperty.call(e, n)) continue;
        if (!$1ec05aac0120a3f2$var$Yn(n)) {
            $1ec05aac0120a3f2$var$yn.warn(`Invalid attribute key: ${n}`);
            continue;
        }
        const r = e[n];
        $1ec05aac0120a3f2$var$Wn(r) ? Array.isArray(r) ? t[n] = r.slice() : t[n] = r : $1ec05aac0120a3f2$var$yn.warn(`Invalid attribute value set for key: ${n}`);
    }
    return t;
}
function $1ec05aac0120a3f2$var$Yn(e) {
    return "string" == typeof e && "" !== e;
}
function $1ec05aac0120a3f2$var$Wn(e) {
    return null == e || (Array.isArray(e) ? function(e) {
        let t;
        for (const n of e){
            if (null == n) continue;
            const e = typeof n;
            if (e !== t) {
                if (!t) {
                    if ($1ec05aac0120a3f2$var$Zn(e)) {
                        t = e;
                        continue;
                    }
                    return !1;
                }
                return !1;
            }
        }
        return !0;
    }(e) : $1ec05aac0120a3f2$var$Zn(typeof e));
}
function $1ec05aac0120a3f2$var$Zn(e) {
    switch(e){
        case "number":
        case "boolean":
        case "string":
            return !0;
    }
    return !1;
}
let $1ec05aac0120a3f2$var$$n = (e)=>{
    $1ec05aac0120a3f2$var$yn.error(function(e) {
        return "string" == typeof e ? e : JSON.stringify(function(e) {
            const t = {};
            let n = e;
            for(; null !== n;)Object.getOwnPropertyNames(n).forEach((e)=>{
                if (t[e]) return;
                const r = n[e];
                r && (t[e] = String(r));
            }), n = Object.getPrototypeOf(n);
            return t;
        }(e));
    }(e));
};
function $1ec05aac0120a3f2$var$er(e) {
    try {
        $1ec05aac0120a3f2$var$$n(e);
    } catch  {}
}
const $1ec05aac0120a3f2$var$tr = "exception.message", $1ec05aac0120a3f2$var$nr = "exception.type", $1ec05aac0120a3f2$var$rr = "service.name", $1ec05aac0120a3f2$var$ir = "telemetry.sdk.language", $1ec05aac0120a3f2$var$or = "telemetry.sdk.name", $1ec05aac0120a3f2$var$ar = "telemetry.sdk.version", $1ec05aac0120a3f2$var$sr = "process.runtime.name", $1ec05aac0120a3f2$var$cr = {
    [$1ec05aac0120a3f2$var$or]: "opentelemetry",
    [$1ec05aac0120a3f2$var$sr]: "browser",
    [$1ec05aac0120a3f2$var$ir]: "webjs",
    [$1ec05aac0120a3f2$var$ar]: "2.5.0"
}, $1ec05aac0120a3f2$var$ur = performance, $1ec05aac0120a3f2$var$lr = Math.pow(10, 6), $1ec05aac0120a3f2$var$dr = Math.pow(10, 9);
function $1ec05aac0120a3f2$var$pr(e) {
    const t = e / 1e3;
    return [
        Math.trunc(t),
        Math.round(e % 1e3 * $1ec05aac0120a3f2$var$lr)
    ];
}
function $1ec05aac0120a3f2$var$fr(e) {
    return $1ec05aac0120a3f2$var$mr($1ec05aac0120a3f2$var$pr($1ec05aac0120a3f2$var$ur.timeOrigin), $1ec05aac0120a3f2$var$pr("number" == typeof e ? e : $1ec05aac0120a3f2$var$ur.now()));
}
function $1ec05aac0120a3f2$var$gr(e) {
    if ($1ec05aac0120a3f2$var$Ar(e)) return e;
    if ("number" == typeof e) return e < $1ec05aac0120a3f2$var$ur.timeOrigin ? $1ec05aac0120a3f2$var$fr(e) : $1ec05aac0120a3f2$var$pr(e);
    if (e instanceof Date) return $1ec05aac0120a3f2$var$pr(e.getTime());
    throw TypeError("Invalid input type");
}
function $1ec05aac0120a3f2$var$hr(e) {
    return e[0] * $1ec05aac0120a3f2$var$dr + e[1];
}
function $1ec05aac0120a3f2$var$Er(e) {
    return 1e6 * e[0] + e[1] / 1e3;
}
function $1ec05aac0120a3f2$var$Ar(e) {
    return Array.isArray(e) && 2 === e.length && "number" == typeof e[0] && "number" == typeof e[1];
}
function $1ec05aac0120a3f2$var$_r(e) {
    return $1ec05aac0120a3f2$var$Ar(e) || "number" == typeof e || e instanceof Date;
}
function $1ec05aac0120a3f2$var$mr(e, t) {
    const n = [
        e[0] + t[0],
        e[1] + t[1]
    ];
    return n[1] >= $1ec05aac0120a3f2$var$dr && (n[1] -= $1ec05aac0120a3f2$var$dr, n[0] += 1), n;
}
var $1ec05aac0120a3f2$var$Tr;
!function(e) {
    e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
}($1ec05aac0120a3f2$var$Tr || ($1ec05aac0120a3f2$var$Tr = {}));
let $1ec05aac0120a3f2$var$yr = class {
    _propagators;
    _fields;
    constructor(e = {}){
        this._propagators = e.propagators ?? [], this._fields = Array.from(new Set(this._propagators.map((e)=>"function" == typeof e.fields ? e.fields() : []).reduce((e, t)=>e.concat(t), [])));
    }
    inject(e, t, n) {
        for (const r of this._propagators)try {
            r.inject(e, t, n);
        } catch (e) {
            $1ec05aac0120a3f2$var$yn.warn(`Failed to inject with ${r.constructor.name}. Err: ${e.message}`);
        }
    }
    extract(e, t, n) {
        return this._propagators.reduce((e, r)=>{
            try {
                return r.extract(e, t, n);
            } catch (e) {
                $1ec05aac0120a3f2$var$yn.warn(`Failed to extract with ${r.constructor.name}. Err: ${e.message}`);
            }
            return e;
        }, e);
    }
    fields() {
        return this._fields.slice();
    }
};
const $1ec05aac0120a3f2$var$vr = "[_0-9a-z-*/]", $1ec05aac0120a3f2$var$br = new RegExp(`^(?:${`[a-z]${$1ec05aac0120a3f2$var$vr}{0,255}`}|${`[a-z0-9]${$1ec05aac0120a3f2$var$vr}{0,240}@[a-z]${$1ec05aac0120a3f2$var$vr}{0,13}`})$`), $1ec05aac0120a3f2$var$Ir = /^[ -~]{0,255}[!-~]$/, $1ec05aac0120a3f2$var$Sr = /,|=/;
let $1ec05aac0120a3f2$var$Or = class e {
    _internalState = new Map;
    constructor(e){
        e && this._parse(e);
    }
    set(e, t) {
        const n = this._clone();
        return n._internalState.has(e) && n._internalState.delete(e), n._internalState.set(e, t), n;
    }
    unset(e) {
        const t = this._clone();
        return t._internalState.delete(e), t;
    }
    get(e) {
        return this._internalState.get(e);
    }
    serialize() {
        return this._keys().reduce((e, t)=>(e.push(t + "=" + this.get(t)), e), []).join(",");
    }
    _parse(e) {
        e.length > 512 || (this._internalState = e.split(",").reverse().reduce((e, t)=>{
            const n = t.trim(), r = n.indexOf("=");
            if (-1 !== r) {
                const i = n.slice(0, r), o = n.slice(r + 1, t.length);
                (function(e) {
                    return $1ec05aac0120a3f2$var$br.test(e);
                })(i) && function(e) {
                    return $1ec05aac0120a3f2$var$Ir.test(e) && !$1ec05aac0120a3f2$var$Sr.test(e);
                }(o) && e.set(i, o);
            }
            return e;
        }, new Map), this._internalState.size > 32 && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, 32))));
    }
    _keys() {
        return Array.from(this._internalState.keys()).reverse();
    }
    _clone() {
        const t = new e;
        return t._internalState = new Map(this._internalState), t;
    }
};
const $1ec05aac0120a3f2$var$wr = "traceparent", $1ec05aac0120a3f2$var$Rr = "tracestate", $1ec05aac0120a3f2$var$Lr = new RegExp("^\\s?((?!ff)[\\da-f]{2})-((?![0]{32})[\\da-f]{32})-((?![0]{16})[\\da-f]{16})-([\\da-f]{2})(-.*)?\\s?$");
let $1ec05aac0120a3f2$var$Cr = class {
    inject(e, t, n) {
        const r = $1ec05aac0120a3f2$var$Dn.getSpanContext(e);
        if (!r || $1ec05aac0120a3f2$var$jn(e) || !$1ec05aac0120a3f2$var$un(r)) return;
        const i = `00-${r.traceId}-${r.spanId}-0${Number(r.traceFlags || $1ec05aac0120a3f2$var$Et.NONE).toString(16)}`;
        n.set(t, $1ec05aac0120a3f2$var$wr, i), r.traceState && n.set(t, $1ec05aac0120a3f2$var$Rr, r.traceState.serialize());
    }
    extract(e, t, n) {
        const r = n.get(t, $1ec05aac0120a3f2$var$wr);
        if (!r) return e;
        const i = Array.isArray(r) ? r[0] : r;
        if ("string" != typeof i) return e;
        const o = function(e) {
            const t = $1ec05aac0120a3f2$var$Lr.exec(e);
            return t ? "00" === t[1] && t[5] ? null : {
                traceId: t[2],
                spanId: t[3],
                traceFlags: parseInt(t[4], 16)
            } : null;
        }(i);
        if (!o) return e;
        o.isRemote = !0;
        const a = n.get(t, $1ec05aac0120a3f2$var$Rr);
        if (a) {
            const e = Array.isArray(a) ? a.join(",") : a;
            o.traceState = new $1ec05aac0120a3f2$var$Or("string" == typeof e ? e : void 0);
        }
        return $1ec05aac0120a3f2$var$Dn.setSpanContext(e, o);
    }
    fields() {
        return [
            $1ec05aac0120a3f2$var$wr,
            $1ec05aac0120a3f2$var$Rr
        ];
    }
};
const $1ec05aac0120a3f2$var$Pr = "[object Null]", $1ec05aac0120a3f2$var$Br = "[object Undefined]", $1ec05aac0120a3f2$var$Nr = Function.prototype.toString, $1ec05aac0120a3f2$var$Mr = $1ec05aac0120a3f2$var$Nr.call(Object), $1ec05aac0120a3f2$var$xr = Object.getPrototypeOf, $1ec05aac0120a3f2$var$Dr = Object.prototype, $1ec05aac0120a3f2$var$Fr = $1ec05aac0120a3f2$var$Dr.hasOwnProperty, $1ec05aac0120a3f2$var$Qr = Symbol ? Symbol.toStringTag : void 0, $1ec05aac0120a3f2$var$Ur = $1ec05aac0120a3f2$var$Dr.toString;
function $1ec05aac0120a3f2$var$kr(e) {
    if (!function(e) {
        return null != e && "object" == typeof e;
    }(e) || "[object Object]" !== function(e) {
        if (null == e) return void 0 === e ? $1ec05aac0120a3f2$var$Br : $1ec05aac0120a3f2$var$Pr;
        return $1ec05aac0120a3f2$var$Qr && $1ec05aac0120a3f2$var$Qr in Object(e) ? function(e) {
            const t = $1ec05aac0120a3f2$var$Fr.call(e, $1ec05aac0120a3f2$var$Qr), n = e[$1ec05aac0120a3f2$var$Qr];
            let r = !1;
            try {
                e[$1ec05aac0120a3f2$var$Qr] = void 0, r = !0;
            } catch  {}
            const i = $1ec05aac0120a3f2$var$Ur.call(e);
            r && (t ? e[$1ec05aac0120a3f2$var$Qr] = n : delete e[$1ec05aac0120a3f2$var$Qr]);
            return i;
        }(e) : function(e) {
            return $1ec05aac0120a3f2$var$Ur.call(e);
        }(e);
    }(e)) return !1;
    const t = $1ec05aac0120a3f2$var$xr(e);
    if (null === t) return !0;
    const n = $1ec05aac0120a3f2$var$Fr.call(t, "constructor") && t.constructor;
    return "function" == typeof n && n instanceof n && $1ec05aac0120a3f2$var$Nr.call(n) === $1ec05aac0120a3f2$var$Mr;
}
function $1ec05aac0120a3f2$var$Gr(e) {
    return $1ec05aac0120a3f2$var$Hr(e) ? e.slice() : e;
}
function $1ec05aac0120a3f2$var$zr(e, t, n = 0, r) {
    let i;
    if (!(n > 20)) {
        if (n++, $1ec05aac0120a3f2$var$Vr(e) || $1ec05aac0120a3f2$var$Vr(t) || $1ec05aac0120a3f2$var$qr(t)) i = $1ec05aac0120a3f2$var$Gr(t);
        else if ($1ec05aac0120a3f2$var$Hr(e)) {
            if (i = e.slice(), $1ec05aac0120a3f2$var$Hr(t)) for(let e = 0, n = t.length; e < n; e++)i.push($1ec05aac0120a3f2$var$Gr(t[e]));
            else if ($1ec05aac0120a3f2$var$jr(t)) {
                const e = Object.keys(t);
                for(let n = 0, r = e.length; n < r; n++){
                    const r = e[n];
                    i[r] = $1ec05aac0120a3f2$var$Gr(t[r]);
                }
            }
        } else if ($1ec05aac0120a3f2$var$jr(e)) {
            if ($1ec05aac0120a3f2$var$jr(t)) {
                if (!function(e, t) {
                    if (!$1ec05aac0120a3f2$var$kr(e) || !$1ec05aac0120a3f2$var$kr(t)) return !1;
                    return !0;
                }(e, t)) return t;
                i = Object.assign({}, e);
                const o = Object.keys(t);
                for(let a = 0, s = o.length; a < s; a++){
                    const s = o[a], c = t[s];
                    if ($1ec05aac0120a3f2$var$Vr(c)) void 0 === c ? delete i[s] : i[s] = c;
                    else {
                        const o = i[s], a = c;
                        if ($1ec05aac0120a3f2$var$Xr(e, s, r) || $1ec05aac0120a3f2$var$Xr(t, s, r)) delete i[s];
                        else {
                            if ($1ec05aac0120a3f2$var$jr(o) && $1ec05aac0120a3f2$var$jr(a)) {
                                const n = r.get(o) || [], i = r.get(a) || [];
                                n.push({
                                    obj: e,
                                    key: s
                                }), i.push({
                                    obj: t,
                                    key: s
                                }), r.set(o, n), r.set(a, i);
                            }
                            i[s] = $1ec05aac0120a3f2$var$zr(i[s], c, n, r);
                        }
                    }
                }
            } else i = t;
        }
        return i;
    }
}
function $1ec05aac0120a3f2$var$Xr(e, t, n) {
    const r = n.get(e[t]) || [];
    for(let n = 0, i = r.length; n < i; n++){
        const i = r[n];
        if (i.key === t && i.obj === e) return !0;
    }
    return !1;
}
function $1ec05aac0120a3f2$var$Hr(e) {
    return Array.isArray(e);
}
function $1ec05aac0120a3f2$var$qr(e) {
    return "function" == typeof e;
}
function $1ec05aac0120a3f2$var$jr(e) {
    return !$1ec05aac0120a3f2$var$Vr(e) && !$1ec05aac0120a3f2$var$Hr(e) && !$1ec05aac0120a3f2$var$qr(e) && "object" == typeof e;
}
function $1ec05aac0120a3f2$var$Vr(e) {
    return "string" == typeof e || "number" == typeof e || "boolean" == typeof e || void 0 === e || e instanceof Date || e instanceof RegExp || null === e;
}
let $1ec05aac0120a3f2$var$Jr = class {
    _promise;
    _resolve;
    _reject;
    constructor(){
        this._promise = new Promise((e, t)=>{
            this._resolve = e, this._reject = t;
        });
    }
    get promise() {
        return this._promise;
    }
    resolve(e) {
        this._resolve(e);
    }
    reject(e) {
        this._reject(e);
    }
}, $1ec05aac0120a3f2$var$Kr = class {
    _isCalled = !1;
    _deferred = new $1ec05aac0120a3f2$var$Jr;
    _callback;
    _that;
    constructor(e, t){
        this._callback = e, this._that = t;
    }
    get isCalled() {
        return this._isCalled;
    }
    get promise() {
        return this._deferred.promise;
    }
    call(...e) {
        if (!this._isCalled) {
            this._isCalled = !0;
            try {
                Promise.resolve(this._callback.call(this._that, ...e)).then((e)=>this._deferred.resolve(e), (e)=>this._deferred.reject(e));
            } catch (e) {
                this._deferred.reject(e);
            }
        }
        return this._deferred.promise;
    }
};
const $1ec05aac0120a3f2$var$Yr = {
    _export: function(e, t) {
        return new Promise((n)=>{
            $1ec05aac0120a3f2$var$Tn.with($1ec05aac0120a3f2$var$qn($1ec05aac0120a3f2$var$Tn.active()), ()=>{
                e.export(t, (e)=>{
                    n(e);
                });
            });
        });
    }
};
let $1ec05aac0120a3f2$var$Wr;
function $1ec05aac0120a3f2$var$Zr() {
    if (void 0 === $1ec05aac0120a3f2$var$Wr) try {
        const e = globalThis.process.argv0;
        $1ec05aac0120a3f2$var$Wr = e ? `unknown_service:${e}` : "unknown_service";
    } catch  {
        $1ec05aac0120a3f2$var$Wr = "unknown_service";
    }
    return $1ec05aac0120a3f2$var$Wr;
}
const $1ec05aac0120a3f2$var$$r = (e)=>null !== e && "object" == typeof e && "function" == typeof e.then;
class $1ec05aac0120a3f2$var$ei {
    _rawAttributes;
    _asyncAttributesPending = !1;
    _schemaUrl;
    _memoizedAttributes;
    static FromAttributeList(e, t) {
        const n = new $1ec05aac0120a3f2$var$ei({}, t);
        return n._rawAttributes = $1ec05aac0120a3f2$var$ni(e), n._asyncAttributesPending = e.filter(([e, t])=>$1ec05aac0120a3f2$var$$r(t)).length > 0, n;
    }
    constructor(e, t){
        const n = e.attributes ?? {};
        this._rawAttributes = Object.entries(n).map(([e, t])=>($1ec05aac0120a3f2$var$$r(t) && (this._asyncAttributesPending = !0), [
                e,
                t
            ])), this._rawAttributes = $1ec05aac0120a3f2$var$ni(this._rawAttributes), this._schemaUrl = function(e) {
            if ("string" == typeof e || void 0 === e) return e;
            return void $1ec05aac0120a3f2$var$yn.warn("Schema URL must be string or undefined, got %s. Schema URL will be ignored.", e);
        }(t?.schemaUrl);
    }
    get asyncAttributesPending() {
        return this._asyncAttributesPending;
    }
    async waitForAsyncAttributes() {
        if (this.asyncAttributesPending) {
            for(let e = 0; e < this._rawAttributes.length; e++){
                const [t, n] = this._rawAttributes[e];
                this._rawAttributes[e] = [
                    t,
                    $1ec05aac0120a3f2$var$$r(n) ? await n : n
                ];
            }
            this._asyncAttributesPending = !1;
        }
    }
    get attributes() {
        if (this.asyncAttributesPending && $1ec05aac0120a3f2$var$yn.error("Accessing resource attributes before async attributes settled"), this._memoizedAttributes) return this._memoizedAttributes;
        const e = {};
        for (const [t, n] of this._rawAttributes)$1ec05aac0120a3f2$var$$r(n) ? $1ec05aac0120a3f2$var$yn.debug(`Unsettled resource attribute ${t} skipped`) : null != n && (e[t] ??= n);
        return this._asyncAttributesPending || (this._memoizedAttributes = e), e;
    }
    getRawAttributes() {
        return this._rawAttributes;
    }
    get schemaUrl() {
        return this._schemaUrl;
    }
    merge(e) {
        if (null == e) return this;
        const t = function(e, t) {
            const n = e?.schemaUrl, r = t?.schemaUrl, i = void 0 === n || "" === n, o = void 0 === r || "" === r;
            if (i) return r;
            if (o) return n;
            if (n === r) return n;
            return void $1ec05aac0120a3f2$var$yn.warn('Schema URL merge conflict: old resource has "%s", updating resource has "%s". Resulting resource will have undefined Schema URL.', n, r);
        }(this, e), n = t ? {
            schemaUrl: t
        } : void 0;
        return $1ec05aac0120a3f2$var$ei.FromAttributeList([
            ...e.getRawAttributes(),
            ...this.getRawAttributes()
        ], n);
    }
}
function $1ec05aac0120a3f2$var$ti() {
    var e, t;
    return e = {
        [$1ec05aac0120a3f2$var$rr]: $1ec05aac0120a3f2$var$Zr(),
        [$1ec05aac0120a3f2$var$ir]: $1ec05aac0120a3f2$var$cr[$1ec05aac0120a3f2$var$ir],
        [$1ec05aac0120a3f2$var$or]: $1ec05aac0120a3f2$var$cr[$1ec05aac0120a3f2$var$or],
        [$1ec05aac0120a3f2$var$ar]: $1ec05aac0120a3f2$var$cr[$1ec05aac0120a3f2$var$ar]
    }, $1ec05aac0120a3f2$var$ei.FromAttributeList(Object.entries(e), t);
}
function $1ec05aac0120a3f2$var$ni(e) {
    return e.map(([e, t])=>$1ec05aac0120a3f2$var$$r(t) ? [
            e,
            t.catch((t)=>{
                $1ec05aac0120a3f2$var$yn.debug("promise rejection for resource attribute: %s - %s", e, t);
            })
        ] : [
            e,
            t
        ]);
}
class $1ec05aac0120a3f2$var$ri {
    _spanContext;
    kind;
    parentSpanContext;
    attributes = {};
    links = [];
    events = [];
    startTime;
    resource;
    instrumentationScope;
    _droppedAttributesCount = 0;
    _droppedEventsCount = 0;
    _droppedLinksCount = 0;
    name;
    status = {
        code: $1ec05aac0120a3f2$var$hn.UNSET
    };
    endTime = [
        0,
        0
    ];
    _ended = !1;
    _duration = [
        -1,
        -1
    ];
    _spanProcessor;
    _spanLimits;
    _attributeValueLengthLimit;
    _performanceStartTime;
    _performanceOffset;
    _startTimeProvided;
    constructor(e){
        const t = Date.now();
        this._spanContext = e.spanContext, this._performanceStartTime = $1ec05aac0120a3f2$var$ur.now(), this._performanceOffset = t - (this._performanceStartTime + $1ec05aac0120a3f2$var$ur.timeOrigin), this._startTimeProvided = null != e.startTime, this._spanLimits = e.spanLimits, this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, this._spanProcessor = e.spanProcessor, this.name = e.name, this.parentSpanContext = e.parentSpanContext, this.kind = e.kind, this.links = e.links || [], this.startTime = this._getTime(e.startTime ?? t), this.resource = e.resource, this.instrumentationScope = e.scope, null != e.attributes && this.setAttributes(e.attributes), this._spanProcessor.onStart(this, e.context);
    }
    spanContext() {
        return this._spanContext;
    }
    setAttribute(e, t) {
        if (null == t || this._isSpanEnded()) return this;
        if (0 === e.length) return $1ec05aac0120a3f2$var$yn.warn(`Invalid attribute key: ${e}`), this;
        if (!$1ec05aac0120a3f2$var$Wn(t)) return $1ec05aac0120a3f2$var$yn.warn(`Invalid attribute value set for key: ${e}`), this;
        const { attributeCountLimit: n } = this._spanLimits;
        return void 0 !== n && Object.keys(this.attributes).length >= n && !Object.prototype.hasOwnProperty.call(this.attributes, e) ? (this._droppedAttributesCount++, this) : (this.attributes[e] = this._truncateToSize(t), this);
    }
    setAttributes(e) {
        for (const [t, n] of Object.entries(e))this.setAttribute(t, n);
        return this;
    }
    addEvent(e, t, n) {
        if (this._isSpanEnded()) return this;
        const { eventCountLimit: r } = this._spanLimits;
        if (0 === r) return $1ec05aac0120a3f2$var$yn.warn("No events allowed."), this._droppedEventsCount++, this;
        void 0 !== r && this.events.length >= r && (0 === this._droppedEventsCount && $1ec05aac0120a3f2$var$yn.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), $1ec05aac0120a3f2$var$_r(t) && ($1ec05aac0120a3f2$var$_r(n) || (n = t), t = void 0);
        const i = $1ec05aac0120a3f2$var$Kn(t);
        return this.events.push({
            name: e,
            attributes: i,
            time: this._getTime(n),
            droppedAttributesCount: 0
        }), this;
    }
    addLink(e) {
        return this.links.push(e), this;
    }
    addLinks(e) {
        return this.links.push(...e), this;
    }
    setStatus(e) {
        return this._isSpanEnded() || (this.status = {
            ...e
        }, null != this.status.message && "string" != typeof e.message && ($1ec05aac0120a3f2$var$yn.warn(`Dropping invalid status.message of type '${typeof e.message}', expected 'string'`), delete this.status.message)), this;
    }
    updateName(e) {
        return this._isSpanEnded() || (this.name = e), this;
    }
    end(e) {
        this._isSpanEnded() ? $1ec05aac0120a3f2$var$yn.error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`) : (this.endTime = this._getTime(e), this._duration = function(e, t) {
            let n = t[0] - e[0], r = t[1] - e[1];
            return r < 0 && (n -= 1, r += $1ec05aac0120a3f2$var$dr), [
                n,
                r
            ];
        }(this.startTime, this.endTime), this._duration[0] < 0 && ($1ec05aac0120a3f2$var$yn.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [
            0,
            0
        ]), this._droppedEventsCount > 0 && $1ec05aac0120a3f2$var$yn.warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`), this._spanProcessor.onEnding && this._spanProcessor.onEnding(this), this._ended = !0, this._spanProcessor.onEnd(this));
    }
    _getTime(e) {
        if ("number" == typeof e && e <= $1ec05aac0120a3f2$var$ur.now()) return $1ec05aac0120a3f2$var$fr(e + this._performanceOffset);
        if ("number" == typeof e) return $1ec05aac0120a3f2$var$pr(e);
        if (e instanceof Date) return $1ec05aac0120a3f2$var$pr(e.getTime());
        if ($1ec05aac0120a3f2$var$Ar(e)) return e;
        if (this._startTimeProvided) return $1ec05aac0120a3f2$var$pr(Date.now());
        const t = $1ec05aac0120a3f2$var$ur.now() - this._performanceStartTime;
        return $1ec05aac0120a3f2$var$mr(this.startTime, $1ec05aac0120a3f2$var$pr(t));
    }
    isRecording() {
        return !1 === this._ended;
    }
    recordException(e, t) {
        const n = {};
        "string" == typeof e ? n[$1ec05aac0120a3f2$var$tr] = e : e && (e.code ? n[$1ec05aac0120a3f2$var$nr] = e.code.toString() : e.name && (n[$1ec05aac0120a3f2$var$nr] = e.name), e.message && (n[$1ec05aac0120a3f2$var$tr] = e.message), e.stack && (n["exception.stacktrace"] = e.stack)), n[$1ec05aac0120a3f2$var$nr] || n[$1ec05aac0120a3f2$var$tr] ? this.addEvent("exception", n, t) : $1ec05aac0120a3f2$var$yn.warn(`Failed to record an exception ${e}`);
    }
    get duration() {
        return this._duration;
    }
    get ended() {
        return this._ended;
    }
    get droppedAttributesCount() {
        return this._droppedAttributesCount;
    }
    get droppedEventsCount() {
        return this._droppedEventsCount;
    }
    get droppedLinksCount() {
        return this._droppedLinksCount;
    }
    _isSpanEnded() {
        if (this._ended) {
            const e = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
            $1ec05aac0120a3f2$var$yn.warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, e);
        }
        return this._ended;
    }
    _truncateToLimitUtil(e, t) {
        return e.length <= t ? e : e.substring(0, t);
    }
    _truncateToSize(e) {
        const t = this._attributeValueLengthLimit;
        return t <= 0 ? ($1ec05aac0120a3f2$var$yn.warn(`Attribute value limit must be positive, got ${t}`), e) : "string" == typeof e ? this._truncateToLimitUtil(e, t) : Array.isArray(e) ? e.map((e)=>"string" == typeof e ? this._truncateToLimitUtil(e, t) : e) : e;
    }
}
var $1ec05aac0120a3f2$var$ii;
!function(e) {
    e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
}($1ec05aac0120a3f2$var$ii || ($1ec05aac0120a3f2$var$ii = {}));
let $1ec05aac0120a3f2$var$oi = class {
    shouldSample() {
        return {
            decision: $1ec05aac0120a3f2$var$ii.NOT_RECORD
        };
    }
    toString() {
        return "AlwaysOffSampler";
    }
}, $1ec05aac0120a3f2$var$ai = class {
    shouldSample() {
        return {
            decision: $1ec05aac0120a3f2$var$ii.RECORD_AND_SAMPLED
        };
    }
    toString() {
        return "AlwaysOnSampler";
    }
}, $1ec05aac0120a3f2$var$si = class {
    _root;
    _remoteParentSampled;
    _remoteParentNotSampled;
    _localParentSampled;
    _localParentNotSampled;
    constructor(e){
        this._root = e.root, this._root || ($1ec05aac0120a3f2$var$er(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new $1ec05aac0120a3f2$var$ai), this._remoteParentSampled = e.remoteParentSampled ?? new $1ec05aac0120a3f2$var$ai, this._remoteParentNotSampled = e.remoteParentNotSampled ?? new $1ec05aac0120a3f2$var$oi, this._localParentSampled = e.localParentSampled ?? new $1ec05aac0120a3f2$var$ai, this._localParentNotSampled = e.localParentNotSampled ?? new $1ec05aac0120a3f2$var$oi;
    }
    shouldSample(e, t, n, r, i, o) {
        const a = $1ec05aac0120a3f2$var$Dn.getSpanContext(e);
        return a && $1ec05aac0120a3f2$var$un(a) ? a.isRemote ? a.traceFlags & $1ec05aac0120a3f2$var$Et.SAMPLED ? this._remoteParentSampled.shouldSample(e, t, n, r, i, o) : this._remoteParentNotSampled.shouldSample(e, t, n, r, i, o) : a.traceFlags & $1ec05aac0120a3f2$var$Et.SAMPLED ? this._localParentSampled.shouldSample(e, t, n, r, i, o) : this._localParentNotSampled.shouldSample(e, t, n, r, i, o) : this._root.shouldSample(e, t, n, r, i, o);
    }
    toString() {
        return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
    }
}, $1ec05aac0120a3f2$var$ci = class {
    _ratio;
    _upperBound;
    constructor(e = 0){
        this._ratio = this._normalize(e), this._upperBound = Math.floor(4294967295 * this._ratio);
    }
    shouldSample(e, t) {
        return {
            decision: $1ec05aac0120a3f2$var$cn(t) && this._accumulate(t) < this._upperBound ? $1ec05aac0120a3f2$var$ii.RECORD_AND_SAMPLED : $1ec05aac0120a3f2$var$ii.NOT_RECORD
        };
    }
    toString() {
        return `TraceIdRatioBased{${this._ratio}}`;
    }
    _normalize(e) {
        return "number" != typeof e || isNaN(e) ? 0 : e >= 1 ? 1 : e <= 0 ? 0 : e;
    }
    _accumulate(e) {
        let t = 0;
        for(let n = 0; n < e.length / 8; n++){
            const r = 8 * n;
            t = (t ^ parseInt(e.slice(r, r + 8), 16)) >>> 0;
        }
        return t;
    }
};
var $1ec05aac0120a3f2$var$ui;
!function(e) {
    e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
}($1ec05aac0120a3f2$var$ui || ($1ec05aac0120a3f2$var$ui = {}));
function $1ec05aac0120a3f2$var$li() {
    return {
        sampler: $1ec05aac0120a3f2$var$di(),
        forceFlushTimeoutMillis: 3e4,
        generalLimits: {
            attributeValueLengthLimit: 1 / 0,
            attributeCountLimit: 128
        },
        spanLimits: {
            attributeValueLengthLimit: 1 / 0,
            attributeCountLimit: 128,
            linkCountLimit: 128,
            eventCountLimit: 128,
            attributePerEventCountLimit: 128,
            attributePerLinkCountLimit: 128
        }
    };
}
function $1ec05aac0120a3f2$var$di() {
    const e = $1ec05aac0120a3f2$var$ui.ParentBasedAlwaysOn;
    switch(e){
        case $1ec05aac0120a3f2$var$ui.AlwaysOn:
            return new $1ec05aac0120a3f2$var$ai;
        case $1ec05aac0120a3f2$var$ui.AlwaysOff:
            return new $1ec05aac0120a3f2$var$oi;
        case $1ec05aac0120a3f2$var$ui.ParentBasedAlwaysOn:
            return new $1ec05aac0120a3f2$var$si({
                root: new $1ec05aac0120a3f2$var$ai
            });
        case $1ec05aac0120a3f2$var$ui.ParentBasedAlwaysOff:
            return new $1ec05aac0120a3f2$var$si({
                root: new $1ec05aac0120a3f2$var$oi
            });
        case $1ec05aac0120a3f2$var$ui.TraceIdRatio:
            return new $1ec05aac0120a3f2$var$ci($1ec05aac0120a3f2$var$pi());
        case $1ec05aac0120a3f2$var$ui.ParentBasedTraceIdRatio:
            return new $1ec05aac0120a3f2$var$si({
                root: new $1ec05aac0120a3f2$var$ci($1ec05aac0120a3f2$var$pi())
            });
        default:
            return $1ec05aac0120a3f2$var$yn.error(`OTEL_TRACES_SAMPLER value "${e}" invalid, defaulting to "${$1ec05aac0120a3f2$var$ui.ParentBasedAlwaysOn}".`), new $1ec05aac0120a3f2$var$si({
                root: new $1ec05aac0120a3f2$var$ai
            });
    }
}
function $1ec05aac0120a3f2$var$pi() {
    return $1ec05aac0120a3f2$var$yn.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to 1."), 1;
}
const $1ec05aac0120a3f2$var$fi = 1 / 0;
let $1ec05aac0120a3f2$var$gi = class {
    _maxExportBatchSize;
    _maxQueueSize;
    _scheduledDelayMillis;
    _exportTimeoutMillis;
    _exporter;
    _isExporting = !1;
    _finishedSpans = [];
    _timer;
    _shutdownOnce;
    _droppedSpansCount = 0;
    constructor(e, t){
        this._exporter = e, this._maxExportBatchSize = "number" == typeof t?.maxExportBatchSize ? t.maxExportBatchSize : 512, this._maxQueueSize = "number" == typeof t?.maxQueueSize ? t.maxQueueSize : 2048, this._scheduledDelayMillis = "number" == typeof t?.scheduledDelayMillis ? t.scheduledDelayMillis : 5e3, this._exportTimeoutMillis = "number" == typeof t?.exportTimeoutMillis ? t.exportTimeoutMillis : 3e4, this._shutdownOnce = new $1ec05aac0120a3f2$var$Kr(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && ($1ec05aac0120a3f2$var$yn.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    forceFlush() {
        return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }
    onStart(e, t) {}
    onEnd(e) {
        this._shutdownOnce.isCalled || 0 !== (e.spanContext().traceFlags & $1ec05aac0120a3f2$var$Et.SAMPLED) && this._addToBuffer(e);
    }
    shutdown() {
        return this._shutdownOnce.call();
    }
    _shutdown() {
        return Promise.resolve().then(()=>this.onShutdown()).then(()=>this._flushAll()).then(()=>this._exporter.shutdown());
    }
    _addToBuffer(e) {
        if (this._finishedSpans.length >= this._maxQueueSize) return 0 === this._droppedSpansCount && $1ec05aac0120a3f2$var$yn.debug("maxQueueSize reached, dropping spans"), void this._droppedSpansCount++;
        this._droppedSpansCount > 0 && ($1ec05aac0120a3f2$var$yn.warn(`Dropped ${this._droppedSpansCount} spans because maxQueueSize reached`), this._droppedSpansCount = 0), this._finishedSpans.push(e), this._maybeStartTimer();
    }
    _flushAll() {
        return new Promise((e, t)=>{
            const n = [];
            for(let e = 0, t = Math.ceil(this._finishedSpans.length / this._maxExportBatchSize); e < t; e++)n.push(this._flushOneBatch());
            Promise.all(n).then(()=>{
                e();
            }).catch(t);
        });
    }
    _flushOneBatch() {
        return this._clearTimer(), 0 === this._finishedSpans.length ? Promise.resolve() : new Promise((e, t)=>{
            const n = setTimeout(()=>{
                t(new Error("Timeout"));
            }, this._exportTimeoutMillis);
            $1ec05aac0120a3f2$var$Tn.with($1ec05aac0120a3f2$var$qn($1ec05aac0120a3f2$var$Tn.active()), ()=>{
                let r;
                this._finishedSpans.length <= this._maxExportBatchSize ? (r = this._finishedSpans, this._finishedSpans = []) : r = this._finishedSpans.splice(0, this._maxExportBatchSize);
                const i = ()=>this._exporter.export(r, (r)=>{
                        clearTimeout(n), r.code === $1ec05aac0120a3f2$var$Tr.SUCCESS ? e() : t(r.error ?? new Error("BatchSpanProcessor: span export failed"));
                    });
                let o = null;
                for(let e = 0, t = r.length; e < t; e++){
                    const t = r[e];
                    t.resource.asyncAttributesPending && t.resource.waitForAsyncAttributes && (o ??= [], o.push(t.resource.waitForAsyncAttributes()));
                }
                null === o ? i() : Promise.all(o).then(i, (e)=>{
                    $1ec05aac0120a3f2$var$er(e), t(e);
                });
            });
        });
    }
    _maybeStartTimer() {
        if (this._isExporting) return;
        const e = ()=>{
            this._isExporting = !0, this._flushOneBatch().finally(()=>{
                this._isExporting = !1, this._finishedSpans.length > 0 && (this._clearTimer(), this._maybeStartTimer());
            }).catch((e)=>{
                this._isExporting = !1, $1ec05aac0120a3f2$var$er(e);
            });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize) return e();
        void 0 === this._timer && (this._timer = setTimeout(()=>e(), this._scheduledDelayMillis), "number" != typeof this._timer && this._timer.unref());
    }
    _clearTimer() {
        void 0 !== this._timer && (clearTimeout(this._timer), this._timer = void 0);
    }
};
let $1ec05aac0120a3f2$var$hi = class {
    generateTraceId = $1ec05aac0120a3f2$var$Ai(16);
    generateSpanId = $1ec05aac0120a3f2$var$Ai(8);
};
const $1ec05aac0120a3f2$var$Ei = Array(32);
function $1ec05aac0120a3f2$var$Ai(e) {
    return function() {
        for(let t = 0; t < 2 * e; t++)$1ec05aac0120a3f2$var$Ei[t] = Math.floor(16 * Math.random()) + 48, $1ec05aac0120a3f2$var$Ei[t] >= 58 && ($1ec05aac0120a3f2$var$Ei[t] += 39);
        return String.fromCharCode.apply(null, $1ec05aac0120a3f2$var$Ei.slice(0, 2 * e));
    };
}
let $1ec05aac0120a3f2$var$_i = class {
    _sampler;
    _generalLimits;
    _spanLimits;
    _idGenerator;
    instrumentationScope;
    _resource;
    _spanProcessor;
    constructor(e, t, n, r){
        const i = function(e) {
            const t = {
                sampler: $1ec05aac0120a3f2$var$di()
            }, n = $1ec05aac0120a3f2$var$li(), r = Object.assign({}, n, t, e);
            return r.generalLimits = Object.assign({}, n.generalLimits, e.generalLimits || {}), r.spanLimits = Object.assign({}, n.spanLimits, e.spanLimits || {}), r;
        }(t);
        this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = t.idGenerator || new $1ec05aac0120a3f2$var$hi, this._resource = n, this._spanProcessor = r, this.instrumentationScope = e;
    }
    startSpan(e, t = {}, n = $1ec05aac0120a3f2$var$Tn.active()) {
        t.root && (n = $1ec05aac0120a3f2$var$Dn.deleteSpan(n));
        const r = $1ec05aac0120a3f2$var$Dn.getSpan(n);
        if ($1ec05aac0120a3f2$var$jn(n)) {
            $1ec05aac0120a3f2$var$yn.debug("Instrumentation suppressed, returning Noop Span");
            return $1ec05aac0120a3f2$var$Dn.wrapSpanContext($1ec05aac0120a3f2$var$Yt);
        }
        const i = r?.spanContext(), o = this._idGenerator.generateSpanId();
        let a, s, c;
        i && $1ec05aac0120a3f2$var$Dn.isSpanContextValid(i) ? (s = i.traceId, c = i.traceState, a = i) : s = this._idGenerator.generateTraceId();
        const u = t.kind ?? $1ec05aac0120a3f2$var$gn.INTERNAL, l = (t.links ?? []).map((e)=>({
                context: e.context,
                attributes: $1ec05aac0120a3f2$var$Kn(e.attributes)
            })), d = $1ec05aac0120a3f2$var$Kn(t.attributes), p = this._sampler.shouldSample(n, s, e, u, d, l);
        c = p.traceState ?? c;
        const f = {
            traceId: s,
            spanId: o,
            traceFlags: p.decision === $1ec05aac0120a3f2$var$fn.RECORD_AND_SAMPLED ? $1ec05aac0120a3f2$var$Et.SAMPLED : $1ec05aac0120a3f2$var$Et.NONE,
            traceState: c
        };
        if (p.decision === $1ec05aac0120a3f2$var$fn.NOT_RECORD) {
            $1ec05aac0120a3f2$var$yn.debug("Recording is off, propagating context in a non-recording span");
            return $1ec05aac0120a3f2$var$Dn.wrapSpanContext(f);
        }
        const g = $1ec05aac0120a3f2$var$Kn(Object.assign(d, p.attributes));
        return new $1ec05aac0120a3f2$var$ri({
            resource: this._resource,
            scope: this.instrumentationScope,
            context: n,
            spanContext: f,
            name: e,
            kind: u,
            links: l,
            parentSpanContext: a,
            attributes: g,
            startTime: t.startTime,
            spanProcessor: this._spanProcessor,
            spanLimits: this._spanLimits
        });
    }
    startActiveSpan(e, t, n, r) {
        let i, o, a;
        if (arguments.length < 2) return;
        2 === arguments.length ? a = t : 3 === arguments.length ? (i = t, a = n) : (i = t, o = n, a = r);
        const s = o ?? $1ec05aac0120a3f2$var$Tn.active(), c = this.startSpan(e, i, s), u = $1ec05aac0120a3f2$var$Dn.setSpan(s, c);
        return $1ec05aac0120a3f2$var$Tn.with(u, a, void 0, c);
    }
    getGeneralLimits() {
        return this._generalLimits;
    }
    getSpanLimits() {
        return this._spanLimits;
    }
}, $1ec05aac0120a3f2$var$mi = class {
    _spanProcessors;
    constructor(e){
        this._spanProcessors = e;
    }
    forceFlush() {
        const e = [];
        for (const t of this._spanProcessors)e.push(t.forceFlush());
        return new Promise((t)=>{
            Promise.all(e).then(()=>{
                t();
            }).catch((e)=>{
                $1ec05aac0120a3f2$var$er(e || new Error("MultiSpanProcessor: forceFlush failed")), t();
            });
        });
    }
    onStart(e, t) {
        for (const n of this._spanProcessors)n.onStart(e, t);
    }
    onEnding(e) {
        for (const t of this._spanProcessors)t.onEnding && t.onEnding(e);
    }
    onEnd(e) {
        for (const t of this._spanProcessors)t.onEnd(e);
    }
    shutdown() {
        const e = [];
        for (const t of this._spanProcessors)e.push(t.shutdown());
        return new Promise((t, n)=>{
            Promise.all(e).then(()=>{
                t();
            }, n);
        });
    }
};
var $1ec05aac0120a3f2$var$Ti;
!function(e) {
    e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
}($1ec05aac0120a3f2$var$Ti || ($1ec05aac0120a3f2$var$Ti = {}));
let $1ec05aac0120a3f2$var$yi = class {
    _config;
    _tracers = new Map;
    _resource;
    _activeSpanProcessor;
    constructor(e = {}){
        const t = function(...e) {
            let t = e.shift();
            const n = new WeakMap;
            for(; e.length > 0;)t = $1ec05aac0120a3f2$var$zr(t, e.shift(), 0, n);
            return t;
        }({}, $1ec05aac0120a3f2$var$li(), function(e) {
            const t = Object.assign({}, e.spanLimits);
            return t.attributeCountLimit = e.spanLimits?.attributeCountLimit ?? e.generalLimits?.attributeCountLimit ?? void 0 ?? void 0 ?? 128, t.attributeValueLengthLimit = e.spanLimits?.attributeValueLengthLimit ?? e.generalLimits?.attributeValueLengthLimit ?? void 0 ?? void 0 ?? $1ec05aac0120a3f2$var$fi, Object.assign({}, e, {
                spanLimits: t
            });
        }(e));
        this._resource = t.resource ?? $1ec05aac0120a3f2$var$ti(), this._config = Object.assign({}, t, {
            resource: this._resource
        });
        const n = [];
        e.spanProcessors?.length && n.push(...e.spanProcessors), this._activeSpanProcessor = new $1ec05aac0120a3f2$var$mi(n);
    }
    getTracer(e, t, n) {
        const r = `${e}@${t || ""}:${n?.schemaUrl || ""}`;
        return this._tracers.has(r) || this._tracers.set(r, new $1ec05aac0120a3f2$var$_i({
            name: e,
            version: t,
            schemaUrl: n?.schemaUrl
        }, this._config, this._resource, this._activeSpanProcessor)), this._tracers.get(r);
    }
    forceFlush() {
        const e = this._config.forceFlushTimeoutMillis, t = this._activeSpanProcessor._spanProcessors.map((t)=>new Promise((n)=>{
                let r;
                const i = setTimeout(()=>{
                    n(new Error(`Span processor did not completed within timeout period of ${e} ms`)), r = $1ec05aac0120a3f2$var$Ti.timeout;
                }, e);
                t.forceFlush().then(()=>{
                    clearTimeout(i), r !== $1ec05aac0120a3f2$var$Ti.timeout && (r = $1ec05aac0120a3f2$var$Ti.resolved, n(r));
                }).catch((e)=>{
                    clearTimeout(i), r = $1ec05aac0120a3f2$var$Ti.error, n(e);
                });
            }));
        return new Promise((e, n)=>{
            Promise.all(t).then((t)=>{
                const r = t.filter((e)=>e !== $1ec05aac0120a3f2$var$Ti.resolved);
                r.length > 0 ? n(r) : e();
            }).catch((e)=>n([
                    e
                ]));
        });
    }
    shutdown() {
        return this._activeSpanProcessor.shutdown();
    }
};
class $1ec05aac0120a3f2$var$vi {
    _enabled = !1;
    _currentContext = $1ec05aac0120a3f2$var$_t;
    _bindFunction(e = $1ec05aac0120a3f2$var$_t, t) {
        const n = this, r = function(...r) {
            return n.with(e, ()=>t.apply(this, r));
        };
        return Object.defineProperty(r, "length", {
            enumerable: !1,
            configurable: !0,
            writable: !1,
            value: t.length
        }), r;
    }
    active() {
        return this._currentContext;
    }
    bind(e, t) {
        return void 0 === e && (e = this.active()), "function" == typeof t ? this._bindFunction(e, t) : t;
    }
    disable() {
        return this._currentContext = $1ec05aac0120a3f2$var$_t, this._enabled = !1, this;
    }
    enable() {
        return this._enabled || (this._enabled = !0, this._currentContext = $1ec05aac0120a3f2$var$_t), this;
    }
    with(e, t, n, ...r) {
        const i = this._currentContext;
        this._currentContext = e || $1ec05aac0120a3f2$var$_t;
        try {
            return t.call(n, ...r);
        } finally{
            this._currentContext = i;
        }
    }
}
var $1ec05aac0120a3f2$var$bi;
!function(e) {
    e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.START_TIME = "startTime", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
}($1ec05aac0120a3f2$var$bi || ($1ec05aac0120a3f2$var$bi = {}));
let $1ec05aac0120a3f2$var$Ii;
function $1ec05aac0120a3f2$var$Si(e, t) {
    return t in e;
}
function $1ec05aac0120a3f2$var$Oi(e, t, n, r = !0) {
    if ($1ec05aac0120a3f2$var$Si(n, t) && "number" == typeof n[t] && (!r || 0 !== n[t])) return e.addEvent(t, n[t]);
}
function $1ec05aac0120a3f2$var$wi(e) {
    return e.slice().sort((e, t)=>{
        const n = e[$1ec05aac0120a3f2$var$bi.FETCH_START], r = t[$1ec05aac0120a3f2$var$bi.FETCH_START];
        return n > r ? 1 : n < r ? -1 : 0;
    });
}
function $1ec05aac0120a3f2$var$Ri() {
    return "undefined" != typeof location ? location.origin : void 0;
}
function $1ec05aac0120a3f2$var$Li(e) {
    if ("function" == typeof URL) return new URL(e, "undefined" != typeof document ? document.baseURI : "undefined" != typeof location ? location.href : void 0);
    const t = ($1ec05aac0120a3f2$var$Ii || ($1ec05aac0120a3f2$var$Ii = document.createElement("a")), $1ec05aac0120a3f2$var$Ii);
    return t.href = e, t;
}
var $1ec05aac0120a3f2$var$Ci, $1ec05aac0120a3f2$var$Pi = Object.freeze({
    __proto__: null,
    AlwaysOffSampler: $1ec05aac0120a3f2$var$oi,
    AlwaysOnSampler: $1ec05aac0120a3f2$var$ai,
    BasicTracerProvider: $1ec05aac0120a3f2$var$yi,
    BatchSpanProcessor: class extends $1ec05aac0120a3f2$var$gi {
        _visibilityChangeListener;
        _pageHideListener;
        constructor(e, t){
            super(e, t), this.onInit(t);
        }
        onInit(e) {
            !0 !== e?.disableAutoFlushOnDocumentHide && "undefined" != typeof document && (this._visibilityChangeListener = ()=>{
                "hidden" === document.visibilityState && this.forceFlush().catch((e)=>{
                    $1ec05aac0120a3f2$var$er(e);
                });
            }, this._pageHideListener = ()=>{
                this.forceFlush().catch((e)=>{
                    $1ec05aac0120a3f2$var$er(e);
                });
            }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
        }
        onShutdown() {
            "undefined" != typeof document && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
        }
    },
    ConsoleSpanExporter: class {
        export(e, t) {
            return this._sendSpans(e, t);
        }
        shutdown() {
            return this._sendSpans([]), this.forceFlush();
        }
        forceFlush() {
            return Promise.resolve();
        }
        _exportInfo(e) {
            return {
                resource: {
                    attributes: e.resource.attributes
                },
                instrumentationScope: e.instrumentationScope,
                traceId: e.spanContext().traceId,
                parentSpanContext: e.parentSpanContext,
                traceState: e.spanContext().traceState?.serialize(),
                name: e.name,
                id: e.spanContext().spanId,
                kind: e.kind,
                timestamp: $1ec05aac0120a3f2$var$Er(e.startTime),
                duration: $1ec05aac0120a3f2$var$Er(e.duration),
                attributes: e.attributes,
                status: e.status,
                events: e.events,
                links: e.links
            };
        }
        _sendSpans(e, t) {
            for (const t of e)console.dir(this._exportInfo(t), {
                depth: 3
            });
            if (t) return t({
                code: $1ec05aac0120a3f2$var$Tr.SUCCESS
            });
        }
    },
    InMemorySpanExporter: class {
        _finishedSpans = [];
        _stopped = !1;
        export(e, t) {
            if (this._stopped) return t({
                code: $1ec05aac0120a3f2$var$Tr.FAILED,
                error: new Error("Exporter has been stopped")
            });
            this._finishedSpans.push(...e), setTimeout(()=>t({
                    code: $1ec05aac0120a3f2$var$Tr.SUCCESS
                }), 0);
        }
        shutdown() {
            return this._stopped = !0, this._finishedSpans = [], this.forceFlush();
        }
        forceFlush() {
            return Promise.resolve();
        }
        reset() {
            this._finishedSpans = [];
        }
        getFinishedSpans() {
            return this._finishedSpans;
        }
    },
    NoopSpanProcessor: class {
        onStart(e, t) {}
        onEnd(e) {}
        shutdown() {
            return Promise.resolve();
        }
        forceFlush() {
            return Promise.resolve();
        }
    },
    ParentBasedSampler: $1ec05aac0120a3f2$var$si,
    get PerformanceTimingNames () {
        return $1ec05aac0120a3f2$var$bi;
    },
    RandomIdGenerator: $1ec05aac0120a3f2$var$hi,
    get SamplingDecision () {
        return $1ec05aac0120a3f2$var$ii;
    },
    SimpleSpanProcessor: class {
        _exporter;
        _shutdownOnce;
        _pendingExports;
        constructor(e){
            this._exporter = e, this._shutdownOnce = new $1ec05aac0120a3f2$var$Kr(this._shutdown, this), this._pendingExports = new Set;
        }
        async forceFlush() {
            await Promise.all(Array.from(this._pendingExports)), this._exporter.forceFlush && await this._exporter.forceFlush();
        }
        onStart(e, t) {}
        onEnd(e) {
            if (this._shutdownOnce.isCalled) return;
            if (0 === (e.spanContext().traceFlags & $1ec05aac0120a3f2$var$Et.SAMPLED)) return;
            const t = this._doExport(e).catch((e)=>$1ec05aac0120a3f2$var$er(e));
            this._pendingExports.add(t), t.finally(()=>this._pendingExports.delete(t));
        }
        async _doExport(e) {
            e.resource.asyncAttributesPending && await e.resource.waitForAsyncAttributes?.();
            const t = await $1ec05aac0120a3f2$var$Yr._export(this._exporter, [
                e
            ]);
            if (t.code !== $1ec05aac0120a3f2$var$Tr.SUCCESS) throw t.error ?? new Error(`SimpleSpanProcessor: span export failed (status ${t})`);
        }
        shutdown() {
            return this._shutdownOnce.call();
        }
        _shutdown() {
            return this._exporter.shutdown();
        }
    },
    StackContextManager: $1ec05aac0120a3f2$var$vi,
    TraceIdRatioBasedSampler: $1ec05aac0120a3f2$var$ci,
    WebTracerProvider: class extends $1ec05aac0120a3f2$var$yi {
        constructor(e = {}){
            super(e);
        }
        register(e = {}) {
            var t;
            $1ec05aac0120a3f2$var$Dn.setGlobalTracerProvider(this), null !== (t = e.propagator) && (void 0 !== t ? $1ec05aac0120a3f2$var$Mn.setGlobalPropagator(t) : $1ec05aac0120a3f2$var$Mn.setGlobalPropagator(new $1ec05aac0120a3f2$var$yr({
                propagators: [
                    new $1ec05aac0120a3f2$var$Cr,
                    new $1ec05aac0120a3f2$var$Jn
                ]
            }))), function(e) {
                if (null !== e) {
                    if (void 0 === e) {
                        const e = new $1ec05aac0120a3f2$var$vi;
                        return e.enable(), void $1ec05aac0120a3f2$var$Tn.setGlobalContextManager(e);
                    }
                    e.enable(), $1ec05aac0120a3f2$var$Tn.setGlobalContextManager(e);
                }
            }(e.contextManager);
        }
    },
    addSpanNetworkEvent: $1ec05aac0120a3f2$var$Oi,
    addSpanNetworkEvents: function(e, t, n = !1, r, i) {
        if (void 0 === r && (r = 0 !== t[$1ec05aac0120a3f2$var$bi.START_TIME]), n || ($1ec05aac0120a3f2$var$Oi(e, $1ec05aac0120a3f2$var$bi.FETCH_START, t, r), $1ec05aac0120a3f2$var$Oi(e, $1ec05aac0120a3f2$var$bi.DOMAIN_LOOKUP_START, t, r), $1ec05aac0120a3f2$var$Oi(e, $1ec05aac0120a3f2$var$bi.DOMAIN_LOOKUP_END, t, r), $1ec05aac0120a3f2$var$Oi(e, $1ec05aac0120a3f2$var$bi.CONNECT_START, t, r), $1ec05aac0120a3f2$var$Oi(e, $1ec05aac0120a3f2$var$bi.SECURE_CONNECTION_START, t, r), $1ec05aac0120a3f2$var$Oi(e, $1ec05aac0120a3f2$var$bi.CONNECT_END, t, r), $1ec05aac0120a3f2$var$Oi(e, $1ec05aac0120a3f2$var$bi.REQUEST_START, t, r), $1ec05aac0120a3f2$var$Oi(e, $1ec05aac0120a3f2$var$bi.RESPONSE_START, t, r), $1ec05aac0120a3f2$var$Oi(e, $1ec05aac0120a3f2$var$bi.RESPONSE_END, t, r)), !i) {
            const n = t[$1ec05aac0120a3f2$var$bi.ENCODED_BODY_SIZE];
            void 0 !== n && e.setAttribute("http.response_content_length", n);
            const r = t[$1ec05aac0120a3f2$var$bi.DECODED_BODY_SIZE];
            void 0 !== r && n !== r && e.setAttribute("http.response_content_length_uncompressed", r);
        }
    },
    getElementXPath: function e(t, n) {
        if (t.nodeType === Node.DOCUMENT_NODE) return "/";
        const r = function(e, t) {
            const n = e.nodeType, r = function(_e) {
                if (!_e.parentNode) return 0;
                const t = [
                    _e.nodeType
                ];
                _e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
                let n = Array.from(_e.parentNode.childNodes);
                if (n = n.filter((n)=>{
                    const r = n.localName;
                    return t.indexOf(n.nodeType) >= 0 && r === _e.localName;
                }), n.length >= 1) return n.indexOf(_e) + 1;
                return 0;
            }(e);
            let i = "";
            if (n === Node.ELEMENT_NODE) {
                const n = e.getAttribute("id");
                if (t && n) return `//*[@id="${n}"]`;
                i = e.localName;
            } else if (n === Node.TEXT_NODE || n === Node.CDATA_SECTION_NODE) i = "text()";
            else {
                if (n !== Node.COMMENT_NODE) return "";
                i = "comment()";
            }
            if (i && r > 1) return `/${i}[${r}]`;
            return `/${i}`;
        }(t, n);
        if (n && r.indexOf("@id") > 0) return r;
        let i = "";
        return t.parentNode && (i += e(t.parentNode, !1)), i += r, i;
    },
    getResource: function(e, t, n, r, i = new WeakSet, o) {
        const a = $1ec05aac0120a3f2$var$Li(e), s = function(e, t, n, r, i, o) {
            const a = $1ec05aac0120a3f2$var$hr(t), s = $1ec05aac0120a3f2$var$hr(n);
            let c = r.filter((t)=>{
                const n = $1ec05aac0120a3f2$var$hr($1ec05aac0120a3f2$var$gr(t[$1ec05aac0120a3f2$var$bi.FETCH_START])), r = $1ec05aac0120a3f2$var$hr($1ec05aac0120a3f2$var$gr(t[$1ec05aac0120a3f2$var$bi.RESPONSE_END]));
                return t.initiatorType.toLowerCase() === (o || "xmlhttprequest") && t.name === e && n >= a && r <= s;
            });
            c.length > 0 && (c = c.filter((e)=>!i.has(e)));
            return c;
        }(e = a.toString(), t, n, r, i, o);
        if (0 === s.length) return {
            mainRequest: void 0
        };
        if (1 === s.length) return {
            mainRequest: s[0]
        };
        const c = $1ec05aac0120a3f2$var$wi(s);
        if (a.origin !== $1ec05aac0120a3f2$var$Ri() && c.length > 1) {
            let e = c[0], t = function(e, t, n) {
                const r = $1ec05aac0120a3f2$var$hr(n), i = $1ec05aac0120a3f2$var$hr($1ec05aac0120a3f2$var$gr(t));
                let o, a = e[1];
                const s = e.length;
                for(let t = 1; t < s; t++){
                    const n = e[t], s = $1ec05aac0120a3f2$var$hr($1ec05aac0120a3f2$var$gr(n[$1ec05aac0120a3f2$var$bi.FETCH_START])), c = r - $1ec05aac0120a3f2$var$hr($1ec05aac0120a3f2$var$gr(n[$1ec05aac0120a3f2$var$bi.RESPONSE_END]));
                    s >= i && (!o || c < o) && (o = c, a = n);
                }
                return a;
            }(c, e[$1ec05aac0120a3f2$var$bi.RESPONSE_END], n);
            const r = e[$1ec05aac0120a3f2$var$bi.RESPONSE_END];
            return t[$1ec05aac0120a3f2$var$bi.FETCH_START] < r && (t = e, e = void 0), {
                corsPreFlightRequest: e,
                mainRequest: t
            };
        }
        return {
            mainRequest: s[0]
        };
    },
    hasKey: $1ec05aac0120a3f2$var$Si,
    normalizeUrl: function(e) {
        return $1ec05aac0120a3f2$var$Li(e).href;
    },
    parseUrl: $1ec05aac0120a3f2$var$Li,
    shouldPropagateTraceHeaders: function(e, t) {
        let n = t || [];
        return ("string" == typeof n || n instanceof RegExp) && (n = [
            n
        ]), $1ec05aac0120a3f2$var$Li(e).origin === $1ec05aac0120a3f2$var$Ri() || n.some((t)=>{
            var n, r;
            return n = e, "string" == typeof (r = t) ? n === r : !!n.match(r);
        });
    },
    sortResources: $1ec05aac0120a3f2$var$wi
});
function $1ec05aac0120a3f2$var$Bi(e) {
    return "string" != typeof e || 0 === e.length ? {} : e.split(",").map(function(e) {
        return function(e) {
            var t = e.split(";");
            if (!(t.length <= 0)) {
                var n = t.shift();
                if (n) {
                    var r = n.indexOf("=");
                    if (!(r <= 0)) {
                        var i, o = decodeURIComponent(n.substring(0, r).trim()), a = decodeURIComponent(n.substring(r + 1).trim());
                        return t.length > 0 && (i = $1ec05aac0120a3f2$var$ft(t.join(";"))), {
                            key: o,
                            value: a,
                            metadata: i
                        };
                    }
                }
            }
        }(e);
    }).filter(function(e) {
        return void 0 !== e && e.value.length > 0;
    }).reduce(function(e, t) {
        return e[t.key] = t.value, e;
    }, {});
}
!function(e) {
    e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
}($1ec05aac0120a3f2$var$Ci || ($1ec05aac0120a3f2$var$Ci = {}));
var $1ec05aac0120a3f2$var$Ni = [
    "OTEL_SDK_DISABLED"
];
function $1ec05aac0120a3f2$var$Mi(e) {
    return $1ec05aac0120a3f2$var$Ni.indexOf(e) > -1;
}
var $1ec05aac0120a3f2$var$xi = [
    "OTEL_BSP_EXPORT_TIMEOUT",
    "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BSP_MAX_QUEUE_SIZE",
    "OTEL_BSP_SCHEDULE_DELAY",
    "OTEL_BLRP_EXPORT_TIMEOUT",
    "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BLRP_MAX_QUEUE_SIZE",
    "OTEL_BLRP_SCHEDULE_DELAY",
    "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_LINK_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
    "OTEL_EXPORTER_OTLP_TIMEOUT",
    "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
    "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
    "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
    "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function $1ec05aac0120a3f2$var$Di(e) {
    return $1ec05aac0120a3f2$var$xi.indexOf(e) > -1;
}
var $1ec05aac0120a3f2$var$Fi = [
    "OTEL_NO_PATCH_MODULES",
    "OTEL_PROPAGATORS"
];
function $1ec05aac0120a3f2$var$Qi(e) {
    return $1ec05aac0120a3f2$var$Fi.indexOf(e) > -1;
}
var $1ec05aac0120a3f2$var$Ui = 1 / 0, $1ec05aac0120a3f2$var$ki = {
    OTEL_SDK_DISABLED: !1,
    CONTAINER_NAME: "",
    ECS_CONTAINER_METADATA_URI_V4: "",
    ECS_CONTAINER_METADATA_URI: "",
    HOSTNAME: "",
    KUBERNETES_SERVICE_HOST: "",
    NAMESPACE: "",
    OTEL_BSP_EXPORT_TIMEOUT: 3e4,
    OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BSP_MAX_QUEUE_SIZE: 2048,
    OTEL_BSP_SCHEDULE_DELAY: 5e3,
    OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
    OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
    OTEL_BLRP_SCHEDULE_DELAY: 5e3,
    OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
    OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
    OTEL_EXPORTER_JAEGER_ENDPOINT: "",
    OTEL_EXPORTER_JAEGER_PASSWORD: "",
    OTEL_EXPORTER_JAEGER_USER: "",
    OTEL_EXPORTER_OTLP_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_HEADERS: "",
    OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
    OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
    OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
    OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
    OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
    OTEL_LOG_LEVEL: $1ec05aac0120a3f2$var$$e.INFO,
    OTEL_NO_PATCH_MODULES: [],
    OTEL_PROPAGATORS: [
        "tracecontext",
        "baggage"
    ],
    OTEL_RESOURCE_ATTRIBUTES: "",
    OTEL_SERVICE_NAME: "",
    OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: $1ec05aac0120a3f2$var$Ui,
    OTEL_ATTRIBUTE_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: $1ec05aac0120a3f2$var$Ui,
    OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: 128,
    OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: $1ec05aac0120a3f2$var$Ui,
    OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: 128,
    OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_LINK_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: 128,
    OTEL_TRACES_EXPORTER: "",
    OTEL_TRACES_SAMPLER: $1ec05aac0120a3f2$var$Ci.ParentBasedAlwaysOn,
    OTEL_TRACES_SAMPLER_ARG: "",
    OTEL_LOGS_EXPORTER: "",
    OTEL_EXPORTER_OTLP_INSECURE: "",
    OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
    OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
    OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
    OTEL_EXPORTER_OTLP_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
function $1ec05aac0120a3f2$var$Gi(e, t, n) {
    if (void 0 !== n[e]) {
        var r = String(n[e]);
        t[e] = "true" === r.toLowerCase();
    }
}
function $1ec05aac0120a3f2$var$zi(e, t, n, r, i) {
    if (void 0 === r && (r = -1 / 0), void 0 === i && (i = 1 / 0), void 0 !== n[e]) {
        var o = Number(n[e]);
        isNaN(o) || (t[e] = o < r ? r : o > i ? i : o);
    }
}
function $1ec05aac0120a3f2$var$Xi(e, t, n, r) {
    void 0 === r && (r = ",");
    var i = n[e];
    "string" == typeof i && (t[e] = i.split(r).map(function(e) {
        return e.trim();
    }));
}
var $1ec05aac0120a3f2$var$Hi = {
    ALL: $1ec05aac0120a3f2$var$$e.ALL,
    VERBOSE: $1ec05aac0120a3f2$var$$e.VERBOSE,
    DEBUG: $1ec05aac0120a3f2$var$$e.DEBUG,
    INFO: $1ec05aac0120a3f2$var$$e.INFO,
    WARN: $1ec05aac0120a3f2$var$$e.WARN,
    ERROR: $1ec05aac0120a3f2$var$$e.ERROR,
    NONE: $1ec05aac0120a3f2$var$$e.NONE
};
function $1ec05aac0120a3f2$var$qi(e, t, n) {
    var r = n[e];
    if ("string" == typeof r) {
        var i = $1ec05aac0120a3f2$var$Hi[r.toUpperCase()];
        null != i && (t[e] = i);
    }
}
var $1ec05aac0120a3f2$var$ji = "object" == typeof globalThis ? globalThis : "object" == typeof self ? self : "object" == typeof window ? window : "object" == typeof $parcel$global ? $parcel$global : {};
function $1ec05aac0120a3f2$var$Vi() {
    var e = function(e) {
        var t = {};
        for(var n in $1ec05aac0120a3f2$var$ki){
            var r = n;
            if ("OTEL_LOG_LEVEL" === r) $1ec05aac0120a3f2$var$qi(r, t, e);
            else if ($1ec05aac0120a3f2$var$Mi(r)) $1ec05aac0120a3f2$var$Gi(r, t, e);
            else if ($1ec05aac0120a3f2$var$Di(r)) $1ec05aac0120a3f2$var$zi(r, t, e);
            else if ($1ec05aac0120a3f2$var$Qi(r)) $1ec05aac0120a3f2$var$Xi(r, t, e);
            else {
                var i = e[r];
                null != i && (t[r] = String(i));
            }
        }
        return t;
    }($1ec05aac0120a3f2$var$ji);
    return Object.assign({}, $1ec05aac0120a3f2$var$ki, e);
}
var $1ec05aac0120a3f2$var$Ji;
function $1ec05aac0120a3f2$var$Ki(e) {
    return "string" != typeof e || 0 === e.length ? {} : e.split(",").map(function(e) {
        return function(e) {
            var t = e.split(";");
            if (!(t.length <= 0)) {
                var n = t.shift();
                if (n) {
                    var r = n.indexOf("=");
                    if (!(r <= 0)) {
                        var i, o = decodeURIComponent(n.substring(0, r).trim()), a = decodeURIComponent(n.substring(r + 1).trim());
                        return t.length > 0 && (i = $1ec05aac0120a3f2$var$ft(t.join(";"))), {
                            key: o,
                            value: a,
                            metadata: i
                        };
                    }
                }
            }
        }(e);
    }).filter(function(e) {
        return void 0 !== e && e.value.length > 0;
    }).reduce(function(e, t) {
        return e[t.key] = t.value, e;
    }, {});
}
!function(e) {
    e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
}($1ec05aac0120a3f2$var$Ji || ($1ec05aac0120a3f2$var$Ji = {}));
var $1ec05aac0120a3f2$var$Yi = [
    "OTEL_SDK_DISABLED"
];
function $1ec05aac0120a3f2$var$Wi(e) {
    return $1ec05aac0120a3f2$var$Yi.indexOf(e) > -1;
}
var $1ec05aac0120a3f2$var$Zi = [
    "OTEL_BSP_EXPORT_TIMEOUT",
    "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BSP_MAX_QUEUE_SIZE",
    "OTEL_BSP_SCHEDULE_DELAY",
    "OTEL_BLRP_EXPORT_TIMEOUT",
    "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BLRP_MAX_QUEUE_SIZE",
    "OTEL_BLRP_SCHEDULE_DELAY",
    "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_LINK_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
    "OTEL_EXPORTER_OTLP_TIMEOUT",
    "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
    "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
    "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
    "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function $1ec05aac0120a3f2$var$$i(e) {
    return $1ec05aac0120a3f2$var$Zi.indexOf(e) > -1;
}
var $1ec05aac0120a3f2$var$eo = [
    "OTEL_NO_PATCH_MODULES",
    "OTEL_PROPAGATORS"
];
function $1ec05aac0120a3f2$var$to(e) {
    return $1ec05aac0120a3f2$var$eo.indexOf(e) > -1;
}
var $1ec05aac0120a3f2$var$no = 1 / 0, $1ec05aac0120a3f2$var$ro = {
    OTEL_SDK_DISABLED: !1,
    CONTAINER_NAME: "",
    ECS_CONTAINER_METADATA_URI_V4: "",
    ECS_CONTAINER_METADATA_URI: "",
    HOSTNAME: "",
    KUBERNETES_SERVICE_HOST: "",
    NAMESPACE: "",
    OTEL_BSP_EXPORT_TIMEOUT: 3e4,
    OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BSP_MAX_QUEUE_SIZE: 2048,
    OTEL_BSP_SCHEDULE_DELAY: 5e3,
    OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
    OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
    OTEL_BLRP_SCHEDULE_DELAY: 5e3,
    OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
    OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
    OTEL_EXPORTER_JAEGER_ENDPOINT: "",
    OTEL_EXPORTER_JAEGER_PASSWORD: "",
    OTEL_EXPORTER_JAEGER_USER: "",
    OTEL_EXPORTER_OTLP_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_HEADERS: "",
    OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
    OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
    OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
    OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
    OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
    OTEL_LOG_LEVEL: $1ec05aac0120a3f2$var$$e.INFO,
    OTEL_NO_PATCH_MODULES: [],
    OTEL_PROPAGATORS: [
        "tracecontext",
        "baggage"
    ],
    OTEL_RESOURCE_ATTRIBUTES: "",
    OTEL_SERVICE_NAME: "",
    OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: $1ec05aac0120a3f2$var$no,
    OTEL_ATTRIBUTE_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: $1ec05aac0120a3f2$var$no,
    OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: 128,
    OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: $1ec05aac0120a3f2$var$no,
    OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: 128,
    OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_LINK_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: 128,
    OTEL_TRACES_EXPORTER: "",
    OTEL_TRACES_SAMPLER: $1ec05aac0120a3f2$var$Ji.ParentBasedAlwaysOn,
    OTEL_TRACES_SAMPLER_ARG: "",
    OTEL_LOGS_EXPORTER: "",
    OTEL_EXPORTER_OTLP_INSECURE: "",
    OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
    OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
    OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
    OTEL_EXPORTER_OTLP_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
function $1ec05aac0120a3f2$var$io(e, t, n) {
    if (void 0 !== n[e]) {
        var r = String(n[e]);
        t[e] = "true" === r.toLowerCase();
    }
}
function $1ec05aac0120a3f2$var$oo(e, t, n, r, i) {
    if (void 0 === r && (r = -1 / 0), void 0 === i && (i = 1 / 0), void 0 !== n[e]) {
        var o = Number(n[e]);
        isNaN(o) || (t[e] = o < r ? r : o > i ? i : o);
    }
}
function $1ec05aac0120a3f2$var$ao(e, t, n, r) {
    void 0 === r && (r = ",");
    var i = n[e];
    "string" == typeof i && (t[e] = i.split(r).map(function(e) {
        return e.trim();
    }));
}
var $1ec05aac0120a3f2$var$so = {
    ALL: $1ec05aac0120a3f2$var$$e.ALL,
    VERBOSE: $1ec05aac0120a3f2$var$$e.VERBOSE,
    DEBUG: $1ec05aac0120a3f2$var$$e.DEBUG,
    INFO: $1ec05aac0120a3f2$var$$e.INFO,
    WARN: $1ec05aac0120a3f2$var$$e.WARN,
    ERROR: $1ec05aac0120a3f2$var$$e.ERROR,
    NONE: $1ec05aac0120a3f2$var$$e.NONE
};
function $1ec05aac0120a3f2$var$co(e, t, n) {
    var r = n[e];
    if ("string" == typeof r) {
        var i = $1ec05aac0120a3f2$var$so[r.toUpperCase()];
        null != i && (t[e] = i);
    }
}
var $1ec05aac0120a3f2$var$uo, $1ec05aac0120a3f2$var$lo = "object" == typeof globalThis ? globalThis : "object" == typeof self ? self : "object" == typeof window ? window : "object" == typeof $parcel$global ? $parcel$global : {};
function $1ec05aac0120a3f2$var$po() {
    var e = function(e) {
        var t = {};
        for(var n in $1ec05aac0120a3f2$var$ro){
            var r = n;
            if ("OTEL_LOG_LEVEL" === r) $1ec05aac0120a3f2$var$co(r, t, e);
            else if ($1ec05aac0120a3f2$var$Wi(r)) $1ec05aac0120a3f2$var$io(r, t, e);
            else if ($1ec05aac0120a3f2$var$$i(r)) $1ec05aac0120a3f2$var$oo(r, t, e);
            else if ($1ec05aac0120a3f2$var$to(r)) $1ec05aac0120a3f2$var$ao(r, t, e);
            else {
                var i = e[r];
                null != i && (t[r] = String(i));
            }
        }
        return t;
    }($1ec05aac0120a3f2$var$lo);
    return Object.assign({}, $1ec05aac0120a3f2$var$ro, e);
}
!function(e) {
    e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
}($1ec05aac0120a3f2$var$uo || ($1ec05aac0120a3f2$var$uo = {}));
var $1ec05aac0120a3f2$var$fo = function() {
    function e() {
        var e = this;
        this._promise = new Promise(function(t, n) {
            e._resolve = t, e._reject = n;
        });
    }
    return Object.defineProperty(e.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.resolve = function(e) {
        this._resolve(e);
    }, e.prototype.reject = function(e) {
        this._reject(e);
    }, e;
}(), $1ec05aac0120a3f2$var$go = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$ho = function(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
}, $1ec05aac0120a3f2$var$Eo = function() {
    function e(e, t) {
        this._callback = e, this._that = t, this._isCalled = !1, this._deferred = new $1ec05aac0120a3f2$var$fo;
    }
    return Object.defineProperty(e.prototype, "isCalled", {
        get: function() {
            return this._isCalled;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
        get: function() {
            return this._deferred.promise;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.call = function() {
        for(var e, t = this, n = [], r = 0; r < arguments.length; r++)n[r] = arguments[r];
        if (!this._isCalled) {
            this._isCalled = !0;
            try {
                Promise.resolve((e = this._callback).call.apply(e, $1ec05aac0120a3f2$var$ho([
                    this._that
                ], $1ec05aac0120a3f2$var$go(n), !1))).then(function(e) {
                    return t._deferred.resolve(e);
                }, function(e) {
                    return t._deferred.reject(e);
                });
            } catch (e) {
                this._deferred.reject(e);
            }
        }
        return this._deferred.promise;
    }, e;
}(), $1ec05aac0120a3f2$var$Ao = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$_o = 1e4;
function $1ec05aac0120a3f2$var$mo(e) {
    return "number" == typeof e ? e <= 0 ? $1ec05aac0120a3f2$var$To(e, 1e4) : e : function() {
        var e, t = Number(null !== (e = $1ec05aac0120a3f2$var$po().OTEL_EXPORTER_OTLP_TRACES_TIMEOUT) && void 0 !== e ? e : $1ec05aac0120a3f2$var$po().OTEL_EXPORTER_OTLP_TIMEOUT);
        return t <= 0 ? $1ec05aac0120a3f2$var$To(t, $1ec05aac0120a3f2$var$_o) : t;
    }();
}
function $1ec05aac0120a3f2$var$To(e, t) {
    return $1ec05aac0120a3f2$var$yn.warn("Timeout must be greater than 0", e), t;
}
var $1ec05aac0120a3f2$var$yo = function() {
    function e(e) {
        void 0 === e && (e = {}), this._sendingPromises = [], this.url = this.getDefaultUrl(e), "string" == typeof e.hostname && (this.hostname = e.hostname), this.shutdown = this.shutdown.bind(this), this._shutdownOnce = new $1ec05aac0120a3f2$var$Eo(this._shutdown, this), this._concurrencyLimit = "number" == typeof e.concurrencyLimit ? e.concurrencyLimit : 30, this.timeoutMillis = $1ec05aac0120a3f2$var$mo(e.timeoutMillis), this.onInit(e);
    }
    return e.prototype.export = function(e, t) {
        this._shutdownOnce.isCalled ? t({
            code: $1ec05aac0120a3f2$var$uo.FAILED,
            error: new Error("Exporter has been shutdown")
        }) : this._sendingPromises.length >= this._concurrencyLimit ? t({
            code: $1ec05aac0120a3f2$var$uo.FAILED,
            error: new Error("Concurrent export limit reached")
        }) : this._export(e).then(function() {
            t({
                code: $1ec05aac0120a3f2$var$uo.SUCCESS
            });
        }).catch(function(e) {
            t({
                code: $1ec05aac0120a3f2$var$uo.FAILED,
                error: e
            });
        });
    }, e.prototype._export = function(e) {
        var t = this;
        return new Promise(function(n, r) {
            try {
                $1ec05aac0120a3f2$var$yn.debug("items to be sent", e), t.send(e, n, r);
            } catch (e) {
                r(e);
            }
        });
    }, e.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    }, e.prototype.forceFlush = function() {
        return Promise.all(this._sendingPromises).then(function() {});
    }, e.prototype._shutdown = function() {
        return $1ec05aac0120a3f2$var$yn.debug("shutdown started"), this.onShutdown(), this.forceFlush();
    }, e;
}(), $1ec05aac0120a3f2$var$vo = function() {
    var e = function(t, n) {
        return e = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(e, t) {
            e.__proto__ = t;
        } || function(e, t) {
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }, e(t, n);
    };
    return function(t, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
        function r() {
            this.constructor = t;
        }
        e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r);
    };
}(), $1ec05aac0120a3f2$var$bo = function(e) {
    function t(t, n, r) {
        var i = e.call(this, t) || this;
        return i.name = "OTLPExporterError", i.data = r, i.code = n, i;
    }
    return $1ec05aac0120a3f2$var$vo(t, e), t;
}(Error), $1ec05aac0120a3f2$var$Io = function() {
    return $1ec05aac0120a3f2$var$Io = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
    }, $1ec05aac0120a3f2$var$Io.apply(this, arguments);
}, $1ec05aac0120a3f2$var$So = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
};
function $1ec05aac0120a3f2$var$Oo(e, t, n, r, i, o) {
    var a, s, c = !1, u = setTimeout(function() {
        if (clearTimeout(a), c = !0, s.readyState === XMLHttpRequest.DONE) {
            var e = new $1ec05aac0120a3f2$var$bo("Request Timeout");
            o(e);
        } else s.abort();
    }, r), l = function(r, d) {
        void 0 === r && (r = 5), void 0 === d && (d = 1e3), (s = new XMLHttpRequest).open("POST", t);
        Object.entries($1ec05aac0120a3f2$var$Io($1ec05aac0120a3f2$var$Io({}, {
            Accept: "application/json",
            "Content-Type": "application/json"
        }), n)).forEach(function(e) {
            var t = $1ec05aac0120a3f2$var$So(e, 2), n = t[0], r = t[1];
            s.setRequestHeader(n, r);
        }), s.send(e), s.onreadystatechange = function() {
            if (s.readyState === XMLHttpRequest.DONE && !1 === c) {
                if (s.status >= 200 && s.status <= 299) $1ec05aac0120a3f2$var$yn.debug("xhr success", e), i(), clearTimeout(u), clearTimeout(a);
                else if (s.status && (p = s.status, [
                    429,
                    502,
                    503,
                    504
                ].includes(p)) && r > 0) {
                    var t = void 0;
                    d *= 1.5, t = s.getResponseHeader("Retry-After") ? function(e) {
                        if (null == e) return -1;
                        var t = Number.parseInt(e, 10);
                        if (Number.isInteger(t)) return t > 0 ? 1e3 * t : -1;
                        var n = new Date(e).getTime() - Date.now();
                        return n >= 0 ? n : 0;
                    }(s.getResponseHeader("Retry-After")) : Math.round(Math.random() * (5e3 - d) + d), a = setTimeout(function() {
                        l(r - 1, d);
                    }, t);
                } else {
                    var n = new $1ec05aac0120a3f2$var$bo("Failed to export with XHR (status: " + s.status + ")", s.status);
                    o(n), clearTimeout(u), clearTimeout(a);
                }
            }
            var p;
        }, s.onabort = function() {
            if (c) {
                var e = new $1ec05aac0120a3f2$var$bo("Request Timeout");
                o(e);
            }
            clearTimeout(u), clearTimeout(a);
        }, s.onerror = function() {
            if (c) {
                var e = new $1ec05aac0120a3f2$var$bo("Request Timeout");
                o(e);
            }
            clearTimeout(u), clearTimeout(a);
        };
    };
    l();
}
var $1ec05aac0120a3f2$var$wo = function() {
    var e = function(t, n) {
        return e = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(e, t) {
            e.__proto__ = t;
        } || function(e, t) {
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }, e(t, n);
    };
    return function(t, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
        function r() {
            this.constructor = t;
        }
        e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r);
    };
}(), $1ec05aac0120a3f2$var$Ro = function() {
    return $1ec05aac0120a3f2$var$Ro = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
    }, $1ec05aac0120a3f2$var$Ro.apply(this, arguments);
}, $1ec05aac0120a3f2$var$Lo = function(e) {
    function t(t, n, r) {
        void 0 === t && (t = {});
        var i = e.call(this, t) || this;
        return i._useXHR = !1, i._serializer = n, i._contentType = r, i._useXHR = !!t.headers || "function" != typeof navigator.sendBeacon, i._useXHR ? i._headers = Object.assign({}, function(e) {
            void 0 === e && (e = {});
            var t = {};
            return Object.entries(e).forEach(function(e) {
                var n = $1ec05aac0120a3f2$var$Ao(e, 2), r = n[0], i = n[1];
                void 0 !== i ? t[r] = String(i) : $1ec05aac0120a3f2$var$yn.warn('Header "' + r + '" has invalid value (' + i + ") and will be ignored");
            }), t;
        }(t.headers), $1ec05aac0120a3f2$var$Ki($1ec05aac0120a3f2$var$po().OTEL_EXPORTER_OTLP_HEADERS)) : i._headers = {}, i;
    }
    return $1ec05aac0120a3f2$var$wo(t, e), t.prototype.onInit = function() {}, t.prototype.onShutdown = function() {}, t.prototype.send = function(e, t, n) {
        var r, i = this;
        if (this._shutdownOnce.isCalled) $1ec05aac0120a3f2$var$yn.debug("Shutdown already started. Cannot send objects");
        else {
            var o = null !== (r = this._serializer.serializeRequest(e)) && void 0 !== r ? r : new Uint8Array, a = new Promise(function(e, t) {
                i._useXHR ? $1ec05aac0120a3f2$var$Oo(o, i.url, $1ec05aac0120a3f2$var$Ro($1ec05aac0120a3f2$var$Ro({}, i._headers), {
                    "Content-Type": i._contentType
                }), i.timeoutMillis, e, t) : function(e, t, n, r, i) {
                    navigator.sendBeacon(t, new Blob([
                        e
                    ], n)) ? ($1ec05aac0120a3f2$var$yn.debug("sendBeacon - can send", e), r()) : i(new $1ec05aac0120a3f2$var$bo("sendBeacon - cannot send " + e));
                }(o, i.url, {
                    type: i._contentType
                }, e, t);
            }).then(t, n);
            this._sendingPromises.push(a);
            var s = function() {
                var e = i._sendingPromises.indexOf(a);
                i._sendingPromises.splice(e, 1);
            };
            a.then(s, s);
        }
    }, t;
}($1ec05aac0120a3f2$var$yo);
function $1ec05aac0120a3f2$var$Co(e) {
    return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function $1ec05aac0120a3f2$var$Po(e) {
    for(var t = new Uint8Array(e.length / 2), n = 0, r = 0; r < e.length; r += 2){
        var i = $1ec05aac0120a3f2$var$Co(e.charCodeAt(r)), o = $1ec05aac0120a3f2$var$Co(e.charCodeAt(r + 1));
        t[n++] = i << 4 | o;
    }
    return t;
}
var $1ec05aac0120a3f2$var$Bo = Math.pow(10, 9);
function $1ec05aac0120a3f2$var$No(e) {
    var t = BigInt(1e9);
    return BigInt(e[0]) * t + BigInt(e[1]);
}
function $1ec05aac0120a3f2$var$Mo(e) {
    var t, n = $1ec05aac0120a3f2$var$No(e);
    return t = n, {
        low: Number(BigInt.asUintN(32, t)),
        high: Number(BigInt.asUintN(32, t >> BigInt(32)))
    };
}
var $1ec05aac0120a3f2$var$xo = "undefined" != typeof BigInt ? function(e) {
    return $1ec05aac0120a3f2$var$No(e).toString();
} : function(e) {
    return e[0] * $1ec05aac0120a3f2$var$Bo + e[1];
};
function $1ec05aac0120a3f2$var$Do(e) {
    return e;
}
function $1ec05aac0120a3f2$var$Fo(e) {
    if (void 0 !== e) return $1ec05aac0120a3f2$var$Po(e);
}
var $1ec05aac0120a3f2$var$Qo = {
    encodeHrTime: $1ec05aac0120a3f2$var$Mo,
    encodeSpanContext: $1ec05aac0120a3f2$var$Po,
    encodeOptionalSpanContext: $1ec05aac0120a3f2$var$Fo
};
var $1ec05aac0120a3f2$var$Uo = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
};
function $1ec05aac0120a3f2$var$ko(e) {
    return {
        name: e.name,
        version: e.version
    };
}
function $1ec05aac0120a3f2$var$Go(e) {
    return Object.keys(e).map(function(t) {
        return $1ec05aac0120a3f2$var$zo(t, e[t]);
    });
}
function $1ec05aac0120a3f2$var$zo(e, t) {
    return {
        key: e,
        value: $1ec05aac0120a3f2$var$Xo(t)
    };
}
function $1ec05aac0120a3f2$var$Xo(e) {
    var t = typeof e;
    return "string" === t ? {
        stringValue: e
    } : "number" === t ? Number.isInteger(e) ? {
        intValue: e
    } : {
        doubleValue: e
    } : "boolean" === t ? {
        boolValue: e
    } : e instanceof Uint8Array ? {
        bytesValue: e
    } : Array.isArray(e) ? {
        arrayValue: {
            values: e.map($1ec05aac0120a3f2$var$Xo)
        }
    } : "object" === t && null != e ? {
        kvlistValue: {
            values: Object.entries(e).map(function(e) {
                var t = $1ec05aac0120a3f2$var$Uo(e, 2);
                return $1ec05aac0120a3f2$var$zo(t[0], t[1]);
            })
        }
    } : {};
}
function $1ec05aac0120a3f2$var$Ho(e, t) {
    var n, r = e.spanContext(), i = e.status;
    return {
        traceId: t.encodeSpanContext(r.traceId),
        spanId: t.encodeSpanContext(r.spanId),
        parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
        traceState: null === (n = r.traceState) || void 0 === n ? void 0 : n.serialize(),
        name: e.name,
        kind: null == e.kind ? 0 : e.kind + 1,
        startTimeUnixNano: t.encodeHrTime(e.startTime),
        endTimeUnixNano: t.encodeHrTime(e.endTime),
        attributes: $1ec05aac0120a3f2$var$Go(e.attributes),
        droppedAttributesCount: e.droppedAttributesCount,
        events: e.events.map(function(e) {
            return function(e, t) {
                return {
                    attributes: e.attributes ? $1ec05aac0120a3f2$var$Go(e.attributes) : [],
                    name: e.name,
                    timeUnixNano: t.encodeHrTime(e.time),
                    droppedAttributesCount: e.droppedAttributesCount || 0
                };
            }(e, t);
        }),
        droppedEventsCount: e.droppedEventsCount,
        status: {
            code: i.code,
            message: i.message
        },
        links: e.links.map(function(e) {
            return function(e, t) {
                var n;
                return {
                    attributes: e.attributes ? $1ec05aac0120a3f2$var$Go(e.attributes) : [],
                    spanId: t.encodeSpanContext(e.context.spanId),
                    traceId: t.encodeSpanContext(e.context.traceId),
                    traceState: null === (n = e.context.traceState) || void 0 === n ? void 0 : n.serialize(),
                    droppedAttributesCount: e.droppedAttributesCount || 0
                };
            }(e, t);
        }),
        droppedLinksCount: e.droppedLinksCount
    };
}
function $1ec05aac0120a3f2$var$qo(e) {
    return {
        attributes: $1ec05aac0120a3f2$var$Go(e.attributes),
        droppedAttributesCount: 0
    };
}
var $1ec05aac0120a3f2$var$jo = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $1ec05aac0120a3f2$var$Vo = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
};
function $1ec05aac0120a3f2$var$Jo(e, t) {
    var n = function(e) {
        var t, n;
        if (void 0 === e) return $1ec05aac0120a3f2$var$Qo;
        var r = null === (t = e.useLongBits) || void 0 === t || t, i = null !== (n = e.useHex) && void 0 !== n && n;
        return {
            encodeHrTime: r ? $1ec05aac0120a3f2$var$Mo : $1ec05aac0120a3f2$var$xo,
            encodeSpanContext: i ? $1ec05aac0120a3f2$var$Do : $1ec05aac0120a3f2$var$Po,
            encodeOptionalSpanContext: i ? $1ec05aac0120a3f2$var$Do : $1ec05aac0120a3f2$var$Fo
        };
    }(t);
    return {
        resourceSpans: $1ec05aac0120a3f2$var$Ko(e, n)
    };
}
function $1ec05aac0120a3f2$var$Ko(e, t) {
    for(var n = function(e) {
        var t, n, r = new Map;
        try {
            for(var i = $1ec05aac0120a3f2$var$jo(e), o = i.next(); !o.done; o = i.next()){
                var a = o.value, s = r.get(a.resource);
                s || (s = new Map, r.set(a.resource, s));
                var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), u = s.get(c);
                u || (u = [], s.set(c, u)), u.push(a);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                o && !o.done && (n = i.return) && n.call(i);
            } finally{
                if (t) throw t.error;
            }
        }
        return r;
    }(e), r = [], i = n.entries(), o = i.next(); !o.done;){
        for(var a = $1ec05aac0120a3f2$var$Vo(o.value, 2), s = a[0], c = [], u = a[1].values(), l = u.next(); !l.done;){
            var d = l.value;
            if (d.length > 0) {
                var p = d.map(function(e) {
                    return $1ec05aac0120a3f2$var$Ho(e, t);
                });
                c.push({
                    scope: $1ec05aac0120a3f2$var$ko(d[0].instrumentationLibrary),
                    spans: p,
                    schemaUrl: d[0].instrumentationLibrary.schemaUrl
                });
            }
            l = u.next();
        }
        var f = {
            resource: $1ec05aac0120a3f2$var$qo(s),
            scopeSpans: c,
            schemaUrl: void 0
        };
        r.push(f), o = i.next();
    }
    return r;
}
var $1ec05aac0120a3f2$var$Yo = {
    serializeRequest: function(e) {
        var t = $1ec05aac0120a3f2$var$Jo(e, {
            useHex: !0,
            useLongBits: !1
        });
        return (new TextEncoder).encode(JSON.stringify(t));
    },
    deserializeResponse: function(e) {
        var t = new TextDecoder;
        return JSON.parse(t.decode(e));
    }
}, $1ec05aac0120a3f2$var$Wo = function() {
    var e = function(t, n) {
        return e = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(e, t) {
            e.__proto__ = t;
        } || function(e, t) {
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }, e(t, n);
    };
    return function(t, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
        function r() {
            this.constructor = t;
        }
        e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r);
    };
}(), $1ec05aac0120a3f2$var$Zo = "v1/traces", $1ec05aac0120a3f2$var$$o = "http://localhost:4318/" + $1ec05aac0120a3f2$var$Zo, $1ec05aac0120a3f2$var$ea = function(e) {
    function t(t) {
        void 0 === t && (t = {});
        var n = e.call(this, t, $1ec05aac0120a3f2$var$Yo, "application/json") || this;
        return n._headers = Object.assign(n._headers, $1ec05aac0120a3f2$var$Bi($1ec05aac0120a3f2$var$Vi().OTEL_EXPORTER_OTLP_TRACES_HEADERS)), n;
    }
    return $1ec05aac0120a3f2$var$Wo(t, e), t.prototype.getDefaultUrl = function(e) {
        var t, n;
        return "string" == typeof e.url ? e.url : $1ec05aac0120a3f2$var$Vi().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT.length > 0 ? function(e) {
            try {
                var t = new URL(e);
                return "" === t.pathname && (t.pathname = t.pathname + "/"), t.toString();
            } catch (t) {
                return $1ec05aac0120a3f2$var$yn.warn("Could not parse export URL: '" + e + "'"), e;
            }
        }($1ec05aac0120a3f2$var$Vi().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT) : $1ec05aac0120a3f2$var$Vi().OTEL_EXPORTER_OTLP_ENDPOINT.length > 0 ? (t = $1ec05aac0120a3f2$var$Vi().OTEL_EXPORTER_OTLP_ENDPOINT, n = $1ec05aac0120a3f2$var$Zo, t.endsWith("/") || (t += "/"), t + n) : $1ec05aac0120a3f2$var$$o;
    }, t;
}($1ec05aac0120a3f2$var$Lo), $1ec05aac0120a3f2$var$ta = Object.freeze({
    __proto__: null,
    OTLPTraceExporter: $1ec05aac0120a3f2$var$ea
}), $1ec05aac0120a3f2$var$na = $1ec05aac0120a3f2$var$gt("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function $1ec05aac0120a3f2$var$ra(e) {
    return e.setValue($1ec05aac0120a3f2$var$na, !0);
}
function $1ec05aac0120a3f2$var$ia(e) {
    return !0 === e.getValue($1ec05aac0120a3f2$var$na);
}
var $1ec05aac0120a3f2$var$oa = "baggage", $1ec05aac0120a3f2$var$aa = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
};
var $1ec05aac0120a3f2$var$sa = function() {
    function e() {}
    return e.prototype.inject = function(e, t, n) {
        var r = $1ec05aac0120a3f2$var$Mn.getBaggage(e);
        if (r && !$1ec05aac0120a3f2$var$ia(e)) {
            var i = (function(e) {
                return e.getAllEntries().map(function(e) {
                    var t = $1ec05aac0120a3f2$var$aa(e, 2), n = t[0], r = t[1], i = encodeURIComponent(n) + "=" + encodeURIComponent(r.value);
                    return void 0 !== r.metadata && (i += ";" + r.metadata.toString()), i;
                });
            })(r).filter(function(e) {
                return e.length <= 4096;
            }).slice(0, 180), o = function(e) {
                return e.reduce(function(e, t) {
                    var n = e + ("" !== e ? "," : "") + t;
                    return n.length > 8192 ? e : n;
                }, "");
            }(i);
            o.length > 0 && n.set(t, $1ec05aac0120a3f2$var$oa, o);
        }
    }, e.prototype.extract = function(e, t, n) {
        var r = n.get(t, $1ec05aac0120a3f2$var$oa), i = Array.isArray(r) ? r.join(",") : r;
        if (!i) return e;
        var o = {};
        return 0 === i.length ? e : (i.split(",").forEach(function(e) {
            var t = function(e) {
                var t = e.split(";");
                if (!(t.length <= 0)) {
                    var n = t.shift();
                    if (n) {
                        var r = n.indexOf("=");
                        if (!(r <= 0)) {
                            var i, o = decodeURIComponent(n.substring(0, r).trim()), a = decodeURIComponent(n.substring(r + 1).trim());
                            return t.length > 0 && (i = $1ec05aac0120a3f2$var$ft(t.join(";"))), {
                                key: o,
                                value: a,
                                metadata: i
                            };
                        }
                    }
                }
            }(e);
            if (t) {
                var n = {
                    value: t.value
                };
                t.metadata && (n.metadata = t.metadata), o[t.key] = n;
            }
        }), 0 === Object.entries(o).length ? e : $1ec05aac0120a3f2$var$Mn.setBaggage(e, $1ec05aac0120a3f2$var$Mn.createBaggage(o)));
    }, e.prototype.fields = function() {
        return [
            $1ec05aac0120a3f2$var$oa
        ];
    }, e;
}(), $1ec05aac0120a3f2$var$ca = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $1ec05aac0120a3f2$var$ua = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
};
function $1ec05aac0120a3f2$var$la(e) {
    var t, n, r = {};
    if ("object" != typeof e || null == e) return r;
    try {
        for(var i = $1ec05aac0120a3f2$var$ca(Object.entries(e)), o = i.next(); !o.done; o = i.next()){
            var a = $1ec05aac0120a3f2$var$ua(o.value, 2), s = a[0], c = a[1];
            $1ec05aac0120a3f2$var$da(s) ? $1ec05aac0120a3f2$var$pa(c) ? Array.isArray(c) ? r[s] = c.slice() : r[s] = c : $1ec05aac0120a3f2$var$yn.warn("Invalid attribute value set for key: " + s) : $1ec05aac0120a3f2$var$yn.warn("Invalid attribute key: " + s);
        }
    } catch (e) {
        t = {
            error: e
        };
    } finally{
        try {
            o && !o.done && (n = i.return) && n.call(i);
        } finally{
            if (t) throw t.error;
        }
    }
    return r;
}
function $1ec05aac0120a3f2$var$da(e) {
    return "string" == typeof e && e.length > 0;
}
function $1ec05aac0120a3f2$var$pa(e) {
    return null == e || (Array.isArray(e) ? function(e) {
        var t, n, r;
        try {
            for(var i = $1ec05aac0120a3f2$var$ca(e), o = i.next(); !o.done; o = i.next()){
                var a = o.value;
                if (null != a) {
                    if (!r) {
                        if ($1ec05aac0120a3f2$var$fa(a)) {
                            r = typeof a;
                            continue;
                        }
                        return !1;
                    }
                    if (typeof a !== r) return !1;
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                o && !o.done && (n = i.return) && n.call(i);
            } finally{
                if (t) throw t.error;
            }
        }
        return !0;
    }(e) : $1ec05aac0120a3f2$var$fa(e));
}
function $1ec05aac0120a3f2$var$fa(e) {
    switch(typeof e){
        case "number":
        case "boolean":
        case "string":
            return !0;
    }
    return !1;
}
var $1ec05aac0120a3f2$var$ga, $1ec05aac0120a3f2$var$ha = function(e) {
    $1ec05aac0120a3f2$var$yn.error(function(e) {
        return "string" == typeof e ? e : JSON.stringify(function(e) {
            for(var t = {}, n = e; null !== n;)Object.getOwnPropertyNames(n).forEach(function(e) {
                if (!t[e]) {
                    var r = n[e];
                    r && (t[e] = String(r));
                }
            }), n = Object.getPrototypeOf(n);
            return t;
        }(e));
    }(e));
};
function $1ec05aac0120a3f2$var$Ea(e) {
    try {
        $1ec05aac0120a3f2$var$ha(e);
    } catch (e) {}
}
!function(e) {
    e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
}($1ec05aac0120a3f2$var$ga || ($1ec05aac0120a3f2$var$ga = {}));
var $1ec05aac0120a3f2$var$Aa = [
    "OTEL_SDK_DISABLED"
];
function $1ec05aac0120a3f2$var$_a(e) {
    return $1ec05aac0120a3f2$var$Aa.indexOf(e) > -1;
}
var $1ec05aac0120a3f2$var$ma = [
    "OTEL_BSP_EXPORT_TIMEOUT",
    "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BSP_MAX_QUEUE_SIZE",
    "OTEL_BSP_SCHEDULE_DELAY",
    "OTEL_BLRP_EXPORT_TIMEOUT",
    "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BLRP_MAX_QUEUE_SIZE",
    "OTEL_BLRP_SCHEDULE_DELAY",
    "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_LINK_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
    "OTEL_EXPORTER_OTLP_TIMEOUT",
    "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
    "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
    "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
    "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function $1ec05aac0120a3f2$var$Ta(e) {
    return $1ec05aac0120a3f2$var$ma.indexOf(e) > -1;
}
var $1ec05aac0120a3f2$var$ya = [
    "OTEL_NO_PATCH_MODULES",
    "OTEL_PROPAGATORS",
    "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function $1ec05aac0120a3f2$var$va(e) {
    return $1ec05aac0120a3f2$var$ya.indexOf(e) > -1;
}
var $1ec05aac0120a3f2$var$ba = 1 / 0, $1ec05aac0120a3f2$var$Ia = 128, $1ec05aac0120a3f2$var$Sa = {
    OTEL_SDK_DISABLED: !1,
    CONTAINER_NAME: "",
    ECS_CONTAINER_METADATA_URI_V4: "",
    ECS_CONTAINER_METADATA_URI: "",
    HOSTNAME: "",
    KUBERNETES_SERVICE_HOST: "",
    NAMESPACE: "",
    OTEL_BSP_EXPORT_TIMEOUT: 3e4,
    OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BSP_MAX_QUEUE_SIZE: 2048,
    OTEL_BSP_SCHEDULE_DELAY: 5e3,
    OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
    OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
    OTEL_BLRP_SCHEDULE_DELAY: 5e3,
    OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
    OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
    OTEL_EXPORTER_JAEGER_ENDPOINT: "",
    OTEL_EXPORTER_JAEGER_PASSWORD: "",
    OTEL_EXPORTER_JAEGER_USER: "",
    OTEL_EXPORTER_OTLP_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_HEADERS: "",
    OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
    OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
    OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
    OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
    OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
    OTEL_LOG_LEVEL: $1ec05aac0120a3f2$var$$e.INFO,
    OTEL_NO_PATCH_MODULES: [],
    OTEL_PROPAGATORS: [
        "tracecontext",
        "baggage"
    ],
    OTEL_RESOURCE_ATTRIBUTES: "",
    OTEL_SERVICE_NAME: "",
    OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: $1ec05aac0120a3f2$var$ba,
    OTEL_ATTRIBUTE_COUNT_LIMIT: $1ec05aac0120a3f2$var$Ia,
    OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: $1ec05aac0120a3f2$var$ba,
    OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: $1ec05aac0120a3f2$var$Ia,
    OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: $1ec05aac0120a3f2$var$ba,
    OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: $1ec05aac0120a3f2$var$Ia,
    OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_LINK_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: 128,
    OTEL_TRACES_EXPORTER: "",
    OTEL_TRACES_SAMPLER: $1ec05aac0120a3f2$var$ga.ParentBasedAlwaysOn,
    OTEL_TRACES_SAMPLER_ARG: "",
    OTEL_LOGS_EXPORTER: "",
    OTEL_EXPORTER_OTLP_INSECURE: "",
    OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
    OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
    OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
    OTEL_EXPORTER_OTLP_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
    OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function $1ec05aac0120a3f2$var$Oa(e, t, n) {
    if (void 0 !== n[e]) {
        var r = String(n[e]);
        t[e] = "true" === r.toLowerCase();
    }
}
function $1ec05aac0120a3f2$var$wa(e, t, n, r, i) {
    if (void 0 === r && (r = -1 / 0), void 0 === i && (i = 1 / 0), void 0 !== n[e]) {
        var o = Number(n[e]);
        isNaN(o) || (t[e] = o < r ? r : o > i ? i : o);
    }
}
function $1ec05aac0120a3f2$var$Ra(e, t, n, r) {
    void 0 === r && (r = ",");
    var i = n[e];
    "string" == typeof i && (t[e] = i.split(r).map(function(e) {
        return e.trim();
    }));
}
var $1ec05aac0120a3f2$var$La = {
    ALL: $1ec05aac0120a3f2$var$$e.ALL,
    VERBOSE: $1ec05aac0120a3f2$var$$e.VERBOSE,
    DEBUG: $1ec05aac0120a3f2$var$$e.DEBUG,
    INFO: $1ec05aac0120a3f2$var$$e.INFO,
    WARN: $1ec05aac0120a3f2$var$$e.WARN,
    ERROR: $1ec05aac0120a3f2$var$$e.ERROR,
    NONE: $1ec05aac0120a3f2$var$$e.NONE
};
function $1ec05aac0120a3f2$var$Ca(e, t, n) {
    var r = n[e];
    if ("string" == typeof r) {
        var i = $1ec05aac0120a3f2$var$La[r.toUpperCase()];
        null != i && (t[e] = i);
    }
}
function $1ec05aac0120a3f2$var$Pa(e) {
    var t = {};
    for(var n in $1ec05aac0120a3f2$var$Sa){
        var r = n;
        if ("OTEL_LOG_LEVEL" === r) $1ec05aac0120a3f2$var$Ca(r, t, e);
        else if ($1ec05aac0120a3f2$var$_a(r)) $1ec05aac0120a3f2$var$Oa(r, t, e);
        else if ($1ec05aac0120a3f2$var$Ta(r)) $1ec05aac0120a3f2$var$wa(r, t, e);
        else if ($1ec05aac0120a3f2$var$va(r)) $1ec05aac0120a3f2$var$Ra(r, t, e);
        else {
            var i = e[r];
            null != i && (t[r] = String(i));
        }
    }
    return t;
}
var $1ec05aac0120a3f2$var$Ba = "object" == typeof globalThis ? globalThis : "object" == typeof self ? self : "object" == typeof window ? window : "object" == typeof $parcel$global ? $parcel$global : {};
function $1ec05aac0120a3f2$var$Na() {
    var e = $1ec05aac0120a3f2$var$Pa($1ec05aac0120a3f2$var$Ba);
    return Object.assign({}, $1ec05aac0120a3f2$var$Sa, e);
}
var $1ec05aac0120a3f2$var$Ma, $1ec05aac0120a3f2$var$xa = performance, $1ec05aac0120a3f2$var$Da = "exception.type", $1ec05aac0120a3f2$var$Fa = "exception.message", $1ec05aac0120a3f2$var$Qa = "telemetry.sdk.name", $1ec05aac0120a3f2$var$Ua = "telemetry.sdk.language", $1ec05aac0120a3f2$var$ka = "telemetry.sdk.version", $1ec05aac0120a3f2$var$Ga = (($1ec05aac0120a3f2$var$Ma = {})[$1ec05aac0120a3f2$var$Qa] = "opentelemetry", $1ec05aac0120a3f2$var$Ma["process.runtime.name"] = "browser", $1ec05aac0120a3f2$var$Ma[$1ec05aac0120a3f2$var$Ua] = "webjs", $1ec05aac0120a3f2$var$Ma[$1ec05aac0120a3f2$var$ka] = "1.30.1", $1ec05aac0120a3f2$var$Ma);
var $1ec05aac0120a3f2$var$za, $1ec05aac0120a3f2$var$Xa = Math.pow(10, 6), $1ec05aac0120a3f2$var$Ha = Math.pow(10, 9);
function $1ec05aac0120a3f2$var$qa(e) {
    var t = e / 1e3;
    return [
        Math.trunc(t),
        Math.round(e % 1e3 * $1ec05aac0120a3f2$var$Xa)
    ];
}
function $1ec05aac0120a3f2$var$ja() {
    var e = $1ec05aac0120a3f2$var$xa.timeOrigin;
    if ("number" != typeof e) {
        var t = $1ec05aac0120a3f2$var$xa;
        e = t.timing && t.timing.fetchStart;
    }
    return e;
}
function $1ec05aac0120a3f2$var$Va(e) {
    return 1e6 * e[0] + e[1] / 1e3;
}
function $1ec05aac0120a3f2$var$Ja(e) {
    return Array.isArray(e) && 2 === e.length && "number" == typeof e[0] && "number" == typeof e[1];
}
function $1ec05aac0120a3f2$var$Ka(e) {
    return $1ec05aac0120a3f2$var$Ja(e) || "number" == typeof e || e instanceof Date;
}
function $1ec05aac0120a3f2$var$Ya(e, t) {
    var n = [
        e[0] + t[0],
        e[1] + t[1]
    ];
    return n[1] >= $1ec05aac0120a3f2$var$Ha && (n[1] -= $1ec05aac0120a3f2$var$Ha, n[0] += 1), n;
}
!function(e) {
    e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
}($1ec05aac0120a3f2$var$za || ($1ec05aac0120a3f2$var$za = {}));
var $1ec05aac0120a3f2$var$Wa = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $1ec05aac0120a3f2$var$Za = function() {
    function e(e) {
        var t;
        void 0 === e && (e = {}), this._propagators = null !== (t = e.propagators) && void 0 !== t ? t : [], this._fields = Array.from(new Set(this._propagators.map(function(e) {
            return "function" == typeof e.fields ? e.fields() : [];
        }).reduce(function(e, t) {
            return e.concat(t);
        }, [])));
    }
    return e.prototype.inject = function(e, t, n) {
        var r, i;
        try {
            for(var o = $1ec05aac0120a3f2$var$Wa(this._propagators), a = o.next(); !a.done; a = o.next()){
                var s = a.value;
                try {
                    s.inject(e, t, n);
                } catch (e) {
                    $1ec05aac0120a3f2$var$yn.warn("Failed to inject with " + s.constructor.name + ". Err: " + e.message);
                }
            }
        } catch (e) {
            r = {
                error: e
            };
        } finally{
            try {
                a && !a.done && (i = o.return) && i.call(o);
            } finally{
                if (r) throw r.error;
            }
        }
    }, e.prototype.extract = function(e, t, n) {
        return this._propagators.reduce(function(e, r) {
            try {
                return r.extract(e, t, n);
            } catch (e) {
                $1ec05aac0120a3f2$var$yn.warn("Failed to extract with " + r.constructor.name + ". Err: " + e.message);
            }
            return e;
        }, e);
    }, e.prototype.fields = function() {
        return this._fields.slice();
    }, e;
}(), $1ec05aac0120a3f2$var$$a = "[_0-9a-z-*/]", $1ec05aac0120a3f2$var$es = new RegExp("^(?:" + ("[a-z]" + $1ec05aac0120a3f2$var$$a + "{0,255}") + "|" + ("[a-z0-9]" + $1ec05aac0120a3f2$var$$a + "{0,240}@[a-z]" + $1ec05aac0120a3f2$var$$a + "{0,13}") + ")$"), $1ec05aac0120a3f2$var$ts = /^[ -~]{0,255}[!-~]$/, $1ec05aac0120a3f2$var$ns = /,|=/;
var $1ec05aac0120a3f2$var$rs = function() {
    function e(e) {
        this._internalState = new Map, e && this._parse(e);
    }
    return e.prototype.set = function(e, t) {
        var n = this._clone();
        return n._internalState.has(e) && n._internalState.delete(e), n._internalState.set(e, t), n;
    }, e.prototype.unset = function(e) {
        var t = this._clone();
        return t._internalState.delete(e), t;
    }, e.prototype.get = function(e) {
        return this._internalState.get(e);
    }, e.prototype.serialize = function() {
        var e = this;
        return this._keys().reduce(function(t, n) {
            return t.push(n + "=" + e.get(n)), t;
        }, []).join(",");
    }, e.prototype._parse = function(e) {
        e.length > 512 || (this._internalState = e.split(",").reverse().reduce(function(e, t) {
            var n = t.trim(), r = n.indexOf("=");
            if (-1 !== r) {
                var i = n.slice(0, r), o = n.slice(r + 1, t.length);
                (function(e) {
                    return $1ec05aac0120a3f2$var$es.test(e);
                })(i) && function(e) {
                    return $1ec05aac0120a3f2$var$ts.test(e) && !$1ec05aac0120a3f2$var$ns.test(e);
                }(o) && e.set(i, o);
            }
            return e;
        }, new Map), this._internalState.size > 32 && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, 32))));
    }, e.prototype._keys = function() {
        return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
        var t = new e;
        return t._internalState = new Map(this._internalState), t;
    }, e;
}(), $1ec05aac0120a3f2$var$is = "traceparent", $1ec05aac0120a3f2$var$os = "tracestate", $1ec05aac0120a3f2$var$as = new RegExp("^\\s?((?!ff)[\\da-f]{2})-((?![0]{32})[\\da-f]{32})-((?![0]{16})[\\da-f]{16})-([\\da-f]{2})(-.*)?\\s?$");
var $1ec05aac0120a3f2$var$ss, $1ec05aac0120a3f2$var$cs, $1ec05aac0120a3f2$var$us = function() {
    function e() {}
    return e.prototype.inject = function(e, t, n) {
        var r = $1ec05aac0120a3f2$var$Dn.getSpanContext(e);
        if (r && !$1ec05aac0120a3f2$var$ia(e) && $1ec05aac0120a3f2$var$un(r)) {
            var i = "00-" + r.traceId + "-" + r.spanId + "-0" + Number(r.traceFlags || $1ec05aac0120a3f2$var$Et.NONE).toString(16);
            n.set(t, $1ec05aac0120a3f2$var$is, i), r.traceState && n.set(t, $1ec05aac0120a3f2$var$os, r.traceState.serialize());
        }
    }, e.prototype.extract = function(e, t, n) {
        var r = n.get(t, $1ec05aac0120a3f2$var$is);
        if (!r) return e;
        var i = Array.isArray(r) ? r[0] : r;
        if ("string" != typeof i) return e;
        var o = function(e) {
            var t = $1ec05aac0120a3f2$var$as.exec(e);
            return t ? "00" === t[1] && t[5] ? null : {
                traceId: t[2],
                spanId: t[3],
                traceFlags: parseInt(t[4], 16)
            } : null;
        }(i);
        if (!o) return e;
        o.isRemote = !0;
        var a = n.get(t, $1ec05aac0120a3f2$var$os);
        if (a) {
            var s = Array.isArray(a) ? a.join(",") : a;
            o.traceState = new $1ec05aac0120a3f2$var$rs("string" == typeof s ? s : void 0);
        }
        return $1ec05aac0120a3f2$var$Dn.setSpanContext(e, o);
    }, e.prototype.fields = function() {
        return [
            $1ec05aac0120a3f2$var$is,
            $1ec05aac0120a3f2$var$os
        ];
    }, e;
}(), $1ec05aac0120a3f2$var$ls = "[object Null]", $1ec05aac0120a3f2$var$ds = "[object Undefined]", $1ec05aac0120a3f2$var$ps = Function.prototype.toString, $1ec05aac0120a3f2$var$fs = $1ec05aac0120a3f2$var$ps.call(Object), $1ec05aac0120a3f2$var$gs = ($1ec05aac0120a3f2$var$ss = Object.getPrototypeOf, $1ec05aac0120a3f2$var$cs = Object, function(e) {
    return $1ec05aac0120a3f2$var$ss($1ec05aac0120a3f2$var$cs(e));
}), $1ec05aac0120a3f2$var$hs = Object.prototype, $1ec05aac0120a3f2$var$Es = $1ec05aac0120a3f2$var$hs.hasOwnProperty, $1ec05aac0120a3f2$var$As = Symbol ? Symbol.toStringTag : void 0, $1ec05aac0120a3f2$var$_s = $1ec05aac0120a3f2$var$hs.toString;
function $1ec05aac0120a3f2$var$ms(e) {
    if (!function(e) {
        return null != e && "object" == typeof e;
    }(e) || "[object Object]" !== function(e) {
        if (null == e) return void 0 === e ? $1ec05aac0120a3f2$var$ds : $1ec05aac0120a3f2$var$ls;
        return $1ec05aac0120a3f2$var$As && $1ec05aac0120a3f2$var$As in Object(e) ? function(e) {
            var t = $1ec05aac0120a3f2$var$Es.call(e, $1ec05aac0120a3f2$var$As), n = e[$1ec05aac0120a3f2$var$As], r = !1;
            try {
                e[$1ec05aac0120a3f2$var$As] = void 0, r = !0;
            } catch (e) {}
            var i = $1ec05aac0120a3f2$var$_s.call(e);
            r && (t ? e[$1ec05aac0120a3f2$var$As] = n : delete e[$1ec05aac0120a3f2$var$As]);
            return i;
        }(e) : function(e) {
            return $1ec05aac0120a3f2$var$_s.call(e);
        }(e);
    }(e)) return !1;
    var t = $1ec05aac0120a3f2$var$gs(e);
    if (null === t) return !0;
    var n = $1ec05aac0120a3f2$var$Es.call(t, "constructor") && t.constructor;
    return "function" == typeof n && n instanceof n && $1ec05aac0120a3f2$var$ps.call(n) === $1ec05aac0120a3f2$var$fs;
}
function $1ec05aac0120a3f2$var$Ts(e) {
    return $1ec05aac0120a3f2$var$bs(e) ? e.slice() : e;
}
function $1ec05aac0120a3f2$var$ys(e, t, n, r) {
    var i;
    if (void 0 === n && (n = 0), !(n > 20)) {
        if (n++, $1ec05aac0120a3f2$var$Os(e) || $1ec05aac0120a3f2$var$Os(t) || $1ec05aac0120a3f2$var$Is(t)) i = $1ec05aac0120a3f2$var$Ts(t);
        else if ($1ec05aac0120a3f2$var$bs(e)) {
            if (i = e.slice(), $1ec05aac0120a3f2$var$bs(t)) for(var o = 0, a = t.length; o < a; o++)i.push($1ec05aac0120a3f2$var$Ts(t[o]));
            else if ($1ec05aac0120a3f2$var$Ss(t)) for(o = 0, a = (s = Object.keys(t)).length; o < a; o++)i[c = s[o]] = $1ec05aac0120a3f2$var$Ts(t[c]);
        } else if ($1ec05aac0120a3f2$var$Ss(e)) {
            if ($1ec05aac0120a3f2$var$Ss(t)) {
                if (!function(e, t) {
                    if (!$1ec05aac0120a3f2$var$ms(e) || !$1ec05aac0120a3f2$var$ms(t)) return !1;
                    return !0;
                }(e, t)) return t;
                i = Object.assign({}, e);
                var s;
                for(o = 0, a = (s = Object.keys(t)).length; o < a; o++){
                    var c, u = t[c = s[o]];
                    if ($1ec05aac0120a3f2$var$Os(u)) void 0 === u ? delete i[c] : i[c] = u;
                    else {
                        var l = i[c], d = u;
                        if ($1ec05aac0120a3f2$var$vs(e, c, r) || $1ec05aac0120a3f2$var$vs(t, c, r)) delete i[c];
                        else {
                            if ($1ec05aac0120a3f2$var$Ss(l) && $1ec05aac0120a3f2$var$Ss(d)) {
                                var p = r.get(l) || [], f = r.get(d) || [];
                                p.push({
                                    obj: e,
                                    key: c
                                }), f.push({
                                    obj: t,
                                    key: c
                                }), r.set(l, p), r.set(d, f);
                            }
                            i[c] = $1ec05aac0120a3f2$var$ys(i[c], u, n, r);
                        }
                    }
                }
            } else i = t;
        }
        return i;
    }
}
function $1ec05aac0120a3f2$var$vs(e, t, n) {
    for(var r = n.get(e[t]) || [], i = 0, o = r.length; i < o; i++){
        var a = r[i];
        if (a.key === t && a.obj === e) return !0;
    }
    return !1;
}
function $1ec05aac0120a3f2$var$bs(e) {
    return Array.isArray(e);
}
function $1ec05aac0120a3f2$var$Is(e) {
    return "function" == typeof e;
}
function $1ec05aac0120a3f2$var$Ss(e) {
    return !$1ec05aac0120a3f2$var$Os(e) && !$1ec05aac0120a3f2$var$bs(e) && !$1ec05aac0120a3f2$var$Is(e) && "object" == typeof e;
}
function $1ec05aac0120a3f2$var$Os(e) {
    return "string" == typeof e || "number" == typeof e || "boolean" == typeof e || void 0 === e || e instanceof Date || e instanceof RegExp || null === e;
}
var $1ec05aac0120a3f2$var$ws = function() {
    function e() {
        var e = this;
        this._promise = new Promise(function(t, n) {
            e._resolve = t, e._reject = n;
        });
    }
    return Object.defineProperty(e.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.resolve = function(e) {
        this._resolve(e);
    }, e.prototype.reject = function(e) {
        this._reject(e);
    }, e;
}(), $1ec05aac0120a3f2$var$Rs = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$Ls = function(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
}, $1ec05aac0120a3f2$var$Cs = function() {
    function e(e, t) {
        this._callback = e, this._that = t, this._isCalled = !1, this._deferred = new $1ec05aac0120a3f2$var$ws;
    }
    return Object.defineProperty(e.prototype, "isCalled", {
        get: function() {
            return this._isCalled;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
        get: function() {
            return this._deferred.promise;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.call = function() {
        for(var e, t = this, n = [], r = 0; r < arguments.length; r++)n[r] = arguments[r];
        if (!this._isCalled) {
            this._isCalled = !0;
            try {
                Promise.resolve((e = this._callback).call.apply(e, $1ec05aac0120a3f2$var$Ls([
                    this._that
                ], $1ec05aac0120a3f2$var$Rs(n), !1))).then(function(e) {
                    return t._deferred.resolve(e);
                }, function(e) {
                    return t._deferred.reject(e);
                });
            } catch (e) {
                this._deferred.reject(e);
            }
        }
        return this._deferred.promise;
    }, e;
}();
var $1ec05aac0120a3f2$var$Ps, $1ec05aac0120a3f2$var$Bs = {
    _export: function(e, t) {
        return new Promise(function(n) {
            $1ec05aac0120a3f2$var$Tn.with($1ec05aac0120a3f2$var$ra($1ec05aac0120a3f2$var$Tn.active()), function() {
                e.export(t, function(e) {
                    n(e);
                });
            });
        });
    }
}, $1ec05aac0120a3f2$var$Ns = function() {
    return $1ec05aac0120a3f2$var$Ns = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
    }, $1ec05aac0120a3f2$var$Ns.apply(this, arguments);
}, $1ec05aac0120a3f2$var$Ms = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $1ec05aac0120a3f2$var$xs = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$Ds = function(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
}, $1ec05aac0120a3f2$var$Fs = function() {
    function e(e, t, n, r, i, o, a, s, c, u) {
        void 0 === a && (a = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
            code: $1ec05aac0120a3f2$var$hn.UNSET
        }, this.endTime = [
            0,
            0
        ], this._ended = !1, this._duration = [
            -1,
            -1
        ], this.name = n, this._spanContext = r, this.parentSpanId = o, this.kind = i, this.links = a;
        var l = Date.now();
        this._performanceStartTime = $1ec05aac0120a3f2$var$xa.now(), this._performanceOffset = l - (this._performanceStartTime + $1ec05aac0120a3f2$var$ja()), this._startTimeProvided = null != s, this.startTime = this._getTime(null != s ? s : l), this.resource = e.resource, this.instrumentationLibrary = e.instrumentationLibrary, this._spanLimits = e.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, null != u && this.setAttributes(u), this._spanProcessor = e.getActiveSpanProcessor(), this._spanProcessor.onStart(this, t);
    }
    return e.prototype.spanContext = function() {
        return this._spanContext;
    }, e.prototype.setAttribute = function(e, t) {
        return null == t || this._isSpanEnded() ? this : 0 === e.length ? ($1ec05aac0120a3f2$var$yn.warn("Invalid attribute key: " + e), this) : $1ec05aac0120a3f2$var$pa(t) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, e) ? (this._droppedAttributesCount++, this) : (this.attributes[e] = this._truncateToSize(t), this) : ($1ec05aac0120a3f2$var$yn.warn("Invalid attribute value set for key: " + e), this);
    }, e.prototype.setAttributes = function(e) {
        var t, n;
        try {
            for(var r = $1ec05aac0120a3f2$var$Ms(Object.entries(e)), i = r.next(); !i.done; i = r.next()){
                var o = $1ec05aac0120a3f2$var$xs(i.value, 2), a = o[0], s = o[1];
                this.setAttribute(a, s);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (n = r.return) && n.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
        return this;
    }, e.prototype.addEvent = function(e, t, n) {
        if (this._isSpanEnded()) return this;
        if (0 === this._spanLimits.eventCountLimit) return $1ec05aac0120a3f2$var$yn.warn("No events allowed."), this._droppedEventsCount++, this;
        this.events.length >= this._spanLimits.eventCountLimit && (0 === this._droppedEventsCount && $1ec05aac0120a3f2$var$yn.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), $1ec05aac0120a3f2$var$Ka(t) && ($1ec05aac0120a3f2$var$Ka(n) || (n = t), t = void 0);
        var r = $1ec05aac0120a3f2$var$la(t);
        return this.events.push({
            name: e,
            attributes: r,
            time: this._getTime(n),
            droppedAttributesCount: 0
        }), this;
    }, e.prototype.addLink = function(e) {
        return this.links.push(e), this;
    }, e.prototype.addLinks = function(e) {
        var t;
        return (t = this.links).push.apply(t, $1ec05aac0120a3f2$var$Ds([], $1ec05aac0120a3f2$var$xs(e), !1)), this;
    }, e.prototype.setStatus = function(e) {
        return this._isSpanEnded() || (this.status = $1ec05aac0120a3f2$var$Ns({}, e), null != this.status.message && "string" != typeof e.message && ($1ec05aac0120a3f2$var$yn.warn("Dropping invalid status.message of type '" + typeof e.message + "', expected 'string'"), delete this.status.message)), this;
    }, e.prototype.updateName = function(e) {
        return this._isSpanEnded() || (this.name = e), this;
    }, e.prototype.end = function(e) {
        this._isSpanEnded() ? $1ec05aac0120a3f2$var$yn.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.") : (this._ended = !0, this.endTime = this._getTime(e), this._duration = function(e, t) {
            var n = t[0] - e[0], r = t[1] - e[1];
            return r < 0 && (n -= 1, r += $1ec05aac0120a3f2$var$Ha), [
                n,
                r
            ];
        }(this.startTime, this.endTime), this._duration[0] < 0 && ($1ec05aac0120a3f2$var$yn.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [
            0,
            0
        ]), this._droppedEventsCount > 0 && $1ec05aac0120a3f2$var$yn.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this));
    }, e.prototype._getTime = function(e) {
        if ("number" == typeof e && e <= $1ec05aac0120a3f2$var$xa.now()) return t = e + this._performanceOffset, $1ec05aac0120a3f2$var$Ya($1ec05aac0120a3f2$var$qa($1ec05aac0120a3f2$var$ja()), $1ec05aac0120a3f2$var$qa("number" == typeof t ? t : $1ec05aac0120a3f2$var$xa.now()));
        var t;
        if ("number" == typeof e) return $1ec05aac0120a3f2$var$qa(e);
        if (e instanceof Date) return $1ec05aac0120a3f2$var$qa(e.getTime());
        if ($1ec05aac0120a3f2$var$Ja(e)) return e;
        if (this._startTimeProvided) return $1ec05aac0120a3f2$var$qa(Date.now());
        var n = $1ec05aac0120a3f2$var$xa.now() - this._performanceStartTime;
        return $1ec05aac0120a3f2$var$Ya(this.startTime, $1ec05aac0120a3f2$var$qa(n));
    }, e.prototype.isRecording = function() {
        return !1 === this._ended;
    }, e.prototype.recordException = function(e, t) {
        var n = {};
        "string" == typeof e ? n[$1ec05aac0120a3f2$var$Fa] = e : e && (e.code ? n[$1ec05aac0120a3f2$var$Da] = e.code.toString() : e.name && (n[$1ec05aac0120a3f2$var$Da] = e.name), e.message && (n[$1ec05aac0120a3f2$var$Fa] = e.message), e.stack && (n["exception.stacktrace"] = e.stack)), n[$1ec05aac0120a3f2$var$Da] || n[$1ec05aac0120a3f2$var$Fa] ? this.addEvent("exception", n, t) : $1ec05aac0120a3f2$var$yn.warn("Failed to record an exception " + e);
    }, Object.defineProperty(e.prototype, "duration", {
        get: function() {
            return this._duration;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
        get: function() {
            return this._ended;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
        get: function() {
            return this._droppedAttributesCount;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
        get: function() {
            return this._droppedEventsCount;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
        get: function() {
            return this._droppedLinksCount;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype._isSpanEnded = function() {
        return this._ended && $1ec05aac0120a3f2$var$yn.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(e, t) {
        return e.length <= t ? e : e.substring(0, t);
    }, e.prototype._truncateToSize = function(e) {
        var t = this, n = this._attributeValueLengthLimit;
        return n <= 0 ? ($1ec05aac0120a3f2$var$yn.warn("Attribute value limit must be positive, got " + n), e) : "string" == typeof e ? this._truncateToLimitUtil(e, n) : Array.isArray(e) ? e.map(function(e) {
            return "string" == typeof e ? t._truncateToLimitUtil(e, n) : e;
        }) : e;
    }, e;
}();
!function(e) {
    e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
}($1ec05aac0120a3f2$var$Ps || ($1ec05aac0120a3f2$var$Ps = {}));
var $1ec05aac0120a3f2$var$Qs = function() {
    function e() {}
    return e.prototype.shouldSample = function() {
        return {
            decision: $1ec05aac0120a3f2$var$Ps.NOT_RECORD
        };
    }, e.prototype.toString = function() {
        return "AlwaysOffSampler";
    }, e;
}(), $1ec05aac0120a3f2$var$Us = function() {
    function e() {}
    return e.prototype.shouldSample = function() {
        return {
            decision: $1ec05aac0120a3f2$var$Ps.RECORD_AND_SAMPLED
        };
    }, e.prototype.toString = function() {
        return "AlwaysOnSampler";
    }, e;
}(), $1ec05aac0120a3f2$var$ks = function() {
    function e(e) {
        var t, n, r, i;
        this._root = e.root, this._root || ($1ec05aac0120a3f2$var$Ea(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new $1ec05aac0120a3f2$var$Us), this._remoteParentSampled = null !== (t = e.remoteParentSampled) && void 0 !== t ? t : new $1ec05aac0120a3f2$var$Us, this._remoteParentNotSampled = null !== (n = e.remoteParentNotSampled) && void 0 !== n ? n : new $1ec05aac0120a3f2$var$Qs, this._localParentSampled = null !== (r = e.localParentSampled) && void 0 !== r ? r : new $1ec05aac0120a3f2$var$Us, this._localParentNotSampled = null !== (i = e.localParentNotSampled) && void 0 !== i ? i : new $1ec05aac0120a3f2$var$Qs;
    }
    return e.prototype.shouldSample = function(e, t, n, r, i, o) {
        var a = $1ec05aac0120a3f2$var$Dn.getSpanContext(e);
        return a && $1ec05aac0120a3f2$var$un(a) ? a.isRemote ? a.traceFlags & $1ec05aac0120a3f2$var$Et.SAMPLED ? this._remoteParentSampled.shouldSample(e, t, n, r, i, o) : this._remoteParentNotSampled.shouldSample(e, t, n, r, i, o) : a.traceFlags & $1ec05aac0120a3f2$var$Et.SAMPLED ? this._localParentSampled.shouldSample(e, t, n, r, i, o) : this._localParentNotSampled.shouldSample(e, t, n, r, i, o) : this._root.shouldSample(e, t, n, r, i, o);
    }, e.prototype.toString = function() {
        return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
}(), $1ec05aac0120a3f2$var$Gs = function() {
    function e(e) {
        void 0 === e && (e = 0), this._ratio = e, this._ratio = this._normalize(e), this._upperBound = Math.floor(4294967295 * this._ratio);
    }
    return e.prototype.shouldSample = function(e, t) {
        return {
            decision: $1ec05aac0120a3f2$var$cn(t) && this._accumulate(t) < this._upperBound ? $1ec05aac0120a3f2$var$Ps.RECORD_AND_SAMPLED : $1ec05aac0120a3f2$var$Ps.NOT_RECORD
        };
    }, e.prototype.toString = function() {
        return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(e) {
        return "number" != typeof e || isNaN(e) ? 0 : e >= 1 ? 1 : e <= 0 ? 0 : e;
    }, e.prototype._accumulate = function(e) {
        for(var t = 0, n = 0; n < e.length / 8; n++){
            var r = 8 * n;
            t = (t ^ parseInt(e.slice(r, r + 8), 16)) >>> 0;
        }
        return t;
    }, e;
}(), $1ec05aac0120a3f2$var$zs = $1ec05aac0120a3f2$var$ga.AlwaysOn;
function $1ec05aac0120a3f2$var$Xs() {
    var e = $1ec05aac0120a3f2$var$Na();
    return {
        sampler: $1ec05aac0120a3f2$var$Hs(e),
        forceFlushTimeoutMillis: 3e4,
        generalLimits: {
            attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
        },
        spanLimits: {
            attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
            linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
            eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
            attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
            attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
        },
        mergeResourceWithDefaults: !0
    };
}
function $1ec05aac0120a3f2$var$Hs(e) {
    switch(void 0 === e && (e = $1ec05aac0120a3f2$var$Na()), e.OTEL_TRACES_SAMPLER){
        case $1ec05aac0120a3f2$var$ga.AlwaysOn:
            return new $1ec05aac0120a3f2$var$Us;
        case $1ec05aac0120a3f2$var$ga.AlwaysOff:
            return new $1ec05aac0120a3f2$var$Qs;
        case $1ec05aac0120a3f2$var$ga.ParentBasedAlwaysOn:
            return new $1ec05aac0120a3f2$var$ks({
                root: new $1ec05aac0120a3f2$var$Us
            });
        case $1ec05aac0120a3f2$var$ga.ParentBasedAlwaysOff:
            return new $1ec05aac0120a3f2$var$ks({
                root: new $1ec05aac0120a3f2$var$Qs
            });
        case $1ec05aac0120a3f2$var$ga.TraceIdRatio:
            return new $1ec05aac0120a3f2$var$Gs($1ec05aac0120a3f2$var$qs(e));
        case $1ec05aac0120a3f2$var$ga.ParentBasedTraceIdRatio:
            return new $1ec05aac0120a3f2$var$ks({
                root: new $1ec05aac0120a3f2$var$Gs($1ec05aac0120a3f2$var$qs(e))
            });
        default:
            return $1ec05aac0120a3f2$var$yn.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + $1ec05aac0120a3f2$var$zs + '".'), new $1ec05aac0120a3f2$var$Us;
    }
}
function $1ec05aac0120a3f2$var$qs(e) {
    if (void 0 === e.OTEL_TRACES_SAMPLER_ARG || "" === e.OTEL_TRACES_SAMPLER_ARG) return $1ec05aac0120a3f2$var$yn.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to 1."), 1;
    var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
    return isNaN(t) ? ($1ec05aac0120a3f2$var$yn.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to 1."), 1) : t < 0 || t > 1 ? ($1ec05aac0120a3f2$var$yn.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to 1."), 1) : t;
}
function $1ec05aac0120a3f2$var$js(e) {
    var t, n, r, i, o, a, s, c, u, l, d, p, f = Object.assign({}, e.spanLimits), g = $1ec05aac0120a3f2$var$Pa($1ec05aac0120a3f2$var$Ba);
    return f.attributeCountLimit = null !== (a = null !== (o = null !== (i = null !== (n = null === (t = e.spanLimits) || void 0 === t ? void 0 : t.attributeCountLimit) && void 0 !== n ? n : null === (r = e.generalLimits) || void 0 === r ? void 0 : r.attributeCountLimit) && void 0 !== i ? i : g.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) && void 0 !== o ? o : g.OTEL_ATTRIBUTE_COUNT_LIMIT) && void 0 !== a ? a : $1ec05aac0120a3f2$var$Ia, f.attributeValueLengthLimit = null !== (p = null !== (d = null !== (l = null !== (c = null === (s = e.spanLimits) || void 0 === s ? void 0 : s.attributeValueLengthLimit) && void 0 !== c ? c : null === (u = e.generalLimits) || void 0 === u ? void 0 : u.attributeValueLengthLimit) && void 0 !== l ? l : g.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) && void 0 !== d ? d : g.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) && void 0 !== p ? p : $1ec05aac0120a3f2$var$ba, Object.assign({}, e, {
        spanLimits: f
    });
}
var $1ec05aac0120a3f2$var$Vs = function() {
    function e(e, t) {
        this._exporter = e, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
        var n = $1ec05aac0120a3f2$var$Na();
        this._maxExportBatchSize = "number" == typeof (null == t ? void 0 : t.maxExportBatchSize) ? t.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = "number" == typeof (null == t ? void 0 : t.maxQueueSize) ? t.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = "number" == typeof (null == t ? void 0 : t.scheduledDelayMillis) ? t.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = "number" == typeof (null == t ? void 0 : t.exportTimeoutMillis) ? t.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new $1ec05aac0120a3f2$var$Cs(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && ($1ec05aac0120a3f2$var$yn.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
        return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(e, t) {}, e.prototype.onEnd = function(e) {
        this._shutdownOnce.isCalled || 0 !== (e.spanContext().traceFlags & $1ec05aac0120a3f2$var$Et.SAMPLED) && this._addToBuffer(e);
    }, e.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
        var e = this;
        return Promise.resolve().then(function() {
            return e.onShutdown();
        }).then(function() {
            return e._flushAll();
        }).then(function() {
            return e._exporter.shutdown();
        });
    }, e.prototype._addToBuffer = function(e) {
        if (this._finishedSpans.length >= this._maxQueueSize) return 0 === this._droppedSpansCount && $1ec05aac0120a3f2$var$yn.debug("maxQueueSize reached, dropping spans"), void this._droppedSpansCount++;
        this._droppedSpansCount > 0 && ($1ec05aac0120a3f2$var$yn.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(e), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
        var e = this;
        return new Promise(function(t, n) {
            for(var r = [], i = 0, o = Math.ceil(e._finishedSpans.length / e._maxExportBatchSize); i < o; i++)r.push(e._flushOneBatch());
            Promise.all(r).then(function() {
                t();
            }).catch(n);
        });
    }, e.prototype._flushOneBatch = function() {
        var e = this;
        return this._clearTimer(), 0 === this._finishedSpans.length ? Promise.resolve() : new Promise(function(t, n) {
            var r = setTimeout(function() {
                n(new Error("Timeout"));
            }, e._exportTimeoutMillis);
            $1ec05aac0120a3f2$var$Tn.with($1ec05aac0120a3f2$var$ra($1ec05aac0120a3f2$var$Tn.active()), function() {
                var i;
                e._finishedSpans.length <= e._maxExportBatchSize ? (i = e._finishedSpans, e._finishedSpans = []) : i = e._finishedSpans.splice(0, e._maxExportBatchSize);
                for(var o = function() {
                    return e._exporter.export(i, function(e) {
                        var i;
                        clearTimeout(r), e.code === $1ec05aac0120a3f2$var$za.SUCCESS ? t() : n(null !== (i = e.error) && void 0 !== i ? i : new Error("BatchSpanProcessor: span export failed"));
                    });
                }, a = null, s = 0, c = i.length; s < c; s++){
                    var u = i[s];
                    u.resource.asyncAttributesPending && u.resource.waitForAsyncAttributes && (null != a || (a = []), a.push(u.resource.waitForAsyncAttributes()));
                }
                null === a ? o() : Promise.all(a).then(o, function(e) {
                    $1ec05aac0120a3f2$var$Ea(e), n(e);
                });
            });
        });
    }, e.prototype._maybeStartTimer = function() {
        var e = this;
        if (!this._isExporting) {
            var t = function() {
                e._isExporting = !0, e._flushOneBatch().finally(function() {
                    e._isExporting = !1, e._finishedSpans.length > 0 && (e._clearTimer(), e._maybeStartTimer());
                }).catch(function(t) {
                    e._isExporting = !1, $1ec05aac0120a3f2$var$Ea(t);
                });
            };
            if (this._finishedSpans.length >= this._maxExportBatchSize) return t();
            void 0 === this._timer && (this._timer = setTimeout(function() {
                return t();
            }, this._scheduledDelayMillis), this._timer);
        }
    }, e.prototype._clearTimer = function() {
        void 0 !== this._timer && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
}(), $1ec05aac0120a3f2$var$Js = function() {
    var e = function(t, n) {
        return e = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(e, t) {
            e.__proto__ = t;
        } || function(e, t) {
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }, e(t, n);
    };
    return function(t, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
        function r() {
            this.constructor = t;
        }
        e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r);
    };
}(), $1ec05aac0120a3f2$var$Ks = function(e) {
    function t(t, n) {
        var r = e.call(this, t, n) || this;
        return r.onInit(n), r;
    }
    return $1ec05aac0120a3f2$var$Js(t, e), t.prototype.onInit = function(e) {
        var t = this;
        !0 !== (null == e ? void 0 : e.disableAutoFlushOnDocumentHide) && "undefined" != typeof document && (this._visibilityChangeListener = function() {
            "hidden" === document.visibilityState && t.forceFlush().catch(function(e) {
                $1ec05aac0120a3f2$var$Ea(e);
            });
        }, this._pageHideListener = function() {
            t.forceFlush().catch(function(e) {
                $1ec05aac0120a3f2$var$Ea(e);
            });
        }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
        "undefined" != typeof document && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
}($1ec05aac0120a3f2$var$Vs), $1ec05aac0120a3f2$var$Ys = function() {
    this.generateTraceId = $1ec05aac0120a3f2$var$Zs(16), this.generateSpanId = $1ec05aac0120a3f2$var$Zs(8);
}, $1ec05aac0120a3f2$var$Ws = Array(32);
function $1ec05aac0120a3f2$var$Zs(e) {
    return function() {
        for(var t = 0; t < 2 * e; t++)$1ec05aac0120a3f2$var$Ws[t] = Math.floor(16 * Math.random()) + 48, $1ec05aac0120a3f2$var$Ws[t] >= 58 && ($1ec05aac0120a3f2$var$Ws[t] += 39);
        return String.fromCharCode.apply(null, $1ec05aac0120a3f2$var$Ws.slice(0, 2 * e));
    };
}
var $1ec05aac0120a3f2$var$$s = function() {
    function e(e, t, n) {
        this._tracerProvider = n;
        var r = function(e) {
            var t = {
                sampler: $1ec05aac0120a3f2$var$Hs()
            }, n = $1ec05aac0120a3f2$var$Xs(), r = Object.assign({}, n, t, e);
            return r.generalLimits = Object.assign({}, n.generalLimits, e.generalLimits || {}), r.spanLimits = Object.assign({}, n.spanLimits, e.spanLimits || {}), r;
        }(t);
        this._sampler = r.sampler, this._generalLimits = r.generalLimits, this._spanLimits = r.spanLimits, this._idGenerator = t.idGenerator || new $1ec05aac0120a3f2$var$Ys, this.resource = n.resource, this.instrumentationLibrary = e;
    }
    return e.prototype.startSpan = function(e, t, n) {
        var r, i, o;
        void 0 === t && (t = {}), void 0 === n && (n = $1ec05aac0120a3f2$var$Tn.active()), t.root && (n = $1ec05aac0120a3f2$var$Dn.deleteSpan(n));
        var a = $1ec05aac0120a3f2$var$Dn.getSpan(n);
        if ($1ec05aac0120a3f2$var$ia(n)) return $1ec05aac0120a3f2$var$yn.debug("Instrumentation suppressed, returning Noop Span"), $1ec05aac0120a3f2$var$Dn.wrapSpanContext($1ec05aac0120a3f2$var$Yt);
        var s, c, u, l = null == a ? void 0 : a.spanContext(), d = this._idGenerator.generateSpanId();
        l && $1ec05aac0120a3f2$var$Dn.isSpanContextValid(l) ? (s = l.traceId, c = l.traceState, u = l.spanId) : s = this._idGenerator.generateTraceId();
        var p = null !== (r = t.kind) && void 0 !== r ? r : $1ec05aac0120a3f2$var$gn.INTERNAL, f = (null !== (i = t.links) && void 0 !== i ? i : []).map(function(e) {
            return {
                context: e.context,
                attributes: $1ec05aac0120a3f2$var$la(e.attributes)
            };
        }), g = $1ec05aac0120a3f2$var$la(t.attributes), h = this._sampler.shouldSample(n, s, e, p, g, f);
        c = null !== (o = h.traceState) && void 0 !== o ? o : c;
        var E = {
            traceId: s,
            spanId: d,
            traceFlags: h.decision === $1ec05aac0120a3f2$var$fn.RECORD_AND_SAMPLED ? $1ec05aac0120a3f2$var$Et.SAMPLED : $1ec05aac0120a3f2$var$Et.NONE,
            traceState: c
        };
        if (h.decision === $1ec05aac0120a3f2$var$fn.NOT_RECORD) return $1ec05aac0120a3f2$var$yn.debug("Recording is off, propagating context in a non-recording span"), $1ec05aac0120a3f2$var$Dn.wrapSpanContext(E);
        var A = $1ec05aac0120a3f2$var$la(Object.assign(g, h.attributes));
        return new $1ec05aac0120a3f2$var$Fs(this, n, e, E, p, u, f, t.startTime, void 0, A);
    }, e.prototype.startActiveSpan = function(e, t, n, r) {
        var i, o, a;
        if (!(arguments.length < 2)) {
            2 === arguments.length ? a = t : 3 === arguments.length ? (i = t, a = n) : (i = t, o = n, a = r);
            var s = null != o ? o : $1ec05aac0120a3f2$var$Tn.active(), c = this.startSpan(e, i, s), u = $1ec05aac0120a3f2$var$Dn.setSpan(s, c);
            return $1ec05aac0120a3f2$var$Tn.with(u, a, void 0, c);
        }
    }, e.prototype.getGeneralLimits = function() {
        return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
        return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
        return this._tracerProvider.getActiveSpanProcessor();
    }, e;
}();
var $1ec05aac0120a3f2$var$ec, $1ec05aac0120a3f2$var$tc = function() {
    return $1ec05aac0120a3f2$var$tc = Object.assign || function(e) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
    }, $1ec05aac0120a3f2$var$tc.apply(this, arguments);
}, $1ec05aac0120a3f2$var$nc = function(e, t, n, r) {
    return new (n || (n = Promise))(function(i, o) {
        function a(e) {
            try {
                c(r.next(e));
            } catch (e) {
                o(e);
            }
        }
        function s(e) {
            try {
                c(r.throw(e));
            } catch (e) {
                o(e);
            }
        }
        function c(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, s);
        }
        c((r = r.apply(e, t || [])).next());
    });
}, $1ec05aac0120a3f2$var$rc = function(e, t) {
    var n, r, i, o, a = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function s(o) {
        return function(s) {
            return function(o) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch(r = 0, i && (o = [
                        2 & o[0],
                        i.value
                    ]), o[0]){
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return a.label++, {
                                value: o[1],
                                done: !1
                            };
                        case 5:
                            a.label++, r = o[1], o = [
                                0
                            ];
                            continue;
                        case 7:
                            o = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                a.label = o[1];
                                break;
                            }
                            if (6 === o[0] && a.label < i[1]) {
                                a.label = i[1], i = o;
                                break;
                            }
                            if (i && a.label < i[2]) {
                                a.label = i[2], a.ops.push(o);
                                break;
                            }
                            i[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    o = t.call(e, a);
                } catch (e) {
                    o = [
                        6,
                        e
                    ], r = 0;
                } finally{
                    n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                    value: o[0] ? o[1] : void 0,
                    done: !0
                };
            }([
                o,
                s
            ]);
        };
    }
}, $1ec05aac0120a3f2$var$ic = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$oc = function() {
    function e(e, t) {
        var n, r = this;
        this._attributes = e, this.asyncAttributesPending = null != t, this._syncAttributes = null !== (n = this._attributes) && void 0 !== n ? n : {}, this._asyncAttributesPromise = null == t ? void 0 : t.then(function(e) {
            return r._attributes = Object.assign({}, r._attributes, e), r.asyncAttributesPending = !1, e;
        }, function(e) {
            return $1ec05aac0120a3f2$var$yn.debug("a resource's async attributes promise rejected: %s", e), r.asyncAttributesPending = !1, {};
        });
    }
    return e.empty = function() {
        return e.EMPTY;
    }, e.default = function() {
        var t;
        return new e(((t = {})["service.name"] = "unknown_service", t[$1ec05aac0120a3f2$var$Ua] = $1ec05aac0120a3f2$var$Ga[$1ec05aac0120a3f2$var$Ua], t[$1ec05aac0120a3f2$var$Qa] = $1ec05aac0120a3f2$var$Ga[$1ec05aac0120a3f2$var$Qa], t[$1ec05aac0120a3f2$var$ka] = $1ec05aac0120a3f2$var$Ga[$1ec05aac0120a3f2$var$ka], t));
    }, Object.defineProperty(e.prototype, "attributes", {
        get: function() {
            var e;
            return this.asyncAttributesPending && $1ec05aac0120a3f2$var$yn.error("Accessing resource attributes before async attributes settled"), null !== (e = this._attributes) && void 0 !== e ? e : {};
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
        return $1ec05aac0120a3f2$var$nc(this, void 0, void 0, function() {
            return $1ec05aac0120a3f2$var$rc(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.asyncAttributesPending ? [
                            4,
                            this._asyncAttributesPromise
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.merge = function(t) {
        var n, r = this;
        if (!t) return this;
        var i = $1ec05aac0120a3f2$var$tc($1ec05aac0120a3f2$var$tc({}, this._syncAttributes), null !== (n = t._syncAttributes) && void 0 !== n ? n : t.attributes);
        if (!this._asyncAttributesPromise && !t._asyncAttributesPromise) return new e(i);
        var o = Promise.all([
            this._asyncAttributesPromise,
            t._asyncAttributesPromise
        ]).then(function(e) {
            var n, i = $1ec05aac0120a3f2$var$ic(e, 2), o = i[0], a = i[1];
            return $1ec05aac0120a3f2$var$tc($1ec05aac0120a3f2$var$tc($1ec05aac0120a3f2$var$tc($1ec05aac0120a3f2$var$tc({}, r._syncAttributes), o), null !== (n = t._syncAttributes) && void 0 !== n ? n : t.attributes), a);
        });
        return new e(i, o);
    }, e.EMPTY = new e({}), e;
}(), $1ec05aac0120a3f2$var$ac = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $1ec05aac0120a3f2$var$sc = function() {
    function e(e) {
        this._spanProcessors = e;
    }
    return e.prototype.forceFlush = function() {
        var e, t, n = [];
        try {
            for(var r = $1ec05aac0120a3f2$var$ac(this._spanProcessors), i = r.next(); !i.done; i = r.next()){
                var o = i.value;
                n.push(o.forceFlush());
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (t = r.return) && t.call(r);
            } finally{
                if (e) throw e.error;
            }
        }
        return new Promise(function(e) {
            Promise.all(n).then(function() {
                e();
            }).catch(function(t) {
                $1ec05aac0120a3f2$var$Ea(t || new Error("MultiSpanProcessor: forceFlush failed")), e();
            });
        });
    }, e.prototype.onStart = function(e, t) {
        var n, r;
        try {
            for(var i = $1ec05aac0120a3f2$var$ac(this._spanProcessors), o = i.next(); !o.done; o = i.next())o.value.onStart(e, t);
        } catch (e) {
            n = {
                error: e
            };
        } finally{
            try {
                o && !o.done && (r = i.return) && r.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
    }, e.prototype.onEnd = function(e) {
        var t, n;
        try {
            for(var r = $1ec05aac0120a3f2$var$ac(this._spanProcessors), i = r.next(); !i.done; i = r.next())i.value.onEnd(e);
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (n = r.return) && n.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e.prototype.shutdown = function() {
        var e, t, n = [];
        try {
            for(var r = $1ec05aac0120a3f2$var$ac(this._spanProcessors), i = r.next(); !i.done; i = r.next()){
                var o = i.value;
                n.push(o.shutdown());
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (t = r.return) && t.call(r);
            } finally{
                if (e) throw e.error;
            }
        }
        return new Promise(function(e, t) {
            Promise.all(n).then(function() {
                e();
            }, t);
        });
    }, e;
}(), $1ec05aac0120a3f2$var$cc = function() {
    function e() {}
    return e.prototype.onStart = function(e, t) {}, e.prototype.onEnd = function(e) {}, e.prototype.shutdown = function() {
        return Promise.resolve();
    }, e.prototype.forceFlush = function() {
        return Promise.resolve();
    }, e;
}(), $1ec05aac0120a3f2$var$uc = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$lc = function(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
};
!function(e) {
    e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
}($1ec05aac0120a3f2$var$ec || ($1ec05aac0120a3f2$var$ec = {}));
var $1ec05aac0120a3f2$var$dc = function() {
    function e(e) {
        var t, n;
        void 0 === e && (e = {}), this._registeredSpanProcessors = [], this._tracers = new Map;
        var r = function() {
            for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
            for(var n = e.shift(), r = new WeakMap; e.length > 0;)n = $1ec05aac0120a3f2$var$ys(n, e.shift(), 0, r);
            return n;
        }({}, $1ec05aac0120a3f2$var$Xs(), $1ec05aac0120a3f2$var$js(e));
        if (this.resource = null !== (t = r.resource) && void 0 !== t ? t : $1ec05aac0120a3f2$var$oc.empty(), r.mergeResourceWithDefaults && (this.resource = $1ec05aac0120a3f2$var$oc.default().merge(this.resource)), this._config = Object.assign({}, r, {
            resource: this.resource
        }), null === (n = e.spanProcessors) || void 0 === n ? void 0 : n.length) this._registeredSpanProcessors = $1ec05aac0120a3f2$var$lc([], $1ec05aac0120a3f2$var$uc(e.spanProcessors), !1), this.activeSpanProcessor = new $1ec05aac0120a3f2$var$sc(this._registeredSpanProcessors);
        else {
            var i = this._buildExporterFromEnv();
            if (void 0 !== i) {
                var o = new $1ec05aac0120a3f2$var$Ks(i);
                this.activeSpanProcessor = o;
            } else this.activeSpanProcessor = new $1ec05aac0120a3f2$var$cc;
        }
    }
    return e.prototype.getTracer = function(e, t, n) {
        var r = e + "@" + (t || "") + ":" + ((null == n ? void 0 : n.schemaUrl) || "");
        return this._tracers.has(r) || this._tracers.set(r, new $1ec05aac0120a3f2$var$$s({
            name: e,
            version: t,
            schemaUrl: null == n ? void 0 : n.schemaUrl
        }, this._config, this)), this._tracers.get(r);
    }, e.prototype.addSpanProcessor = function(e) {
        0 === this._registeredSpanProcessors.length && this.activeSpanProcessor.shutdown().catch(function(e) {
            return $1ec05aac0120a3f2$var$yn.error("Error while trying to shutdown current span processor", e);
        }), this._registeredSpanProcessors.push(e), this.activeSpanProcessor = new $1ec05aac0120a3f2$var$sc(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
        return this.activeSpanProcessor;
    }, e.prototype.register = function(e) {
        void 0 === e && (e = {}), $1ec05aac0120a3f2$var$Dn.setGlobalTracerProvider(this), void 0 === e.propagator && (e.propagator = this._buildPropagatorFromEnv()), e.contextManager && $1ec05aac0120a3f2$var$Tn.setGlobalContextManager(e.contextManager), e.propagator && $1ec05aac0120a3f2$var$Mn.setGlobalPropagator(e.propagator);
    }, e.prototype.forceFlush = function() {
        var e = this._config.forceFlushTimeoutMillis, t = this._registeredSpanProcessors.map(function(t) {
            return new Promise(function(n) {
                var r, i = setTimeout(function() {
                    n(new Error("Span processor did not completed within timeout period of " + e + " ms")), r = $1ec05aac0120a3f2$var$ec.timeout;
                }, e);
                t.forceFlush().then(function() {
                    clearTimeout(i), r !== $1ec05aac0120a3f2$var$ec.timeout && (r = $1ec05aac0120a3f2$var$ec.resolved, n(r));
                }).catch(function(e) {
                    clearTimeout(i), r = $1ec05aac0120a3f2$var$ec.error, n(e);
                });
            });
        });
        return new Promise(function(e, n) {
            Promise.all(t).then(function(t) {
                var r = t.filter(function(e) {
                    return e !== $1ec05aac0120a3f2$var$ec.resolved;
                });
                r.length > 0 ? n(r) : e();
            }).catch(function(e) {
                return n([
                    e
                ]);
            });
        });
    }, e.prototype.shutdown = function() {
        return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(e) {
        var t;
        return null === (t = this.constructor._registeredPropagators.get(e)) || void 0 === t ? void 0 : t();
    }, e.prototype._getSpanExporter = function(e) {
        var t;
        return null === (t = this.constructor._registeredExporters.get(e)) || void 0 === t ? void 0 : t();
    }, e.prototype._buildPropagatorFromEnv = function() {
        var e = this, t = Array.from(new Set($1ec05aac0120a3f2$var$Na().OTEL_PROPAGATORS)), n = t.map(function(t) {
            var n = e._getPropagator(t);
            return n || $1ec05aac0120a3f2$var$yn.warn('Propagator "' + t + '" requested through environment variable is unavailable.'), n;
        }).reduce(function(e, t) {
            return t && e.push(t), e;
        }, []);
        return 0 === n.length ? void 0 : 1 === t.length ? n[0] : new $1ec05aac0120a3f2$var$Za({
            propagators: n
        });
    }, e.prototype._buildExporterFromEnv = function() {
        var e = $1ec05aac0120a3f2$var$Na().OTEL_TRACES_EXPORTER;
        if ("none" !== e && "" !== e) {
            var t = this._getSpanExporter(e);
            return t || $1ec05aac0120a3f2$var$yn.error('Exporter "' + e + '" requested through environment variable is unavailable.'), t;
        }
    }, e._registeredPropagators = new Map([
        [
            "tracecontext",
            function() {
                return new $1ec05aac0120a3f2$var$us;
            }
        ],
        [
            "baggage",
            function() {
                return new $1ec05aac0120a3f2$var$sa;
            }
        ]
    ]), e._registeredExporters = new Map, e;
}(), $1ec05aac0120a3f2$var$pc = function(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $1ec05aac0120a3f2$var$fc = function() {
    function e() {}
    return e.prototype.export = function(e, t) {
        return this._sendSpans(e, t);
    }, e.prototype.shutdown = function() {
        return this._sendSpans([]), this.forceFlush();
    }, e.prototype.forceFlush = function() {
        return Promise.resolve();
    }, e.prototype._exportInfo = function(e) {
        var t;
        return {
            resource: {
                attributes: e.resource.attributes
            },
            instrumentationScope: e.instrumentationLibrary,
            traceId: e.spanContext().traceId,
            parentId: e.parentSpanId,
            traceState: null === (t = e.spanContext().traceState) || void 0 === t ? void 0 : t.serialize(),
            name: e.name,
            id: e.spanContext().spanId,
            kind: e.kind,
            timestamp: $1ec05aac0120a3f2$var$Va(e.startTime),
            duration: $1ec05aac0120a3f2$var$Va(e.duration),
            attributes: e.attributes,
            status: e.status,
            events: e.events,
            links: e.links
        };
    }, e.prototype._sendSpans = function(e, t) {
        var n, r;
        try {
            for(var i = $1ec05aac0120a3f2$var$pc(e), o = i.next(); !o.done; o = i.next()){
                var a = o.value;
                console.dir(this._exportInfo(a), {
                    depth: 3
                });
            }
        } catch (e) {
            n = {
                error: e
            };
        } finally{
            try {
                o && !o.done && (r = i.return) && r.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        if (t) return t({
            code: $1ec05aac0120a3f2$var$za.SUCCESS
        });
    }, e;
}(), $1ec05aac0120a3f2$var$gc = function(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), a = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(r = o.next()).done;)a.push(r.value);
    } catch (e) {
        i = {
            error: e
        };
    } finally{
        try {
            r && !r.done && (n = o.return) && n.call(o);
        } finally{
            if (i) throw i.error;
        }
    }
    return a;
}, $1ec05aac0120a3f2$var$hc = function(e, t, n) {
    if (n || 2 === arguments.length) for(var r, i = 0, o = t.length; i < o; i++)!r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
    return e.concat(r || Array.prototype.slice.call(t));
}, $1ec05aac0120a3f2$var$Ec = function() {
    function e() {
        this._finishedSpans = [], this._stopped = !1;
    }
    return e.prototype.export = function(e, t) {
        var n;
        if (this._stopped) return t({
            code: $1ec05aac0120a3f2$var$za.FAILED,
            error: new Error("Exporter has been stopped")
        });
        (n = this._finishedSpans).push.apply(n, $1ec05aac0120a3f2$var$hc([], $1ec05aac0120a3f2$var$gc(e), !1)), setTimeout(function() {
            return t({
                code: $1ec05aac0120a3f2$var$za.SUCCESS
            });
        }, 0);
    }, e.prototype.shutdown = function() {
        return this._stopped = !0, this._finishedSpans = [], this.forceFlush();
    }, e.prototype.forceFlush = function() {
        return Promise.resolve();
    }, e.prototype.reset = function() {
        this._finishedSpans = [];
    }, e.prototype.getFinishedSpans = function() {
        return this._finishedSpans;
    }, e;
}(), $1ec05aac0120a3f2$var$Ac = function(e, t, n, r) {
    return new (n || (n = Promise))(function(i, o) {
        function a(e) {
            try {
                c(r.next(e));
            } catch (e) {
                o(e);
            }
        }
        function s(e) {
            try {
                c(r.throw(e));
            } catch (e) {
                o(e);
            }
        }
        function c(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, s);
        }
        c((r = r.apply(e, t || [])).next());
    });
}, $1ec05aac0120a3f2$var$_c = function(e, t) {
    var n, r, i, o, a = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function s(o) {
        return function(s) {
            return function(o) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch(r = 0, i && (o = [
                        2 & o[0],
                        i.value
                    ]), o[0]){
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return a.label++, {
                                value: o[1],
                                done: !1
                            };
                        case 5:
                            a.label++, r = o[1], o = [
                                0
                            ];
                            continue;
                        case 7:
                            o = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                a.label = o[1];
                                break;
                            }
                            if (6 === o[0] && a.label < i[1]) {
                                a.label = i[1], i = o;
                                break;
                            }
                            if (i && a.label < i[2]) {
                                a.label = i[2], a.ops.push(o);
                                break;
                            }
                            i[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    o = t.call(e, a);
                } catch (e) {
                    o = [
                        6,
                        e
                    ], r = 0;
                } finally{
                    n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                    value: o[0] ? o[1] : void 0,
                    done: !0
                };
            }([
                o,
                s
            ]);
        };
    }
}, $1ec05aac0120a3f2$var$mc = function() {
    function e(e) {
        this._exporter = e, this._shutdownOnce = new $1ec05aac0120a3f2$var$Cs(this._shutdown, this), this._unresolvedExports = new Set;
    }
    return e.prototype.forceFlush = function() {
        return $1ec05aac0120a3f2$var$Ac(this, void 0, void 0, function() {
            return $1ec05aac0120a3f2$var$_c(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            Promise.all(Array.from(this._unresolvedExports))
                        ];
                    case 1:
                        return e.sent(), this._exporter.forceFlush ? [
                            4,
                            this._exporter.forceFlush()
                        ] : [
                            3,
                            3
                        ];
                    case 2:
                        e.sent(), e.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.onStart = function(e, t) {}, e.prototype.onEnd = function(e) {
        var t, n, r = this;
        if (!this._shutdownOnce.isCalled && 0 !== (e.spanContext().traceFlags & $1ec05aac0120a3f2$var$Et.SAMPLED)) {
            var i = function() {
                return $1ec05aac0120a3f2$var$Bs._export(r._exporter, [
                    e
                ]).then(function(e) {
                    var t;
                    e.code !== $1ec05aac0120a3f2$var$za.SUCCESS && $1ec05aac0120a3f2$var$Ea(null !== (t = e.error) && void 0 !== t ? t : new Error("SimpleSpanProcessor: span export failed (status " + e + ")"));
                }).catch(function(e) {
                    $1ec05aac0120a3f2$var$Ea(e);
                });
            };
            if (e.resource.asyncAttributesPending) {
                var o = null === (n = (t = e.resource).waitForAsyncAttributes) || void 0 === n ? void 0 : n.call(t).then(function() {
                    return null != o && r._unresolvedExports.delete(o), i();
                }, function(e) {
                    return $1ec05aac0120a3f2$var$Ea(e);
                });
                null != o && this._unresolvedExports.add(o);
            } else i();
        }
    }, e.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
        return this._exporter.shutdown();
    }, e;
}(), $1ec05aac0120a3f2$var$Tc = Object.freeze({
    __proto__: null,
    AlwaysOffSampler: $1ec05aac0120a3f2$var$Qs,
    AlwaysOnSampler: $1ec05aac0120a3f2$var$Us,
    BasicTracerProvider: $1ec05aac0120a3f2$var$dc,
    BatchSpanProcessor: $1ec05aac0120a3f2$var$Ks,
    ConsoleSpanExporter: $1ec05aac0120a3f2$var$fc,
    get ForceFlushState () {
        return $1ec05aac0120a3f2$var$ec;
    },
    InMemorySpanExporter: $1ec05aac0120a3f2$var$Ec,
    NoopSpanProcessor: $1ec05aac0120a3f2$var$cc,
    ParentBasedSampler: $1ec05aac0120a3f2$var$ks,
    RandomIdGenerator: $1ec05aac0120a3f2$var$Ys,
    get SamplingDecision () {
        return $1ec05aac0120a3f2$var$Ps;
    },
    SimpleSpanProcessor: $1ec05aac0120a3f2$var$mc,
    Span: $1ec05aac0120a3f2$var$Fs,
    TraceIdRatioBasedSampler: $1ec05aac0120a3f2$var$Gs,
    Tracer: $1ec05aac0120a3f2$var$$s
});
 //# sourceMappingURL=index.esm.js.map

});



parcelRegister("lIMa5", function(module, exports) {

$parcel$export(module.exports, "getLeadingQueryStringChar", function () { return $5203835e26514f83$export$fc4d3ce7fa6c0c9c; });
$parcel$export(module.exports, "getQueryStringAsObject", function () { return $5203835e26514f83$export$3c28aa6dc8da4cbf; });
$parcel$export(module.exports, "updateBrowserUrlOnNavigate", function () { return $5203835e26514f83$export$c667132d1c639bbe; });
function $5203835e26514f83$export$6b17a39e52c8ee53(obj) {
    const strBuilder = [];
    if (typeof obj !== "object" || !obj) return obj;
    if (typeof obj === "string" || typeof obj === "number") return obj;
    for (const [prop, value] of Object.entries(obj))if (Object.prototype.hasOwnProperty.call(obj, prop)) strBuilder.push(encodeURIComponent(prop) + "=" + encodeURIComponent(value));
    return strBuilder.join("&");
}
function $5203835e26514f83$export$9fc3462b5b0688c0(path) {
    return /[?&]/.test(path);
}
function $5203835e26514f83$export$fc4d3ce7fa6c0c9c(path) {
    return $5203835e26514f83$export$9fc3462b5b0688c0(path) ? "&" : "?";
}
function $5203835e26514f83$export$3c28aa6dc8da4cbf(options) {
    options = options ?? {
        query: "",
        asObject: true,
        transformers: {}
    };
    const queryString = options.query;
    const params = new URLSearchParams(queryString ?? window.location.search);
    if (options.asObject) {
        const object = $5203835e26514f83$var$paramsToObject(params);
        const transformers = options.transformers ?? {};
        return Object.keys(transformers).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: transformers[key](acc[key])
            };
        }, object);
    } else return params; // Get query string values using params.get(key);
}
function $5203835e26514f83$export$c667132d1c639bbe(state) {
    if (typeof window.history.pushState === "function") {
        const newUrl = new URL(window.location.href);
        for (const [prop, value] of Object.entries(state))if (Object.prototype.hasOwnProperty.call(state, prop)) newUrl.searchParams.set(prop, value);
        window.history.pushState(state, "", newUrl.toString());
    }
}
function $5203835e26514f83$var$paramsToObject(entries) {
    return Object.fromEntries(entries);
}

});






parcelRegister("dbeOd", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("86S4X")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("5miPd")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("7X1Jz")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("kECgv")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("XaBSS"))
]).then(()=>parcelRequire('1I7o7'));

});
parcelRegister("5FrBL", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1c132cac09cd18d9$var$cachedPreloads;
        case 'prefetch':
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});


parcelRegister("a6qac", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("4XN3V")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3CXxv")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("f3Mcb")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("6bJBC"))
]).then(()=>parcelRequire('bDNMc'));

});

parcelRegister("beSF1", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("7nlE0")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("f3Mcb")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("jbq04"))
]).then(()=>parcelRequire('bF4eV'));

});

parcelRegister("90wy4", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("8DCbk")).then(()=>parcelRequire('elz6M'));

});

parcelRegister("1J82K", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("dkrzP")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3CXxv")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("f3Mcb")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("kLKFG"))
]).then(()=>parcelRequire('9Z8dz'));

});

parcelRegister("KsOfD", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("cOtZb")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("7X1Jz")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("kECgv")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("lQObL"))
]).then(()=>parcelRequire('84qIa'));

});

parcelRegister("8f7gC", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("jQKBB")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("01HYE"))
]).then(()=>parcelRequire('dmNg4'));

});

parcelRegister("8kfIQ", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("hqCx5")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("f3Mcb")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ecXJq"))
]).then(()=>parcelRequire('80xWN'));

});

parcelRegister("jpZrb", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("1taXa")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("5miPd")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("7X1Jz")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("kECgv")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("d3glp"))
]).then(()=>parcelRequire('kYcuR'));

});

parcelRegister("7bAH7", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("hRlpj")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("cbKR1"))
]).then(()=>parcelRequire('2uwQJ'));

});

parcelRegister("er5uo", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("6A0zs")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("49pF6"))
]).then(()=>parcelRequire('kxGES'));

});

parcelRegister("3k404", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("jU9WK")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("1G9Al"))
]).then(()=>parcelRequire('iyjbG'));

});

parcelRegister("81Ki0", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("3WPwS")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("5F58N"))
]).then(()=>parcelRequire('6bxVx'));

});

parcelRegister("k9s88", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("hneH2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("7X1Jz")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("bQSX4"))
]).then(()=>parcelRequire('hy7Y5'));

});

parcelRegister("9OTRW", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("kJ90r")).then(()=>parcelRequire('jQ7kp'));

});

parcelRegister("dZbs5", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("bTPEi")).then(()=>parcelRequire('kWnES'));

});

parcelRegister("8aPVI", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("1SfMx")).then(()=>parcelRequire('fgq5H'));

});

parcelRegister("kkAoC", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("2DHhQ")).then(()=>parcelRequire('8biGe'));

});

parcelRegister("77JkQ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("i7BFt")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("6hnLv"))
]).then(()=>parcelRequire('6uMse'));

});

parcelRegister("gTppb", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("5FrBL"))((parcelRequire("iE7OH")).resolve("jzdzP")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("5HmOr"))
]).then(()=>parcelRequire('g5VW3'));

});

parcelRegister("grHnD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5c8b136cf6b3484$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $3H7F0 = parcelRequire("3H7F0");
function $a5c8b136cf6b3484$export$2e2bcd8739ae039({ page: page, children: children, ...rest }) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3H7F0.default), {
        page: page,
        ...rest,
        children: children
    });
}

});
parcelRegister("3H7F0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6f95990228ef2d7$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $hvIjv = parcelRequire("hvIjv");

var $jUdMV = parcelRequire("jUdMV");

var $9Amww = parcelRequire("9Amww");

var $dUCd0 = parcelRequire("dUCd0");

var $7JoNl = parcelRequire("7JoNl");
function $f6f95990228ef2d7$export$2e2bcd8739ae039({ page: page, className: className, children: children }) {
    (0, $9Amww.default)();
    (0, $exYeM.useEffect)(()=>{
        window.addEventListener("scroll", showScrollUpButton);
        function showScrollUpButton() {
            const btn = document.getElementById("scrollUp");
            if (!btn) return;
            if (window.scrollY > 300) btn.classList.remove("no-display");
            else btn.classList.add("no-display");
        }
        return ()=>window.removeEventListener("scroll", showScrollUpButton);
    }, []);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $hvIjv.default), {
                titleTemplate: `%s - ${"NearBuyCart"}`,
                title: page.title,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        "http-equiv": "x-ua-compatible",
                        content: "ie=edge"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "description",
                        content: page.description
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("link", {
                rel: "icon",
                type: "image/png",
                href: "favicon/favicon-96x96.png",
                sizes: "96x96"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("link", {
                rel: "icon",
                type: "image/svg+xml",
                href: "favicon/favicon.svg"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("link", {
                rel: "shortcut icon",
                href: "favicon/favicon.ico"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "favicon/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("link", {
                rel: "manifest",
                href: "favicon/site.webmanifest"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                id: "page-top",
                className: `body-wrapper ${className ?? ""}`,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7JoNl.default), {}),
                    children,
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dUCd0.default), {}),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $jUdMV.default), {
                        to: "page-top",
                        id: "scrollUp",
                        className: "no-display",
                        style: {
                            position: "fixed",
                            zIndex: 2147483647
                        }
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("hvIjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbf7b4aedff497d3$export$2e2bcd8739ae039; });

var $bisEj = parcelRequire("bisEj");

var $Y4OQ1 = parcelRequire("Y4OQ1");

var $g6MkC = parcelRequire("g6MkC");

var $exYeM = parcelRequire("exYeM");

var $j8GnD = parcelRequire("j8GnD");
var $cbf7b4aedff497d3$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $cbf7b4aedff497d3$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $cbf7b4aedff497d3$var$VALID_TAG_NAMES = Object.keys($cbf7b4aedff497d3$var$TAG_NAMES).map(function(name) {
    return $cbf7b4aedff497d3$var$TAG_NAMES[name];
});
var $cbf7b4aedff497d3$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $cbf7b4aedff497d3$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $cbf7b4aedff497d3$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $cbf7b4aedff497d3$var$HTML_TAG_MAP = Object.keys($cbf7b4aedff497d3$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$cbf7b4aedff497d3$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $cbf7b4aedff497d3$var$SELF_CLOSING_TAGS = [
    $cbf7b4aedff497d3$var$TAG_NAMES.NOSCRIPT,
    $cbf7b4aedff497d3$var$TAG_NAMES.SCRIPT,
    $cbf7b4aedff497d3$var$TAG_NAMES.STYLE
];
var $cbf7b4aedff497d3$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $cbf7b4aedff497d3$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $cbf7b4aedff497d3$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $cbf7b4aedff497d3$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $cbf7b4aedff497d3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $cbf7b4aedff497d3$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $cbf7b4aedff497d3$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $cbf7b4aedff497d3$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $cbf7b4aedff497d3$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $cbf7b4aedff497d3$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $cbf7b4aedff497d3$var$getInnermostProperty(propsList, $cbf7b4aedff497d3$var$TAG_NAMES.TITLE);
    var innermostTemplate = $cbf7b4aedff497d3$var$getInnermostProperty(propsList, $cbf7b4aedff497d3$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $cbf7b4aedff497d3$var$getInnermostProperty(propsList, $cbf7b4aedff497d3$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $cbf7b4aedff497d3$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $cbf7b4aedff497d3$var$getInnermostProperty(propsList, $cbf7b4aedff497d3$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $cbf7b4aedff497d3$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $cbf7b4aedff497d3$var$_extends({}, tagAttrs, current);
    }, {});
};
var $cbf7b4aedff497d3$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$cbf7b4aedff497d3$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$cbf7b4aedff497d3$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $cbf7b4aedff497d3$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $cbf7b4aedff497d3$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $cbf7b4aedff497d3$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $cbf7b4aedff497d3$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $cbf7b4aedff497d3$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $cbf7b4aedff497d3$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $cbf7b4aedff497d3$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $cbf7b4aedff497d3$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($j8GnD)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $cbf7b4aedff497d3$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $cbf7b4aedff497d3$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $cbf7b4aedff497d3$var$getBaseTagFromPropsList([
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.HREF,
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $cbf7b4aedff497d3$var$getAttributesFromPropsList($cbf7b4aedff497d3$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $cbf7b4aedff497d3$var$getInnermostProperty(propsList, $cbf7b4aedff497d3$var$HELMET_PROPS.DEFER),
        encode: $cbf7b4aedff497d3$var$getInnermostProperty(propsList, $cbf7b4aedff497d3$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $cbf7b4aedff497d3$var$getAttributesFromPropsList($cbf7b4aedff497d3$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $cbf7b4aedff497d3$var$getTagsFromPropsList($cbf7b4aedff497d3$var$TAG_NAMES.LINK, [
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.REL,
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $cbf7b4aedff497d3$var$getTagsFromPropsList($cbf7b4aedff497d3$var$TAG_NAMES.META, [
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.NAME,
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.CHARSET,
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.HTTPEQUIV,
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.PROPERTY,
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $cbf7b4aedff497d3$var$getTagsFromPropsList($cbf7b4aedff497d3$var$TAG_NAMES.NOSCRIPT, [
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $cbf7b4aedff497d3$var$getOnChangeClientState(propsList),
        scriptTags: $cbf7b4aedff497d3$var$getTagsFromPropsList($cbf7b4aedff497d3$var$TAG_NAMES.SCRIPT, [
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.SRC,
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $cbf7b4aedff497d3$var$getTagsFromPropsList($cbf7b4aedff497d3$var$TAG_NAMES.STYLE, [
            $cbf7b4aedff497d3$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $cbf7b4aedff497d3$var$getTitleFromPropsList(propsList),
        titleAttributes: $cbf7b4aedff497d3$var$getAttributesFromPropsList($cbf7b4aedff497d3$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $cbf7b4aedff497d3$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $cbf7b4aedff497d3$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $cbf7b4aedff497d3$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $cbf7b4aedff497d3$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $cbf7b4aedff497d3$var$rafPolyfill : $parcel$global.requestAnimationFrame || $cbf7b4aedff497d3$var$rafPolyfill;
var $cbf7b4aedff497d3$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $cbf7b4aedff497d3$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $cbf7b4aedff497d3$var$cafPolyfill;
var $cbf7b4aedff497d3$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $cbf7b4aedff497d3$var$_helmetCallback = null;
var $cbf7b4aedff497d3$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($cbf7b4aedff497d3$var$_helmetCallback) $cbf7b4aedff497d3$var$cancelAnimationFrame($cbf7b4aedff497d3$var$_helmetCallback);
    if (newState.defer) $cbf7b4aedff497d3$var$_helmetCallback = $cbf7b4aedff497d3$var$requestAnimationFrame(function() {
        $cbf7b4aedff497d3$var$commitTagChanges(newState, function() {
            $cbf7b4aedff497d3$var$_helmetCallback = null;
        });
    });
    else {
        $cbf7b4aedff497d3$var$commitTagChanges(newState);
        $cbf7b4aedff497d3$var$_helmetCallback = null;
    }
};
var $cbf7b4aedff497d3$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $cbf7b4aedff497d3$var$updateAttributes($cbf7b4aedff497d3$var$TAG_NAMES.BODY, bodyAttributes);
    $cbf7b4aedff497d3$var$updateAttributes($cbf7b4aedff497d3$var$TAG_NAMES.HTML, htmlAttributes);
    $cbf7b4aedff497d3$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $cbf7b4aedff497d3$var$updateTags($cbf7b4aedff497d3$var$TAG_NAMES.BASE, baseTag),
        linkTags: $cbf7b4aedff497d3$var$updateTags($cbf7b4aedff497d3$var$TAG_NAMES.LINK, linkTags),
        metaTags: $cbf7b4aedff497d3$var$updateTags($cbf7b4aedff497d3$var$TAG_NAMES.META, metaTags),
        noscriptTags: $cbf7b4aedff497d3$var$updateTags($cbf7b4aedff497d3$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $cbf7b4aedff497d3$var$updateTags($cbf7b4aedff497d3$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $cbf7b4aedff497d3$var$updateTags($cbf7b4aedff497d3$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $cbf7b4aedff497d3$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $cbf7b4aedff497d3$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $cbf7b4aedff497d3$var$flattenArray(title);
    $cbf7b4aedff497d3$var$updateAttributes($cbf7b4aedff497d3$var$TAG_NAMES.TITLE, attributes);
};
var $cbf7b4aedff497d3$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($cbf7b4aedff497d3$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($cbf7b4aedff497d3$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($cbf7b4aedff497d3$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($cbf7b4aedff497d3$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $cbf7b4aedff497d3$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($cbf7b4aedff497d3$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $cbf7b4aedff497d3$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $cbf7b4aedff497d3$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $cbf7b4aedff497d3$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($cbf7b4aedff497d3$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $cbf7b4aedff497d3$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $cbf7b4aedff497d3$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $cbf7b4aedff497d3$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $cbf7b4aedff497d3$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $cbf7b4aedff497d3$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $cbf7b4aedff497d3$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $cbf7b4aedff497d3$var$HELMET_ATTRIBUTE + "=\"true\">" + $cbf7b4aedff497d3$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $cbf7b4aedff497d3$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $cbf7b4aedff497d3$var$TAG_PROPERTIES.INNER_HTML || attribute === $cbf7b4aedff497d3$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $cbf7b4aedff497d3$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $cbf7b4aedff497d3$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $cbf7b4aedff497d3$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $cbf7b4aedff497d3$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$cbf7b4aedff497d3$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $cbf7b4aedff497d3$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$cbf7b4aedff497d3$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $cbf7b4aedff497d3$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$cbf7b4aedff497d3$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $cbf7b4aedff497d3$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cbf7b4aedff497d3$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $cbf7b4aedff497d3$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$cbf7b4aedff497d3$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $cbf7b4aedff497d3$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $cbf7b4aedff497d3$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $cbf7b4aedff497d3$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(type, mappedTag);
    });
};
var $cbf7b4aedff497d3$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $cbf7b4aedff497d3$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $cbf7b4aedff497d3$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $cbf7b4aedff497d3$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $cbf7b4aedff497d3$var$ATTRIBUTE_NAMES.BODY:
        case $cbf7b4aedff497d3$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $cbf7b4aedff497d3$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $cbf7b4aedff497d3$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $cbf7b4aedff497d3$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $cbf7b4aedff497d3$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $cbf7b4aedff497d3$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $cbf7b4aedff497d3$var$getMethodsForTag($cbf7b4aedff497d3$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $cbf7b4aedff497d3$var$getMethodsForTag($cbf7b4aedff497d3$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $cbf7b4aedff497d3$var$getMethodsForTag($cbf7b4aedff497d3$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $cbf7b4aedff497d3$var$getMethodsForTag($cbf7b4aedff497d3$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $cbf7b4aedff497d3$var$getMethodsForTag($cbf7b4aedff497d3$var$TAG_NAMES.META, metaTags, encode),
        noscript: $cbf7b4aedff497d3$var$getMethodsForTag($cbf7b4aedff497d3$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $cbf7b4aedff497d3$var$getMethodsForTag($cbf7b4aedff497d3$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $cbf7b4aedff497d3$var$getMethodsForTag($cbf7b4aedff497d3$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $cbf7b4aedff497d3$var$getMethodsForTag($cbf7b4aedff497d3$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $cbf7b4aedff497d3$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $cbf7b4aedff497d3$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $cbf7b4aedff497d3$var$classCallCheck(this, HelmetWrapper);
            return $cbf7b4aedff497d3$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($g6MkC)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $cbf7b4aedff497d3$var$TAG_NAMES.SCRIPT:
                case $cbf7b4aedff497d3$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $cbf7b4aedff497d3$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $cbf7b4aedff497d3$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $cbf7b4aedff497d3$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $cbf7b4aedff497d3$var$TAG_NAMES.TITLE:
                    return $cbf7b4aedff497d3$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $cbf7b4aedff497d3$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $cbf7b4aedff497d3$var$TAG_NAMES.BODY:
                    return $cbf7b4aedff497d3$var$_extends({}, newProps, {
                        bodyAttributes: $cbf7b4aedff497d3$var$_extends({}, newChildProps)
                    });
                case $cbf7b4aedff497d3$var$TAG_NAMES.HTML:
                    return $cbf7b4aedff497d3$var$_extends({}, newProps, {
                        htmlAttributes: $cbf7b4aedff497d3$var$_extends({}, newChildProps)
                    });
            }
            return $cbf7b4aedff497d3$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $cbf7b4aedff497d3$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $cbf7b4aedff497d3$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $cbf7b4aedff497d3$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $cbf7b4aedff497d3$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $cbf7b4aedff497d3$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $cbf7b4aedff497d3$var$TAG_NAMES.LINK:
                    case $cbf7b4aedff497d3$var$TAG_NAMES.META:
                    case $cbf7b4aedff497d3$var$TAG_NAMES.NOSCRIPT:
                    case $cbf7b4aedff497d3$var$TAG_NAMES.SCRIPT:
                    case $cbf7b4aedff497d3$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $cbf7b4aedff497d3$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $cbf7b4aedff497d3$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Component, newProps);
        };
        $cbf7b4aedff497d3$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $cbf7b4aedff497d3$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $cbf7b4aedff497d3$var$NullComponent = function NullComponent() {
    return null;
};
var $cbf7b4aedff497d3$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($Y4OQ1)))($cbf7b4aedff497d3$var$reducePropsToState, $cbf7b4aedff497d3$var$handleClientStateChange, $cbf7b4aedff497d3$var$mapStateOnServer)($cbf7b4aedff497d3$var$NullComponent);
var $cbf7b4aedff497d3$export$dcef8f9bb9a41431 = $cbf7b4aedff497d3$var$Helmet($cbf7b4aedff497d3$var$HelmetSideEffects);
$cbf7b4aedff497d3$export$dcef8f9bb9a41431.renderStatic = $cbf7b4aedff497d3$export$dcef8f9bb9a41431.rewind;
var $cbf7b4aedff497d3$export$2e2bcd8739ae039 = $cbf7b4aedff497d3$export$dcef8f9bb9a41431;

});
parcelRegister("bisEj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839799496b62fb71$var$ReactIs, $839799496b62fb71$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("jpdgm"))();

});
parcelRegister("jpdgm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $L7tyD = parcelRequire("L7tyD");
function $e20aa3d84dea372f$var$emptyFunction() {}
function $e20aa3d84dea372f$var$emptyFunctionWithReset() {}
$e20aa3d84dea372f$var$emptyFunctionWithReset.resetWarningCache = $e20aa3d84dea372f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $L7tyD) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e20aa3d84dea372f$var$emptyFunctionWithReset,
        resetWarningCache: $e20aa3d84dea372f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("L7tyD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $08da306d15728f79$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $08da306d15728f79$var$ReactPropTypesSecret;

});



parcelRegister("Y4OQ1", function(module, exports) {
'use strict';
function $0b4957a86ead0873$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $exYeM = parcelRequire("exYeM");
var $0b4957a86ead0873$var$React__default = $0b4957a86ead0873$var$_interopDefault($exYeM);
function $0b4957a86ead0873$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0b4957a86ead0873$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $0b4957a86ead0873$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $0b4957a86ead0873$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $0b4957a86ead0873$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $0b4957a86ead0873$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($exYeM.PureComponent);
        $0b4957a86ead0873$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $0b4957a86ead0873$var$_defineProperty(SideEffect, "canUseDOM", $0b4957a86ead0873$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $0b4957a86ead0873$var$withSideEffect;

});

parcelRegister("g6MkC", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $bba2b2857408f717$var$hasElementType = typeof Element !== 'undefined';
var $bba2b2857408f717$var$hasMap = typeof Map === 'function';
var $bba2b2857408f717$var$hasSet = typeof Set === 'function';
var $bba2b2857408f717$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $bba2b2857408f717$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$bba2b2857408f717$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($bba2b2857408f717$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$bba2b2857408f717$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($bba2b2857408f717$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($bba2b2857408f717$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($bba2b2857408f717$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$bba2b2857408f717$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $bba2b2857408f717$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("j8GnD", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $deefa37a789291dc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $deefa37a789291dc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $deefa37a789291dc$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $deefa37a789291dc$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $deefa37a789291dc$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $deefa37a789291dc$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $deefa37a789291dc$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($deefa37a789291dc$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($deefa37a789291dc$var$getOwnPropertySymbols) {
            symbols = $deefa37a789291dc$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($deefa37a789291dc$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("jUdMV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52c7ae3ea9b5bfaa$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
function $52c7ae3ea9b5bfaa$export$2e2bcd8739ae039(props) {
    const { to: to, id: id, className: className, style: style } = props;
    const node = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(()=>{
        node.current?.addEventListener("click", scrollTo);
        return ()=>node.current?.removeEventListener("click", scrollTo);
        function scrollTo(e) {
            e.preventDefault();
            const element = document.getElementById(to);
            if (element) element.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        node.current
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
        id: id,
        className: className,
        href: `#${to}`,
        ref: node,
        style: {
            ...style ?? {}
        },
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
            className: "fa fa-angle-double-up"
        })
    });
}

});

parcelRegister("9Amww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f6afcfb3db2f539$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");

var $eML00 = parcelRequire("eML00");

var $i5N2N = parcelRequire("i5N2N");
const $3f6afcfb3db2f539$var$DEFAULT_TRACKING_ID = "G-9QGNFN9M9C";
function $3f6afcfb3db2f539$export$2e2bcd8739ae039(data) {
    const { trackingId: trackingId } = data || {};
    const TRACKING_ID = trackingId || $3f6afcfb3db2f539$var$DEFAULT_TRACKING_ID;
    (0, $exYeM.useEffect)(()=>{
        // Initialize GA4 once when the app mounts
        (0, $eML00.default).initialize(TRACKING_ID);
        // Send initial pageview
        (0, $eML00.default).send({
            hitType: "pageview",
            page: window.location.pathname
        });
    }, []);
    // Record page views
    $3f6afcfb3db2f539$var$usePageViews();
}
function $3f6afcfb3db2f539$export$6794ace65368b7c3(data) {
    const { action: action, category: category, label: label, value: value } = data ?? {};
    (0, $eML00.default).event({
        category: category,
        action: action,
        label: label,
        value: value
    });
/* Usage example: 
  recordAnalyticsEvent({
    category: 'E-commerce',
    action: 'Click Add To Cart Button',
    label: 'Add Product To Cart',
    value: <productId>
  })
  */ }
/** 
 * Because React handles routing on the client side without reloading the browser, 
 * we must log pageviews manually when routes change. 
 * Since we're using react-router-dom, 
 * we track page views dynamically inside a custom hook:
 */ function $3f6afcfb3db2f539$var$usePageViews() {
    const location = (0, $i5N2N.useLocation)();
    (0, $exYeM.useEffect)(()=>{
        (0, $eML00.default).send({
            hitType: "pageview",
            page: location.pathname + (location.search ?? "")
        });
    }, [
        location
    ]);
}

});
parcelRegister("eML00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd60f1e5d9834587$export$2e2bcd8739ae039; });
//#region src/gtag.ts
const $cd60f1e5d9834587$var$gtag = (...args)=>{
    if (typeof window !== "undefined") {
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        window.gtag(...args);
    }
};
//#endregion
//#region src/format.ts
const $cd60f1e5d9834587$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $cd60f1e5d9834587$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, (match, index, title)=>{
        if (index > 0 && index + match.length !== title.length && match.search($cd60f1e5d9834587$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
function $cd60f1e5d9834587$var$mightBeEmail(s) {
    return typeof s === "string" && s.indexOf("@") !== -1;
}
const $cd60f1e5d9834587$var$redacted = "REDACTED (Potential Email Address)";
function $cd60f1e5d9834587$var$redactEmail(string) {
    if ($cd60f1e5d9834587$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $cd60f1e5d9834587$var$redacted;
    }
    return string;
}
function $cd60f1e5d9834587$var$format(s = "", titleCase = true, redactingEmail = true) {
    let _str = s || "";
    if (titleCase) _str = $cd60f1e5d9834587$var$toTitleCase(s);
    if (redactingEmail) _str = $cd60f1e5d9834587$var$redactEmail(_str);
    return _str;
}
//#endregion
//#region src/ga4.ts
var $cd60f1e5d9834587$var$GA4 = class {
    isInitialized;
    _testMode;
    _currentMeasurementId;
    _hasLoadedGA;
    _isQueuing;
    _queueGtag;
    constructor(){
        this.reset();
    }
    reset = ()=>{
        this.isInitialized = false;
        this._testMode = false;
        this._currentMeasurementId = "";
        this._hasLoadedGA = false;
        this._isQueuing = false;
        this._queueGtag = [];
    };
    _gtag = (...args)=>{
        if (!this._testMode) {
            if (this._isQueuing) this._queueGtag.push(args);
            else $cd60f1e5d9834587$var$gtag(...args);
        } else this._queueGtag.push(args);
    };
    gtag(...args) {
        this._gtag(...args);
    }
    _loadGA = (GA_MEASUREMENT_ID, nonce, gtagUrl = "https://www.googletagmanager.com/gtag/js")=>{
        if (typeof window === "undefined" || typeof document === "undefined") return;
        if (!this._hasLoadedGA) {
            const script = document.createElement("script");
            script.async = true;
            script.src = `${gtagUrl}?id=${GA_MEASUREMENT_ID}`;
            if (nonce) script.setAttribute("nonce", nonce);
            document.body.appendChild(script);
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
            this._hasLoadedGA = true;
        }
    };
    _toGtagOptions = (gaOptions)=>{
        if (!gaOptions) return;
        const mapFields = {
            cookieUpdate: "cookie_update",
            cookieExpires: "cookie_expires",
            cookieDomain: "cookie_domain",
            cookieFlags: "cookie_flags",
            userId: "user_id",
            clientId: "client_id",
            anonymizeIp: "anonymize_ip",
            contentGroup1: "content_group1",
            contentGroup2: "content_group2",
            contentGroup3: "content_group3",
            contentGroup4: "content_group4",
            contentGroup5: "content_group5",
            allowAdFeatures: "allow_google_signals",
            allowAdPersonalizationSignals: "allow_ad_personalization_signals",
            nonInteraction: "non_interaction",
            page: "page_path",
            hitCallback: "event_callback"
        };
        return Object.entries(gaOptions).reduce((prev, [key, value])=>{
            if (mapFields[key]) prev[mapFields[key]] = value;
            else prev[key] = value;
            return prev;
        }, {});
    };
    /**
	*
	* @param {InitOptions[]|string} GA_MEASUREMENT_ID
	* @param {Object} [options]
	* @param {string} [options.nonce]
	* @param {boolean} [options.testMode=false]
	* @param {string} [options.gtagUrl=https://www.googletagmanager.com/gtag/js]
	* @param {GaOptions|any} [options.gaOptions]
	* @param {Object} [options.gtagOptions] New parameter
	*/ initialize = (GA_MEASUREMENT_ID, options = {})=>{
        if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
        const initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
            {
                trackingId: GA_MEASUREMENT_ID
            }
        ] : GA_MEASUREMENT_ID;
        this._currentMeasurementId = initConfigs[0].trackingId;
        const { gaOptions: gaOptions, gtagOptions: gtagOptions, nonce: nonce, testMode: testMode = false, gtagUrl: gtagUrl } = options;
        this._testMode = testMode;
        if (!testMode) this._loadGA(this._currentMeasurementId, nonce, gtagUrl);
        if (!this.isInitialized) {
            this._gtag("js", /* @__PURE__ */ new Date());
            initConfigs.forEach((config)=>{
                const mergedGtagOptions = {
                    ...this._toGtagOptions({
                        ...gaOptions,
                        ...config.gaOptions
                    }),
                    ...gtagOptions,
                    ...config.gtagOptions
                };
                if (Object.keys(mergedGtagOptions).length) this._gtag("config", config.trackingId, mergedGtagOptions);
                else this._gtag("config", config.trackingId);
            });
        }
        this.isInitialized = true;
        if (!testMode) {
            const queues = [
                ...this._queueGtag
            ];
            this._queueGtag = [];
            this._isQueuing = false;
            while(queues.length){
                const queue = queues.shift();
                this._gtag(...queue);
                if (queue[0] === "get") this._isQueuing = true;
            }
        }
    };
    set = (fieldsObject)=>{
        if (!fieldsObject) {
            console.warn("`fieldsObject` is required in .set()");
            return;
        }
        if (typeof fieldsObject !== "object") {
            console.warn("Expected `fieldsObject` arg to be an Object");
            return;
        }
        if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
        this._gaCommand("set", fieldsObject);
    };
    _gaCommandSendEvent = (eventCategory, eventAction, eventLabel, eventValue, fieldsObject)=>{
        this._gtag("event", eventAction, {
            event_category: eventCategory,
            event_label: eventLabel,
            value: eventValue,
            ...fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            },
            ...this._toGtagOptions(fieldsObject)
        });
    };
    _gaCommandSendEventParameters = (...args)=>{
        if (typeof args[0] === "string") this._gaCommandSendEvent(...args.slice(1));
        else {
            const { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel, eventValue: eventValue, hitType: hitType, ...rest } = args[0];
            this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
        }
    };
    _gaCommandSendTiming = (timingCategory, timingVar, timingValue, timingLabel)=>{
        this._gtag("event", "timing_complete", {
            name: timingVar,
            value: timingValue,
            event_category: timingCategory,
            event_label: timingLabel
        });
    };
    _gaCommandSendPageview = (page, fieldsObject)=>{
        if (fieldsObject && Object.keys(fieldsObject).length) {
            const { title: title, location: location, ...rest } = this._toGtagOptions(fieldsObject) || {};
            this._gtag("event", "page_view", {
                ...page && {
                    page_path: page
                },
                ...title && {
                    page_title: title
                },
                ...location && {
                    page_location: location
                },
                ...rest
            });
        } else if (page) this._gtag("event", "page_view", {
            page_path: page
        });
        else this._gtag("event", "page_view");
    };
    _gaCommandSendPageviewParameters = (...args)=>{
        if (typeof args[0] === "string") this._gaCommandSendPageview(...args.slice(1));
        else {
            const { page: page, hitType: hitType, ...rest } = args[0];
            this._gaCommandSendPageview(page, rest);
        }
    };
    _gaCommandSend = (...args)=>{
        const hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
        switch(hitType){
            case "event":
                this._gaCommandSendEventParameters(...args);
                break;
            case "pageview":
                this._gaCommandSendPageviewParameters(...args);
                break;
            case "timing":
                this._gaCommandSendTiming(...args.slice(1));
                break;
            case "screenview":
            case "transaction":
            case "item":
            case "social":
            case "exception":
                console.warn(`Unsupported send command: ${hitType}`);
                break;
            default:
                console.warn(`Send command doesn't exist: ${hitType}`);
        }
    };
    _gaCommandSet = (...args)=>{
        if (typeof args[0] === "string") args[0] = {
            [args[0]]: args[1]
        };
        this._gtag("set", this._toGtagOptions(args[0]));
    };
    _gaCommand = (command, ...args)=>{
        switch(command){
            case "send":
                this._gaCommandSend(...args);
                break;
            case "set":
                this._gaCommandSet(...args);
                break;
            default:
                console.warn(`Command doesn't exist: ${command}`);
        }
    };
    ga = (...args)=>{
        if (typeof args[0] === "string") this._gaCommand(...args);
        else {
            const [readyCallback] = args;
            this._gtag("get", this._currentMeasurementId, "client_id", (clientId)=>{
                this._isQueuing = false;
                const queues = this._queueGtag;
                readyCallback({
                    get: (property)=>property === "clientId" ? clientId : property === "trackingId" ? this._currentMeasurementId : property === "apiVersion" ? "1" : void 0
                });
                while(queues.length){
                    const queue = queues.shift();
                    this._gtag(...queue);
                }
            });
            this._isQueuing = true;
        }
        return this.ga;
    };
    /**
	* @param {UaEventOptions|string} optionsOrName
	* @param {Object} [params]
	*/ event = (optionsOrName, params)=>{
        if (typeof optionsOrName === "string") this._gtag("event", optionsOrName, this._toGtagOptions(params));
        else {
            const { action: action, category: category, label: label, value: value, nonInteraction: nonInteraction, transport: transport } = optionsOrName;
            if (!category || !action) {
                console.warn("args.category AND args.action are required in event()");
                return;
            }
            const fieldObject = {
                hitType: "event",
                eventCategory: $cd60f1e5d9834587$var$format(category),
                eventAction: $cd60f1e5d9834587$var$format(action)
            };
            if (label) fieldObject.eventLabel = $cd60f1e5d9834587$var$format(label);
            if (typeof value !== "undefined") {
                if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                else fieldObject.eventValue = value;
            }
            if (typeof nonInteraction !== "undefined") {
                if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                else fieldObject.nonInteraction = nonInteraction;
            }
            if (typeof transport !== "undefined") {
                if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                else {
                    if ([
                        "beacon",
                        "xhr",
                        "image"
                    ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                    fieldObject.transport = transport;
                }
            }
            this._gaCommand("send", fieldObject);
        }
    };
    send = (fieldObject)=>{
        this._gaCommand("send", fieldObject);
    };
};
var $cd60f1e5d9834587$var$ga4_default = new $cd60f1e5d9834587$var$GA4();
//#endregion
//#region src/index.ts
const $cd60f1e5d9834587$export$7459d731d9494519 = $cd60f1e5d9834587$var$GA4;
var $cd60f1e5d9834587$export$2e2bcd8739ae039 = $cd60f1e5d9834587$var$ga4_default;

});


parcelRegister("dUCd0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce5fde326a598790$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");

var $bGXlg = parcelRequire("bGXlg");

var $9Liyz = parcelRequire("9Liyz");
function $ce5fde326a598790$var$Footer() {
    const appName = "NearBuyCart";
    const appDomain = "nearbuycart.com";
    const businessAddressLine1 = "84A Lafiaji Street, Dolphin Estate,";
    const businessAddressLine2 = "101222, Ikoyi, Lagos";
    const businessAddressLine3 = undefined;
    const supportPhoneNumber = "(+234) 806 347 2981";
    const facebookUrl = "https://www.facebook.com/profile.php?id=61577802724031";
    const linkedinUrl = "https://www.linkedin.com/company/nearbuycart";
    const instagramUrl = "";
    const twitterUrl = "";
    const youtubeUrl = "";
    const vendorBackendUrl = "https://vendor.nearbuycart.com";
    const currYear = new Date().getFullYear();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "footer-static-middle",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "footer-logo-wrap pt-50 pb-35",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "col-lg-4 col-md-6",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "footer-logo",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                    to: (0, $hSqCk).HOME,
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                        src: "/images/branding/SecondaryLogo.svg",
                                                        alt: `${appName} Footer Logo`
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                    className: "info text-muted",
                                                    children: "Customer support:"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                            className: "des",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                    className: "support-phone",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                        href: "#",
                                                        children: supportPhoneNumber
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                                    className: "business-address",
                                                    children: [
                                                        businessAddressLine1,
                                                        businessAddressLine2 && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                                                businessAddressLine2
                                                            ]
                                                        }),
                                                        businessAddressLine3 && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                                                businessAddressLine3
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                    className: "support-email",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                        href: `mailto://info@${appDomain}`,
                                                        children: `info@${appDomain}`
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "col-lg-2 col-md-3 col-sm-6",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "footer-block",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                className: "footer-block-title",
                                                children: "Top Categories"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: $ce5fde326a598790$var$generateCategoryUrl("Computers & Accessories"),
                                                            children: "Computers & Laptops"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: $ce5fde326a598790$var$generateCategoryUrl("Phones & Tablets"),
                                                            children: "Smart phones"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: $ce5fde326a598790$var$generateCategoryUrl("Headphones"),
                                                            children: "Headphones"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                                        className: "with-streak",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {}),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                                to: $ce5fde326a598790$var$generateCategoryUrl("Appliances"),
                                                                children: "Appliances"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: $ce5fde326a598790$var$generateCategoryUrl("Cameras & Photos"),
                                                            children: "Cameras & photos"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: $ce5fde326a598790$var$generateCategoryUrl("Electronics"),
                                                            children: "TV & Homes"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "col-lg-2 col-md-3 col-sm-6",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "footer-block",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                className: "footer-block-title",
                                                children: "Quick Links"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: (0, $hSqCk).SHOP,
                                                            children: "Shop products"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: (0, $hSqCk).CART,
                                                            children: "Shopping cart"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: (0, $hSqCk).WISHLIST,
                                                            children: "Wishlist"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: (0, $hSqCk).PRODUCT_COMPARE.replace(":productId", "all"),
                                                            children: "Compare products"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: (0, $hSqCk).ORDER_TRACKING.replace(":orderReferenceNumber", "all"),
                                                            children: "Track orders"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "col-lg-4",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "footer-block",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                className: "footer-block-title",
                                                children: "Our company"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: (0, $hSqCk).ABOUT_US,
                                                            children: "About us"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: (0, $hSqCk).PRIVACY_POLICY,
                                                            children: "Privacy Policy"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                            to: (0, $hSqCk).CONTACT_US,
                                                            children: "Contact us"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                className: "footer-block-title",
                                                children: "Follow Us"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                                className: "social-link",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        className: "twitter",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                            href: twitterUrl,
                                                            "data-toggle": "tooltip",
                                                            target: "_blank",
                                                            title: "Twitter",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                                                                className: "fa fa-x",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        className: "facebook",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                            href: facebookUrl,
                                                            "data-toggle": "tooltip",
                                                            target: "_blank",
                                                            title: "Facebook",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                                                                className: "fa fa-facebook",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        className: "instagram",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                            href: instagramUrl,
                                                            "data-toggle": "tooltip",
                                                            target: "_blank",
                                                            title: "Instagram",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                                                                className: "fa fa-instagram",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        className: "linkedin",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                            href: linkedinUrl,
                                                            "data-toggle": "tooltip",
                                                            target: "_blank",
                                                            title: "LinkedIn",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                                                                className: "fa fa-linkedin",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                        className: "youtube",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                            href: youtubeUrl,
                                                            "data-toggle": "tooltip",
                                                            target: "_blank",
                                                            title: "YouTube",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                                                                className: "fa fa-youtube",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "col-lg-12",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "text-center",
                        children: vendorBackendUrl && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    style: {
                                        marginRight: "5px",
                                        color: "#fff"
                                    },
                                    children: "Reach more customers:"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                                    href: vendorBackendUrl,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                                            className: "fa fa-store",
                                            "aria-hidden": "true",
                                            style: {
                                                marginRight: "5px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: "Become a vendor"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                                            className: "fa fa-external-link",
                                            "aria-hidden": "true",
                                            style: {
                                                marginLeft: "5px",
                                                position: "relative",
                                                top: "1px"
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("hr", {
                className: "footer-separator"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "footer-static-bottom pt-0 pb-20",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "col-lg-12",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "copyright text-center pt-5 pb-10",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                                        href: "#",
                                        onClick: (e)=>e.preventDefault(),
                                        children: [
                                            "\xa9 ",
                                            currYear <= 2025 ? 2025 : `2025 - ${currYear}`,
                                            " ",
                                            appName?.toLowerCase()
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
var $ce5fde326a598790$export$2e2bcd8739ae039 = $ce5fde326a598790$var$Footer;
function $ce5fde326a598790$var$generateCategoryUrl(categoryName) {
    return (0, $9Liyz.getCategoryUrl)({
        name: categoryName.toLowerCase()
    });
}

});
parcelRegister("bGXlg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4626c65403a00f42$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $i5N2N = parcelRequire("i5N2N");
function $4626c65403a00f42$export$2e2bcd8739ae039(props) {
    const { to: to, children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $i5N2N.NavLink), {
        to: to,
        ...rest,
        children: children
    });
}

});

parcelRegister("9Liyz", function(module, exports) {

$parcel$export(module.exports, "getFeaturedImage", function () { return $c5e233d966994ba6$export$b4a1d86b0c2b64eb; });
$parcel$export(module.exports, "getImageHost", function () { return $c5e233d966994ba6$export$868ddc4c8ae450e8; });
$parcel$export(module.exports, "generateRatingTitle", function () { return $c5e233d966994ba6$export$8c30026c5a5f1419; });
$parcel$export(module.exports, "getComparisonFields", function () { return $c5e233d966994ba6$export$16527fcef8957d70; });
$parcel$export(module.exports, "getProductUrl", function () { return $c5e233d966994ba6$export$bb9e5e4e313054b8; });
$parcel$export(module.exports, "getBrandUrl", function () { return $c5e233d966994ba6$export$781a62cd6a0f5ea6; });
$parcel$export(module.exports, "getCategoryUrl", function () { return $c5e233d966994ba6$export$be461ba6bbed633c; });
$parcel$export(module.exports, "parseBrandForDisplay", function () { return $c5e233d966994ba6$export$1a4718b888943502; });
$parcel$export(module.exports, "parsePriceInfo", function () { return $c5e233d966994ba6$export$e09f9a486287d78f; });
$parcel$export(module.exports, "parseProductForDisplay", function () { return $c5e233d966994ba6$export$13f9d896af942807; });
$parcel$export(module.exports, "parseProductVariantForDisplay", function () { return $c5e233d966994ba6$export$784569cc2449831a; });
$parcel$export(module.exports, "rawRating", function () { return $c5e233d966994ba6$export$37bd6492f9f0eff4; });

var $bokng = parcelRequire("bokng");
parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");

var $l8Aho = parcelRequire("l8Aho");

var $1KXyM = parcelRequire("1KXyM");

var $e6drH = parcelRequire("e6drH");

var $1RJFN = parcelRequire("1RJFN");
function $c5e233d966994ba6$export$b4a1d86b0c2b64eb(images) {
    let featuredImage = images?.find((image)=>image.is_featured);
    if (!featuredImage) featuredImage = images?.find((image)=>image.displayOrder === 1);
    if (!featuredImage) featuredImage = images?.[0];
    return featuredImage ?? {
        url: $c5e233d966994ba6$var$getDefaultProductImageUrl()
    };
}
function $c5e233d966994ba6$export$868ddc4c8ae450e8(image) {
    if (image.url.startsWith("data:image/")) return "disk";
    if (image.url.startsWith("https://ik.imagekit.io")) return "imagekit";
    return "cloudinary";
}
function $c5e233d966994ba6$export$2aa5ca4c994232f6(products) {
    if (!products || products.length < 2) return "Please select at least two products to compare.";
    const firstProduct = products[0];
    const comparisonResult = {};
    for(const key in firstProduct){
        comparisonResult[key] = {
            values: [],
            different: false
        };
        for (const product of products)comparisonResult[key].values.push(product[key]);
        if (new Set(comparisonResult[key].values).size > 1) comparisonResult[key].different = true;
    }
    return comparisonResult;
}
function $c5e233d966994ba6$export$8c30026c5a5f1419(rating, rawRating) {
    let ratingTitle;
    if (rating > 0) ratingTitle = `Average Rating ${rawRating}`;
    else ratingTitle = "No reviews yet";
    return ratingTitle;
}
function $c5e233d966994ba6$export$16527fcef8957d70(product, possibleFields) {
    const comparisonFields = [];
    for (const { key: key, label: label } of possibleFields)if (key in product) comparisonFields.push({
        key: key,
        label: label
    });
    return comparisonFields;
}
function $c5e233d966994ba6$export$bb9e5e4e313054b8(product) {
    return (0, $hSqCk).PRODUCT.replace(":productId", product.id ?? "");
}
function $c5e233d966994ba6$export$781a62cd6a0f5ea6(brand) {
    return (0, $hSqCk).BRAND.replace(":brandName", brand.name?.toLowerCase() ?? "");
}
function $c5e233d966994ba6$export$be461ba6bbed633c(category) {
    return (0, $hSqCk).CATEGORY.replace(":categoryName", category.name ?? "");
}
function $c5e233d966994ba6$export$1a4718b888943502(brand) {
    const brandName = (0, $1RJFN.decodeSpecialChars)(brand.name ?? "");
    return {
        ...brand,
        id: brand.id,
        name: brandName,
        value: `${brand.id}:${brandName}`,
        url: $c5e233d966994ba6$export$781a62cd6a0f5ea6(brand)
    };
}
function $c5e233d966994ba6$export$e09f9a486287d78f(price, discountedPrice) {
    let originalPrice;
    let sellingPrice;
    let discountPercentage;
    const returnData = {};
    if (discountedPrice && discountedPrice !== price) {
        originalPrice = price;
        sellingPrice = discountedPrice;
        discountPercentage = (0, $e6drH.calculateDiscountPercentage)(originalPrice, sellingPrice);
        returnData.originalPrice = originalPrice;
        returnData.sellingPrice = sellingPrice;
        returnData.discountPercentage = discountPercentage;
    } else {
        sellingPrice = price;
        returnData.sellingPrice = sellingPrice;
    }
    return returnData;
/*return [
    originalPrice,
    sellingPrice,
    discountPercentage
  ];*/ }
function $c5e233d966994ba6$export$13f9d896af942807(product) {
    if (!product) return null;
    // Product variants have a "product" property
    // pointing to the parent product
    const parent = product?.product;
    const attributes = product.attributes;
    const brand = attributes.find((a)=>a.name === "Brand");
    const featuredImage = $c5e233d966994ba6$export$b4a1d86b0c2b64eb(product.images);
    return {
        id: product.id,
        type: "Product",
        name: (0, $1RJFN.decodeSpecialChars)(product.name ?? parent?.name),
        sku: product.sku,
        url: $c5e233d966994ba6$export$bb9e5e4e313054b8(product),
        description: (0, $1RJFN.decodeSpecialChars)(product.description ?? parent?.description),
        shortDescription: (0, $1RJFN.decodeSpecialChars)(product.short_description ?? parent?.short_description),
        business: {
            ...product.business ?? parent?.business,
            name: (0, $1RJFN.decodeSpecialChars)((product.business ?? parent?.business ?? {}).name)
        },
        category: {
            ...product.category ?? parent?.category,
            name: (0, $1RJFN.decodeSpecialChars)((product.category ?? parent?.category ?? {}).name)
        },
        status: product.archived ? "Archived" : product.status,
        inventory: product.inventory,
        rating: {
            ...product.rating,
            average: $c5e233d966994ba6$var$formatRating(product.rating?.average ?? 0)
        },
        price: product.price,
        discountedPrice: product.discounted_price,
        currencyCode: product.currency_code ?? (0, $bokng.defaultCurrency).code,
        features: (0, $1RJFN.decodeSpecialChars)(product.features ?? parent.features),
        brand: {
            id: brand?.id ?? "",
            name: brand?.value,
            url: $c5e233d966994ba6$export$781a62cd6a0f5ea6({
                name: brand?.value
            })
        },
        weight: attributes.find((a)=>a.name === "Weight")?.value,
        dimensions: attributes.find((a)=>a.name === "Dimensions")?.value,
        attributes: attributes.filter((a)=>![
                "Dimensions",
                "Weight"
            ].includes(a.name)).map($c5e233d966994ba6$var$parseAttributeForDisplay),
        featuredImage: featuredImage,
        images: $c5e233d966994ba6$var$sortImagesByDisplayOrder(product.images?.filter((i)=>i.url !== featuredImage.url)),
        isDownloadable: product.is_downloadable,
        isVirtual: product.is_virtual,
        archived: product.archived,
        allowPayOnDelivery: product.allow_pay_on_delivery,
        stockStatus: product.stock_status,
        isAvailable: $c5e233d966994ba6$var$isInStock(product),
        isNew: $c5e233d966994ba6$var$isNew(product),
        isOnSale: $c5e233d966994ba6$var$isOnSale(product),
        saleStartDate: product.sale_start_date,
        saleEndDate: product.sale_end_date,
        shippingClass: product.shipping_class,
        taxClass: product.tax_class,
        processingTime: product.processing_time,
        cancellationPolicy: (0, $1RJFN.decodeSpecialChars)(product.cancellation_policy ?? parent.cancellation_policy),
        refundPolicy: (0, $1RJFN.decodeSpecialChars)(product.refund_policy ?? parent.refund_policy),
        returnPolicy: (0, $1RJFN.decodeSpecialChars)(product.return_policy ?? parent.return_policy),
        shippingPolicy: (0, $1RJFN.decodeSpecialChars)(product.shipping_policy ?? parent.shipping_policy),
        purchaseNote: (0, $1RJFN.decodeSpecialChars)(product.purchase_note ?? parent.purchase_note),
        variants: (product.variants || []).map((v)=>$c5e233d966994ba6$export$784569cc2449831a(v, product))
    };
}
function $c5e233d966994ba6$export$784569cc2449831a(variant, parent) {
    if (!variant) return null;
    let { images: images } = variant;
    const { attributes: attributes } = variant;
    if (images.length === 0) images = images = parent.images;
    const featuredImage = $c5e233d966994ba6$export$b4a1d86b0c2b64eb(images);
    return {
        id: variant.id,
        sku: variant.sku,
        name: (0, $1RJFN.decodeSpecialChars)(parent.name),
        url: `${$c5e233d966994ba6$export$bb9e5e4e313054b8(parent)}?v=${variant.id}`,
        type: "ProductVariant",
        price: variant.price,
        discountedPrice: variant.discounted_price,
        currencyCode: variant.currency_code ?? (0, $bokng.defaultCurrency).code,
        status: variant.status,
        description: (0, $1RJFN.decodeSpecialChars)(variant.description ?? ""),
        isDownloadable: variant.is_downloadable,
        isVirtual: variant.is_virtual,
        archived: variant.archived,
        allowPayOnDelivery: variant.allow_pay_on_delivery,
        inventory: variant.inventory,
        stockStatus: variant.stock_status ?? "",
        isAvailable: $c5e233d966994ba6$var$isInStock(variant),
        isNew: $c5e233d966994ba6$var$isNew(variant),
        isOnSale: $c5e233d966994ba6$var$isOnSale(variant),
        saleStartDate: variant.sale_start_date,
        saleEndDate: variant.sale_end_date,
        weight: attributes.find((a)=>a.name === "Weight")?.value,
        dimensions: attributes.find((a)=>a.name === "Dimensions")?.value,
        attributes: attributes.filter((a)=>![
                "Dimensions",
                "Weight"
            ].includes(a.name)).map($c5e233d966994ba6$var$parseAttributeForDisplay),
        featuredImage: featuredImage,
        images: $c5e233d966994ba6$var$sortImagesByDisplayOrder(images?.filter((i)=>i.url !== featuredImage.url)),
        shippingClass: variant.shipping_class ?? "",
        taxClass: variant.tax_class ?? "",
        processingTime: variant.processing_time ?? "",
        rating: variant.rating,
        product: parent
    };
}
function $c5e233d966994ba6$export$37bd6492f9f0eff4(value) {
    return (0, $e6drH.isFloat)(value) ? Number(value.toFixed(1)) : value;
}
/*export function parseProductForDisplay(product) {
  // Product variants have a "product" property
  // pointing to the parent product
  const parent = product?.product;
  const parsedAttributes = parseProductAttributes(parent || product);
  const productImages = getProductImages(product);

  return {
    ...product,
    id: product.id,
    name: decodeSpecialChars(product.name || parent?.name),
    description: decodeSpecialChars(product.description || parent?.description),
    price: product.price,
    discountedPrice: product.discounted_price,
    currencyCode: defaultCurrency.code,
    url: getProductUrl(product),
    business: product.business || parent?.business,
    sku: product.sku,
    type: parent ? "ProductVariant" : "Product",
    category: product.category || parent?.category,
    //images: product.images,
    imageUrl: productImages[0].url,
    inventory: product.inventory,
    stockStatus: product.stock_status,
    allowPayOnDelivery: product.allow_pay_on_delivery,
    rawRating: rawRating(product.rating?.average),
    rating: formatRating(product.rating?.average),
    totalReviews: product.rating?.reviews,
    images: productImages.map(image => ({
      large: image.url,
      thumbnail: image.thumbnailUrl || image.url
    })),

    ...parsedAttributes,
    brand: getProductBrand(product),
  };
}*/ /*export function parseProductFromAdvancedSearchForDisplay(product) {
  //const { attributes } = product;
  const productImages = getProductImages(product);
  const parsedAttributes = parseProductAttributes(product);

  return {
    ...product,
    name: decodeSpecialChars(product.name),
    description: decodeSpecialChars(product.description),
    discountedPrice: product.discounted_price,
    currencyCode: defaultCurrency.code,
    url: getProductUrl(product),
    business: product.business,
    sku: product.sku,
    type: "Product",
    stockStatus: product.stock_status,
    allowPayOnDelivery: product.allow_pay_on_delivery,
    brands: product.brands,
    imageUrl: productImages[0].url,
    rawRating: rawRating(product.rating.average),
    rating: formatRating(product.rating.average),
    totalReviews: product.rating.reviews,
    images: productImages.map(image => ({
      large: image.url,
      thumbnail: image.thumbnailUrl || image.url
    })),
    /*attributes: attributes.reduce((map, productAttribute) => {
      //const attributeId = productAttribute.attribute.id;
      const attributeName = productAttribute.attribute.name;
      const attributeValue = productAttribute.value;
      const attributeKey = attributeName;

      (map[attributeKey] = map[attributeKey] || []).push(attributeValue);

      return map;
    }, {}),* /
    ...parsedAttributes,
    brand: getProductBrand(product),
  };
}*/ /*export function parseProductVariantFromAdvancedSearchForDisplay(variant) {
  const { product, attributes } = variant;
  const variantImages = variant?.images?.length > 0 ? variant.images : product.images;

  return {
    //...variant,
    id: variant.id, // This must never be the parent ID, it must be the variant's
    name: decodeSpecialChars(product.name),
    description: decodeSpecialChars(product.description),
    price: variant.price,
    discountedPrice: variant.discounted_price,
    currencyCode: defaultCurrency.code,
    url: getProductUrl(variant),
    business: product.business,
    sku: variant.sku,
    type: "ProductVariant",
    brands: product.brands,
    category: variant.category || product.category,
    imageUrl: variantImages[0].url,
    inventory: variant.inventory,
    rawRating: rawRating(variant.rating.average),
    rating: formatRating(variant.rating.average),
    totalReviews: variant.rating.reviews,
    images: variantImages.map(image => ({
      large: image.url,
      thumbnail: image.thumbnailUrl || image.url
    })),
    attributes: attributes.reduce((map, variantAttribute) => {
      //const attributeId = variantAttribute.attribute.id;
      const attributeName = variantAttribute.attribute.name;
      const attributeValue = variantAttribute.value;
      const attributeKey = attributeName;

      (map[attributeKey] = map[attributeKey] || []).push(attributeValue);

      return map;
    }, {}),
  };
}*/ // Helper functions
function $c5e233d966994ba6$var$formatRating(value) {
    return Math.round(value);
}
function $c5e233d966994ba6$var$getDefaultProductImageUrl() {
    return "images/product/product-placeholder.svg";
}
function $c5e233d966994ba6$var$isInStock(product) {
    let isAvailable = true;
    const isInStock = product.stock_status === "In stock";
    if (product.inventory) isAvailable = isInStock && product.inventory.quantity > 0;
    else isAvailable = isInStock;
    return isAvailable;
}
function $c5e233d966994ba6$var$isNew(product) {
    return (0, $1KXyM.isLessThanDays)(product.created_at, 7);
}
function $c5e233d966994ba6$var$isOnSale(product) {
    const now = (0, $1KXyM.toISODateString)(new Date());
    const { sale_start_date: sale_start_date, sale_end_date: sale_end_date } = product;
    const startDate = sale_start_date ?? now;
    const endDate = sale_end_date ?? now;
    return (0, $1KXyM.isBetweenDates)(startDate, endDate, now);
}
function $c5e233d966994ba6$var$parseAttributeForDisplay(attribute) {
    if (!attribute) return null;
    return {
        ...attribute,
        options: attribute.options ?? []
    };
}
function $c5e233d966994ba6$var$sortImagesByDisplayOrder(images) {
    return (0, $l8Aho.sort)(images, {
        by: "displayOrder",
        order: "asc"
    });
} /*function getProductBrand(product) {
  const parent = product?.product;
  const parsedAttributes = parseProductAttributes(parent || product);

  let oldBrandMethod: { name: string } | undefined;
  
  if(product?.brands?.length > 0) {
    oldBrandMethod = product?.brands[0];
  } else if(parent?.brands?.length > 0) {
    oldBrandMethod = parent?.brands[0];
  }

  return parsedAttributes.brand || oldBrandMethod?.name;
}*/  /*function getProductImages(product): Array<{ url: string, thumbnailUrl: string }> {
  const parent = product?.product;
  let productImages: Array<{ url: string, thumbnailUrl: string}>;

  if(product.images?.length > 0) {
    productImages = product.images;
  } else if(parent?.images?.length > 0) {
    productImages = parent.images;
  } else {
    const defaultProductImageUrl = getDefaultProductImageUrl();

    productImages = [{ url: defaultProductImageUrl, thumbnailUrl: defaultProductImageUrl }];
  }

  return productImages;
}*/  /*function parseProductAttributes(product) {
  const complexAttributes = product.attributes.filter(isComplexAttribute);
  const regularAttributes = product.attributes.filter(attribute => !isComplexAttribute(attribute));

  const allAttributes = [
    ...regularAttributes,
    ...(complexAttributes.map(prodAttribute => ({ 
      name: prodAttribute.attribute.name, 
      value: prodAttribute.value.value 
    }))),
    
  ];

  //return product.attributes.reduce((parsedAttributes, attribute) => {
  return allAttributes.reduce((parsedAttributes, attribute) => {
    if(["Brand", "Color", "Size"].includes(attribute.name)) {
      parsedAttributes[attribute.name.toLowerCase()] = attribute.value.name; 
    } else {
      parsedAttributes[attribute.name.toLowerCase()] = attribute.value;
    }

    return parsedAttributes;
  }, {});

  /*const attributes = product.attributes; 
  const parsedAttributes = {};

  for(const attribute of attributes) {
    parsedAttributes[attribute.name.toLowerCase()] = attribute.value;
  }

  return parsedAttributes;* /

  function isComplexAttribute(attribute) {
    // Attributes coming from advanced product search
    return ("attribute" in attribute && "value" in attribute);
  }
}*/ 

});
parcelRegister("bokng", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67bcc106cd8c54ac$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "defaultCurrency", function () { return $67bcc106cd8c54ac$export$d4e4337bfb8071d2; });

var $4WgQx = parcelRequire("4WgQx");
var $67bcc106cd8c54ac$export$2e2bcd8739ae039 = $4WgQx;
const $67bcc106cd8c54ac$export$d4e4337bfb8071d2 = $4WgQx["NGN" ?? "NGN"];

});
parcelRegister("4WgQx", function(module, exports) {

$parcel$export(module.exports, "EUR", function () { return $e166c1cf16bb6c94$export$56b85b07b2af7a09; });
$parcel$export(module.exports, "GBP", function () { return $e166c1cf16bb6c94$export$934d96ab768fd888; });
$parcel$export(module.exports, "INR", function () { return $e166c1cf16bb6c94$export$b58d7930a68cce5c; });
$parcel$export(module.exports, "NGN", function () { return $e166c1cf16bb6c94$export$fec9c06778f525b5; });
$parcel$export(module.exports, "USD", function () { return $e166c1cf16bb6c94$export$21abe75bbf5aa63c; });
const $e166c1cf16bb6c94$export$56b85b07b2af7a09 = {
    code: "EUR",
    name: "Euro",
    htmlEntity: "&#8364;",
    locale: "en-DE",
    symbol: "\u20AC"
};
const $e166c1cf16bb6c94$export$934d96ab768fd888 = {
    code: "GBP",
    name: "British Pound",
    htmlEntity: "&#163;",
    locale: "en-GB",
    symbol: "\xa3"
};
const $e166c1cf16bb6c94$export$b58d7930a68cce5c = {
    code: "INR",
    name: "Indian Rupee",
    htmlEntity: "&#8377",
    locale: "en-IN",
    symbol: "\u20B9"
};
const $e166c1cf16bb6c94$export$fec9c06778f525b5 = {
    code: "NGN",
    name: "Nigerian Naira",
    htmlEntity: "&#8358;",
    locale: "en-US",
    symbol: "\u20A6"
};
const $e166c1cf16bb6c94$export$21abe75bbf5aa63c = {
    code: "USD",
    name: "United States Dollar",
    htmlEntity: "&#36;",
    locale: "en-US",
    symbol: "$"
};

});


parcelRegister("l8Aho", function(module, exports) {

$parcel$export(module.exports, "removeDuplicates", function () { return $270cc6757e5f6dab$export$2e2262a44ac61957; });
$parcel$export(module.exports, "sort", function () { return $270cc6757e5f6dab$export$97db5808d8f88186; });

var $8ZeiI = parcelRequire("8ZeiI");
function $270cc6757e5f6dab$export$2e2262a44ac61957(data) {
    const keys = (data)=>Object.keys(data).map((k)=>data[k]).join("|");
    return data.filter(function(set) {
        return function(o) {
            return function(k) {
                if (!set.has(k)) {
                    set.add(k);
                    return true;
                }
                return false;
            }(keys(o));
        };
    }(new Set()));
}
function $270cc6757e5f6dab$export$97db5808d8f88186(array, sortOptions) {
    if (sortOptions?.by && sortOptions?.orderArray) return $270cc6757e5f6dab$var$_orderSort(array, sortOptions);
    else return (0, $8ZeiI.default)(array, sortOptions);
}
function $270cc6757e5f6dab$var$_orderSort(array, options) {
    const { by: by, order: order, orderArray: orderArray } = options;
    /*return array.sort((a, b) => {
    const indexA = orderArray.indexOf(a[by]);
    const indexB = orderArray.indexOf(b[by]);
  
    // Handle cases where an item is not in the order array
    // Place items not in the order array at the end by assigning them a high index
    const orderA = indexA === -1 ? orderArray.length : indexA;
    const orderB = indexB === -1 ? orderArray.length : indexB;
  
    return ((order === "desc") ? orderB - orderA : orderA - orderB);
  });*/ /*
   * Alternative: Create a map for better performance
   * For larger arrays, repeatedly calling indexOf() can be inefficient. 
   * A more performant approach is to create a map of the order array first.
   */ // Create a map from the order array for faster lookups
    const orderMap = orderArray.reduce((map, value, index)=>{
        map[value] = index;
        return map;
    }, {});
    return array.sort((a, b)=>order === "desc" ? orderMap[b[by]] - orderMap[a[by]] : orderMap[a[by]] - orderMap[b[by]]);
}

});
parcelRegister("8ZeiI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68af1d115ee18683$export$2e2bcd8739ae039; });

var $aLrJq = parcelRequire("aLrJq");

var $keIam = parcelRequire("keIam");
/**
 * Isomorphic, load-anywhere function to sort an array by scalar, deep or computed values in any standard or custom order.
 *
 * @module sort-array
 * @typicalname sortArray
 * @example
 * const sortArray = require('sort-array')
 */ /**
 * @param {Array} array - The input array to sort. It is sorted in place.
 * @param {object} [options] - Sort options.
 * @param {string[]} [options.by] - One or more property names or computed fields to sort by. Specifying property names is only relevant when sorting an array of objects.
 * @param {string[]} [options.order] - One or more sort orders. Specify `'asc'`, `'desc'` or a property name from the `options.customOrders` object.
 * @param {object} [options.customOrders] - A dictionary object containing one or more custom orders. Each custom order value must be an array defining the order expected values must be sorted in.
 * @param {object} [options.computed] - A dictionary object containing one or more computed field functions. The function will be invoked once per item in the array. Each invocation will receive the array item as input and must return a primitive value by which the array can be sorted.
 * @param {number} [options.nullRank] - Configures whether `null` values will be sorted before or after defined values. Set to `-1` for before, `1` for after. Defaults to `1`.
 * @param {number} [options.undefinedRank] - Configures whether `undefined` values will be sorted before or after defined values. Set to `-1` for before, `1` for after. Defaults to `1`.
 * @returns {Array} Returns the array that was passed in.
 * @alias module:sort-array
 */ function $68af1d115ee18683$var$sortArray(arr, options = {}) {
    options = Object.assign({
        computed: {},
        customOrders: {},
        nullRank: 1,
        undefinedRank: 1
    }, options);
    arr.sort($68af1d115ee18683$var$getCompareFunc(options));
    return arr;
}
function $68af1d115ee18683$var$getCompareFunc(options = {}) {
    const by = (0, $aLrJq.default)(options.by);
    const order = (0, $aLrJq.default)(options.order);
    const { customOrders: customOrders, computed: computed } = options;
    return function compareFunc(xIn, yIn, byIndex = 0) {
        const currOrder = order[byIndex] || 'asc';
        if (!(currOrder === 'asc' || currOrder === 'desc' || customOrders[currOrder])) return 0;
        let result, x, y;
        if (by.length) {
            x = (0, $keIam.default).isDefined(xIn[by[byIndex]]) ? xIn[by[byIndex]] : computed[by[byIndex]] && computed[by[byIndex]](xIn);
            y = (0, $keIam.default).isDefined(yIn[by[byIndex]]) ? yIn[by[byIndex]] : computed[by[byIndex]] && computed[by[byIndex]](yIn);
        } else {
            x = xIn;
            y = yIn;
        }
        if (customOrders && customOrders[currOrder]) result = customOrders[currOrder].indexOf(x) - customOrders[currOrder].indexOf(y);
        else if (x === y) result = 0;
        else if ((0, $keIam.default).isNull(x) && (0, $keIam.default).isUndefined(y)) result = currOrder === 'asc' ? 1 : currOrder === 'desc' ? -1 : 0;
        else if ((0, $keIam.default).isUndefined(x) && (0, $keIam.default).isNull(y)) result = currOrder === 'asc' ? -1 : currOrder === 'desc' ? 1 : 0;
        else if ((0, $keIam.default).isNull(x) && (0, $keIam.default).isDefinedValue(y)) result = options.nullRank;
        else if ((0, $keIam.default).isUndefined(x) && (0, $keIam.default).isDefinedValue(y)) result = options.undefinedRank;
        else if ((0, $keIam.default).isNull(y) && (0, $keIam.default).isDefinedValue(x)) result = -options.nullRank;
        else if ((0, $keIam.default).isUndefined(y) && (0, $keIam.default).isDefinedValue(x)) result = -options.undefinedRank;
        else {
            result = x < y ? -1 : x > y ? 1 : 0;
            if (currOrder === 'desc') result = result * -1;
        }
        if (result === 0 && (0, $keIam.default).isDefined(by[byIndex + 1])) result = compareFunc(xIn, yIn, byIndex + 1);
        return result;
    };
}
var $68af1d115ee18683$export$2e2bcd8739ae039 = $68af1d115ee18683$var$sortArray;

});
parcelRegister("aLrJq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d63ce15a9157556$export$2e2bcd8739ae039; });
/**
 * Takes any input and guarantees an array back.
 *
 * - Converts array-like objects (e.g. `arguments`, `Set`) to a real array.
 * - Converts `undefined` to an empty array.
 * - Converts any another other, singular value (including `null`, objects and iterables other than `Set`) into an array containing that value.
 * - Ignores input which is already an array.
 *
 * @module array-back
 * @example
 * > const arrayify = require('array-back')
 *
 * > arrayify(undefined)
 * []
 *
 * > arrayify(null)
 * [ null ]
 *
 * > arrayify(0)
 * [ 0 ]
 *
 * > arrayify([ 1, 2 ])
 * [ 1, 2 ]
 *
 * > arrayify(new Set([ 1, 2 ]))
 * [ 1, 2 ]
 *
 * > function f(){ return arrayify(arguments); }
 * > f(1,2,3)
 * [ 1, 2, 3 ]
 */ function $7d63ce15a9157556$var$isObject(input) {
    return typeof input === 'object' && input !== null;
}
function $7d63ce15a9157556$var$isArrayLike(input) {
    return $7d63ce15a9157556$var$isObject(input) && typeof input.length === 'number';
}
/**
 * @param {*} - The input value to convert to an array
 * @returns {Array}
 * @alias module:array-back
 */ function $7d63ce15a9157556$var$arrayify(input) {
    if (Array.isArray(input)) return input;
    else if (input === undefined) return [];
    else if ($7d63ce15a9157556$var$isArrayLike(input) || input instanceof Set) return Array.from(input);
    else return [
        input
    ];
}
var $7d63ce15a9157556$export$2e2bcd8739ae039 = $7d63ce15a9157556$var$arrayify;

});

parcelRegister("keIam", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebb75ff17355338d$export$2e2bcd8739ae039; });
/**
 * Isomorphic, functional type-checking for Javascript.
 * @module typical
 * @typicalname t
 * @example
 * import t from 'typical'
 * const allDefined = array.every(t.isDefined)
 */ /**
 * Returns true if input is a number (including infinity). It is a more reasonable alternative to `typeof n` which returns `number` for `NaN`.
 *
 * @param {*} n - The input to test
 * @returns {boolean} `true` if input is a number
 * @static
 * @example
 * > t.isNumber(0)
 * true
 * > t.isNumber(1)
 * true
 * > t.isNumber(1.1)
 * true
 * > t.isNumber(0xff)
 * true
 * > t.isNumber(0644)
 * true
 * > t.isNumber(6.2e5)
 * true
 * > t.isNumber(NaN)
 * false
 * > t.isNumber(Infinity)
 * true
 */ function $ebb75ff17355338d$export$7e4aa119212bc614(n) {
    return !isNaN(parseFloat(n));
}
function $ebb75ff17355338d$export$cf6c09818bd7035a(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $ebb75ff17355338d$export$53b83ca8eaab0383(input) {
    return input !== null && typeof input === 'object' && input.constructor === Object;
}
function $ebb75ff17355338d$export$1e2f57719e155213(input) {
    return $ebb75ff17355338d$export$a6cdc56e425d0d0a(input) && typeof input.length === 'number';
}
function $ebb75ff17355338d$export$a6cdc56e425d0d0a(input) {
    return typeof input === 'object' && input !== null;
}
function $ebb75ff17355338d$export$4e62c701997796c1(input) {
    return typeof input !== 'undefined';
}
function $ebb75ff17355338d$export$fce6876652108ab(input) {
    return !$ebb75ff17355338d$export$4e62c701997796c1(input);
}
function $ebb75ff17355338d$export$630801d484da15df(input) {
    return input === null;
}
function $ebb75ff17355338d$export$238d822591457a11(input) {
    return $ebb75ff17355338d$export$4e62c701997796c1(input) && !$ebb75ff17355338d$export$630801d484da15df(input) && !Number.isNaN(input);
}
function $ebb75ff17355338d$export$5578ef75f4140928(input) {
    if (typeof input === 'function') return /^class /.test(Function.prototype.toString.call(input));
    else return false;
}
function $ebb75ff17355338d$export$c3825b437cbdea5c(input) {
    if (input === null) return true;
    switch(typeof input){
        case 'string':
        case 'number':
        case 'symbol':
        case 'undefined':
        case 'boolean':
            return true;
        default:
            return false;
    }
}
function $ebb75ff17355338d$export$4369c812aac99591(input) {
    if (input) {
        const isPromise = $ebb75ff17355338d$export$4e62c701997796c1(Promise) && input instanceof Promise;
        const isThenable = input.then && typeof input.then === 'function';
        return !!(isPromise || isThenable);
    } else return false;
}
function $ebb75ff17355338d$export$9652023d9040757(input) {
    if (input === null || !$ebb75ff17355338d$export$4e62c701997796c1(input)) return false;
    else return typeof input[Symbol.iterator] === 'function' || typeof input[Symbol.asyncIterator] === 'function';
}
function $ebb75ff17355338d$export$844ec244b1367d54(input) {
    return typeof input === 'string';
}
function $ebb75ff17355338d$export$f6e2535fb5126e54(input) {
    return typeof input === 'function';
}
function $ebb75ff17355338d$export$cb3f0f7ea9814480(input) {
    return typeof input === 'function' && input.constructor.name === 'AsyncFunction';
}
var $ebb75ff17355338d$export$2e2bcd8739ae039 = {
    isNumber: $ebb75ff17355338d$export$7e4aa119212bc614,
    isFiniteNumber: $ebb75ff17355338d$export$cf6c09818bd7035a,
    isPlainObject: $ebb75ff17355338d$export$53b83ca8eaab0383,
    isArrayLike: $ebb75ff17355338d$export$1e2f57719e155213,
    isObject: $ebb75ff17355338d$export$a6cdc56e425d0d0a,
    isDefined: $ebb75ff17355338d$export$4e62c701997796c1,
    isUndefined: $ebb75ff17355338d$export$fce6876652108ab,
    isNull: $ebb75ff17355338d$export$630801d484da15df,
    isDefinedValue: $ebb75ff17355338d$export$238d822591457a11,
    isClass: $ebb75ff17355338d$export$5578ef75f4140928,
    isPrimitive: $ebb75ff17355338d$export$c3825b437cbdea5c,
    isPromise: $ebb75ff17355338d$export$4369c812aac99591,
    isIterable: $ebb75ff17355338d$export$9652023d9040757,
    isString: $ebb75ff17355338d$export$844ec244b1367d54,
    isFunction: $ebb75ff17355338d$export$f6e2535fb5126e54,
    isAsyncFunction: $ebb75ff17355338d$export$cb3f0f7ea9814480
};

});



parcelRegister("e6drH", function(module, exports) {

$parcel$export(module.exports, "calculateDiscountPercentage", function () { return $799dc6374ec237d1$export$ec5e97fc9b9d0839; });
$parcel$export(module.exports, "isFloat", function () { return $799dc6374ec237d1$export$4ba1d6600e2a2892; });
$parcel$export(module.exports, "toInteger", function () { return $799dc6374ec237d1$export$f728be4ab20cbf1f; });

var $bcfZL = parcelRequire("bcfZL");
function $799dc6374ec237d1$export$a0ec456f1b803019(price, discountPercentage) {
    return price - price * discountPercentage / 100;
}
function $799dc6374ec237d1$export$ec5e97fc9b9d0839(originalPrice, sellingPrice) {
    return Math.round((originalPrice - sellingPrice) / originalPrice * 100);
}
function $799dc6374ec237d1$export$87326579db5e2e(price, tax) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bcfZL)))(price).add(tax).value;
}
function $799dc6374ec237d1$export$32eed5f4447a26d2(price, taxPercentage = 7.5) {
    if (price === 0 || [
        0,
        0.0,
        0.00
    ].includes(taxPercentage)) return price;
    return price * (taxPercentage / 100);
}
function $799dc6374ec237d1$export$a0151d75660c2768(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $799dc6374ec237d1$export$4ba1d6600e2a2892(num) {
    return num % 1 !== 0;
}
function $799dc6374ec237d1$export$f728be4ab20cbf1f(value) {
    return parseInt(value, 10);
} /*
 * Works but currently not used since Intl.NumberFormat serves our purposes.

export function compactNumber(number, digits = 1) {
  const lookup = [
    { value: 1,    symbol: "" },
    { value: 1e0,  symbol: "" },
    { value: 1e3,  symbol: "k" },
    { value: 1e6,  symbol: "M" },
    { value: 1e9,  symbol: "B" }, // or for memory sizes "G"
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];

  if(!number) {
    return number;
  }

  const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
  const item = lookup.findLast(item => Math.abs(number) >= item.value);

  return (
    item
      ? (number / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol)
      : "0"
  );
}
*/ 

});
parcelRegister("bcfZL", function(module, exports) {
/*
 currency.js - v2.0.4
 http://scurker.github.io/currency.js

 Copyright (c) 2021 Jason Wilson
 Released under MIT license
*/ (function(e, g) {
    module.exports = g();
})(module.exports, function() {
    function e(b, a) {
        if (!(this instanceof e)) return new e(b, a);
        a = Object.assign({}, m, a);
        var d = Math.pow(10, a.precision);
        this.intValue = b = g(b, a);
        this.value = b / d;
        a.increment = a.increment || 1 / d;
        a.groups = a.useVedic ? n : p;
        this.s = a;
        this.p = d;
    }
    function g(b, a) {
        var d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : !0;
        var c = a.decimal;
        var h = a.errorOnInvalid, k = a.fromCents, l = Math.pow(10, a.precision), f = b instanceof e;
        if (f && k) return b.intValue;
        if ("number" === typeof b || f) c = f ? b.value : b;
        else if ("string" === typeof b) h = new RegExp("[^-\\d" + c + "]", "g"), c = new RegExp("\\" + c, "g"), c = (c = b.replace(/\((.*)\)/, "-$1").replace(h, "").replace(c, ".")) || 0;
        else {
            if (h) throw Error("Invalid Input");
            c = 0;
        }
        k || (c = (c * l).toFixed(4));
        return d ? Math.round(c) : c;
    }
    var m = {
        symbol: "$",
        separator: ",",
        decimal: ".",
        errorOnInvalid: !1,
        precision: 2,
        pattern: "!#",
        negativePattern: "-!#",
        format: function(b, a) {
            var d = a.pattern, c = a.negativePattern, h = a.symbol, k = a.separator, l = a.decimal;
            a = a.groups;
            var f = ("" + b).replace(/^-/, "").split("."), q = f[0];
            f = f[1];
            return (0 <= b.value ? d : c).replace("!", h).replace("#", q.replace(a, "$1" + k) + (f ? l + f : ""));
        },
        fromCents: !1
    }, p = /(\d)(?=(\d{3})+\b)/g, n = /(\d)(?=(\d\d)+\d\b)/g;
    e.prototype = {
        add: function(b) {
            var a = this.s, d = this.p;
            return e((this.intValue + g(b, a)) / (a.fromCents ? 1 : d), a);
        },
        subtract: function(b) {
            var a = this.s, d = this.p;
            return e((this.intValue - g(b, a)) / (a.fromCents ? 1 : d), a);
        },
        multiply: function(b) {
            var a = this.s;
            return e(this.intValue * b / (a.fromCents ? 1 : Math.pow(10, a.precision)), a);
        },
        divide: function(b) {
            var a = this.s;
            return e(this.intValue / g(b, a, !1), a);
        },
        distribute: function(b) {
            var a = this.intValue, d = this.p, c = this.s, h = [], k = Math[0 <= a ? "floor" : "ceil"](a / b), l = Math.abs(a - k * b);
            for(d = c.fromCents ? 1 : d; 0 !== b; b--){
                var f = e(k / d, c);
                0 < l-- && (f = f[0 <= a ? "add" : "subtract"](1 / d));
                h.push(f);
            }
            return h;
        },
        dollars: function() {
            return ~~this.value;
        },
        cents: function() {
            return ~~(this.intValue % this.p);
        },
        format: function(b) {
            var a = this.s;
            return "function" === typeof b ? b(this, a) : a.format(this, Object.assign({}, a, b));
        },
        toString: function() {
            var b = this.s, a = b.increment;
            return (Math.round(this.intValue / this.p / a) * a).toFixed(b.precision);
        },
        toJSON: function() {
            return this.value;
        }
    };
    return e;
});

});




parcelRegister("7JoNl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $612f40c6f9266408$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $g2KM2 = parcelRequire("g2KM2");

var $1nvlT = parcelRequire("1nvlT");
function $612f40c6f9266408$var$Header() {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("header", {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $g2KM2.default), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1nvlT.default), {})
        ]
    });
}
var $612f40c6f9266408$export$2e2bcd8739ae039 = $612f40c6f9266408$var$Header;

});
parcelRegister("g2KM2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e937c4e5b56cace$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $bGXlg = parcelRequire("bGXlg");

var $7dOZN = parcelRequire("7dOZN");

var $03uJQ = parcelRequire("03uJQ");
parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");

var $l8Aho = parcelRequire("l8Aho");

var $fJI9q = parcelRequire("fJI9q");

var $1RJFN = parcelRequire("1RJFN");

var $dQKsl = parcelRequire("dQKsl");

var $iA5sF = parcelRequire("iA5sF");

var $2Nb4S = parcelRequire("2Nb4S");

var $bFoIU = parcelRequire("bFoIU");

var $fLIY3 = parcelRequire("fLIY3");

var $kPAf0 = parcelRequire("kPAf0");
function $1e937c4e5b56cace$export$2e2bcd8739ae039() {
    const [queryStringData] = (0, $2Nb4S.default)();
    const { categoryName: categoryName } = (0, $bFoIU.default)(); // Only applies if we are on the CATEGORY (/shop/categories/:categoryName) page
    //const [categoriesData, fetchCategoriesData] = useCategories();
    const { values: formData, handleChange: handleFormFieldChange } = (0, $dQKsl.default)({
        query: queryStringData.query ?? "",
        category: queryStringData.category?.toLowerCase() ?? categoryName?.toLowerCase() ?? ""
    }, {
        onInputChange: (e)=>{
            if (e.target.name === "category") refs?.query?.current?.focus(); // We are able to get access to refs due to closure
        }
    });
    const [refs] = (0, $iA5sF.default)(formData);
    const searchBtnRef = (0, $exYeM.useRef)(null);
    const topLevelCategories = (0, $fJI9q.topLevelCategoryNames).filter((name)=>name.toLowerCase() !== "other categories").map((name)=>({
            id: (0, $1RJFN.stringToSlug)(name),
            name: name
        }));
    const categoriesData = {
        categories: topLevelCategories
    };
    const sortedCategories = (0, $l8Aho.sort)(categoriesData?.categories ?? [], {
        by: "name"
    }).concat((0, $fJI9q.topLevelCategoryNames).filter((name)=>name.toLowerCase() === "other categories").map((name)=>({
            id: (0, $1RJFN.stringToSlug)(name),
            name: name
        })));
    //useEffect(() => { fetchCategoriesData(); }, []);
    (0, $exYeM.useEffect)(()=>{
        if (refs.category?.current) {
            refs.category.current.addEventListener("focus", handleCategoryFieldFocus);
            refs.category.current.addEventListener("blur", handleCategoryFieldBlur);
            refs.category.current.addEventListener("mouseover", handleFormFieldMouseOver);
            refs.category.current.addEventListener("mouseout", handleFormFieldMouseOut);
        }
        if (refs.query?.current) {
            refs.query.current.addEventListener("focus", handleQueryFieldFocus);
            refs.query.current.addEventListener("blur", handleQueryFieldBlur);
            refs.query.current.addEventListener("mouseover", handleFormFieldMouseOver);
            refs.query.current.addEventListener("mouseout", handleFormFieldMouseOut);
        }
        return function cleanup() {
            if (refs.category?.current) {
                refs.category.current.removeEventListener("focus", handleCategoryFieldFocus);
                refs.category.current.removeEventListener("blur", handleCategoryFieldBlur);
                refs.category.current.removeEventListener("mouseover", handleFormFieldMouseOver);
                refs.category.current.removeEventListener("mouseout", handleFormFieldMouseOut);
            }
            if (refs?.query?.current) {
                refs.query.current.removeEventListener("focus", handleQueryFieldFocus);
                refs.query.current.removeEventListener("blur", handleQueryFieldBlur);
                refs.query.current.removeEventListener("mouseout", handleFormFieldMouseOver);
                refs.query.current.removeEventListener("mouseout", handleFormFieldMouseOut);
            }
        };
        function handleCategoryFieldFocus() {
            if (refs.query?.current) refs.query.current.classList.add("bordered");
            if (searchBtnRef?.current) searchBtnRef.current.classList.add("bordered");
            // If we hovered over the category or search input element before focusing, 
            // undo the hover effect previously applied.
            handleFormFieldMouseOut();
        }
        function handleCategoryFieldBlur() {
            if (refs.query?.current) refs.query.current.classList.remove("bordered");
            if (searchBtnRef?.current) searchBtnRef.current.classList.remove("bordered");
        }
        function handleQueryFieldFocus() {
            if (refs.category?.current) refs.category.current.classList.add("bordered");
            if (searchBtnRef?.current) searchBtnRef.current.classList.add("bordered");
            // If we hovered over the category or search input element before focusing, 
            // undo the hover effect previously applied.
            handleFormFieldMouseOut();
        }
        function handleQueryFieldBlur() {
            if (refs.category?.current) refs.category.current.classList.remove("bordered");
            if (searchBtnRef?.current) searchBtnRef.current.classList.remove("bordered");
        }
        function handleFormFieldMouseOver() {
            if ([
                refs.category?.current,
                refs.query?.current
            ].includes(document.activeElement)) // If the category field or the search input field has focus, 
            // then, ignore the hover (mouseover).
            return;
            if (refs.category?.current) refs.category.current.classList.add("hovered");
            if (refs.query?.current) refs.query.current.classList.add("hovered");
        }
        function handleFormFieldMouseOut() {
            if (refs.category?.current) refs.category.current.classList.remove("hovered");
            if (refs.query?.current) refs.query.current.classList.remove("hovered");
        }
    }, [
        refs.category?.current,
        refs.query?.current
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "header-middle pl-sm-0 pr-sm-0 pl-xs-0 pr-xs-0",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "col-lg-3",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "brand logo pb-sm-30 pb-xs-30",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                to: (0, $hSqCk).HOME,
                                end: true,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                    className: "brand-logo",
                                    src: "/images/branding/SecondaryLogo.png",
                                    alt: `${"NearBuyCart"} logo`
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "col-lg-9 pl-0 ml-sm-15 ml-xs-15",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                                action: (0, $hSqCk).SEARCH,
                                className: "hm-searchbox raised",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $03uJQ.default), {
                                        name: "category",
                                        className: "nice-select select-search-category",
                                        ref: refs.category,
                                        value: formData.category.toLowerCase(),
                                        onChange: handleFormFieldChange,
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("option", {
                                                value: "",
                                                children: "All Categories"
                                            }),
                                            sortedCategories.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $aSiaI.jsx)("option", {
                                                    value: name.toLowerCase(),
                                                    children: name
                                                }, id))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7dOZN.default), {
                                        name: "query",
                                        placeholder: "Enter your search term ...",
                                        ref: refs.query,
                                        value: formData.query,
                                        onChange: handleFormFieldChange
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        className: "li-btn header-search-btn raised",
                                        type: "submit",
                                        ref: searchBtnRef,
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                                            className: "fa fa-search"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "header-middle-right",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                    className: "hm-menu",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                            className: "hm-wishlist raised",
                                            title: "My Wishlist",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kPAf0.default), {})
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                            className: "hm-minicart raised",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fLIY3.default), {})
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}

});
parcelRegister("7dOZN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e19447168fd1fc76$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

function $e19447168fd1fc76$export$2e2bcd8739ae039(props) {
    const { placeholder: placeholder = "", className: className, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest } = props;
    const node = (0, $exYeM.useRef)(null);
    const [fieldPlaceholder, setFieldPlaceholder] = (0, $exYeM.useState)(placeholder);
    /**
   * React refs refer to DOM elements not to custom compoents.
   * To pass a ref from a custom component to the DOM component of a child
   * (aka nested) component, we previously had to use React.forwardRef.
   *
   * However, React.forwardRef is soon to be deprecated,
   * and the React guys says we can now use a 'ref' prop directly just like other props.
   * @see: https://react.dev/reference/react/forwardRef
   * @see: https://react.dev/blog/2024/12/05/react-19#ref-as-a-prop
   *
   * Also, in addition to the ref passed from the parent component,
   * we are also using an inner ref which is also needed by this component.
   * To have both refs (passed and internal) refer to the same DOM element,
   * we use this useImperativeHandle trick.
   *
   * > Call the useImperativeHandle hook on the outer ref
   * > (which is being forwarded to the child component)
   * > and pass a function that returns the current property of the inner ref,
   * > which is the value that will be set to the current property of the outer ref.
   *
   * > Remember to list any dependencies of the function that returns the ref value,
   * > similar to useEffect.
   *
   * @see: https://stackoverflow.com/a/77055616/1743192
   */ (0, $exYeM.useImperativeHandle)(ref, ()=>node.current, []);
    function handleInputBlur(e) {
        e.preventDefault();
        setFieldPlaceholder(placeholder);
        if (typeof onBlur === "function") onBlur(e);
    }
    function handleInputFocus(e) {
        e.preventDefault();
        setFieldPlaceholder("");
        if (typeof onFocus === "function") onFocus(e);
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
        ref: node,
        className: `form-control input-field ${className ? className : ""}`,
        placeholder: fieldPlaceholder,
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        ...rest
    });
}

});

parcelRegister("03uJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6d9f49af8a4ec35$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
function $a6d9f49af8a4ec35$export$2e2bcd8739ae039(props) {
    const { className: className, children: children, ref: ref, value: value, ...rest } = props;
    const node = (0, $exYeM.useRef)(null);
    /**
   * React refs refer to DOM elements not to custom compoents.
   * To pass a ref from a custom component to the DOM component of a child
   * (aka nested) component, we previously had to use React.forwardRef.
   *
   * However, React.forwardRef is soon to be deprecated,
   * and the React guys says we can now use a 'ref' prop directly just like other props.
   * @see: https://react.dev/reference/react/forwardRef
   * @see: https://react.dev/blog/2024/12/05/react-19#ref-as-a-prop
   *
   * Also, in addition to the ref passed from the parent component,
   * we are also using an inner ref which is also needed by this component.
   * To have both refs (passed and internal) refer to the same DOM element,
   * we use this useImperativeHandle trick.
   *
   * > Call the useImperativeHandle hook on the outer ref
   * > (which is being forwarded to the child component)
   * > and pass a function that returns the current property of the inner ref,
   * > which is the value that will be set to the current property of the outer ref.
   *
   * > Remember to list any dependencies of the function that returns the ref value,
   * > similar to useEffect.
   *
   * @see: https://stackoverflow.com/a/77055616/1743192
   */ (0, $exYeM.useImperativeHandle)(ref, ()=>node.current, []);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("select", {
        ref: node,
        value: value,
        className: `form-control ${className ? className : ""}`,
        ...rest,
        children: children
    });
}

});

parcelRegister("fJI9q", function(module, exports) {

$parcel$export(module.exports, "topLevelCategoryNames", function () { return $e3ba8ac79bb3282c$export$eb0158b57a72f61f; });
$parcel$export(module.exports, "buildCategoryStringForApiCall", function () { return $e3ba8ac79bb3282c$export$2168b03f92532092; });
$parcel$export(module.exports, "parseCategories", function () { return $e3ba8ac79bb3282c$export$2d9dfae9dd50d547; });

var $gbNm9 = parcelRequire("gbNm9");
const $e3ba8ac79bb3282c$export$eb0158b57a72f61f = [
    "Appliances",
    "Computers & Accessories",
    "Electronics",
    "Phones & Tablets",
    "Fashion",
    "Sports",
    "Gaming",
    "Baby Products",
    "Building Materials",
    "Garden & Outdoors",
    "Health & Beauty",
    "Home & Office",
    "Industrial & Scientific",
    "Musical Instruments",
    "Supermarket",
    "Other Categories"
];
function $e3ba8ac79bb3282c$export$2168b03f92532092(categoryObject) {
    let category = (0, $gbNm9.deepClone)(categoryObject);
    const categoryNames = [];
    function buildCategoryWithChildrenNameArray(category) {
        const names = [
            category.name
        ];
        if (category.children) for(let i = 0; i < category.children.length; i++){
            const child = category.children[i];
            names.push(child.name);
            if (child.children) names.push(...buildCategoryWithChildrenNameArray(child));
        }
        return names;
    }
    if (category.children) // If a category that has gone through the parseCategories() function
    // the category will have a children array.
    categoryNames.push(...buildCategoryWithChildrenNameArray(category));
    else while(category){
        categoryNames.push(category.name);
        category = category.parent;
    }
    return categoryNames.map((name)=>name.toLowerCase()).join(";");
}
function $e3ba8ac79bb3282c$export$2d9dfae9dd50d547(categories) {
    const childCategories = categories.filter((category)=>Boolean(category.parent));
    const parentCategories = categories.filter((category)=>!category.parent).map((category)=>$e3ba8ac79bb3282c$var$populateWithChildren(category, childCategories));
    const topLevelCategories = parentCategories.sort((a, b)=>a.name.localeCompare(b.name));
    /* Uncomment these lines if we need to use second- and third-level categories
  const topLevelCategoryNames = getCategoryNames(topLevelCategories);
  const secondLevelCategories = (parentCategories
    .filter(category => !(topLevelCategoryNames.includes(category.name))) 
    .sort((a, b) => a.name.localeCompare(b.name))
  );

  const secondLevelCategoryNames = getCategoryNames(secondLevelCategories);
  const thirdLevelCategories = (categories
    .filter(category => !(secondLevelCategoryNames.includes(category.name)))
    .sort((a, b) => a.name.localeCompare(b.name))
  );
  */ return {
        topLevelCategories: topLevelCategories
    };
}
/*function getCategoryNames(categories: Category[]): string[] {
  return categories.map(category => category.name);
}*/ // Helper function to find the top-level parent name
/*function getTopLevelParent(category: Category) {
  let parent = category.parent;

  while(parent && parent.parent) {
    parent = parent.parent;
  }

  return parent;
}*/ function $e3ba8ac79bb3282c$var$populateWithChildren(category, childCategories) {
    return {
        ...category,
        children: childCategories.filter((cc)=>cc.parent?.id === category.id).map((child)=>$e3ba8ac79bb3282c$var$populateWithChildren(child, childCategories)).sort((a, b)=>a.name.localeCompare(b.name))
    };
}

});
parcelRegister("gbNm9", function(module, exports) {

$parcel$export(module.exports, "deepClone", function () { return $56f4ae773d06f9f1$export$b7d58db314e0ac27; });
$parcel$export(module.exports, "deepEqual", function () { return $56f4ae773d06f9f1$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "getKeyFromValue", function () { return $56f4ae773d06f9f1$export$64b8078172f9a157; });

var $9HiNL = parcelRequire("9HiNL");
function $56f4ae773d06f9f1$export$b7d58db314e0ac27(obj) {
    /*
   * If we are dealing with a falsy value
   * (null, undefined, the empty string, false, 0, etc.),
   * return as-is
   */ if (!obj) return obj;
    /*
   * Check if we are dealing with a simple primitive/scalar type.
   * If so, return it as-is
   */ if ((0, $9HiNL.default).scalar(obj)) return obj;
    /*
   * If we are dealing with an object of a Built-in type,
   * e.g., new Boolean(true), new Number(123), new String('Jamie'),
   * normalize it to its primitives equivalent
   */ const primitive = $56f4ae773d06f9f1$var$toPrimitive(obj);
    /*
   * If we got a valid primitive of type Number, String or Boolean,
   * just return it
   */ if (typeof primitive !== "undefined") return primitive;
    /*
   * We are dealing with a complex object
   * (such as an array, Date, HTML DOM Node, or an object literal)
   */ let clone;
    if ((0, $9HiNL.default).array(obj)) {
        clone = [];
        obj.forEach((element, index)=>clone[index] = $56f4ae773d06f9f1$export$b7d58db314e0ac27(element));
    } else if (obj instanceof Date) clone = new Date(obj);
    else if (obj.nodeType && typeof obj.cloneNode === "function") clone = obj.cloneNode(true);
    else if (typeof obj === "function" || obj instanceof Function) clone = $56f4ae773d06f9f1$var$cloneFunction(obj);
    else {
        clone = typeof obj.constructor === "function" ? new obj.constructor(obj) : {}; // We have an object literal
        for(const x in obj)clone[x] = $56f4ae773d06f9f1$export$b7d58db314e0ac27(obj[x]);
    }
    return clone;
}
function $56f4ae773d06f9f1$export$9cb4719e2e525b7a(x, y) {
    if (x === y) return true;
    if (typeof x == "object" && x != null && typeof y == "object" && y != null) {
        if (Object.keys(x).length != Object.keys(y).length) return false;
        for(const prop in x){
            if (Object.prototype.hasOwnProperty.call(y, prop)) {
                if (!$56f4ae773d06f9f1$export$9cb4719e2e525b7a(x[prop], y[prop])) return false;
            } else return false;
        }
        return true;
    }
    return false;
}
function $56f4ae773d06f9f1$export$64b8078172f9a157(object, value) {
    return Object.keys(object).find((key)=>object[key] === value);
}
// Helpers 
function $56f4ae773d06f9f1$var$cloneFunction(fn) {
    const temp = function temporary(...args) {
        return fn.apply(this, args);
    };
    for(const key in fn)if (Object.prototype.hasOwnProperty.call(fn, key)) temp[key] = fn[key];
    return temp;
}
function $56f4ae773d06f9f1$var$toPrimitive(obj) {
    for (const type of [
        Boolean,
        Number,
        String
    ]){
        if (obj instanceof type) return type(obj);
    }
} /**
 * Deep (recursive) Object.freeze
 */  /*function deepFreezeObject(o) {
  Object.freeze(o);

  if(o === null) {
    return o;
  }

  Object.getOwnPropertyNames(o).forEach(function freezeRecursive(prop) {
    if(o[prop] && ["function", "object"].includes(typeof o[prop]) &&
      !Object.isFrozen(o[prop])) {
      deepFreezeObject(o[prop]);
    }
  });

  return o;
}*/ 

});
parcelRegister("9HiNL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70f6b6d2f8f19940$export$2e2bcd8739ae039; });
var $70f6b6d2f8f19940$export$2e2bcd8739ae039 = {
    array: $70f6b6d2f8f19940$var$isArray,
    boolean: $70f6b6d2f8f19940$var$isBoolean,
    empty: $70f6b6d2f8f19940$var$isEmpty,
    falsy: $70f6b6d2f8f19940$var$isFalsy,
    "function": $70f6b6d2f8f19940$var$isFunction,
    number: $70f6b6d2f8f19940$var$isNumber,
    numeric: $70f6b6d2f8f19940$var$isNumeric,
    object: $70f6b6d2f8f19940$var$isObject,
    scalar: $70f6b6d2f8f19940$var$isScalar,
    string: $70f6b6d2f8f19940$var$isString,
    undefined: $70f6b6d2f8f19940$var$isUndefined
};
function $70f6b6d2f8f19940$var$isArray(data) {
    return typeof Array.isArray === "function" ? Array.isArray(data) : Object.prototype.toString.call(data) === "[object Array]";
}
function $70f6b6d2f8f19940$var$isBoolean(data) {
    return typeof data === "boolean";
}
function $70f6b6d2f8f19940$var$isEmpty(data) {
    if ($70f6b6d2f8f19940$var$isArray(data)) return data.length === 0;
    if ($70f6b6d2f8f19940$var$isObject(data)) return Object.keys(data).length === 0;
    return [
        0,
        null,
        false,
        NaN,
        undefined,
        ""
    ].includes(data);
}
function $70f6b6d2f8f19940$var$isFalsy(val) {
    return [
        0,
        false,
        NaN,
        null,
        undefined,
        ""
    ].includes(val);
}
function $70f6b6d2f8f19940$var$isFunction(fn) {
    return typeof fn === "function";
}
function $70f6b6d2f8f19940$var$isNumber(num) {
    num = Number(num);
    return Number.isNaN(num) ? false : true;
}
function $70f6b6d2f8f19940$var$isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $70f6b6d2f8f19940$var$isObject(data) {
    return typeof data === "object" && data && !$70f6b6d2f8f19940$var$isArray(data);
}
function $70f6b6d2f8f19940$var$isScalar(obj) {
    return !$70f6b6d2f8f19940$var$isArray(obj) && !$70f6b6d2f8f19940$var$isFunction(obj) && typeof obj !== "object";
}
function $70f6b6d2f8f19940$var$isString(data) {
    return typeof data === "string";
}
function $70f6b6d2f8f19940$var$isUndefined(data) {
    return typeof data === "undefined";
}

});



parcelRegister("dQKsl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9d248aaefcda9bb$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
function $a9d248aaefcda9bb$export$2e2bcd8739ae039(initialValues, options) {
    const [values, setValues] = (0, $exYeM.useState)(initialValues);
    const { onInputChange: onInputChange } = options ?? {};
    return {
        values: values,
        setValues: setValues,
        handleChange: (e)=>{
            setValues({
                ...values,
                [e.target.name]: e.target.value
            });
            if (typeof onInputChange === "function") onInputChange(e);
        /*const { name, value } = e.target;

      setValues(prevValues => ({
        ...prevValues,
        [name]: value
      }));*/ },
        reset: ()=>setValues(initialValues)
    };
}

});

parcelRegister("iA5sF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7843dd68f35cac97$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
function $7843dd68f35cac97$export$2e2bcd8739ae039(formData) {
    const refs = Object.keys(formData).reduce((acc, name)=>{
        if ([
            "business",
            "category",
            "status"
        ].includes(name)) acc[name] = (0, $exYeM.useRef)(null);
        else acc[name] = (0, $exYeM.useRef)(null);
        return acc;
    }, {});
    function setFocusOnField(fieldname) {
        refs[fieldname]?.current?.focus();
    }
    return [
        refs,
        setFocusOnField
    ];
}

});

parcelRegister("2Nb4S", function(module, exports) {

$parcel$export(module.exports, "parseAsNumber", function () { return $f5203adb076c94bc$export$88913b267eaf82e3; });
$parcel$export(module.exports, "parseAsString", function () { return $f5203adb076c94bc$export$2d07c45fecfefade; });
$parcel$export(module.exports, "default", function () { return $f5203adb076c94bc$export$2e2bcd8739ae039; });
/**
 * With the default react-router's search params first argument (search),
 * when we have a url like: /books?title=Node&rating=5, we'd have to obtain
 * the query paramaters and values using method calls like:
 * const title = search.get("title");
 * const rating = search.get("rating");
 *
 * Our custom search params wraps react-router's search params and
 * returns and object that lets us query for properties directly:
 * const title = query.title
 * const rating = query.rating
 *
 * Our custom implementation also takes an object with optional transformation functions.
 * It iterates through each transformation function
 * and if it finds a match between transformation function and search param
 * it applies the function onto the search param.
 *
 * For example, we could do something like this:
 * const transformers = {
 *   parseAsBoolean: (string = '') => string === 'true',
 *   parseAsNumber: (string = '') => (string ? Number(string) : null),
 *   // other transformation functions to map all data types
 * };
 *
 * @credits: https://www.robinwieruch.de/react-router-search-params/
 */ 
var $i5N2N = parcelRequire("i5N2N");
function $f5203adb076c94bc$export$166e49b06e53891d(input) {
    return Boolean(input);
}
function $f5203adb076c94bc$export$88913b267eaf82e3(input) {
    const num = Number(input);
    return num ?? null;
}
function $f5203adb076c94bc$export$2d07c45fecfefade(input) {
    return input ? String(input) : "";
}
function $f5203adb076c94bc$export$2e2bcd8739ae039(transformers = {}) {
    const [search, setSearch] = (0, $i5N2N.useSearchParams)();
    const searchAsObject = Object.fromEntries(new URLSearchParams(search));
    const transformedSearch = Object.keys(transformers).reduce((acc, key)=>{
        return {
            ...acc,
            [key]: transformers[key](acc[key])
        };
    }, searchAsObject);
    return [
        transformedSearch,
        setSearch
    ];
}

});

parcelRegister("bFoIU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aff44a833fc794a4$export$2e2bcd8739ae039; });

var $i5N2N = parcelRequire("i5N2N");
function $aff44a833fc794a4$export$2e2bcd8739ae039() {
    return (0, $i5N2N.useParams)();
}

});

parcelRegister("fLIY3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40594c3f3b067895$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $i5N2N = parcelRequire("i5N2N");

var $hhQDo = parcelRequire("hhQDo");

var $bokng = parcelRequire("bokng");

var $ekqph = parcelRequire("ekqph");

var $jSimJ = parcelRequire("jSimJ");
parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");

var $dA2xi = parcelRequire("dA2xi");

var $9Liyz = parcelRequire("9Liyz");

var $15Ljq = parcelRequire("15Ljq");
var $40594c3f3b067895$export$2e2bcd8739ae039 = (0, $jSimJ.withAccordionProvider)($40594c3f3b067895$var$Minicart);
function $40594c3f3b067895$var$Minicart() {
    const cart = (0, $15Ljq.useCart)();
    const [cartItemsCount, setCartItemsCount] = (0, $exYeM.useState)(0);
    const [cartCost, setCartCost] = (0, $exYeM.useState)(0);
    const { toggle: toggle } = (0, $jSimJ.useAccordionApi)();
    //const { isExpanded } = useAccordionState();
    (0, $exYeM.useEffect)(()=>{
        if (cart) {
            setCartCost((0, $dA2xi.calculateCost)(cart.items)?.totalSellingPrice ?? 0);
            setCartItemsCount((0, $dA2xi.countTotalItemsInCart)(cart));
        }
    }, [
        cart
    ]);
    function toggleMiniCartDisplay(e) {
        e.preventDefault();
        //setShowMiniCart(!showMiniCart);
        toggle();
    }
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "hm-minicart-trigger",
                onClick: toggleMiniCartDisplay,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "item-icon"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                        className: "item-text",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $hhQDo.default), {
                                amount: cartCost,
                                currencyCode: (0, $bokng.defaultCurrency).code,
                                compact: true
                            }),
                            !cart && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "cart-item-count loading",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ekqph.default), {})
                            }),
                            cartItemsCount > 0 && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "cart-item-count",
                                children: cartItemsCount
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $jSimJ.Accordion), {
                className: "minicart",
                expanded: false,
                children: [
                    cartItemsCount === 0 && /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        children: "There are no items in your cart yet. Add items to your cart to see them reflected here."
                    }),
                    cartItemsCount > 0 && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                className: "minicart-product-list",
                                children: cart?.items?.map((item)=>/*#__PURE__*/ (0, $aSiaI.jsx)($40594c3f3b067895$var$CartItemDetails, {
                                        cartId: cart.id,
                                        itemId: item.id,
                                        itemType: item.type,
                                        itemPrice: item.discountedPrice ?? item.price,
                                        quantity: item.quantity
                                    }, item.id))
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("p", {
                                className: "minicart-total",
                                children: [
                                    "Subtotal:",
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $hhQDo.default), {
                                            amount: cartCost,
                                            currencyCode: (0, $bokng.defaultCurrency).code,
                                            compact: false
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "minicart-button",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $i5N2N.NavLink), {
                                        to: (0, $hSqCk).CART,
                                        className: "li-button li-button-dark li-button-fullwidth li-button-sm",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: "View Full Cart"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $i5N2N.NavLink), {
                                        to: (0, $hSqCk).CHECKOUT,
                                        className: "li-button li-button-fullwidth li-button-sm",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: "Checkout"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $40594c3f3b067895$var$CartItemDetails(props) {
    const { cartId: cartId, itemId: itemId, itemType: itemType, itemPrice: itemPrice, quantity: quantity } = props;
    const [isFetching, setIsFetching] = (0, $exYeM.useState)(false);
    const [itemDetails, setItemDetails] = (0, $exYeM.useState)(null);
    const [itemDetailsUrl, setItemDetailsUrl] = (0, $exYeM.useState)("");
    (0, $exYeM.useEffect)(()=>{
        fetchDetails();
        async function fetchDetails() {
            setIsFetching(true);
            const itemData = await (0, $15Ljq.fetchItemDetails)({
                itemId: itemId,
                itemType: itemType
            });
            if (itemData) {
                setItemDetails(itemData);
                setItemDetailsUrl((0, $9Liyz.getProductUrl)({
                    id: itemData.id
                }));
            }
            setIsFetching(false);
        }
    }, [
        itemId,
        itemType
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
        children: [
            isFetching && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "Fetching..."
            }),
            !isFetching && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $i5N2N.NavLink), {
                        to: itemDetailsUrl,
                        className: "minicart-product-image",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                            src: itemDetails?.featuredImage?.url,
                            alt: "cart products"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "minicart-product-details",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h6", {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $i5N2N.NavLink), {
                                    to: itemDetailsUrl,
                                    children: itemDetails?.name?.substring(0, 15)
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $hhQDo.default), {
                                        amount: itemPrice,
                                        currencyCode: (0, $bokng.defaultCurrency).code,
                                        compact: false
                                    }),
                                    " x ",
                                    quantity
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        className: "close",
                        title: "Remove from cart",
                        onClick: ()=>(0, $15Ljq.removeItemFromCart)(cartId, itemId),
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                            className: "fa fa-close"
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("hhQDo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76d0be6cf1071655$export$2e2bcd8739ae039; });

var $bokng = parcelRequire("bokng");
function $76d0be6cf1071655$export$2e2bcd8739ae039({ amount: amount, currencyCode: currencyCode, compact: compact }) {
    let currency = Object.values((0, $bokng.default)).find((curr)=>curr.code === currencyCode);
    if (!currency) currency = (0, $bokng.defaultCurrency);
    return $76d0be6cf1071655$var$formatAmountForDisplay(amount, currency.code, {
        locale: currency.locale,
        notation: compact ? "compact" : "standard"
    });
}
function $76d0be6cf1071655$var$formatAmountForDisplay(amount, currencyCode, options) {
    const { locale: locale, notation: notation } = options;
    const formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currencyDisplay: "narrowSymbol",
        currency: currencyCode,
        notation: notation
    });
    return formatter.format(amount / 100);
}

});

parcelRegister("ekqph", function(module, exports) {

$parcel$export(module.exports, "LoadingOverlay", function () { return $fe04c2453a983970$export$3fb99980b01d36b1; });
$parcel$export(module.exports, "default", function () { return $fe04c2453a983970$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $3lKhV = parcelRequire("3lKhV");
function $fe04c2453a983970$export$3fb99980b01d36b1({ children: children }) {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: $3lKhV.overlay
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: $3lKhV["loading-overlay"],
                children: children
            })
        ]
    });
}
function $fe04c2453a983970$export$2e2bcd8739ae039({ style: style }) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "loading-spinner",
        style: {
            fontSize: "20px",
            ...style ?? {}
        },
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
            className: "fa-solid fa-spinner fa-spin-pulse",
            "aria-hidden": "true"
        })
    });
} /**
 * Usage Examples:
 *
 * 1. Using the loading spinner standalone
 * import Spinner from "loading";
 * <Spinner />
 *
 * 2. Using the spinner as a modal spinner with a modal overlay background:
 * import Spinner, { LoadingOverlay } from "loading";
 *
 * <LoadingOverlay>
 *   <Spinner />
 * <LoadingOverlay>
 *
 * 3. Using the loading overlay standalone as a modal overlay background:
 * import { LoadingOverlay } from "loading";
 *
 * <LoadingOverlay>
 *   ... your content here
 *   ... anything here is centralized on the page
 * </LoadingOverlay>
 */ 

});
parcelRegister("3lKhV", function(module, exports) {

$parcel$export(module.exports, "loading-overlay", function () { return $27073d23eafabc3b$export$3a6f5ef4a315556b; }, function (v) { return $27073d23eafabc3b$export$3a6f5ef4a315556b = v; });
$parcel$export(module.exports, "overlay", function () { return $27073d23eafabc3b$export$29dd17c7f3c81c36; }, function (v) { return $27073d23eafabc3b$export$29dd17c7f3c81c36 = v; });
var $27073d23eafabc3b$export$3a6f5ef4a315556b;
var $27073d23eafabc3b$export$29dd17c7f3c81c36;
$27073d23eafabc3b$export$3a6f5ef4a315556b = `TZcZnG_loading-overlay`;
$27073d23eafabc3b$export$29dd17c7f3c81c36 = `TZcZnG_overlay`;

});


parcelRegister("jSimJ", function(module, exports) {

$parcel$export(module.exports, "useAccordionApi", function () { return $04231b41a36d4fd4$export$b299627440e4e198; });
$parcel$export(module.exports, "useAccordionState", function () { return $04231b41a36d4fd4$export$dae930a4ba30758b; });
$parcel$export(module.exports, "withAccordionProvider", function () { return $04231b41a36d4fd4$export$57a9162a17046231; });
$parcel$export(module.exports, "default", function () { return $04231b41a36d4fd4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Accordion", function () { return $04231b41a36d4fd4$export$a766cd26d0d69044; });
$parcel$export(module.exports, "AccordionToggler", function () { return $04231b41a36d4fd4$export$65868e3b07ef9d13; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $47f9D = parcelRequire("47f9D");

var $4pizv = parcelRequire("4pizv");
const $04231b41a36d4fd4$var$AccordionDataContext = /*#__PURE__*/ (0, $exYeM.createContext)({
    isExpanded: false
});
const $04231b41a36d4fd4$var$AccordionApiContext = /*#__PURE__*/ (0, $exYeM.createContext)({
    expand: ()=>{},
    collapse: ()=>{},
    toggle: ()=>{}
});
function $04231b41a36d4fd4$var$useAccordionApiContext() {
    return (0, $exYeM.useContext)($04231b41a36d4fd4$var$AccordionApiContext);
}
function $04231b41a36d4fd4$var$useAccordionDataContext() {
    return (0, $exYeM.useContext)($04231b41a36d4fd4$var$AccordionDataContext);
}
function $04231b41a36d4fd4$export$b299627440e4e198() {
    return $04231b41a36d4fd4$var$useAccordionApiContext();
}
function $04231b41a36d4fd4$export$dae930a4ba30758b() {
    return $04231b41a36d4fd4$var$useAccordionDataContext();
}
function $04231b41a36d4fd4$export$57a9162a17046231(Component) {
    return function AccordionizedComponent(props) {
        return /*#__PURE__*/ (0, $aSiaI.jsx)($04231b41a36d4fd4$export$2e2bcd8739ae039, {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)(Component, {
                ...props
            })
        });
    };
}
function $04231b41a36d4fd4$export$a766cd26d0d69044(props) {
    const { expanded: expanded, children: children, className: className, element: element = "div", ...rest } = props;
    const { expand: expand, collapse: collapse } = $04231b41a36d4fd4$var$useAccordionApiContext();
    const { isExpanded: isExpanded } = $04231b41a36d4fd4$var$useAccordionDataContext();
    const isFirstLoad = (0, $exYeM.useRef)(true);
    const elementRef = (0, $exYeM.useRef)(null);
    const [slider, setSlider] = (0, $exYeM.useState)(null);
    (0, $exYeM.useEffect)(()=>{
        if (elementRef.current) setSlider((0, $47f9D.default)(elementRef.current));
    }, [
        elementRef.current
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (expanded) expand();
        else if (!isFirstLoad.current) collapse();
    }, [
        expanded
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!slider || isFirstLoad.current) return;
        if (isExpanded) slider.slideDown();
        else slider.slideUp();
    }, [
        isExpanded,
        slider,
        isFirstLoad.current
    ]);
    //return (isExpanded ? children : null);
    if (isFirstLoad.current === true) {
        isFirstLoad.current = false;
        return expanded ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4pizv.default), {
            nodeName: element,
            className: className,
            ref: elementRef,
            ...rest,
            children: children
        }) : null;
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4pizv.default), {
        nodeName: element,
        className: className,
        ref: elementRef,
        ...rest,
        children: children
    });
}
function $04231b41a36d4fd4$export$65868e3b07ef9d13({ children: children, onExpand: onExpand, onCollapse: onCollapse, ...rest }) {
    const { expand: expand, collapse: collapse } = $04231b41a36d4fd4$var$useAccordionApiContext();
    const { isExpanded: isExpanded } = $04231b41a36d4fd4$var$useAccordionDataContext();
    function handleClick(e) {
        e.preventDefault();
        if (isExpanded) {
            collapse();
            if (typeof onCollapse === "function") onCollapse();
        } else {
            expand();
            if (typeof onExpand === "function") onExpand();
        }
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        onClick: handleClick,
        style: {
            display: "inherit",
            padding: 0,
            margin: 0
        },
        ...rest,
        children: children
    });
}
function $04231b41a36d4fd4$export$dd0ede89b9b7c115({ children: children, onExpand: onExpand, ...rest }) {
    const { expand: expand } = $04231b41a36d4fd4$var$useAccordionApiContext();
    function handleClick(e) {
        e.preventDefault();
        expand();
        if (typeof onExpand === "function") onExpand();
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        onClick: handleClick,
        ...rest,
        children: children
    });
}
function $04231b41a36d4fd4$export$6326de7270ea49bb({ children: children, onCollapse: onCollapse, ...rest }) {
    const { collapse: collapse } = $04231b41a36d4fd4$var$useAccordionApiContext();
    function handleClick(e) {
        e.preventDefault();
        collapse();
        if (typeof onCollapse === "function") onCollapse();
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        onClick: handleClick,
        ...rest,
        children: children
    });
}
function $04231b41a36d4fd4$export$2e2bcd8739ae039({ children: children }) {
    const [state, dispatch] = (0, $exYeM.useReducer)(reducer, {
        isExpanded: false
    });
    const api = (0, $exYeM.useMemo)(()=>{
        return {
            expand: ()=>dispatch({
                    type: "expand"
                }),
            collapse: ()=>dispatch({
                    type: "collapse"
                }),
            toggle: ()=>dispatch({
                    type: "toggle"
                })
        };
    }, []);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($04231b41a36d4fd4$var$AccordionDataContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($04231b41a36d4fd4$var$AccordionApiContext.Provider, {
            value: api,
            children: children
        })
    });
    function reducer(state, action) {
        switch(action.type){
            case "expand":
                return {
                    ...state,
                    isExpanded: true
                };
            case "collapse":
                return {
                    ...state,
                    isExpanded: false
                };
            case "toggle":
                return {
                    ...state,
                    isExpanded: !state.isExpanded
                };
            default:
                return state;
        }
    }
} /**
 * USAGE Examples: 
 * 
 * 1. 
 *   import AccordionProvider, { Accordion, AccordionToggler } from "nbc-ui/accordion";
 *   <AccordionProvider>
 *     <AccordionToggler>
 *        {children}
 *     </AccordionToggler>
 *     
 *     <Accordion id="some-id" className="some-classname" expanded={true}>
 *       {children}
 *     </Accordion>
 *   </AccordionProvider>
 * 
 * 2. 
 *   import { Accordion, useAccordionApi, withAccordionProvider } from "nbc-ui/accordion";
 * 
 *   export default withAccordionProvider(MyComponent);
 *   
 *   function MyComponent() {
 *     const { toggle } = useAccordionApi();
 *     
 *     function handleToggleBtnClick(e: MouseEvent<HTMLButtonElement>) {
 *       e.preventDefault();
 *       toggle();
 *     }
 * 
 *     return (
 *       <React.Fragment>
 *         <button onClick={handleToggleBtnClick}>
 *           Click to toggle accordion
 *         </button>
 * 
 *         {...otherChildren}
 * 
 *       </React.Fragment>
 *     )
 *   }
 */ 

});
parcelRegister("47f9D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7000b74487650a5$export$2e2bcd8739ae039; });
function $a7000b74487650a5$export$2e2bcd8739ae039(element) {
    const object = {
        slideToggle: $a7000b74487650a5$export$715de50cedc228a8.bind(element),
        slideUp: $a7000b74487650a5$export$deed561b1a0ff1ea.bind(element),
        slideDown: $a7000b74487650a5$export$abdd11a06a163232.bind(element)
    };
    return object;
}
function $a7000b74487650a5$export$715de50cedc228a8(duration, callback) {
    if (this.clientHeight === 0) $a7000b74487650a5$var$_slideVertical(this, {
        duration: duration,
        callback: callback,
        isDown: true
    });
    else $a7000b74487650a5$var$_slideVertical(this, {
        duration: duration,
        callback: callback
    });
}
function $a7000b74487650a5$export$deed561b1a0ff1ea(duration, callback) {
    $a7000b74487650a5$var$_slideVertical(this, {
        duration: duration,
        callback: callback
    });
}
function $a7000b74487650a5$export$abdd11a06a163232(duration, callback) {
    $a7000b74487650a5$var$_slideVertical(this, {
        duration: duration,
        callback: callback,
        isDown: true
    });
}
function $a7000b74487650a5$var$_slideVertical(el, options) {
    const { duration: duration = 400, callback: callback, isDown: isDown = false } = options ?? {};
    el.style.overflow = "hidden";
    if (isDown) el.style.display = "block";
    const elStyles = window.getComputedStyle(el);
    const elHeight = parseFloat(elStyles.getPropertyValue('height'));
    const elPaddingTop = parseFloat(elStyles.getPropertyValue('padding-top'));
    const elPaddingBottom = parseFloat(elStyles.getPropertyValue('padding-bottom'));
    const elMarginTop = parseFloat(elStyles.getPropertyValue('margin-top'));
    const elMarginBottom = parseFloat(elStyles.getPropertyValue('margin-bottom'));
    const stepHeight = elHeight / duration;
    const stepPaddingTop = elPaddingTop / duration;
    const stepPaddingBottom = elPaddingBottom / duration;
    const stepMarginTop = elMarginTop / duration;
    const stepMarginBottom = elMarginBottom / duration;
    let start;
    function step(timestamp) {
        if (start === undefined) start = timestamp;
        const elapsed = timestamp - start;
        if (isDown) {
            el.style.height = stepHeight * elapsed + "px";
            el.style.paddingTop = stepPaddingTop * elapsed + "px";
            el.style.paddingBottom = stepPaddingBottom * elapsed + "px";
            el.style.marginTop = stepMarginTop * elapsed + "px";
            el.style.marginBottom = stepMarginBottom * elapsed + "px";
        } else {
            el.style.height = elHeight - stepHeight * elapsed + "px";
            el.style.paddingTop = elPaddingTop - stepPaddingTop * elapsed + "px";
            el.style.paddingBottom = elPaddingBottom - stepPaddingBottom * elapsed + "px";
            el.style.marginTop = elMarginTop - stepMarginTop * elapsed + "px";
            el.style.marginBottom = elMarginBottom - stepMarginBottom * elapsed + "px";
        }
        if (elapsed >= duration) {
            el.style.height = "";
            el.style.paddingTop = "";
            el.style.paddingBottom = "";
            el.style.marginTop = "";
            el.style.marginBottom = "";
            el.style.overflow = "";
            if (!isDown) el.style.display = "none";
            if (typeof callback === "function") callback();
        } else window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
}

});

parcelRegister("4pizv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32afe35f2c9f40ab$export$2e2bcd8739ae039; });
/**
 * Accordion Container: renders our accordion inside an HTML element (div, p, span, ul);
 * HTML block-level elements (for span, make sure to set display to block)
 */ 
var $exYeM = parcelRequire("exYeM");
function $32afe35f2c9f40ab$export$2e2bcd8739ae039({ className: className, children: children, ref: ref, nodeName: nodeName = "div", ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(nodeName, {
        className: className,
        ref: ref,
        ...rest
    }, children);
}

});


parcelRegister("dA2xi", function(module, exports) {

$parcel$export(module.exports, "setDefaultCartId", function () { return $62daf1301524aae9$export$8db36bf11eccdcff; });
$parcel$export(module.exports, "deleteDefaultCartId", function () { return $62daf1301524aae9$export$272e16f68b2529bf; });
$parcel$export(module.exports, "getDefaultCartId", function () { return $62daf1301524aae9$export$9dcb4be73a274935; });
$parcel$export(module.exports, "itemExistsInCart", function () { return $62daf1301524aae9$export$648eb04ec0985de3; });
$parcel$export(module.exports, "calculateCost", function () { return $62daf1301524aae9$export$ccac9139013839fb; });
$parcel$export(module.exports, "countTotalItemsInCart", function () { return $62daf1301524aae9$export$9471bf996ef8a772; });

var $bcfZL = parcelRequire("bcfZL");

var $jvC6o = parcelRequire("jvC6o");

var $e6drH = parcelRequire("e6drH");
const $62daf1301524aae9$var$defaultCartName = "shopping-cart" ?? "shopping-cart";
function $62daf1301524aae9$export$7d42cc841d20a4bf(cartName, cartId) {
    (0, $jvC6o.setCookie)(cartName, cartId);
}
function $62daf1301524aae9$export$9b4eaa4a2f473789(cartName) {
    return (0, $jvC6o.getCookie)(cartName);
}
function $62daf1301524aae9$export$50319c2ff48ecf8a(cartName) {
    (0, $jvC6o.deleteCookie)(cartName);
}
function $62daf1301524aae9$export$8db36bf11eccdcff(cartId) {
    $62daf1301524aae9$export$7d42cc841d20a4bf($62daf1301524aae9$var$defaultCartName, cartId);
}
function $62daf1301524aae9$export$272e16f68b2529bf() {
    $62daf1301524aae9$export$50319c2ff48ecf8a($62daf1301524aae9$var$defaultCartName);
}
function $62daf1301524aae9$export$9dcb4be73a274935() {
    return $62daf1301524aae9$export$9b4eaa4a2f473789($62daf1301524aae9$var$defaultCartName);
}
function $62daf1301524aae9$export$648eb04ec0985de3(cart, itemId) {
    return Boolean(cart.items.find((item)=>item.id === itemId));
}
function $62daf1301524aae9$export$ccac9139013839fb(cartItems) {
    const items = cartItems;
    const totalPrice = $62daf1301524aae9$var$calculateTotalCost(items, "price");
    const totalSellingPrice = $62daf1301524aae9$var$calculateTotalCost(items, "discountedPrice");
    return {
        totalPrice: totalPrice,
        totalSellingPrice: totalSellingPrice
    };
}
function $62daf1301524aae9$export$9471bf996ef8a772(cart) {
    const items = cart.items;
    const count = items.reduce((acc, item)=>{
        acc += item.quantity;
        return acc;
    }, 0);
    return count;
}
function $62daf1301524aae9$export$7766c2f1dd9bd6c5(cart) {
    const items = cart.items;
    const count = items.length;
    return count;
}
// Helpers
function $62daf1301524aae9$var$calculateTotalCost(items, priceField) {
    if (!items.every((item)=>Number(item[priceField]))) return 0;
    /* This might work in some situations. But we may run into
     JavaScript number issues when dealing with some floating point arithmentc.
  return items.reduce((total, item) => {
    return total + parseFloat(item[priceField]) * toInteger(item.quantity);
  }, 0).toPrecision(4);
  */ // I'm returning the .value at the end so we have the raw number
    // not the object currency object itself even though that works
    // with Intl.NumberFormat, we may need the raw number in other situations
    // where we are not using Intl.NumberFormat.
    // Plus, after performing this calculation, the caller expects a number
    // not an object.
    return items.reduce((total, item)=>{
        return total.add((0, (/*@__PURE__*/$parcel$interopDefault($bcfZL)))(item[priceField]).multiply((0, $e6drH.toInteger)(item.quantity)));
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bcfZL)))(0)).value;
}

});
parcelRegister("jvC6o", function(module, exports) {

$parcel$export(module.exports, "setCookie", function () { return $fb7572b1498082f5$export$110700823644f4a6; });
$parcel$export(module.exports, "getCookie", function () { return $fb7572b1498082f5$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "deleteCookie", function () { return $fb7572b1498082f5$export$b43e45590305ffaa; });

var $jmPqD = parcelRequire("jmPqD");
const $fb7572b1498082f5$var$cookies = new (0, $jmPqD.default)();
function $fb7572b1498082f5$export$110700823644f4a6(name, value, options) {
    $fb7572b1498082f5$var$cookies.set(name, value, {
        path: "/",
        expires: new Date(Date.now() + 2592000000),
        ...options ?? {}
    });
}
function $fb7572b1498082f5$export$4be65e66cfa2648a(name, options) {
    return $fb7572b1498082f5$var$cookies.get(name, options);
}
function $fb7572b1498082f5$export$b43e45590305ffaa(name, options) {
    $fb7572b1498082f5$var$cookies.remove(name, options);
}

});
parcelRegister("jmPqD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d8bff05fa9fed19$export$2e2bcd8739ae039; });
var $6d8bff05fa9fed19$var$dist = {};
var $6d8bff05fa9fed19$var$hasRequiredDist;
function $6d8bff05fa9fed19$var$requireDist() {
    if ($6d8bff05fa9fed19$var$hasRequiredDist) return $6d8bff05fa9fed19$var$dist;
    $6d8bff05fa9fed19$var$hasRequiredDist = 1;
    Object.defineProperty($6d8bff05fa9fed19$var$dist, "__esModule", {
        value: true
    });
    $6d8bff05fa9fed19$var$dist.parse = parse;
    $6d8bff05fa9fed19$var$dist.serialize = serialize;
    /**
	 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
	 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
	 * which has been replaced by the token definition in RFC 7230 appendix B.
	 *
	 * cookie-name       = token
	 * token             = 1*tchar
	 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
	 *                     "*" / "+" / "-" / "." / "^" / "_" /
	 *                     "`" / "|" / "~" / DIGIT / ALPHA
	 *
	 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
	 * Allow same range as cookie value, except `=`, which delimits end of name.
	 */ const cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
    /**
	 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
	 *
	 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
	 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
	 *                     ; US-ASCII characters excluding CTLs,
	 *                     ; whitespace DQUOTE, comma, semicolon,
	 *                     ; and backslash
	 *
	 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
	 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
	 */ const cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
    /**
	 * RegExp to match domain-value in RFC 6265 sec 4.1.1
	 *
	 * domain-value      = <subdomain>
	 *                     ; defined in [RFC1034], Section 3.5, as
	 *                     ; enhanced by [RFC1123], Section 2.1
	 * <subdomain>       = <label> | <subdomain> "." <label>
	 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
	 *                     Labels must be 63 characters or less.
	 *                     'let-dig' not 'letter' in the first char, per RFC1123
	 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
	 * <let-dig-hyp>     = <let-dig> | "-"
	 * <let-dig>         = <letter> | <digit>
	 * <letter>          = any one of the 52 alphabetic characters A through Z in
	 *                     upper case and a through z in lower case
	 * <digit>           = any one of the ten digits 0 through 9
	 *
	 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
	 *
	 * > (Note that a leading %x2E ("."), if present, is ignored even though that
	 * character is not permitted, but a trailing %x2E ("."), if present, will
	 * cause the user agent to ignore the attribute.)
	 */ const domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
    /**
	 * RegExp to match path-value in RFC 6265 sec 4.1.1
	 *
	 * path-value        = <any CHAR except CTLs or ";">
	 * CHAR              = %x01-7F
	 *                     ; defined in RFC 5234 appendix B.1
	 */ const pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
    const __toString = Object.prototype.toString;
    const NullObject = /* @__PURE__ */ (()=>{
        const C = function() {};
        C.prototype = Object.create(null);
        return C;
    })();
    /**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 */ function parse(str, options) {
        const obj = new NullObject();
        const len = str.length;
        // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
        if (len < 2) return obj;
        const dec = options?.decode || decode;
        let index = 0;
        do {
            const eqIdx = str.indexOf("=", index);
            if (eqIdx === -1) break; // No more cookie pairs.
            const colonIdx = str.indexOf(";", index);
            const endIdx = colonIdx === -1 ? len : colonIdx;
            if (eqIdx > endIdx) {
                // backtrack on prior semicolon
                index = str.lastIndexOf(";", eqIdx - 1) + 1;
                continue;
            }
            const keyStartIdx = startIndex(str, index, eqIdx);
            const keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
            const key = str.slice(keyStartIdx, keyEndIdx);
            // only assign once
            if (obj[key] === undefined) {
                let valStartIdx = startIndex(str, eqIdx + 1, endIdx);
                let valEndIdx = endIndex(str, endIdx, valStartIdx);
                const value = dec(str.slice(valStartIdx, valEndIdx));
                obj[key] = value;
            }
            index = endIdx + 1;
        }while (index < len);
        return obj;
    }
    function startIndex(str, index, max) {
        do {
            const code = str.charCodeAt(index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
        }while (++index < max);
        return max;
    }
    function endIndex(str, index, min) {
        while(index > min){
            const code = str.charCodeAt(--index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
        }
        return min;
    }
    /**
	 * Serialize data into a cookie header.
	 *
	 * Serialize a name value pair into a cookie string suitable for
	 * http headers. An optional options object specifies cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 */ function serialize(name, val, options) {
        const enc = options?.encode || encodeURIComponent;
        if (!cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
        const value = enc(val);
        if (!cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
        let str = name + "=" + value;
        if (!options) return str;
        if (options.maxAge !== undefined) {
            if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
            str += "; Max-Age=" + options.maxAge;
        }
        if (options.domain) {
            if (!domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
            str += "; Domain=" + options.domain;
        }
        if (options.path) {
            if (!pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
            str += "; Path=" + options.path;
        }
        if (options.expires) {
            if (!isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
            str += "; Expires=" + options.expires.toUTCString();
        }
        if (options.httpOnly) str += "; HttpOnly";
        if (options.secure) str += "; Secure";
        if (options.partitioned) str += "; Partitioned";
        if (options.priority) {
            const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
            switch(priority){
                case "low":
                    str += "; Priority=Low";
                    break;
                case "medium":
                    str += "; Priority=Medium";
                    break;
                case "high":
                    str += "; Priority=High";
                    break;
                default:
                    throw new TypeError(`option priority is invalid: ${options.priority}`);
            }
        }
        if (options.sameSite) {
            const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
            switch(sameSite){
                case true:
                case "strict":
                    str += "; SameSite=Strict";
                    break;
                case "lax":
                    str += "; SameSite=Lax";
                    break;
                case "none":
                    str += "; SameSite=None";
                    break;
                default:
                    throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
            }
        }
        return str;
    }
    /**
	 * URL-decode string value. Optimized to skip native call when no %.
	 */ function decode(str) {
        if (str.indexOf("%") === -1) return str;
        try {
            return decodeURIComponent(str);
        } catch (e) {
            return str;
        }
    }
    /**
	 * Determine if value is a Date.
	 */ function isDate(val) {
        return __toString.call(val) === "[object Date]";
    }
    return $6d8bff05fa9fed19$var$dist;
}
var $6d8bff05fa9fed19$var$distExports = $6d8bff05fa9fed19$var$requireDist();
function $6d8bff05fa9fed19$var$hasDocumentCookie() {
    const testingValue = typeof $parcel$global === 'undefined' ? undefined : $parcel$global.TEST_HAS_DOCUMENT_COOKIE;
    if (typeof testingValue === 'boolean') return testingValue;
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $6d8bff05fa9fed19$var$parseCookies(cookies) {
    if (typeof cookies === 'string') return $6d8bff05fa9fed19$var$distExports.parse(cookies);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $6d8bff05fa9fed19$var$readCookie(value, options = {}) {
    const cleanValue = $6d8bff05fa9fed19$var$cleanupCookieValue(value);
    if (!options.doNotParse) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $6d8bff05fa9fed19$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}
class $6d8bff05fa9fed19$export$2e2bcd8739ae039 {
    constructor(cookies, defaultSetOptions = {}){
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.update = ()=>{
            if (!this.HAS_DOCUMENT_COOKIE) return;
            const previousCookies = this.cookies;
            this.cookies = $6d8bff05fa9fed19$var$distExports.parse(document.cookie);
            this._checkChanges(previousCookies);
        };
        const domCookies = typeof document === 'undefined' ? '' : document.cookie;
        this.cookies = $6d8bff05fa9fed19$var$parseCookies(cookies || domCookies);
        this.defaultSetOptions = defaultSetOptions;
        this.HAS_DOCUMENT_COOKIE = $6d8bff05fa9fed19$var$hasDocumentCookie();
    }
    _emitChange(params) {
        for(let i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    }
    _checkChanges(previousCookies) {
        const names = new Set(Object.keys(previousCookies).concat(Object.keys(this.cookies)));
        names.forEach((name)=>{
            if (previousCookies[name] !== this.cookies[name]) this._emitChange({
                name: name,
                value: $6d8bff05fa9fed19$var$readCookie(this.cookies[name])
            });
        });
    }
    _startPolling() {
        this.pollingInterval = setInterval(this.update, 300);
    }
    _stopPolling() {
        if (this.pollingInterval) clearInterval(this.pollingInterval);
    }
    get(name, options = {}) {
        if (!options.doNotUpdate) this.update();
        return $6d8bff05fa9fed19$var$readCookie(this.cookies[name], options);
    }
    getAll(options = {}) {
        if (!options.doNotUpdate) this.update();
        const result = {};
        for(let name in this.cookies)result[name] = $6d8bff05fa9fed19$var$readCookie(this.cookies[name], options);
        return result;
    }
    set(name, value, options) {
        if (options) options = Object.assign(Object.assign({}, this.defaultSetOptions), options);
        else options = this.defaultSetOptions;
        const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        this.cookies = Object.assign(Object.assign({}, this.cookies), {
            [name]: stringValue
        });
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $6d8bff05fa9fed19$var$distExports.serialize(name, stringValue, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    }
    remove(name, options) {
        const finalOptions = options = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = Object.assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $6d8bff05fa9fed19$var$distExports.serialize(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    }
    addChangeListener(callback) {
        this.changeListeners.push(callback);
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1) {
            if (typeof window === 'object' && 'cookieStore' in window) window.cookieStore.addEventListener('change', this.update);
            else this._startPolling();
        }
    }
    removeChangeListener(callback) {
        const idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0) {
            if (typeof window === 'object' && 'cookieStore' in window) window.cookieStore.removeEventListener('change', this.update);
            else this._stopPolling();
        }
    }
    removeAllChangeListeners() {
        while(this.changeListeners.length > 0)this.removeChangeListener(this.changeListeners[0]);
    }
}

});



parcelRegister("15Ljq", function(module, exports) {

$parcel$export(module.exports, "useCart", function () { return $f661fa123a874e07$export$7e0ba394830a1349; });
$parcel$export(module.exports, "emptyCart", function () { return $f661fa123a874e07$export$499eb6fc472e9275; });
$parcel$export(module.exports, "updateCart", function () { return $f661fa123a874e07$export$edba26a5417c3f39; });
$parcel$export(module.exports, "addItemToCart", function () { return $f661fa123a874e07$export$b6bb524f49c7be0f; });
$parcel$export(module.exports, "removeItemFromCart", function () { return $f661fa123a874e07$export$37fbab1ed176a8ca; });
$parcel$export(module.exports, "incrementItemQuantityInCart", function () { return $f661fa123a874e07$export$a3f6346ad6e0a74b; });
$parcel$export(module.exports, "decrementItemQuantityInCart", function () { return $f661fa123a874e07$export$b4e69944664bf81a; });
$parcel$export(module.exports, "changeItemQuantityInCart", function () { return $f661fa123a874e07$export$31ec7a4f73aed47e; });
$parcel$export(module.exports, "fetchItemDetails", function () { return $f661fa123a874e07$export$32791d55f96f1bb0; });

var $4uxUo = parcelRequire("4uxUo");

var $7DA0g = parcelRequire("7DA0g");

var $42IXp = parcelRequire("42IXp");

var $4FeSR = parcelRequire("4FeSR");

var $dA2xi = parcelRequire("dA2xi");

var $9w0rm = parcelRequire("9w0rm");

var $9Liyz = parcelRequire("9Liyz");

var $aOyeg = parcelRequire("aOyeg");

var $cHV6g = parcelRequire("cHV6g");

var $11ryz = parcelRequire("11ryz");
const [$f661fa123a874e07$export$7e0ba394830a1349, $f661fa123a874e07$var$setCart] = (0, $11ryz.default)(null);
const $f661fa123a874e07$var$getCartCached = (0, $7DA0g.withCachedResponse)((0, $aOyeg.default).getCart, {
    cacheKey: "shopping-cart" ?? "shopping-cart",
    expiresIn: Number("15") || 300,
    isSuccessfulRequest: (response)=>(0, $4uxUo.SUCCESS) in response
});
(async function() {
    await (0, $42IXp.withExponentialBackoffRetry)($f661fa123a874e07$var$createDefaultCartIfNotExists)();
})();
async function $f661fa123a874e07$var$createDefaultCartIfNotExists() {
    let defaultCartId = (0, $dA2xi.getDefaultCartId)();
    async function createNewCart() {
        const response = await (0, $aOyeg.default).createCart();
        if ((0, $4uxUo.SUCCESS) in response) {
            const data = response.data;
            const cart = data.cart;
            return cart;
        }
        return null;
    }
    async function createAndSetDefaultCart() {
        const cart = await createNewCart();
        if (cart) {
            const cartId = cart.id;
            defaultCartId = cartId;
            (0, $dA2xi.setDefaultCartId)(cartId);
        }
        return cart;
    }
    try {
        if (!defaultCartId) await createAndSetDefaultCart();
        const response = await $f661fa123a874e07$var$getCartCached(defaultCartId);
        if (response && (0, $4uxUo.SUCCESS) in response) {
            const apiCart = response.data.cart;
            const cart = $f661fa123a874e07$var$parseApiCart(apiCart);
            if (cart) $f661fa123a874e07$var$setCart(cart);
        } else if (response && (0, $4uxUo.ERROR) in response) {
            if (response.statusCode === (0, $4FeSR.HTTP_STATUS_CODES).NOT_FOUND) {
                (0, $dA2xi.deleteDefaultCartId)();
                // Clear the previously cached cart
                // so that when the next fetchCart call is made,
                // it sees the updated cart info and not the cached version.
                /* @ts-expect-error: don't check for TS error for the .clearCache */ $f661fa123a874e07$var$getCartCached.clearCache();
                const cart = await createAndSetDefaultCart();
                if (cart) $f661fa123a874e07$var$setCart($f661fa123a874e07$var$parseApiCart(cart));
            }
        }
    } catch (error) {
        (0, $9w0rm.default).error("store::cart::createDefaultCartIfNotExists:: Error creating cart", error);
        if ((0, $4FeSR.isServerDownError)(error)) throw error;
    }
}
function $f661fa123a874e07$var$handleSuccessResponse(response) {
    const data = response.data;
    // Clear the previously cached cart
    // so that when the next fetchCart call is made,
    // it sees the updated cart info and not the cached version.
    /* @ts-expect-error: don't check for TS error for the .clearCache */ $f661fa123a874e07$var$getCartCached.clearCache();
    $f661fa123a874e07$var$setCart($f661fa123a874e07$var$parseApiCart(data.cart));
}
function $f661fa123a874e07$var$handleErrorResponse(response, options) {
    (0, $9w0rm.default).error(`store::cart::${options.method}: API returned error response:`, response.errorData.message);
}
function $f661fa123a874e07$var$onErrorThrown(error, options) {
    (0, $9w0rm.default).error(`store::cart::${options.method}: Error ${options.action}`, error);
    return {
        error: true,
        statusCode: error.status,
        errorData: {
            message: error.message
        }
    };
}
async function $f661fa123a874e07$export$499eb6fc472e9275(cartId) {
    try {
        const response = await (0, $aOyeg.default).emptyCart(cartId);
        if ((0, $4uxUo.SUCCESS) in response) $f661fa123a874e07$var$handleSuccessResponse(response);
        else if ((0, $4uxUo.ERROR) in response) $f661fa123a874e07$var$handleErrorResponse(response, {
            method: "emptyCart"
        });
        return response;
    } catch (error) {
        return $f661fa123a874e07$var$onErrorThrown(error, {
            action: `emptying cart ${cartId}`,
            method: "emptyCart"
        });
    } finally{
        await $f661fa123a874e07$var$fetchCart(cartId, true);
    }
}
async function $f661fa123a874e07$export$edba26a5417c3f39(cartId, updateData) {
    try {
        const response = await (0, $aOyeg.default).updateCart(cartId, updateData);
        if ((0, $4uxUo.SUCCESS) in response) $f661fa123a874e07$var$handleSuccessResponse(response);
        else if ((0, $4uxUo.ERROR) in response) $f661fa123a874e07$var$handleErrorResponse(response, {
            method: "updateCart"
        });
        return response;
    } catch (error) {
        return $f661fa123a874e07$var$onErrorThrown(error, {
            action: `updating cart ${cartId} with data ${updateData}`,
            method: "updateCart"
        });
    }
}
async function $f661fa123a874e07$export$b6bb524f49c7be0f(cartId, item) {
    try {
        const response = await (0, $aOyeg.default).addItemToCart(cartId, item);
        if ((0, $4uxUo.SUCCESS) in response) $f661fa123a874e07$var$handleSuccessResponse(response);
        else if ((0, $4uxUo.ERROR) in response) $f661fa123a874e07$var$handleErrorResponse(response, {
            method: "addItemToCart"
        });
        return response;
    } catch (error) {
        return $f661fa123a874e07$var$onErrorThrown(error, {
            action: `adding item ${item} to cart ${cartId}`,
            method: "addItemToCart"
        });
    }
}
async function $f661fa123a874e07$export$5db1d7cb6d5061b5(cartId, items) {
    try {
        const response = await (0, $aOyeg.default).addItemsToCart(cartId, items);
        if ((0, $4uxUo.SUCCESS) in response) $f661fa123a874e07$var$handleSuccessResponse(response);
        else if ((0, $4uxUo.ERROR) in response) $f661fa123a874e07$var$handleErrorResponse(response, {
            method: "addItemsToCart"
        });
        return response;
    } catch (error) {
        return $f661fa123a874e07$var$onErrorThrown(error, {
            action: `adding items ${items} to cart ${cartId}`,
            method: "addItemsToCart"
        });
    }
}
async function $f661fa123a874e07$export$37fbab1ed176a8ca(cartId, itemId) {
    try {
        const response = await (0, $aOyeg.default).removeItemFromCart(cartId, itemId);
        if ((0, $4uxUo.SUCCESS) in response) $f661fa123a874e07$var$handleSuccessResponse(response);
        else if ((0, $4uxUo.ERROR) in response) $f661fa123a874e07$var$handleErrorResponse(response, {
            method: "removeItemFromCart"
        });
        return response;
    } catch (error) {
        return $f661fa123a874e07$var$onErrorThrown(error, {
            action: `removing item ${itemId} from cart ${cartId}`,
            method: "removeItemFromCart"
        });
    }
}
async function $f661fa123a874e07$export$dbb1118706570557(cartId, itemId, updateData) {
    try {
        const response = await (0, $aOyeg.default).updateItemInCart(cartId, itemId, updateData);
        if ((0, $4uxUo.SUCCESS) in response) $f661fa123a874e07$var$handleSuccessResponse(response);
        else if ((0, $4uxUo.ERROR) in response) $f661fa123a874e07$var$handleErrorResponse(response, {
            method: "updateItemInCart"
        });
        return response;
    } catch (error) {
        return $f661fa123a874e07$var$onErrorThrown(error, {
            action: `updating item ${itemId} in cart ${cartId}`,
            method: "updateItemInCart"
        });
    }
}
async function $f661fa123a874e07$export$a3f6346ad6e0a74b(cartId, itemId, incrementNumber) {
    try {
        const response = await (0, $aOyeg.default).incrementItemQuantityInCart(cartId, itemId, incrementNumber);
        if ((0, $4uxUo.SUCCESS) in response) $f661fa123a874e07$var$handleSuccessResponse(response);
        else if ((0, $4uxUo.ERROR) in response) $f661fa123a874e07$var$handleErrorResponse(response, {
            method: "incrementItemQuantityInCart"
        });
        return response;
    } catch (error) {
        return $f661fa123a874e07$var$onErrorThrown(error, {
            action: `incrementing item ${itemId} quantity in cart ${cartId}`,
            method: "incrementItemQuantityInCart"
        });
    }
}
async function $f661fa123a874e07$export$b4e69944664bf81a(cartId, itemId, decrementNumber) {
    try {
        const response = await (0, $aOyeg.default).decrementItemQuantityInCart(cartId, itemId, decrementNumber);
        if ((0, $4uxUo.SUCCESS) in response) $f661fa123a874e07$var$handleSuccessResponse(response);
        else if ((0, $4uxUo.ERROR) in response) $f661fa123a874e07$var$handleErrorResponse(response, {
            method: "decrementItemQuantityInCart"
        });
        return response;
    } catch (error) {
        return $f661fa123a874e07$var$onErrorThrown(error, {
            action: `decrementing item ${itemId} quantity in cart ${cartId}`,
            method: "decrementItemQuantityInCart"
        });
    }
}
async function $f661fa123a874e07$export$31ec7a4f73aed47e(cartId, itemId, quantity) {
    try {
        const response = await (0, $aOyeg.default).changeItemQuantityInCart(cartId, itemId, quantity);
        if ((0, $4uxUo.SUCCESS) in response) $f661fa123a874e07$var$handleSuccessResponse(response);
        else if ((0, $4uxUo.ERROR) in response) $f661fa123a874e07$var$handleErrorResponse(response, {
            method: "changeItemQuantityInCart"
        });
        return response;
    } catch (error) {
        return $f661fa123a874e07$var$onErrorThrown(error, {
            action: `changing item ${itemId} quantity in cart ${cartId}`,
            method: "changeItemQuantityInCart"
        });
    }
}
/**
 * Caches the item (product(variant)) that it fetches for 300 seconds
 */ async function $f661fa123a874e07$export$32791d55f96f1bb0(item) {
    const { itemId: itemId, itemType: itemType } = item;
    let result = null;
    const collection = "product";
    const method = (0, $7DA0g.withCachedResponse)((0, $cHV6g.default).getProduct, {
        cacheKey: `${itemType}_${itemId}`,
        expiresIn: 300
    });
    try {
        const response = await method(itemId, {
            relatedFields: "category, images, inventory"
        });
        if (!response || !((0, $4uxUo.SUCCESS) in response)) return result;
        const data = response.data;
        if (data) {
            const object = data[collection];
            result = object;
        }
    } catch (error) {
        (0, $9w0rm.default).error(`store::cart::getItemDetails:: Error fetching ${itemType} details with id ${itemId}`, error);
    }
    if (itemType === "ProductVariant") {
        const variant = result;
        return (0, $9Liyz.parseProductVariantForDisplay)(variant, variant?.product);
    } else {
        const product = result;
        return (0, $9Liyz.parseProductForDisplay)(product);
    }
}
// Helpers
async function $f661fa123a874e07$var$fetchCart(cartId, setCartInState) {
    try {
        const response = await (0, $aOyeg.default).getCart(cartId);
        if (response && (0, $4uxUo.SUCCESS) in response) {
            const apiCart = response.data.cart;
            const cart = $f661fa123a874e07$var$parseApiCart(apiCart);
            if (setCartInState) $f661fa123a874e07$var$setCart(cart);
            return cart;
        } else return null;
    } catch (error) {
        (0, $9w0rm.default).error(`store::cart::fetchCart:: Error fetching cart ${cartId}`, error);
        return null;
    }
}
function $f661fa123a874e07$var$parseApiCart(apiCart) {
    return {
        ...apiCart,
        items: apiCart.items.map((item)=>({
                id: item.item_id,
                type: item.item_type,
                quantity: item.quantity,
                price: item.price,
                discountedPrice: item.discounted_price,
                currencyCode: item.currency_code
            }))
    };
}

});
parcelRegister("4uxUo", function(module, exports) {

$parcel$export(module.exports, "ERROR", function () { return $462de0528ff5bace$export$103bedf43ba882db; });
$parcel$export(module.exports, "SUCCESS", function () { return $462de0528ff5bace$export$638cc6e36b2a737a; });
const $462de0528ff5bace$export$103bedf43ba882db = "error";
const $462de0528ff5bace$export$638cc6e36b2a737a = "success";

});

parcelRegister("aOyeg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80a342256150e81b$export$2e2bcd8739ae039; });

var $kdahk = parcelRequire("kdahk");
const $80a342256150e81b$var$baseEndpoint = "/carts";
const $80a342256150e81b$var$singleCartEndpoint = `${$80a342256150e81b$var$baseEndpoint}/:cartId`;
const $80a342256150e81b$var$cartItemsEndpoint = `${$80a342256150e81b$var$singleCartEndpoint}/items`;
const $80a342256150e81b$var$singleItemEndpoint = `${$80a342256150e81b$var$cartItemsEndpoint}/:itemId`;
function $80a342256150e81b$var$formatCartItem(item) {
    return {
        item_id: item.id,
        item_type: item.type,
        quantity: item.quantity,
        price: item.price,
        discounted_price: item.discountedPrice,
        currency_code: item.currencyCode
    };
}
class $80a342256150e81b$export$2e2bcd8739ae039 {
    static async createCart() {
        return await (0, $kdahk.default).post($80a342256150e81b$var$baseEndpoint);
    }
    static async getCart(cartId) {
        return await (0, $kdahk.default).get($80a342256150e81b$var$singleCartEndpoint, {
            cartId: cartId
        });
    }
    static async emptyCart(cartId) {
        return await (0, $kdahk.default).put(`${$80a342256150e81b$var$singleCartEndpoint}/empty`, {
            cartId: cartId
        });
    }
    static async updateCart(cartId, updateData) {
        return await (0, $kdahk.default).put($80a342256150e81b$var$singleCartEndpoint, {
            cartId: cartId
        }, updateData);
    }
    static async addItemToCart(cartId, item) {
        return await (0, $kdahk.default).post($80a342256150e81b$var$cartItemsEndpoint, {
            cartId: cartId
        }, $80a342256150e81b$var$formatCartItem(item));
    }
    static async addItemsToCart(cartId, items) {
        return await (0, $kdahk.default).post($80a342256150e81b$var$cartItemsEndpoint, {
            cartId: cartId
        }, {
            items: items.map($80a342256150e81b$var$formatCartItem)
        });
    }
    static async removeItemFromCart(cartId, itemId) {
        return await (0, $kdahk.default).delete($80a342256150e81b$var$singleItemEndpoint, {
            cartId: cartId,
            itemId: itemId
        });
    }
    static async updateItemInCart(cartId, itemId, updateData) {
        const { price: price, discountedPrice: discountedPrice } = updateData;
        return await (0, $kdahk.default).put($80a342256150e81b$var$singleItemEndpoint, {
            cartId: cartId,
            itemId: itemId
        }, {
            price: price,
            discounted_price: discountedPrice
        });
    }
    static async incrementItemQuantityInCart(cartId, itemId, incrementNumber) {
        const endpoint = `${$80a342256150e81b$var$singleItemEndpoint}/incrementCount?quantity=:quantity`;
        return await (0, $kdahk.default).put(endpoint, {
            cartId: cartId,
            itemId: itemId,
            quantity: incrementNumber
        });
    }
    static async decrementItemQuantityInCart(cartId, itemId, decrementNumber) {
        const endpoint = `${$80a342256150e81b$var$singleItemEndpoint}/decrementCount?quantity=:quantity`;
        return await (0, $kdahk.default).put(endpoint, {
            cartId: cartId,
            itemId: itemId,
            quantity: decrementNumber
        });
    }
    static async changeItemQuantityInCart(cartId, itemId, quantity) {
        const endpoint = `${$80a342256150e81b$var$singleItemEndpoint}/updateCount?quantity=:quantity`;
        return await (0, $kdahk.default).put(endpoint, {
            cartId: cartId,
            itemId: itemId,
            quantity: quantity
        });
    }
    static async getItemsInCart(cartId) {
        return await (0, $kdahk.default).get($80a342256150e81b$var$cartItemsEndpoint, {
            cartId: cartId
        });
    }
}

});

parcelRegister("cHV6g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5da021342331dd28$export$2e2bcd8739ae039; });

var $kdahk = parcelRequire("kdahk");
const $5da021342331dd28$var$endpoint = "/products";
class $5da021342331dd28$export$2e2bcd8739ae039 {
    static async getProducts(params) {
        return await (0, $kdahk.default).get($5da021342331dd28$var$endpoint, params);
    }
    static async getProductsWithAdvancedSearch(params) {
        // ?color=blue;green;yellow&model=s360;x45&size=small:extraSmall&price=100
        // ?brand=sony:sharp&price=100:200
        // ?price=100&exactPriceMath=1&pattern=or
        // ?...&relatedFields=category,images,inventory
        return await (0, $kdahk.default).get(`${$5da021342331dd28$var$endpoint}/search/advanced`, params);
    }
    static async getProduct(productId, params) {
        return await (0, $kdahk.default).get(`${$5da021342331dd28$var$endpoint}/:productId`, {
            ...params ?? {},
            productId: productId
        });
    }
    // Not needed. getProduct already fills the role
    // because the backend auto fetches from product variants collection
    // if a product with the productId passed to getProduct is not found
    /*
  static async getProductVariant(variantId, params) {
    return await ApiService.get(`${endpoint}/variants/:variantId`, {
      ...(params ?? {}),
      variantId
    });
  }*/ static async addProductReview(productId, reviewData) {
        const { author: author, body: body, rating: rating, target: target } = reviewData;
        return await (0, $kdahk.default).post(`${$5da021342331dd28$var$endpoint}/${productId}/reviews`, undefined, {
            author: author,
            body: body,
            rating: rating,
            target: target
        });
    }
    static async getProductReviews(productId, params) {
        return await (0, $kdahk.default).get(`${$5da021342331dd28$var$endpoint}/:productId/reviews`, {
            ...params ?? {},
            productId: productId
        });
    }
}

});



parcelRegister("kPAf0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97b68d88c3f0cac7$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $i5N2N = parcelRequire("i5N2N");

var $ekqph = parcelRequire("ekqph");
parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");

var $ehJ6T = parcelRequire("ehJ6T");

var $kVlWG = parcelRequire("kVlWG");
function $97b68d88c3f0cac7$export$2e2bcd8739ae039() {
    const { fetchWishlistCount: fetchWishlistCount, isFetchingWishlistCount: isFetchingWishlistCount, wishlistCount: wishlistCount } = (0, $kVlWG.default)();
    const [currentUser, , fetchCurrentUser] = (0, $ehJ6T.useCurrentUser)();
    (0, $exYeM.useEffect)(()=>{
        fetchCurrentUser();
    }, []);
    (0, $exYeM.useEffect)(()=>{
        if (currentUser) (async function() {
            await fetchWishlistCount(currentUser.id);
        })();
    }, [
        currentUser
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $i5N2N.NavLink), {
        to: (0, $hSqCk).WISHLIST,
        children: [
            isFetchingWishlistCount && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "wishlist-item-count loading",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ekqph.default), {})
            }),
            !isFetchingWishlistCount && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "wishlist-item-count",
                children: wishlistCount
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                className: "fa fa-heart-o"
            })
        ]
    });
}

});
parcelRegister("kVlWG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a19b7f88edee6f2e$export$2e2bcd8739ae039; });

var $4uxUo = parcelRequire("4uxUo");

var $7DA0g = parcelRequire("7DA0g");

var $42IXp = parcelRequire("42IXp");

var $4FeSR = parcelRequire("4FeSR");

var $9w0rm = parcelRequire("9w0rm");

var $9Liyz = parcelRequire("9Liyz");

var $jjGdj = parcelRequire("jjGdj");

var $anY8p = parcelRequire("anY8p");

var $11ryz = parcelRequire("11ryz");

var $ehJ6T = parcelRequire("ehJ6T");
let $a19b7f88edee6f2e$var$clearCachedWishlist;
let $a19b7f88edee6f2e$var$clearCachedWishlistCount;
let $a19b7f88edee6f2e$var$cachedGetUserWishlist;
let $a19b7f88edee6f2e$var$cachedGetUserWishlistCount;
const $a19b7f88edee6f2e$var$getWishlistWithExponentialBackoff = (0, $42IXp.withExponentialBackoffRetry)((0, $jjGdj.default).getUserWishlist);
const $a19b7f88edee6f2e$var$getWishlistCountWithExponentialBackoff = (0, $42IXp.withExponentialBackoffRetry)((0, $jjGdj.default).getUserWishlistCount);
const [$a19b7f88edee6f2e$var$useWishlist, $a19b7f88edee6f2e$var$setWishlist] = (0, $11ryz.default)([]);
const [$a19b7f88edee6f2e$var$useWishlistCount, $a19b7f88edee6f2e$var$setWishlistCount] = (0, $11ryz.default)(0);
const [$a19b7f88edee6f2e$var$useIsFetchingWishlist, $a19b7f88edee6f2e$var$setIsFetchingWishlist] = (0, $11ryz.default)(false);
const [$a19b7f88edee6f2e$var$useIsFetchingWishlistCount, $a19b7f88edee6f2e$var$setIsFetchingWishlistCount] = (0, $11ryz.default)(false);
const [$a19b7f88edee6f2e$var$useIsAddingItemToWishlist, $a19b7f88edee6f2e$var$setIsAddingItemToWishlist] = (0, $11ryz.default)({});
const [$a19b7f88edee6f2e$var$useIsRemovingItemFromWishlist, $a19b7f88edee6f2e$var$setIsRemovingItemFromWishlist] = (0, $11ryz.default)({});
const [$a19b7f88edee6f2e$var$useItemRemovedFromWishlist, $a19b7f88edee6f2e$var$setItemRemovedFromWishlist] = (0, $11ryz.default)({});
const [$a19b7f88edee6f2e$var$useAddItemToWishlistError, $a19b7f88edee6f2e$var$setAddItemToWishlistError] = (0, $11ryz.default)({});
const [$a19b7f88edee6f2e$var$useAddItemToWishlistSuccess, $a19b7f88edee6f2e$var$setAddItemToWishlistSuccess] = (0, $11ryz.default)({});
const [$a19b7f88edee6f2e$var$useRemoveItemFromWishlistError, $a19b7f88edee6f2e$var$setRemoveItemFromWishlistError] = (0, $11ryz.default)({});
//const [useWishlistFetched, setWishlistFetched] = createStore(false);
async function $a19b7f88edee6f2e$var$handleApiCall(apiCall, method) {
    const response = await apiCall;
    if (response && (0, $4uxUo.SUCCESS) in response) {
        const data = response.data;
        // Clear the previously cached wishlist
        // so that when the next fetchWishlist call is made,
        // it sees the updated wishlist info and not the cached (now stale) version.
        $a19b7f88edee6f2e$var$clearCachedWishlist?.();
        const parsedWishlist = $a19b7f88edee6f2e$var$parseApiWishlistResponse(data?.wishlist ?? []);
        $a19b7f88edee6f2e$var$setWishlist(parsedWishlist);
    } else if (response && (0, $4uxUo.ERROR) in response) (0, $9w0rm.default).error(`store::wishlist::${method}: API returned error response:`, response.errorData.message);
    return response;
}
function $a19b7f88edee6f2e$var$parseApiWishlistResponse(wishlist) {
    return wishlist.map((product)=>{
        return product.product ? (0, $9Liyz.parseProductVariantForDisplay)(product, product.product) : (0, $9Liyz.parseProductForDisplay)(product);
    });
}
function $a19b7f88edee6f2e$export$2e2bcd8739ae039() {
    const wishlist = $a19b7f88edee6f2e$var$useWishlist();
    const wishlistCount = $a19b7f88edee6f2e$var$useWishlistCount();
    const isFetchingWishlist = $a19b7f88edee6f2e$var$useIsFetchingWishlist();
    const isFetchingWishlistCount = $a19b7f88edee6f2e$var$useIsFetchingWishlistCount();
    const isAddingItemToWishlist = $a19b7f88edee6f2e$var$useIsAddingItemToWishlist();
    const isRemovingItemFromWishlist = $a19b7f88edee6f2e$var$useIsRemovingItemFromWishlist();
    const itemRemovedFromWishlist = $a19b7f88edee6f2e$var$useItemRemovedFromWishlist();
    const addItemToWishlistError = $a19b7f88edee6f2e$var$useAddItemToWishlistError();
    const addItemToWishlistSuccess = $a19b7f88edee6f2e$var$useAddItemToWishlistSuccess();
    const removeItemFromWishlistError = $a19b7f88edee6f2e$var$useRemoveItemFromWishlistError();
    const [currentUser] = (0, $ehJ6T.useCurrentUser)();
    async function addItemToWishlist(item) {
        if (!currentUser) {
            $a19b7f88edee6f2e$var$setAddItemToWishlistError((prev)=>({
                    ...prev,
                    [item.id]: (0, $anY8p.message)("LOGIN_TO_ADD_PRODUCT_TO_WISHLIST")
                }));
            return;
        }
        const itemId = item.id;
        const itemType = item.type;
        const userId = currentUser.id;
        $a19b7f88edee6f2e$var$setAddItemToWishlistError((prev)=>({
                ...prev,
                [itemId]: null
            }));
        $a19b7f88edee6f2e$var$setAddItemToWishlistSuccess((prev)=>({
                ...prev,
                [itemId]: null
            }));
        $a19b7f88edee6f2e$var$setIsAddingItemToWishlist((prev)=>({
                ...prev,
                [itemId]: true
            }));
        try {
            const response = await $a19b7f88edee6f2e$var$handleApiCall((0, $jjGdj.default).addItemToUserWishlist(userId, item), "addItemToUserWishlist");
            if (response && (0, $4uxUo.SUCCESS) in response) {
                $a19b7f88edee6f2e$var$clearCachedWishlist?.();
                $a19b7f88edee6f2e$var$clearCachedWishlistCount?.();
                $a19b7f88edee6f2e$var$setAddItemToWishlistSuccess((prev)=>({
                        ...prev,
                        [itemId]: (0, $anY8p.message)("PRODUCT_ADDED_TO_WISHLIST").replace(":productName", "Product")
                    }));
                fetchWishlistCount(userId);
                fetchWishlist(userId);
            } else if (response && (0, $4uxUo.ERROR) in response) $a19b7f88edee6f2e$var$setAddItemToWishlistError((prev)=>({
                    ...prev,
                    [itemId]: response.errorData.message
                }));
        } catch (error) {
            (0, $9w0rm.default).error(`Error adding item ${itemId} of type ${itemType} to wishlist`, error);
        } finally{
            $a19b7f88edee6f2e$var$setIsAddingItemToWishlist((prev)=>({
                    ...prev,
                    [itemId]: false
                }));
        }
    }
    async function removeItemFromWishlist(item) {
        if (!currentUser) {
            $a19b7f88edee6f2e$var$setRemoveItemFromWishlistError((prev)=>({
                    ...prev,
                    [item.id]: (0, $anY8p.message)("LOGIN_TO_REMOVE_PRODUCT_FROM_WISHLIST")
                }));
            return;
        }
        const itemId = item.id;
        const userId = currentUser.id;
        $a19b7f88edee6f2e$var$setIsRemovingItemFromWishlist((prev)=>({
                ...prev,
                [itemId]: true
            }));
        try {
            const response = await (0, $jjGdj.default).removeItemFromUserWishlist(userId, itemId);
            if (response && (0, $4uxUo.SUCCESS) in response) {
                $a19b7f88edee6f2e$var$clearCachedWishlist?.();
                $a19b7f88edee6f2e$var$clearCachedWishlistCount?.();
                $a19b7f88edee6f2e$var$setItemRemovedFromWishlist((prev)=>({
                        ...prev,
                        [itemId]: true
                    }));
                fetchWishlistCount(userId);
            //fetchWishlist(userId, { page: queryStringData.page, limit: queryStringData.limit });
            //await handleApiCall(UserService.getUserWishlist(userId), "removeItemFromUserWishlist");
            }
        } catch (error) {
            (0, $9w0rm.default).error(`Error removing item ${itemId} from wishlist`, error);
        } finally{
            $a19b7f88edee6f2e$var$setIsRemovingItemFromWishlist((prev)=>({
                    ...prev,
                    [itemId]: false
                }));
        }
    }
    /**
   * For the other functions to work (addItem, removeItem),
   * We must first call the fetchWishlist(userId)
   * so that the userId is set for the other functions.
   */ async function fetchWishlist(userId, params) {
        $a19b7f88edee6f2e$var$setIsFetchingWishlist(true);
        $a19b7f88edee6f2e$var$cachedGetUserWishlist = $a19b7f88edee6f2e$var$cachedGetUserWishlist ?? (0, $7DA0g.withCachedResponse)($a19b7f88edee6f2e$var$getWishlistWithExponentialBackoff, {
            cacheKey: `${userId}_wishlist`,
            expiresIn: 300,
            isSuccessfulRequest: (response)=>{
                let requestSuccessful = (0, $4uxUo.SUCCESS) in response;
                const data = response.data;
                const { page: page } = params ?? {};
                if (page) requestSuccessful = requestSuccessful && page <= data.pages;
                return requestSuccessful;
            }
        });
        ///* @ts-expect-error: ignore TS error about .clearCache */
        $a19b7f88edee6f2e$var$clearCachedWishlist = $a19b7f88edee6f2e$var$clearCachedWishlist ?? $a19b7f88edee6f2e$var$cachedGetUserWishlist.clearCache;
        try {
            const { page: page = 1, limit: limit = 20 } = params ?? {};
            const response = await $a19b7f88edee6f2e$var$cachedGetUserWishlist(userId, {
                page: page,
                limit: limit
            });
            if (response && (0, $4uxUo.SUCCESS) in response) {
                const data = response.data;
                const wishlist = $a19b7f88edee6f2e$var$parseApiWishlistResponse(data?.wishlist ?? []);
                //if(autoFetch) { 
                $a19b7f88edee6f2e$var$setWishlist(wishlist);
                //}
                return {
                    ...data,
                    wishlist: wishlist
                };
            }
        } catch (error) {
            (0, $9w0rm.default).error(`store::wishlist::fetchWishlist:: Error fetching wishlist for user ${userId}`, error);
            if ((0, $4FeSR.isServerDownError)(error)) throw error;
        } finally{
            $a19b7f88edee6f2e$var$setIsFetchingWishlist(false);
        }
    }
    async function fetchWishlistCount(userId) {
        $a19b7f88edee6f2e$var$setIsFetchingWishlistCount(true);
        $a19b7f88edee6f2e$var$cachedGetUserWishlistCount = $a19b7f88edee6f2e$var$cachedGetUserWishlistCount ?? (0, $7DA0g.withCachedResponse)($a19b7f88edee6f2e$var$getWishlistCountWithExponentialBackoff, {
            cacheKey: `${userId}_wishlist_count`,
            expiresIn: 300,
            isSuccessfulRequest: (response)=>(0, $4uxUo.SUCCESS) in response
        });
        ///* @ts-expect-error: ignore TS error about .clearCache */
        $a19b7f88edee6f2e$var$clearCachedWishlistCount = $a19b7f88edee6f2e$var$clearCachedWishlistCount ?? $a19b7f88edee6f2e$var$cachedGetUserWishlistCount.clearCache;
        try {
            const response = await $a19b7f88edee6f2e$var$cachedGetUserWishlistCount(userId);
            if (response && (0, $4uxUo.SUCCESS) in response) {
                const data = response.data;
                const count = data?.count ?? 0;
                $a19b7f88edee6f2e$var$setWishlistCount(count);
                return {
                    count: count
                };
            }
        } catch (error) {
            $a19b7f88edee6f2e$var$setWishlistCount(wishlistCount);
            (0, $9w0rm.default).error(`store::wishlist::fetchWishlistCount:: Error fetching count of items in wishlist for user ${userId}`, error);
            if ((0, $4FeSR.isServerDownError)(error)) throw error;
        } finally{
            $a19b7f88edee6f2e$var$setIsFetchingWishlistCount(false);
        }
    }
    return {
        wishlist: wishlist,
        wishlistCount: wishlistCount,
        addItemToWishlist: addItemToWishlist,
        removeItemFromWishlist: removeItemFromWishlist,
        fetchWishlist: fetchWishlist,
        fetchWishlistCount: fetchWishlistCount,
        isAddingItemToWishlist: isAddingItemToWishlist,
        isRemovingItemFromWishlist: isRemovingItemFromWishlist,
        isFetchingWishlist: isFetchingWishlist,
        isFetchingWishlistCount: isFetchingWishlistCount,
        addItemToWishlistError: addItemToWishlistError,
        addItemToWishlistSuccess: addItemToWishlistSuccess,
        removeItemFromWishlistError: removeItemFromWishlistError,
        itemRemovedFromWishlist: itemRemovedFromWishlist,
        //setAddItemToWishlistError,
        //setAddItemToWishlistSuccess, 
        unsetAddItemToWishlistError: (itemId)=>$a19b7f88edee6f2e$var$setAddItemToWishlistError((prev)=>({
                    ...prev,
                    [itemId]: null
                })),
        unsetAddItemToWishlistSuccess: (itemId)=>$a19b7f88edee6f2e$var$setAddItemToWishlistSuccess((prev)=>({
                    ...prev,
                    [itemId]: null
                })),
        unsetRemoveItemFromWishlistError: (itemId)=>$a19b7f88edee6f2e$var$setRemoveItemFromWishlistError((prev)=>({
                    ...prev,
                    [itemId]: null
                }))
    };
}

});
parcelRegister("anY8p", function(module, exports) {

$parcel$export(module.exports, "message", function () { return $1d1a6e5c134e93bd$export$a8ecead220dd38a6; });

var $eUxJk = parcelRequire("eUxJk");
const $1d1a6e5c134e93bd$var$availableStrings = {
    ...(0, $eUxJk.default)
};
function $1d1a6e5c134e93bd$export$a8ecead220dd38a6(key, replacements) {
    let str = $1d1a6e5c134e93bd$var$availableStrings[key];
    if (replacements) Object.keys(replacements).forEach((placeholder)=>{
        str = str.replace(`:${placeholder}:`, replacements[placeholder]);
    });
    return str;
}

});
parcelRegister("eUxJk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75a5984ee94b8724$export$2e2bcd8739ae039; });

var $bDFsJ = parcelRequire("bDFsJ");

var $FyfQ5 = parcelRequire("FyfQ5");

var $k9MrO = parcelRequire("k9MrO");

var $57jL5 = parcelRequire("57jL5");
var $75a5984ee94b8724$export$2e2bcd8739ae039 = {
    ...(0, $bDFsJ.default),
    ...(0, $FyfQ5.default),
    ...(0, $k9MrO.default),
    ...(0, $57jL5.default)
};

});
parcelRegister("bDFsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ad9997ab8580ee0$export$2e2bcd8739ae039; });
var $5ad9997ab8580ee0$export$2e2bcd8739ae039 = {
    PRODUCT_NOT_AVAILABLE: "Product is currently not available. Add it to your wishlist or check back later."
};

});

parcelRegister("FyfQ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8be7d54742308795$export$2e2bcd8739ae039; });
var $8be7d54742308795$export$2e2bcd8739ae039 = {
    LOGIN_TO_ADD_PRODUCT_TO_WISHLIST: "Please login to add products to your wishlist.",
    LOGIN_TO_REMOVE_PRODUCT_FROM_WISHLIST: "Please login to remove products from your wishlist."
};

});

parcelRegister("k9MrO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $546c54133c73c882$export$2e2bcd8739ae039; });
var $546c54133c73c882$export$2e2bcd8739ae039 = {
    PRODUCT_ADDED_TO_CART: ":productName: added to cart successfully.",
    PRODUCT_ADDED_TO_WISHLIST: ":productName: successfully added to your wishlist."
};

});

parcelRegister("57jL5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68a134138e71a3d7$export$2e2bcd8739ae039; });
var $68a134138e71a3d7$export$2e2bcd8739ae039 = {
};

});






parcelRegister("1nvlT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4489be52e4613064$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $93BR6 = parcelRequire("93BR6");
parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");

var $ehJ6T = parcelRequire("ehJ6T");

var $bGXlg = parcelRequire("bGXlg");

var $jSimJ = parcelRequire("jSimJ");

var $8SVQu = parcelRequire("8SVQu");
function $4489be52e4613064$export$2e2bcd8739ae039() {
    const [currentUser, , , setCurrentUser] = (0, $ehJ6T.useCurrentUser)();
    /*useEffect(() => {
    fetchCurrentUser();
  }, []);*/ function handleLogoutButtonClick(e) {
        e.preventDefault();
        (0, $93BR6.logout)({
            onLogoutSuccess: function onLogoutSuccess() {
                setCurrentUser(null);
            }
        });
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "header-top",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "col-lg-3 col-md-4",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "header-top-left",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                className: "phone-wrap",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: "Telephone Enquiry:"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8SVQu.default), {}),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                            href: "#",
                                            children: "(+234) 806 347 2981"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "col-lg-9 col-md-8",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "header-top-right",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                className: "ht-menu",
                                children: [
                                    currentUser && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                style: {
                                                    color: "var(--gray)",
                                                    fontSize: "14.5px"
                                                },
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                    children: [
                                                        "Welcome ",
                                                        currentUser.firstname
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $jSimJ.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                            className: "ht-setting-trigger",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $jSimJ.AccordionToggler), {
                                                                children: "Account"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $jSimJ.Accordion), {
                                                            className: "setting ht-setting",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                                                className: "ht-setting-list",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                                            to: (0, $hSqCk).ORDER_LISTING,
                                                                            children: "My Orders"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                                            to: (0, $hSqCk).WISHLIST,
                                                                            children: "My Saved Items"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                    href: "#",
                                                    onClick: handleLogoutButtonClick,
                                                    title: "Logout",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("i", {
                                                        className: "fa fa-power-off",
                                                        "aria-hidden": "true"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    !currentUser && /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                        children: [
                                            "Welcome,",
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8SVQu.default), {}),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                to: (0, $hSqCk).SIGNIN,
                                                end: true,
                                                children: "login"
                                            }),
                                            " or",
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8SVQu.default), {}),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bGXlg.default), {
                                                to: (0, $hSqCk).SIGNUP,
                                                end: true,
                                                children: "sign up"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}

});
parcelRegister("93BR6", function(module, exports) {

$parcel$export(module.exports, "logout", function () { return $52c081104c3eda87$export$a0973bcfe11b05c9; });

var $4uxUo = parcelRequire("4uxUo");
parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");

var $bLIxp = parcelRequire("bLIxp");

var $jjGdj = parcelRequire("jjGdj");
parcelRequire("ehJ6T");
var $hcamj = parcelRequire("hcamj");

var $9w0rm = parcelRequire("9w0rm");
async function $52c081104c3eda87$export$a0973bcfe11b05c9({ redirectTo: redirectTo = (0, $hSqCk).HOME, onLogoutSuccess: onLogoutSuccess }) {
    try {
        const response = await (0, $jjGdj.default).logout();
        if (!((0, $4uxUo.ERROR) in response)) {
            (0, $bLIxp.default).deleteAccessToken();
            (0, $hcamj.clearCachedUser)();
            if (typeof onLogoutSuccess === "function") onLogoutSuccess();
            if (redirectTo) window.location.href = redirectTo;
        }
    } catch (error) {
        (0, $9w0rm.default).error("Error logging user out: ", error);
        window.location.href = location.href; // just reload if logout fails
    }
}

});

parcelRegister("8SVQu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a2ce3c2cd9ca1c1$export$2e2bcd8739ae039; });

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");
function $3a2ce3c2cd9ca1c1$export$2e2bcd8739ae039({ count: count = 1 }) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: " ".repeat(count)
    });
}

});





var $c779dbaaf34c7a65$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL('cD01m'), JSON.parse("[\"cD01m\",\"index.0c41f390.js\",\"XaBSS\",\"Home.3fe54490.js\",\"8KpnF\",\"1.bec53705.jpg\",\"dOR8m\",\"2.c89b1c9d.jpg\",\"eU6ux\",\"3.884a2690.jpg\",\"5MkWy\",\"apple-870-200.ff569d17.webp\",\"5qh0l\",\"apple-1170-400.b338a4f1.webp\",\"5CaKH\",\"samsung-870-200.dcfd4745.webp\",\"9YSqP\",\"samsung-1170-400.cc66b1b2.webp\",\"cluiy\",\"smart-screen-with-decoder.6568e010.webp\",\"cXstv\",\"asus-computer-desk-2-column.67569400.webp\",\"04Zgu\",\"asus-computer-2-column.77102b7f.webp\",\"bU1We\",\"laptop-tablet-and-phone.c0618b8f.webp\",\"dNqxS\",\"curved-screen-smart-tv.94a53770.webp\",\"cLjN0\",\"headphone-with-microphone.c5f62c5c.webp\",\"5kzNG\",\"smartphone.dd5be055.webp\",\"knkwC\",\"phones-and-tablets.7c12b86b.webp\",\"9oLrx\",\"household-electronics-3-column.90ee7d92.webp\",\"l6HRS\",\"iphone17-3-column.26d6b2dc.webp\",\"heDij\",\"men-fashion-3-column.c4d07579.webp\",\"lzpB2\",\"sneakers-3-column.594b1d34.webp\",\"5GC62\",\"women-fashion-3-column.e327a318.webp\",\"kECgv\",\"Home.1812c1c1.js\",\"7X1Jz\",\"Home.efca2f09.js\",\"5miPd\",\"Home.27b89cf7.js\",\"86S4X\",\"Home.05c1268f.css\",\"6bJBC\",\"Login.c3263d9e.js\",\"f3Mcb\",\"Login.0c24b612.js\",\"3CXxv\",\"Login.950ac19d.js\",\"4XN3V\",\"Login.1ea1af16.css\",\"jbq04\",\"Register.f1fe0a8e.js\",\"7nlE0\",\"Register.74a68d9f.css\",\"8DCbk\",\"PasswordResetRequest.5ad9a6fa.js\",\"kLKFG\",\"PasswordReset.88f53948.js\",\"dkrzP\",\"PasswordReset.117ef7c5.css\",\"lQObL\",\"Shop.4d4c616b.js\",\"cOtZb\",\"Shop.4873ef80.css\",\"01HYE\",\"Cart.f74d8191.js\",\"jQKBB\",\"Cart.426c2405.css\",\"ecXJq\",\"Checkout.033b9453.js\",\"bcfte\",\"arrow-right-white.2f3fc5fd.svg\",\"ehjVR\",\"mastercard.5b64eb13.svg\",\"aJUm3\",\"verve.91d821a1.svg\",\"1u2gQ\",\"visa.2d95a030.svg\",\"bVuT2\",\"truck-gold.847c83a0.svg\",\"hqCx5\",\"Checkout.684723fa.css\",\"d3glp\",\"Product.7c9bf820.js\",\"1taXa\",\"Product.9153f877.css\",\"cbKR1\",\"PaymentStatus.0a95c9e2.js\",\"hRlpj\",\"PaymentStatus.3cca9d8d.css\",\"49pF6\",\"OrderPayment.5cecb2e7.js\",\"6A0zs\",\"OrderPayment.1331da0c.css\",\"1G9Al\",\"Wishlist.8e7313db.js\",\"jU9WK\",\"Wishlist.8ddea69c.css\",\"5F58N\",\"EmailVerification.cb77cdd3.js\",\"3WPwS\",\"EmailVerification.648e4c01.css\",\"bQSX4\",\"ProductCompare.3677a618.js\",\"hneH2\",\"ProductCompare.58675c3f.css\",\"kJ90r\",\"OrderTracking.a5b25304.js\",\"bTPEi\",\"PrivacyPolicy.46d26b26.js\",\"1SfMx\",\"About.af645030.js\",\"2DHhQ\",\"Contact.beaaef39.js\",\"6hnLv\",\"OrderListing.27645093.js\",\"i7BFt\",\"OrderListing.1b98fded.css\",\"5HmOr\",\"OrderDetails.653be83f.js\",\"jzdzP\",\"OrderDetails.2c756251.css\",\"jm0TH\",\"index.7f9298da.css\"]"));

/*
 * This file is responsible for rendering the App component
 * into the <div id="app"> element on the page.
 */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
var $7bd215913159ea08$exports = {};
'use strict';
function $7bd215913159ea08$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7bd215913159ea08$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7bd215913159ea08$var$checkDCE();

$7bd215913159ea08$exports = (parcelRequire("8LThT"));


/*
 * This file serves as the root component of our app.
 */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $i5N2N = parcelRequire("i5N2N");

var $hj9EK = parcelRequire("hj9EK");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $bsJmv = parcelRequire("bsJmv");

function $1c1e566952a98905$export$2e2bcd8739ae039(props) {
    const { error: error, isLoading: isLoading, isOffline: isOffline, progress: progress, statusMessage: statusMessage, maxRetries: maxRetries, retryCount: retryCount, restart: restart } = props;
    const [showSplash, setShowSplash] = (0, $exYeM.useState)(true);
    const [isFadingOut, setIsFadingOut] = (0, $exYeM.useState)(false);
    (0, $exYeM.useEffect)(()=>{
        if (!isLoading && progress === 100) {
            setIsFadingOut(true);
            setTimeout(()=>setShowSplash(false), 500); // Match this duration exactly with the CSS transition property (500ms)
        }
    }, [
        isLoading,
        progress
    ]);
    // Completely wipe Splash out of the DOM after fade-out finishes
    if (!showSplash) return null;
    const hasExceededRetryLimit = retryCount >= maxRetries;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: `splash-screen ${isFadingOut ? "fade-out" : ""}`,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                    src: "/images/branding/SecondaryLogo.png",
                    alt: "NearBuyCart Logo",
                    className: "splash-logo"
                })
            }),
            error && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "splash-error-container",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "error-title",
                        children: isOffline ? "Network Offline" : "Initialization Failed"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "error-message",
                        children: error
                    }),
                    isOffline && !hasExceededRetryLimit && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "auto-retry-notice",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "pulse-dot"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: "Waiting for a stable internet connection..."
                            })
                        ]
                    }),
                    hasExceededRetryLimit && /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "retry-limit-warning",
                        children: "Auto-retry attempts exhausted."
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $bsJmv.default), {
                        className: "retry-button",
                        onClick: restart,
                        children: [
                            "Retry Manually ",
                            hasExceededRetryLimit ? "" : `(${retryCount}/${maxRetries})`
                        ]
                    })
                ]
            }),
            !error && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "progress-container",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "progress-bar-track",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "progress-bar-fill",
                            style: {
                                width: `${progress}%`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "progress-text-row",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "status-message",
                                children: statusMessage
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: "percentage-counter",
                                children: [
                                    progress,
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $exYeM = parcelRequire("exYeM");

var $42IXp = parcelRequire("42IXp");

var $9w0rm = parcelRequire("9w0rm");

var $bLIxp = parcelRequire("bLIxp");

var $ehJ6T = parcelRequire("ehJ6T");
const $912e39342655221a$var$MAX_RETRIES = 3;
const $912e39342655221a$var$refreshAccessToken = (0, $42IXp.debounceWithPromise)((0, $bLIxp.default).refreshAccessToken, 1000);
function $912e39342655221a$export$2e2bcd8739ae039() {
    const [error, setError] = (0, $exYeM.useState)(null);
    const [isInitializing, setIsInitializing] = (0, $exYeM.useState)(true);
    const [isOffline, setIsOffline] = (0, $exYeM.useState)(!navigator.onLine);
    const [progress, setProgress] = (0, $exYeM.useState)(0);
    const [statusMessage, setStatusMessage] = (0, $exYeM.useState)("Initializing application...");
    const [, , fetchCurrentUser] = (0, $ehJ6T.useCurrentUser)();
    // useRef preserves the value without triggering unwanted re-renders
    const retryCount = (0, $exYeM.useRef)(0);
    (0, $exYeM.useEffect)(()=>{
        initializeApp();
    }, []);
    // Network Event Listener Effect
    (0, $exYeM.useEffect)(()=>{
        function handleInternetConnectionRestored() {
            setIsOffline(false);
            // Auto-retry initialization if an error state is currently active
            if (error && retryCount.current < $912e39342655221a$var$MAX_RETRIES) {
                console.log("Internet restored. Auto-retrying initialization...");
                initializeApp(true);
            }
        }
        function handleInternetConnectionLost() {
            setIsOffline(true);
            setError("Network connection lost. Please check your internet connection.");
        }
        // Bind browser network events
        window.addEventListener("online", handleInternetConnectionRestored);
        window.addEventListener("offline", handleInternetConnectionLost);
        return ()=>{
            window.removeEventListener("online", handleInternetConnectionRestored);
            window.removeEventListener("offline", handleInternetConnectionLost);
        };
    }, [
        error
    ]);
    // Reset retry counters manually if explicit user interaction happens
    function handleManualRetry() {
        retryCount.current = 0; // Clear bounds because user explicitly clicked
        initializeApp(false);
    }
    async function initializeApp(isAutoRetry = false) {
        if (!navigator.onLine) {
            setIsOffline(true);
            setError("No internet connection detected. Check your network hardware.");
            return;
        }
        setError(null); // Reset errors on initialization attempt
        setProgress(0);
        setStatusMessage("Initializing application...");
        try {
            // `refreshAccessToken()` must be called before `fetchCurrentUser()`.
            // This ensures that the access token has been refreshed 
            // before attempting to fetch the user.
            setProgress(15);
            setStatusMessage("Checking active user session...");
            const userStillLoggedIn = await $912e39342655221a$var$refreshAccessToken();
            setProgress(50);
            if (userStillLoggedIn) {
                setStatusMessage("User session is active. Fetching user information...");
                await fetchCurrentUser();
            } else setStatusMessage("No active user sessions found.");
            setProgress(80);
            setStatusMessage("Finalizing setup...");
            setProgress(100);
            setIsInitializing(false);
            setStatusMessage(`Welcome to ${"NearBuyCart" ?? "NearBuyCart"}!`);
            retryCount.current = 0; // Clear retry limits on a successful boot
        } catch (error) {
            // Check if browser is offline OR if fetch failed completely due to CORS/DNS/Network
            if (!navigator.onLine || error.name === 'TypeError' || error.message.includes('fetch')) {
                setIsOffline(true);
                setError("Network connection lost. Please check your internet connection.");
            } else {
                setIsOffline(false);
                if (error.name === "Pending Promise Cancelled" && error.message === "Pending Promise Resolution Cancelled by a newer debounced call") (0, $9w0rm.default).error("Debounced `refreshAccessToken` error: ", error);
                else {
                    (0, $9w0rm.default).error("Initialization failed: ", error);
                    setStatusMessage("Initialization failed");
                    setError(error.message || "A network connectivity issue occurred.");
                }
            }
            // Handle loop capping
            if (isAutoRetry) {
                retryCount.current += 1;
                (0, $9w0rm.default).warn(`Auto-retry attempt ${retryCount.current} of ${$912e39342655221a$var$MAX_RETRIES}`);
            }
        }
    }
    return {
        error: error,
        isInitializing: isInitializing,
        isOffline: isOffline,
        progress: progress,
        statusMessage: statusMessage,
        maxRetries: $912e39342655221a$var$MAX_RETRIES,
        retryCount: retryCount.current,
        restart: handleManualRetry
    };
}


/**
 * router/index.ts
 *
 * Purpose:
 *   Collects all of the (top-level) pages listed in the /routes/index.ts file
 *   and builds them into routes to be served by the application.
 *   Any top-level page not registered in the /pages/indexjs file
 *   may not show up when navigated to.
 *   We use some fancy react features to lazy load in new pages
 *   with react's Suspense system.
 *
 * Things to Change:
 *   If you have very specific views about how pages should be routed using react,
 *   then change them around here.
 *   Also if you want to use something like helmet
 *   to give each page a specific title you can add that in here as well.
 *   Basically anything having to do with switching between pages
 *   can be changed around in this file.
 */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $i5N2N = parcelRequire("i5N2N");
/*export default function PageLoading() {
  return <div>Loading...</div>;
}*/ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
var $704ad812f49450ce$exports = {};
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else $704ad812f49450ce$exports = factory();
})($704ad812f49450ce$exports, function() {
    var NProgress = {};
    NProgress.version = '0.2.0';
    var Settings = NProgress.settings = {
        minimum: 0.08,
        easing: 'ease',
        positionUsing: '',
        speed: 200,
        trickle: true,
        trickleRate: 0.02,
        trickleSpeed: 800,
        showSpinner: true,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: 'body',
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */ NProgress.configure = function(options) {
        var key, value;
        for(key in options){
            value = options[key];
            if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
        }
        return this;
    };
    /**
   * Last number.
   */ NProgress.status = null;
    /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */ NProgress.set = function(n) {
        var started = NProgress.isStarted();
        n = clamp(n, Settings.minimum, 1);
        NProgress.status = n === 1 ? null : n;
        var progress = NProgress.render(!started), bar = progress.querySelector(Settings.barSelector), speed = Settings.speed, ease = Settings.easing;
        progress.offsetWidth; /* Repaint */ 
        queue(function(next) {
            // Set positionUsing if it hasn't already been set
            if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();
            // Add transition
            css(bar, barPositionCSS(n, speed, ease));
            if (n === 1) {
                // Fade out
                css(progress, {
                    transition: 'none',
                    opacity: 1
                });
                progress.offsetWidth; /* Repaint */ 
                setTimeout(function() {
                    css(progress, {
                        transition: 'all ' + speed + 'ms linear',
                        opacity: 0
                    });
                    setTimeout(function() {
                        NProgress.remove();
                        next();
                    }, speed);
                }, speed);
            } else setTimeout(next, speed);
        });
        return this;
    };
    NProgress.isStarted = function() {
        return typeof NProgress.status === 'number';
    };
    /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */ NProgress.start = function() {
        if (!NProgress.status) NProgress.set(0);
        var work = function() {
            setTimeout(function() {
                if (!NProgress.status) return;
                NProgress.trickle();
                work();
            }, Settings.trickleSpeed);
        };
        if (Settings.trickle) work();
        return this;
    };
    /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */ NProgress.done = function(force) {
        if (!force && !NProgress.status) return this;
        return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
    };
    /**
   * Increments by a random amount.
   */ NProgress.inc = function(amount) {
        var n = NProgress.status;
        if (!n) return NProgress.start();
        else {
            if (typeof amount !== 'number') amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
            n = clamp(n + amount, 0, 0.994);
            return NProgress.set(n);
        }
    };
    NProgress.trickle = function() {
        return NProgress.inc(Math.random() * Settings.trickleRate);
    };
    /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */ (function() {
        var initial = 0, current = 0;
        NProgress.promise = function($promise) {
            if (!$promise || $promise.state() === "resolved") return this;
            if (current === 0) NProgress.start();
            initial++;
            current++;
            $promise.always(function() {
                current--;
                if (current === 0) {
                    initial = 0;
                    NProgress.done();
                } else NProgress.set((initial - current) / initial);
            });
            return this;
        };
    })();
    /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */ NProgress.render = function(fromStart) {
        if (NProgress.isRendered()) return document.getElementById('nprogress');
        addClass(document.documentElement, 'nprogress-busy');
        var progress = document.createElement('div');
        progress.id = 'nprogress';
        progress.innerHTML = Settings.template;
        var bar = progress.querySelector(Settings.barSelector), perc = fromStart ? '-100' : toBarPerc(NProgress.status || 0), parent = document.querySelector(Settings.parent), spinner;
        css(bar, {
            transition: 'all 0 linear',
            transform: 'translate3d(' + perc + '%,0,0)'
        });
        if (!Settings.showSpinner) {
            spinner = progress.querySelector(Settings.spinnerSelector);
            spinner && removeElement(spinner);
        }
        if (parent != document.body) addClass(parent, 'nprogress-custom-parent');
        parent.appendChild(progress);
        return progress;
    };
    /**
   * Removes the element. Opposite of render().
   */ NProgress.remove = function() {
        removeClass(document.documentElement, 'nprogress-busy');
        removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
        var progress = document.getElementById('nprogress');
        progress && removeElement(progress);
    };
    /**
   * Checks if the progress bar is rendered.
   */ NProgress.isRendered = function() {
        return !!document.getElementById('nprogress');
    };
    /**
   * Determine which positioning CSS rule to use.
   */ NProgress.getPositioningCSS = function() {
        // Sniff on document.body.style
        var bodyStyle = document.body.style;
        // Sniff prefixes
        var vendorPrefix = 'WebkitTransform' in bodyStyle ? 'Webkit' : 'MozTransform' in bodyStyle ? 'Moz' : 'msTransform' in bodyStyle ? 'ms' : 'OTransform' in bodyStyle ? 'O' : '';
        if (vendorPrefix + 'Perspective' in bodyStyle) // Modern browsers with 3D support, e.g. Webkit, IE10
        return 'translate3d';
        else if (vendorPrefix + 'Transform' in bodyStyle) // Browsers without 3D support, e.g. IE9
        return 'translate';
        else // Browsers without translate() support, e.g. IE7-8
        return 'margin';
    };
    /**
   * Helpers
   */ function clamp(n, min, max) {
        if (n < min) return min;
        if (n > max) return max;
        return n;
    }
    /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */ function toBarPerc(n) {
        return (-1 + n) * 100;
    }
    /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */ function barPositionCSS(n, speed, ease) {
        var barCSS;
        if (Settings.positionUsing === 'translate3d') barCSS = {
            transform: 'translate3d(' + toBarPerc(n) + '%,0,0)'
        };
        else if (Settings.positionUsing === 'translate') barCSS = {
            transform: 'translate(' + toBarPerc(n) + '%,0)'
        };
        else barCSS = {
            'margin-left': toBarPerc(n) + '%'
        };
        barCSS.transition = 'all ' + speed + 'ms ' + ease;
        return barCSS;
    }
    /**
   * (Internal) Queues a function to be executed.
   */ var queue = function() {
        var pending = [];
        function next() {
            var fn = pending.shift();
            if (fn) fn(next);
        }
        return function(fn) {
            pending.push(fn);
            if (pending.length == 1) next();
        };
    }();
    /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */ var css = function() {
        var cssPrefixes = [
            'Webkit',
            'O',
            'Moz',
            'ms'
        ], cssProps = {};
        function camelCase(string) {
            return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
                return letter.toUpperCase();
            });
        }
        function getVendorProp(name) {
            var style = document.body.style;
            if (name in style) return name;
            var i = cssPrefixes.length, capName = name.charAt(0).toUpperCase() + name.slice(1), vendorName;
            while(i--){
                vendorName = cssPrefixes[i] + capName;
                if (vendorName in style) return vendorName;
            }
            return name;
        }
        function getStyleProp(name) {
            name = camelCase(name);
            return cssProps[name] || (cssProps[name] = getVendorProp(name));
        }
        function applyCss(element, prop, value) {
            prop = getStyleProp(prop);
            element.style[prop] = value;
        }
        return function(element, properties) {
            var args = arguments, prop, value;
            if (args.length == 2) for(prop in properties){
                value = properties[prop];
                if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
            }
            else applyCss(element, args[1], args[2]);
        };
    }();
    /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */ function hasClass(element, name) {
        var list = typeof element == 'string' ? element : classList(element);
        return list.indexOf(' ' + name + ' ') >= 0;
    }
    /**
   * (Internal) Adds a class to an element.
   */ function addClass(element, name) {
        var oldList = classList(element), newList = oldList + name;
        if (hasClass(oldList, name)) return;
        // Trim the opening space.
        element.className = newList.substring(1);
    }
    /**
   * (Internal) Removes a class from an element.
   */ function removeClass(element, name) {
        var oldList = classList(element), newList;
        if (!hasClass(element, name)) return;
        // Replace the class name.
        newList = oldList.replace(' ' + name + ' ', ' ');
        // Trim the opening and closing spaces.
        element.className = newList.substring(1, newList.length - 1);
    }
    /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */ function classList(element) {
        return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
    }
    /**
   * (Internal) Removes an element from the DOM.
   */ function removeElement(element) {
        element && element.parentNode && element.parentNode.removeChild(element);
    }
    return NProgress;
});



function $fe3e0119044c3d10$export$2e2bcd8739ae039() {
    (0, $exYeM.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($704ad812f49450ce$exports))).start();
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($704ad812f49450ce$exports))).done();
        };
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "grid min-h-screen animate-pulse place-content-center text-6xl text-white",
        children: "Loading..."
    });
}



var $bLIxp = parcelRequire("bLIxp");























const $df800c9d5d307ccd$var$pageComponents = {
    Home: (parcelRequire("dbeOd")),
    Login: (parcelRequire("a6qac")),
    Register: (parcelRequire("beSF1")),
    PasswordResetRequest: (parcelRequire("90wy4")),
    PasswordReset: (parcelRequire("1J82K")),
    Shop: (parcelRequire("KsOfD")),
    Brand: (parcelRequire("KsOfD")),
    Category: (parcelRequire("KsOfD")),
    Cart: (parcelRequire("8f7gC")),
    Checkout: (parcelRequire("8kfIQ")),
    Product: (parcelRequire("jpZrb")),
    PaymentStatus: (parcelRequire("7bAH7")),
    OrderPayment: (parcelRequire("er5uo")),
    Wishlist: (parcelRequire("3k404")),
    EmailVerification: (parcelRequire("81Ki0")),
    ProductCompare: (parcelRequire("k9s88")),
    OrderTracking: (parcelRequire("9OTRW")),
    PrivacyPolicy: (parcelRequire("dZbs5")),
    AboutUs: (parcelRequire("8aPVI")),
    ContactUs: (parcelRequire("kkAoC")),
    Search: (parcelRequire("KsOfD")),
    OrderListing: (parcelRequire("77JkQ")),
    OrderDetails: (parcelRequire("gTppb"))
};
var $df800c9d5d307ccd$export$2e2bcd8739ae039 = $df800c9d5d307ccd$var$pageComponents;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $i5N2N = parcelRequire("i5N2N");

var $grHnD = parcelRequire("grHnD");
parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");
function $3ea0907423b6b451$var$NotFound() {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $grHnD.default), {
        page: {
            title: "404",
            description: "Page not found"
        },
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                children: "Page Not Found"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                children: "The page you are looking for was not foung"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $i5N2N.Link), {
                to: (0, $hSqCk).HOME,
                children: "Back to home"
            })
        ]
    });
}
var $3ea0907423b6b451$export$2e2bcd8739ae039 = $3ea0907423b6b451$var$NotFound;



var $gB5us = parcelRequire("gB5us");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $i5N2N = parcelRequire("i5N2N");
parcelRequire("gB5us");
var $hSqCk = parcelRequire("hSqCk");
const $4d1bb9bd6dffc425$var$ProtectedRoute = ({ component: Component, isAuthenticatedUser: isAuthenticatedUser })=>{
    const location = (0, $i5N2N.useLocation)();
    const navigate = (0, $i5N2N.useNavigate)();
    (0, $exYeM.useEffect)(()=>{
        if (!isAuthenticatedUser) navigate((0, $hSqCk).SIGNIN, {
            state: {
                from: location,
                fromProtectedPage: true
            }
        });
    }, [
        isAuthenticatedUser
    ]);
    // Prevent the user from accidentally seeing protected stufff
    // incase the redirection from useEffect is taking long.
    return isAuthenticatedUser ? /*#__PURE__*/ (0, $aSiaI.jsx)(Component, {}) : null;
};
var $4d1bb9bd6dffc425$export$2e2bcd8739ae039 = $4d1bb9bd6dffc425$var$ProtectedRoute;


function $ba3067642477311e$var$AppRoutes() {
    const routes = (0, $gB5us.default).map((currRoute)=>{
        const route = {
            ...currRoute
        };
        const { component: component } = route;
        delete route.component;
        const Component = (props)=>{
            if (!component) throw new Error("Component name is required");
            const InternalComponent = /*#__PURE__*/ (0, $exYeM.lazy)(()=>(0, $df800c9d5d307ccd$export$2e2bcd8739ae039)[component]);
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $exYeM.Suspense), {
                fallback: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fe3e0119044c3d10$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $aSiaI.jsx)(InternalComponent, {
                    ...props
                })
            });
        };
        return {
            ...route,
            Component: Component
        };
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $i5N2N.Routes), {
        children: [
            routes.map(({ path: path, authRequired: authRequired, Component: Component }, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $i5N2N.Route), {
                    path: path,
                    element: authRequired ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4d1bb9bd6dffc425$export$2e2bcd8739ae039), {
                        component: Component,
                        isAuthenticatedUser: (0, $bLIxp.default).isAuthenticatedUser()
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)(Component, {})
                }, index)),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $i5N2N.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3ea0907423b6b451$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $ba3067642477311e$export$2e2bcd8739ae039 = $ba3067642477311e$var$AppRoutes;



function $26c28601dd21ca71$var$App() {
    const { isInitializing: isInitializing, isOffline: isOffline, progress: progress, statusMessage: statusMessage, error: error, maxRetries: maxRetries, retryCount: retryCount, restart: restart } = (0, $912e39342655221a$export$2e2bcd8739ae039)();
    (0, $exYeM.useEffect)(()=>{
        window.addEventListener("scroll", enableStickyHeader);
        function enableStickyHeader() {
            const target = document.querySelector(".header-sticky");
            if (!target) return;
            if (window.scrollY > 300) target.classList.add("sticky");
            else target.classList.remove("sticky");
        }
        return ()=>window.removeEventListener("scroll", enableStickyHeader);
    }, []);
    if (isInitializing) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1c1e566952a98905$export$2e2bcd8739ae039), {
        error: error,
        isLoading: isInitializing,
        isOffline: isOffline,
        progress: progress,
        statusMessage: statusMessage,
        maxRetries: maxRetries,
        retryCount: retryCount,
        restart: restart
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $i5N2N.BrowserRouter), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ba3067642477311e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $hj9EK.ToastContainer), {})
        ]
    });
}
var $26c28601dd21ca71$export$2e2bcd8739ae039 = $26c28601dd21ca71$var$App;


const $7d0d880cf2ba634e$var$container = document.getElementById("app");
const $7d0d880cf2ba634e$var$root = (0, $7bd215913159ea08$exports.createRoot)($7d0d880cf2ba634e$var$container);
$7d0d880cf2ba634e$var$root.render(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $exYeM.StrictMode), {
    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $26c28601dd21ca71$export$2e2bcd8739ae039), {})
}));

})();
//# sourceMappingURL=index.0c41f390.js.map
